package com.havn.app.core.localization

// Generated from composeResources/values*/strings.xml. Do not edit by hand.
object HavnStringCatalog {
    fun stringsFor(language: HavnLanguage): HavnStrings = when (language) {
        HavnLanguage.English -> english
        HavnLanguage.Slovak -> slovak
        HavnLanguage.German -> german
        HavnLanguage.French -> french
        HavnLanguage.Czech -> czech
        HavnLanguage.Spanish -> spanish
        HavnLanguage.Italian -> italian
        HavnLanguage.Croatian -> croatian
        HavnLanguage.Portuguese -> portuguese
        HavnLanguage.Dutch -> dutch
        HavnLanguage.Polish -> polish
        HavnLanguage.Hungarian -> hungarian
        HavnLanguage.Romanian -> romanian
    }

    private val english: HavnStrings = object : HavnStrings {
        override val navToday: String = "Today"
        override val navProperties: String = "Properties"
        override val navLeads: String = "Leads"
        override val navReports: String = "Reports"
        override val navTasks: String = "Tasks"
        override val navAnalytics: String = "Analytics"
        override val navAgency: String = "Agency"
        override val navSettings: String = "Settings"
        override val navAuth: String = "Agent access"
        override val navOpenHouses: String = "Open Houses"
        override val navTours: String = "Open Houses"
        override val navFollowUps: String = "Contacts"
        override val navFollow: String = "Contacts"
        override val back: String = "Back"
        override val settingsEyebrow: String = "Account"
        override val settingsTitle: String = "Settings"
        override val settingsSubtitle: String = "Brokerage profile, invite policy, storage buckets, and team roles."
        override val agentProfileTitle: String = "Agent profile"
        override val agentPhoto: String = "Agent photo"
        override val uploading: String = "Uploading..."
        override val saving: String = "Saving..."
        override val validAgentPhotoRequired: String = "Choose a valid agent photo."
        override val signOut: String = "Sign out"
        override val signOutQuestion: String = "Sign out?"
        override val signOutConfirmation: String = "Are you sure you want to sign out of HAVN?"
        override val deleteAccount: String = "Delete Account"
        override val deleteAccountQuestion: String = "Delete Account?"
        override val deleteAccountOpenPageBody: String = "This will open the account deletion request page."
        override val deleteAccountReviewTitle: String = "Use a real account"
        override val deleteAccountReviewBody: String = "This app review account is protected so reviewers do not lose access during testing. Please use a real test account to verify account deletion."
        override val upgrade: String = "Upgrade"
        override val premiumThemesTitle: String = "Premium themes"
        override val premiumThemesUpgradePrompt: String = "Upgrade to Pro to unlock premium themes."
        override val appearanceTitle: String = "Appearance"
        override val appearanceBody: String = "Choose light or dark mode for the web app."
        override val previewComponents: String = "Preview components"
        override val themeShowcaseTitle: String = "Theme showcase"
        override val showcaseButtons: String = "Buttons"
        override val showcasePrimaryAction: String = "Primary action"
        override val showcaseSecondaryAction: String = "Secondary action"
        override val showcaseGhostAction: String = "Ghost action"
        override val showcaseTextField: String = "Text field"
        override val showcaseFocusedBorder: String = "Focused accent border"
        override val showcaseSearchPreview: String = "Search preview"
        override val showcaseOpeningCheckedIn: String = "Open House check-in today"
        override val showcaseSentAt: String = "Sent at 10:30 AM"
        override val themeObsidianGoldName: String = "Obsidian Gold"
        override val themeObsidianGoldDescription: String = "Luxury black, graphite, and warm gold."
        override val themeMidnightSapphireName: String = "Midnight Sapphire"
        override val themeMidnightSapphireDescription: String = "Deep navy, sapphire blue, and silver accents."
        override val themeEmeraldEstateName: String = "Emerald Estate"
        override val themeEmeraldEstateDescription: String = "Dark emerald, charcoal, and champagne gold."
        override val themePlatinumStoneName: String = "Platinum Stone"
        override val themePlatinumStoneDescription: String = "Stone gray, platinum, and soft white."
        override val themeBordeauxNoirName: String = "Bordeaux Noir"
        override val themeBordeauxNoirDescription: String = "Dark wine, graphite, and copper accents."
        override val commonChange: String = "Change"
        override val agentPlanTitle: String = "Agent plan"
        override val agentPlanBody: String = "Upgrade your experience, choose the plan that fits how you work best."
        override val currentPlan: String = "Current plan"
        override val transferPlan: String = "Transfer plan"
        override val transferPlanTitle: String = "Transfer plan"
        override val transferPlanBody: String = "Move this subscription to another HAVN account. Both email addresses must confirm with verification codes."
        override val transferTargetEmail: String = "New account email"
        override val transferSendCodes: String = "Send verification codes"
        override val transferCodesSentTitle: String = "Verification codes sent"
        override val transferCodesSentBody: String = "We sent one code to your email and one code to the new account email."
        override val transferYourCode: String = "Your email code"
        override val transferTargetCode: String = "New account code"
        override val transferConfirm: String = "Transfer plan"
        override val transferSuccessTitle: String = "Plan transferred"
        override val transferSuccessBody: String = "The subscription is now connected to the new HAVN account."
        override val restorePurchase: String = "Restore Purchase"
        override val agencySettingsProBody: String = "Solo agency is active by default. Pro lets you create or select a shared agency."
        override val agencySettingsLockedBody: String = "Solo agency is active. Agency changes unlock with Pro."
        override val soloAgency: String = "Solo agency"
        override val defaultPrivateAgencyWorkspace: String = "Default private agency"
        override val noAgenciesAvailableYet: String = "No agency invitations or owned agencies are available yet."
        override val oneOwnedAgencyHint: String = "Your owned agency is listed above. One agent can own one agency."
        override val createAgency: String = "Create agency"
        override val createYourAgency: String = "Create your agency"
        override val createAgencyBody: String = "Build your team, manage properties together, and grow your business."
        override val agencyName: String = "Agency name"
        override val agencyEmail: String = "Agency email"
        override val logoOptional: String = "Logo (optional)"
        override val upgradeExperienceTitle: String = "Upgrade your experience"
        override val upgradeExperienceSubtitle: String = "Run your first Open House free. Upgrade when you need more listings, open houses, and Pro workflows."
        override val soloAgentPlan: String = "Solo agent"
        override val proAgentPlan: String = "Pro agent"
        override val teamAgentPlan: String = "Team"
        override val soloBenefitActiveProperties: String = "Up to 100 active properties"
        override val soloBenefitAiFollowUps: String = "AI follow-ups (basic)"
        override val soloBenefitSellerReports: String = "No seller reports"
        override val soloBenefitPersonalOnly: String = "Personal only"
        override val proBenefitUnlimitedProperties: String = "Up to 10,000 properties"
        override val proBenefitUnlimitedAi: String = "10,000 AI text requests / month"
        override val proBenefitAdvancedReports: String = "Advanced seller reports"
        override val proBenefitAgencyCreation: String = "Agency creation and management"
        override val proBenefitInviteAgents: String = "Invite agents and collaborate"
        override val proBenefitSharedLeads: String = "Shared leads and team workflows"
        override val proBenefitAgencyBranding: String = "Agency branding"
        override val proBenefitAdvancedAnalytics: String = "Advanced analytics"
        override val teamBenefitLargeLimits: String = "Team-scale limits"
        override val teamBenefitPrioritySupport: String = "Priority email support"
        override val teamBenefitDailyBackups: String = "Daily backups for 7 days"
        override val teamBenefitLargeStorage: String = "10GB document storage"
        override val startFreeTrial7Day: String = "Subscribe now"
        override val restorePurchases: String = "Restore Purchase"
        override val comparePlans: String = "Compare plans"
        override val startFreeTrial: String = "Choose plan"
        override val noCommitmentCancelAnytime: String = "Run your first Open House free. Upgrade when you need more."
        override val monthly: String = "Monthly"
        override val yearly: String = "Yearly"
        override val yearlySave20: String = "Yearly"
        override val yearlySavings20: String = "Billed yearly."
        override val perYear: String = "/ year"
        override val loadingPlans: String = "Loading plans..."
        override val selectedPlanUnavailable: String = "Subscriptions are temporarily unavailable. Please try again later or contact support."
        override val signInRequiredForPurchase: String = "Sign in before starting a purchase."
        override val subscriptionDisclosureIos: String = "Auto-renewable subscription. Payment will be charged to your Apple Account at confirmation of purchase. Your subscription renews automatically unless canceled at least 24 hours before the end of the current period. Renewal will be charged within 24 hours before the end of the current period. You can manage or cancel your subscription in App Store account settings."
        override val subscriptionDisclosureAndroid: String = "Auto-renewable subscription through Google Play. You will be charged every billing period unless you cancel. You can manage or cancel your subscription anytime in Google Play subscriptions. Access continues until the end of the paid period."
        override val subscriptionDisclosureWeb: String = "Auto-renewable subscription. You will be charged every billing period using your selected payment method unless you cancel. You can manage or cancel anytime from Billing settings. Access continues until the end of the paid period. Taxes may apply."
        override val subscriptionAgreementPrefix: String = "By subscribing, you agree to"
        override val subscriptionTermsOfUse: String = "HAVN Terms of Use"
        override val subscriptionAgreementAnd: String = "and"
        override val subscriptionPrivacyPolicy: String = "Privacy Policy."
        override val purchaseSuccessTitle: String = "Thank you for your purchase"
        override val purchaseSuccessBody: String = "Your HAVN subscription is active and your plan is ready."
        override val restoreSuccessTitle: String = "Restore Purchase"
        override val restoreSuccessBody: String = "Your HAVN subscription was restored successfully."
        override val purchaseCouldNotComplete: String = "The purchase could not be completed. Please try again, or check your App Store or Google Play account."
        override val purchaseVerificationPending: String = "Your payment has not been confirmed yet. If you completed checkout, use Restore purchase to check again. You do not need to pay again."
        override val completeWebCheckout: String = "Complete payment in the checkout tab, then return here. Your access will update automatically once payment is confirmed."
        override val restoreCouldNotComplete: String = "No active HAVN subscription was found for this store account."
        override val noActiveSubscriptionFound: String = "No active HAVN subscription was found for this store account."
        override val compareActiveProperties: String = "Active properties"
        override val compareAiFollowUps: String = "AI follow-ups"
        override val compareSellerReports: String = "Seller reports"
        override val compareAdvancedAnalytics: String = "Advanced analytics"
        override val compareAgencyCreation: String = "Agency creation"
        override val compareJoinAgencies: String = "Join agencies"
        override val compareInviteAgents: String = "Invite agents"
        override val compareSharedLeads: String = "Shared leads"
        override val compareAgencyBranding: String = "Agency branding"
        override val comparePrioritySupport: String = "Priority support"
        override val compareFeature: String = "Feature"
        override val compareFreePlan: String = "Free"
        override val compareValueYes: String = "Yes"
        override val compareValueNo: String = "No"
        override val comparePricePerMonthUser: String = "Price / Month / User"
        override val comparePricePerYearUser: String = "Price / Year / User"
        override val compareMaxPropertiesOwner: String = "Max properties / owner"
        override val compareMaxContactsOwner: String = "Max contacts / owner"
        override val compareMaxOpenHousesOwner: String = "Max open houses / owner"
        override val compareMaxLeadsOwner: String = "Max leads / owner"
        override val compareMaxPhotosProperty: String = "Max photos per property"
        override val compareMaxDocumentsProperty: String = "Max documents per property"
        override val compareDocumentsStorage: String = "Documents storage"
        override val compareAgencyAgenda: String = "Agency agenda"
        override val compareAiTextRequestsMonth: String = "AI text generation requests / month"
        override val compareAnalytics: String = "Analytics"
        override val compareTasks: String = "Tasks"
        override val compareDocumentsStorageOwner: String = "Documents storage / owner"
        override val compareMaxFileSizeOwner: String = "Max file size / owner"
        override val compareEmailSupport: String = "Email support"
        override val compareDailyBackups7Days: String = "Daily backups stored for 7 days"
        override val compareKioskMode: String = "Kiosk mode"
        override val unlimited: String = "Unlimited"
        override val basic: String = "Basic"
        override val advanced: String = "Advanced"
        override val perMonth: String = "/ month"
        override val members: String = "members"
        override val upgradeToProForAgencyTools: String = "Upgrade to Pro to use agency tools"
        override val languageTitle: String = "Language"
        override val languageBody: String = "Choose the app language for this device."
        override val english: String = "English"
        override val slovak: String = "Slovak"
        override val unitsTitle: String = "Units and currency"
        override val unitsBody: String = "Choose how prices and property dimensions are shown across the app."
        override val measurementSystemTitle: String = "Measurement"
        override val metric: String = "Metric"
        override val imperial: String = "Imperial"
        override val currencyTitle: String = "Currency"
        override val notificationsTitle: String = "Notifications"
        override val notificationsBody: String = "Control push alerts, quiet hours, and the types of updates HAVN can send."
        override val notificationSettings: String = "Notification settings"
        override val notificationsSubtitle: String = "Only important updates, filtered by your preferences."
        override val quietHoursTitle: String = "Quiet hours"
        override val quietHoursBody: String = "HAVN skips non-critical pushes during quiet hours. Billing and account issues still stay concise."
        override val enableQuietHours: String = "Enable quiet hours"
        override val quietHoursStart: String = "Start"
        override val quietHoursEnd: String = "End"
        override val timezoneLabel: String = "Timezone"
        override val notificationTypesTitle: String = "Notification types"
        override val notificationNewLeadCapturedTitle: String = "New lead captured"
        override val notificationNewLeadCapturedBody: String = "When an open house or QR flow captures a lead."
        override val notificationHotLeadTitle: String = "Lead marked as hot"
        override val notificationHotLeadBody: String = "Only when a lead becomes high intent."
        override val notificationOpeningStartsSoonTitle: String = "Open House starts soon"
        override val notificationOpeningStartsSoonBody: String = "A single reminder 30 minutes before start."
        override val notificationOpeningSummaryReadyTitle: String = "Open House summary ready"
        override val notificationOpeningSummaryReadyBody: String = "When the post-event summary is ready."
        override val notificationSellerReportGeneratedTitle: String = "Seller report generated"
        override val notificationSellerReportGeneratedBody: String = "When a seller report has been created."
        override val notificationAiFollowUpReadyTitle: String = "AI follow-up ready"
        override val notificationAiFollowUpReadyBody: String = "When a follow-up draft is ready to review."
        override val notificationAgentInvitedTitle: String = "Agent invited to agency"
        override val notificationAgentInvitedBody: String = "Agency invitations and membership changes."
        override val notificationLeadAssignedTitle: String = "Lead assigned to you"
        override val notificationLeadAssignedBody: String = "When a teammate assigns a lead to you."
        override val notificationLeadTransferredTitle: String = "Lead transferred to you"
        override val notificationLeadTransferredBody: String = "When ownership of a lead moves to you."
        override val notificationSubscriptionIssueTitle: String = "Subscription issue"
        override val notificationSubscriptionIssueBody: String = "Renewal failures and billing problems."
        override val kioskSecurityTitle: String = "Kiosk security"
        override val kioskSecurityBody: String = "Use this PIN to leave kiosk mode and return to the agent app."
        override val kioskPinLabel: String = "Kiosk PIN"
        override val mcpAccessTitle: String = "MCP access"
        override val mcpAccessBody: String = "Bridge HAVN to Claude, OpenAI, and other MCP clients at mcp.havnre.app. Available on every plan."
        override val mcpAuthorizationBearer: String = "Authorization: Bearer"
        override val mcpNoApiKeyCreated: String = "No API key created"
        override val mcpNotUsedYet: String = "Not used yet"
        override val mcpLastUsedPrefix: String = "Last used"
        override val mcpRevealApiKeyTitle: String = "Reveal API key"
        override val mcpRevealApiKeyBody: String = "The full key is shown only after create or rotate."
        override val mcpCreateKey: String = "Create key"
        override val mcpRotateKey: String = "Rotate key"
        override val mcpRevokeKey: String = "Revoke key"
        override val mcpEndpointHint: String = "Use endpoint https://mcp.havnre.app/mcp with this key as the Bearer token."
        override val mcpUpgradeHint: String = "MCP access is available on every HAVN plan."
        override val mcpUpgradePrompt: String = "MCP access is available on every HAVN plan."
        override val mcpCopied: String = "Copied"
        override val mcpCopy: String = "Copy"
        override val mcpLoading: String = "Loading"
        override val kioskFeaturedProperty: String = "Featured property"
        override val kioskPrivateShowing: String = "Private showing"
        override val kioskLuxuryListing: String = "Luxury listing"
        override val kioskFastCheckIn: String = "Fast check-in"
        override val kioskExitContentDescription: String = "Exit kiosk"
        override val kioskWelcome: String = "Welcome"
        override val kioskGladHere: String = "We’re glad you’re here."
        override val kioskScanToCheckIn: String = "Scan to check in"
        override val kioskReceivePropertyDetails: String = "and receive property details"
        override val kioskOr: String = "Or"
        override val kioskStartCheckInManually: String = "Start check-in manually"
        override val kioskSecureInfo: String = "Your information is secure and will never be shared."
        override val kioskExitTitle: String = "Exit kiosk"
        override val kioskExitBody: String = "Enter the kiosk PIN to return to the agent app."
        override val kioskIncorrectPin: String = "Incorrect PIN."
        override val kioskUnlock: String = "Unlock"
        override val kioskTellUsTitle: String = "Tell us about yourself"
        override val kioskTellUsBody: String = "Your information goes only to the hosting agent."
        override val kioskFullName: String = "Full name"
        override val kioskContinue: String = "Continue"
        override val kioskQuestionsTitle: String = "A couple quick questions"
        override val kioskQuestionsBody: String = "This helps the agent follow up with the right context."
        override val kioskWorkingWithAgentQuestion: String = "Are you working with an agent?"
        override val kioskYes: String = "Yes"
        override val kioskNo: String = "No"
        override val kioskInterestQuestion: String = "What are you interested in?"
        override val kioskInterestBuying: String = "Buying"
        override val kioskInterestInvesting: String = "Investing"
        override val kioskInterestBrowsing: String = "Just browsing"
        override val kioskInterestRelocating: String = "Relocating"
        override val kioskFinish: String = "Finish"
        override val kioskThankYou: String = "Thank you"
        override val kioskEnjoyVisitPrefix: String = "Enjoy your visit at"
        override val kioskResetAutomatically: String = "This kiosk will reset automatically."
        override val environmentTitle: String = "Environment"
        override val environmentBody: String = "Connection details are configured for this build."
        override val secure: String = "Secure"
        override val brokerageProfileTitle: String = "Brokerage profile"
        override val brokerageProfileBody: String = "Team branding, agent invites, and notification preferences will live here."
        override val logout: String = "Log out"
        override val languageChanged: String = "Language changed"
        override val commonAdd: String = "Add"
        override val commonEdit: String = "Edit"
        override val commonDelete: String = "Delete"
        override val commonCancel: String = "Cancel"
        override val commonSave: String = "Save"
        override val commonCreate: String = "Create"
        override val commonDismiss: String = "Dismiss"
        override val commonAll: String = "All"
        override val commonDone: String = "Done"
        override val commonSend: String = "Send"
        override val commonTime: String = "Time"
        override val commonHour: String = "Hour"
        override val commonMinute: String = "Minute"
        override val commonAgency: String = "Agency"
        override val commonSettings: String = "Settings"
        override val commonOpening: String = "Open House"
        override val commonPropertyName: String = "Property"
        override val commonToday: String = "Today"
        override val agencyToolsAvailable: String = "Agency tools are available."
        override val agencySetupSubtitle: String = "Every HAVN account has a default agency. Pro lets you manage invites, shared leads, and branding."
        override val agencyRecentActivity: String = "Recent activity"
        override val agencyActivityNewLead: String = "New lead added"
        override val agencyActivityInvitationAccepted: String = "Agent invitation accepted"
        override val agencyActivityAgentJoined: String = "Agent joined the agency"
        override val agencyActivitySellerReport: String = "Seller report created"
        override val agencyWorkspaceTitle: String = "Agency"
        override val agencyWorkspaceBody: String = "Choose which agency you are working with."
        override val agencySoloActiveTitle: String = "Solo agency is active"
        override val agencyProRequiredTitle: String = "Pro plan required"
        override val agencyCreateOrAcceptInviteBody: String = "Create your agency or accept an invite to collaborate with another agency."
        override val agencyProUnlockBody: String = "Agency changes, invites, shared leads, and shared branding unlock with Pro."
        override val realEstate: String = "Real estate"
        override val proAgency: String = "Pro agency"
        override val agencyBrandingTitle: String = "Agency branding"
        override val agencyBrandingBody: String = "Set the agency name and logo shown in the app, kiosk, and team views."
        override val uploadLogo: String = "Upload logo"
        override val saveAgency: String = "Save agency"
        override val yourAgencyRole: String = "Your agency role"
        override val agencyAgentsTitle: String = "Agency agents"
        override val agencyAgentsBody: String = "People eligible to work with this agency."
        override val inviteAgent: String = "Invite agent"
        override val loadingAgents: String = "Loading agents..."
        override val noAgencyAgentsYet: String = "No agency agents yet."
        override val changeRole: String = "Change role"
        override val updating: String = "Updating..."
        override val deleting: String = "Deleting..."
        override val deleteInvite: String = "Cancel invitation"
        override val chooseAgencyRoleFor: String = "Choose the agency role for"
        override val removeAccess: String = "Remove access"
        override val inviteAgentBody: String = "Send an agency invitation by email. The agent accepts after signing in with the same email."
        override val agentEmail: String = "Agent email"
        override val role: String = "Role"
        override val inviting: String = "Inviting..."
        override val invite: String = "Invite"
        override val agents: String = "Agents"
        override val ok: String = "Ok"
        override val personalActivePropertyLimit: String = "Personal active property limit"
        override val personalAccountAgencyToolsLocked: String = "Personal account is active. Agency tools unlock with Pro."
        override val selected: String = "Selected"
        override val activeMembers: String = "active members"
        override val agencySharedWorkspaceBody: String = "Shared properties, contacts, open houses, leads, follow-ups, and reports use this agency."
        override val actLikeAgent: String = "Act like Agent"
        override val actAsAdmin: String = "Act as Admin"
        override val actAsOwner: String = "Act as Owner"
        override val actLikeAgentBody: String = "Use the agency as a normal Agent."
        override val actLikeAgentSelectedBody: String = "Only assigned or owned work is shown."
        override val agencyRoleOwner: String = "Owner"
        override val agencyRoleAdmin: String = "Admin"
        override val agencyRoleAgent: String = "Agent"
        override val agencyRoleAssistant: String = "Assistant"
        override val agencyRoleViewer: String = "Viewer"
        override val agencyRoleOwnerDescription: String = "Full agency control, including members, branding, assignments, listings, leads, and reports."
        override val agencyRoleAdminDescription: String = "Full agency management except deleting the agency."
        override val agencyRoleAgentDescription: String = "Works assigned listings, open houses, leads, follow-ups, notes, and seller reports."
        override val agencyRoleAssistantDescription: String = "Supports assigned listings by editing leads, preparing follow-ups, and drafting reports."
        override val agencyRoleViewerDescription: String = "Read-only access to dashboards and reports."
        override val agencyCapabilityInviteRemoveMembers: String = "Invite and remove members"
        override val agencyCapabilityChangeRoles: String = "Change member roles"
        override val agencyCapabilityManageAllProperties: String = "Create, edit, and delete all properties"
        override val agencyCapabilityAssignAgents: String = "Assign agents"
        override val agencyCapabilitySeeAllLeads: String = "See all leads"
        override val agencyCapabilityExportReports: String = "Export reports"
        override val agencyCapabilityChangeBranding: String = "Change agency branding and settings"
        override val agencyCapabilityDeleteAgency: String = "Delete agency"
        override val agencyCapabilityViewAssignedProperties: String = "View assigned properties"
        override val agencyCapabilityHostAssignedOpenings: String = "Host assigned open houses"
        override val agencyCapabilitySeeAssignedLeads: String = "See leads from assigned properties and open houses"
        override val agencyCapabilityAddNotes: String = "Add notes"
        override val agencyCapabilitySendFollowUps: String = "Send follow-ups"
        override val agencyCapabilityCreateSellerReports: String = "Create seller reports for assigned listings"
        override val agencyCapabilityEditAssignedLeads: String = "Edit assigned leads"
        override val agencyCapabilityPrepareFollowUps: String = "Prepare follow-ups"
        override val agencyCapabilityCreateDraftReports: String = "Create draft reports"
        override val agencyCapabilityCannotDeleteProperties: String = "Cannot delete properties"
        override val agencyCapabilityCannotInviteAgents: String = "Cannot invite agents unless allowed"
        override val agencyCapabilityViewDashboards: String = "View dashboards"
        override val agencyCapabilityViewReports: String = "View reports"
        override val agencyCapabilityCannotEdit: String = "Cannot edit anything"
        override val commonVisitors: String = "Leads"
        override val commonHot: String = "Hot"
        override val commonWarm: String = "Warm"
        override val commonCold: String = "Cold"
        override val commonActive: String = "Active"
        override val commonPlanned: String = "Planned"
        override val commonArchived: String = "Archived"
        override val commonPast: String = "Past"
        override val commonFollowUps: String = "Follow-ups"
        override val commonProperty: String = "Property"
        override val commonAddress: String = "Address"
        override val commonOpenHouse: String = "Open House"
        override val commonInquiry: String = "Inquiry"
        override val commonInquiries: String = "Inquiries"
        override val generalInquiry: String = "General inquiry"
        override val generalInquiries: String = "General Inquiries"
        override val propertyInquiry: String = "Property inquiry"
        override val propertyInquiries: String = "Property Inquiries"
        override val addGeneralInquiry: String = "Add general inquiry"
        override val newGeneralInquiry: String = "New general inquiry"
        override val noGeneralInquiries: String = "No general inquiries yet."
        override val noPropertyInquiries: String = "No property inquiries yet."
        override val buyerLookingFor: String = "What is this buyer looking for?"
        override val locationCity: String = "Location / city"
        override val radiusKm: String = "Radius (km)"
        override val propertyType: String = "Property type"
        override val budgetFrom: String = "Budget from"
        override val budgetTo: String = "Budget to"
        override val purchaseTimeline: String = "Purchase timeline"
        override val createGeneralInquiry: String = "Create general inquiry"
        override val saveGeneralInquiry: String = "Save general inquiry"
        override val inquiryType: String = "Inquiry type"
        override val leadSource: String = "Lead source"
        override val notSpecified: String = "Not specified"
        override val inquiryStatus: String = "Inquiry status"
        override val inquiryFollowUp: String = "Inquiry follow-up"
        override val addInquiry: String = "Add inquiry"
        override val searchInquiries: String = "Search inquiries"
        override val noInquiries: String = "No inquiries"
        override val noInquiriesBody: String = "Use the plus button to add buyer interest from an existing contact."
        override val inquiryUnavailableTitle: String = "Inquiry unavailable"
        override val inquiryUnavailableBody: String = "This inquiry may have been removed or is still loading."
        override val backToInquiries: String = "Back to inquiries"
        override val deleteInquiry: String = "Delete inquiry"
        override val deleteInquiryQuestionPrefix: String = "Delete"
        override val deleteInquiryQuestionSuffix: String = "from this property?"
        override val deleteInquiryTargetFallback: String = "this inquiry"
        override val propertyInquiriesBody: String = "Track buyers who asked about this property. Inquiries also appear in Leads."
        override val propertyInquiriesEmpty: String = "Add an inquiry by choosing one of your contacts."
        override val contactInquiriesBody: String = "Properties this contact has asked about."
        override val contactInquiriesEmpty: String = "No property inquiries yet."
        override val viewInquiries: String = "View inquiries"
        override val createContactFirstForInquiry: String = "Create a contact first, then add the inquiry from this property."
        override val commonCheckedIn: String = "Checked in"
        override val commonNotScheduled: String = "not scheduled"
        override val todayTitle: String = "Today"
        override val todaySubtitle: String = "Your daily home for open houses, leads, follow-ups, and seller-ready momentum."
        override val todayOpenHousesMetric: String = "open houses"
        override val capturedMetric: String = "captured"
        override val priorityMetric: String = "priority"
        override val noActivePropertiesTitle: String = "No active properties"
        override val noActivePropertiesBody: String = "Add or activate a property to make it appear on Today."
        override val checkIns: String = "Check-ins"
        override val allOpenHouses: String = "all open houses"
        override val pendingDrafts: String = "pending drafts"
        override val priorityLead: String = "Priority lead"
        override val nextOpenHouseAt: String = "Next open house at"
        override val noOpenHouseScheduled: String = "No open house scheduled"
        override val personalAccount: String = "Personal account"
        override val accountReady: String = "Your account is ready"
        override val realEstateApp: String = "Real estate app"
        override val needHelp: String = "Need help?"
        override val contactSupport: String = "Contact support"
        override val upgradePlan: String = "Upgrade plan"
        override val planSuffix: String = "Plan"
        override val todayActionsTitle: String = "Today's priorities"
        override val agencyInvitation: String = "Agency invitation"
        override val joinAgency: String = "Join"
        override val youWereInvitedAs: String = "You were invited as"
        override val invitedBy: String = "by"
        override val decline: String = "Decline"
        override val yourDefaultAgency: String = "Your default agency"
        override val chooseAgencyBody: String = "Choose which agency you want to work with. Agency tools include invites, shared leads, and branding."
        override val agencyMembersSuffix: String = "members"
        override val quickActionTasksBody: String = "Queue"
        override val quickActionReportsBody: String = "Seller"
        override val quickActionAnalyticsBody: String = "Trends"
        override val quickActionAddPropertyTitle: String = "Add"
        override val quickActionAddPropertyBody: String = "Listing"
        override val quickActionAddContactTitle: String = "Contact"
        override val quickActionAddContactBody: String = "New"
        override val quickActionFilesTitle: String = "Files"
        override val quickActionFilesBody: String = "Docs"
        override val firstRunStepsTitle: String = "Start with four simple steps"
        override val firstRunAddProperty: String = "Add property"
        override val firstRunScheduleOpening: String = "Schedule open house"
        override val firstRunStartGuestCheckIn: String = "Start guest check-in"
        override val firstRunSendFollowUp: String = "Send follow-up"
        override val greetingNamePrefix: String = "Hi"
        override val greetingAgent: String = "Hi Agent"
        override val createListing: String = "Create listing"
        override val newOwnerBuyer: String = "New owner/buyer"
        override val documents: String = "Documents"
        override val whatOpeningNext: String = "What open house is next?"
        override val whoCheckedIn: String = "Who checked in?"
        override val whoNeedsFollowUp: String = "Who needs follow-up?"
        override val whatShouldIDoNow: String = "What should I do now?"
        override val noCheckInsYet: String = "No contacts have checked in yet."
        override val noPendingFollowUps: String = "No pending follow-ups right now."
        override val openKioskForNextOpening: String = "Open the kiosk for the next open house."
        override val reviewNewLeads: String = "Review new leads and send follow-ups."
        override val createOpeningToStart: String = "Create an open house from a property to start collecting leads."
        override val addFirstPropertyToStart: String = "Add your first property to get started."
        override val nextOpening: String = "Next open house"
        override val quickSignIn: String = "Quick sign-in"
        override val scanQrCode: String = "Scan QR code"
        override val newLead: String = "New lead"
        override val myProperties: String = "My properties"
        override val manageListings: String = "Manage listings"
        override val todaysOverview: String = "Today's overview"
        override val seeAll: String = "See all"
        override val propertiesEyebrow: String = "Portfólio"
        override val propertiesSubtitle: String = "Manage active, planned, and archived listings with listing media, buyer activity, and performance insights."
        override val propertiesLiveMetric: String = "live"
        override val propertiesPipelineMetric: String = "pipeline"
        override val propertiesAllTimeMetric: String = "all time"
        override val addProperty: String = "Add property"
        override val editProperty: String = "Edit property"
        override val propertyFallback: String = "Property"
        override val propertyUnavailableTitle: String = "Property unavailable"
        override val propertyUnavailableBody: String = "Refresh the portfolio to reload this listing."
        override val backToProperties: String = "Back to properties"
        override val deletePropertyTitle: String = "Delete property?"
        override val deletePropertyBody: String = "This will permanently delete the property and its related local records. This cannot be undone."
        override val loadingProperties: String = "Loading properties"
        override val loadMore: String = "Load more"
        override val loadingPropertyDetails: String = "Loading property details"
        override val noPropertiesTitle: String = "No properties yet"
        override val noPropertiesBody: String = "Add your first property, then create an open house to start collecting leads and seller-ready feedback."
        override val openHouseButton: String = "Create open house"
        override val photosTitle: String = "Photos"
        override val photosBody: String = "The first photo is used as the main property image across Portfolio."
        override val uploadPhoto: String = "Upload photo"
        override val noPhotosYet: String = "No photos uploaded yet."
        override val propertyPhotoCountPlanLimit: String = "Photo limit reached for this property on your current plan. Upgrade to upload more photos."
        override val propertyPhotoStoragePlanLimit: String = "Storage limit reached for your current plan. Upgrade to upload more photos or files."
        override val mainPhoto: String = "Main"
        override val propertyTitleLabel: String = "Property name"
        override val propertyAddressLine1Label: String = "Street address"
        override val propertyAddressLine2Label: String = "Address line 2"
        override val propertyCityLabel: String = "City"
        override val propertyRegionLabel: String = "Region"
        override val propertyPostalCodeLabel: String = "Postal code"
        override val propertyCountryLabel: String = "Country"
        override val propertyAskingPriceLabel: String = "Asking price"
        override val propertyBedsLabel: String = "Beds"
        override val propertyBathsLabel: String = "Baths"
        override val propertyInteriorLabel: String = "Interior"
        override val propertyDescriptionLabel: String = "Description"
        override val createPropertyButton: String = "+ Property"
        override val locateProperty: String = "Locate property"
        override val findLocation: String = "Find location"
        override val find: String = "Find"
        override val navigate: String = "Navigate"
        override val propertyLocationMarkerTitle: String = "Property location"
        override val mapKitJsMissingToken: String = "Add HAVN_MAPKIT_JS_TOKEN to local.properties for the web map."
        override val mapKitJsLoading: String = "Loading MapKit JS..."
        override val generateSellerReport: String = "Generate seller report"
        override val deleteProperty: String = "Delete property"
        override val conversionMetric: String = "Conversion"
        override val propertyPhotoContentDescription: String = "Property photo"
        override val deletePhoto: String = "Delete photo"
        override val movePhotoLeft: String = "Move photo left"
        override val movePhotoRight: String = "Move photo right"
        override val propertyTitleRequired: String = "Property name is required."
        override val propertyStreetRequired: String = "Street address is required."
        override val propertyCityRequired: String = "City is required."
        override val propertyRegionRequired: String = "Region is required."
        override val propertyPostalRequired: String = "Postal code is required."
        override val propertyAskingPriceInvalid: String = "Enter a valid asking price."
        override val propertyOwnerContactTitle: String = "Property owner contact"
        override val propertyOwnerSelectContact: String = "Select an existing contact as the property owner."
        override val propertyOwnerSelected: String = "Selected owner"
        override val propertyOwnerNoContacts: String = "No contacts yet. Add the owner in Contacts, then select them here."
        override val propertyOwnerChooseContact: String = "Choose contact"
        override val propertyOwnerChangeContact: String = "Change contact"
        override val propertyOwnerRemoveContact: String = "Remove"
        override val propertyOwnerPickerTitle: String = "Choose property owner"
        override val propertyOwnerSearchContact: String = "Search contacts"
        override val propertyOwnerSearchHint: String = "Start typing a name, email, or phone number."
        override val propertyOwnerNoMatches: String = "No matching contacts."
        override val propertyOpeningsTitle: String = "Open Houses"
        override val propertyNoOpenings: String = "No open houses scheduled for this property."
        override val teamAccessTitle: String = "Team access"
        override val onlyListingOwner: String = "Only the listing owner"
        override val assignTeam: String = "Assign team"
        override val assignPropertyTitle: String = "Assign property"
        override val assignPropertyBody: String = "Choose who can work this property. Select the whole team or specific agents."
        override val wholeTeam: String = "Whole team"
        override val leadsEyebrow: String = "Leads"
        override val leadFallback: String = "Lead"
        override val leadsSubtitle: String = "Search, filter, and qualify leads captured across every open house."
        override val leadDetailSubtitle: String = "Source, qualification, notes, and follow-up history for this open house lead."
        override val totalMetric: String = "Total"
        override val loggedMetric: String = "logged"
        override val searchLeads: String = "Search leads"
        override val searchLeadsPlaceholder: String = "Name, phone, or email"
        override val allProperties: String = "All properties"
        override val loadingLeads: String = "Loading open house leads"
        override val loadingLeadDetails: String = "Loading lead details"
        override val noLeadsFoundTitle: String = "Leads will appear here when contacts check in to an open house."
        override val noLeadsEmptyBody: String = "Use kiosk check-in or add contacts manually from an open house."
        override val noLeadsFilteredBody: String = "Try a different property, status, or search term."
        override val backToLeads: String = "Back to leads"
        override val leadUnavailableTitle: String = "Lead unavailable"
        override val leadUnavailableBody: String = "This lead is no longer available in the current lead list."
        override val leadTemperature: String = "Lead status"
        override val leadLabelSuffix: String = "Lead"
        override val greetingHi: String = "Hi"
        override val leadActionCall: String = "Call"
        override val leadActionSms: String = "SMS"
        override val leadActionEmail: String = "Email"
        override val leadFollowUp: String = "Follow-up"
        override val leadNoFollowUpScheduled: String = "No follow-up scheduled"
        override val leadIntentScore: String = "Intent score"
        override val leadInterestedIn: String = "Interested in"
        override val leadGenericGreetingName: String = "there"
        override val followUpMessageTypeThankYou: String = "Thank you"
        override val followUpMessageTypePropertyInfo: String = "Property info"
        override val followUpMessageTypeFollowUp: String = "Follow up"
        override val followUpMessageTypeCheckIn: String = "Check in"
        override val followUpMessageTypePriceUpdate: String = "Price update"
        override val followUpMessageTypePropertyBrochure: String = "Files"
        override val followUpPreview: String = "Preview"
        override val followUpSubject: String = "Subject"
        override val followUpMessage: String = "Message"
        override val followUpSendViaEmail: String = "Send via email"
        override val followUpSendViaSms: String = "Send via SMS"
        override val followUpAiAssistantTitle: String = "AI assistant"
        override val followUpAiAssistantBody: String = "Generate a personalized message in seconds."
        override val followUpGenerateWithAi: String = "Generate with AI"
        override val followUpUpgradeForAi: String = "Upgrade for AI"
        override val followUpDefaultSubject: String = "Following up on"
        override val privateAgentNotes: String = "Private agent notes"
        override val notes: String = "Notes"
        override val notesPlaceholder: String = "Motivation, preferences, objections, next move"
        override val saveNotes: String = "Save notes"
        override val followUpHistory: String = "Follow-up history"
        override val noFollowUpsLogged: String = "No follow-ups logged yet."
        override val openHousesEyebrow: String = "Showings"
        override val scheduleOpenHouse: String = "Create open house"
        override val openingDetails: String = "Open House details"
        override val editOpening: String = "Edit open house"
        override val deleteOpening: String = "Delete open house"
        override val deleteOpeningBody: String = "Are you sure you want to delete this open house? This cannot be undone."
        override val removeLeadTitle: String = "Remove lead?"
        override val removeLeadBody: String = "Remove %s from this open house?"
        override val removeLeadFallback: String = "this lead"
        override val openingName: String = "Open House name"
        override val startsAt: String = "Starts at"
        override val endsAt: String = "Ends at"
        override val chooseStartDateTime: String = "Choose start date and time"
        override val chooseEndDateTime: String = "Choose end date and time"
        override val accessNotes: String = "Access notes"
        override val privateNotes: String = "Private notes"
        override val addPrivateNote: String = "Add private note"
        override val liveDashboard: String = "Live dashboard"
        override val visitorKiosk: String = "Lead kiosk"
        override val openHousesSubtitle: String = "Create open houses for properties, review leads, and launch kiosk sessions."
        override val liveMetric: String = "Live"
        override val upcomingMetric: String = "Upcoming"
        override val inProgressMetric: String = "in progress"
        override val scheduledMetric: String = "scheduled"
        override val loadingOpenHouses: String = "Loading open houses"
        override val addPropertyFirstTitle: String = "Add a property first"
        override val addPropertyFirstBody: String = "Create an open house from a property to start collecting leads."
        override val noOpenHousesTitle: String = "No open houses scheduled"
        override val noOpenHousesBody: String = "Create an open house from a property to start collecting leads."
        override val noSignInsTitle: String = "No sign-ins yet"
        override val noSignInsBody: String = "Leads checked in through kiosk mode will appear here in real time."
        override val dashboard: String = "Dashboard"
        override val start: String = "Start"
        override val end: String = "End"
        override val endOpenHouse: String = "End open house"
        override val reportsEyebrow: String = "Owners"
        override val sellerReportsTitle: String = "Seller reports"
        override val createReport: String = "Create report"
        override val reportPreview: String = "Seller Report"
        override val reportsSubtitle: String = "Create premium post-open-house recaps with lead quality, buyer intent, and seller-ready narrative."
        override val reportsMetricSaved: String = "saved"
        override val reportedMetric: String = "reported"
        override val leadsMetric: String = "leads"
        override val createSellerReport: String = "Create report"
        override val attendance: String = "Attendance"
        override val savedReports: String = "saved reports"
        override val buyerHeat: String = "Buyer heat"
        override val hotLeads: String = "Hot leads"
        override val loadingSellerReports: String = "Loading seller reports"
        override val noSellerReportsTitle: String = "No seller reports yet"
        override val noSellerReportsBody: String = "Choose an open house, add agent notes, preview an export-ready recap, then save it."
        override val chooseOpenHouse: String = "Choose open house"
        override val noOpenHousesAvailable: String = "No open houses available yet."
        override val agentNotes: String = "Agent notes"
        override val notesForSeller: String = "Notes for seller"
        override val sellerNotesPlaceholder: String = "Buyer objections, pricing signals, showing feedback, recommended next move"
        override val generatePreview: String = "Generate preview"
        override val noPreviewReadyTitle: String = "No preview ready"
        override val noPreviewReadyBody: String = "Generate a seller report preview before saving."
        override val saveReport: String = "Save report"
        override val reportSaved: String = "Report saved"
        override val sellerOpenHouseReport: String = "Seller open house report"
        override val mostCommonBuyerInterest: String = "Most common buyer interest"
        override val followUpsSent: String = "Follow-ups sent"
        override val summary: String = "Summary"
        override val noPrivateNotesAdded: String = "No private notes added."
        override val openHouseReport: String = "Open House report"
        override val commonDraft: String = "Draft"
        override val commonAccepted: String = "Accepted"
        override val searchSellerReports: String = "Search seller reports"
        override val noMatchingReports: String = "No matching reports"
        override val clearFilters: String = "Clear filters"
        override val tryDifferentSearchOrStatusFilter: String = "Try a different search or status filter."
        override val connectedToProperty: String = "Connected to property"
        override val viewProperty: String = "View property"
        override val dataRollup: String = "Data rollup"
        override val connectedOpenings: String = "Open Houses"
        override val visitors: String = "Visitors"
        override val interestedBuyers: String = "Interested buyers"
        override val completedFollowUps: String = "Follow Ups"
        override val reportHistory: String = "Report history"
        override val noPreviousReportsYet: String = "No previous reports yet."
        override val viewAllReports: String = "View all reports"
        override val actions: String = "Actions"
        override val generatePdf: String = "Create spreadsheet"
        override val previewPdf: String = "Preview spreadsheet"
        override val pdfSavedToPropertyFiles: String = "%s saved to property files."
        override val pdfSavingToPropertyFiles: String = "%s is being saved to property files."
        override val pdfSavedToFiles: String = "%s saved to files."
        override val pdfSavingToFiles: String = "%s is being saved to files."
        override val pdfIncludesSellerReport: String = "Spreadsheet includes Seller Report metrics, AI insights, agent details, property data, and open house history."
        override val pdfIncludesAnalytics: String = "Spreadsheet includes analytics metrics, top properties, agent performance, follow-up channels, and AI insights."
        override val pdfGenerateBeforeSending: String = "Create the spreadsheet before sending."
        override val pdfUploadBeforeSharing: String = "The spreadsheet must finish uploading before sharing."
        override val sellerReportPdfNeedsProperty: String = "Seller Report spreadsheet needs a connected property before uploading."
        override val deleteReport: String = "Delete Report"
        override val deleteReportBody: String = "Are you sure you want to delete this seller report? This cannot be undone."
        override val shareReport: String = "Share report"
        override val openingPropertyReportLoading: String = "Property report..."
        override val openingPropertyReportCreating: String = "Creating property report..."
        override val sellerReportGeneratedPrefix: String = "Seller Report generated"
        override val sellerReportGeneratedSuffix: String = "from open houses, visitors, leads, follow-ups, and feedback connected to this property at report time."
        override val priceNotSet: String = "Price not set"
        override val daysSuffix: String = "days"
        override val connectedOpeningSingular: String = "open house"
        override val connectedOpeningPlural: String = "open houses"
        override val connectedLeadSingular: String = "connected lead"
        override val connectedLeadPlural: String = "connected leads"
        override val sellerConfidence: String = "Seller confidence"
        override val sellerConfidenceExplanation: String = "Confidence explanation"
        override val aiDraftReviewBeforeSending: String = "AI draft only. Review and edit before sending to the seller."
        override val executiveSummary: String = "Executive summary"
        override val buyerInterestOverview: String = "Buyer interest overview"
        override val whatBuyersLoved: String = "What buyers loved"
        override val buyerConcerns: String = "Buyer concerns"
        override val leadQualitySummary: String = "Lead quality summary"
        override val agentActivity: String = "Agent activity"
        override val aiRecommendations: String = "AI recommendations"
        override val recommendations: String = "Recommendations"
        override val marketPositionComparison: String = "Market position comparison"
        override val nextSteps: String = "Next steps"
        override val conversion: String = "Conversion"
        override val interested: String = "interested"
        override val tourSignalsLowercase: String = "tour signals"
        override val propertyTimeline: String = "Property timeline"
        override val timelineBasisNote: String = "Timeline is based only on connected open house registrations and follow-ups."
        override val visitorsLowercase: String = "visitors"
        override val hotLeadsLowercase: String = "hot leads"
        override val hotLowercase: String = "hot"
        override val sentiment: String = "Sentiment"
        override val toursLowercase: String = "tours"
        override val interestedLowercase: String = "interested"
        override val noRepeatedFeedbackMentions: String = "No repeated feedback mentions have been recorded yet."
        override val scoresMentionRates: String = "Scores are mention rates across saved buyer feedback."
        override val aiExecutiveBriefing: String = "AI executive briefing"
        override val viewAllAiInsights: String = "View all AI insights ->"
        override val followUpsSentTitle: String = "Follow-Ups Sent"
        override val financingPacketsShared: String = "Financing Packets Shared"
        override val buyerCalls: String = "Buyer Calls"
        override val propertyDataEvidence: String = "Property data evidence"
        override val attendanceCoverage: String = "Attendance coverage"
        override val leadQuality: String = "Lead quality"
        override val followUpExecution: String = "Follow-up execution"
        override val activityChannels: String = "Activity channels"
        override val callsLowercase: String = "calls"
        override val emailsLowercase: String = "emails"
        override val offerReadinessScore: String = "Offer readiness score"
        override val date: String = "Date"
        override val propertyLeadFunnel: String = "Property lead funnel"
        override val openHouseBreakdown: String = "Open house breakdown"
        override val aiInsights: String = "AI Insights"
        override val generateAiInsights: String = "Generate AI Insights"
        override val analyticsOverview: String = "Analytics overview"
        override val allAgents: String = "All agents"
        override val me: String = "Me"
        override val allActivity: String = "All activity"
        override val latest30Days: String = "Latest 30 days"
        override val latest7Days: String = "Latest 7 days"
        override val analyticsDatePreset: String = "Date range"
        override val analyticsCustomDate: String = "Custom date"
        override val analyticsLastDay: String = "Last day"
        override val analyticsLastWeek: String = "Last week"
        override val analyticsLastMonth: String = "Last month"
        override val analyticsLastYear: String = "Last year"
        override val analyticsAllTime: String = "All time"
        override val analyticsDateFrom: String = "Date from"
        override val analyticsDateTo: String = "Date to"
        override val analyticsOpenHousesLowercase: String = "open houses"
        override val analyticsWarmLeadsLowercase: String = "warm leads"
        override val analyticsFromNotesFollowUps: String = ""
        override val analyticsFromText: String = "from text"
        override val analyticsHotConversion: String = "Hot conversion"
        override val analyticsHotLeadsPerVisitors: String = "hot leads / visitors"
        override val analyticsAverageIntent: String = "Avg. intent"
        override val analyticsVisitorIntentScore: String = "visitor intent score"
        override val analyticsSelectDate: String = "Select date"
        override val propertyFunnel: String = "Property funnel"
        override val propertyFunnelSubtitle: String = "From property activity to qualified buyer momentum"
        override val properties: String = "Properties"
        override val tourSignals: String = "Tour signals"
        override val offerSignals: String = "Offer signals"
        override val viewFullFunnelReport: String = "View full funnel report"
        override val performanceOverTime: String = "Performance over time"
        override val thirtyDays: String = "30 days"
        override val topPerformingProperties: String = "Top performing properties"
        override val viewAll: String = "View all"
        override val noPropertyAnalyticsYet: String = "No property analytics yet."
        override val leadQualityBreakdown: String = "Lead quality breakdown"
        override val warmLeadsTitle: String = "Warm leads"
        override val coldLeadsTitle: String = "Cold leads"
        override val followUpPerformance: String = "Follow-up performance"
        override val agentPerformance: String = "Agent performance"
        override val viewTeamReport: String = "View team report"
        override val followUpChannels: String = "Follow-up channels"
        override val viewReport: String = "View report"
        override val searchProperties: String = "Search properties"
        override val searchOpenings: String = "Search open houses"
        override val noOpeningsFoundTitle: String = "No open houses found"
        override val noOpeningsFoundBody: String = "Try another search or open house status filter."
        override val noMatchingPropertiesTitle: String = "No matching properties"
        override val noMatchingPropertiesBody: String = "Try another search or status filter."
        override val clientsTitle: String = "Contacts"
        override val clientFallback: String = "Contact"
        override val addClient: String = "Add contact"
        override val editClient: String = "Edit contact"
        override val newClient: String = "New contact"
        override val saveClient: String = "Save contact"
        override val createClient: String = "Create contact"
        override val deleteClientTitle: String = "Delete contact?"
        override val deleteClientBody: String = "This will permanently delete the contact. This cannot be undone."
        override val firstName: String = "First name"
        override val lastName: String = "Last name"
        override val email: String = "Email"
        override val phone: String = "Phone"
        override val comments: String = "Comments"
        override val addPhoto: String = "Add photo"
        override val sendQr: String = "Send QR"
        override val sendQrShareTitle: String = "Your HAVN open house QR"
        override val sendQrShareBody: String = "Your HAVN open house QR is attached. Add the Wallet pass (.pkpass) to your phone when available, or show the QR image at the open house."
        override val sendQrReadyMessage: String = "QR code ready to send"
        override val sendQrUnavailableError: String = "No email or SMS app is available for this contact."
        override val clientQrDeliveryRequired: String = "Add an email or phone number for QR delivery."
        override val photo: String = "Photo"
        override val clientDetailSubtitle: String = "QR identity, contact details, comments, and open houses connected through leads."
        override val clientFormEditSubtitle: String = "Update contact details, delivery info, and comments."
        override val clientFormNewSubtitle: String = "Register a buyer/contact and generate a reusable QR identity for open houses."
        override val searchClients: String = "Search contacts"
        override val noClientsYetTitle: String = "No contacts yet"
        override val noClientsYetBody: String = "Register contacts first, then send their QR code by email or SMS before an open house."
        override val noClientsFoundTitle: String = "No contacts found"
        override val noClientsFoundBody: String = "Try another name, phone, or email."
        override val clientUnavailableTitle: String = "Contact unavailable"
        override val clientUnavailableBody: String = "Refresh the contacts list and open this record again."
        override val noCommentsAdded: String = "No comments added."
        override val openingsTitle: String = "Open Houses"
        override val clientOpeningsEmpty: String = "No open houses connected yet. Leads connect a contact to an open house."
        override val clientPassLabel: String = "Wallet pass"
        override val clientNoEmail: String = "No email"
        override val visitorsBody: String = "Open kiosk mode, scan a contact QR, or add existing contacts as leads for this open house."
        override val openKiosk: String = "Open kiosk"
        override val addQrClient: String = "Add QR contact"
        override val addManually: String = "Add manually"
        override val selectClients: String = "Select contacts"
        override val selectClientsBody: String = "Choose contacts from your list. Each selected contact becomes a lead for this open house."
        override val kioskCheckIn: String = "Kiosk check-in"
        override val kioskCheckInBody: String = "Use the rear camera to scan the contact's HAVN Wallet QR. When the code is recognized, HAVN creates the lead for this open house automatically."
        override val scanWithCamera: String = "Scan with rear camera"
        override val clientQrImage: String = "Contact QR image"
        override val clientQrImageBody: String = "Keep the contact's QR inside the gold square. HAVN collects each scan below."
        override val scanMultipleQrBody: String = "Scan one or more HAVN contact QR codes, then tap Add QR contact."
        override val scannedQrReady: String = "contact QR ready to add"
        override val createLeadFromQr: String = "Create lead from QR"
        override val noClientsFoundShort: String = "No contacts found."
        override val remove: String = "Remove"
        override val tasksTitle: String = "Tasks"
        override val addTask: String = "Add task"
        override val searchTasks: String = "Search tasks"
        override val loadMoreTasks: String = "Load more tasks"
        override val createTask: String = "Create Task"
        override val saveTask: String = "Save Task"
        override val editTask: String = "Edit Task"
        override val newTask: String = "New task"
        override val taskDetails: String = "Task Details"
        override val taskName: String = "Name"
        override val taskDescription: String = "Description"
        override val taskDueDateTime: String = "Task date & time"
        override val chooseTaskDateTime: String = "Choose task date & time"
        override val clearTaskDateTime: String = "Clear date & time"
        override val assignToAgent: String = "Assign To Agent"
        override val noAgencyAgentsFound: String = "No agency agents found. The task will stay assigned to the owner."
        override val taskPriority: String = "Task Priority"
        override val taskStatus: String = "Status"
        override val taskVisibility: String = "Visibility"
        override val taskOwner: String = "Owner"
        override val taskOwnerFallback: String = "Task owner"
        override val assignedTo: String = "Assigned to"
        override val selectedAgent: String = "Selected agent"
        override val taskVisibilityBody: String = "This task is visible to the owner and the assigned agent."
        override val taskQueue: String = "Task queue"
        override val taskDetail: String = "Task detail"
        override val taskDetailEmpty: String = "Select a task to see context and next actions."
        override val connectedContext: String = "Connected Context"
        override val noTaskContext: String = "No property, contact, open house, or lead is linked yet."
        override val activityTimeline: String = "Activity Timeline"
        override val created: String = "Created"
        override val recently: String = "Recently"
        override val completed: String = "Completed"
        override val nextAction: String = "Next action"
        override val agentReviewOrCompletion: String = "Agent review or completion"
        override val noDueDate: String = "No due date"
        override val reopen: String = "Reopen"
        override val accept: String = "Accept"
        override val linkedTasks: String = "Linked tasks"
        override val noLinkedTasks: String = "No linked tasks yet."
        override val filesTitle: String = "Files"
        override val attachFile: String = "Attach file"
        override val noFilesAttached: String = "No files attached yet."
        override val fileLimitHint: String = "Files can be PDF, DOC, CAD, or other formats up to 20 MB each."
        override val deleteFileTitle: String = "Delete file?"
        override val deleteFileBody: String = "This file will be removed from HAVN storage."
        override val attachmentOpenFailed: String = "Could not open this file."
        override val attachmentDeleteOwnerOnly: String = "Only the file owner can delete this attachment."
        override val attachmentDocumentsNotIncluded: String = "Your current plan does not include file uploads. Upgrade to upload files."
        override val attachmentDocumentStorageNotIncluded: String = "Your current plan does not include document storage. Upgrade to upload files."
        override val attachmentFileSizePlanLimit: String = "This file is larger than your current plan allows. Upgrade to upload larger files."
        override val attachmentStoragePlanLimit: String = "Storage limit reached for your current plan. Upgrade to upload more files."
        override val attachmentDocumentCountPlanLimit: String = "Document limit reached for this property on your current plan. Upgrade to upload more files."
        override val attachmentHardFileLimit: String = "File attachments are limited to 100 MB."
        override val openFiles: String = "Open File(s)"
        override val sendViaEmail: String = "Send via Email"
        override val sendViaSms: String = "Send via SMS"
        override val sendEmailHeader: String = "Send Email"
        override val sendSmsHeader: String = "Send SMS"
        override val noContactsFound: String = "No contacts found."
        override val searchContacts: String = "Search contacts"
        override val linked: String = "Linked"
        override val recent: String = "Recent"
        override val taskColumnToDo: String = "To Do"
        override val taskColumnInProgress: String = "In Progress"
        override val taskColumnDone: String = "Done"
        override val taskColumnToDoSubtitle: String = "New tasks and next actions waiting to be started."
        override val taskColumnInProgressSubtitle: String = "Work currently owned by you or the team."
        override val taskColumnDoneSubtitle: String = "Completed tasks kept visible for team confidence."
        override val taskEmptyToDo: String = "No tasks to do."
        override val taskEmptyInProgress: String = "Nothing in progress."
        override val taskEmptyDone: String = "No completed tasks yet."
        override val taskKanbanEmptyToDo: String = "Nothing waiting. New follow-ups and report work will appear here."
        override val taskKanbanEmptyInProgress: String = "No active work in progress."
        override val taskKanbanEmptyDone: String = "Completed tasks will land here."
        override val taskEmptyBodyPrefix: String = "Create a task or move another task into"
        override val taskEmptyBodySuffix: String = "."
        override val taskActionStart: String = "Start"
        override val taskActionOverdue: String = "Overdue"
        override val taskActionCancel: String = "Cancel"
        override val taskPriorityLow: String = "Low"
        override val taskPriorityMedium: String = "Medium"
        override val taskPriorityHigh: String = "High"
        override val taskPriorityUrgent: String = "Urgent"
        override val taskStatusOpen: String = "Open"
        override val taskStatusInProgress: String = "In progress"
        override val taskStatusDone: String = "Done"
        override val taskStatusOverdue: String = "Overdue"
        override val taskStatusCancelled: String = "Cancelled"
        override val aiSuggestedTasks: String = "AI Suggested Tasks"
        override val noAiSuggestedTasks: String = "No AI suggestions yet. HAVN will suggest tasks after open houses and lead activity."
        override val taskFilterToday: String = "Today"
        override val taskFilterUpcoming: String = "Upcoming"
        override val taskFilterOverdue: String = "Overdue"
        override val taskFilterCompleted: String = "Completed"
        override val taskFilterAssignedToMe: String = "Assigned to Me"
        override val taskFilterAiSuggested: String = "AI Suggested"
        override val taskFilterEmptyToday: String = "You're clear for today."
        override val taskFilterEmptyUpcoming: String = "No upcoming tasks."
        override val taskFilterEmptyOverdue: String = "No overdue tasks."
        override val taskFilterEmptyCompleted: String = "No completed tasks yet."
        override val taskFilterEmptyAssignedToMe: String = "No tasks assigned to you."
        override val taskFilterEmptyAiSuggested: String = "No accepted AI suggested tasks yet."
        override val taskSuggestionHotLeadTitlePrefix: String = "Follow up with"
        override val taskSuggestionHotLeadTitleSuffix: String = "within 2 hours."
        override val taskSuggestionHotLeadDescriptionPrefix: String = "Hot lead from"
        override val taskSuggestionHotLeadDescriptionSuffix: String = "Keep momentum while intent is fresh."
        override val taskSuggestionHotLeadReason: String = "New hot lead captured."
        override val taskSuggestionSellerReportTitlePrefix: String = "Generate seller report for"
        override val taskSuggestionSellerReportTitleSuffix: String = "."
        override val taskSuggestionSellerReportDescription: String = "Summarize visitor volume, hot leads, follow-up activity, and buyer sentiment."
        override val taskSuggestionSellerReportReason: String = "Open house ended."
        override val taskSuggestionReviewFollowUpTitlePrefix: String = "Review and send"
        override val taskSuggestionReviewFollowUpTitleSuffix: String = "follow-up."
        override val taskSuggestionReviewFollowUpReason: String = "Follow-up draft still needs agent review."
        override val taskSuggestionKioskTitle: String = "Prepare kiosk mode and verify property photos."
        override val taskSuggestionKioskDescription: String = "Confirm sign-in flow, gallery, and open house details before buyers arrive."
        override val taskSuggestionKioskReason: String = "Open house is scheduled."
    }

    private val slovak: HavnStrings = object : HavnStrings {
        override val navToday: String = "Dnes"
        override val navProperties: String = "Nehnuteľnosti"
        override val navLeads: String = "Leady"
        override val navReports: String = "Reporty"
        override val navTasks: String = "Úlohy"
        override val navAnalytics: String = "Analytika"
        override val navAgency: String = "Agentúra"
        override val navSettings: String = "Nastavenia"
        override val navAuth: String = "Prístup agenta"
        override val navOpenHouses: String = "Obhliadky"
        override val navTours: String = "Obhliadky"
        override val navFollowUps: String = "Kontakty"
        override val navFollow: String = "Kontakty"
        override val back: String = "Späť"
        override val settingsEyebrow: String = "Účet"
        override val settingsTitle: String = "Nastavenia"
        override val settingsSubtitle: String = "Profil kancelárie, pozvánky, úložisko a tímové roly."
        override val agentProfileTitle: String = "Profil agenta"
        override val agentPhoto: String = "Fotka agenta"
        override val uploading: String = "Nahrávam..."
        override val saving: String = "Ukladám..."
        override val validAgentPhotoRequired: String = "Vyberte platnú fotku agenta."
        override val signOut: String = "Odhlásiť sa"
        override val signOutQuestion: String = "Odhlásiť sa?"
        override val signOutConfirmation: String = "Naozaj sa chcete odhlásiť z HAVN?"
        override val deleteAccount: String = "Vymazať účet"
        override val deleteAccountQuestion: String = "Vymazať účet?"
        override val deleteAccountOpenPageBody: String = "Otvorí sa stránka so žiadosťou o vymazanie účtu."
        override val deleteAccountReviewTitle: String = "Použite skutočný účet"
        override val deleteAccountReviewBody: String = "Tento účet pre app review je chránený, aby recenzenti počas testovania nestratili prístup. Na overenie vymazania účtu použite skutočný testovací účet."
        override val upgrade: String = "Vylepšiť"
        override val premiumThemesTitle: String = "Prémiové motívy"
        override val premiumThemesUpgradePrompt: String = "Vylepšite na Pro a odomknite prémiové motívy."
        override val appearanceTitle: String = "Vzhľad"
        override val appearanceBody: String = "Vyberte svetlý alebo tmavý režim pre webovú aplikáciu."
        override val previewComponents: String = "Ukážka komponentov"
        override val themeShowcaseTitle: String = "Ukážka motívu"
        override val showcaseButtons: String = "Tlačidlá"
        override val showcasePrimaryAction: String = "Hlavná akcia"
        override val showcaseSecondaryAction: String = "Vedľajšia akcia"
        override val showcaseGhostAction: String = "Nenápadná akcia"
        override val showcaseTextField: String = "Textové pole"
        override val showcaseFocusedBorder: String = "Zvýraznený okraj"
        override val showcaseSearchPreview: String = "Ukážka vyhľadávania"
        override val showcaseOpeningCheckedIn: String = "Príchod na obhliadku dnes"
        override val showcaseSentAt: String = "Odoslané o 10:30"
        override val themeObsidianGoldName: String = "Obsidian Gold"
        override val themeObsidianGoldDescription: String = "Luxusná čierna, grafit a zlato."
        override val themeMidnightSapphireName: String = "Midnight Sapphire"
        override val themeMidnightSapphireDescription: String = "Hlboká námornícka modrá, zafír a strieborné akcenty."
        override val themeEmeraldEstateName: String = "Emerald Estate"
        override val themeEmeraldEstateDescription: String = "Tmavý smaragd, charcoal a šampanské zlato."
        override val themePlatinumStoneName: String = "Platinum Stone"
        override val themePlatinumStoneDescription: String = "Kamenná sivá, platina a jemná biela."
        override val themeBordeauxNoirName: String = "Bordeaux Noir"
        override val themeBordeauxNoirDescription: String = "Tmavé víno, grafit a medené akcenty."
        override val commonChange: String = "Zmeniť"
        override val agentPlanTitle: String = "Plán agenta"
        override val agentPlanBody: String = "Vylepšite si prácu. Vyberte plán, ktorý najlepšie sedí vášmu spôsobu predaja."
        override val currentPlan: String = "Aktuálny plán"
        override val transferPlan: String = "Preniesť plán"
        override val transferPlanTitle: String = "Preniesť plán"
        override val transferPlanBody: String = "Presuňte toto predplatné na iný HAVN účet. Obe e-mailové adresy musia potvrdiť prenos overovacími kódmi."
        override val transferTargetEmail: String = "E-mail nového účtu"
        override val transferSendCodes: String = "Odoslať overovacie kódy"
        override val transferCodesSentTitle: String = "Overovacie kódy odoslané"
        override val transferCodesSentBody: String = "Jeden kód sme poslali na váš e-mail a druhý na e-mail nového účtu."
        override val transferYourCode: String = "Kód z vášho e-mailu"
        override val transferTargetCode: String = "Kód nového účtu"
        override val transferConfirm: String = "Preniesť plán"
        override val transferSuccessTitle: String = "Plán bol prenesený"
        override val transferSuccessBody: String = "Predplatné je teraz pripojené k novému HAVN účtu."
        override val restorePurchase: String = "Obnoviť nákup"
        override val agencySettingsProBody: String = "Solo agentúra je aktívna predvolene. Pro umožňuje vytvoriť alebo vybrať zdieľanú agentúru."
        override val agencySettingsLockedBody: String = "Solo agentúra je aktívna. Zmeny agentúry odomkne Pro."
        override val soloAgency: String = "Solo agentúra"
        override val defaultPrivateAgencyWorkspace: String = "Predvolená súkromná agentúra"
        override val noAgenciesAvailableYet: String = "Zatiaľ nie sú dostupné žiadne pozvánky ani vlastnené agentúry."
        override val oneOwnedAgencyHint: String = "Vaša agentúra je uvedená vyššie. Jeden agent môže vlastniť jednu agentúru."
        override val createAgency: String = "Vytvoriť agentúru"
        override val createYourAgency: String = "Vytvorte svoju agentúru"
        override val createAgencyBody: String = "Budujte tím, spravujte nehnuteľnosti spolu a rozvíjajte svoje podnikanie."
        override val agencyName: String = "Názov agentúry"
        override val agencyEmail: String = "E-mail agentúry"
        override val logoOptional: String = "Logo (voliteľné)"
        override val upgradeExperienceTitle: String = "Vylepšite svoj zážitok"
        override val upgradeExperienceSubtitle: String = "Prvú obhliadku môžete spustiť zdarma. Pro odomkne viac ponúk, obhliadok a tímové nástroje."
        override val soloAgentPlan: String = "Solo agent"
        override val proAgentPlan: String = "Pro agent"
        override val teamAgentPlan: String = "Tím"
        override val soloBenefitActiveProperties: String = "Až 100 aktívnych nehnuteľností"
        override val soloBenefitAiFollowUps: String = "AI follow-upy (základné)"
        override val soloBenefitSellerReports: String = "Bez reportov pre predávajúcich"
        override val soloBenefitPersonalOnly: String = "Iba osobný účet"
        override val proBenefitUnlimitedProperties: String = "Až 10 000 nehnuteľností"
        override val proBenefitUnlimitedAi: String = "10 000 AI textových požiadaviek / mesiac"
        override val proBenefitAdvancedReports: String = "Pokročilé reporty pre predávajúcich"
        override val proBenefitAgencyCreation: String = "Vytvorenie a správa agentúry"
        override val proBenefitInviteAgents: String = "Pozývanie agentov a spolupráca"
        override val proBenefitSharedLeads: String = "Zdieľané leady a tímové workflow"
        override val proBenefitAgencyBranding: String = "Branding agentúry"
        override val proBenefitAdvancedAnalytics: String = "Pokročilá analytika"
        override val teamBenefitLargeLimits: String = "Limity pre tímy"
        override val teamBenefitPrioritySupport: String = "Prioritná e-mailová podpora"
        override val teamBenefitDailyBackups: String = "Denné zálohy na 7 dní"
        override val teamBenefitLargeStorage: String = "10 GB úložisko dokumentov"
        override val startFreeTrial7Day: String = "Predplatiť teraz"
        override val restorePurchases: String = "Obnoviť nákup"
        override val comparePlans: String = "Porovnať plány"
        override val startFreeTrial: String = "Vybrať plán"
        override val noCommitmentCancelAnytime: String = "Prvú obhliadku môžete spustiť zdarma. Pro použite, keď potrebujete viac."
        override val monthly: String = "Mesačne"
        override val yearly: String = "Ročne"
        override val yearlySave20: String = "Ročne"
        override val yearlySavings20: String = "Fakturované ročne."
        override val perYear: String = "/ rok"
        override val loadingPlans: String = "Načítavam plány..."
        override val selectedPlanUnavailable: String = "Tento plán zatiaľ nie je dostupný. Skúste to znova neskôr alebo kontaktujte podporu."
        override val signInRequiredForPurchase: String = "Pred nákupom sa prihláste."
        override val subscriptionDisclosureIos: String = "Automaticky obnovované predplatné. Platba bude účtovaná na váš Apple účet pri potvrdení nákupu. Predplatné sa automaticky obnoví, pokiaľ ho nezrušíte najneskôr 24 hodín pred koncom aktuálneho obdobia. Obnovenie bude účtované počas 24 hodín pred koncom aktuálneho obdobia. Predplatné môžete spravovať alebo zrušiť v nastaveniach účtu v App Store."
        override val subscriptionDisclosureAndroid: String = "Automaticky obnovované predplatné cez Google Play. Poplatok vám bude účtovaný v každom fakturačnom období, pokiaľ predplatné nezrušíte. Predplatné môžete kedykoľvek spravovať alebo zrušiť v predplatných Google Play. Prístup pokračuje do konca zaplateného obdobia."
        override val subscriptionDisclosureWeb: String = "Automaticky obnovované predplatné. Poplatok vám bude účtovaný v každom fakturačnom období zvoleným spôsobom platby, pokiaľ predplatné nezrušíte. Predplatné môžete kedykoľvek spravovať alebo zrušiť v nastaveniach fakturácie. Prístup pokračuje do konca zaplateného obdobia. Môžu sa účtovať dane."
        override val subscriptionAgreementPrefix: String = "Predplatením súhlasíte s"
        override val subscriptionTermsOfUse: String = "Podmienkami používania HAVN"
        override val subscriptionAgreementAnd: String = "a"
        override val subscriptionPrivacyPolicy: String = "Zásadami ochrany súkromia."
        override val purchaseSuccessTitle: String = "Ďakujeme za nákup"
        override val purchaseSuccessBody: String = "Vaše predplatné HAVN je aktívne a plán je pripravený."
        override val restoreSuccessTitle: String = "Obnoviť nákup"
        override val restoreSuccessBody: String = "Vaše predplatné HAVN bolo úspešne obnovené."
        override val purchaseCouldNotComplete: String = "Nákup sa nepodarilo dokončiť. Skúste to znova alebo skontrolujte účet v App Store alebo Google Play."
        override val purchaseVerificationPending: String = "Your payment has not been confirmed yet. If you completed checkout, use Restore purchase to check again. You do not need to pay again."
        override val completeWebCheckout: String = "Complete payment in the checkout tab, then return here. Your access will update automatically once payment is confirmed."
        override val restoreCouldNotComplete: String = "Pre tento účet obchodu sa nenašlo aktívne predplatné HAVN."
        override val noActiveSubscriptionFound: String = "Pre tento účet obchodu sa nenašlo aktívne predplatné HAVN."
        override val compareActiveProperties: String = "Aktívne nehnuteľnosti"
        override val compareAiFollowUps: String = "AI pripomienky"
        override val compareSellerReports: String = "Reporty pre predávajúcich"
        override val compareAdvancedAnalytics: String = "Pokročilá analytika"
        override val compareAgencyCreation: String = "Vytvorenie agentúry"
        override val compareJoinAgencies: String = "Pripojenie k agentúram"
        override val compareInviteAgents: String = "Pozývanie agentov"
        override val compareSharedLeads: String = "Zdieľané leady"
        override val compareAgencyBranding: String = "Branding agentúry"
        override val comparePrioritySupport: String = "Prioritná podpora"
        override val compareFeature: String = "Funkcia"
        override val compareFreePlan: String = "Zadarmo"
        override val compareValueYes: String = "Áno"
        override val compareValueNo: String = "Nie"
        override val comparePricePerMonthUser: String = "Cena / mesiac / používateľ"
        override val comparePricePerYearUser: String = "Cena / rok / používateľ"
        override val compareMaxPropertiesOwner: String = "Max. nehnuteľností / vlastník"
        override val compareMaxContactsOwner: String = "Max. kontaktov / vlastník"
        override val compareMaxOpenHousesOwner: String = "Max. obhliadok / vlastník"
        override val compareMaxLeadsOwner: String = "Max. leadov / vlastník"
        override val compareMaxPhotosProperty: String = "Max. fotiek na nehnuteľnosť"
        override val compareMaxDocumentsProperty: String = "Max. dokumentov na nehnuteľnosť"
        override val compareDocumentsStorage: String = "Úložisko dokumentov"
        override val compareAgencyAgenda: String = "Agenda agentúry"
        override val compareAiTextRequestsMonth: String = "AI textové požiadavky / mesiac"
        override val compareAnalytics: String = "Analytika"
        override val compareTasks: String = "Úlohy"
        override val compareDocumentsStorageOwner: String = "Úložisko dokumentov / vlastník"
        override val compareMaxFileSizeOwner: String = "Max. veľkosť súboru / vlastník"
        override val compareEmailSupport: String = "E-mailová podpora"
        override val compareDailyBackups7Days: String = "Denné zálohy uložené na 7 dní"
        override val compareKioskMode: String = "Kiosk režim"
        override val unlimited: String = "Neobmedzené"
        override val basic: String = "Základné"
        override val advanced: String = "Pokročilé"
        override val perMonth: String = "/ mesiac"
        override val members: String = "členov"
        override val upgradeToProForAgencyTools: String = "Vylepšite na Pro a používajte nástroje agentúry"
        override val languageTitle: String = "Jazyk"
        override val languageBody: String = "Vyberte jazyk aplikácie pre toto zariadenie."
        override val english: String = "Angličtina"
        override val slovak: String = "Slovenčina"
        override val unitsTitle: String = "Jednotky a mena"
        override val unitsBody: String = "Vyberte, ako sa v aplikácii zobrazujú ceny a rozmery nehnuteľnosti."
        override val measurementSystemTitle: String = "Meranie"
        override val metric: String = "Metrické"
        override val imperial: String = "Imperiálne"
        override val currencyTitle: String = "Mena"
        override val notificationsTitle: String = "Notifikácie"
        override val notificationsBody: String = "Nastavte push upozornenia, tichý režim a typy správ, ktoré môže HAVN posielať."
        override val notificationSettings: String = "Nastavenia notifikácií"
        override val notificationsSubtitle: String = "Iba dôležité upozornenia podľa vašich nastavení."
        override val quietHoursTitle: String = "Tichý režim"
        override val quietHoursBody: String = "HAVN počas tichého režimu preskočí menej dôležité upozornenia. Fakturácia a problémy s účtom ostanú stručné."
        override val enableQuietHours: String = "Zapnúť tichý režim"
        override val quietHoursStart: String = "Začiatok"
        override val quietHoursEnd: String = "Koniec"
        override val timezoneLabel: String = "Časové pásmo"
        override val notificationTypesTitle: String = "Typy notifikácií"
        override val notificationNewLeadCapturedTitle: String = "Zachytený nový lead"
        override val notificationNewLeadCapturedBody: String = "Keď obhliadka alebo QR proces zachytí lead."
        override val notificationHotLeadTitle: String = "Lead označený ako horúci"
        override val notificationHotLeadBody: String = "Iba keď sa z leadu stane vysoký záujem."
        override val notificationOpeningStartsSoonTitle: String = "Obhliadka čoskoro začína"
        override val notificationOpeningStartsSoonBody: String = "Jedno pripomenutie 30 minút pred začiatkom."
        override val notificationOpeningSummaryReadyTitle: String = "Súhrn obhliadky je pripravený"
        override val notificationOpeningSummaryReadyBody: String = "Keď je pripravený súhrn po obhliadke."
        override val notificationSellerReportGeneratedTitle: String = "Report pre predávajúceho vytvorený"
        override val notificationSellerReportGeneratedBody: String = "Keď bol vytvorený report pre predávajúceho."
        override val notificationAiFollowUpReadyTitle: String = "AI pripomienka pripravená"
        override val notificationAiFollowUpReadyBody: String = "Keď je návrh pripomienky pripravený na kontrolu."
        override val notificationAgentInvitedTitle: String = "Agent pozvaný do agentúry"
        override val notificationAgentInvitedBody: String = "Pozvánky do agentúry a zmeny členstva."
        override val notificationLeadAssignedTitle: String = "Lead priradený vám"
        override val notificationLeadAssignedBody: String = "Keď vám kolega priradí lead."
        override val notificationLeadTransferredTitle: String = "Lead presunutý na vás"
        override val notificationLeadTransferredBody: String = "Keď sa vlastníctvo leadu presunie na vás."
        override val notificationSubscriptionIssueTitle: String = "Problém s predplatným"
        override val notificationSubscriptionIssueBody: String = "Neúspešné obnovenie a problémy s platbou."
        override val kioskSecurityTitle: String = "Zabezpečenie kiosku"
        override val kioskSecurityBody: String = "Tento PIN slúži na opustenie kiosku a návrat do aplikácie agenta."
        override val kioskPinLabel: String = "PIN kiosku"
        override val mcpAccessTitle: String = "Prístup MCP"
        override val mcpAccessBody: String = "Prepojte HAVN s Claude, OpenAI a ďalšími MCP klientmi na mcp.havnre.app. Dostupné v každom pláne."
        override val mcpAuthorizationBearer: String = "Autorizácia: Bearer"
        override val mcpNoApiKeyCreated: String = "API kľúč ešte nebol vytvorený"
        override val mcpNotUsedYet: String = "Zatiaľ nepoužité"
        override val mcpLastUsedPrefix: String = "Naposledy použité"
        override val mcpRevealApiKeyTitle: String = "Zobraziť API kľúč"
        override val mcpRevealApiKeyBody: String = "Celý kľúč sa zobrazí iba po vytvorení alebo otočení."
        override val mcpCreateKey: String = "Vytvoriť kľúč"
        override val mcpRotateKey: String = "Otočiť kľúč"
        override val mcpRevokeKey: String = "Zrušiť kľúč"
        override val mcpEndpointHint: String = "Použite endpoint https://mcp.havnre.app/mcp s týmto kľúčom ako Bearer tokenom."
        override val mcpUpgradeHint: String = "MCP prístup je dostupný v každom pláne HAVN."
        override val mcpUpgradePrompt: String = "MCP prístup je dostupný v každom pláne HAVN."
        override val mcpCopied: String = "Skopírované"
        override val mcpCopy: String = "Kopírovať"
        override val mcpLoading: String = "Načítava sa"
        override val kioskFeaturedProperty: String = "Odporúčaná nehnuteľnosť"
        override val kioskPrivateShowing: String = "Súkromná obhliadka"
        override val kioskLuxuryListing: String = "Luxusná ponuka"
        override val kioskFastCheckIn: String = "Rýchle prihlásenie"
        override val kioskExitContentDescription: String = "Opustiť kiosk"
        override val kioskWelcome: String = "Vitajte"
        override val kioskGladHere: String = "Sme radi, že ste tu."
        override val kioskScanToCheckIn: String = "Naskenujte QR kód"
        override val kioskReceivePropertyDetails: String = "a získajte informácie o nehnuteľnosti"
        override val kioskOr: String = "Alebo"
        override val kioskStartCheckInManually: String = "Prihlásiť sa manuálne"
        override val kioskSecureInfo: String = "Vaše údaje sú v bezpečí a nebudú zdieľané."
        override val kioskExitTitle: String = "Opustiť kiosk"
        override val kioskExitBody: String = "Zadajte PIN kiosku pre návrat do aplikácie agenta."
        override val kioskIncorrectPin: String = "Nesprávny PIN."
        override val kioskUnlock: String = "Odomknúť"
        override val kioskTellUsTitle: String = "Povedzte nám o sebe"
        override val kioskTellUsBody: String = "Vaše údaje dostane iba agent, ktorý obhliadku organizuje."
        override val kioskFullName: String = "Meno a priezvisko"
        override val kioskContinue: String = "Pokračovať"
        override val kioskQuestionsTitle: String = "Pár krátkych otázok"
        override val kioskQuestionsBody: String = "Pomôže to agentovi nadviazať s vami správnym spôsobom."
        override val kioskWorkingWithAgentQuestion: String = "Spolupracujete už s agentom?"
        override val kioskYes: String = "Áno"
        override val kioskNo: String = "Nie"
        override val kioskInterestQuestion: String = "O čo máte záujem?"
        override val kioskInterestBuying: String = "Kúpa"
        override val kioskInterestInvesting: String = "Investícia"
        override val kioskInterestBrowsing: String = "Len sa pozerám"
        override val kioskInterestRelocating: String = "Sťahovanie"
        override val kioskFinish: String = "Dokončiť"
        override val kioskThankYou: String = "Ďakujeme"
        override val kioskEnjoyVisitPrefix: String = "Užite si návštevu nehnuteľnosti"
        override val kioskResetAutomatically: String = "Kiosk sa automaticky obnoví."
        override val environmentTitle: String = "Prostredie"
        override val environmentBody: String = "Pripojenie je nakonfigurované pre tento build."
        override val secure: String = "Zabezpečiť"
        override val brokerageProfileTitle: String = "Profil kancelárie"
        override val brokerageProfileBody: String = "Tu budú tímová značka, pozvánky agentov a notifikačné preferencie."
        override val logout: String = "Odhlásiť sa"
        override val languageChanged: String = "Jazyk bol zmenený"
        override val commonAdd: String = "Pridať"
        override val commonEdit: String = "Upraviť"
        override val commonDelete: String = "Zmazať"
        override val commonCancel: String = "Zrušiť"
        override val commonSave: String = "Uložiť"
        override val commonCreate: String = "Vytvoriť"
        override val commonDismiss: String = "Zavrieť"
        override val commonAll: String = "Všetko"
        override val commonDone: String = "Hotovo"
        override val commonSend: String = "Odoslať"
        override val commonTime: String = "Čas"
        override val commonHour: String = "Hodina"
        override val commonMinute: String = "Minúta"
        override val commonAgency: String = "Agentúra"
        override val commonSettings: String = "Nastavenia"
        override val commonOpening: String = "Obhliadka"
        override val commonPropertyName: String = "Nehnuteľnosť"
        override val commonToday: String = "Dnes"
        override val agencyToolsAvailable: String = "Nástroje agentúry sú dostupné."
        override val agencySetupSubtitle: String = "Každý účet HAVN má predvolenú agentúru. Pro umožňuje spravovať pozvánky, zdieľané leady a branding."
        override val agencyRecentActivity: String = "Nedávna aktivita"
        override val agencyActivityNewLead: String = "Pridaný nový lead"
        override val agencyActivityInvitationAccepted: String = "Pozvánka agenta prijatá"
        override val agencyActivityAgentJoined: String = "Agent sa pridal do agentúry"
        override val agencyActivitySellerReport: String = "Report pre predávajúceho vytvorený"
        override val agencyWorkspaceTitle: String = "Agentúra"
        override val agencyWorkspaceBody: String = "Vyberte agentúru, v ktorej práve pracujete."
        override val agencySoloActiveTitle: String = "Solo agency je aktívna"
        override val agencyProRequiredTitle: String = "Vyžaduje sa Pro plán"
        override val agencyCreateOrAcceptInviteBody: String = "Vytvorte pracovný priestor agentúry alebo prijmite pozvánku na spoluprácu s inou agentúrou."
        override val agencyProUnlockBody: String = "Zmeny agentúry, pozvánky, zdieľané leady a branding odomkne Pro."
        override val realEstate: String = "Realitná kancelária"
        override val proAgency: String = "Pro agentúra"
        override val agencyBrandingTitle: String = "Branding agentúry"
        override val agencyBrandingBody: String = "Nastavte názov a logo agentúry zobrazené v aplikácii, kiosku a zdieľanom priestore."
        override val uploadLogo: String = "Nahrať logo"
        override val saveAgency: String = "Uložiť agentúru"
        override val yourAgencyRole: String = "Vaša rola v agentúre"
        override val agencyAgentsTitle: String = "Agenti agentúry"
        override val agencyAgentsBody: String = "Ľudia oprávnení pracovať v tejto agentúre."
        override val inviteAgent: String = "Pozvať agenta"
        override val loadingAgents: String = "Načítavam agentov..."
        override val noAgencyAgentsYet: String = "Zatiaľ tu nie sú žiadni agenti agentúry."
        override val changeRole: String = "Zmeniť rolu"
        override val updating: String = "Aktualizujem..."
        override val deleting: String = "Mažem..."
        override val deleteInvite: String = "Zrušiť pozvánku"
        override val chooseAgencyRoleFor: String = "Vyberte rolu v agentúre pre"
        override val removeAccess: String = "Odobrať prístup"
        override val inviteAgentBody: String = "Pošlite pozvánku do agentúry e-mailom. Agent ju prijme po prihlásení rovnakým e-mailom."
        override val agentEmail: String = "E-mail agenta"
        override val role: String = "Rola"
        override val inviting: String = "Pozývam..."
        override val invite: String = "Pozvať"
        override val agents: String = "Agenti"
        override val ok: String = "Ok"
        override val personalActivePropertyLimit: String = "Limit osobných aktívnych nehnuteľností"
        override val personalAccountAgencyToolsLocked: String = "Osobný účet je aktívny. Nástroje agentúry odomkne Pro."
        override val selected: String = "Vybrané"
        override val activeMembers: String = "aktívnych členov"
        override val agencySharedWorkspaceBody: String = "Zdieľané nehnuteľnosti, kontakty, obhliadky, leady, pripomienky a reporty používajú tento pracovný priestor agentúry."
        override val actLikeAgent: String = "Pracovať ako agent"
        override val actAsAdmin: String = "Pracovať ako admin"
        override val actAsOwner: String = "Pracovať ako vlastník"
        override val actLikeAgentBody: String = "Používať agentúru ako bežný agent."
        override val actLikeAgentSelectedBody: String = "Zobrazuje sa iba priradená alebo vlastnená práca."
        override val agencyRoleOwner: String = "Vlastník"
        override val agencyRoleAdmin: String = "Admin"
        override val agencyRoleAgent: String = "Agent"
        override val agencyRoleAssistant: String = "Asistent"
        override val agencyRoleViewer: String = "Pozorovateľ"
        override val agencyRoleOwnerDescription: String = "Úplná správa agentúry vrátane členov, brandingu, priradení, ponúk, leadov a reportov."
        override val agencyRoleAdminDescription: String = "Úplná správa agentúry okrem vymazania agentúry."
        override val agencyRoleAgentDescription: String = "Pracuje s priradenými ponukami, obhliadkami, leadmi, pripomienkami, poznámkami a reportmi pre predávajúcich."
        override val agencyRoleAssistantDescription: String = "Pomáha s priradenými ponukami úpravou leadov, prípravou pripomienok a konceptov reportov."
        override val agencyRoleViewerDescription: String = "Prístup iba na čítanie k prehľadom a reportom."
        override val agencyCapabilityInviteRemoveMembers: String = "Pozývať a odoberať členov"
        override val agencyCapabilityChangeRoles: String = "Meniť roly členov"
        override val agencyCapabilityManageAllProperties: String = "Vytvárať, upravovať a vymazávať všetky nehnuteľnosti"
        override val agencyCapabilityAssignAgents: String = "Priraďovať agentov"
        override val agencyCapabilitySeeAllLeads: String = "Vidieť všetky leady"
        override val agencyCapabilityExportReports: String = "Exportovať reporty"
        override val agencyCapabilityChangeBranding: String = "Meniť branding a nastavenia agentúry"
        override val agencyCapabilityDeleteAgency: String = "Vymazať agentúru"
        override val agencyCapabilityViewAssignedProperties: String = "Zobraziť priradené nehnuteľnosti"
        override val agencyCapabilityHostAssignedOpenings: String = "Organizovať priradené obhliadky"
        override val agencyCapabilitySeeAssignedLeads: String = "Vidieť leady z priradených nehnuteľností a obhliadok"
        override val agencyCapabilityAddNotes: String = "Pridávať poznámky"
        override val agencyCapabilitySendFollowUps: String = "Posielať pripomienky"
        override val agencyCapabilityCreateSellerReports: String = "Vytvárať reporty pre predávajúcich k priradeným ponukám"
        override val agencyCapabilityEditAssignedLeads: String = "Upravovať priradené leady"
        override val agencyCapabilityPrepareFollowUps: String = "Pripravovať pripomienky"
        override val agencyCapabilityCreateDraftReports: String = "Vytvárať koncepty reportov"
        override val agencyCapabilityCannotDeleteProperties: String = "Nemôže vymazávať nehnuteľnosti"
        override val agencyCapabilityCannotInviteAgents: String = "Nemôže pozývať agentov, pokiaľ to nie je povolené"
        override val agencyCapabilityViewDashboards: String = "Zobraziť prehľady"
        override val agencyCapabilityViewReports: String = "Zobraziť reporty"
        override val agencyCapabilityCannotEdit: String = "Nemôže nič upravovať"
        override val commonVisitors: String = "Leady"
        override val commonHot: String = "Horúci"
        override val commonWarm: String = "Teplý"
        override val commonCold: String = "Studený"
        override val commonActive: String = "Aktívne"
        override val commonPlanned: String = "Plánované"
        override val commonArchived: String = "Archivované"
        override val commonPast: String = "Ukončené"
        override val commonFollowUps: String = "Pripomienky"
        override val commonProperty: String = "Nehnuteľnosť"
        override val commonAddress: String = "Adresa"
        override val commonOpenHouse: String = "Obhliadka"
        override val commonInquiry: String = "Dopyt"
        override val commonInquiries: String = "Dopyty"
        override val generalInquiry: String = "Všeobecný dopyt"
        override val generalInquiries: String = "Všeobecné dopyty"
        override val propertyInquiry: String = "Dopyt na nehnuteľnosť"
        override val propertyInquiries: String = "Dopyty na nehnuteľnosti"
        override val addGeneralInquiry: String = "Pridať všeobecný dopyt"
        override val newGeneralInquiry: String = "Nový všeobecný dopyt"
        override val noGeneralInquiries: String = "Zatiaľ žiadne všeobecné dopyty."
        override val noPropertyInquiries: String = "Zatiaľ žiadne dopyty na nehnuteľnosti."
        override val buyerLookingFor: String = "Čo tento kupujúci hľadá?"
        override val locationCity: String = "Lokalita / mesto"
        override val radiusKm: String = "Okruh (km)"
        override val propertyType: String = "Typ nehnuteľnosti"
        override val budgetFrom: String = "Rozpočet od"
        override val budgetTo: String = "Rozpočet do"
        override val purchaseTimeline: String = "Termín kúpy"
        override val createGeneralInquiry: String = "Vytvoriť všeobecný dopyt"
        override val saveGeneralInquiry: String = "Uložiť všeobecný dopyt"
        override val inquiryType: String = "Typ dopytu"
        override val leadSource: String = "Zdroj leadu"
        override val notSpecified: String = "Neuvedené"
        override val inquiryStatus: String = "Stav dopytu"
        override val inquiryFollowUp: String = "Pripomienka k dopytu"
        override val addInquiry: String = "Pridať dopyt"
        override val searchInquiries: String = "Hľadať dopyty"
        override val noInquiries: String = "Žiadne dopyty"
        override val noInquiriesBody: String = "Pomocou tlačidla plus pridajte záujem kupujúceho z existujúceho kontaktu."
        override val inquiryUnavailableTitle: String = "Dopyt nie je dostupný"
        override val inquiryUnavailableBody: String = "Tento dopyt mohol byť odstránený alebo sa ešte načítava."
        override val backToInquiries: String = "Späť na dopyty"
        override val deleteInquiry: String = "Odstrániť dopyt"
        override val deleteInquiryQuestionPrefix: String = "Odstrániť"
        override val deleteInquiryQuestionSuffix: String = "z tejto nehnuteľnosti?"
        override val deleteInquiryTargetFallback: String = "tento dopyt"
        override val propertyInquiriesBody: String = "Sledujte kupujúcich, ktorí sa pýtali na túto nehnuteľnosť. Dopyty sa zobrazujú aj v Leadoch."
        override val propertyInquiriesEmpty: String = "Pridajte dopyt výberom jedného z kontaktov."
        override val contactInquiriesBody: String = "Nehnuteľnosti, na ktoré sa tento kontakt pýtal."
        override val contactInquiriesEmpty: String = "Zatiaľ žiadne dopyty na nehnuteľnosti."
        override val viewInquiries: String = "Zobraziť dopyty"
        override val createContactFirstForInquiry: String = "Najprv vytvorte kontakt a potom pridajte dopyt z tejto nehnuteľnosti."
        override val commonCheckedIn: String = "Príchod"
        override val commonNotScheduled: String = "nenaplánované"
        override val todayTitle: String = "Dnes"
        override val todaySubtitle: String = "Denný priestor pre obhliadky, leady, pripomienky a podklady pre predávajúceho."
        override val todayOpenHousesMetric: String = "obhliadky"
        override val capturedMetric: String = "zachytené"
        override val priorityMetric: String = "priorita"
        override val noActivePropertiesTitle: String = "Žiadne aktívne nehnuteľnosti"
        override val noActivePropertiesBody: String = "Pridajte alebo aktivujte nehnuteľnosť, aby sa zobrazila na obrazovke Dnes."
        override val checkIns: String = "Príchody"
        override val allOpenHouses: String = "všetky obhliadky"
        override val pendingDrafts: String = "čakajúce koncepty"
        override val priorityLead: String = "Prioritný kontakt"
        override val nextOpenHouseAt: String = "Najbližšie obhliadky"
        override val noOpenHouseScheduled: String = "Žiadna obhliadka nie je naplánované"
        override val personalAccount: String = "Osobný účet"
        override val accountReady: String = "Váš účet je pripravený"
        override val realEstateApp: String = "Realitná aplikácia"
        override val needHelp: String = "Potrebujete pomoc?"
        override val contactSupport: String = "Kontaktovať podporu"
        override val upgradePlan: String = "Vylepšiť plán"
        override val planSuffix: String = "Plán"
        override val todayActionsTitle: String = "Dnešné priority"
        override val agencyInvitation: String = "Pozvánka do agentúry"
        override val joinAgency: String = "Pripojiť sa k"
        override val youWereInvitedAs: String = "Boli ste pozvaný ako"
        override val invitedBy: String = "od"
        override val decline: String = "Odmietnuť"
        override val yourDefaultAgency: String = "Vaša predvolená agentúra"
        override val chooseAgencyBody: String = "Vyberte agentúru, s ktorou chcete pracovať. Nástroje agentúry zahŕňajú pozvánky, zdieľané leady a branding."
        override val agencyMembersSuffix: String = "členov"
        override val quickActionTasksBody: String = "Zoznam"
        override val quickActionReportsBody: String = "Predávajúci"
        override val quickActionAnalyticsBody: String = "Trendy"
        override val quickActionAddPropertyTitle: String = "Pridať"
        override val quickActionAddPropertyBody: String = "Ponuka"
        override val quickActionAddContactTitle: String = "Kontakt"
        override val quickActionAddContactBody: String = "Nový"
        override val quickActionFilesTitle: String = "Súbory"
        override val quickActionFilesBody: String = "Dok."
        override val firstRunStepsTitle: String = "Začnite štyrmi jednoduchými krokmi"
        override val firstRunAddProperty: String = "Pridať nehnuteľnosť"
        override val firstRunScheduleOpening: String = "Naplánovať obhliadku"
        override val firstRunStartGuestCheckIn: String = "Spustiť prihlásenie hostí"
        override val firstRunSendFollowUp: String = "Odoslať follow-up"
        override val greetingNamePrefix: String = "Ahoj,"
        override val greetingAgent: String = "Ahoj, agent"
        override val createListing: String = "Vytvoriť ponuku"
        override val newOwnerBuyer: String = "Nový majiteľ/kupujúci"
        override val documents: String = "Dokumenty"
        override val whatOpeningNext: String = "Ktorá Obhliadka je najbližšie?"
        override val whoCheckedIn: String = "Kto sa prihlásil?"
        override val whoNeedsFollowUp: String = "Kto čaká na pripomienku?"
        override val whatShouldIDoNow: String = "Čo mám urobiť teraz?"
        override val noCheckInsYet: String = "Zatiaľ sa neprihlásil žiadny kontakt."
        override val noPendingFollowUps: String = "Momentálne nie sú žiadne čakajúce pripomienky."
        override val openKioskForNextOpening: String = "Otvorte kiosk pre najbližšiu obhliadku."
        override val reviewNewLeads: String = "Skontrolujte nové leady a pošlite pripomienky."
        override val createOpeningToStart: String = "Vytvorte obhliadku z nehnuteľnosti a začnite zbierať leady."
        override val addFirstPropertyToStart: String = "Začnite pridaním prvej nehnuteľnosti."
        override val nextOpening: String = "Najbližšia obhliadka"
        override val quickSignIn: String = "Rýchle prihlásenie"
        override val scanQrCode: String = "Skenovať QR kód"
        override val newLead: String = "Nový lead"
        override val myProperties: String = "Moje nehnuteľnosti"
        override val manageListings: String = "Spravovať ponuky"
        override val todaysOverview: String = "Dnešný prehľad"
        override val seeAll: String = "Zobraziť všetko"
        override val propertiesEyebrow: String = "Portfolio"
        override val propertiesSubtitle: String = "Spravujte aktívne, plánované a archivované ponuky s médiami, aktivitou kupujúcich a výkonom."
        override val propertiesLiveMetric: String = "live"
        override val propertiesPipelineMetric: String = "pipeline"
        override val propertiesAllTimeMetric: String = "celkovo"
        override val addProperty: String = "Pridať nehnuteľnosť"
        override val editProperty: String = "Upraviť nehnuteľnosť"
        override val propertyFallback: String = "Nehnuteľnosť"
        override val propertyUnavailableTitle: String = "Nehnuteľnosť nie je dostupná"
        override val propertyUnavailableBody: String = "Obnovte portfólio a načítajte túto ponuku znova."
        override val backToProperties: String = "Späť na nehnuteľnosti"
        override val deletePropertyTitle: String = "Zmazať nehnuteľnosť?"
        override val deletePropertyBody: String = "Týmto natrvalo zmažete nehnuteľnosť a jej súvisiace lokálne záznamy. Akciu nie je možné vrátiť späť."
        override val loadingProperties: String = "Načítavam nehnuteľnosti"
        override val loadMore: String = "Načítať ďalšie"
        override val loadingPropertyDetails: String = "Načítavam detaily nehnuteľnosti"
        override val noPropertiesTitle: String = "Zatiaľ žiadne nehnuteľnosti"
        override val noPropertiesBody: String = "Pridajte prvú nehnuteľnosť a vytvorte obhliadku, aby ste začali zbierať leady a spätnú väzbu pre predávajúceho."
        override val openHouseButton: String = "Obhliadka"
        override val photosTitle: String = "Fotky"
        override val photosBody: String = "Prvá fotka sa použije ako hlavný obrázok nehnuteľnosti v portfóliu."
        override val uploadPhoto: String = "Nahrať fotku"
        override val noPhotosYet: String = "Zatiaľ nie sú nahraté žiadne fotky."
        override val propertyPhotoCountPlanLimit: String = "Dosiahli ste limit fotiek pre túto nehnuteľnosť vo vašom aktuálnom pláne. Upgradujte plán a nahrajte ďalšie fotky."
        override val propertyPhotoStoragePlanLimit: String = "Dosiahli ste limit úložiska vo vašom aktuálnom pláne. Upgradujte plán a nahrajte ďalšie fotky alebo súbory."
        override val mainPhoto: String = "Hlavná"
        override val propertyTitleLabel: String = "Názov nehnuteľnosti"
        override val propertyAddressLine1Label: String = "Ulica a číslo"
        override val propertyAddressLine2Label: String = "Doplnenie adresy"
        override val propertyCityLabel: String = "Mesto"
        override val propertyRegionLabel: String = "Kraj"
        override val propertyPostalCodeLabel: String = "PSČ"
        override val propertyCountryLabel: String = "Krajina"
        override val propertyAskingPriceLabel: String = "Požadovaná cena"
        override val propertyBedsLabel: String = "Izby"
        override val propertyBathsLabel: String = "Kúpeľne"
        override val propertyInteriorLabel: String = "Interiér"
        override val propertyDescriptionLabel: String = "Popis"
        override val createPropertyButton: String = "+ Ponuka"
        override val locateProperty: String = "Lokalizovať nehnuteľnosť"
        override val findLocation: String = "Nájsť polohu"
        override val find: String = "Nájsť"
        override val navigate: String = "Navigovať"
        override val propertyLocationMarkerTitle: String = "Poloha nehnuteľnosti"
        override val mapKitJsMissingToken: String = "Mapa nie je nakonfigurovaná pre tento build."
        override val mapKitJsLoading: String = "Načítava sa MapKit JS..."
        override val generateSellerReport: String = "Vygenerovať report pre predávajúceho"
        override val deleteProperty: String = "Zmazať nehnuteľnosť"
        override val conversionMetric: String = "Konverzia"
        override val propertyPhotoContentDescription: String = "Fotka nehnuteľnosti"
        override val deletePhoto: String = "Zmazať fotku"
        override val movePhotoLeft: String = "Presunúť fotku doľava"
        override val movePhotoRight: String = "Presunúť fotku doprava"
        override val propertyTitleRequired: String = "Názov nehnuteľnosti je povinný."
        override val propertyStreetRequired: String = "Ulica a číslo sú povinné."
        override val propertyCityRequired: String = "Mesto je povinné."
        override val propertyRegionRequired: String = "Kraj je povinný."
        override val propertyPostalRequired: String = "PSČ je povinné."
        override val propertyAskingPriceInvalid: String = "Zadajte platnú požadovanú cenu."
        override val propertyOwnerContactTitle: String = "Kontakt na majiteľa nehnuteľnosti"
        override val propertyOwnerSelectContact: String = "Vyberte existujúci kontakt ako majiteľa nehnuteľnosti."
        override val propertyOwnerSelected: String = "Vybraný majiteľ"
        override val propertyOwnerNoContacts: String = "Zatiaľ nemáte žiadne kontakty. Pridajte majiteľa v Kontaktoch a potom ho tu vyberte."
        override val propertyOwnerChooseContact: String = "Vybrať kontakt"
        override val propertyOwnerChangeContact: String = "Zmeniť kontakt"
        override val propertyOwnerRemoveContact: String = "Odstrániť"
        override val propertyOwnerPickerTitle: String = "Vyberte majiteľa nehnuteľnosti"
        override val propertyOwnerSearchContact: String = "Hľadať kontakty"
        override val propertyOwnerSearchHint: String = "Začnite písať meno, e-mail alebo telefón."
        override val propertyOwnerNoMatches: String = "Nenašli sa žiadne kontakty."
        override val propertyOpeningsTitle: String = "Obhliadky"
        override val propertyNoOpenings: String = "Pre túto nehnuteľnosť nie sú naplánované žiadne obhliadky."
        override val teamAccessTitle: String = "Prístup tímu"
        override val onlyListingOwner: String = "Iba vlastník ponuky"
        override val assignTeam: String = "Priradiť tím"
        override val assignPropertyTitle: String = "Priradiť nehnuteľnosť"
        override val assignPropertyBody: String = "Vyberte, kto môže pracovať s touto nehnuteľnosťou. Vyberte celý tím alebo konkrétnych agentov."
        override val wholeTeam: String = "Celý tím"
        override val leadsEyebrow: String = "Leady"
        override val leadFallback: String = "Kontakt"
        override val leadsSubtitle: String = "Vyhľadávajte, filtrujte a kvalifikujte leady zo všetkých obhliadok."
        override val leadDetailSubtitle: String = "Zdroj, kvalifikácia, poznámky a história pripomienok pre tento lead z obhliadky."
        override val totalMetric: String = "Spolu"
        override val loggedMetric: String = "zapísané"
        override val searchLeads: String = "Hľadať leady"
        override val searchLeadsPlaceholder: String = "Meno, telefón alebo e-mail"
        override val allProperties: String = "Všetky nehnuteľnosti"
        override val loadingLeads: String = "Načítavam leady z obhliadok"
        override val loadingLeadDetails: String = "Načítavam detail leadu"
        override val noLeadsFoundTitle: String = "Leady sa zobrazia tu, keď sa kontakty prihlásia na obhliadku."
        override val noLeadsEmptyBody: String = "Použite kiosk alebo pridajte kontakty ručne z obhliadky."
        override val noLeadsFilteredBody: String = "Skúste inú nehnuteľnosť, stav alebo hľadaný výraz."
        override val backToLeads: String = "Späť na leady"
        override val leadUnavailableTitle: String = "Lead nie je dostupný"
        override val leadUnavailableBody: String = "Tento lead už nie je dostupný v aktuálnom zozname leadov."
        override val leadTemperature: String = "Stav leadu"
        override val leadLabelSuffix: String = "Lead"
        override val greetingHi: String = "Dobrý deň"
        override val leadActionCall: String = "Zavolať"
        override val leadActionSms: String = "SMS"
        override val leadActionEmail: String = "E-mail"
        override val leadFollowUp: String = "Pripomienka"
        override val leadNoFollowUpScheduled: String = "Pripomienka nie je naplánovaná"
        override val leadIntentScore: String = "Skóre záujmu"
        override val leadInterestedIn: String = "Záujem o"
        override val leadGenericGreetingName: String = "vás"
        override val followUpMessageTypeThankYou: String = "Poďakovanie"
        override val followUpMessageTypePropertyInfo: String = "Info o nehnuteľnosti"
        override val followUpMessageTypeFollowUp: String = "Pripomienka"
        override val followUpMessageTypeCheckIn: String = "Overenie záujmu"
        override val followUpMessageTypePriceUpdate: String = "Zmena ceny"
        override val followUpMessageTypePropertyBrochure: String = "Files"
        override val followUpPreview: String = "Náhľad"
        override val followUpSubject: String = "Predmet"
        override val followUpMessage: String = "Správa"
        override val followUpSendViaEmail: String = "Odoslať e-mailom"
        override val followUpSendViaSms: String = "Odoslať SMS"
        override val followUpAiAssistantTitle: String = "AI asistent"
        override val followUpAiAssistantBody: String = "Vygenerujte osobnú správu za pár sekúnd."
        override val followUpGenerateWithAi: String = "Vygenerovať s AI"
        override val followUpUpgradeForAi: String = "Odomknúť AI"
        override val followUpDefaultSubject: String = "Pripomienka k nehnuteľnosti"
        override val privateAgentNotes: String = "Súkromné poznámky agenta"
        override val notes: String = "Poznámky"
        override val notesPlaceholder: String = "Motivácia, preferencie, námietky, ďalší krok"
        override val saveNotes: String = "Uložiť poznámky"
        override val followUpHistory: String = "História pripomienok"
        override val noFollowUpsLogged: String = "Zatiaľ nie sú zapísané žiadne pripomienky."
        override val openHousesEyebrow: String = "Obhliadky"
        override val scheduleOpenHouse: String = "Vytvoriť obhliadku"
        override val openingDetails: String = "Detail obhliadky"
        override val editOpening: String = "Upraviť obhliadku"
        override val deleteOpening: String = "Vymazať obhliadku"
        override val deleteOpeningBody: String = "Naozaj chcete vymazať túto obhliadku? Táto akcia sa nedá vrátiť späť."
        override val removeLeadTitle: String = "Odstrániť lead?"
        override val removeLeadBody: String = "Odstrániť %s z tejto obhliadky?"
        override val removeLeadFallback: String = "tento lead"
        override val openingName: String = "Názov obhliadky"
        override val startsAt: String = "Začína"
        override val endsAt: String = "Končí"
        override val chooseStartDateTime: String = "Vyberte dátum a čas začiatku"
        override val chooseEndDateTime: String = "Vyberte dátum a čas konca"
        override val accessNotes: String = "Poznámky k prístupu"
        override val privateNotes: String = "Súkromné poznámky"
        override val addPrivateNote: String = "Pridať súkromnú poznámku"
        override val liveDashboard: String = "Live prehľad"
        override val visitorKiosk: String = "Kiosk leadov"
        override val openHousesSubtitle: String = "Vytvárajte obhliadky k nehnuteľnostiam, sledujte leady a spúšťajte kiosk."
        override val liveMetric: String = "Live"
        override val upcomingMetric: String = "Najbližšie"
        override val inProgressMetric: String = "prebieha"
        override val scheduledMetric: String = "naplánované"
        override val loadingOpenHouses: String = "Načítavam obhliadky"
        override val addPropertyFirstTitle: String = "Najprv pridajte nehnuteľnosť"
        override val addPropertyFirstBody: String = "Vytvorte obhliadku z nehnuteľnosti a začnite zbierať leady."
        override val noOpenHousesTitle: String = "Žiadne naplánované obhliadky"
        override val noOpenHousesBody: String = "Vytvorte obhliadku z nehnuteľnosti a začnite zbierať leady."
        override val noSignInsTitle: String = "Žiadne príchody"
        override val noSignInsBody: String = "Leady prihlásené cez kiosk sa tu zobrazia v reálnom čase."
        override val dashboard: String = "Prehľad"
        override val start: String = "Spustiť"
        override val end: String = "Ukončiť"
        override val endOpenHouse: String = "Ukončiť obhliadku"
        override val reportsEyebrow: String = "Predávajúci"
        override val sellerReportsTitle: String = "Reporty"
        override val createReport: String = "Report"
        override val reportPreview: String = "Report pre predávajúceho"
        override val reportsSubtitle: String = "Vytvárajte prémiové zhrnutia po obhliadkach s kvalitou leadov, záujmom kupujúcich a textom pripraveným pre predávajúceho."
        override val reportsMetricSaved: String = "uložené"
        override val reportedMetric: String = "reportované"
        override val leadsMetric: String = "kontakty"
        override val createSellerReport: String = "Report"
        override val attendance: String = "Účasť"
        override val savedReports: String = "uložené reporty"
        override val buyerHeat: String = "Záujem kupujúcich"
        override val hotLeads: String = "horúce kontakty"
        override val loadingSellerReports: String = "Načítavam reporty pre predávajúceho"
        override val noSellerReportsTitle: String = "Zatiaľ žiadne reporty"
        override val noSellerReportsBody: String = "Vyberte obhliadku, pridajte poznámky agenta, zobrazte náhľad a uložte report."
        override val chooseOpenHouse: String = "Vyberte obhliadku"
        override val noOpenHousesAvailable: String = "Zatiaľ nie sú dostupné žiadne obhliadky."
        override val agentNotes: String = "Poznámky agenta"
        override val notesForSeller: String = "Poznámky pre predávajúceho"
        override val sellerNotesPlaceholder: String = "Námietky kupujúcich, cenové signály, spätná väzba, odporúčaný ďalší krok"
        override val generatePreview: String = "Vygenerovať náhľad"
        override val noPreviewReadyTitle: String = "Náhľad nie je pripravený"
        override val noPreviewReadyBody: String = "Pred uložením najprv vygenerujte náhľad reportu."
        override val saveReport: String = "Uložiť"
        override val reportSaved: String = "Report uložený"
        override val sellerOpenHouseReport: String = "Report z obhliadky pre predávajúceho"
        override val mostCommonBuyerInterest: String = "Najčastejší záujem kupujúcich"
        override val followUpsSent: String = "Odoslané pripomienky"
        override val summary: String = "Súhrn"
        override val noPrivateNotesAdded: String = "Neboli pridané žiadne súkromné poznámky."
        override val openHouseReport: String = "Report z obhliadky"
        override val commonDraft: String = "Koncept"
        override val commonAccepted: String = "Schválené"
        override val searchSellerReports: String = "Hľadať reporty pre predávajúcich"
        override val noMatchingReports: String = "Nenašli sa žiadne reporty"
        override val clearFilters: String = "Vymazať filtre"
        override val tryDifferentSearchOrStatusFilter: String = "Skúste iné vyhľadávanie alebo filter stavu."
        override val connectedToProperty: String = "Priradené k nehnuteľnosti"
        override val viewProperty: String = "Zobraziť nehnuteľnosť"
        override val dataRollup: String = "Súhrn dát"
        override val connectedOpenings: String = "Priradené obhliadky"
        override val visitors: String = "Návštevníci"
        override val interestedBuyers: String = "Záujemcovia"
        override val completedFollowUps: String = "Dokončené follow-upy"
        override val reportHistory: String = "História reportov"
        override val noPreviousReportsYet: String = "Zatiaľ žiadne predchádzajúce reporty."
        override val viewAllReports: String = "Zobraziť všetky reporty"
        override val actions: String = "Akcie"
        override val generatePdf: String = "Vygenerovať Spreadsheet"
        override val previewPdf: String = "Náhľad Spreadsheet"
        override val pdfSavedToPropertyFiles: String = "%s bolo uložené do súborov nehnuteľnosti."
        override val pdfSavingToPropertyFiles: String = "%s sa ukladá do súborov nehnuteľnosti."
        override val pdfSavedToFiles: String = "%s bolo uložené do súborov."
        override val pdfSavingToFiles: String = "%s sa ukladá do súborov."
        override val pdfIncludesSellerReport: String = "Spreadsheet obsahuje metriky reportu pre predávajúceho, AI poznatky, údaje agenta, údaje nehnuteľnosti a históriu obhliadok."
        override val pdfIncludesAnalytics: String = "Spreadsheet obsahuje analytické metriky, najvýkonnejšie nehnuteľnosti, výkon agentov, follow-up kanály a AI poznatky."
        override val pdfGenerateBeforeSending: String = "Pred odoslaním najprv vygenerujte Spreadsheet."
        override val pdfUploadBeforeSharing: String = "Spreadsheet sa musí pred zdieľaním dokončiť nahrávať."
        override val sellerReportPdfNeedsProperty: String = "Tabuľka reportu pre predávajúceho vyžaduje pred nahraním priradenú nehnuteľnosť."
        override val deleteReport: String = "Vymazať report"
        override val deleteReportBody: String = "Naozaj chcete vymazať tento report pre predávajúceho? Táto akcia sa nedá vrátiť späť."
        override val shareReport: String = "Zdieľať report"
        override val openingPropertyReportLoading: String = "Otváram report nehnuteľnosti..."
        override val openingPropertyReportCreating: String = "Vytváram report nehnuteľnosti..."
        override val sellerReportGeneratedPrefix: String = "Seller Report vygenerovaný"
        override val sellerReportGeneratedSuffix: String = "z obhliadok, návštevníkov, leadov, pripomienok a spätnej väzby priradenej k tejto nehnuteľnosti v čase reportu."
        override val priceNotSet: String = "Cena nie je zadaná"
        override val daysSuffix: String = "dní"
        override val connectedOpeningSingular: String = "priradená obhliadka"
        override val connectedOpeningPlural: String = "priradené obhliadky"
        override val connectedLeadSingular: String = "priradený lead"
        override val connectedLeadPlural: String = "priradené leady"
        override val sellerConfidence: String = "Dôvera predávajúceho"
        override val sellerConfidenceExplanation: String = "Vysvetlenie dôvery"
        override val aiDraftReviewBeforeSending: String = "Iba AI návrh. Pred odoslaním predávajúcemu ho skontrolujte a upravte."
        override val executiveSummary: String = "Výkonný súhrn"
        override val buyerInterestOverview: String = "Prehľad záujmu kupujúcich"
        override val whatBuyersLoved: String = "Čo kupujúcich zaujalo"
        override val buyerConcerns: String = "Obavy kupujúcich"
        override val leadQualitySummary: String = "Súhrn kvality leadov"
        override val agentActivity: String = "Aktivita agenta"
        override val aiRecommendations: String = "AI odporúčania"
        override val recommendations: String = "Odporúčania"
        override val marketPositionComparison: String = "Porovnanie trhovej pozície"
        override val nextSteps: String = "Ďalšie kroky"
        override val conversion: String = "Konverzia"
        override val interested: String = "záujem"
        override val tourSignalsLowercase: String = "signály obhliadok"
        override val propertyTimeline: String = "Časová os nehnuteľnosti"
        override val timelineBasisNote: String = "Časová os vychádza iba z priradených registrácií na obhliadky a pripomienok."
        override val visitorsLowercase: String = "návštevníci"
        override val hotLeadsLowercase: String = "horúce leady"
        override val hotLowercase: String = "horúce"
        override val sentiment: String = "Sentiment"
        override val toursLowercase: String = "obhliadky"
        override val interestedLowercase: String = "záujem"
        override val noRepeatedFeedbackMentions: String = "Zatiaľ neboli zaznamenané opakované zmienky v spätnej väzbe."
        override val scoresMentionRates: String = "Skóre predstavuje podiel zmienok v uloženej spätnej väzbe kupujúcich."
        override val aiExecutiveBriefing: String = "AI manažérsky briefing"
        override val viewAllAiInsights: String = "Zobraziť všetky AI poznatky ->"
        override val followUpsSentTitle: String = "Odoslané follow-upy"
        override val financingPacketsShared: String = "Zdieľané finančné podklady"
        override val buyerCalls: String = "Telefonáty s kupujúcimi"
        override val propertyDataEvidence: String = "Dátové podklady nehnuteľnosti"
        override val attendanceCoverage: String = "Pokrytie návštevnosti"
        override val leadQuality: String = "Kvalita leadov"
        override val followUpExecution: String = "Realizácia follow-upov"
        override val activityChannels: String = "Kanály aktivity"
        override val callsLowercase: String = "hovory"
        override val emailsLowercase: String = "e-maily"
        override val offerReadinessScore: String = "Skóre pripravenosti na ponuku"
        override val date: String = "Dátum"
        override val propertyLeadFunnel: String = "Funnel nehnuteľnosti"
        override val openHouseBreakdown: String = "Prehľad obhliadok"
        override val aiInsights: String = "AI poznatky"
        override val generateAiInsights: String = "Vygenerovať AI poznatky"
        override val analyticsOverview: String = "Prehľad analytiky"
        override val allAgents: String = "Všetci agenti"
        override val me: String = "Ja"
        override val allActivity: String = "Všetka aktivita"
        override val latest30Days: String = "Posledných 30 dní"
        override val latest7Days: String = "Posledných 7 dní"
        override val analyticsDatePreset: String = "Obdobie"
        override val analyticsCustomDate: String = "Vlastný dátum"
        override val analyticsLastDay: String = "Posledný deň"
        override val analyticsLastWeek: String = "Posledný týždeň"
        override val analyticsLastMonth: String = "Posledný mesiac"
        override val analyticsLastYear: String = "Posledný rok"
        override val analyticsAllTime: String = "Celé obdobie"
        override val analyticsDateFrom: String = "Dátum od"
        override val analyticsDateTo: String = "Dátum do"
        override val analyticsOpenHousesLowercase: String = "obhliadky"
        override val analyticsWarmLeadsLowercase: String = "teplé leady"
        override val analyticsFromNotesFollowUps: String = ""
        override val analyticsFromText: String = "z textu"
        override val analyticsHotConversion: String = "Konverzia horúcich leadov"
        override val analyticsHotLeadsPerVisitors: String = "horúce leady / návštevníci"
        override val analyticsAverageIntent: String = "Priem. zámer"
        override val analyticsVisitorIntentScore: String = "skóre zámeru návštevníkov"
        override val analyticsSelectDate: String = "Vyberte dátum"
        override val propertyFunnel: String = "Funnel nehnuteľnosti"
        override val propertyFunnelSubtitle: String = "Od aktivity nehnuteľností ku kvalifikovanému záujmu kupujúcich"
        override val properties: String = "Nehnuteľnosti"
        override val tourSignals: String = "Signály obhliadok"
        override val offerSignals: String = "Signály ponúk"
        override val viewFullFunnelReport: String = "Zobraziť celý funnel"
        override val performanceOverTime: String = "Výkon v čase"
        override val thirtyDays: String = "30 dní"
        override val topPerformingProperties: String = "Najvýkonnejšie nehnuteľnosti"
        override val viewAll: String = "Zobraziť všetko"
        override val noPropertyAnalyticsYet: String = "Zatiaľ nie sú dostupné analytiky nehnuteľností."
        override val leadQualityBreakdown: String = "Rozdelenie kvality leadov"
        override val warmLeadsTitle: String = "Teplé leady"
        override val coldLeadsTitle: String = "Studené leady"
        override val followUpPerformance: String = "Výkon follow-upov"
        override val agentPerformance: String = "Výkon agentov"
        override val viewTeamReport: String = "Zobraziť tímový report"
        override val followUpChannels: String = "Follow-up kanály"
        override val viewReport: String = "Zobraziť report"
        override val searchProperties: String = "Hľadať nehnuteľnosti"
        override val searchOpenings: String = "Hľadať obhliadky"
        override val noOpeningsFoundTitle: String = "Nenašli sa žiadne obhliadky"
        override val noOpeningsFoundBody: String = "Skúste iné vyhľadávanie alebo filter stavu obhliadky."
        override val noMatchingPropertiesTitle: String = "Žiadne zodpovedajúce nehnuteľnosti"
        override val noMatchingPropertiesBody: String = "Skúste iné vyhľadávanie alebo filter stavu."
        override val clientsTitle: String = "Kontakty"
        override val clientFallback: String = "Kontakt"
        override val addClient: String = "Pridať kontakt"
        override val editClient: String = "Upraviť kontakt"
        override val newClient: String = "Nový kontakt"
        override val saveClient: String = "Uložiť kontakt"
        override val createClient: String = "Vytvoriť kontakt"
        override val deleteClientTitle: String = "Zmazať kontakt?"
        override val deleteClientBody: String = "Týmto natrvalo zmažete kontakt. Akciu nie je možné vrátiť späť."
        override val firstName: String = "Meno"
        override val lastName: String = "Priezvisko"
        override val email: String = "Email"
        override val phone: String = "Telefón"
        override val comments: String = "Komentáre"
        override val addPhoto: String = "Pridať fotku"
        override val sendQr: String = "Odoslať QR"
        override val sendQrShareTitle: String = "Váš HAVN QR kód na obhliadku"
        override val sendQrShareBody: String = "V prílohe je váš HAVN QR kód na obhliadku. Keď bude dostupný Wallet pass (.pkpass), pridajte si ho do telefónu, alebo pri obhliadke ukážte QR obrázok."
        override val sendQrReadyMessage: String = "QR je pripravené"
        override val sendQrUnavailableError: String = "Pre tento kontakt nie je dostupná žiadna e-mailová ani SMS aplikácia."
        override val clientQrDeliveryRequired: String = "Pre doručenie QR pridajte e-mail alebo telefónne číslo."
        override val photo: String = "Fotka"
        override val clientDetailSubtitle: String = "QR identita, kontaktné údaje, komentáre a obhliadky prepojené cez leady."
        override val clientFormEditSubtitle: String = "Upravte kontaktné údaje, doručenie a komentáre."
        override val clientFormNewSubtitle: String = "Zaregistrujte kupujúceho/kontakt a vytvorte opakovane použiteľnú QR identitu pre obhliadky."
        override val searchClients: String = "Hľadať kontakty"
        override val noClientsYetTitle: String = "Zatiaľ žiadne kontakty"
        override val noClientsYetBody: String = "Najprv zaregistrujte kontakty a potom im pred obhliadkou odošlite QR kód emailom alebo SMS."
        override val noClientsFoundTitle: String = "Nenašli sa žiadne kontakty"
        override val noClientsFoundBody: String = "Skúste iné meno, telefón alebo email."
        override val clientUnavailableTitle: String = "Kontakt nie je dostupný"
        override val clientUnavailableBody: String = "Obnovte zoznam kontaktov a otvorte tento záznam znova."
        override val noCommentsAdded: String = "Neboli pridané žiadne komentáre."
        override val openingsTitle: String = "Obhliadky"
        override val clientOpeningsEmpty: String = "Zatiaľ nie sú pripojené žiadne obhliadky. Leady prepájajú kontakt s obhliadkou."
        override val clientPassLabel: String = "Wallet pass"
        override val clientNoEmail: String = "Bez e-mailu"
        override val visitorsBody: String = "Otvorte kiosk, naskenujte QR kontakt alebo pridajte existujúce kontakty ako leady pre túto obhliadku."
        override val openKiosk: String = "Otvoriť kiosk"
        override val addQrClient: String = "QR kontakt"
        override val addManually: String = "Manuálne"
        override val selectClients: String = "Vybrať kontakty"
        override val selectClientsBody: String = "Vyberte kontakty zo zoznamu. Každý vybraný kontakt sa stane leadom pre túto obhliadku."
        override val kioskCheckIn: String = "Kiosk check-in"
        override val kioskCheckInBody: String = "Použite zadnú kameru na skenovanie HAVN Wallet QR kontaktu. Keď sa kód rozpozná, HAVN automaticky vytvorí lead pre túto obhliadku."
        override val scanWithCamera: String = "Skenovať zadnou kamerou"
        override val clientQrImage: String = "QR obrázok kontaktu"
        override val clientQrImageBody: String = "Držte QR kontaktu v zlatom štvorci. HAVN pridá každý sken do zoznamu nižšie."
        override val scanMultipleQrBody: String = "Naskenujte jeden alebo viac HAVN QR kódov kontaktov a potom klepnite na Pridať QR kontakt."
        override val scannedQrReady: String = "QR kontakt pripravený na pridanie"
        override val createLeadFromQr: String = "Vytvoriť lead z QR"
        override val noClientsFoundShort: String = "Nenašli sa žiadne kontakty."
        override val remove: String = "Odstrániť"
        override val tasksTitle: String = "Úlohy"
        override val addTask: String = "Pridať úlohu"
        override val searchTasks: String = "Hľadať úlohy"
        override val loadMoreTasks: String = "Načítať ďalšie úlohy"
        override val createTask: String = "Vytvoriť úlohu"
        override val saveTask: String = "Uložiť úlohu"
        override val editTask: String = "Upraviť úlohu"
        override val newTask: String = "Nová úloha"
        override val taskDetails: String = "Detaily úlohy"
        override val taskName: String = "Názov"
        override val taskDescription: String = "Popis"
        override val taskDueDateTime: String = "Dátum a čas úlohy"
        override val chooseTaskDateTime: String = "Vyberte dátum a čas úlohy"
        override val clearTaskDateTime: String = "Vymazať dátum a čas"
        override val assignToAgent: String = "Priradiť agentovi"
        override val noAgencyAgentsFound: String = "Nenašli sa žiadni agenti v agentúre. Úloha zostane priradená vlastníkovi."
        override val taskPriority: String = "Priorita úlohy"
        override val taskStatus: String = "Stav"
        override val taskVisibility: String = "Viditeľnosť"
        override val taskOwner: String = "Vlastník"
        override val taskOwnerFallback: String = "Vlastník úlohy"
        override val assignedTo: String = "Priradené"
        override val selectedAgent: String = "Vybraný agent"
        override val taskVisibilityBody: String = "Táto úloha je viditeľná vlastníkovi a priradenému agentovi."
        override val taskQueue: String = "Zoznam úloh"
        override val taskDetail: String = "Detail úlohy"
        override val taskDetailEmpty: String = "Vyberte úlohu a zobrazia sa kontext a ďalšie kroky."
        override val connectedContext: String = "Prepojený kontext"
        override val noTaskContext: String = "Zatiaľ nie je prepojená žiadna nehnuteľnosť, kontakt, obhliadka ani lead."
        override val activityTimeline: String = "Časová os aktivity"
        override val created: String = "Vytvorené"
        override val recently: String = "Nedávno"
        override val completed: String = "Dokončené"
        override val nextAction: String = "Ďalší krok"
        override val agentReviewOrCompletion: String = "Kontrola agentom alebo dokončenie"
        override val noDueDate: String = "Bez termínu"
        override val reopen: String = "Znovu otvoriť"
        override val accept: String = "Prijať"
        override val linkedTasks: String = "Prepojené úlohy"
        override val noLinkedTasks: String = "Zatiaľ žiadne prepojené úlohy."
        override val filesTitle: String = "Súbory"
        override val attachFile: String = "Priložiť súbor"
        override val noFilesAttached: String = "Zatiaľ nie sú priložené žiadne súbory."
        override val fileLimitHint: String = "Súbory môžu byť PDF, DOC, CAD alebo iné formáty do 20 MB každý."
        override val deleteFileTitle: String = "Odstrániť súbor?"
        override val deleteFileBody: String = "Tento súbor bude odstránený z úložiska HAVN."
        override val attachmentOpenFailed: String = "Tento súbor sa nepodarilo otvoriť."
        override val attachmentDeleteOwnerOnly: String = "Túto prílohu môže odstrániť iba vlastník súboru."
        override val attachmentDocumentsNotIncluded: String = "Váš aktuálny plán neobsahuje nahrávanie súborov. Upgradujte plán a nahrajte súbory."
        override val attachmentDocumentStorageNotIncluded: String = "Váš aktuálny plán neobsahuje úložisko dokumentov. Upgradujte plán a nahrajte súbory."
        override val attachmentFileSizePlanLimit: String = "Tento súbor je väčší, než povoľuje váš aktuálny plán. Upgradujte plán a nahrajte väčšie súbory."
        override val attachmentStoragePlanLimit: String = "Dosiahli ste limit úložiska vo vašom aktuálnom pláne. Upgradujte plán a nahrajte ďalšie súbory."
        override val attachmentDocumentCountPlanLimit: String = "Dosiahli ste limit dokumentov pre túto nehnuteľnosť vo vašom aktuálnom pláne. Upgradujte plán a nahrajte ďalšie súbory."
        override val attachmentHardFileLimit: String = "Prílohy sú obmedzené na 100 MB."
        override val openFiles: String = "Otvoriť súbor(y)"
        override val sendViaEmail: String = "Poslať e-mailom"
        override val sendViaSms: String = "Poslať cez SMS"
        override val sendEmailHeader: String = "Odoslať e-mail"
        override val sendSmsHeader: String = "Odoslať SMS"
        override val noContactsFound: String = "Nenašli sa žiadne kontakty."
        override val searchContacts: String = "Hľadať kontakty"
        override val linked: String = "Prepojené"
        override val recent: String = "Nedávne"
        override val taskColumnToDo: String = "Na spravenie"
        override val taskColumnInProgress: String = "Prebieha"
        override val taskColumnDone: String = "Hotovo"
        override val taskColumnToDoSubtitle: String = "Nové úlohy a ďalšie kroky čakajúce na začatie."
        override val taskColumnInProgressSubtitle: String = "Práca, ktorú práve riešite vy alebo tím."
        override val taskColumnDoneSubtitle: String = "Dokončené úlohy zostávajú viditeľné pre tímový prehľad."
        override val taskEmptyToDo: String = "Žiadne úlohy na spravenie."
        override val taskEmptyInProgress: String = "Nič neprebieha."
        override val taskEmptyDone: String = "Zatiaľ žiadne dokončené úlohy."
        override val taskKanbanEmptyToDo: String = "Nič nečaká. Nové follow-upy a reporty sa zobrazia tu."
        override val taskKanbanEmptyInProgress: String = "Žiadna aktívna práca neprebieha."
        override val taskKanbanEmptyDone: String = "Dokončené úlohy sa zobrazia tu."
        override val taskEmptyBodyPrefix: String = "Vytvorte úlohu alebo presuňte inú úlohu do stĺpca"
        override val taskEmptyBodySuffix: String = "."
        override val taskActionStart: String = "Začať"
        override val taskActionOverdue: String = "Po termíne"
        override val taskActionCancel: String = "Zrušiť"
        override val taskPriorityLow: String = "Nízka"
        override val taskPriorityMedium: String = "Stredná"
        override val taskPriorityHigh: String = "Vysoká"
        override val taskPriorityUrgent: String = "Urgentná"
        override val taskStatusOpen: String = "Otvorená"
        override val taskStatusInProgress: String = "Prebieha"
        override val taskStatusDone: String = "Hotovo"
        override val taskStatusOverdue: String = "Po termíne"
        override val taskStatusCancelled: String = "Zrušená"
        override val aiSuggestedTasks: String = "AI navrhnuté úlohy"
        override val noAiSuggestedTasks: String = "Zatiaľ žiadne AI návrhy. HAVN navrhne úlohy po obhliadkach a aktivite leadov."
        override val taskFilterToday: String = "Dnes"
        override val taskFilterUpcoming: String = "Nadchádzajúce"
        override val taskFilterOverdue: String = "Po termíne"
        override val taskFilterCompleted: String = "Dokončené"
        override val taskFilterAssignedToMe: String = "Priradené mne"
        override val taskFilterAiSuggested: String = "AI návrhy"
        override val taskFilterEmptyToday: String = "Na dnes máte hotovo."
        override val taskFilterEmptyUpcoming: String = "Žiadne nadchádzajúce úlohy."
        override val taskFilterEmptyOverdue: String = "Žiadne úlohy po termíne."
        override val taskFilterEmptyCompleted: String = "Zatiaľ žiadne dokončené úlohy."
        override val taskFilterEmptyAssignedToMe: String = "Nemáte priradené žiadne úlohy."
        override val taskFilterEmptyAiSuggested: String = "Zatiaľ žiadne prijaté AI navrhnuté úlohy."
        override val taskSuggestionHotLeadTitlePrefix: String = "Follow-up s kontaktom"
        override val taskSuggestionHotLeadTitleSuffix: String = "do 2 hodín."
        override val taskSuggestionHotLeadDescriptionPrefix: String = "Horúci lead z nehnuteľnosti"
        override val taskSuggestionHotLeadDescriptionSuffix: String = "Udržte momentum, kým je záujem čerstvý."
        override val taskSuggestionHotLeadReason: String = "Zachytený nový horúci lead."
        override val taskSuggestionSellerReportTitlePrefix: String = "Vytvoriť seller report pre"
        override val taskSuggestionSellerReportTitleSuffix: String = "."
        override val taskSuggestionSellerReportDescription: String = "Zhrňte počet návštevníkov, horúce leady, aktivitu pripomienok a sentiment kupujúcich."
        override val taskSuggestionSellerReportReason: String = "Obhliadka skončila."
        override val taskSuggestionReviewFollowUpTitlePrefix: String = "Skontrolovať a odoslať"
        override val taskSuggestionReviewFollowUpTitleSuffix: String = "follow-up."
        override val taskSuggestionReviewFollowUpReason: String = "Návrh follow-upu ešte potrebuje kontrolu agentom."
        override val taskSuggestionKioskTitle: String = "Pripraviť kiosk a skontrolovať fotky nehnuteľnosti."
        override val taskSuggestionKioskDescription: String = "Overte sign-in flow, galériu a detaily obhliadky pred príchodom kupujúcich."
        override val taskSuggestionKioskReason: String = "Obhliadka je naplánovaná."
    }

    private val german: HavnStrings = object : HavnStrings {
        override val navToday: String = "Heute"
        override val navProperties: String = "Immobilien"
        override val navLeads: String = "Leads"
        override val navReports: String = "Berichte"
        override val navTasks: String = "Aufgaben"
        override val navAnalytics: String = "Analysen"
        override val navAgency: String = "Agentur"
        override val navSettings: String = "Einstellungen"
        override val navAuth: String = "Agentenzugang"
        override val navOpenHouses: String = "Besichtigungen"
        override val navTours: String = "Besichtigungen"
        override val navFollowUps: String = "Kontakte"
        override val navFollow: String = "Kontakte"
        override val back: String = "Zurück"
        override val settingsEyebrow: String = "Arbeitsbereich"
        override val settingsTitle: String = "Einstellungen"
        override val settingsSubtitle: String = "Profil, Sprache, Einheiten, Umgebung und Teamoptionen."
        override val agentProfileTitle: String = "Agentenprofil"
        override val agentPhoto: String = "Agentenfoto"
        override val uploading: String = "Wird hochgeladen..."
        override val saving: String = "Wird gespeichert..."
        override val validAgentPhotoRequired: String = "Wählen Sie ein gültiges Agentenfoto."
        override val signOut: String = "Abmelden"
        override val signOutQuestion: String = "Abmelden?"
        override val signOutConfirmation: String = "Möchten Sie sich wirklich von HAVN abmelden?"
        override val deleteAccount: String = "Konto löschen"
        override val deleteAccountQuestion: String = "Konto löschen?"
        override val deleteAccountOpenPageBody: String = "Die Seite zum Beantragen der Kontolöschung wird geöffnet."
        override val deleteAccountReviewTitle: String = "Echtes Konto verwenden"
        override val deleteAccountReviewBody: String = "Dieses App-Review-Konto ist geschützt, damit Reviewer während des Tests den Zugriff nicht verlieren. Bitte verwenden Sie ein echtes Testkonto, um die Kontolöschung zu prüfen."
        override val upgrade: String = "Upgrade"
        override val premiumThemesTitle: String = "Premium-Designs"
        override val premiumThemesUpgradePrompt: String = "Wechseln Sie zu Pro, um Premium-Designs freizuschalten."
        override val appearanceTitle: String = "Darstellung"
        override val appearanceBody: String = "Wählen Sie den hellen oder dunklen Modus für die Web-App."
        override val previewComponents: String = "Komponenten ansehen"
        override val themeShowcaseTitle: String = "Design-Vorschau"
        override val showcaseButtons: String = "Buttons"
        override val showcasePrimaryAction: String = "Primäre Aktion"
        override val showcaseSecondaryAction: String = "Sekundäre Aktion"
        override val showcaseGhostAction: String = "Dezente Aktion"
        override val showcaseTextField: String = "Textfeld"
        override val showcaseFocusedBorder: String = "Akzent-Rahmen im Fokus"
        override val showcaseSearchPreview: String = "Suchvorschau"
        override val showcaseOpeningCheckedIn: String = "Heute bei einer Besichtigung eingecheckt"
        override val showcaseSentAt: String = "Gesendet um 10:30"
        override val themeObsidianGoldName: String = "Obsidian Gold"
        override val themeObsidianGoldDescription: String = "Luxuriöses Schwarz, Graphit und warmes Gold."
        override val themeMidnightSapphireName: String = "Midnight Sapphire"
        override val themeMidnightSapphireDescription: String = "Tiefes Navy, Saphirblau und silberne Akzente."
        override val themeEmeraldEstateName: String = "Emerald Estate"
        override val themeEmeraldEstateDescription: String = "Dunkles Smaragdgrün, Anthrazit und Champagnergold."
        override val themePlatinumStoneName: String = "Platinum Stone"
        override val themePlatinumStoneDescription: String = "Steingrau, Platin und sanftes Weiß."
        override val themeBordeauxNoirName: String = "Bordeaux Noir"
        override val themeBordeauxNoirDescription: String = "Dunkler Weinrot-Ton, Graphit und Kupferakzente."
        override val commonChange: String = "Ändern"
        override val agentPlanTitle: String = "Agentenplan"
        override val agentPlanBody: String = "Verbessern Sie Ihre Arbeitsweise und wählen Sie den Plan, der am besten passt."
        override val currentPlan: String = "Aktueller Plan"
        override val transferPlan: String = "Plan übertragen"
        override val transferPlanTitle: String = "Plan übertragen"
        override val transferPlanBody: String = "Übertragen Sie dieses Abonnement auf ein anderes HAVN-Konto. Beide E-Mail-Adressen müssen mit Verifizierungscodes bestätigen."
        override val transferTargetEmail: String = "E-Mail des neuen Kontos"
        override val transferSendCodes: String = "Verifizierungscodes senden"
        override val transferCodesSentTitle: String = "Verifizierungscodes gesendet"
        override val transferCodesSentBody: String = "Wir haben einen Code an Ihre E-Mail und einen Code an die E-Mail des neuen Kontos gesendet."
        override val transferYourCode: String = "Code aus Ihrer E-Mail"
        override val transferTargetCode: String = "Code des neuen Kontos"
        override val transferConfirm: String = "Plan übertragen"
        override val transferSuccessTitle: String = "Plan übertragen"
        override val transferSuccessBody: String = "Das Abonnement ist jetzt mit dem neuen HAVN-Konto verbunden."
        override val restorePurchase: String = "Kauf wiederherstellen"
        override val agencySettingsProBody: String = "Solo agency ist standardmäßig aktiv. Mit Pro können Sie eine gemeinsame Agentur erstellen oder auswählen."
        override val agencySettingsLockedBody: String = "Solo agency ist aktiv. Änderungen an Agenturen sind mit Pro verfügbar."
        override val soloAgency: String = "Solo Agentur"
        override val defaultPrivateAgencyWorkspace: String = "Standardmäßige private Agentur"
        override val noAgenciesAvailableYet: String = "Es sind noch keine Einladungen oder eigenen Agenturen verfügbar."
        override val oneOwnedAgencyHint: String = "Ihre eigene Agentur ist oben aufgeführt. Ein Agent kann eine Agentur besitzen."
        override val createAgency: String = "Agentur erstellen"
        override val createYourAgency: String = "Erstellen Sie Ihre Agentur"
        override val createAgencyBody: String = "Bauen Sie Ihr Team auf, verwalten Sie Immobilien gemeinsam und wachsen Sie weiter."
        override val agencyName: String = "Agenturname"
        override val agencyEmail: String = "Agentur-E-Mail"
        override val logoOptional: String = "Logo (optional)"
        override val upgradeExperienceTitle: String = "Erweitern Sie Ihr Erlebnis"
        override val upgradeExperienceSubtitle: String = "Wählen Sie den Plan, der zu Ihrer Arbeitsweise passt."
        override val soloAgentPlan: String = "Solo agent"
        override val proAgentPlan: String = "Pro agent"
        override val teamAgentPlan: String = "Team"
        override val soloBenefitActiveProperties: String = "Bis zu 1.000 Immobilien"
        override val soloBenefitAiFollowUps: String = "1.000 AI-Textanfragen / Monat"
        override val soloBenefitSellerReports: String = "Keine Verkäuferberichte"
        override val soloBenefitPersonalOnly: String = "Nur persönliches Konto"
        override val proBenefitUnlimitedProperties: String = "Bis zu 10.000 Immobilien"
        override val proBenefitUnlimitedAi: String = "10.000 AI-Textanfragen / Monat"
        override val proBenefitAdvancedReports: String = "Erweiterte Verkäuferberichte"
        override val proBenefitAgencyCreation: String = "Agentur erstellen und verwalten"
        override val proBenefitInviteAgents: String = "Agenten einladen und zusammenarbeiten"
        override val proBenefitSharedLeads: String = "Geteilte Leads und Teamabläufe"
        override val proBenefitAgencyBranding: String = "Agentur-Branding"
        override val proBenefitAdvancedAnalytics: String = "Erweiterte Analysen"
        override val teamBenefitLargeLimits: String = "Limits für Teams"
        override val teamBenefitPrioritySupport: String = "Prioritärer E-Mail-Support"
        override val teamBenefitDailyBackups: String = "Tägliche Backups für 7 Tage"
        override val teamBenefitLargeStorage: String = "10 GB Dokumentenspeicher"
        override val startFreeTrial7Day: String = "Jetzt abonnieren"
        override val restorePurchases: String = "Kauf wiederherstellen"
        override val comparePlans: String = "Pläne vergleichen"
        override val startFreeTrial: String = "Plan wählen"
        override val noCommitmentCancelAnytime: String = "Keine Verpflichtung. Jederzeit kündbar."
        override val monthly: String = "Monatlich"
        override val yearly: String = "Jährlich"
        override val yearlySave20: String = "Jährlich"
        override val yearlySavings20: String = "Jährliche Abrechnung."
        override val perYear: String = "/ Jahr"
        override val loadingPlans: String = "Pläne werden geladen..."
        override val selectedPlanUnavailable: String = "Dieser Plan ist noch nicht verfügbar. Versuchen Sie es später erneut oder kontaktieren Sie den Support."
        override val signInRequiredForPurchase: String = "Melden Sie sich vor dem Kauf an."
        override val subscriptionDisclosureIos: String = "Automatisch verlängerbares Abonnement. Die Zahlung wird bei der Kaufbestätigung Ihrem Apple Account belastet. Ihr Abonnement verlängert sich automatisch, sofern es nicht mindestens 24 Stunden vor Ende des aktuellen Zeitraums gekündigt wird. Die Verlängerung wird innerhalb von 24 Stunden vor Ende des aktuellen Zeitraums berechnet. Sie können Ihr Abonnement in den App Store Account-Einstellungen verwalten oder kündigen."
        override val subscriptionDisclosureAndroid: String = "Automatisch verlängerbares Abonnement über Google Play. Ihnen wird jeder Abrechnungszeitraum berechnet, sofern Sie nicht kündigen. Sie können Ihr Abonnement jederzeit in den Google Play-Abos verwalten oder kündigen. Der Zugriff bleibt bis zum Ende des bezahlten Zeitraums bestehen."
        override val subscriptionDisclosureWeb: String = "Automatisch verlängerbares Abonnement. Ihnen wird jeder Abrechnungszeitraum über die ausgewählte Zahlungsmethode berechnet, sofern Sie nicht kündigen. Sie können jederzeit in den Abrechnungseinstellungen verwalten oder kündigen. Der Zugriff bleibt bis zum Ende des bezahlten Zeitraums bestehen. Steuern können anfallen."
        override val subscriptionAgreementPrefix: String = "Mit dem Abonnement stimmen Sie den"
        override val subscriptionTermsOfUse: String = "HAVN Nutzungsbedingungen"
        override val subscriptionAgreementAnd: String = "und der"
        override val subscriptionPrivacyPolicy: String = "Datenschutzerklärung zu."
        override val purchaseSuccessTitle: String = "Vielen Dank für Ihren Kauf"
        override val purchaseSuccessBody: String = "Ihr HAVN-Abonnement ist aktiv und Ihr Plan ist bereit."
        override val restoreSuccessTitle: String = "Kauf wiederherstellen"
        override val restoreSuccessBody: String = "Ihr HAVN-Abonnement wurde erfolgreich wiederhergestellt."
        override val purchaseCouldNotComplete: String = "Der Kauf konnte nicht abgeschlossen werden. Versuchen Sie es erneut oder prüfen Sie Ihr App Store- oder Google Play-Konto."
        override val purchaseVerificationPending: String = "Your payment has not been confirmed yet. If you completed checkout, use Restore purchase to check again. You do not need to pay again."
        override val completeWebCheckout: String = "Complete payment in the checkout tab, then return here. Your access will update automatically once payment is confirmed."
        override val restoreCouldNotComplete: String = "Für dieses Store-Konto wurde kein aktives HAVN-Abonnement gefunden."
        override val noActiveSubscriptionFound: String = "Für dieses Store-Konto wurde kein aktives HAVN-Abonnement gefunden."
        override val compareActiveProperties: String = "Aktive Immobilien"
        override val compareAiFollowUps: String = "AI-Follow-ups"
        override val compareSellerReports: String = "Verkäuferberichte"
        override val compareAdvancedAnalytics: String = "Erweiterte Analysen"
        override val compareAgencyCreation: String = "Agenturerstellung"
        override val compareJoinAgencies: String = "Agenturen beitreten"
        override val compareInviteAgents: String = "Agenten einladen"
        override val compareSharedLeads: String = "Geteilte Leads"
        override val compareAgencyBranding: String = "Agentur-Branding"
        override val comparePrioritySupport: String = "Prioritäts-Support"
        override val compareFeature: String = "Funktion"
        override val compareFreePlan: String = "Kostenlos"
        override val compareValueYes: String = "Ja"
        override val compareValueNo: String = "Nein"
        override val comparePricePerMonthUser: String = "Preis / Monat / Nutzer"
        override val comparePricePerYearUser: String = "Preis / Jahr / Nutzer"
        override val compareMaxPropertiesOwner: String = "Max. Immobilien / Eigentümer"
        override val compareMaxContactsOwner: String = "Max. Kontakte / Eigentümer"
        override val compareMaxOpenHousesOwner: String = "Max. Open Houses / Eigentümer"
        override val compareMaxLeadsOwner: String = "Max. Leads / Eigentümer"
        override val compareMaxPhotosProperty: String = "Max. Fotos pro Immobilie"
        override val compareMaxDocumentsProperty: String = "Max. Dokumente pro Immobilie"
        override val compareDocumentsStorage: String = "Dokumentenspeicher"
        override val compareAgencyAgenda: String = "Agentur-Agenda"
        override val compareAiTextRequestsMonth: String = "AI-Textanfragen / Monat"
        override val compareAnalytics: String = "Analysen"
        override val compareTasks: String = "Aufgaben"
        override val compareDocumentsStorageOwner: String = "Dokumentenspeicher / Eigentümer"
        override val compareMaxFileSizeOwner: String = "Max. Dateigröße / Eigentümer"
        override val compareEmailSupport: String = "E-Mail-Support"
        override val compareDailyBackups7Days: String = "Tägliche Backups für 7 Tage gespeichert"
        override val compareKioskMode: String = "Kioskmodus"
        override val unlimited: String = "Unbegrenzt"
        override val basic: String = "Basis"
        override val advanced: String = "Erweitert"
        override val perMonth: String = "/ Monat"
        override val members: String = "Mitglieder"
        override val upgradeToProForAgencyTools: String = "Wechseln Sie zu Pro, um Agentur-Tools zu nutzen"
        override val languageTitle: String = "Sprache"
        override val languageBody: String = "Wählen Sie die App-Sprache für dieses Gerät."
        override val english: String = "English"
        override val slovak: String = "Slovak"
        override val unitsTitle: String = "Einheiten und Währung"
        override val unitsBody: String = "Legen Sie fest, wie Preise und Flachen in der App angezeigt werden."
        override val measurementSystemTitle: String = "Masssystem"
        override val metric: String = "Metrisch"
        override val imperial: String = "Imperial"
        override val currencyTitle: String = "Währung"
        override val notificationsTitle: String = "Benachrichtigungen"
        override val notificationsBody: String = "Control push alerts, quiet hours, and the types of updates HAVN can senden."
        override val notificationSettings: String = "Benachrichtigungseinstellungen"
        override val notificationsSubtitle: String = "Only important updates, filtered von your preferences."
        override val quietHoursTitle: String = "Ruhezeiten"
        override val quietHoursBody: String = "HAVN skips non-critical pushes during quiet hours. Billing and account issues still stay concise."
        override val enableQuietHours: String = "Ruhezeiten aktivieren"
        override val quietHoursStart: String = "Start"
        override val quietHoursEnd: String = "Ende"
        override val timezoneLabel: String = "Zeitzone"
        override val notificationTypesTitle: String = "Benachrichtigungstypen"
        override val notificationNewLeadCapturedTitle: String = "New Lead captured"
        override val notificationNewLeadCapturedBody: String = "When an Besichtigung or QR flow captures a Lead."
        override val notificationHotLeadTitle: String = "Lead als heiß markiert"
        override val notificationHotLeadBody: String = "Only when a Lead becomes high intent."
        override val notificationOpeningStartsSoonTitle: String = "Besichtigung starts soon"
        override val notificationOpeningStartsSoonBody: String = "A single reminder 30 minutes vor start."
        override val notificationOpeningSummaryReadyTitle: String = "Besichtigung summary ready"
        override val notificationOpeningSummaryReadyBody: String = "Wenn die Zusammenfassung nach dem Termin bereit ist."
        override val notificationSellerReportGeneratedTitle: String = "Seller Bericht generated"
        override val notificationSellerReportGeneratedBody: String = "When a Verkäuferbericht has been erstellend."
        override val notificationAiFollowUpReadyTitle: String = "AI Follow-up ready"
        override val notificationAiFollowUpReadyBody: String = "When a Follow-up draft is ready to reanzeigen."
        override val notificationAgentInvitedTitle: String = "Agent einladend to Agentur"
        override val notificationAgentInvitedBody: String = "Agentur invitations and Mitgliederhip changes."
        override val notificationLeadAssignedTitle: String = "Lead Ihnen zugewiesen"
        override val notificationLeadAssignedBody: String = "When a teammate assigns a Lead to you."
        override val notificationLeadTransferredTitle: String = "Lead an Sie übertragen"
        override val notificationLeadTransferredBody: String = "When Eigentümership of a Lead moves to you."
        override val notificationSubscriptionIssueTitle: String = "Abo-Problem"
        override val notificationSubscriptionIssueBody: String = "Fehlgeschlagene Verlängerungen und Zahlungsprobleme."
        override val kioskSecurityTitle: String = "Kiosk-Sicherheit"
        override val kioskSecurityBody: String = "Mit dieser PIN verlassen Sie den Kioskmodus und kehren zur Agenten-App zurück."
        override val kioskPinLabel: String = "Kiosk-PIN"
        override val mcpAccessTitle: String = "MCP-Zugriff"
        override val mcpAccessBody: String = "Verbinden Sie HAVN mit Claude, OpenAI und anderen MCP-Clients unter mcp.havnre.app. In jedem Plan verfügbar."
        override val mcpAuthorizationBearer: String = "Autorisierung: Bearer"
        override val mcpNoApiKeyCreated: String = "Noch kein API-Schlüssel erstellt"
        override val mcpNotUsedYet: String = "Noch nicht verwendet"
        override val mcpLastUsedPrefix: String = "Zuletzt verwendet"
        override val mcpRevealApiKeyTitle: String = "API-Schlüssel anzeigen"
        override val mcpRevealApiKeyBody: String = "Der vollständige Schlüssel wird nur direkt nach dem Erstellen oder Rotieren angezeigt."
        override val mcpCreateKey: String = "Schlüssel erstellen"
        override val mcpRotateKey: String = "Schlüssel rotieren"
        override val mcpRevokeKey: String = "Schlüssel widerrufen"
        override val mcpEndpointHint: String = "Verwenden Sie den Endpoint https://mcp.havnre.app/mcp mit diesem Schlüssel als Bearer-Token."
        override val mcpUpgradeHint: String = "MCP-Zugriff ist in jedem HAVN-Plan verfügbar."
        override val mcpUpgradePrompt: String = "MCP-Zugriff ist in jedem HAVN-Plan verfügbar."
        override val mcpCopied: String = "Kopiert"
        override val mcpCopy: String = "Kopieren"
        override val mcpLoading: String = "Wird geladen"
        override val kioskFeaturedProperty: String = "Featured Immobilie"
        override val kioskPrivateShowing: String = "Private Besichtigung"
        override val kioskLuxuryListing: String = "Luxusangebot"
        override val kioskFastCheckIn: String = "Schneller Check-in"
        override val kioskExitContentDescription: String = "Kiosk verlassen"
        override val kioskWelcome: String = "Willkommen"
        override val kioskGladHere: String = "Schön, dass Sie hier sind."
        override val kioskScanToCheckIn: String = "Zum Check-in scannen"
        override val kioskReceivePropertyDetails: String = "and receive Immobilie details"
        override val kioskOr: String = "Oder"
        override val kioskStartCheckInManually: String = "Manuell einchecken"
        override val kioskSecureInfo: String = "Ihre Daten sind sicher und werden nicht geteilt."
        override val kioskExitTitle: String = "Kiosk verlassen"
        override val kioskExitBody: String = "Geben Sie die Kiosk-PIN ein, um zur Agenten-App zurückzukehren."
        override val kioskIncorrectPin: String = "Falsche PIN."
        override val kioskUnlock: String = "Entsperren"
        override val kioskTellUsTitle: String = "Erzählen Sie uns von sich"
        override val kioskTellUsBody: String = "Ihre Informationen gehen nur an den betreuenden Agenten."
        override val kioskFullName: String = "Vollständiger Name"
        override val kioskContinue: String = "Weiter"
        override val kioskQuestionsTitle: String = "Ein paar kurze Fragen"
        override val kioskQuestionsBody: String = "Das hilft dem Agenten beim passenden Follow-up."
        override val kioskWorkingWithAgentQuestion: String = "Arbeiten Sie mit einem Agenten?"
        override val kioskYes: String = "Ja"
        override val kioskNo: String = "Nein"
        override val kioskInterestQuestion: String = "Woran sind Sie interessiert?"
        override val kioskInterestBuying: String = "Kaufen"
        override val kioskInterestInvesting: String = "Investieren"
        override val kioskInterestBrowsing: String = "Nur ansehen"
        override val kioskInterestRelocating: String = "Umzug"
        override val kioskFinish: String = "Fertig"
        override val kioskThankYou: String = "Danke"
        override val kioskEnjoyVisitPrefix: String = "Viel Freude bei Ihrem Besuch in"
        override val kioskResetAutomatically: String = "Dieser Kiosk wird automatisch zurückgesetzt."
        override val environmentTitle: String = "Umgebung"
        override val environmentBody: String = "Verbindungsdetails sind für diesen Build konfiguriert."
        override val secure: String = "Sicher"
        override val brokerageProfileTitle: String = "Maklerprofil"
        override val brokerageProfileBody: String = "Team-Branding, Agenteneinladungen und Benachrichtigungen werden hier verwaltet."
        override val logout: String = "Abmelden"
        override val languageChanged: String = "Sprache geändert"
        override val commonAdd: String = "Hinzufügen"
        override val commonEdit: String = "Bearbeiten"
        override val commonDelete: String = "Loschen"
        override val commonCancel: String = "Abbrechen"
        override val commonSave: String = "Speichern"
        override val commonCreate: String = "Erstellen"
        override val commonDismiss: String = "Schließen"
        override val commonAll: String = "Alle"
        override val commonDone: String = "Fertig"
        override val commonSend: String = "Senden"
        override val commonTime: String = "Zeit"
        override val commonHour: String = "Stunde"
        override val commonMinute: String = "Minute"
        override val commonAgency: String = "Agentur"
        override val commonSettings: String = "Einstellungen"
        override val commonOpening: String = "Besichtigung"
        override val commonPropertyName: String = "Immobilie"
        override val commonToday: String = "Heute"
        override val agencyToolsAvailable: String = "Agentur-Tools sind verfügbar."
        override val agencySetupSubtitle: String = "Jedes HAVN-Konto hat eine Standardagentur. Pro ermöglicht Einladungen, gemeinsame Leads und Branding."
        override val agencyRecentActivity: String = "Kürzlich activity"
        override val agencyActivityNewLead: String = "New Lead added"
        override val agencyActivityInvitationAccepted: String = "Agent invitation accepted"
        override val agencyActivityAgentJoined: String = "Agent joined the Agentur"
        override val agencyActivitySellerReport: String = "Seller Bericht erstellend"
        override val agencyWorkspaceTitle: String = "Agentur"
        override val agencyWorkspaceBody: String = "Wählen which Agentur you are working with."
        override val agencySoloActiveTitle: String = "Solo Agentur is aktiv"
        override val agencyProRequiredTitle: String = "Pro Plan required"
        override val agencyCreateOrAcceptInviteBody: String = "Erstellen your Agentur or accept an einladen to collaborate with another Agentur."
        override val agencyProUnlockBody: String = "Agentur changes, einladens, shared Leads, and shared branding unlock with Pro."
        override val realEstate: String = "Immobilien"
        override val proAgency: String = "Pro Agentur"
        override val agencyBrandingTitle: String = "Agentur branding"
        override val agencyBrandingBody: String = "Set the Agentur name and logo shown in the app, kiosk, and team anzeigens."
        override val uploadLogo: String = "Hochladen logo"
        override val saveAgency: String = "Speichern Agentur"
        override val yourAgencyRole: String = "Your Agentur role"
        override val agencyAgentsTitle: String = "Agentur agents"
        override val agencyAgentsBody: String = "People eligible to work with this Agentur."
        override val inviteAgent: String = "Einladen agent"
        override val loadingAgents: String = "Laden agents..."
        override val noAgencyAgentsYet: String = "Keine Agentur agents noch nicht."
        override val changeRole: String = "Rolle ändern"
        override val updating: String = "Aktualisieren..."
        override val deleting: String = "Löschen..."
        override val deleteInvite: String = "Einladung stornieren"
        override val chooseAgencyRoleFor: String = "Wählen the Agentur role for"
        override val removeAccess: String = "Remove access"
        override val inviteAgentBody: String = "Senden an Agentur invitation von email. The agent accepts nach signing in with the same email."
        override val agentEmail: String = "Agent email"
        override val role: String = "Role"
        override val inviting: String = "Inviting..."
        override val invite: String = "Einladen"
        override val agents: String = "Agents"
        override val ok: String = "OK"
        override val personalActivePropertyLimit: String = "Personal aktiv Immobilie limit"
        override val personalAccountAgencyToolsLocked: String = "Personal account is aktiv. Agentur tools unlock with Pro."
        override val selected: String = "Ausgewählt"
        override val activeMembers: String = "aktiv Mitglieder"
        override val agencySharedWorkspaceBody: String = "Shared Immobilien, Kontakte, Besichtigungen, Leads, Follow-ups, and Berichte use this Agentur."
        override val actLikeAgent: String = "Als Agent arbeiten"
        override val actAsAdmin: String = "Als Admin arbeiten"
        override val actAsOwner: String = "Als Eigentümer arbeiten"
        override val actLikeAgentBody: String = "Die Agentur wie ein normaler Agent nutzen."
        override val actLikeAgentSelectedBody: String = "Nur zugewiesene oder eigene Arbeit wird angezeigt."
        override val agencyRoleOwner: String = "Eigentümer"
        override val agencyRoleAdmin: String = "Admin"
        override val agencyRoleAgent: String = "Agent"
        override val agencyRoleAssistant: String = "Assistent"
        override val agencyRoleViewer: String = "Betrachter"
        override val agencyRoleOwnerDescription: String = "Vollständige Agenturverwaltung einschließlich Mitglieder, Branding, Zuweisungen, Angebote, Leads und Berichte."
        override val agencyRoleAdminDescription: String = "Vollständige Agenturverwaltung außer dem Löschen der Agentur."
        override val agencyRoleAgentDescription: String = "Bearbeitet zugewiesene Angebote, Besichtigungen, Leads, Follow-ups, Notizen und Verkäuferberichte."
        override val agencyRoleAssistantDescription: String = "Unterstützt zugewiesene Angebote durch Bearbeiten von Leads, Vorbereiten von Follow-ups und Erstellen von Berichtsentwürfen."
        override val agencyRoleViewerDescription: String = "Nur Lesezugriff auf Dashboards und Berichte."
        override val agencyCapabilityInviteRemoveMembers: String = "Mitglieder einladen und entfernen"
        override val agencyCapabilityChangeRoles: String = "Mitgliederrollen ändern"
        override val agencyCapabilityManageAllProperties: String = "Alle Immobilien erstellen, bearbeiten und löschen"
        override val agencyCapabilityAssignAgents: String = "Agenten zuweisen"
        override val agencyCapabilitySeeAllLeads: String = "Alle Leads sehen"
        override val agencyCapabilityExportReports: String = "Berichte exportieren"
        override val agencyCapabilityChangeBranding: String = "Agentur-Branding und Einstellungen ändern"
        override val agencyCapabilityDeleteAgency: String = "Agentur löschen"
        override val agencyCapabilityViewAssignedProperties: String = "Zugewiesene Immobilien anzeigen"
        override val agencyCapabilityHostAssignedOpenings: String = "Zugewiesene Besichtigungen durchführen"
        override val agencyCapabilitySeeAssignedLeads: String = "Leads aus zugewiesenen Immobilien und Besichtigungen sehen"
        override val agencyCapabilityAddNotes: String = "Notizen hinzufügen"
        override val agencyCapabilitySendFollowUps: String = "Follow-ups senden"
        override val agencyCapabilityCreateSellerReports: String = "Verkäuferberichte für zugewiesene Angebote erstellen"
        override val agencyCapabilityEditAssignedLeads: String = "Zugewiesene Leads bearbeiten"
        override val agencyCapabilityPrepareFollowUps: String = "Follow-ups vorbereiten"
        override val agencyCapabilityCreateDraftReports: String = "Berichtsentwürfe erstellen"
        override val agencyCapabilityCannotDeleteProperties: String = "Kann keine Immobilien löschen"
        override val agencyCapabilityCannotInviteAgents: String = "Kann keine Agenten einladen, sofern nicht erlaubt"
        override val agencyCapabilityViewDashboards: String = "Dashboards anzeigen"
        override val agencyCapabilityViewReports: String = "Berichte anzeigen"
        override val agencyCapabilityCannotEdit: String = "Kann nichts bearbeiten"
        override val commonVisitors: String = "Leads"
        override val commonHot: String = "Heiß"
        override val commonWarm: String = "Warm"
        override val commonCold: String = "Kalt"
        override val commonActive: String = "Aktiv"
        override val commonPlanned: String = "Geplant"
        override val commonArchived: String = "Archiviert"
        override val commonPast: String = "Vergangen"
        override val commonFollowUps: String = "Nachfass."
        override val commonProperty: String = "Immobilie"
        override val commonAddress: String = "Adresse"
        override val commonOpenHouse: String = "Besichtigung"
        override val commonInquiry: String = "Anfrage"
        override val commonInquiries: String = "Anfragen"
        override val generalInquiry: String = "Allgemeine Anfrage"
        override val generalInquiries: String = "Allgemeine Anfragen"
        override val propertyInquiry: String = "Immobilienanfrage"
        override val propertyInquiries: String = "Immobilienanfragen"
        override val addGeneralInquiry: String = "Allgemeine Anfrage hinzufügen"
        override val newGeneralInquiry: String = "Neue allgemeine Anfrage"
        override val noGeneralInquiries: String = "Noch keine allgemeinen Anfragen."
        override val noPropertyInquiries: String = "Noch keine Immobilienanfragen."
        override val buyerLookingFor: String = "Wonach sucht dieser Käufer?"
        override val locationCity: String = "Ort / Stadt"
        override val radiusKm: String = "Umkreis (km)"
        override val propertyType: String = "Immobilientyp"
        override val budgetFrom: String = "Budget von"
        override val budgetTo: String = "Budget bis"
        override val purchaseTimeline: String = "Kaufzeitraum"
        override val createGeneralInquiry: String = "Allgemeine Anfrage erstellen"
        override val saveGeneralInquiry: String = "Allgemeine Anfrage speichern"
        override val inquiryType: String = "Anfragetyp"
        override val leadSource: String = "Lead-Quelle"
        override val notSpecified: String = "Nicht angegeben"
        override val inquiryStatus: String = "Anfragestatus"
        override val inquiryFollowUp: String = "Anfrage-Follow-up"
        override val addInquiry: String = "Anfrage hinzufügen"
        override val searchInquiries: String = "Anfragen suchen"
        override val noInquiries: String = "Keine Anfragen"
        override val noInquiriesBody: String = "Nutzen Sie die Plus-Schaltfläche, um Käuferinteresse aus einem bestehenden Kontakt hinzuzufügen."
        override val inquiryUnavailableTitle: String = "Anfrage nicht verfügbar"
        override val inquiryUnavailableBody: String = "Diese Anfrage wurde möglicherweise entfernt oder wird noch geladen."
        override val backToInquiries: String = "Zurück zu Anfragen"
        override val deleteInquiry: String = "Anfrage löschen"
        override val deleteInquiryQuestionPrefix: String = "Löschen"
        override val deleteInquiryQuestionSuffix: String = "aus dieser Immobilie?"
        override val deleteInquiryTargetFallback: String = "diese Anfrage"
        override val propertyInquiriesBody: String = "Verfolgen Sie Käufer, die nach dieser Immobilie gefragt haben. Anfragen erscheinen auch in Leads."
        override val propertyInquiriesEmpty: String = "Fügen Sie eine Anfrage hinzu, indem Sie einen Ihrer Kontakte auswählen."
        override val contactInquiriesBody: String = "Immobilien, nach denen dieser Kontakt gefragt hat."
        override val contactInquiriesEmpty: String = "Noch keine Immobilienanfragen."
        override val viewInquiries: String = "Anfragen anzeigen"
        override val createContactFirstForInquiry: String = "Erstellen Sie zuerst einen Kontakt und fügen Sie dann die Anfrage aus dieser Immobilie hinzu."
        override val commonCheckedIn: String = "Eingecheckt"
        override val commonNotScheduled: String = "nicht geplant"
        override val todayTitle: String = "Heute"
        override val todaySubtitle: String = "Ihr Tagesüberblick für Besichtigungen, Leads, Follow-ups und Verkäufer-Momentum."
        override val todayOpenHousesMetric: String = "Besichtigungen"
        override val capturedMetric: String = "captured"
        override val priorityMetric: String = "priority"
        override val noActivePropertiesTitle: String = "Keine aktiv Immobilien"
        override val noActivePropertiesBody: String = "Add or activate a Immobilie to make it appear on Heute."
        override val checkIns: String = "Check-ins"
        override val allOpenHouses: String = "all Besichtigungen"
        override val pendingDrafts: String = "pending drafts"
        override val priorityLead: String = "Priorität Lead"
        override val nextOpenHouseAt: String = "Next Besichtigung at"
        override val noOpenHouseScheduled: String = "Keine Besichtigung scheduled"
        override val personalAccount: String = "Persönliches Konto"
        override val accountReady: String = "Ihr Konto ist bereit"
        override val realEstateApp: String = "Immobilien-App"
        override val needHelp: String = "Brauchen Sie Hilfe?"
        override val contactSupport: String = "Support kontaktieren"
        override val upgradePlan: String = "Plan upgraden"
        override val planSuffix: String = "Plan"
        override val todayActionsTitle: String = "Heutige Prioritäten"
        override val agencyInvitation: String = "Agentur invitation"
        override val joinAgency: String = "Join"
        override val youWereInvitedAs: String = "You were einladend as"
        override val invitedBy: String = "von"
        override val decline: String = "Decline"
        override val yourDefaultAgency: String = "Your default Agentur"
        override val chooseAgencyBody: String = "Wählen which Agentur you want to work with. Agentur tools include einladens, shared Leads, and branding."
        override val agencyMembersSuffix: String = "Mitglieder"
        override val quickActionTasksBody: String = "Queue"
        override val quickActionReportsBody: String = "Seller"
        override val quickActionAnalyticsBody: String = "Trends"
        override val quickActionAddPropertyTitle: String = "Neu"
        override val quickActionAddPropertyBody: String = "Objekt"
        override val quickActionAddContactTitle: String = "Kontakt"
        override val quickActionAddContactBody: String = "Neu"
        override val quickActionFilesTitle: String = "Dateien"
        override val quickActionFilesBody: String = "Dok."
        override val firstRunStepsTitle: String = "Start with four simple steps"
        override val firstRunAddProperty: String = "Add Immobilie"
        override val firstRunScheduleOpening: String = "Schedule Besichtigung"
        override val firstRunStartGuestCheckIn: String = "Start guest check-in"
        override val firstRunSendFollowUp: String = "Senden Follow-up"
        override val greetingNamePrefix: String = "Hallo"
        override val greetingAgent: String = "Hallo Agent"
        override val createListing: String = "Erstellen listing"
        override val newOwnerBuyer: String = "New Eigentümer/buyer"
        override val documents: String = "Dokumente"
        override val whatOpeningNext: String = "What Besichtigung is next?"
        override val whoCheckedIn: String = "Wer hat eingecheckt?"
        override val whoNeedsFollowUp: String = "Who needs Follow-up?"
        override val whatShouldIDoNow: String = "Was soll ich jetzt tun?"
        override val noCheckInsYet: String = "Noch keine Kontakte eingecheckt."
        override val noPendingFollowUps: String = "Aktuell keine offenen Follow-ups."
        override val openKioskForNextOpening: String = "Open the kiosk for the next Besichtigung."
        override val reviewNewLeads: String = "Prüfen Sie neue Leads und senden Sie Follow-ups."
        override val createOpeningToStart: String = "Erstellen an Besichtigung from a Immobilie to start collecting Leads."
        override val addFirstPropertyToStart: String = "Fügen Sie Ihre erste Immobilie hinzu."
        override val nextOpening: String = "Next Besichtigung"
        override val quickSignIn: String = "Schneller Check-in"
        override val scanQrCode: String = "QR-Code scannen"
        override val newLead: String = "Neuer Lead"
        override val myProperties: String = "Meine Immobilien"
        override val manageListings: String = "Angebote verwalten"
        override val todaysOverview: String = "Heutige Übersicht"
        override val seeAll: String = "Alle anzeigen"
        override val propertiesEyebrow: String = "Portfólio"
        override val propertiesSubtitle: String = "Manage aktiv, Planned, and archived listings with listing media, buyer activity, and performance insights."
        override val propertiesLiveMetric: String = "live"
        override val propertiesPipelineMetric: String = "pipeline"
        override val propertiesAllTimeMetric: String = "all time"
        override val addProperty: String = "Immobilie hinzufugen"
        override val editProperty: String = "Immobilie bearbeiten"
        override val propertyFallback: String = "Immobilie"
        override val propertyUnavailableTitle: String = "Immobilie nicht verfügbar"
        override val propertyUnavailableBody: String = "Refresh the portfolio to reload this listing."
        override val backToProperties: String = "Zurück zu Immobilien"
        override val deletePropertyTitle: String = "Immobilie löschen?"
        override val deletePropertyBody: String = "This will permanently löschen the Immobilie and its related local records. Diese Aktion kann nicht rückgängig gemacht werden."
        override val loadingProperties: String = "Immobilien werden geladen"
        override val loadMore: String = "Mehr laden"
        override val loadingPropertyDetails: String = "Laden Immobilie details"
        override val noPropertiesTitle: String = "Noch keine Immobilien"
        override val noPropertiesBody: String = "Add your first Immobilie, then erstellen an Besichtigung to start collecting Leads and seller-ready feedback."
        override val openHouseButton: String = "Erstellen Besichtigung"
        override val photosTitle: String = "Fotos"
        override val photosBody: String = "The first Foto is used as the main Immobilie image across Portfolio."
        override val uploadPhoto: String = "Foto hochladen"
        override val noPhotosYet: String = "Noch keine Fotos hochgeladen."
        override val propertyPhotoCountPlanLimit: String = "Das Fotolimit fuer dieses Objekt in deinem aktuellen Tarif ist erreicht. Upgrade deinen Tarif, um weitere Fotos hochzuladen."
        override val propertyPhotoStoragePlanLimit: String = "Das Speicherlimit deines aktuellen Tarifs ist erreicht. Upgrade deinen Tarif, um weitere Fotos oder Dateien hochzuladen."
        override val mainPhoto: String = "Hauptfoto"
        override val propertyTitleLabel: String = "Name der Immobilie"
        override val propertyAddressLine1Label: String = "Straße und Hausnummer"
        override val propertyAddressLine2Label: String = "Adresszusatz"
        override val propertyCityLabel: String = "Stadt"
        override val propertyRegionLabel: String = "Region"
        override val propertyPostalCodeLabel: String = "Postleitzahl"
        override val propertyCountryLabel: String = "Land"
        override val propertyAskingPriceLabel: String = "Angebotspreis"
        override val propertyBedsLabel: String = "Zimmer"
        override val propertyBathsLabel: String = "Bäder"
        override val propertyInteriorLabel: String = "Innenfläche"
        override val propertyDescriptionLabel: String = "Beschreibung"
        override val createPropertyButton: String = "+ Objekt"
        override val locateProperty: String = "Immobilie lokalisieren"
        override val findLocation: String = "Standort suchen"
        override val find: String = "Suchen"
        override val navigate: String = "Navigieren"
        override val propertyLocationMarkerTitle: String = "Standort der Immobilie"
        override val mapKitJsMissingToken: String = "Die Karte ist für diesen Build nicht konfiguriert."
        override val mapKitJsLoading: String = "MapKit JS wird geladen..."
        override val generateSellerReport: String = "Verkäuferbericht erstellen"
        override val deleteProperty: String = "Immobilie löschen"
        override val conversionMetric: String = "Konversion"
        override val propertyPhotoContentDescription: String = "Foto der Immobilie"
        override val deletePhoto: String = "Foto löschen"
        override val movePhotoLeft: String = "Foto nach links verschieben"
        override val movePhotoRight: String = "Foto nach rechts verschieben"
        override val propertyTitleRequired: String = "Der Name der Immobilie ist erforderlich."
        override val propertyStreetRequired: String = "Straße und Hausnummer sind erforderlich."
        override val propertyCityRequired: String = "Die Stadt ist erforderlich."
        override val propertyRegionRequired: String = "Die Region ist erforderlich."
        override val propertyPostalRequired: String = "Die Postleitzahl ist erforderlich."
        override val propertyAskingPriceInvalid: String = "Geben Sie einen gültigen Angebotspreis ein."
        override val propertyOwnerContactTitle: String = "Kontakt des Eigentümers"
        override val propertyOwnerSelectContact: String = "Wählen Sie einen bestehenden Kontakt als Eigentümer der Immobilie aus."
        override val propertyOwnerSelected: String = "Ausgewählter Eigentümer"
        override val propertyOwnerNoContacts: String = "Noch keine Kontakte. Fügen Sie den Eigentümer unter Kontakte hinzu und wählen Sie ihn dann hier aus."
        override val propertyOwnerChooseContact: String = "Kontakt wählen"
        override val propertyOwnerChangeContact: String = "Kontakt ändern"
        override val propertyOwnerRemoveContact: String = "Entfernen"
        override val propertyOwnerPickerTitle: String = "Eigentümer der Immobilie wählen"
        override val propertyOwnerSearchContact: String = "Kontakte suchen"
        override val propertyOwnerSearchHint: String = "Beginnen Sie mit Name, E-Mail oder Telefonnummer."
        override val propertyOwnerNoMatches: String = "Keine passenden Kontakte."
        override val propertyOpeningsTitle: String = "Besichtigungen"
        override val propertyNoOpenings: String = "Für diese Immobilie sind keine Besichtigungen geplant."
        override val teamAccessTitle: String = "Teamzugriff"
        override val onlyListingOwner: String = "Nur der Eigentümer des Angebots"
        override val assignTeam: String = "Team zuweisen"
        override val assignPropertyTitle: String = "Immobilie zuweisen"
        override val assignPropertyBody: String = "Wählen Sie, wer mit dieser Immobilie arbeiten darf. Wählen Sie das ganze Team oder bestimmte Agenten."
        override val wholeTeam: String = "Ganzes Team"
        override val leadsEyebrow: String = "Leads"
        override val leadFallback: String = "Lead"
        override val leadsSubtitle: String = "Suchen, filtern und qualifizieren Sie Leads aus allen Besichtigungen."
        override val leadDetailSubtitle: String = "Quelle, Qualifikation, Notizen und Follow-up-Verlauf für diesen Lead aus der Besichtigung."
        override val totalMetric: String = "Gesamt"
        override val loggedMetric: String = "erfasst"
        override val searchLeads: String = "Leads suchen"
        override val searchLeadsPlaceholder: String = "Name, Telefon oder E-Mail"
        override val allProperties: String = "Alle Immobilien"
        override val loadingLeads: String = "Leads aus Besichtigungen werden geladen"
        override val loadingLeadDetails: String = "Lead-Details werden geladen"
        override val noLeadsFoundTitle: String = "Leads erscheinen hier, wenn Kontakte bei einer Besichtigung einchecken."
        override val noLeadsEmptyBody: String = "Nutzen Sie den Kiosk-Check-in oder fügen Sie Kontakte manuell aus einer Besichtigung hinzu."
        override val noLeadsFilteredBody: String = "Versuchen Sie eine andere Immobilie, einen anderen Status oder Suchbegriff."
        override val backToLeads: String = "Zurück zu Leads"
        override val leadUnavailableTitle: String = "Lead nicht verfügbar"
        override val leadUnavailableBody: String = "Dieser Lead ist in der aktuellen Lead-Liste nicht mehr verfügbar."
        override val leadTemperature: String = "Lead-Status"
        override val leadLabelSuffix: String = "Lead"
        override val greetingHi: String = "Hallo"
        override val leadActionCall: String = "Anrufen"
        override val leadActionSms: String = "SMS"
        override val leadActionEmail: String = "E-Mail"
        override val leadFollowUp: String = "Follow-up"
        override val leadNoFollowUpScheduled: String = "Keine Follow-up scheduled"
        override val leadIntentScore: String = "Interesse-Score"
        override val leadInterestedIn: String = "Interessiert an"
        override val leadGenericGreetingName: String = "zusammen"
        override val followUpMessageTypeThankYou: String = "Danke"
        override val followUpMessageTypePropertyInfo: String = "Immobilieninfo"
        override val followUpMessageTypeFollowUp: String = "Follow up"
        override val followUpMessageTypeCheckIn: String = "Nachfragen"
        override val followUpMessageTypePriceUpdate: String = "Preisupdate"
        override val followUpMessageTypePropertyBrochure: String = "Datumien"
        override val followUpPreview: String = "Vorschau"
        override val followUpSubject: String = "Betreff"
        override val followUpMessage: String = "Nachricht"
        override val followUpSendViaEmail: String = "Per E-Mail senden"
        override val followUpSendViaSms: String = "Per SMS senden"
        override val followUpAiAssistantTitle: String = "AI-Assistent"
        override val followUpAiAssistantBody: String = "Erstellen Sie in Sekunden eine persönliche Nachricht."
        override val followUpGenerateWithAi: String = "Mit AI erstellen"
        override val followUpUpgradeForAi: String = "AI freischalten"
        override val followUpDefaultSubject: String = "Following up on"
        override val privateAgentNotes: String = "Private agent notes"
        override val notes: String = "Notes"
        override val notesPlaceholder: String = "Motivation, preferences, objections, next move"
        override val saveNotes: String = "Speichern notes"
        override val followUpHistory: String = "Follow-up history"
        override val noFollowUpsLogged: String = "Keine Follow-ups logged noch nicht."
        override val openHousesEyebrow: String = "Showings"
        override val scheduleOpenHouse: String = "Besichtigung erstellen"
        override val openingDetails: String = "Besichtigung details"
        override val editOpening: String = "Bearbeiten Besichtigung"
        override val deleteOpening: String = "Löschen Besichtigung"
        override val deleteOpeningBody: String = "Möchten Sie wirklich löschen this Besichtigung? Diese Aktion kann nicht rückgängig gemacht werden."
        override val removeLeadTitle: String = "Lead entfernen?"
        override val removeLeadBody: String = "%s aus dieser Besichtigung entfernen?"
        override val removeLeadFallback: String = "diesen Lead"
        override val openingName: String = "Name des Open Houses"
        override val startsAt: String = "Beginnt um"
        override val endsAt: String = "Endet um"
        override val chooseStartDateTime: String = "Startdatum und Uhrzeit wählen"
        override val chooseEndDateTime: String = "Enddatum und Uhrzeit wählen"
        override val accessNotes: String = "Zugangshinweise"
        override val privateNotes: String = "Private Notizen"
        override val addPrivateNote: String = "Private Notiz hinzufügen"
        override val liveDashboard: String = "Live dashboard"
        override val visitorKiosk: String = "Lead kiosk"
        override val openHousesSubtitle: String = "Erstellen Besichtigungen for Immobilien, reanzeigen Leads, and launch kiosk sessions."
        override val liveMetric: String = "Live"
        override val upcomingMetric: String = "Anstehend"
        override val inProgressMetric: String = "in progress"
        override val scheduledMetric: String = "scheduled"
        override val loadingOpenHouses: String = "Laden Besichtigungen"
        override val addPropertyFirstTitle: String = "Add a Immobilie first"
        override val addPropertyFirstBody: String = "Erstellen an Besichtigung from a Immobilie to start collecting Leads."
        override val noOpenHousesTitle: String = "Keine Besichtigungen scheduled"
        override val noOpenHousesBody: String = "Erstellen an Besichtigung from a Immobilie to start collecting Leads."
        override val noSignInsTitle: String = "Keine sign-ins yet"
        override val noSignInsBody: String = "Leads checked in through kiosk mode will appear here in real time."
        override val dashboard: String = "Dashboard"
        override val start: String = "Start"
        override val end: String = "Ende"
        override val endOpenHouse: String = "Ende Besichtigung"
        override val reportsEyebrow: String = "Eigentümers"
        override val sellerReportsTitle: String = "Verkäuferberichte"
        override val createReport: String = "Bericht"
        override val reportPreview: String = "Verkäuferbericht"
        override val reportsSubtitle: String = "Erstellen Sie hochwertige Zusammenfassungen nach Besichtigungen mit Lead-Qualität, Käuferinteresse und verkäuferfertiger Darstellung."
        override val reportsMetricSaved: String = "speichernd"
        override val reportedMetric: String = "Berichted"
        override val leadsMetric: String = "Leads"
        override val createSellerReport: String = "Bericht"
        override val attendance: String = "Besuche"
        override val savedReports: String = "speichernd Berichte"
        override val buyerHeat: String = "Käuferinteresse"
        override val hotLeads: String = "heiße Leads"
        override val loadingSellerReports: String = "Laden Verkäuferberichte"
        override val noSellerReportsTitle: String = "Keine Verkäuferberichte yet"
        override val noSellerReportsBody: String = "Wählen an Besichtigung, add agent notes, preanzeigen an export-ready recap, then speichern it."
        override val chooseOpenHouse: String = "Wählen Besichtigung"
        override val noOpenHousesAvailable: String = "Keine Besichtigungen available noch nicht."
        override val agentNotes: String = "Agent notes"
        override val notesForSeller: String = "Notes for seller"
        override val sellerNotesPlaceholder: String = "Einwände, Preissignale, Besichtigungsfeedback, empfohlener nächster Schritt"
        override val generatePreview: String = "Generate preanzeigen"
        override val noPreviewReadyTitle: String = "Keine preanzeigen ready"
        override val noPreviewReadyBody: String = "Generate a Verkäuferbericht preanzeigen vor saving."
        override val saveReport: String = "Speichern"
        override val reportSaved: String = "Bericht speichernd"
        override val sellerOpenHouseReport: String = "Seller Besichtigung Bericht"
        override val mostCommonBuyerInterest: String = "Most common buyer interest"
        override val followUpsSent: String = "Follow-ups sent"
        override val summary: String = "Zusammenfassung"
        override val noPrivateNotesAdded: String = "Keine private notes added."
        override val openHouseReport: String = "Besichtigung Bericht"
        override val commonDraft: String = "Entwurf"
        override val commonAccepted: String = "Akzeptiert"
        override val searchSellerReports: String = "Verkäuferberichte suchen"
        override val noMatchingReports: String = "Keine passenden Berichte"
        override val clearFilters: String = "Clear filters"
        override val tryDifferentSearchOrStatusFilter: String = "Versuchen Sie eine andere Suche oder einen anderen Statusfilter."
        override val connectedToProperty: String = "Mit Immobilie verknüpft"
        override val viewProperty: String = "Immobilie anzeigen"
        override val dataRollup: String = "Data rollup"
        override val connectedOpenings: String = "Besichtigungen"
        override val visitors: String = "Besucher"
        override val interestedBuyers: String = "Interessenten"
        override val completedFollowUps: String = "Follow Ups"
        override val reportHistory: String = "Bericht history"
        override val noPreviousReportsYet: String = "Noch keine vorherigen Berichte."
        override val viewAllReports: String = "Alle Berichte anzeigen"
        override val actions: String = "Aktionen"
        override val generatePdf: String = "Tabelle erstellen"
        override val previewPdf: String = "Tabelle ansehen"
        override val pdfSavedToPropertyFiles: String = "%s speichernd to Immobilie Datumien."
        override val pdfSavingToPropertyFiles: String = "%s is being speichernd to Immobilie Datumien."
        override val pdfSavedToFiles: String = "%s speichernd to Datumien."
        override val pdfSavingToFiles: String = "%s is being speichernd to Datumien."
        override val pdfIncludesSellerReport: String = "Spreadsheet includes Verkäuferbericht metrics, AI insights, agent details, Immobilie data, and Besichtigung history."
        override val pdfIncludesAnalytics: String = "Die Tabelle enthält Analysekennzahlen, Top-Immobilien, Agentenleistung, Follow-up-Kanäle und AI-Erkenntnisse."
        override val pdfGenerateBeforeSending: String = "Erstellen the spreadsheet vor sendening."
        override val pdfUploadBeforeSharing: String = "The spreadsheet must finish upladen vor sharing."
        override val sellerReportPdfNeedsProperty: String = "Die Verkäuferbericht-Tabelle benötigt vor dem Hochladen eine verknüpfte Immobilie."
        override val deleteReport: String = "Löschen Bericht"
        override val deleteReportBody: String = "Möchten Sie wirklich löschen this Verkäuferbericht? Diese Aktion kann nicht rückgängig gemacht werden."
        override val shareReport: String = "Share Bericht"
        override val openingPropertyReportLoading: String = "Immobilie Bericht..."
        override val openingPropertyReportCreating: String = "Creating Immobilie Bericht..."
        override val sellerReportGeneratedPrefix: String = "Verkäuferbericht generated"
        override val sellerReportGeneratedSuffix: String = "aus Besichtigungen, Besuchern, Leads, Follow-ups und Feedback, die zum Berichtszeitpunkt mit dieser Immobilie verknüpft waren."
        override val priceNotSet: String = "Preis not set"
        override val daysSuffix: String = "Tage"
        override val connectedOpeningSingular: String = "Besichtigung"
        override val connectedOpeningPlural: String = "Besichtigungen"
        override val connectedLeadSingular: String = "verknüpfter Lead"
        override val connectedLeadPlural: String = "verknüpfte Leads"
        override val sellerConfidence: String = "Seller confidence"
        override val sellerConfidenceExplanation: String = "Confidence exPlanation"
        override val aiDraftReviewBeforeSending: String = "AI draft only. Reanzeigen and bearbeiten vor sendening to the seller."
        override val executiveSummary: String = "Executive summary"
        override val buyerInterestOverview: String = "Überblick zum Käuferinteresse"
        override val whatBuyersLoved: String = "What buyers loved"
        override val buyerConcerns: String = "Bedenken der Käufer"
        override val leadQualitySummary: String = "Zusammenfassung der Lead-Qualität"
        override val agentActivity: String = "Agent activity"
        override val aiRecommendations: String = "AI recommendations"
        override val recommendations: String = "Empfehlungen"
        override val marketPositionComparison: String = "Market position comparison"
        override val nextSteps: String = "Next steps"
        override val conversion: String = "Konversion"
        override val interested: String = "interested"
        override val tourSignalsLowercase: String = "tour signals"
        override val propertyTimeline: String = "Immobilie timeline"
        override val timelineBasisNote: String = "Die Zeitleiste basiert nur auf verknüpften Besichtigungsregistrierungen und Follow-ups."
        override val visitorsLowercase: String = "Besucher"
        override val hotLeadsLowercase: String = "heiße Leads"
        override val hotLowercase: String = "heiß"
        override val sentiment: String = "Sentiment"
        override val toursLowercase: String = "tours"
        override val interestedLowercase: String = "interested"
        override val noRepeatedFeedbackMentions: String = "Keine repeated feedback mentions have been recorded noch nicht."
        override val scoresMentionRates: String = "Scores are mention rates across speichernd buyer feedback."
        override val aiExecutiveBriefing: String = "AI executive briefing"
        override val viewAllAiInsights: String = "Anzeigen all AI insights ->"
        override val followUpsSentTitle: String = "Follow-Ups Sent"
        override val financingPacketsShared: String = "Financing Packets Shared"
        override val buyerCalls: String = "Käuferanrufe"
        override val propertyDataEvidence: String = "Immobilie data evidence"
        override val attendanceCoverage: String = "Besuchsabdeckung"
        override val leadQuality: String = "Lead-Qualität"
        override val followUpExecution: String = "Follow-up execution"
        override val activityChannels: String = "Aktivitätskanäle"
        override val callsLowercase: String = "Anrufe"
        override val emailsLowercase: String = "E-Mails"
        override val offerReadinessScore: String = "Offer readiness score"
        override val date: String = "Datum"
        override val propertyLeadFunnel: String = "Immobilie Lead funnel"
        override val openHouseBreakdown: String = "Open house breakdown"
        override val aiInsights: String = "AI-Erkenntnisse"
        override val generateAiInsights: String = "AI-Erkenntnisse erzeugen"
        override val analyticsOverview: String = "Analysen overanzeigen"
        override val allAgents: String = "All agents"
        override val me: String = "Ich"
        override val allActivity: String = "All activity"
        override val latest30Days: String = "Latest 30 Tage"
        override val latest7Days: String = "Latest 7 Tage"
        override val analyticsDatePreset: String = "Zeitraum"
        override val analyticsCustomDate: String = "Custom date"
        override val analyticsLastDay: String = "Letzter Tag"
        override val analyticsLastWeek: String = "Letzte Woche"
        override val analyticsLastMonth: String = "Letzter Monat"
        override val analyticsLastYear: String = "Letztes Jahr"
        override val analyticsAllTime: String = "Gesamt"
        override val analyticsDateFrom: String = "Datum from"
        override val analyticsDateTo: String = "Datum to"
        override val analyticsOpenHousesLowercase: String = "Besichtigungen"
        override val analyticsWarmLeadsLowercase: String = "warme Leads"
        override val analyticsFromNotesFollowUps: String = ""
        override val analyticsFromText: String = "aus Text"
        override val analyticsHotConversion: String = "Konversion heißer Leads"
        override val analyticsHotLeadsPerVisitors: String = "heiße Leads / Besucher"
        override val analyticsAverageIntent: String = "Avg. intent"
        override val analyticsVisitorIntentScore: String = "visitor intent score"
        override val analyticsSelectDate: String = "Auswählen date"
        override val propertyFunnel: String = "Immobilie funnel"
        override val propertyFunnelSubtitle: String = "From Immobilie activity to qualified buyer momentum"
        override val properties: String = "Immobilien"
        override val tourSignals: String = "Besichtigungssignale"
        override val offerSignals: String = "Angebotssignale"
        override val viewFullFunnelReport: String = "Anzeigen full funnel Bericht"
        override val performanceOverTime: String = "Leistung über Zeit"
        override val thirtyDays: String = "30 Tage"
        override val topPerformingProperties: String = "Beste Immobilien"
        override val viewAll: String = "Anzeigen all"
        override val noPropertyAnalyticsYet: String = "Keine Immobilie Analysen noch nicht."
        override val leadQualityBreakdown: String = "Aufschlüsselung der Lead-Qualität"
        override val warmLeadsTitle: String = "Warme Leads"
        override val coldLeadsTitle: String = "Kalte Leads"
        override val followUpPerformance: String = "Follow-up performance"
        override val agentPerformance: String = "Agent performance"
        override val viewTeamReport: String = "Teambericht anzeigen"
        override val followUpChannels: String = "Follow-up-Kanäle"
        override val viewReport: String = "Anzeigen Bericht"
        override val searchProperties: String = "Immobilien suchen"
        override val searchOpenings: String = "Besichtigungen suchen"
        override val noOpeningsFoundTitle: String = "Keine Besichtigungen found"
        override val noOpeningsFoundBody: String = "Versuchen Sie eine andere Suche oder einen anderen Besichtigungsstatusfilter."
        override val noMatchingPropertiesTitle: String = "Keine passenden Immobilien"
        override val noMatchingPropertiesBody: String = "Versuchen Sie eine andere Suche oder einen anderen Statusfilter."
        override val clientsTitle: String = "Kontakte"
        override val clientFallback: String = "Kontakt"
        override val addClient: String = "Kontakt hinzufügen"
        override val editClient: String = "Kontakt bearbeiten"
        override val newClient: String = "Neuer Kontakt"
        override val saveClient: String = "Kontakt speichern"
        override val createClient: String = "Kontakt erstellen"
        override val deleteClientTitle: String = "Löschen Kontakt?"
        override val deleteClientBody: String = "This will permanently löschen the Kontakt. Diese Aktion kann nicht rückgängig gemacht werden."
        override val firstName: String = "Vorname"
        override val lastName: String = "Nachname"
        override val email: String = "E-Mail"
        override val phone: String = "Telefon"
        override val comments: String = "Kommentare"
        override val addPhoto: String = "Foto hinzufügen"
        override val sendQr: String = "QR senden"
        override val sendQrShareTitle: String = "Ihr HAVN-QR für die Besichtigung"
        override val sendQrShareBody: String = "Ihr HAVN-QR für die Besichtigung ist angehängt. Fügen Sie den Wallet Pass (.pkpass) zum Telefon hinzu, sobald er verfügbar ist, oder zeigen Sie das QR-Bild bei der Besichtigung vor."
        override val sendQrReadyMessage: String = "QR-Code ist zum Senden bereit"
        override val sendQrUnavailableError: String = "Für diesen Kontakt ist keine E-Mail- oder SMS-App verfügbar."
        override val clientQrDeliveryRequired: String = "Fügen Sie für die QR-Zustellung eine E-Mail-Adresse oder Telefonnummer hinzu."
        override val photo: String = "Foto"
        override val clientDetailSubtitle: String = "QR-Identität, Kontaktdaten, Kommentare und Besichtigungen, die über Leads verbunden sind."
        override val clientFormEditSubtitle: String = "Kontaktdaten, Zustellung und Kommentare aktualisieren."
        override val clientFormNewSubtitle: String = "Registrieren Sie einen Käufer/Kontakt und erstellen Sie eine wiederverwendbare QR-Identität für Besichtigungen."
        override val searchClients: String = "Kontakte suchen"
        override val noClientsYetTitle: String = "Noch keine Kontakte"
        override val noClientsYetBody: String = "Registrieren Sie zuerst Kontakte und senden Sie ihnen vor der Besichtigung den QR-Code per E-Mail oder SMS."
        override val noClientsFoundTitle: String = "Keine Kontakte gefunden"
        override val noClientsFoundBody: String = "Versuchen Sie einen anderen Namen, eine Telefonnummer oder E-Mail."
        override val clientUnavailableTitle: String = "Kontakt nicht verfügbar"
        override val clientUnavailableBody: String = "Aktualisieren Sie die Kontaktliste und öffnen Sie diesen Eintrag erneut."
        override val noCommentsAdded: String = "Keine Kommentare hinzugefügt."
        override val openingsTitle: String = "Besichtigungen"
        override val clientOpeningsEmpty: String = "Noch keine Besichtigungen verknüpft. Leads verbinden einen Kontakt mit einer Besichtigung."
        override val clientPassLabel: String = "Wallet Pass"
        override val clientNoEmail: String = "Keine E-Mail"
        override val visitorsBody: String = "Öffnen Sie den Kiosk, scannen Sie einen Kontakt-QR oder fügen Sie bestehende Kontakte als Leads für diese Besichtigung hinzu."
        override val openKiosk: String = "Kiosk öffnen"
        override val addQrClient: String = "QR-Kontakt"
        override val addManually: String = "Manuell"
        override val selectClients: String = "Kontakte auswählen"
        override val selectClientsBody: String = "Wählen Sie Kontakte aus Ihrer Liste. Jeder ausgewählte Kontakt wird zu einem Lead für diese Besichtigung."
        override val kioskCheckIn: String = "Kiosk-Check-in"
        override val kioskCheckInBody: String = "Scannen Sie mit der Rückkamera den HAVN Wallet QR des Kontakts. Sobald der Code erkannt wird, erstellt HAVN automatisch den Lead für diese Besichtigung."
        override val scanWithCamera: String = "Mit Rückkamera scannen"
        override val clientQrImage: String = "QR-Bild des Kontakts"
        override val clientQrImageBody: String = "Halten Sie den QR des Kontakts im goldenen Quadrat. HAVN sammelt jeden Scan unten."
        override val scanMultipleQrBody: String = "Scannen Sie einen oder mehrere HAVN Kontakt-QR-Codes und tippen Sie dann auf QR-Kontakt hinzufügen."
        override val scannedQrReady: String = "Kontakt-QR bereit zum Hinzufügen"
        override val createLeadFromQr: String = "Lead aus QR erstellen"
        override val noClientsFoundShort: String = "Keine Kontakte gefunden."
        override val remove: String = "Entfernen"
        override val tasksTitle: String = "Aufgaben"
        override val addTask: String = "Add Aufgabe"
        override val searchTasks: String = "Suchen Aufgaben"
        override val loadMoreTasks: String = "Load more Aufgaben"
        override val createTask: String = "Erstellen Aufgabe"
        override val saveTask: String = "Speichern Aufgabe"
        override val editTask: String = "Bearbeiten Aufgabe"
        override val newTask: String = "New Aufgabe"
        override val taskDetails: String = "Aufgabe Details"
        override val taskName: String = "Name"
        override val taskDescription: String = "Beschreibung"
        override val taskDueDateTime: String = "Aufgabe date & time"
        override val chooseTaskDateTime: String = "Wählen Aufgabe date & time"
        override val clearTaskDateTime: String = "Clear date & time"
        override val assignToAgent: String = "Agent zuweisen"
        override val noAgencyAgentsFound: String = "Keine Agentur agents found. The Aufgabe will stay assigned to the Eigentümer."
        override val taskPriority: String = "Aufgabe Priorität"
        override val taskStatus: String = "Status"
        override val taskVisibility: String = "Sichtbarkeit"
        override val taskOwner: String = "Eigentümer"
        override val taskOwnerFallback: String = "Aufgabe Eigentümer"
        override val assignedTo: String = "Assigned to"
        override val selectedAgent: String = "Ausgewählt agent"
        override val taskVisibilityBody: String = "This Aufgabe is visible to the Eigentümer and the assigned agent."
        override val taskQueue: String = "Aufgabe queue"
        override val taskDetail: String = "Aufgabe detail"
        override val taskDetailEmpty: String = "Auswählen a Aufgabe to see context and next actions."
        override val connectedContext: String = "Verknüpfter Kontext"
        override val noTaskContext: String = "Keine Immobilie, Kontakt, Besichtigung, or Lead is linked noch nicht."
        override val activityTimeline: String = "Aktivitätsverlauf"
        override val created: String = "Erstellend"
        override val recently: String = "Kürzlichly"
        override val completed: String = "Erledigt"
        override val nextAction: String = "Next action"
        override val agentReviewOrCompletion: String = "Agent reanzeigen or completion"
        override val noDueDate: String = "Keine due date"
        override val reopen: String = "Wieder öffnen"
        override val accept: String = "Annehmen"
        override val linkedTasks: String = "Verknüpft Aufgaben"
        override val noLinkedTasks: String = "Keine linked Aufgaben noch nicht."
        override val filesTitle: String = "Datumien"
        override val attachFile: String = "Attach Datumi"
        override val noFilesAttached: String = "Keine Datumien attached noch nicht."
        override val fileLimitHint: String = "Datumien can be PDF, DOC, CAD, or other formats up to 20 MB each."
        override val deleteFileTitle: String = "Löschen Datumi?"
        override val deleteFileBody: String = "This Datumi will be removed from HAVN storage."
        override val attachmentOpenFailed: String = "Diese Datei konnte nicht geöffnet werden."
        override val attachmentDeleteOwnerOnly: String = "Only the Datumi Eigentümer can löschen this attachment."
        override val attachmentDocumentsNotIncluded: String = "Dein aktueller Tarif enthaelt keine Datei-Uploads. Upgrade deinen Tarif, um Dateien hochzuladen."
        override val attachmentDocumentStorageNotIncluded: String = "Dein aktueller Tarif enthaelt keinen Dokumentenspeicher. Upgrade deinen Tarif, um Dateien hochzuladen."
        override val attachmentFileSizePlanLimit: String = "Diese Datei ist groesser, als dein aktueller Tarif erlaubt. Upgrade deinen Tarif, um groessere Dateien hochzuladen."
        override val attachmentStoragePlanLimit: String = "Das Speicherlimit deines aktuellen Tarifs ist erreicht. Upgrade deinen Tarif, um weitere Dateien hochzuladen."
        override val attachmentDocumentCountPlanLimit: String = "Das Dokumentenlimit fuer dieses Objekt in deinem aktuellen Tarif ist erreicht. Upgrade deinen Tarif, um weitere Dateien hochzuladen."
        override val attachmentHardFileLimit: String = "Dateianhaenge sind auf 100 MB begrenzt."
        override val openFiles: String = "Dateien öffnen"
        override val sendViaEmail: String = "Per E-Mail senden"
        override val sendViaSms: String = "Per SMS senden"
        override val sendEmailHeader: String = "E-Mail senden"
        override val sendSmsHeader: String = "SMS senden"
        override val noContactsFound: String = "Keine Kontakte found."
        override val searchContacts: String = "Suchen Kontakte"
        override val linked: String = "Verknüpft"
        override val recent: String = "Kürzlich"
        override val taskColumnToDo: String = "To Do"
        override val taskColumnInProgress: String = "In Progress"
        override val taskColumnDone: String = "Fertig"
        override val taskColumnToDoSubtitle: String = "New Aufgaben and next actions waiting to be started."
        override val taskColumnInProgressSubtitle: String = "Work currently owned von you or the team."
        override val taskColumnDoneSubtitle: String = "Erledigt Aufgaben kept visible for team confidence."
        override val taskEmptyToDo: String = "Keine Aufgaben to do."
        override val taskEmptyInProgress: String = "Nothing in progress."
        override val taskEmptyDone: String = "Keine completed Aufgaben noch nicht."
        override val taskKanbanEmptyToDo: String = "Nothing waiting. New Follow-ups and Bericht work will appear here."
        override val taskKanbanEmptyInProgress: String = "Keine aktiv work in progress."
        override val taskKanbanEmptyDone: String = "Erledigt Aufgaben will land here."
        override val taskEmptyBodyPrefix: String = "Erstellen a Aufgabe or move another Aufgabe into"
        override val taskEmptyBodySuffix: String = "."
        override val taskActionStart: String = "Start"
        override val taskActionOverdue: String = "Überfällig"
        override val taskActionCancel: String = "Abbrechen"
        override val taskPriorityLow: String = "Low"
        override val taskPriorityMedium: String = "Ichdium"
        override val taskPriorityHigh: String = "High"
        override val taskPriorityUrgent: String = "Urgent"
        override val taskStatusOpen: String = "Open"
        override val taskStatusInProgress: String = "In progress"
        override val taskStatusDone: String = "Fertig"
        override val taskStatusOverdue: String = "Überfällig"
        override val taskStatusCancelled: String = "Abgebrochen"
        override val aiSuggestedTasks: String = "AI-Aufgabenvorschläge"
        override val noAiSuggestedTasks: String = "Keine AI suggestions noch nicht. HAVN will suggest Aufgaben nach Besichtigungen and Lead activity."
        override val taskFilterToday: String = "Heute"
        override val taskFilterUpcoming: String = "Anstehend"
        override val taskFilterOverdue: String = "Überfällig"
        override val taskFilterCompleted: String = "Erledigt"
        override val taskFilterAssignedToMe: String = "Assigned to Ich"
        override val taskFilterAiSuggested: String = "AI-Vorschläge"
        override val taskFilterEmptyToday: String = "You're clear for heute."
        override val taskFilterEmptyUpcoming: String = "Keine upcoming Aufgaben."
        override val taskFilterEmptyOverdue: String = "Keine overdue Aufgaben."
        override val taskFilterEmptyCompleted: String = "Keine completed Aufgaben noch nicht."
        override val taskFilterEmptyAssignedToMe: String = "Keine Aufgaben assigned to you."
        override val taskFilterEmptyAiSuggested: String = "Keine accepted AI suggested Aufgaben noch nicht."
        override val taskSuggestionHotLeadTitlePrefix: String = "Nachfassen bei"
        override val taskSuggestionHotLeadTitleSuffix: String = "within 2 hours."
        override val taskSuggestionHotLeadDescriptionPrefix: String = "Hot Lead from"
        override val taskSuggestionHotLeadDescriptionSuffix: String = "Keep momentum while intent is fresh."
        override val taskSuggestionHotLeadReason: String = "New hot Lead captured."
        override val taskSuggestionSellerReportTitlePrefix: String = "Generate Verkäuferbericht for"
        override val taskSuggestionSellerReportTitleSuffix: String = "."
        override val taskSuggestionSellerReportDescription: String = "Fassen Sie Besucherzahl, heiße Leads, Follow-up-Aktivität und Käuferstimmung zusammen."
        override val taskSuggestionSellerReportReason: String = "Open house ended."
        override val taskSuggestionReviewFollowUpTitlePrefix: String = "Reanzeigen and senden"
        override val taskSuggestionReviewFollowUpTitleSuffix: String = "Follow-up."
        override val taskSuggestionReviewFollowUpReason: String = "Follow-up draft still needs agent reanzeigen."
        override val taskSuggestionKioskTitle: String = "Kioskmodus vorbereiten und Immobilienfotos prüfen."
        override val taskSuggestionKioskDescription: String = "Confirm sign-in flow, gallery, and Besichtigung details vor buyers arrive."
        override val taskSuggestionKioskReason: String = "Open house is scheduled."
    }

    private val french: HavnStrings = object : HavnStrings {
        override val navToday: String = "Aujourd'hui"
        override val navProperties: String = "Biens"
        override val navLeads: String = "Prospects"
        override val navReports: String = "Rapports"
        override val navTasks: String = "Tâches"
        override val navAnalytics: String = "Analytique"
        override val navAgency: String = "Agence"
        override val navSettings: String = "Reglages"
        override val navAuth: String = "Acces agent"
        override val navOpenHouses: String = "Visites"
        override val navTours: String = "Visites"
        override val navFollowUps: String = "Contacts"
        override val navFollow: String = "Contacts"
        override val back: String = "Retour"
        override val settingsEyebrow: String = "Espace de travail"
        override val settingsTitle: String = "Reglages"
        override val settingsSubtitle: String = "Profil, langue, unites, environnement et options d'equipe."
        override val agentProfileTitle: String = "Profil agent"
        override val agentPhoto: String = "Photo de l’agent"
        override val uploading: String = "Importation..."
        override val saving: String = "Enregistrement..."
        override val validAgentPhotoRequired: String = "Choisissez une photo d’agent valide."
        override val signOut: String = "Se déconnecter"
        override val signOutQuestion: String = "Se déconnecter ?"
        override val signOutConfirmation: String = "Voulez-vous vraiment vous déconnecter de HAVN ?"
        override val deleteAccount: String = "Supprimer le compte"
        override val deleteAccountQuestion: String = "Supprimer le compte ?"
        override val deleteAccountOpenPageBody: String = "La page de demande de suppression de compte va s’ouvrir."
        override val deleteAccountReviewTitle: String = "Utilisez un vrai compte"
        override val deleteAccountReviewBody: String = "Ce compte d’app review est protégé afin que les reviewers ne perdent pas l’accès pendant les tests. Veuillez utiliser un vrai compte de test pour vérifier la suppression du compte."
        override val upgrade: String = "Mettre à niveau"
        override val premiumThemesTitle: String = "Thèmes premium"
        override val premiumThemesUpgradePrompt: String = "Passez à Pro pour débloquer les thèmes premium."
        override val appearanceTitle: String = "Apparence"
        override val appearanceBody: String = "Choisissez le mode clair ou sombre pour l’application web."
        override val previewComponents: String = "Aperçu des composants"
        override val themeShowcaseTitle: String = "Aperçu du thème"
        override val showcaseButtons: String = "Boutons"
        override val showcasePrimaryAction: String = "Action principale"
        override val showcaseSecondaryAction: String = "Action secondaire"
        override val showcaseGhostAction: String = "Action discrète"
        override val showcaseTextField: String = "Champ texte"
        override val showcaseFocusedBorder: String = "Bordure d’accent active"
        override val showcaseSearchPreview: String = "Aperçu de recherche"
        override val showcaseOpeningCheckedIn: String = "Inscription à une ouverture aujourd’hui"
        override val showcaseSentAt: String = "Envoyé à 10:30"
        override val themeObsidianGoldName: String = "Obsidian Gold"
        override val themeObsidianGoldDescription: String = "Noir luxueux, graphite et or chaud."
        override val themeMidnightSapphireName: String = "Midnight Sapphire"
        override val themeMidnightSapphireDescription: String = "Bleu nuit, saphir et accents argentés."
        override val themeEmeraldEstateName: String = "Emerald Estate"
        override val themeEmeraldEstateDescription: String = "Émeraude foncé, charbon et or champagne."
        override val themePlatinumStoneName: String = "Platinum Stone"
        override val themePlatinumStoneDescription: String = "Gris pierre, platine et blanc doux."
        override val themeBordeauxNoirName: String = "Bordeaux Noir"
        override val themeBordeauxNoirDescription: String = "Rouge vin foncé, graphite et accents cuivre."
        override val commonChange: String = "Changer"
        override val agentPlanTitle: String = "Plan agent"
        override val agentPlanBody: String = "Améliorez votre expérience et choisissez le plan adapté à votre façon de travailler."
        override val currentPlan: String = "Plan actuel"
        override val transferPlan: String = "Transférer le plan"
        override val transferPlanTitle: String = "Transférer le plan"
        override val transferPlanBody: String = "Déplacez cet abonnement vers un autre compte HAVN. Les deux adresses e-mail doivent confirmer avec des codes de vérification."
        override val transferTargetEmail: String = "E-mail du nouveau compte"
        override val transferSendCodes: String = "Envoyer les codes"
        override val transferCodesSentTitle: String = "Codes envoyés"
        override val transferCodesSentBody: String = "Nous avons envoyé un code à votre e-mail et un autre à l’e-mail du nouveau compte."
        override val transferYourCode: String = "Code de votre e-mail"
        override val transferTargetCode: String = "Code du nouveau compte"
        override val transferConfirm: String = "Transférer le plan"
        override val transferSuccessTitle: String = "Plan transféré"
        override val transferSuccessBody: String = "L’abonnement est maintenant connecté au nouveau compte HAVN."
        override val restorePurchase: String = "Restaurer l’achat"
        override val agencySettingsProBody: String = "Solo agency est active par défaut. Pro permet de créer ou choisir une agence partagée."
        override val agencySettingsLockedBody: String = "Solo agency est active. Les changements d’agence sont disponibles avec Pro."
        override val soloAgency: String = "Solo agence"
        override val defaultPrivateAgencyWorkspace: String = "Agence privée par défaut"
        override val noAgenciesAvailableYet: String = "Aucune invitation ni agence détenue n’est encore disponible."
        override val oneOwnedAgencyHint: String = "Votre agence détenue apparaît ci-dessus. Un agent peut posséder une seule agence."
        override val createAgency: String = "Créer une agence"
        override val createYourAgency: String = "Créez votre agence"
        override val createAgencyBody: String = "Développez votre équipe, gérez les biens ensemble et faites grandir votre activité."
        override val agencyName: String = "Nom de l’agence"
        override val agencyEmail: String = "E-mail de l’agence"
        override val logoOptional: String = "Logo (facultatif)"
        override val upgradeExperienceTitle: String = "Améliorez votre expérience"
        override val upgradeExperienceSubtitle: String = "Choisissez le plan adapté à votre façon de travailler."
        override val soloAgentPlan: String = "Solo agent"
        override val proAgentPlan: String = "Pro agent"
        override val teamAgentPlan: String = "Équipe"
        override val soloBenefitActiveProperties: String = "Jusqu’à 1 000 biens"
        override val soloBenefitAiFollowUps: String = "1 000 requêtes de texte AI / mois"
        override val soloBenefitSellerReports: String = "Aucun rapport vendeur"
        override val soloBenefitPersonalOnly: String = "Compte personnel uniquement"
        override val proBenefitUnlimitedProperties: String = "Jusqu’à 10 000 biens"
        override val proBenefitUnlimitedAi: String = "10 000 requêtes de texte AI / mois"
        override val proBenefitAdvancedReports: String = "Rapports vendeurs avancés"
        override val proBenefitAgencyCreation: String = "Création et gestion d’agence"
        override val proBenefitInviteAgents: String = "Inviter des agents et collaborer"
        override val proBenefitSharedLeads: String = "Leads partagés et workflows d’équipe"
        override val proBenefitAgencyBranding: String = "Branding d’agence"
        override val proBenefitAdvancedAnalytics: String = "Analytique avancée"
        override val teamBenefitLargeLimits: String = "Limites pour les équipes"
        override val teamBenefitPrioritySupport: String = "Support e-mail prioritaire"
        override val teamBenefitDailyBackups: String = "Sauvegardes quotidiennes pendant 7 jours"
        override val teamBenefitLargeStorage: String = "10 Go de stockage de documents"
        override val startFreeTrial7Day: String = "S’abonner maintenant"
        override val restorePurchases: String = "Restaurer l’achat"
        override val comparePlans: String = "Comparer les plans"
        override val startFreeTrial: String = "Choisir un plan"
        override val noCommitmentCancelAnytime: String = "Sans engagement. Annulation à tout moment."
        override val monthly: String = "Mensuel"
        override val yearly: String = "Annuel"
        override val yearlySave20: String = "Annuel"
        override val yearlySavings20: String = "Facturé annuellement."
        override val perYear: String = "/ an"
        override val loadingPlans: String = "Chargement des offres..."
        override val selectedPlanUnavailable: String = "Cette offre n’est pas encore disponible. Réessayez plus tard ou contactez le support."
        override val signInRequiredForPurchase: String = "Connectez-vous avant l’achat."
        override val subscriptionDisclosureIos: String = "Abonnement à renouvellement automatique. Le paiement sera débité de votre compte Apple à la confirmation de l’achat. Votre abonnement se renouvelle automatiquement sauf annulation au moins 24 heures avant la fin de la période en cours. Le renouvellement sera facturé dans les 24 heures précédant la fin de la période en cours. Vous pouvez gérer ou annuler votre abonnement dans les réglages de votre compte App Store."
        override val subscriptionDisclosureAndroid: String = "Abonnement à renouvellement automatique via Google Play. Vous serez facturé à chaque période de facturation sauf annulation. Vous pouvez gérer ou annuler votre abonnement à tout moment dans les abonnements Google Play. L’accès continue jusqu’à la fin de la période payée."
        override val subscriptionDisclosureWeb: String = "Abonnement à renouvellement automatique. Vous serez facturé à chaque période de facturation avec le moyen de paiement sélectionné sauf annulation. Vous pouvez gérer ou annuler à tout moment depuis les paramètres de facturation. L’accès continue jusqu’à la fin de la période payée. Des taxes peuvent s’appliquer."
        override val subscriptionAgreementPrefix: String = "En vous abonnant, vous acceptez les"
        override val subscriptionTermsOfUse: String = "Conditions d’utilisation de HAVN"
        override val subscriptionAgreementAnd: String = "et la"
        override val subscriptionPrivacyPolicy: String = "Politique de confidentialité."
        override val purchaseSuccessTitle: String = "Merci pour votre achat"
        override val purchaseSuccessBody: String = "Votre abonnement HAVN est actif et votre offre est prête."
        override val restoreSuccessTitle: String = "Restaurer l’achat"
        override val restoreSuccessBody: String = "Votre abonnement HAVN a été restauré avec succès."
        override val purchaseCouldNotComplete: String = "L’achat n’a pas pu être finalisé. Réessayez ou vérifiez votre compte App Store ou Google Play."
        override val purchaseVerificationPending: String = "Votre paiement n’a pas encore été confirmé. Si vous avez terminé le paiement, utilisez « Restaurer l’achat » pour vérifier à nouveau. Vous n’avez pas besoin de payer une seconde fois."
        override val completeWebCheckout: String = "Terminez le paiement dans l’onglet de paiement, puis revenez ici. Votre accès sera mis à jour automatiquement dès la confirmation du paiement."
        override val restoreCouldNotComplete: String = "Aucun abonnement HAVN actif n’a été trouvé pour ce compte de boutique."
        override val noActiveSubscriptionFound: String = "Aucun abonnement HAVN actif n’a été trouvé pour ce compte de boutique."
        override val compareActiveProperties: String = "Biens actifs"
        override val compareAiFollowUps: String = "Relances AI"
        override val compareSellerReports: String = "Rapports vendeurs"
        override val compareAdvancedAnalytics: String = "Analytique avancée"
        override val compareAgencyCreation: String = "Création d’agence"
        override val compareJoinAgencies: String = "Rejoindre des agences"
        override val compareInviteAgents: String = "Inviter des agents"
        override val compareSharedLeads: String = "Leads partagés"
        override val compareAgencyBranding: String = "Branding d’agence"
        override val comparePrioritySupport: String = "Support prioritaire"
        override val compareFeature: String = "Fonctionnalité"
        override val compareFreePlan: String = "Gratuit"
        override val compareValueYes: String = "Oui"
        override val compareValueNo: String = "Non"
        override val comparePricePerMonthUser: String = "Prix / mois / utilisateur"
        override val comparePricePerYearUser: String = "Prix / an / utilisateur"
        override val compareMaxPropertiesOwner: String = "Biens max. / propriétaire"
        override val compareMaxContactsOwner: String = "Contacts max. / propriétaire"
        override val compareMaxOpenHousesOwner: String = "Visites max. / propriétaire"
        override val compareMaxLeadsOwner: String = "Leads max. / propriétaire"
        override val compareMaxPhotosProperty: String = "Photos max. par bien"
        override val compareMaxDocumentsProperty: String = "Documents max. par bien"
        override val compareDocumentsStorage: String = "Stockage des documents"
        override val compareAgencyAgenda: String = "Agenda d’agence"
        override val compareAiTextRequestsMonth: String = "Requêtes de texte AI / mois"
        override val compareAnalytics: String = "Analytique"
        override val compareTasks: String = "Tâches"
        override val compareDocumentsStorageOwner: String = "Stockage des documents / propriétaire"
        override val compareMaxFileSizeOwner: String = "Taille max. de fichier / propriétaire"
        override val compareEmailSupport: String = "Support par e-mail"
        override val compareDailyBackups7Days: String = "Sauvegardes quotidiennes conservées 7 jours"
        override val compareKioskMode: String = "Mode kiosque"
        override val unlimited: String = "Illimité"
        override val basic: String = "Basique"
        override val advanced: String = "Avancé"
        override val perMonth: String = "/ mois"
        override val members: String = "membres"
        override val upgradeToProForAgencyTools: String = "Passez à Pro pour utiliser les outils d’agence"
        override val languageTitle: String = "Langue"
        override val languageBody: String = "Choisissez la langue de l'application pour cet appareil."
        override val english: String = "English"
        override val slovak: String = "Slovak"
        override val unitsTitle: String = "Unites et devise"
        override val unitsBody: String = "Choisissez l'affichage des prix et surfaces dans l'application."
        override val measurementSystemTitle: String = "Mesure"
        override val metric: String = "Metrique"
        override val imperial: String = "Imperial"
        override val currencyTitle: String = "Devise"
        override val notificationsTitle: String = "Notifications"
        override val notificationsBody: String = "Control push alerts, quiet hours, and the types of updates HAVN can envoyer."
        override val notificationSettings: String = "Paramètres des notifications"
        override val notificationsSubtitle: String = "Only important updates, filtered par your preferences."
        override val quietHoursTitle: String = "Heures calmes"
        override val quietHoursBody: String = "HAVN skips non-critical pushes during quiet hours. Billing and account issues still stay concise."
        override val enableQuietHours: String = "Activer les heures calmes"
        override val quietHoursStart: String = "Début"
        override val quietHoursEnd: String = "Fin"
        override val timezoneLabel: String = "Fuseau horaire"
        override val notificationTypesTitle: String = "Types de notifications"
        override val notificationNewLeadCapturedTitle: String = "Nouveau lead capturé"
        override val notificationNewLeadCapturedBody: String = "When an visite libre or QR flow captures a lead."
        override val notificationHotLeadTitle: String = "Lead marqué chaud"
        override val notificationHotLeadBody: String = "Uniquement lorsqu’un lead montre une forte intention."
        override val notificationOpeningStartsSoonTitle: String = "Visite libre starts soon"
        override val notificationOpeningStartsSoonBody: String = "A single reminder 30 minutes avant start."
        override val notificationOpeningSummaryReadyTitle: String = "Visite libre summary ready"
        override val notificationOpeningSummaryReadyBody: String = "Quand le résumé après visite est prêt."
        override val notificationSellerReportGeneratedTitle: String = "Seller rapport generated"
        override val notificationSellerReportGeneratedBody: String = "When a rapport vendeur has been créerd."
        override val notificationAiFollowUpReadyTitle: String = "AI relance ready"
        override val notificationAiFollowUpReadyBody: String = "When a relance draft is ready to revoir."
        override val notificationAgentInvitedTitle: String = "Agent inviterd to agence"
        override val notificationAgentInvitedBody: String = "Agence invitations and membreship changes."
        override val notificationLeadAssignedTitle: String = "Lead attribué à vous"
        override val notificationLeadAssignedBody: String = "Quand un collègue vous attribue un lead."
        override val notificationLeadTransferredTitle: String = "Lead transféré à vous"
        override val notificationLeadTransferredBody: String = "When propriétaireship of a lead moves to you."
        override val notificationSubscriptionIssueTitle: String = "Problème d’abonnement"
        override val notificationSubscriptionIssueBody: String = "Échecs de renouvellement et problèmes de paiement."
        override val kioskSecurityTitle: String = "Sécurité du kiosque"
        override val kioskSecurityBody: String = "Utilisez ce PIN pour quitter le mode kiosque et revenir à l’app agent."
        override val kioskPinLabel: String = "PIN kiosque"
        override val mcpAccessTitle: String = "Accès MCP"
        override val mcpAccessBody: String = "Connectez HAVN à Claude, OpenAI et d’autres clients MCP sur mcp.havnre.app. Disponible avec chaque offre."
        override val mcpAuthorizationBearer: String = "Autorisation : Bearer"
        override val mcpNoApiKeyCreated: String = "Aucune clé API créée"
        override val mcpNotUsedYet: String = "Pas encore utilisée"
        override val mcpLastUsedPrefix: String = "Dernière utilisation"
        override val mcpRevealApiKeyTitle: String = "Afficher la clé API"
        override val mcpRevealApiKeyBody: String = "La clé complète s’affiche uniquement après sa création ou sa rotation."
        override val mcpCreateKey: String = "Créer une clé"
        override val mcpRotateKey: String = "Renouveler la clé"
        override val mcpRevokeKey: String = "Révoquer la clé"
        override val mcpEndpointHint: String = "Utilisez l’endpoint https://mcp.havnre.app/mcp avec cette clé comme token Bearer."
        override val mcpUpgradeHint: String = "L’accès MCP est disponible avec chaque offre HAVN."
        override val mcpUpgradePrompt: String = "L’accès MCP est disponible avec chaque offre HAVN."
        override val mcpCopied: String = "Copié"
        override val mcpCopy: String = "Copier"
        override val mcpLoading: String = "Chargement"
        override val kioskFeaturedProperty: String = "Featured bien"
        override val kioskPrivateShowing: String = "Visite privée"
        override val kioskLuxuryListing: String = "Bien de luxe"
        override val kioskFastCheckIn: String = "Check-in rapide"
        override val kioskExitContentDescription: String = "Quitter le kiosque"
        override val kioskWelcome: String = "Bienvenue"
        override val kioskGladHere: String = "Nous sommes ravis de vous accueillir."
        override val kioskScanToCheckIn: String = "Scanner pour s’inscrire"
        override val kioskReceivePropertyDetails: String = "and receive bien details"
        override val kioskOr: String = "Ou"
        override val kioskStartCheckInManually: String = "S’inscrire manuellement"
        override val kioskSecureInfo: String = "Vos informations sont sécurisées et ne seront jamais partagées."
        override val kioskExitTitle: String = "Quitter le kiosque"
        override val kioskExitBody: String = "Saisissez le PIN du kiosque pour revenir à l’app agent."
        override val kioskIncorrectPin: String = "PIN incorrect."
        override val kioskUnlock: String = "Déverrouiller"
        override val kioskTellUsTitle: String = "Parlez-nous de vous"
        override val kioskTellUsBody: String = "Vos informations vont uniquement à l’agent hôte."
        override val kioskFullName: String = "Nom complet"
        override val kioskContinue: String = "Continuer"
        override val kioskQuestionsTitle: String = "Quelques questions rapides"
        override val kioskQuestionsBody: String = "Cela aide l’agent à faire un suivi avec le bon contexte."
        override val kioskWorkingWithAgentQuestion: String = "Travaillez-vous avec un agent ?"
        override val kioskYes: String = "Oui"
        override val kioskNo: String = "Non"
        override val kioskInterestQuestion: String = "Qu’est-ce qui vous intéresse ?"
        override val kioskInterestBuying: String = "Acheter"
        override val kioskInterestInvesting: String = "Investir"
        override val kioskInterestBrowsing: String = "Simple visite"
        override val kioskInterestRelocating: String = "Déménager"
        override val kioskFinish: String = "Terminer"
        override val kioskThankYou: String = "Merci"
        override val kioskEnjoyVisitPrefix: String = "Bonne visite à"
        override val kioskResetAutomatically: String = "Ce kiosque se réinitialisera automatiquement."
        override val environmentTitle: String = "Environnement"
        override val environmentBody: String = "La connexion est configurée pour ce build."
        override val secure: String = "Sécurisé"
        override val brokerageProfileTitle: String = "Brokerage profichier"
        override val brokerageProfileBody: String = "Team branding, agent inviters, and notification preferences will live here."
        override val logout: String = "Se deconnecter"
        override val languageChanged: String = "Langue modifiée"
        override val commonAdd: String = "Ajouter"
        override val commonEdit: String = "Modifier"
        override val commonDelete: String = "Supprimer"
        override val commonCancel: String = "Annuler"
        override val commonSave: String = "Enregistrer"
        override val commonCreate: String = "Creer"
        override val commonDismiss: String = "Fermer"
        override val commonAll: String = "Tout"
        override val commonDone: String = "Terminé"
        override val commonSend: String = "Envoyer"
        override val commonTime: String = "Heure"
        override val commonHour: String = "Heure"
        override val commonMinute: String = "Minute"
        override val commonAgency: String = "Agence"
        override val commonSettings: String = "Réglages"
        override val commonOpening: String = "Ouverture"
        override val commonPropertyName: String = "Bien"
        override val commonToday: String = "Aujourd’hui"
        override val agencyToolsAvailable: String = "Les outils d’agence sont disponibles."
        override val agencySetupSubtitle: String = "Chaque compte HAVN dispose d’une agence par défaut. Pro permet de gérer les invitations, les leads partagés et la marque."
        override val agencyRecentActivity: String = "Récent activity"
        override val agencyActivityNewLead: String = "Nouveau lead ajouté"
        override val agencyActivityInvitationAccepted: String = "Invitation agent acceptée"
        override val agencyActivityAgentJoined: String = "Agent joined the agence"
        override val agencyActivitySellerReport: String = "Seller rapport créerd"
        override val agencyWorkspaceTitle: String = "Agence"
        override val agencyWorkspaceBody: String = "Choisir which agence you are working with."
        override val agencySoloActiveTitle: String = "Solo agence is actif"
        override val agencyProRequiredTitle: String = "Pro offre required"
        override val agencyCreateOrAcceptInviteBody: String = "Créer your agence or accept an inviter to collaborate with another agence."
        override val agencyProUnlockBody: String = "Agence changes, inviters, shared leads, and shared branding unlock with Pro."
        override val realEstate: String = "Immobilier"
        override val proAgency: String = "Pro agence"
        override val agencyBrandingTitle: String = "Agence branding"
        override val agencyBrandingBody: String = "Set the agence name and logo shown in the app, kiosk, and team voirs."
        override val uploadLogo: String = "Importer logo"
        override val saveAgency: String = "Enregistrer agence"
        override val yourAgencyRole: String = "Your agence role"
        override val agencyAgentsTitle: String = "Agence agents"
        override val agencyAgentsBody: String = "People eligible to work with this agence."
        override val inviteAgent: String = "Inviter agent"
        override val loadingAgents: String = "Chargement agents..."
        override val noAgencyAgentsYet: String = "Aucun agence agents pour le moment."
        override val changeRole: String = "Changer le rôle"
        override val updating: String = "Mise à jour..."
        override val deleting: String = "Suppression..."
        override val deleteInvite: String = "Annuler l’invitation"
        override val chooseAgencyRoleFor: String = "Choisir the agence role for"
        override val removeAccess: String = "Remove access"
        override val inviteAgentBody: String = "Envoyer an agence invitation par email. The agent accepts après signing in with the same email."
        override val agentEmail: String = "Agent email"
        override val role: String = "Role"
        override val inviting: String = "Inviting..."
        override val invite: String = "Inviter"
        override val agents: String = "Agents"
        override val ok: String = "OK"
        override val personalActivePropertyLimit: String = "Personal actif bien limit"
        override val personalAccountAgencyToolsLocked: String = "Personal account is actif. Agence tools unlock with Pro."
        override val selected: String = "Sélectionné"
        override val activeMembers: String = "actif membres"
        override val agencySharedWorkspaceBody: String = "Shared biens, contacts, visites libres, leads, relances, and rapports use this agence."
        override val actLikeAgent: String = "Agir comme agent"
        override val actAsAdmin: String = "Agir comme admin"
        override val actAsOwner: String = "Agir comme propriétaire"
        override val actLikeAgentBody: String = "Utiliser l'agence comme un agent standard."
        override val actLikeAgentSelectedBody: String = "Seul le travail assigné ou possédé est affiché."
        override val agencyRoleOwner: String = "Propriétaire"
        override val agencyRoleAdmin: String = "Admin"
        override val agencyRoleAgent: String = "Agent"
        override val agencyRoleAssistant: String = "Assistant"
        override val agencyRoleViewer: String = "Lecteur"
        override val agencyRoleOwnerDescription: String = "Contrôle complet de l’agence, y compris les membres, le branding, les affectations, les annonces, les leads et les rapports."
        override val agencyRoleAdminDescription: String = "Gestion complète de l’agence sauf suppression de l’agence."
        override val agencyRoleAgentDescription: String = "Travaille sur les annonces, visites, leads, relances, notes et rapports vendeur assignés."
        override val agencyRoleAssistantDescription: String = "Aide sur les annonces assignées en modifiant les leads, préparant les relances et rédigeant des rapports."
        override val agencyRoleViewerDescription: String = "Accès en lecture seule aux tableaux de bord et rapports."
        override val agencyCapabilityInviteRemoveMembers: String = "Inviter et supprimer des membres"
        override val agencyCapabilityChangeRoles: String = "Modifier les rôles des membres"
        override val agencyCapabilityManageAllProperties: String = "Créer, modifier et supprimer tous les biens"
        override val agencyCapabilityAssignAgents: String = "Assigner des agents"
        override val agencyCapabilitySeeAllLeads: String = "Voir tous les leads"
        override val agencyCapabilityExportReports: String = "Exporter les rapports"
        override val agencyCapabilityChangeBranding: String = "Modifier le branding et les paramètres de l’agence"
        override val agencyCapabilityDeleteAgency: String = "Supprimer l’agence"
        override val agencyCapabilityViewAssignedProperties: String = "Voir les biens assignés"
        override val agencyCapabilityHostAssignedOpenings: String = "Organiser les visites assignées"
        override val agencyCapabilitySeeAssignedLeads: String = "Voir les leads des biens et visites assignés"
        override val agencyCapabilityAddNotes: String = "Ajouter des notes"
        override val agencyCapabilitySendFollowUps: String = "Envoyer des relances"
        override val agencyCapabilityCreateSellerReports: String = "Créer des rapports vendeur pour les annonces assignées"
        override val agencyCapabilityEditAssignedLeads: String = "Modifier les leads assignés"
        override val agencyCapabilityPrepareFollowUps: String = "Préparer des relances"
        override val agencyCapabilityCreateDraftReports: String = "Créer des brouillons de rapport"
        override val agencyCapabilityCannotDeleteProperties: String = "Ne peut pas supprimer de biens"
        override val agencyCapabilityCannotInviteAgents: String = "Ne peut pas inviter d’agents sauf autorisation"
        override val agencyCapabilityViewDashboards: String = "Voir les tableaux de bord"
        override val agencyCapabilityViewReports: String = "Voir les rapports"
        override val agencyCapabilityCannotEdit: String = "Ne peut rien modifier"
        override val commonVisitors: String = "Leads"
        override val commonHot: String = "Chaud"
        override val commonWarm: String = "Tiède"
        override val commonCold: String = "Froid"
        override val commonActive: String = "Actif"
        override val commonPlanned: String = "Planifie"
        override val commonArchived: String = "Archive"
        override val commonPast: String = "Passées"
        override val commonFollowUps: String = "Relances"
        override val commonProperty: String = "Bien"
        override val commonAddress: String = "Adresse"
        override val commonOpenHouse: String = "Visite libre"
        override val commonInquiry: String = "Demande"
        override val commonInquiries: String = "Demandes"
        override val generalInquiry: String = "Demande générale"
        override val generalInquiries: String = "Demandes générales"
        override val propertyInquiry: String = "Demande pour un bien"
        override val propertyInquiries: String = "Demandes pour des biens"
        override val addGeneralInquiry: String = "Ajouter une demande générale"
        override val newGeneralInquiry: String = "Nouvelle demande générale"
        override val noGeneralInquiries: String = "Aucune demande générale pour le moment."
        override val noPropertyInquiries: String = "Aucune demande pour un bien pour le moment."
        override val buyerLookingFor: String = "Que recherche cet acheteur ?"
        override val locationCity: String = "Lieu / ville"
        override val radiusKm: String = "Rayon (km)"
        override val propertyType: String = "Type de bien"
        override val budgetFrom: String = "Budget minimum"
        override val budgetTo: String = "Budget maximum"
        override val purchaseTimeline: String = "Délai d’achat"
        override val createGeneralInquiry: String = "Créer la demande générale"
        override val saveGeneralInquiry: String = "Enregistrer la demande générale"
        override val inquiryType: String = "Type de demande"
        override val leadSource: String = "Source du lead"
        override val notSpecified: String = "Non précisé"
        override val inquiryStatus: String = "Statut de la demande"
        override val inquiryFollowUp: String = "Relance de demande"
        override val addInquiry: String = "Ajouter une demande"
        override val searchInquiries: String = "Rechercher des demandes"
        override val noInquiries: String = "Aucune demande"
        override val noInquiriesBody: String = "Utilisez le bouton plus pour ajouter l’intérêt d’un acheteur depuis un contact existant."
        override val inquiryUnavailableTitle: String = "Demande indisponible"
        override val inquiryUnavailableBody: String = "Cette demande a peut-être été supprimée ou est encore en cours de chargement."
        override val backToInquiries: String = "Retour aux demandes"
        override val deleteInquiry: String = "Supprimer la demande"
        override val deleteInquiryQuestionPrefix: String = "Supprimer"
        override val deleteInquiryQuestionSuffix: String = "de ce bien ?"
        override val deleteInquiryTargetFallback: String = "cette demande"
        override val propertyInquiriesBody: String = "Suivez les acheteurs qui ont posé une question sur ce bien. Les demandes apparaissent aussi dans les leads."
        override val propertyInquiriesEmpty: String = "Ajoutez une demande en choisissant l’un de vos contacts."
        override val contactInquiriesBody: String = "Biens pour lesquels ce contact a demandé des informations."
        override val contactInquiriesEmpty: String = "Aucune demande de bien pour le moment."
        override val viewInquiries: String = "Voir les demandes"
        override val createContactFirstForInquiry: String = "Créez d’abord un contact, puis ajoutez la demande depuis ce bien."
        override val commonCheckedIn: String = "Checked in"
        override val commonNotScheduled: String = "not scheduled"
        override val todayTitle: String = "Aujourd’hui"
        override val todaySubtitle: String = "Votre vue du jour pour visites, leads, relances et dynamique vendeur."
        override val todayOpenHousesMetric: String = "visites libres"
        override val capturedMetric: String = "captured"
        override val priorityMetric: String = "priority"
        override val noActivePropertiesTitle: String = "Aucun actif biens"
        override val noActivePropertiesBody: String = "Add or activate a bien to make it appear on Aujourd’hui."
        override val checkIns: String = "Check-ins"
        override val allOpenHouses: String = "all visites libres"
        override val pendingDrafts: String = "pending drafts"
        override val priorityLead: String = "Priorité lead"
        override val nextOpenHouseAt: String = "Next visite libre at"
        override val noOpenHouseScheduled: String = "Aucun visite libre scheduled"
        override val personalAccount: String = "Compte personnel"
        override val accountReady: String = "Votre compte est prêt"
        override val realEstateApp: String = "Application immobilière"
        override val needHelp: String = "Besoin d’aide ?"
        override val contactSupport: String = "Contacter le support"
        override val upgradePlan: String = "Mettre à niveau"
        override val planSuffix: String = "Formule"
        override val todayActionsTitle: String = "Priorités du jour"
        override val agencyInvitation: String = "Agence invitation"
        override val joinAgency: String = "Join"
        override val youWereInvitedAs: String = "You were inviterd as"
        override val invitedBy: String = "par"
        override val decline: String = "Decline"
        override val yourDefaultAgency: String = "Your default agence"
        override val chooseAgencyBody: String = "Choisir which agence you want to work with. Agence tools include inviters, shared leads, and branding."
        override val agencyMembersSuffix: String = "membres"
        override val quickActionTasksBody: String = "Queue"
        override val quickActionReportsBody: String = "Seller"
        override val quickActionAnalyticsBody: String = "Trends"
        override val quickActionAddPropertyTitle: String = "Ajouter"
        override val quickActionAddPropertyBody: String = "Bien"
        override val quickActionAddContactTitle: String = "Contact"
        override val quickActionAddContactBody: String = "Nouveau"
        override val quickActionFilesTitle: String = "Fichiers"
        override val quickActionFilesBody: String = "Docs"
        override val firstRunStepsTitle: String = "Début with four simple steps"
        override val firstRunAddProperty: String = "Add bien"
        override val firstRunScheduleOpening: String = "Schedule visite libre"
        override val firstRunStartGuestCheckIn: String = "Début guest check-in"
        override val firstRunSendFollowUp: String = "Envoyer relance"
        override val greetingNamePrefix: String = "Bonjour"
        override val greetingAgent: String = "Bonjour agent"
        override val createListing: String = "Créer listing"
        override val newOwnerBuyer: String = "New propriétaire/buyer"
        override val documents: String = "Documents"
        override val whatOpeningNext: String = "Quelle ouverture est la prochaine ?"
        override val whoCheckedIn: String = "Qui s’est enregistré ?"
        override val whoNeedsFollowUp: String = "Qui attend un suivi ?"
        override val whatShouldIDoNow: String = "Que faire maintenant ?"
        override val noCheckInsYet: String = "Aucun contact ne s’est encore enregistré."
        override val noPendingFollowUps: String = "Aucun suivi en attente pour le moment."
        override val openKioskForNextOpening: String = "Ouvrez le kiosque pour la prochaine ouverture."
        override val reviewNewLeads: String = "Consultez les nouveaux leads et envoyez les suivis."
        override val createOpeningToStart: String = "Créez une ouverture depuis un bien pour commencer à collecter des leads."
        override val addFirstPropertyToStart: String = "Ajoutez votre premier bien pour commencer."
        override val nextOpening: String = "Prochaine ouverture"
        override val quickSignIn: String = "Enregistrement rapide"
        override val scanQrCode: String = "Scanner le QR code"
        override val newLead: String = "Nouveau lead"
        override val myProperties: String = "Mes biens"
        override val manageListings: String = "Gérer les annonces"
        override val todaysOverview: String = "Aperçu du jour"
        override val seeAll: String = "Voir tout"
        override val propertiesEyebrow: String = "Portfólio"
        override val propertiesSubtitle: String = "Manage actif, offrened, and archived listings with listing media, buyer activity, and performance insights."
        override val propertiesLiveMetric: String = "live"
        override val propertiesPipelineMetric: String = "pipeline"
        override val propertiesAllTimeMetric: String = "all time"
        override val addProperty: String = "Ajouter un bien"
        override val editProperty: String = "Modifier le bien"
        override val propertyFallback: String = "Bien"
        override val propertyUnavailableTitle: String = "Bien indisponible"
        override val propertyUnavailableBody: String = "Refresh the portfolio to reload this listing."
        override val backToProperties: String = "Retour aux biens"
        override val deletePropertyTitle: String = "Supprimer le bien ?"
        override val deletePropertyBody: String = "This will permanently supprimer the bien and its related local records. Cette action est irréversible."
        override val loadingProperties: String = "Chargement des biens"
        override val loadMore: String = "Charger plus"
        override val loadingPropertyDetails: String = "Chargement bien details"
        override val noPropertiesTitle: String = "Aucun bien pour le moment"
        override val noPropertiesBody: String = "Add your first bien, then créer an visite libre to start collecting leads and seller-ready feedback."
        override val openHouseButton: String = "Créer visite libre"
        override val photosTitle: String = "Photos"
        override val photosBody: String = "The first photo is used as the main bien image across Portfolio."
        override val uploadPhoto: String = "Importer une photo"
        override val noPhotosYet: String = "Aucune photo importée pour le moment."
        override val propertyPhotoCountPlanLimit: String = "La limite de photos pour ce bien est atteinte avec votre offre actuelle. Passez à une offre supérieure pour importer plus de photos."
        override val propertyPhotoStoragePlanLimit: String = "La limite de stockage de votre offre actuelle est atteinte. Passez à une offre supérieure pour importer plus de photos ou de fichiers."
        override val mainPhoto: String = "Principale"
        override val propertyTitleLabel: String = "Nom du bien"
        override val propertyAddressLine1Label: String = "Adresse"
        override val propertyAddressLine2Label: String = "Complément d’adresse"
        override val propertyCityLabel: String = "Ville"
        override val propertyRegionLabel: String = "Région"
        override val propertyPostalCodeLabel: String = "Code postal"
        override val propertyCountryLabel: String = "Pays"
        override val propertyAskingPriceLabel: String = "Prix demandé"
        override val propertyBedsLabel: String = "Chambres"
        override val propertyBathsLabel: String = "Salles de bain"
        override val propertyInteriorLabel: String = "Surface intérieure"
        override val propertyDescriptionLabel: String = "Description"
        override val createPropertyButton: String = "+ Bien"
        override val locateProperty: String = "Localiser le bien"
        override val findLocation: String = "Trouver un emplacement"
        override val find: String = "Trouver"
        override val navigate: String = "Naviguer"
        override val propertyLocationMarkerTitle: String = "Emplacement du bien"
        override val mapKitJsMissingToken: String = "La carte n’est pas configurée pour ce build."
        override val mapKitJsLoading: String = "Chargement de MapKit JS..."
        override val generateSellerReport: String = "Générer le rapport vendeur"
        override val deleteProperty: String = "Supprimer le bien"
        override val conversionMetric: String = "Conversion"
        override val propertyPhotoContentDescription: String = "Photo du bien"
        override val deletePhoto: String = "Supprimer la photo"
        override val movePhotoLeft: String = "Déplacer la photo à gauche"
        override val movePhotoRight: String = "Déplacer la photo à droite"
        override val propertyTitleRequired: String = "Le nom du bien est obligatoire."
        override val propertyStreetRequired: String = "L’adresse est obligatoire."
        override val propertyCityRequired: String = "La ville est obligatoire."
        override val propertyRegionRequired: String = "La région est obligatoire."
        override val propertyPostalRequired: String = "Le code postal est obligatoire."
        override val propertyAskingPriceInvalid: String = "Saisissez un prix demandé valide."
        override val propertyOwnerContactTitle: String = "Contact du propriétaire"
        override val propertyOwnerSelectContact: String = "Sélectionnez un contact existant comme propriétaire du bien."
        override val propertyOwnerSelected: String = "Propriétaire sélectionné"
        override val propertyOwnerNoContacts: String = "Aucun contact pour le moment. Ajoutez le propriétaire dans Contacts, puis sélectionnez-le ici."
        override val propertyOwnerChooseContact: String = "Choisir un contact"
        override val propertyOwnerChangeContact: String = "Changer de contact"
        override val propertyOwnerRemoveContact: String = "Retirer"
        override val propertyOwnerPickerTitle: String = "Choisir le propriétaire du bien"
        override val propertyOwnerSearchContact: String = "Rechercher des contacts"
        override val propertyOwnerSearchHint: String = "Commencez à saisir un nom, un e-mail ou un téléphone."
        override val propertyOwnerNoMatches: String = "Aucun contact correspondant."
        override val propertyOpeningsTitle: String = "Visites libres"
        override val propertyNoOpenings: String = "Aucune visite prévue pour ce bien."
        override val teamAccessTitle: String = "Accès équipe"
        override val onlyListingOwner: String = "Uniquement le propriétaire de l’annonce"
        override val assignTeam: String = "Assigner l’équipe"
        override val assignPropertyTitle: String = "Assigner le bien"
        override val assignPropertyBody: String = "Choisissez qui peut travailler sur ce bien. Sélectionnez toute l’équipe ou des agents spécifiques."
        override val wholeTeam: String = "Toute l’équipe"
        override val leadsEyebrow: String = "Leads"
        override val leadFallback: String = "Lead"
        override val leadsSubtitle: String = "Recherchez, filtrez et qualifiez les leads capturés lors de chaque visite."
        override val leadDetailSubtitle: String = "Source, qualification, notes et historique des relances pour ce lead de visite."
        override val totalMetric: String = "Total"
        override val loggedMetric: String = "enregistrés"
        override val searchLeads: String = "Rechercher des leads"
        override val searchLeadsPlaceholder: String = "Nom, téléphone ou e-mail"
        override val allProperties: String = "Tous les biens"
        override val loadingLeads: String = "Chargement des leads de visite"
        override val loadingLeadDetails: String = "Chargement du détail du lead"
        override val noLeadsFoundTitle: String = "Les leads apparaîtront ici lorsque les contacts feront un check-in à une visite."
        override val noLeadsEmptyBody: String = "Utilisez le check-in kiosk ou ajoutez des contacts manuellement depuis une visite."
        override val noLeadsFilteredBody: String = "Essayez un autre bien, statut ou terme de recherche."
        override val backToLeads: String = "Retour aux leads"
        override val leadUnavailableTitle: String = "Lead indisponible"
        override val leadUnavailableBody: String = "Ce lead n’est plus disponible dans la liste actuelle."
        override val leadTemperature: String = "Statut du lead"
        override val leadLabelSuffix: String = "Lead"
        override val greetingHi: String = "Bonjour"
        override val leadActionCall: String = "Appeler"
        override val leadActionSms: String = "SMS"
        override val leadActionEmail: String = "E-mail"
        override val leadFollowUp: String = "Relance"
        override val leadNoFollowUpScheduled: String = "Aucune relance prévue"
        override val leadIntentScore: String = "Score d'intérêt"
        override val leadInterestedIn: String = "Intéressé par"
        override val leadGenericGreetingName: String = "bonjour"
        override val followUpMessageTypeThankYou: String = "Merci"
        override val followUpMessageTypePropertyInfo: String = "Info bien"
        override val followUpMessageTypeFollowUp: String = "Relance"
        override val followUpMessageTypeCheckIn: String = "Prendre des nouvelles"
        override val followUpMessageTypePriceUpdate: String = "Mise à jour du prix"
        override val followUpMessageTypePropertyBrochure: String = "Fichiers"
        override val followUpPreview: String = "Aperçu"
        override val followUpSubject: String = "Objet"
        override val followUpMessage: String = "Moissage"
        override val followUpSendViaEmail: String = "Envoyer par e-mail"
        override val followUpSendViaSms: String = "Envoyer par SMS"
        override val followUpAiAssistantTitle: String = "Assistant AI"
        override val followUpAiAssistantBody: String = "Générez un message personnalisé en quelques secondes."
        override val followUpGenerateWithAi: String = "Générer avec l'AI"
        override val followUpUpgradeForAi: String = "Débloquer l'AI"
        override val followUpDefaultSubject: String = "Relance au sujet de"
        override val privateAgentNotes: String = "Private agent notes"
        override val notes: String = "Notes"
        override val notesPlaceholder: String = "Motivation, preferences, objections, next move"
        override val saveNotes: String = "Enregistrer notes"
        override val followUpHistory: String = "Relance history"
        override val noFollowUpsLogged: String = "Aucun relances logged pour le moment."
        override val openHousesEyebrow: String = "Showings"
        override val scheduleOpenHouse: String = "Créer une visite"
        override val openingDetails: String = "Détails de l’ouverture"
        override val editOpening: String = "Modifier l’ouverture"
        override val deleteOpening: String = "Supprimer l’ouverture"
        override val deleteOpeningBody: String = "Voulez-vous vraiment supprimer cette ouverture ? Cette action est irréversible."
        override val removeLeadTitle: String = "Retirer le lead ?"
        override val removeLeadBody: String = "Retirer %s de cette visite ?"
        override val removeLeadFallback: String = "ce lead"
        override val openingName: String = "Nom de l’ouverture"
        override val startsAt: String = "Début"
        override val endsAt: String = "Fin"
        override val chooseStartDateTime: String = "Choisir la date et l’heure de début"
        override val chooseEndDateTime: String = "Choisir la date et l’heure de fin"
        override val accessNotes: String = "Notes d’accès"
        override val privateNotes: String = "Notes privées"
        override val addPrivateNote: String = "Ajouter une note privée"
        override val liveDashboard: String = "Live dashboard"
        override val visitorKiosk: String = "Lead kiosk"
        override val openHousesSubtitle: String = "Créer visites libres for biens, revoir leads, and launch kiosk sessions."
        override val liveMetric: String = "Live"
        override val upcomingMetric: String = "À venir"
        override val inProgressMetric: String = "in progress"
        override val scheduledMetric: String = "scheduled"
        override val loadingOpenHouses: String = "Chargement visites libres"
        override val addPropertyFirstTitle: String = "Add a bien first"
        override val addPropertyFirstBody: String = "Créer an visite libre from a bien to start collecting leads."
        override val noOpenHousesTitle: String = "Aucun visites libres scheduled"
        override val noOpenHousesBody: String = "Créer an visite libre from a bien to start collecting leads."
        override val noSignInsTitle: String = "Aucun sign-ins yet"
        override val noSignInsBody: String = "Leads checked in through kiosk mode will appear here in real time."
        override val dashboard: String = "Tableau"
        override val start: String = "Début"
        override val end: String = "Fin"
        override val endOpenHouse: String = "Fin visite libre"
        override val reportsEyebrow: String = "Propriétaires"
        override val sellerReportsTitle: String = "Rapports vendeur"
        override val createReport: String = "Rapport"
        override val reportPreview: String = "Rapport vendeur"
        override val reportsSubtitle: String = "Créez des comptes rendus premium après visite avec qualité des leads, intention des acheteurs et narration prête pour le vendeur."
        override val reportsMetricSaved: String = "enregistrerd"
        override val reportedMetric: String = "rapported"
        override val leadsMetric: String = "leads"
        override val createSellerReport: String = "Rapport"
        override val attendance: String = "Présence"
        override val savedReports: String = "enregistrerd rapports"
        override val buyerHeat: String = "Intérêt acheteurs"
        override val hotLeads: String = "chauds"
        override val loadingSellerReports: String = "Chargement rapports vendeur"
        override val noSellerReportsTitle: String = "Aucun rapports vendeur yet"
        override val noSellerReportsBody: String = "Choisir an visite libre, add agent notes, prevoir an export-ready recap, then enregistrer it."
        override val chooseOpenHouse: String = "Choisir visite libre"
        override val noOpenHousesAvailable: String = "Aucun visites libres available pour le moment."
        override val agentNotes: String = "Agent notes"
        override val notesForSeller: String = "Notes for seller"
        override val sellerNotesPlaceholder: String = "Objections, signaux de prix, retours de visite, prochaine action recommandée"
        override val generatePreview: String = "Generate prevoir"
        override val noPreviewReadyTitle: String = "Aucun prevoir ready"
        override val noPreviewReadyBody: String = "Generate a rapport vendeur prevoir avant saving."
        override val saveReport: String = "Enregistrer"
        override val reportSaved: String = "Rapport enregistrerd"
        override val sellerOpenHouseReport: String = "Seller visite libre rapport"
        override val mostCommonBuyerInterest: String = "Most common buyer interest"
        override val followUpsSent: String = "Relances sent"
        override val summary: String = "Résumé"
        override val noPrivateNotesAdded: String = "Aucun private notes added."
        override val openHouseReport: String = "Visite libre rapport"
        override val commonDraft: String = "Brouillon"
        override val commonAccepted: String = "Accepté"
        override val searchSellerReports: String = "Rechercher des rapports vendeur"
        override val noMatchingReports: String = "Aucun rapport correspondant"
        override val clearFilters: String = "Clear filters"
        override val tryDifferentSearchOrStatusFilter: String = "Essayez une autre recherche ou un autre filtre de statut."
        override val connectedToProperty: String = "Connecté au bien"
        override val viewProperty: String = "Voir le bien"
        override val dataRollup: String = "Data rollup"
        override val connectedOpenings: String = "Visites libres"
        override val visitors: String = "Visiteurs"
        override val interestedBuyers: String = "Acheteurs intéressés"
        override val completedFollowUps: String = "Follow Ups"
        override val reportHistory: String = "Rapport history"
        override val noPreviousReportsYet: String = "Aucun rapport précédent pour le moment."
        override val viewAllReports: String = "Voir tous les rapports"
        override val actions: String = "Actions"
        override val generatePdf: String = "Créer un tableur"
        override val previewPdf: String = "Aperçu du tableur"
        override val pdfSavedToPropertyFiles: String = "%s enregistrerd to bien fichiers."
        override val pdfSavingToPropertyFiles: String = "%s is being enregistrerd to bien fichiers."
        override val pdfSavedToFiles: String = "%s enregistrerd to fichiers."
        override val pdfSavingToFiles: String = "%s is being enregistrerd to fichiers."
        override val pdfIncludesSellerReport: String = "Spreadsheet includes Rapport vendeur metrics, AI insights, agent details, bien data, and visite libre history."
        override val pdfIncludesAnalytics: String = "Spreadsheet includes analytique metrics, top biens, agent performance, relance channels, and AI insights."
        override val pdfGenerateBeforeSending: String = "Créer the spreadsheet avant envoyering."
        override val pdfUploadBeforeSharing: String = "The spreadsheet must finish upchargement avant sharing."
        override val sellerReportPdfNeedsProperty: String = "La feuille de calcul du rapport vendeur nécessite un bien connecté avant l’envoi."
        override val deleteReport: String = "Supprimer Rapport"
        override val deleteReportBody: String = "Voulez-vous vraiment supprimer this rapport vendeur? Cette action est irréversible."
        override val shareReport: String = "Share rapport"
        override val openingPropertyReportLoading: String = "Bien rapport..."
        override val openingPropertyReportCreating: String = "Creating bien rapport..."
        override val sellerReportGeneratedPrefix: String = "Rapport vendeur generated"
        override val sellerReportGeneratedSuffix: String = "à partir des visites, visiteurs, leads, relances et retours connectés à ce bien au moment du rapport."
        override val priceNotSet: String = "Prix not set"
        override val daysSuffix: String = "jours"
        override val connectedOpeningSingular: String = "visite libre"
        override val connectedOpeningPlural: String = "visites libres"
        override val connectedLeadSingular: String = "lead connecté"
        override val connectedLeadPlural: String = "leads connectés"
        override val sellerConfidence: String = "Seller confidence"
        override val sellerConfidenceExplanation: String = "Confidence exoffreation"
        override val aiDraftReviewBeforeSending: String = "AI draft only. Revoir and modifier avant envoyering to the seller."
        override val executiveSummary: String = "Executive summary"
        override val buyerInterestOverview: String = "Aperçu de l’intérêt acheteur"
        override val whatBuyersLoved: String = "What buyers loved"
        override val buyerConcerns: String = "Préoccupations acheteurs"
        override val leadQualitySummary: String = "Résumé de la qualité des leads"
        override val agentActivity: String = "Agent activity"
        override val aiRecommendations: String = "AI recommendations"
        override val recommendations: String = "Recommandations"
        override val marketPositionComparison: String = "Market position comparison"
        override val nextSteps: String = "Next steps"
        override val conversion: String = "Conversion"
        override val interested: String = "interested"
        override val tourSignalsLowercase: String = "tour signals"
        override val propertyTimeline: String = "Bien timeline"
        override val timelineBasisNote: String = "La chronologie se base uniquement sur les inscriptions aux visites connectées et les relances."
        override val visitorsLowercase: String = "visiteurs"
        override val hotLeadsLowercase: String = "leads chauds"
        override val hotLowercase: String = "chaud"
        override val sentiment: String = "Sentiment"
        override val toursLowercase: String = "tours"
        override val interestedLowercase: String = "interested"
        override val noRepeatedFeedbackMentions: String = "Aucun repeated feedback mentions have been recorded pour le moment."
        override val scoresMentionRates: String = "Scores are mention rates across enregistrerd buyer feedback."
        override val aiExecutiveBriefing: String = "AI executive briefing"
        override val viewAllAiInsights: String = "Voir all AI insights ->"
        override val followUpsSentTitle: String = "Follow-Ups Sent"
        override val financingPacketsShared: String = "Financing Packets Shared"
        override val buyerCalls: String = "Appels acheteurs"
        override val propertyDataEvidence: String = "Bien data evidence"
        override val attendanceCoverage: String = "Couverture de présence"
        override val leadQuality: String = "Qualité des leads"
        override val followUpExecution: String = "Relance execution"
        override val activityChannels: String = "Canaux d’activité"
        override val callsLowercase: String = "appels"
        override val emailsLowercase: String = "e-mails"
        override val offerReadinessScore: String = "Offer readiness score"
        override val date: String = "Date"
        override val propertyLeadFunnel: String = "Bien lead funnel"
        override val openHouseBreakdown: String = "Open house breakdown"
        override val aiInsights: String = "Insights AI"
        override val generateAiInsights: String = "Générer insights AI"
        override val analyticsOverview: String = "Analytique overvoir"
        override val allAgents: String = "All agents"
        override val me: String = "Moi"
        override val allActivity: String = "All activity"
        override val latest30Days: String = "Latest 30 jours"
        override val latest7Days: String = "Latest 7 jours"
        override val analyticsDatePreset: String = "Période"
        override val analyticsCustomDate: String = "Custom date"
        override val analyticsLastDay: String = "Dernier jour"
        override val analyticsLastWeek: String = "Dernière semaine"
        override val analyticsLastMonth: String = "Dernier mois"
        override val analyticsLastYear: String = "Dernière année"
        override val analyticsAllTime: String = "Toute période"
        override val analyticsDateFrom: String = "Date from"
        override val analyticsDateTo: String = "Date to"
        override val analyticsOpenHousesLowercase: String = "visites libres"
        override val analyticsWarmLeadsLowercase: String = "leads tièdes"
        override val analyticsFromNotesFollowUps: String = ""
        override val analyticsFromText: String = "depuis le texte"
        override val analyticsHotConversion: String = "Conversion des leads chauds"
        override val analyticsHotLeadsPerVisitors: String = "leads chauds / visiteurs"
        override val analyticsAverageIntent: String = "Avg. intent"
        override val analyticsVisitorIntentScore: String = "visitor intent score"
        override val analyticsSelectDate: String = "Sélectionner date"
        override val propertyFunnel: String = "Bien funnel"
        override val propertyFunnelSubtitle: String = "From bien activity to qualified buyer momentum"
        override val properties: String = "Biens"
        override val tourSignals: String = "Signaux de visite"
        override val offerSignals: String = "Signaux d’offre"
        override val viewFullFunnelReport: String = "Voir full funnel rapport"
        override val performanceOverTime: String = "Performance dans le temps"
        override val thirtyDays: String = "30 jours"
        override val topPerformingProperties: String = "Biens les plus performants"
        override val viewAll: String = "Voir all"
        override val noPropertyAnalyticsYet: String = "Aucun bien analytique pour le moment."
        override val leadQualityBreakdown: String = "Répartition de la qualité des leads"
        override val warmLeadsTitle: String = "Leads tièdes"
        override val coldLeadsTitle: String = "Leads froids"
        override val followUpPerformance: String = "Relance performance"
        override val agentPerformance: String = "Agent performance"
        override val viewTeamReport: String = "Voir le rapport d’équipe"
        override val followUpChannels: String = "Canaux de relance"
        override val viewReport: String = "Voir rapport"
        override val searchProperties: String = "Rechercher des biens"
        override val searchOpenings: String = "Rechercher des visites"
        override val noOpeningsFoundTitle: String = "Aucun visites libres found"
        override val noOpeningsFoundBody: String = "Essayez une autre recherche ou un autre filtre de statut de visite."
        override val noMatchingPropertiesTitle: String = "Aucun bien correspondant"
        override val noMatchingPropertiesBody: String = "Essayez une autre recherche ou un autre filtre de statut."
        override val clientsTitle: String = "Contacts"
        override val clientFallback: String = "Contact"
        override val addClient: String = "Ajouter un contact"
        override val editClient: String = "Modifier le contact"
        override val newClient: String = "Nouveau contact"
        override val saveClient: String = "Enregistrer le contact"
        override val createClient: String = "Créer le contact"
        override val deleteClientTitle: String = "Supprimer contact?"
        override val deleteClientBody: String = "This will permanently supprimer the contact. Cette action est irréversible."
        override val firstName: String = "Prénom"
        override val lastName: String = "Nom"
        override val email: String = "E-mail"
        override val phone: String = "Téléphone"
        override val comments: String = "Commentaires"
        override val addPhoto: String = "Ajouter une photo"
        override val sendQr: String = "Envoyer QR"
        override val sendQrShareTitle: String = "Votre QR HAVN pour la visite"
        override val sendQrShareBody: String = "Votre QR HAVN pour la visite est joint. Ajoutez le Wallet pass (.pkpass) au téléphone dès qu’il est disponible, ou présentez l’image QR lors de la visite."
        override val sendQrReadyMessage: String = "Code QR prêt à envoyer"
        override val sendQrUnavailableError: String = "Aucune app e-mail ou SMS n’est disponible pour ce contact."
        override val clientQrDeliveryRequired: String = "Ajoutez un e-mail ou un numéro de téléphone pour envoyer le QR."
        override val photo: String = "Photo"
        override val clientDetailSubtitle: String = "Identité QR, coordonnées, commentaires et visites liées via les leads."
        override val clientFormEditSubtitle: String = "Mettez à jour les coordonnées, les préférences d’envoi et les commentaires."
        override val clientFormNewSubtitle: String = "Enregistrez un acheteur/contact et générez une identité QR réutilisable pour les visites."
        override val searchClients: String = "Rechercher des contacts"
        override val noClientsYetTitle: String = "Aucun contact pour le moment"
        override val noClientsYetBody: String = "Enregistrez d’abord les contacts, puis envoyez-leur leur QR code par e-mail ou SMS avant une visite."
        override val noClientsFoundTitle: String = "Aucun contact trouvé"
        override val noClientsFoundBody: String = "Essayez un autre nom, téléphone ou e-mail."
        override val clientUnavailableTitle: String = "Contact indisponible"
        override val clientUnavailableBody: String = "Actualisez la liste des contacts et ouvrez de nouveau cette fiche."
        override val noCommentsAdded: String = "Aucun commentaire ajouté."
        override val openingsTitle: String = "Visites"
        override val clientOpeningsEmpty: String = "Aucune visite liée pour le moment. Les leads relient un contact à une visite."
        override val clientPassLabel: String = "Wallet pass"
        override val clientNoEmail: String = "Sans e-mail"
        override val visitorsBody: String = "Ouvrez le kiosque, scannez le QR d’un contact ou ajoutez des contacts existants comme leads pour cette visite."
        override val openKiosk: String = "Ouvrir le kiosque"
        override val addQrClient: String = "Contact QR"
        override val addManually: String = "Manuel"
        override val selectClients: String = "Sélectionner des contacts"
        override val selectClientsBody: String = "Choisissez des contacts dans votre liste. Chaque contact sélectionné devient un lead pour cette visite."
        override val kioskCheckIn: String = "Check-in kiosque"
        override val kioskCheckInBody: String = "Utilisez la caméra arrière pour scanner le QR HAVN Wallet du contact. Une fois le code reconnu, HAVN crée automatiquement le lead pour cette visite."
        override val scanWithCamera: String = "Scanner avec la caméra arrière"
        override val clientQrImage: String = "Image QR du contact"
        override val clientQrImageBody: String = "Gardez le QR du contact dans le carré doré. HAVN ajoute chaque scan ci-dessous."
        override val scanMultipleQrBody: String = "Scannez un ou plusieurs QR codes de contacts HAVN, puis appuyez sur Ajouter contact QR."
        override val scannedQrReady: String = "QR contact prêt à ajouter"
        override val createLeadFromQr: String = "Créer un lead depuis le QR"
        override val noClientsFoundShort: String = "Aucun contact trouvé."
        override val remove: String = "Retirer"
        override val tasksTitle: String = "Tâches"
        override val addTask: String = "Add tâche"
        override val searchTasks: String = "Rechercher tâches"
        override val loadMoreTasks: String = "Load more tâches"
        override val createTask: String = "Créer Tâche"
        override val saveTask: String = "Enregistrer Tâche"
        override val editTask: String = "Modifier Tâche"
        override val newTask: String = "New tâche"
        override val taskDetails: String = "Tâche Details"
        override val taskName: String = "Nom"
        override val taskDescription: String = "Description"
        override val taskDueDateTime: String = "Tâche date & time"
        override val chooseTaskDateTime: String = "Choisir tâche date & time"
        override val clearTaskDateTime: String = "Clear date & time"
        override val assignToAgent: String = "Attribuer à un agent"
        override val noAgencyAgentsFound: String = "Aucun agence agents found. The tâche will stay assigned to the propriétaire."
        override val taskPriority: String = "Tâche Priorité"
        override val taskStatus: String = "Statut"
        override val taskVisibility: String = "Visibilité"
        override val taskOwner: String = "Propriétaire"
        override val taskOwnerFallback: String = "Tâche propriétaire"
        override val assignedTo: String = "Assigned to"
        override val selectedAgent: String = "Sélectionné agent"
        override val taskVisibilityBody: String = "This tâche is visible to the propriétaire and the assigned agent."
        override val taskQueue: String = "Tâche queue"
        override val taskDetail: String = "Tâche detail"
        override val taskDetailEmpty: String = "Sélectionner a tâche to see context and next actions."
        override val connectedContext: String = "Contexte lié"
        override val noTaskContext: String = "Aucun bien, contact, visite libre, or lead is linked pour le moment."
        override val activityTimeline: String = "Chronologie d’activité"
        override val created: String = "Créerd"
        override val recently: String = "Récently"
        override val completed: String = "Terminé"
        override val nextAction: String = "Next action"
        override val agentReviewOrCompletion: String = "Agent revoir or completion"
        override val noDueDate: String = "Aucun due date"
        override val reopen: String = "Rouvrir"
        override val accept: String = "Accepter"
        override val linkedTasks: String = "Lié tâches"
        override val noLinkedTasks: String = "Aucun linked tâches pour le moment."
        override val filesTitle: String = "Fichiers"
        override val attachFile: String = "Attach fichier"
        override val noFilesAttached: String = "Aucun fichiers attached pour le moment."
        override val fileLimitHint: String = "Fichiers can be PDF, DOC, CAD, or other formats up to 20 MB each."
        override val deleteFileTitle: String = "Supprimer fichier?"
        override val deleteFileBody: String = "This fichier will be removed from HAVN storage."
        override val attachmentOpenFailed: String = "Impossible d’ouvrir ce fichier."
        override val attachmentDeleteOwnerOnly: String = "Only the fichier propriétaire can supprimer this attachment."
        override val attachmentDocumentsNotIncluded: String = "Votre offre actuelle n'inclut pas l'import de fichiers. Passez à une offre supérieure pour importer des fichiers."
        override val attachmentDocumentStorageNotIncluded: String = "Votre offre actuelle n'inclut pas le stockage de documents. Passez à une offre supérieure pour importer des fichiers."
        override val attachmentFileSizePlanLimit: String = "Ce fichier dépasse la taille autorisée par votre offre actuelle. Passez à une offre supérieure pour importer des fichiers plus volumineux."
        override val attachmentStoragePlanLimit: String = "La limite de stockage de votre offre actuelle est atteinte. Passez à une offre supérieure pour importer plus de fichiers."
        override val attachmentDocumentCountPlanLimit: String = "La limite de documents pour ce bien est atteinte avec votre offre actuelle. Passez à une offre supérieure pour importer plus de fichiers."
        override val attachmentHardFileLimit: String = "Les pièces jointes sont limitées à 100 MB."
        override val openFiles: String = "Ouvrir fichiers"
        override val sendViaEmail: String = "Envoyer par e-mail"
        override val sendViaSms: String = "Envoyer par SMS"
        override val sendEmailHeader: String = "Envoyer e-mail"
        override val sendSmsHeader: String = "Envoyer SMS"
        override val noContactsFound: String = "Aucun contacts found."
        override val searchContacts: String = "Rechercher contacts"
        override val linked: String = "Lié"
        override val recent: String = "Récent"
        override val taskColumnToDo: String = "To Do"
        override val taskColumnInProgress: String = "In Progress"
        override val taskColumnDone: String = "Terminé"
        override val taskColumnToDoSubtitle: String = "New tâches and next actions waiting to be started."
        override val taskColumnInProgressSubtitle: String = "Work currently owned par you or the team."
        override val taskColumnDoneSubtitle: String = "Terminé tâches kept visible for team confidence."
        override val taskEmptyToDo: String = "Aucun tâches to do."
        override val taskEmptyInProgress: String = "Nothing in progress."
        override val taskEmptyDone: String = "Aucun completed tâches pour le moment."
        override val taskKanbanEmptyToDo: String = "Nothing waiting. New relances and rapport work will appear here."
        override val taskKanbanEmptyInProgress: String = "Aucun actif work in progress."
        override val taskKanbanEmptyDone: String = "Terminé tâches will land here."
        override val taskEmptyBodyPrefix: String = "Créer a tâche or move another tâche into"
        override val taskEmptyBodySuffix: String = "."
        override val taskActionStart: String = "Début"
        override val taskActionOverdue: String = "En retard"
        override val taskActionCancel: String = "Annuler"
        override val taskPriorityLow: String = "Low"
        override val taskPriorityMedium: String = "Moidium"
        override val taskPriorityHigh: String = "High"
        override val taskPriorityUrgent: String = "Urgent"
        override val taskStatusOpen: String = "Open"
        override val taskStatusInProgress: String = "In progress"
        override val taskStatusDone: String = "Terminé"
        override val taskStatusOverdue: String = "En retard"
        override val taskStatusCancelled: String = "Annulé"
        override val aiSuggestedTasks: String = "Tâches suggérées par AI"
        override val noAiSuggestedTasks: String = "Aucun AI suggestions pour le moment. HAVN will suggest tâches après visites libres and lead activity."
        override val taskFilterToday: String = "Aujourd’hui"
        override val taskFilterUpcoming: String = "À venir"
        override val taskFilterOverdue: String = "En retard"
        override val taskFilterCompleted: String = "Terminé"
        override val taskFilterAssignedToMe: String = "Assigned to Moi"
        override val taskFilterAiSuggested: String = "Suggestions AI"
        override val taskFilterEmptyToday: String = "You're clear for aujourd’hui."
        override val taskFilterEmptyUpcoming: String = "Aucun upcoming tâches."
        override val taskFilterEmptyOverdue: String = "Aucun overdue tâches."
        override val taskFilterEmptyCompleted: String = "Aucun completed tâches pour le moment."
        override val taskFilterEmptyAssignedToMe: String = "Aucun tâches assigned to you."
        override val taskFilterEmptyAiSuggested: String = "Aucun accepted AI suggested tâches pour le moment."
        override val taskSuggestionHotLeadTitlePrefix: String = "Relancer"
        override val taskSuggestionHotLeadTitleSuffix: String = "within 2 hours."
        override val taskSuggestionHotLeadDescriptionPrefix: String = "Hot lead from"
        override val taskSuggestionHotLeadDescriptionSuffix: String = "Keep momentum while intent is fresh."
        override val taskSuggestionHotLeadReason: String = "New hot lead captured."
        override val taskSuggestionSellerReportTitlePrefix: String = "Generate rapport vendeur for"
        override val taskSuggestionSellerReportTitleSuffix: String = "."
        override val taskSuggestionSellerReportDescription: String = "Résumez le volume de visiteurs, les leads chauds, l’activité de relance et le sentiment des acheteurs."
        override val taskSuggestionSellerReportReason: String = "Open house ended."
        override val taskSuggestionReviewFollowUpTitlePrefix: String = "Revoir and envoyer"
        override val taskSuggestionReviewFollowUpTitleSuffix: String = "relance."
        override val taskSuggestionReviewFollowUpReason: String = "Relance draft still needs agent revoir."
        override val taskSuggestionKioskTitle: String = "Préparer le mode kiosque et vérifier les photos du bien."
        override val taskSuggestionKioskDescription: String = "Confirm sign-in flow, gallery, and visite libre details avant buyers arrive."
        override val taskSuggestionKioskReason: String = "Open house is scheduled."
    }

    private val czech: HavnStrings = object : HavnStrings {
        override val navToday: String = "Dnes"
        override val navProperties: String = "Nemovitosti"
        override val navLeads: String = "Leady"
        override val navReports: String = "Reporty"
        override val navTasks: String = "Úkoly"
        override val navAnalytics: String = "Analytika"
        override val navAgency: String = "Agentura"
        override val navSettings: String = "Nastaveni"
        override val navAuth: String = "Pristup agenta"
        override val navOpenHouses: String = "Prohlidky"
        override val navTours: String = "Prohlidky"
        override val navFollowUps: String = "Kontakty"
        override val navFollow: String = "Kontakty"
        override val back: String = "Zpet"
        override val settingsEyebrow: String = "Pracovni prostor"
        override val settingsTitle: String = "Nastaveni"
        override val settingsSubtitle: String = "Profil, jazyk, jednotky, prostredi a tymove moznosti."
        override val agentProfileTitle: String = "Profil agenta"
        override val agentPhoto: String = "Fotka agenta"
        override val uploading: String = "Nahrávám..."
        override val saving: String = "Ukládám..."
        override val validAgentPhotoRequired: String = "Vyberte platnou fotku agenta."
        override val signOut: String = "Odhlásit se"
        override val signOutQuestion: String = "Odhlásit se?"
        override val signOutConfirmation: String = "Opravdu se chcete odhlásit z HAVN?"
        override val deleteAccount: String = "Smazat účet"
        override val deleteAccountQuestion: String = "Smazat účet?"
        override val deleteAccountOpenPageBody: String = "Otevře se stránka se žádostí o smazání účtu."
        override val deleteAccountReviewTitle: String = "Použijte skutečný účet"
        override val deleteAccountReviewBody: String = "Tento účet pro app review je chráněný, aby recenzenti během testování nepřišli o přístup. Pro ověření smazání účtu použijte skutečný testovací účet."
        override val upgrade: String = "Vylepšit"
        override val premiumThemesTitle: String = "Prémiová témata"
        override val premiumThemesUpgradePrompt: String = "Vylepšete na Pro a odemkněte prémiová témata."
        override val appearanceTitle: String = "Vzhled"
        override val appearanceBody: String = "Vyberte světlý nebo tmavý režim pro webovou aplikaci."
        override val previewComponents: String = "Ukázka komponent"
        override val themeShowcaseTitle: String = "Ukázka tématu"
        override val showcaseButtons: String = "Tlačítka"
        override val showcasePrimaryAction: String = "Hlavní akce"
        override val showcaseSecondaryAction: String = "Vedlejší akce"
        override val showcaseGhostAction: String = "Nenápadná akce"
        override val showcaseTextField: String = "Textové pole"
        override val showcaseFocusedBorder: String = "Zvýrazněný okraj"
        override val showcaseSearchPreview: String = "Ukázka vyhledávání"
        override val showcaseOpeningCheckedIn: String = "Dnešní příchod na prohlídku"
        override val showcaseSentAt: String = "Odesláno v 10:30"
        override val themeObsidianGoldName: String = "Obsidian Gold"
        override val themeObsidianGoldDescription: String = "Luxusní černá, grafit a teplé zlato."
        override val themeMidnightSapphireName: String = "Midnight Sapphire"
        override val themeMidnightSapphireDescription: String = "Hluboká námořnická modrá, safír a stříbrné akcenty."
        override val themeEmeraldEstateName: String = "Emerald Estate"
        override val themeEmeraldEstateDescription: String = "Tmavý smaragd, antracit a šampaňské zlato."
        override val themePlatinumStoneName: String = "Platinum Stone"
        override val themePlatinumStoneDescription: String = "Kamenná šedá, platina a jemná bílá."
        override val themeBordeauxNoirName: String = "Bordeaux Noir"
        override val themeBordeauxNoirDescription: String = "Tmavé víno, grafit a měděné akcenty."
        override val commonChange: String = "Změnit"
        override val agentPlanTitle: String = "Plán agenta"
        override val agentPlanBody: String = "Vylepšete si práci. Vyberte plán, který nejlépe sedí vašemu způsobu prodeje."
        override val currentPlan: String = "Aktuální plán"
        override val transferPlan: String = "Přenést plán"
        override val transferPlanTitle: String = "Přenést plán"
        override val transferPlanBody: String = "Přesuňte toto předplatné na jiný účet HAVN. Obě e-mailové adresy musí převod potvrdit ověřovacími kódy."
        override val transferTargetEmail: String = "E-mail nového účtu"
        override val transferSendCodes: String = "Odeslat ověřovací kódy"
        override val transferCodesSentTitle: String = "Ověřovací kódy odeslány"
        override val transferCodesSentBody: String = "Jeden kód jsme poslali na váš e-mail a druhý na e-mail nového účtu."
        override val transferYourCode: String = "Kód z vašeho e-mailu"
        override val transferTargetCode: String = "Kód nového účtu"
        override val transferConfirm: String = "Přenést plán"
        override val transferSuccessTitle: String = "Plán byl přenesen"
        override val transferSuccessBody: String = "Předplatné je nyní připojeno k novému účtu HAVN."
        override val restorePurchase: String = "Obnovit nákup"
        override val agencySettingsProBody: String = "Solo agency je aktivní ve výchozím nastavení. Pro umožňuje vytvořit nebo vybrat sdílenou agenturu."
        override val agencySettingsLockedBody: String = "Solo agency je aktivní. Změny agentury odemkne Pro."
        override val soloAgency: String = "Solo agentura"
        override val defaultPrivateAgencyWorkspace: String = "Výchozí soukromá agentura"
        override val noAgenciesAvailableYet: String = "Zatím nejsou dostupné žádné pozvánky ani vlastněné agentury."
        override val oneOwnedAgencyHint: String = "Vaše agentura je uvedena výše. Jeden agent může vlastnit jednu agenturu."
        override val createAgency: String = "Vytvořit agenturu"
        override val createYourAgency: String = "Vytvořte svou agenturu"
        override val createAgencyBody: String = "Budujte tým, spravujte nemovitosti společně a rozvíjejte své podnikání."
        override val agencyName: String = "Název agentury"
        override val agencyEmail: String = "E-mail agentury"
        override val logoOptional: String = "Logo (volitelné)"
        override val upgradeExperienceTitle: String = "Vylepšete svůj zážitek"
        override val upgradeExperienceSubtitle: String = "Vyberte plán, který nejlépe sedí vašemu způsobu práce."
        override val soloAgentPlan: String = "Solo agent"
        override val proAgentPlan: String = "Pro agent"
        override val teamAgentPlan: String = "Tým"
        override val soloBenefitActiveProperties: String = "Až 1 000 nemovitostí"
        override val soloBenefitAiFollowUps: String = "1 000 AI textových požadavků / měsíc"
        override val soloBenefitSellerReports: String = "Bez reportů pro prodávající"
        override val soloBenefitPersonalOnly: String = "Pouze osobní účet"
        override val proBenefitUnlimitedProperties: String = "Až 10 000 nemovitostí"
        override val proBenefitUnlimitedAi: String = "10 000 AI textových požadavků / měsíc"
        override val proBenefitAdvancedReports: String = "Pokročilé reporty pro prodávající"
        override val proBenefitAgencyCreation: String = "Vytvoření a správa agentury"
        override val proBenefitInviteAgents: String = "Pozývání agentů a spolupráce"
        override val proBenefitSharedLeads: String = "Sdílené leady a týmové workflow"
        override val proBenefitAgencyBranding: String = "Branding agentury"
        override val proBenefitAdvancedAnalytics: String = "Pokročilá analytika"
        override val teamBenefitLargeLimits: String = "Limity pro týmy"
        override val teamBenefitPrioritySupport: String = "Prioritní e-mailová podpora"
        override val teamBenefitDailyBackups: String = "Denní zálohy na 7 dní"
        override val teamBenefitLargeStorage: String = "10 GB úložiště dokumentů"
        override val startFreeTrial7Day: String = "Předplatit nyní"
        override val restorePurchases: String = "Obnovit nákup"
        override val comparePlans: String = "Porovnat plány"
        override val startFreeTrial: String = "Vybrat plán"
        override val noCommitmentCancelAnytime: String = "Bez závazku. Zrušit můžete kdykoli."
        override val monthly: String = "Měsíčně"
        override val yearly: String = "Ročně"
        override val yearlySave20: String = "Ročně"
        override val yearlySavings20: String = "Účtováno ročně."
        override val perYear: String = "/ rok"
        override val loadingPlans: String = "Načítám plány..."
        override val selectedPlanUnavailable: String = "Tento plán zatím není dostupný. Zkuste to znovu později nebo kontaktujte podporu."
        override val signInRequiredForPurchase: String = "Před nákupem se přihlaste."
        override val subscriptionDisclosureIos: String = "Automaticky obnovované předplatné. Platba bude stržena z vašeho účtu Apple při potvrzení nákupu. Předplatné se automaticky obnoví, pokud ho nezrušíte nejpozději 24 hodin před koncem aktuálního období. Obnovení bude účtováno během 24 hodin před koncem aktuálního období. Předplatné můžete spravovat nebo zrušit v nastavení účtu v App Store."
        override val subscriptionDisclosureAndroid: String = "Automaticky obnovované předplatné přes Google Play. Poplatek vám bude účtován v každém fakturačním období, pokud předplatné nezrušíte. Předplatné můžete kdykoli spravovat nebo zrušit v předplatných Google Play. Přístup pokračuje do konce zaplaceného období."
        override val subscriptionDisclosureWeb: String = "Automaticky obnovované předplatné. Poplatek vám bude účtován v každém fakturačním období zvolenou platební metodou, pokud předplatné nezrušíte. Předplatné můžete kdykoli spravovat nebo zrušit v nastavení fakturace. Přístup pokračuje do konce zaplaceného období. Mohou se uplatnit daně."
        override val subscriptionAgreementPrefix: String = "Předplacením souhlasíte s"
        override val subscriptionTermsOfUse: String = "Podmínkami používání HAVN"
        override val subscriptionAgreementAnd: String = "a"
        override val subscriptionPrivacyPolicy: String = "Zásadami ochrany soukromí."
        override val purchaseSuccessTitle: String = "Děkujeme za nákup"
        override val purchaseSuccessBody: String = "Vaše předplatné HAVN je aktivní a plán je připravený."
        override val restoreSuccessTitle: String = "Obnovit nákup"
        override val restoreSuccessBody: String = "Vaše předplatné HAVN bylo úspěšně obnoveno."
        override val purchaseCouldNotComplete: String = "Nákup se nepodařilo dokončit. Zkuste to znovu nebo zkontrolujte účet v App Storu nebo Google Play."
        override val purchaseVerificationPending: String = "Your payment has not been confirmed yet. If you completed checkout, use Restore purchase to check again. You do not need to pay again."
        override val completeWebCheckout: String = "Complete payment in the checkout tab, then return here. Your access will update automatically once payment is confirmed."
        override val restoreCouldNotComplete: String = "Pro tento účet obchodu nebylo nalezeno aktivní předplatné HAVN."
        override val noActiveSubscriptionFound: String = "Pro tento účet obchodu nebylo nalezeno aktivní předplatné HAVN."
        override val compareActiveProperties: String = "Aktivní nemovitosti"
        override val compareAiFollowUps: String = "AI připomínky"
        override val compareSellerReports: String = "Reporty pro prodávající"
        override val compareAdvancedAnalytics: String = "Pokročilá analytika"
        override val compareAgencyCreation: String = "Vytvoření agentury"
        override val compareJoinAgencies: String = "Připojení k agenturám"
        override val compareInviteAgents: String = "Pozývání agentů"
        override val compareSharedLeads: String = "Sdílené leady"
        override val compareAgencyBranding: String = "Branding agentury"
        override val comparePrioritySupport: String = "Prioritní podpora"
        override val compareFeature: String = "Funkce"
        override val compareFreePlan: String = "Zdarma"
        override val compareValueYes: String = "Ano"
        override val compareValueNo: String = "Ne"
        override val comparePricePerMonthUser: String = "Cena / měsíc / uživatel"
        override val comparePricePerYearUser: String = "Cena / rok / uživatel"
        override val compareMaxPropertiesOwner: String = "Max. nemovitostí / vlastník"
        override val compareMaxContactsOwner: String = "Max. kontaktů / vlastník"
        override val compareMaxOpenHousesOwner: String = "Max. prohlídek / vlastník"
        override val compareMaxLeadsOwner: String = "Max. leadů / vlastník"
        override val compareMaxPhotosProperty: String = "Max. fotek na nemovitost"
        override val compareMaxDocumentsProperty: String = "Max. dokumentů na nemovitost"
        override val compareDocumentsStorage: String = "Úložiště dokumentů"
        override val compareAgencyAgenda: String = "Agenda agentury"
        override val compareAiTextRequestsMonth: String = "AI textové požadavky / měsíc"
        override val compareAnalytics: String = "Analytika"
        override val compareTasks: String = "Úkoly"
        override val compareDocumentsStorageOwner: String = "Úložiště dokumentů / vlastník"
        override val compareMaxFileSizeOwner: String = "Max. velikost souboru / vlastník"
        override val compareEmailSupport: String = "E-mailová podpora"
        override val compareDailyBackups7Days: String = "Denní zálohy uložené na 7 dní"
        override val compareKioskMode: String = "Kiosk režim"
        override val unlimited: String = "Neomezené"
        override val basic: String = "Základní"
        override val advanced: String = "Pokročilé"
        override val perMonth: String = "/ měsíc"
        override val members: String = "členů"
        override val upgradeToProForAgencyTools: String = "Vylepšete na Pro a používejte nástroje agentury"
        override val languageTitle: String = "Jazyk"
        override val languageBody: String = "Vyberte jazyk aplikace pro toto zarizeni."
        override val english: String = "English"
        override val slovak: String = "Slovak"
        override val unitsTitle: String = "Jednotky a mena"
        override val unitsBody: String = "Vyberte, jak se v aplikaci zobrazuji ceny a rozmery nemovitosti."
        override val measurementSystemTitle: String = "Mereni"
        override val metric: String = "Metricke"
        override val imperial: String = "Imperialni"
        override val currencyTitle: String = "Mena"
        override val notificationsTitle: String = "Oznámení"
        override val notificationsBody: String = "Nastavte push upozornění, tichý režim a typy zpráv, které může HAVN posílat."
        override val notificationSettings: String = "Nastavení oznámení"
        override val notificationsSubtitle: String = "Only important updates, filtered od your preferences."
        override val quietHoursTitle: String = "Tichý režim"
        override val quietHoursBody: String = "HAVN skips non-critical pushes during quiet hours. Billing and account issues still stay concise."
        override val enableQuietHours: String = "Zapnout tichý režim"
        override val quietHoursStart: String = "Začít"
        override val quietHoursEnd: String = "Konec"
        override val timezoneLabel: String = "Časové pásmo"
        override val notificationTypesTitle: String = "Typy oznámení"
        override val notificationNewLeadCapturedTitle: String = "Zachycen nový lead"
        override val notificationNewLeadCapturedBody: String = "When an prohlídka or QR flow captures a lead."
        override val notificationHotLeadTitle: String = "Lead označen jako horký"
        override val notificationHotLeadBody: String = "Pouze když lead projeví vysoký zájem."
        override val notificationOpeningStartsSoonTitle: String = "Prohlídka starts soon"
        override val notificationOpeningStartsSoonBody: String = "A single reminder 30 minutes před start."
        override val notificationOpeningSummaryReadyTitle: String = "Prohlídka summary ready"
        override val notificationOpeningSummaryReadyBody: String = "Když je připraven souhrn po prohlídce."
        override val notificationSellerReportGeneratedTitle: String = "Report prodávajícímu vytvořen"
        override val notificationSellerReportGeneratedBody: String = "When a report pro prodávajícího has been vytvořitd."
        override val notificationAiFollowUpReadyTitle: String = "AI připomínka ready"
        override val notificationAiFollowUpReadyBody: String = "When a připomínka draft is ready to rezobrazit."
        override val notificationAgentInvitedTitle: String = "Agent pozvatd to agentura"
        override val notificationAgentInvitedBody: String = "Agentura invitations and členovéhip changes."
        override val notificationLeadAssignedTitle: String = "Lead přiřazen vám"
        override val notificationLeadAssignedBody: String = "Když vám kolega přiřadí lead."
        override val notificationLeadTransferredTitle: String = "Lead převeden na vás"
        override val notificationLeadTransferredBody: String = "When vlastníkship of a lead moves to you."
        override val notificationSubscriptionIssueTitle: String = "Problém s předplatným"
        override val notificationSubscriptionIssueBody: String = "Neúspěšné obnovení a problémy s platbou."
        override val kioskSecurityTitle: String = "Zabezpečení kiosku"
        override val kioskSecurityBody: String = "Tento PIN slouží k opuštění kiosku a návratu do aplikace agenta."
        override val kioskPinLabel: String = "PIN kiosku"
        override val mcpAccessTitle: String = "Přístup MCP"
        override val mcpAccessBody: String = "Propojte HAVN s Claude, OpenAI a dalšími MCP klienty na mcp.havnre.app. Dostupné v každém tarifu."
        override val mcpAuthorizationBearer: String = "Autorizace: Bearer"
        override val mcpNoApiKeyCreated: String = "API klíč ještě nebyl vytvořen"
        override val mcpNotUsedYet: String = "Zatím nepoužito"
        override val mcpLastUsedPrefix: String = "Naposledy použito"
        override val mcpRevealApiKeyTitle: String = "Zobrazit API klíč"
        override val mcpRevealApiKeyBody: String = "Celý klíč se zobrazí pouze po vytvoření nebo otočení."
        override val mcpCreateKey: String = "Vytvořit klíč"
        override val mcpRotateKey: String = "Otočit klíč"
        override val mcpRevokeKey: String = "Zrušit klíč"
        override val mcpEndpointHint: String = "Použijte endpoint https://mcp.havnre.app/mcp s tímto klíčem jako Bearer tokenem."
        override val mcpUpgradeHint: String = "MCP přístup je dostupný v každém tarifu HAVN."
        override val mcpUpgradePrompt: String = "MCP přístup je dostupný v každém tarifu HAVN."
        override val mcpCopied: String = "Zkopírováno"
        override val mcpCopy: String = "Kopírovat"
        override val mcpLoading: String = "Načítá se"
        override val kioskFeaturedProperty: String = "Featured nemovitost"
        override val kioskPrivateShowing: String = "Soukromá prohlídka"
        override val kioskLuxuryListing: String = "Luxusní nabídka"
        override val kioskFastCheckIn: String = "Rychlý check-in"
        override val kioskExitContentDescription: String = "Opustit kiosk"
        override val kioskWelcome: String = "Vítejte"
        override val kioskGladHere: String = "Jsme rádi, že jste tady."
        override val kioskScanToCheckIn: String = "Naskenujte pro příchod"
        override val kioskReceivePropertyDetails: String = "and receive nemovitost details"
        override val kioskOr: String = "Nebo"
        override val kioskStartCheckInManually: String = "Přihlásit ručně"
        override val kioskSecureInfo: String = "Vaše údaje jsou v bezpečí a nikdy je nesdílíme."
        override val kioskExitTitle: String = "Opustit kiosk"
        override val kioskExitBody: String = "Zadejte PIN kiosku pro návrat do aplikace agenta."
        override val kioskIncorrectPin: String = "Nesprávný PIN."
        override val kioskUnlock: String = "Odemknout"
        override val kioskTellUsTitle: String = "Řekněte nám o sobě"
        override val kioskTellUsBody: String = "Vaše údaje dostane pouze hostující agent."
        override val kioskFullName: String = "Jméno a příjmení"
        override val kioskContinue: String = "Pokračovat"
        override val kioskQuestionsTitle: String = "Pár rychlých otázek"
        override val kioskQuestionsBody: String = "Pomůže to agentovi navázat s vámi správným kontextem."
        override val kioskWorkingWithAgentQuestion: String = "Spolupracujete s agentem?"
        override val kioskYes: String = "Ano"
        override val kioskNo: String = "Ne"
        override val kioskInterestQuestion: String = "O co máte zájem?"
        override val kioskInterestBuying: String = "Koupě"
        override val kioskInterestInvesting: String = "Investice"
        override val kioskInterestBrowsing: String = "Jen se dívám"
        override val kioskInterestRelocating: String = "Stěhování"
        override val kioskFinish: String = "Dokončit"
        override val kioskThankYou: String = "Děkujeme"
        override val kioskEnjoyVisitPrefix: String = "Užijte si návštěvu v"
        override val kioskResetAutomatically: String = "Kiosk se automaticky resetuje."
        override val environmentTitle: String = "Prostředí"
        override val environmentBody: String = "Připojení je nakonfigurováno pro tento build."
        override val secure: String = "Zabezpečeno"
        override val brokerageProfileTitle: String = "Brokerage prosoubor"
        override val brokerageProfileBody: String = "Team branding, agent pozvats, and notification preferences will live here."
        override val logout: String = "Odhlasit se"
        override val languageChanged: String = "Jazyk změněn"
        override val commonAdd: String = "Pridat"
        override val commonEdit: String = "Upravit"
        override val commonDelete: String = "Smazat"
        override val commonCancel: String = "Zrusit"
        override val commonSave: String = "Ulozit"
        override val commonCreate: String = "Vytvorit"
        override val commonDismiss: String = "Zavřít"
        override val commonAll: String = "Vše"
        override val commonDone: String = "Hotovo"
        override val commonSend: String = "Odeslat"
        override val commonTime: String = "Čas"
        override val commonHour: String = "Hodina"
        override val commonMinute: String = "Minuta"
        override val commonAgency: String = "Agentura"
        override val commonSettings: String = "Nastavení"
        override val commonOpening: String = "Prohlídka"
        override val commonPropertyName: String = "Nemovitost"
        override val commonToday: String = "Dnes"
        override val agencyToolsAvailable: String = "Nástroje agentury jsou dostupné."
        override val agencySetupSubtitle: String = "Každý účet HAVN má výchozí agenturu. Pro umožňuje spravovat pozvánky, sdílené leady a branding."
        override val agencyRecentActivity: String = "Nedávné activity"
        override val agencyActivityNewLead: String = "Přidán nový lead"
        override val agencyActivityInvitationAccepted: String = "Pozvánka agenta přijata"
        override val agencyActivityAgentJoined: String = "Agent joined the agentura"
        override val agencyActivitySellerReport: String = "Seller report vytvořitd"
        override val agencyWorkspaceTitle: String = "Agentura"
        override val agencyWorkspaceBody: String = "Vybrat which agentura you are working with."
        override val agencySoloActiveTitle: String = "Solo agentura is aktivní"
        override val agencyProRequiredTitle: String = "Pro plán required"
        override val agencyCreateOrAcceptInviteBody: String = "Vytvořit your agentura or accept an pozvat to collaborate with another agentura."
        override val agencyProUnlockBody: String = "Agentura changes, pozvats, shared leady, and shared branding unlock with Pro."
        override val realEstate: String = "Reality"
        override val proAgency: String = "Pro agentura"
        override val agencyBrandingTitle: String = "Agentura branding"
        override val agencyBrandingBody: String = "Set the agentura name and logo shown in the app, kiosk, and team zobrazits."
        override val uploadLogo: String = "Nahrát logo"
        override val saveAgency: String = "Uložit agentura"
        override val yourAgencyRole: String = "Your agentura role"
        override val agencyAgentsTitle: String = "Agentura agents"
        override val agencyAgentsBody: String = "People eligible to work with this agentura."
        override val inviteAgent: String = "Pozvat agent"
        override val loadingAgents: String = "Načítám agents..."
        override val noAgencyAgentsYet: String = "Žádné agentura agents zatím."
        override val changeRole: String = "Změnit roli"
        override val updating: String = "Aktualizuji..."
        override val deleting: String = "Mažu..."
        override val deleteInvite: String = "Zrušit pozvánku"
        override val chooseAgencyRoleFor: String = "Vybrat the agentura role for"
        override val removeAccess: String = "Odebrat přístup"
        override val inviteAgentBody: String = "Odeslat an agentura invitation od email. The agent accepts po signing in with the same email."
        override val agentEmail: String = "E-mail agenta"
        override val role: String = "Role"
        override val inviting: String = "Zvu..."
        override val invite: String = "Pozvat"
        override val agents: String = "Agenti"
        override val ok: String = "OK"
        override val personalActivePropertyLimit: String = "Personal aktivní nemovitost limit"
        override val personalAccountAgencyToolsLocked: String = "Personal account is aktivní. Agentura tools unlock with Pro."
        override val selected: String = "Vybráno"
        override val activeMembers: String = "aktivní členové"
        override val agencySharedWorkspaceBody: String = "Shared nemovitosti, kontakty, prohlídky, leady, připomínky, and reporty use this agentura."
        override val actLikeAgent: String = "Pracovat jako agent"
        override val actAsAdmin: String = "Pracovat jako admin"
        override val actAsOwner: String = "Pracovat jako vlastník"
        override val actLikeAgentBody: String = "Používat agenturu jako běžný agent."
        override val actLikeAgentSelectedBody: String = "Zobrazuje se jen přiřazená nebo vlastněná práce."
        override val agencyRoleOwner: String = "Vlastník"
        override val agencyRoleAdmin: String = "Admin"
        override val agencyRoleAgent: String = "Agent"
        override val agencyRoleAssistant: String = "Asistent"
        override val agencyRoleViewer: String = "Prohlížející"
        override val agencyRoleOwnerDescription: String = "Úplná správa agentury včetně členů, brandingu, přiřazení, nabídek, leadů a reportů."
        override val agencyRoleAdminDescription: String = "Úplná správa agentury kromě smazání agentury."
        override val agencyRoleAgentDescription: String = "Pracuje s přiřazenými nabídkami, prohlídkami, leady, připomínkami, poznámkami a reporty pro prodávající."
        override val agencyRoleAssistantDescription: String = "Pomáhá s přiřazenými nabídkami úpravou leadů, přípravou připomínek a návrhů reportů."
        override val agencyRoleViewerDescription: String = "Přístup pouze pro čtení k přehledům a reportům."
        override val agencyCapabilityInviteRemoveMembers: String = "Zvát a odebírat členy"
        override val agencyCapabilityChangeRoles: String = "Měnit role členů"
        override val agencyCapabilityManageAllProperties: String = "Vytvářet, upravovat a mazat všechny nemovitosti"
        override val agencyCapabilityAssignAgents: String = "Přiřazovat agenty"
        override val agencyCapabilitySeeAllLeads: String = "Vidět všechny leady"
        override val agencyCapabilityExportReports: String = "Exportovat reporty"
        override val agencyCapabilityChangeBranding: String = "Měnit branding a nastavení agentury"
        override val agencyCapabilityDeleteAgency: String = "Smazat agenturu"
        override val agencyCapabilityViewAssignedProperties: String = "Zobrazit přiřazené nemovitosti"
        override val agencyCapabilityHostAssignedOpenings: String = "Pořádat přiřazené prohlídky"
        override val agencyCapabilitySeeAssignedLeads: String = "Vidět leady z přiřazených nemovitostí a prohlídek"
        override val agencyCapabilityAddNotes: String = "Přidávat poznámky"
        override val agencyCapabilitySendFollowUps: String = "Posílat připomínky"
        override val agencyCapabilityCreateSellerReports: String = "Vytvářet reporty pro prodávající k přiřazeným nabídkám"
        override val agencyCapabilityEditAssignedLeads: String = "Upravovat přiřazené leady"
        override val agencyCapabilityPrepareFollowUps: String = "Připravovat připomínky"
        override val agencyCapabilityCreateDraftReports: String = "Vytvářet návrhy reportů"
        override val agencyCapabilityCannotDeleteProperties: String = "Nemůže mazat nemovitosti"
        override val agencyCapabilityCannotInviteAgents: String = "Nemůže zvát agenty, pokud to není povoleno"
        override val agencyCapabilityViewDashboards: String = "Zobrazit přehledy"
        override val agencyCapabilityViewReports: String = "Zobrazit reporty"
        override val agencyCapabilityCannotEdit: String = "Nemůže nic upravovat"
        override val commonVisitors: String = "Leady"
        override val commonHot: String = "Horký"
        override val commonWarm: String = "Teplý"
        override val commonCold: String = "Studený"
        override val commonActive: String = "Aktivni"
        override val commonPlanned: String = "Planovane"
        override val commonArchived: String = "Archivovane"
        override val commonPast: String = "Proběhlé"
        override val commonFollowUps: String = "Připomínky"
        override val commonProperty: String = "Nemovitost"
        override val commonAddress: String = "Adresa"
        override val commonOpenHouse: String = "Prohlídka"
        override val commonInquiry: String = "Poptávka"
        override val commonInquiries: String = "Poptávky"
        override val generalInquiry: String = "Obecná poptávka"
        override val generalInquiries: String = "Obecné poptávky"
        override val propertyInquiry: String = "Poptávka na nemovitost"
        override val propertyInquiries: String = "Poptávky na nemovitosti"
        override val addGeneralInquiry: String = "Přidat obecnou poptávku"
        override val newGeneralInquiry: String = "Nová obecná poptávka"
        override val noGeneralInquiries: String = "Zatím žádné obecné poptávky."
        override val noPropertyInquiries: String = "Zatím žádné poptávky na nemovitosti."
        override val buyerLookingFor: String = "Co tento kupující hledá?"
        override val locationCity: String = "Lokalita / město"
        override val radiusKm: String = "Okruh (km)"
        override val propertyType: String = "Typ nemovitosti"
        override val budgetFrom: String = "Rozpočet od"
        override val budgetTo: String = "Rozpočet do"
        override val purchaseTimeline: String = "Termín koupě"
        override val createGeneralInquiry: String = "Vytvořit obecnou poptávku"
        override val saveGeneralInquiry: String = "Uložit obecnou poptávku"
        override val inquiryType: String = "Typ poptávky"
        override val leadSource: String = "Zdroj leadu"
        override val notSpecified: String = "Neuvedeno"
        override val inquiryStatus: String = "Stav poptávky"
        override val inquiryFollowUp: String = "Připomínka k poptávce"
        override val addInquiry: String = "Přidat poptávku"
        override val searchInquiries: String = "Hledat poptávky"
        override val noInquiries: String = "Žádné poptávky"
        override val noInquiriesBody: String = "Pomocí tlačítka plus přidejte zájem kupujícího z existujícího kontaktu."
        override val inquiryUnavailableTitle: String = "Poptávka není dostupná"
        override val inquiryUnavailableBody: String = "Tato poptávka mohla být odstraněna nebo se ještě načítá."
        override val backToInquiries: String = "Zpět na poptávky"
        override val deleteInquiry: String = "Odstranit poptávku"
        override val deleteInquiryQuestionPrefix: String = "Odstranit"
        override val deleteInquiryQuestionSuffix: String = "z této nemovitosti?"
        override val deleteInquiryTargetFallback: String = "tuto poptávku"
        override val propertyInquiriesBody: String = "Sledujte kupující, kteří se ptali na tuto nemovitost. Poptávky se zobrazují také v Leadech."
        override val propertyInquiriesEmpty: String = "Přidejte poptávku výběrem jednoho z kontaktů."
        override val contactInquiriesBody: String = "Nemovitosti, na které se tento kontakt ptal."
        override val contactInquiriesEmpty: String = "Zatím žádné poptávky na nemovitosti."
        override val viewInquiries: String = "Zobrazit poptávky"
        override val createContactFirstForInquiry: String = "Nejprve vytvořte kontakt a potom přidejte poptávku z této nemovitosti."
        override val commonCheckedIn: String = "Checked in"
        override val commonNotScheduled: String = "not scheduled"
        override val todayTitle: String = "Dnes"
        override val todaySubtitle: String = "Denní prostor pro prohlídky, leady, připomínky a podklady pro prodávajícího."
        override val todayOpenHousesMetric: String = "prohlídky"
        override val capturedMetric: String = "captured"
        override val priorityMetric: String = "priority"
        override val noActivePropertiesTitle: String = "Žádné aktivní nemovitosti"
        override val noActivePropertiesBody: String = "Add or activate a nemovitost to make it appear on Dnes."
        override val checkIns: String = "Check-ins"
        override val allOpenHouses: String = "all prohlídky"
        override val pendingDrafts: String = "pending drafts"
        override val priorityLead: String = "Priorita lead"
        override val nextOpenHouseAt: String = "Next prohlídka at"
        override val noOpenHouseScheduled: String = "Žádné prohlídka scheduled"
        override val personalAccount: String = "Osobní účet"
        override val accountReady: String = "Váš účet je připraven"
        override val realEstateApp: String = "Realitní aplikace"
        override val needHelp: String = "Potřebujete pomoc?"
        override val contactSupport: String = "Kontaktovat podporu"
        override val upgradePlan: String = "Vylepšit plán"
        override val planSuffix: String = "Plán"
        override val todayActionsTitle: String = "Dnešní priority"
        override val agencyInvitation: String = "Agentura invitation"
        override val joinAgency: String = "Join"
        override val youWereInvitedAs: String = "You were pozvatd as"
        override val invitedBy: String = "od"
        override val decline: String = "Decline"
        override val yourDefaultAgency: String = "Your default agentura"
        override val chooseAgencyBody: String = "Vybrat which agentura you want to work with. Agentura tools include pozvats, shared leady, and branding."
        override val agencyMembersSuffix: String = "členové"
        override val quickActionTasksBody: String = "Queue"
        override val quickActionReportsBody: String = "Seller"
        override val quickActionAnalyticsBody: String = "Trends"
        override val quickActionAddPropertyTitle: String = "Přidat"
        override val quickActionAddPropertyBody: String = "Nabídka"
        override val quickActionAddContactTitle: String = "Kontakt"
        override val quickActionAddContactBody: String = "Nový"
        override val quickActionFilesTitle: String = "Soubory"
        override val quickActionFilesBody: String = "Dok."
        override val firstRunStepsTitle: String = "Začít with four simple steps"
        override val firstRunAddProperty: String = "Add nemovitost"
        override val firstRunScheduleOpening: String = "Schedule prohlídka"
        override val firstRunStartGuestCheckIn: String = "Začít guest check-in"
        override val firstRunSendFollowUp: String = "Odeslat připomínka"
        override val greetingNamePrefix: String = "Ahoj"
        override val greetingAgent: String = "Ahoj agente"
        override val createListing: String = "Vytvořit listing"
        override val newOwnerBuyer: String = "New vlastník/buyer"
        override val documents: String = "Dokumenty"
        override val whatOpeningNext: String = "Která prohlídka je další?"
        override val whoCheckedIn: String = "Kdo se přihlásil?"
        override val whoNeedsFollowUp: String = "Kdo čeká na připomínku?"
        override val whatShouldIDoNow: String = "Co mám udělat teď?"
        override val noCheckInsYet: String = "Zatím se nepřihlásil žádný kontakt."
        override val noPendingFollowUps: String = "Momentálně nejsou žádné čekající připomínky."
        override val openKioskForNextOpening: String = "Otevřete kiosk pro nejbližší prohlídku."
        override val reviewNewLeads: String = "Zkontrolujte nové leady a odešlete připomínky."
        override val createOpeningToStart: String = "Vytvořte prohlídku z nemovitosti a začněte sbírat leady."
        override val addFirstPropertyToStart: String = "Začněte přidáním první nemovitosti."
        override val nextOpening: String = "Další prohlídka"
        override val quickSignIn: String = "Rychlé přihlášení"
        override val scanQrCode: String = "Skenovat QR kód"
        override val newLead: String = "Nový lead"
        override val myProperties: String = "Moje nemovitosti"
        override val manageListings: String = "Spravovat nabídky"
        override val todaysOverview: String = "Dnešní přehled"
        override val seeAll: String = "Zobrazit vše"
        override val propertiesEyebrow: String = "Portfólio"
        override val propertiesSubtitle: String = "Manage aktivní, plánned, and archived listings with listing media, buyer activity, and performance insights."
        override val propertiesLiveMetric: String = "live"
        override val propertiesPipelineMetric: String = "pipeline"
        override val propertiesAllTimeMetric: String = "all time"
        override val addProperty: String = "Pridat nemovitost"
        override val editProperty: String = "Upravit nemovitost"
        override val propertyFallback: String = "Nemovitost"
        override val propertyUnavailableTitle: String = "Nemovitost není dostupná"
        override val propertyUnavailableBody: String = "Refresh the portfolio to reload this listing."
        override val backToProperties: String = "Zpět na nemovitosti"
        override val deletePropertyTitle: String = "Smazat nemovitost?"
        override val deletePropertyBody: String = "This will permanently smazat the nemovitost and its related local records. Tuto akci nelze vrátit zpět."
        override val loadingProperties: String = "Načítám nemovitosti"
        override val loadMore: String = "Načíst další"
        override val loadingPropertyDetails: String = "Načítám nemovitost details"
        override val noPropertiesTitle: String = "Zatím žádné nemovitosti"
        override val noPropertiesBody: String = "Add your first nemovitost, then vytvořit an prohlídka to start collecting leady and seller-ready feedback."
        override val openHouseButton: String = "Prohlídka"
        override val photosTitle: String = "Fotky"
        override val photosBody: String = "The first fotka is used as the main nemovitost image across Portfolio."
        override val uploadPhoto: String = "Nahrát fotku"
        override val noPhotosYet: String = "Zatím nejsou nahrané žádné fotky."
        override val propertyPhotoCountPlanLimit: String = "Dosáhli jste limitu fotek pro tuto nemovitost ve svém aktuálním plánu. Upgradujte plán a nahrajte další fotky."
        override val propertyPhotoStoragePlanLimit: String = "Dosáhli jste limitu úložiště ve svém aktuálním plánu. Upgradujte plán a nahrajte další fotky nebo soubory."
        override val mainPhoto: String = "Hlavní"
        override val propertyTitleLabel: String = "Název nemovitosti"
        override val propertyAddressLine1Label: String = "Ulice a číslo"
        override val propertyAddressLine2Label: String = "Doplnění adresy"
        override val propertyCityLabel: String = "Město"
        override val propertyRegionLabel: String = "Kraj"
        override val propertyPostalCodeLabel: String = "PSČ"
        override val propertyCountryLabel: String = "Země"
        override val propertyAskingPriceLabel: String = "Nabídková cena"
        override val propertyBedsLabel: String = "Pokoje"
        override val propertyBathsLabel: String = "Koupelny"
        override val propertyInteriorLabel: String = "Interiér"
        override val propertyDescriptionLabel: String = "Popis"
        override val createPropertyButton: String = "+ Nabídka"
        override val locateProperty: String = "Lokalizovat nemovitost"
        override val findLocation: String = "Najít polohu"
        override val find: String = "Najít"
        override val navigate: String = "Navigovat"
        override val propertyLocationMarkerTitle: String = "Poloha nemovitosti"
        override val mapKitJsMissingToken: String = "Mapa není pro tento build nakonfigurována."
        override val mapKitJsLoading: String = "Načítá se MapKit JS..."
        override val generateSellerReport: String = "Vygenerovat report pro prodávajícího"
        override val deleteProperty: String = "Smazat nemovitost"
        override val conversionMetric: String = "Konverze"
        override val propertyPhotoContentDescription: String = "Fotka nemovitosti"
        override val deletePhoto: String = "Smazat fotku"
        override val movePhotoLeft: String = "Přesunout fotku doleva"
        override val movePhotoRight: String = "Přesunout fotku doprava"
        override val propertyTitleRequired: String = "Název nemovitosti je povinný."
        override val propertyStreetRequired: String = "Ulice a číslo jsou povinné."
        override val propertyCityRequired: String = "Město je povinné."
        override val propertyRegionRequired: String = "Kraj je povinný."
        override val propertyPostalRequired: String = "PSČ je povinné."
        override val propertyAskingPriceInvalid: String = "Zadejte platnou nabídkovou cenu."
        override val propertyOwnerContactTitle: String = "Kontakt na majitele nemovitosti"
        override val propertyOwnerSelectContact: String = "Vyberte existující kontakt jako majitele nemovitosti."
        override val propertyOwnerSelected: String = "Vybraný majitel"
        override val propertyOwnerNoContacts: String = "Zatím nemáte žádné kontakty. Přidejte majitele v Kontaktech a potom ho zde vyberte."
        override val propertyOwnerChooseContact: String = "Vybrat kontakt"
        override val propertyOwnerChangeContact: String = "Změnit kontakt"
        override val propertyOwnerRemoveContact: String = "Odebrat"
        override val propertyOwnerPickerTitle: String = "Vyberte majitele nemovitosti"
        override val propertyOwnerSearchContact: String = "Hledat kontakty"
        override val propertyOwnerSearchHint: String = "Začněte psát jméno, e-mail nebo telefon."
        override val propertyOwnerNoMatches: String = "Žádné odpovídající kontakty."
        override val propertyOpeningsTitle: String = "Prohlídky"
        override val propertyNoOpenings: String = "Pro tuto nemovitost nejsou naplánované žádné prohlídky."
        override val teamAccessTitle: String = "Přístup týmu"
        override val onlyListingOwner: String = "Pouze vlastník nabídky"
        override val assignTeam: String = "Přiřadit tým"
        override val assignPropertyTitle: String = "Přiřadit nemovitost"
        override val assignPropertyBody: String = "Vyberte, kdo může pracovat s touto nemovitostí. Vyberte celý tým nebo konkrétní agenty."
        override val wholeTeam: String = "Celý tým"
        override val leadsEyebrow: String = "Leady"
        override val leadFallback: String = "Lead"
        override val leadsSubtitle: String = "Vyhledávejte, filtrujte a kvalifikujte leady ze všech prohlídek."
        override val leadDetailSubtitle: String = "Zdroj, kvalifikace, poznámky a historie připomínek pro tento lead z prohlídky."
        override val totalMetric: String = "Celkem"
        override val loggedMetric: String = "zapsáno"
        override val searchLeads: String = "Hledat leady"
        override val searchLeadsPlaceholder: String = "Jméno, telefon nebo e-mail"
        override val allProperties: String = "Všechny nemovitosti"
        override val loadingLeads: String = "Načítám leady z prohlídek"
        override val loadingLeadDetails: String = "Načítám detail leadu"
        override val noLeadsFoundTitle: String = "Leady se zobrazí zde, když se kontakty přihlásí na prohlídku."
        override val noLeadsEmptyBody: String = "Použijte kiosk nebo přidejte kontakty ručně z prohlídky."
        override val noLeadsFilteredBody: String = "Zkuste jinou nemovitost, stav nebo hledaný výraz."
        override val backToLeads: String = "Zpět na leady"
        override val leadUnavailableTitle: String = "Lead není dostupný"
        override val leadUnavailableBody: String = "Tento lead už není dostupný v aktuálním seznamu leadů."
        override val leadTemperature: String = "Stav leadu"
        override val leadLabelSuffix: String = "Lead"
        override val greetingHi: String = "Dobrý den"
        override val leadActionCall: String = "Zavolat"
        override val leadActionSms: String = "SMS"
        override val leadActionEmail: String = "E-mail"
        override val leadFollowUp: String = "Připomínka"
        override val leadNoFollowUpScheduled: String = "Připomínka není naplánovaná"
        override val leadIntentScore: String = "Skóre zájmu"
        override val leadInterestedIn: String = "Zájem o"
        override val leadGenericGreetingName: String = "vás"
        override val followUpMessageTypeThankYou: String = "Poděkování"
        override val followUpMessageTypePropertyInfo: String = "Info o nemovitosti"
        override val followUpMessageTypeFollowUp: String = "Připomínka"
        override val followUpMessageTypeCheckIn: String = "Ověření zájmu"
        override val followUpMessageTypePriceUpdate: String = "Změna ceny"
        override val followUpMessageTypePropertyBrochure: String = "Soubory"
        override val followUpPreview: String = "Náhled"
        override val followUpSubject: String = "Předmět"
        override val followUpMessage: String = "Zpráva"
        override val followUpSendViaEmail: String = "Odeslat e-mailem"
        override val followUpSendViaSms: String = "Odeslat SMS"
        override val followUpAiAssistantTitle: String = "AI asistent"
        override val followUpAiAssistantBody: String = "Vygenerujte osobní zprávu během několika sekund."
        override val followUpGenerateWithAi: String = "Vygenerovat pomocí AI"
        override val followUpUpgradeForAi: String = "Odemknout AI"
        override val followUpDefaultSubject: String = "Připomínka k nemovitosti"
        override val privateAgentNotes: String = "Private agent notes"
        override val notes: String = "Notes"
        override val notesPlaceholder: String = "Motivation, preferences, objections, next move"
        override val saveNotes: String = "Uložit notes"
        override val followUpHistory: String = "Historie připomínek"
        override val noFollowUpsLogged: String = "Zatím nejsou zapsané žádné připomínky."
        override val openHousesEyebrow: String = "Showings"
        override val scheduleOpenHouse: String = "Vytvořit prohlídku"
        override val openingDetails: String = "Detail prohlídky"
        override val editOpening: String = "Upravit prohlídku"
        override val deleteOpening: String = "Smazat prohlídku"
        override val deleteOpeningBody: String = "Opravdu chcete tuto prohlídku smazat? Tuto akci nelze vrátit zpět."
        override val removeLeadTitle: String = "Odebrat lead?"
        override val removeLeadBody: String = "Odebrat %s z této prohlídky?"
        override val removeLeadFallback: String = "tento lead"
        override val openingName: String = "Název prohlídky"
        override val startsAt: String = "Začíná"
        override val endsAt: String = "Končí"
        override val chooseStartDateTime: String = "Vyberte datum a čas začátku"
        override val chooseEndDateTime: String = "Vyberte datum a čas konce"
        override val accessNotes: String = "Poznámky k přístupu"
        override val privateNotes: String = "Soukromé poznámky"
        override val addPrivateNote: String = "Přidat soukromou poznámku"
        override val liveDashboard: String = "Live dashboard"
        override val visitorKiosk: String = "Lead kiosk"
        override val openHousesSubtitle: String = "Vytvořit prohlídky for nemovitosti, rezobrazit leady, and launch kiosk sessions."
        override val liveMetric: String = "Live"
        override val upcomingMetric: String = "Nadcházející"
        override val inProgressMetric: String = "in progress"
        override val scheduledMetric: String = "scheduled"
        override val loadingOpenHouses: String = "Načítám prohlídky"
        override val addPropertyFirstTitle: String = "Add a nemovitost first"
        override val addPropertyFirstBody: String = "Vytvořit an prohlídka from a nemovitost to start collecting leady."
        override val noOpenHousesTitle: String = "Žádné prohlídky scheduled"
        override val noOpenHousesBody: String = "Vytvořit an prohlídka from a nemovitost to start collecting leady."
        override val noSignInsTitle: String = "Žádné sign-ins yet"
        override val noSignInsBody: String = "Leady checked in through kiosk mode will appear here in real time."
        override val dashboard: String = "Dashboard"
        override val start: String = "Začít"
        override val end: String = "Konec"
        override val endOpenHouse: String = "Konec prohlídka"
        override val reportsEyebrow: String = "Vlastníks"
        override val sellerReportsTitle: String = "Reporty pro prodávající"
        override val createReport: String = "Report"
        override val reportPreview: String = "Report pro prodávajícího"
        override val reportsSubtitle: String = "Vytvářejte prémiová shrnutí po prohlídkách s kvalitou leadů, zájmem kupujících a textem připraveným pro prodávajícího."
        override val reportsMetricSaved: String = "uložitd"
        override val reportedMetric: String = "reported"
        override val leadsMetric: String = "leady"
        override val createSellerReport: String = "Report"
        override val attendance: String = "Návštěvnost"
        override val savedReports: String = "uložitd reporty"
        override val buyerHeat: String = "Zájem kupujících"
        override val hotLeads: String = "horké"
        override val loadingSellerReports: String = "Načítám reporty pro prodávající"
        override val noSellerReportsTitle: String = "Žádné reporty pro prodávající yet"
        override val noSellerReportsBody: String = "Vybrat an prohlídka, add agent notes, prezobrazit an export-ready recap, then uložit it."
        override val chooseOpenHouse: String = "Vybrat prohlídka"
        override val noOpenHousesAvailable: String = "Žádné prohlídky dostupné zatím."
        override val agentNotes: String = "Agent notes"
        override val notesForSeller: String = "Notes for seller"
        override val sellerNotesPlaceholder: String = "Námitky kupujících, signály ceny, zpětná vazba z prohlídky, doporučený další krok"
        override val generatePreview: String = "Generate prezobrazit"
        override val noPreviewReadyTitle: String = "Žádné prezobrazit ready"
        override val noPreviewReadyBody: String = "Generate a report pro prodávajícího prezobrazit před saving."
        override val saveReport: String = "Uložit"
        override val reportSaved: String = "Report uložitd"
        override val sellerOpenHouseReport: String = "Seller prohlídka report"
        override val mostCommonBuyerInterest: String = "Most common buyer interest"
        override val followUpsSent: String = "Odeslané připomínky"
        override val summary: String = "Souhrn"
        override val noPrivateNotesAdded: String = "Žádné private notes added."
        override val openHouseReport: String = "Prohlídka report"
        override val commonDraft: String = "Koncept"
        override val commonAccepted: String = "Přijato"
        override val searchSellerReports: String = "Hledat reporty pro prodávající"
        override val noMatchingReports: String = "Žádné odpovídající reporty"
        override val clearFilters: String = "Clear filters"
        override val tryDifferentSearchOrStatusFilter: String = "Zkuste jiné vyhledávání nebo filtr stavu."
        override val connectedToProperty: String = "Přiřazeno k nemovitosti"
        override val viewProperty: String = "Zobrazit nemovitost"
        override val dataRollup: String = "Data rollup"
        override val connectedOpenings: String = "Prohlídky"
        override val visitors: String = "Návštěvníci"
        override val interestedBuyers: String = "Zájemci"
        override val completedFollowUps: String = "Follow Ups"
        override val reportHistory: String = "Report history"
        override val noPreviousReportsYet: String = "Zatím žádné předchozí reporty."
        override val viewAllReports: String = "Zobrazit všechny reporty"
        override val actions: String = "Akce"
        override val generatePdf: String = "Vytvořit tabulku"
        override val previewPdf: String = "Náhled tabulky"
        override val pdfSavedToPropertyFiles: String = "%s uložitd to nemovitost soubory."
        override val pdfSavingToPropertyFiles: String = "%s is being uložitd to nemovitost soubory."
        override val pdfSavedToFiles: String = "%s uložitd to soubory."
        override val pdfSavingToFiles: String = "%s is being uložitd to soubory."
        override val pdfIncludesSellerReport: String = "Spreadsheet includes Report pro prodávajícího metrics, AI insights, agent details, nemovitost data, and prohlídka history."
        override val pdfIncludesAnalytics: String = "Spreadsheet includes analytika metrics, top nemovitosti, agent performance, připomínka channels, and AI insights."
        override val pdfGenerateBeforeSending: String = "Vytvořit the spreadsheet před odeslating."
        override val pdfUploadBeforeSharing: String = "The spreadsheet must finish upnačítám před sharing."
        override val sellerReportPdfNeedsProperty: String = "Tabulka reportu pro prodávajícího vyžaduje před nahráním přiřazenou nemovitost."
        override val deleteReport: String = "Smazat Report"
        override val deleteReportBody: String = "Opravdu chcete smazat this report pro prodávajícího? Tuto akci nelze vrátit zpět."
        override val shareReport: String = "Share report"
        override val openingPropertyReportLoading: String = "Nemovitost report..."
        override val openingPropertyReportCreating: String = "Creating nemovitost report..."
        override val sellerReportGeneratedPrefix: String = "Report pro prodávajícího generated"
        override val sellerReportGeneratedSuffix: String = "z prohlídek, návštěvníků, leadů, připomínek a zpětné vazby přiřazené k této nemovitosti v čase reportu."
        override val priceNotSet: String = "Cena not set"
        override val daysSuffix: String = "dní"
        override val connectedOpeningSingular: String = "prohlídka"
        override val connectedOpeningPlural: String = "prohlídky"
        override val connectedLeadSingular: String = "přiřazený lead"
        override val connectedLeadPlural: String = "přiřazené leady"
        override val sellerConfidence: String = "Seller confidence"
        override val sellerConfidenceExplanation: String = "Confidence explánation"
        override val aiDraftReviewBeforeSending: String = "AI draft only. Rezobrazit and upravit před odeslating to the seller."
        override val executiveSummary: String = "Executive summary"
        override val buyerInterestOverview: String = "Přehled zájmu kupujících"
        override val whatBuyersLoved: String = "What buyers loved"
        override val buyerConcerns: String = "Obavy kupujících"
        override val leadQualitySummary: String = "Souhrn kvality leadů"
        override val agentActivity: String = "Agent activity"
        override val aiRecommendations: String = "AI recommendations"
        override val recommendations: String = "Doporučení"
        override val marketPositionComparison: String = "Market position comparison"
        override val nextSteps: String = "Next steps"
        override val conversion: String = "Konverze"
        override val interested: String = "interested"
        override val tourSignalsLowercase: String = "tour signals"
        override val propertyTimeline: String = "Nemovitost timeline"
        override val timelineBasisNote: String = "Časová osa vychází pouze z přiřazených registrací na prohlídky a připomínek."
        override val visitorsLowercase: String = "návštěvníci"
        override val hotLeadsLowercase: String = "horké leady"
        override val hotLowercase: String = "horké"
        override val sentiment: String = "Sentiment"
        override val toursLowercase: String = "tours"
        override val interestedLowercase: String = "interested"
        override val noRepeatedFeedbackMentions: String = "Žádné repeated feedback mentions have been recorded zatím."
        override val scoresMentionRates: String = "Skóres are mention rates across uložitd buyer feedback."
        override val aiExecutiveBriefing: String = "AI executive briefing"
        override val viewAllAiInsights: String = "Zobrazit all AI insights ->"
        override val followUpsSentTitle: String = "Follow-Ups Sent"
        override val financingPacketsShared: String = "Financing Packets Shared"
        override val buyerCalls: String = "Hovory s kupujícími"
        override val propertyDataEvidence: String = "Nemovitost data evidence"
        override val attendanceCoverage: String = "Pokrytí návštěvnosti"
        override val leadQuality: String = "Kvalita leadů"
        override val followUpExecution: String = "Připomínka execution"
        override val activityChannels: String = "Kanály aktivity"
        override val callsLowercase: String = "hovory"
        override val emailsLowercase: String = "e-maily"
        override val offerReadinessScore: String = "Offer readiness score"
        override val date: String = "Datum"
        override val propertyLeadFunnel: String = "Nemovitost lead funnel"
        override val openHouseBreakdown: String = "Open house breakdown"
        override val aiInsights: String = "AI poznatky"
        override val generateAiInsights: String = "Vygenerovat AI poznatky"
        override val analyticsOverview: String = "Analytika overzobrazit"
        override val allAgents: String = "All agents"
        override val me: String = "Já"
        override val allActivity: String = "All activity"
        override val latest30Days: String = "Latest 30 dní"
        override val latest7Days: String = "Latest 7 dní"
        override val analyticsDatePreset: String = "Období"
        override val analyticsCustomDate: String = "Custom date"
        override val analyticsLastDay: String = "Poslední den"
        override val analyticsLastWeek: String = "Poslední týden"
        override val analyticsLastMonth: String = "Poslední měsíc"
        override val analyticsLastYear: String = "Poslední rok"
        override val analyticsAllTime: String = "Celé období"
        override val analyticsDateFrom: String = "Datum from"
        override val analyticsDateTo: String = "Datum to"
        override val analyticsOpenHousesLowercase: String = "prohlídky"
        override val analyticsWarmLeadsLowercase: String = "teplé leady"
        override val analyticsFromNotesFollowUps: String = ""
        override val analyticsFromText: String = "z textu"
        override val analyticsHotConversion: String = "Konverze horkých leadů"
        override val analyticsHotLeadsPerVisitors: String = "horké leady / návštěvníci"
        override val analyticsAverageIntent: String = "Avg. intent"
        override val analyticsVisitorIntentScore: String = "visitor intent score"
        override val analyticsSelectDate: String = "Vybrat date"
        override val propertyFunnel: String = "Nemovitost funnel"
        override val propertyFunnelSubtitle: String = "From nemovitost activity to qualified buyer momentum"
        override val properties: String = "Nemovitosti"
        override val tourSignals: String = "Signály prohlídek"
        override val offerSignals: String = "Signály nabídek"
        override val viewFullFunnelReport: String = "Zobrazit full funnel report"
        override val performanceOverTime: String = "Výkon v čase"
        override val thirtyDays: String = "30 dní"
        override val topPerformingProperties: String = "Nejvýkonnější nemovitosti"
        override val viewAll: String = "Zobrazit all"
        override val noPropertyAnalyticsYet: String = "Žádné nemovitost analytika zatím."
        override val leadQualityBreakdown: String = "Rozdělení kvality leadů"
        override val warmLeadsTitle: String = "Teplé leady"
        override val coldLeadsTitle: String = "Studené leady"
        override val followUpPerformance: String = "Připomínka performance"
        override val agentPerformance: String = "Agent performance"
        override val viewTeamReport: String = "Zobrazit týmový report"
        override val followUpChannels: String = "Připomínka channels"
        override val viewReport: String = "Zobrazit report"
        override val searchProperties: String = "Hledat nemovitosti"
        override val searchOpenings: String = "Hledat prohlídky"
        override val noOpeningsFoundTitle: String = "Žádné prohlídky found"
        override val noOpeningsFoundBody: String = "Zkuste jiné vyhledávání nebo filtr stavu prohlídky."
        override val noMatchingPropertiesTitle: String = "Žádné odpovídající nemovitosti"
        override val noMatchingPropertiesBody: String = "Zkuste jiné vyhledávání nebo filtr stavu."
        override val clientsTitle: String = "Kontakty"
        override val clientFallback: String = "Kontakt"
        override val addClient: String = "Přidat kontakt"
        override val editClient: String = "Upravit kontakt"
        override val newClient: String = "Nový kontakt"
        override val saveClient: String = "Uložit kontakt"
        override val createClient: String = "Vytvořit kontakt"
        override val deleteClientTitle: String = "Smazat kontakt?"
        override val deleteClientBody: String = "This will permanently smazat the kontakt. Tuto akci nelze vrátit zpět."
        override val firstName: String = "Jméno"
        override val lastName: String = "Příjmení"
        override val email: String = "E-mail"
        override val phone: String = "Telefon"
        override val comments: String = "Komentáře"
        override val addPhoto: String = "Přidat fotku"
        override val sendQr: String = "Odeslat QR"
        override val sendQrShareTitle: String = "Váš HAVN QR kód na prohlídku"
        override val sendQrShareBody: String = "V příloze je váš HAVN QR kód na prohlídku. Jakmile bude k dispozici Wallet pass (.pkpass), přidejte si ho do telefonu, nebo na prohlídce ukažte QR obrázek."
        override val sendQrReadyMessage: String = "QR kód je připraven k odeslání"
        override val sendQrUnavailableError: String = "Pro tento kontakt není dostupná žádná e-mailová ani SMS aplikace."
        override val clientQrDeliveryRequired: String = "Pro doručení QR přidejte e-mail nebo telefonní číslo."
        override val photo: String = "Fotka"
        override val clientDetailSubtitle: String = "QR identita, kontaktní údaje, komentáře a prohlídky propojené přes leady."
        override val clientFormEditSubtitle: String = "Upravte kontaktní údaje, doručení a komentáře."
        override val clientFormNewSubtitle: String = "Zaregistrujte kupujícího/kontakt a vytvořte opakovaně použitelnou QR identitu pro prohlídky."
        override val searchClients: String = "Hledat kontakty"
        override val noClientsYetTitle: String = "Zatím žádné kontakty"
        override val noClientsYetBody: String = "Nejprve zaregistrujte kontakty a potom jim před prohlídkou odešlete QR kód e-mailem nebo SMS."
        override val noClientsFoundTitle: String = "Nenašly se žádné kontakty"
        override val noClientsFoundBody: String = "Zkuste jiné jméno, telefon nebo e-mail."
        override val clientUnavailableTitle: String = "Kontakt není dostupný"
        override val clientUnavailableBody: String = "Obnovte seznam kontaktů a otevřete tento záznam znovu."
        override val noCommentsAdded: String = "Nebyly přidány žádné komentáře."
        override val openingsTitle: String = "Prohlídky"
        override val clientOpeningsEmpty: String = "Zatím nejsou připojené žádné prohlídky. Leady propojují kontakt s prohlídkou."
        override val clientPassLabel: String = "Wallet pass"
        override val clientNoEmail: String = "Bez e-mailu"
        override val visitorsBody: String = "Otevřete kiosk, naskenujte QR kontaktu nebo přidejte existující kontakty jako leady pro tuto prohlídku."
        override val openKiosk: String = "Otevřít kiosk"
        override val addQrClient: String = "QR kontakt"
        override val addManually: String = "Ručně"
        override val selectClients: String = "Vybrat kontakty"
        override val selectClientsBody: String = "Vyberte kontakty ze seznamu. Každý vybraný kontakt se stane leadem pro tuto prohlídku."
        override val kioskCheckIn: String = "Kiosk check-in"
        override val kioskCheckInBody: String = "Použijte zadní kameru ke skenování HAVN Wallet QR kontaktu. Po rozpoznání kódu HAVN automaticky vytvoří lead pro tuto prohlídku."
        override val scanWithCamera: String = "Skenovat zadní kamerou"
        override val clientQrImage: String = "QR obrázek kontaktu"
        override val clientQrImageBody: String = "Držte QR kontaktu ve zlatém čtverci. HAVN přidá každý sken do seznamu níže."
        override val scanMultipleQrBody: String = "Naskenujte jeden nebo více HAVN QR kódů kontaktů a potom klepněte na Přidat QR kontakt."
        override val scannedQrReady: String = "QR kontakt připravený k přidání"
        override val createLeadFromQr: String = "Vytvořit lead z QR"
        override val noClientsFoundShort: String = "Nenašly se žádné kontakty."
        override val remove: String = "Odebrat"
        override val tasksTitle: String = "Úkoly"
        override val addTask: String = "Add úkol"
        override val searchTasks: String = "Hledat úkoly"
        override val loadMoreTasks: String = "Load more úkoly"
        override val createTask: String = "Vytvořit Úkol"
        override val saveTask: String = "Uložit Úkol"
        override val editTask: String = "Upravit Úkol"
        override val newTask: String = "New úkol"
        override val taskDetails: String = "Úkol Details"
        override val taskName: String = "Název"
        override val taskDescription: String = "Popis"
        override val taskDueDateTime: String = "Úkol date & time"
        override val chooseTaskDateTime: String = "Vybrat úkol date & time"
        override val clearTaskDateTime: String = "Clear date & time"
        override val assignToAgent: String = "Přiřadit agentovi"
        override val noAgencyAgentsFound: String = "Žádné agentura agents found. The úkol will stay assigned to the vlastník."
        override val taskPriority: String = "Úkol Priorita"
        override val taskStatus: String = "Stav"
        override val taskVisibility: String = "Viditelnost"
        override val taskOwner: String = "Vlastník"
        override val taskOwnerFallback: String = "Úkol vlastník"
        override val assignedTo: String = "Assigned to"
        override val selectedAgent: String = "Vybráno agent"
        override val taskVisibilityBody: String = "This úkol is visible to the vlastník and the assigned agent."
        override val taskQueue: String = "Úkol queue"
        override val taskDetail: String = "Úkol detail"
        override val taskDetailEmpty: String = "Vybrat a úkol to see context and next actions."
        override val connectedContext: String = "Propojený kontext"
        override val noTaskContext: String = "Žádné nemovitost, kontakt, prohlídka, or lead is linked zatím."
        override val activityTimeline: String = "Časová osa aktivity"
        override val created: String = "Vytvořitd"
        override val recently: String = "Nedávnély"
        override val completed: String = "Dokončeno"
        override val nextAction: String = "Next action"
        override val agentReviewOrCompletion: String = "Agent rezobrazit or completion"
        override val noDueDate: String = "Žádné due date"
        override val reopen: String = "Znovu otevřít"
        override val accept: String = "Přijmout"
        override val linkedTasks: String = "Propojené úkoly"
        override val noLinkedTasks: String = "Žádné linked úkoly zatím."
        override val filesTitle: String = "Soubory"
        override val attachFile: String = "Attach soubor"
        override val noFilesAttached: String = "Žádné soubory attached zatím."
        override val fileLimitHint: String = "Soubory can be PDF, DOC, CAD, or other formats up to 20 MB each."
        override val deleteFileTitle: String = "Smazat soubor?"
        override val deleteFileBody: String = "This soubor will be removed from HAVN storage."
        override val attachmentOpenFailed: String = "Soubor se nepodařilo otevřít."
        override val attachmentDeleteOwnerOnly: String = "Only the soubor vlastník can smazat this attachment."
        override val attachmentDocumentsNotIncluded: String = "Váš aktuální plán neobsahuje nahrávání souborů. Upgradujte plán a nahrajte soubory."
        override val attachmentDocumentStorageNotIncluded: String = "Váš aktuální plán neobsahuje úložiště dokumentů. Upgradujte plán a nahrajte soubory."
        override val attachmentFileSizePlanLimit: String = "Tento soubor je větší, než povoluje váš aktuální plán. Upgradujte plán a nahrajte větší soubory."
        override val attachmentStoragePlanLimit: String = "Dosáhli jste limitu úložiště ve svém aktuálním plánu. Upgradujte plán a nahrajte další soubory."
        override val attachmentDocumentCountPlanLimit: String = "Dosáhli jste limitu dokumentů pro tuto nemovitost ve svém aktuálním plánu. Upgradujte plán a nahrajte další soubory."
        override val attachmentHardFileLimit: String = "Přílohy jsou omezeny na 100 MB."
        override val openFiles: String = "Otevřít soubory"
        override val sendViaEmail: String = "Odeslat e-mailem"
        override val sendViaSms: String = "Odeslat SMS"
        override val sendEmailHeader: String = "Odeslat e-mail"
        override val sendSmsHeader: String = "Odeslat SMS"
        override val noContactsFound: String = "Žádné kontakty found."
        override val searchContacts: String = "Hledat kontakty"
        override val linked: String = "Propojené"
        override val recent: String = "Nedávné"
        override val taskColumnToDo: String = "To Do"
        override val taskColumnInProgress: String = "In Progress"
        override val taskColumnDone: String = "Hotovo"
        override val taskColumnToDoSubtitle: String = "New úkoly and next actions waiting to be started."
        override val taskColumnInProgressSubtitle: String = "Work currently owned od you or the team."
        override val taskColumnDoneSubtitle: String = "Dokončeno úkoly kept visible for team confidence."
        override val taskEmptyToDo: String = "Žádné úkoly to do."
        override val taskEmptyInProgress: String = "Nothing in progress."
        override val taskEmptyDone: String = "Žádné completed úkoly zatím."
        override val taskKanbanEmptyToDo: String = "Nothing waiting. New připomínky and report work will appear here."
        override val taskKanbanEmptyInProgress: String = "Žádné aktivní work in progress."
        override val taskKanbanEmptyDone: String = "Dokončeno úkoly will land here."
        override val taskEmptyBodyPrefix: String = "Vytvořit a úkol or move another úkol into"
        override val taskEmptyBodySuffix: String = "."
        override val taskActionStart: String = "Začít"
        override val taskActionOverdue: String = "Po termínu"
        override val taskActionCancel: String = "Zrušit"
        override val taskPriorityLow: String = "Low"
        override val taskPriorityMedium: String = "Jádium"
        override val taskPriorityHigh: String = "High"
        override val taskPriorityUrgent: String = "Urgent"
        override val taskStatusOpen: String = "Open"
        override val taskStatusInProgress: String = "In progress"
        override val taskStatusDone: String = "Hotovo"
        override val taskStatusOverdue: String = "Po termínu"
        override val taskStatusCancelled: String = "Zrušeno"
        override val aiSuggestedTasks: String = "AI návrhy úkolů"
        override val noAiSuggestedTasks: String = "Žádné AI suggestions zatím. HAVN will suggest úkoly po prohlídky and lead activity."
        override val taskFilterToday: String = "Dnes"
        override val taskFilterUpcoming: String = "Nadcházející"
        override val taskFilterOverdue: String = "Po termínu"
        override val taskFilterCompleted: String = "Dokončeno"
        override val taskFilterAssignedToMe: String = "Assigned to Já"
        override val taskFilterAiSuggested: String = "AI návrhy"
        override val taskFilterEmptyToday: String = "You're clear for dnes."
        override val taskFilterEmptyUpcoming: String = "Žádné upcoming úkoly."
        override val taskFilterEmptyOverdue: String = "Žádné overdue úkoly."
        override val taskFilterEmptyCompleted: String = "Žádné completed úkoly zatím."
        override val taskFilterEmptyAssignedToMe: String = "Žádné úkoly assigned to you."
        override val taskFilterEmptyAiSuggested: String = "Žádné accepted AI suggested úkoly zatím."
        override val taskSuggestionHotLeadTitlePrefix: String = "Navázat kontakt s"
        override val taskSuggestionHotLeadTitleSuffix: String = "within 2 hours."
        override val taskSuggestionHotLeadDescriptionPrefix: String = "Hot lead from"
        override val taskSuggestionHotLeadDescriptionSuffix: String = "Keep momentum while intent is fresh."
        override val taskSuggestionHotLeadReason: String = "New hot lead captured."
        override val taskSuggestionSellerReportTitlePrefix: String = "Generate report pro prodávajícího for"
        override val taskSuggestionSellerReportTitleSuffix: String = "."
        override val taskSuggestionSellerReportDescription: String = "Shrňte počet návštěvníků, horké leady, aktivitu připomínek a sentiment kupujících."
        override val taskSuggestionSellerReportReason: String = "Open house ended."
        override val taskSuggestionReviewFollowUpTitlePrefix: String = "Rezobrazit and odeslat"
        override val taskSuggestionReviewFollowUpTitleSuffix: String = "připomínka."
        override val taskSuggestionReviewFollowUpReason: String = "Připomínka draft still needs agent rezobrazit."
        override val taskSuggestionKioskTitle: String = "Připravte kiosk a zkontrolujte fotky nemovitosti."
        override val taskSuggestionKioskDescription: String = "Confirm sign-in flow, gallery, and prohlídka details před buyers arrive."
        override val taskSuggestionKioskReason: String = "Open house is scheduled."
    }

    private val spanish: HavnStrings = object : HavnStrings {
        override val navToday: String = "Hoy"
        override val navProperties: String = "Propiedades"
        override val navLeads: String = "Leads"
        override val navReports: String = "Informes"
        override val navTasks: String = "Tareas"
        override val navAnalytics: String = "Analítica"
        override val navAgency: String = "Agencia"
        override val navSettings: String = "Ajustes"
        override val navAuth: String = "Acceso agente"
        override val navOpenHouses: String = "Visitas"
        override val navTours: String = "Visitas"
        override val navFollowUps: String = "Contactos"
        override val navFollow: String = "Contactos"
        override val back: String = "Atras"
        override val settingsEyebrow: String = "Espacio de trabajo"
        override val settingsTitle: String = "Ajustes"
        override val settingsSubtitle: String = "Perfil, idioma, unidades, entorno y opciones de equipo."
        override val agentProfileTitle: String = "Perfil del agente"
        override val agentPhoto: String = "Foto del agente"
        override val uploading: String = "Subiendo..."
        override val saving: String = "Guardando..."
        override val validAgentPhotoRequired: String = "Elige una foto de agente válida."
        override val signOut: String = "Cerrar sesión"
        override val signOutQuestion: String = "¿Cerrar sesión?"
        override val signOutConfirmation: String = "¿Seguro que quieres cerrar sesión en HAVN?"
        override val deleteAccount: String = "Eliminar cuenta"
        override val deleteAccountQuestion: String = "¿Eliminar cuenta?"
        override val deleteAccountOpenPageBody: String = "Se abrirá la página de solicitud de eliminación de cuenta."
        override val deleteAccountReviewTitle: String = "Usa una cuenta real"
        override val deleteAccountReviewBody: String = "Esta cuenta de revisión de la app está protegida para que los revisores no pierdan el acceso durante las pruebas. Usa una cuenta de prueba real para verificar la eliminación de cuenta."
        override val upgrade: String = "Mejorar"
        override val premiumThemesTitle: String = "Temas premium"
        override val premiumThemesUpgradePrompt: String = "Mejora a Pro para desbloquear temas premium."
        override val appearanceTitle: String = "Apariencia"
        override val appearanceBody: String = "Elige el modo claro u oscuro para la aplicación web."
        override val previewComponents: String = "Vista previa de componentes"
        override val themeShowcaseTitle: String = "Vista previa del tema"
        override val showcaseButtons: String = "Botones"
        override val showcasePrimaryAction: String = "Acción principal"
        override val showcaseSecondaryAction: String = "Acción secundaria"
        override val showcaseGhostAction: String = "Acción discreta"
        override val showcaseTextField: String = "Campo de texto"
        override val showcaseFocusedBorder: String = "Borde de acento activo"
        override val showcaseSearchPreview: String = "Vista previa de búsqueda"
        override val showcaseOpeningCheckedIn: String = "Registro en una apertura hoy"
        override val showcaseSentAt: String = "Enviado a las 10:30"
        override val themeObsidianGoldName: String = "Obsidian Gold"
        override val themeObsidianGoldDescription: String = "Negro de lujo, grafito y oro cálido."
        override val themeMidnightSapphireName: String = "Midnight Sapphire"
        override val themeMidnightSapphireDescription: String = "Azul noche, zafiro y acentos plateados."
        override val themeEmeraldEstateName: String = "Emerald Estate"
        override val themeEmeraldEstateDescription: String = "Esmeralda oscuro, carbón y oro champán."
        override val themePlatinumStoneName: String = "Platinum Stone"
        override val themePlatinumStoneDescription: String = "Gris piedra, platino y blanco suave."
        override val themeBordeauxNoirName: String = "Bordeaux Noir"
        override val themeBordeauxNoirDescription: String = "Vino oscuro, grafito y acentos de cobre."
        override val commonChange: String = "Cambiar"
        override val agentPlanTitle: String = "Plan del agente"
        override val agentPlanBody: String = "Mejora tu experiencia y elige el plan que encaja con tu forma de trabajar."
        override val currentPlan: String = "Plan actual"
        override val transferPlan: String = "Transferir plan"
        override val transferPlanTitle: String = "Transferir plan"
        override val transferPlanBody: String = "Mueve esta suscripción a otra cuenta HAVN. Ambas direcciones de correo deben confirmar con códigos de verificación."
        override val transferTargetEmail: String = "Correo de la nueva cuenta"
        override val transferSendCodes: String = "Enviar códigos de verificación"
        override val transferCodesSentTitle: String = "Códigos enviados"
        override val transferCodesSentBody: String = "Enviamos un código a tu correo y otro al correo de la nueva cuenta."
        override val transferYourCode: String = "Código de tu correo"
        override val transferTargetCode: String = "Código de la nueva cuenta"
        override val transferConfirm: String = "Transferir plan"
        override val transferSuccessTitle: String = "Plan transferido"
        override val transferSuccessBody: String = "La suscripción ahora está conectada a la nueva cuenta HAVN."
        override val restorePurchase: String = "Restaurar compra"
        override val agencySettingsProBody: String = "Solo agency está activa por defecto. Pro permite crear o seleccionar una agencia compartida."
        override val agencySettingsLockedBody: String = "Solo agency está activa. Los cambios de agencia se desbloquean con Pro."
        override val soloAgency: String = "Solo agencia"
        override val defaultPrivateAgencyWorkspace: String = "Agencia privada predeterminada"
        override val noAgenciesAvailableYet: String = "Todavía no hay invitaciones ni agencias propias disponibles."
        override val oneOwnedAgencyHint: String = "Tu agencia propia aparece arriba. Un agente solo puede tener una agencia."
        override val createAgency: String = "Crear agencia"
        override val createYourAgency: String = "Crea tu agencia"
        override val createAgencyBody: String = "Construye tu equipo, gestiona propiedades juntos y haz crecer tu negocio."
        override val agencyName: String = "Nombre de la agencia"
        override val agencyEmail: String = "Email de la agencia"
        override val logoOptional: String = "Logo (opcional)"
        override val upgradeExperienceTitle: String = "Mejora tu experiencia"
        override val upgradeExperienceSubtitle: String = "Elige el plan que encaja con tu forma de trabajar."
        override val soloAgentPlan: String = "Solo agent"
        override val proAgentPlan: String = "Pro agent"
        override val teamAgentPlan: String = "Equipo"
        override val soloBenefitActiveProperties: String = "Hasta 1.000 propiedades"
        override val soloBenefitAiFollowUps: String = "1.000 solicitudes de texto con AI / mes"
        override val soloBenefitSellerReports: String = "Sin informes de vendedor"
        override val soloBenefitPersonalOnly: String = "Solo cuenta personal"
        override val proBenefitUnlimitedProperties: String = "Hasta 10.000 propiedades"
        override val proBenefitUnlimitedAi: String = "10.000 solicitudes de texto con AI / mes"
        override val proBenefitAdvancedReports: String = "Informes avanzados para vendedores"
        override val proBenefitAgencyCreation: String = "Creación y gestión de agencias"
        override val proBenefitInviteAgents: String = "Invitar agentes y colaborar"
        override val proBenefitSharedLeads: String = "Leads compartidos y flujos de equipo"
        override val proBenefitAgencyBranding: String = "Branding de agencia"
        override val proBenefitAdvancedAnalytics: String = "Analítica avanzada"
        override val teamBenefitLargeLimits: String = "Límites para equipos"
        override val teamBenefitPrioritySupport: String = "Soporte prioritario por e-mail"
        override val teamBenefitDailyBackups: String = "Copias diarias durante 7 días"
        override val teamBenefitLargeStorage: String = "10 GB de almacenamiento de documentos"
        override val startFreeTrial7Day: String = "Suscribirse ahora"
        override val restorePurchases: String = "Restaurar compra"
        override val comparePlans: String = "Comparar planes"
        override val startFreeTrial: String = "Elegir plan"
        override val noCommitmentCancelAnytime: String = "Sin compromiso. Cancela cuando quieras."
        override val monthly: String = "Mensual"
        override val yearly: String = "Anual"
        override val yearlySave20: String = "Anual"
        override val yearlySavings20: String = "Facturado anualmente."
        override val perYear: String = "/ año"
        override val loadingPlans: String = "Cargando planes..."
        override val selectedPlanUnavailable: String = "Este plan aún no está disponible. Inténtalo más tarde o contacta con soporte."
        override val signInRequiredForPurchase: String = "Inicia sesión antes de comprar."
        override val subscriptionDisclosureIos: String = "Suscripción autorrenovable. El pago se cargará a tu cuenta de Apple al confirmar la compra. Tu suscripción se renueva automáticamente salvo que la canceles al menos 24 horas antes del final del período actual. La renovación se cobrará dentro de las 24 horas previas al final del período actual. Puedes gestionar o cancelar tu suscripción en los ajustes de tu cuenta de App Store."
        override val subscriptionDisclosureAndroid: String = "Suscripción autorrenovable a través de Google Play. Se te cobrará en cada período de facturación salvo que canceles. Puedes gestionar o cancelar tu suscripción en cualquier momento en las suscripciones de Google Play. El acceso continúa hasta el final del período pagado."
        override val subscriptionDisclosureWeb: String = "Suscripción autorrenovable. Se te cobrará en cada período de facturación con el método de pago seleccionado salvo que canceles. Puedes gestionarla o cancelarla en cualquier momento desde los ajustes de facturación. El acceso continúa hasta el final del período pagado. Pueden aplicarse impuestos."
        override val subscriptionAgreementPrefix: String = "Al suscribirte, aceptas los"
        override val subscriptionTermsOfUse: String = "Términos de uso de HAVN"
        override val subscriptionAgreementAnd: String = "y la"
        override val subscriptionPrivacyPolicy: String = "Política de privacidad."
        override val purchaseSuccessTitle: String = "Gracias por tu compra"
        override val purchaseSuccessBody: String = "Tu suscripción HAVN está activa y tu plan está listo."
        override val restoreSuccessTitle: String = "Restaurar compra"
        override val restoreSuccessBody: String = "Tu suscripción HAVN se restauró correctamente."
        override val purchaseCouldNotComplete: String = "No se pudo completar la compra. Inténtalo de nuevo o revisa tu cuenta de App Store o Google Play."
        override val purchaseVerificationPending: String = "Your payment has not been confirmed yet. If you completed checkout, use Restore purchase to check again. You do not need to pay again."
        override val completeWebCheckout: String = "Complete payment in the checkout tab, then return here. Your access will update automatically once payment is confirmed."
        override val restoreCouldNotComplete: String = "No se encontró ninguna suscripción HAVN activa para esta cuenta de la tienda."
        override val noActiveSubscriptionFound: String = "No se encontró ninguna suscripción HAVN activa para esta cuenta de la tienda."
        override val compareActiveProperties: String = "Propiedades activas"
        override val compareAiFollowUps: String = "Seguimientos con AI"
        override val compareSellerReports: String = "Informes de vendedor"
        override val compareAdvancedAnalytics: String = "Analítica avanzada"
        override val compareAgencyCreation: String = "Creación de agencia"
        override val compareJoinAgencies: String = "Unirse a agencias"
        override val compareInviteAgents: String = "Invitar agentes"
        override val compareSharedLeads: String = "Leads compartidos"
        override val compareAgencyBranding: String = "Branding de agencia"
        override val comparePrioritySupport: String = "Soporte prioritario"
        override val compareFeature: String = "Función"
        override val compareFreePlan: String = "Gratis"
        override val compareValueYes: String = "Sí"
        override val compareValueNo: String = "No"
        override val comparePricePerMonthUser: String = "Precio / mes / usuario"
        override val comparePricePerYearUser: String = "Precio / año / usuario"
        override val compareMaxPropertiesOwner: String = "Máx. propiedades / propietario"
        override val compareMaxContactsOwner: String = "Máx. contactos / propietario"
        override val compareMaxOpenHousesOwner: String = "Máx. open houses / propietario"
        override val compareMaxLeadsOwner: String = "Máx. leads / propietario"
        override val compareMaxPhotosProperty: String = "Máx. fotos por propiedad"
        override val compareMaxDocumentsProperty: String = "Máx. documentos por propiedad"
        override val compareDocumentsStorage: String = "Almacenamiento de documentos"
        override val compareAgencyAgenda: String = "Agenda de agencia"
        override val compareAiTextRequestsMonth: String = "Solicitudes de texto con AI / mes"
        override val compareAnalytics: String = "Analítica"
        override val compareTasks: String = "Tareas"
        override val compareDocumentsStorageOwner: String = "Almacenamiento de documentos / propietario"
        override val compareMaxFileSizeOwner: String = "Tamaño máx. de archivo / propietario"
        override val compareEmailSupport: String = "Soporte por e-mail"
        override val compareDailyBackups7Days: String = "Copias diarias guardadas durante 7 días"
        override val compareKioskMode: String = "Modo kiosco"
        override val unlimited: String = "Ilimitado"
        override val basic: String = "Básico"
        override val advanced: String = "Avanzado"
        override val perMonth: String = "/ mes"
        override val members: String = "miembros"
        override val upgradeToProForAgencyTools: String = "Mejora a Pro para usar herramientas de agencia"
        override val languageTitle: String = "Idioma"
        override val languageBody: String = "Elige el idioma de la app para este dispositivo."
        override val english: String = "English"
        override val slovak: String = "Slovak"
        override val unitsTitle: String = "Unidades y moneda"
        override val unitsBody: String = "Elige como se muestran precios y superficies en la app."
        override val measurementSystemTitle: String = "Medicion"
        override val metric: String = "Metrico"
        override val imperial: String = "Imperial"
        override val currencyTitle: String = "Moneda"
        override val notificationsTitle: String = "Notificaciones"
        override val notificationsBody: String = "Control push alerts, quiet hours, and the types of updates HAVN can enviar."
        override val notificationSettings: String = "Ajustes de notificaciones"
        override val notificationsSubtitle: String = "Only important updates, filtered por your preferences."
        override val quietHoursTitle: String = "Horas silenciosas"
        override val quietHoursBody: String = "HAVN skips non-critical pushes during quiet hours. Billing and account issues still stay concise."
        override val enableQuietHours: String = "Activar horas silenciosas"
        override val quietHoursStart: String = "Inicio"
        override val quietHoursEnd: String = "Fin"
        override val timezoneLabel: String = "Zona horaria"
        override val notificationTypesTitle: String = "Tipos de notificación"
        override val notificationNewLeadCapturedTitle: String = "Nuevo lead capturado"
        override val notificationNewLeadCapturedBody: String = "When an visita or QR flow captures a lead."
        override val notificationHotLeadTitle: String = "Lead marcado caliente"
        override val notificationHotLeadBody: String = "Solo cuando un lead muestra alta intención."
        override val notificationOpeningStartsSoonTitle: String = "Visita starts soon"
        override val notificationOpeningStartsSoonBody: String = "A single reminder 30 minutes antes de start."
        override val notificationOpeningSummaryReadyTitle: String = "Visita summary ready"
        override val notificationOpeningSummaryReadyBody: String = "Cuando el resumen posterior a la visita está listo."
        override val notificationSellerReportGeneratedTitle: String = "Seller informe generated"
        override val notificationSellerReportGeneratedBody: String = "When a informe vendedor has been creard."
        override val notificationAiFollowUpReadyTitle: String = "AI seguimiento ready"
        override val notificationAiFollowUpReadyBody: String = "When a seguimiento draft is ready to rever."
        override val notificationAgentInvitedTitle: String = "Agent invitard to agencia"
        override val notificationAgentInvitedBody: String = "Agencia invitations and miembroship changes."
        override val notificationLeadAssignedTitle: String = "Lead asignado a ti"
        override val notificationLeadAssignedBody: String = "Cuando un compañero te asigna un lead."
        override val notificationLeadTransferredTitle: String = "Lead transferido a ti"
        override val notificationLeadTransferredBody: String = "When propietarioship of a lead moves to you."
        override val notificationSubscriptionIssueTitle: String = "Problema de suscripción"
        override val notificationSubscriptionIssueBody: String = "Fallos de renovación y problemas de pago."
        override val kioskSecurityTitle: String = "Seguridad del kiosco"
        override val kioskSecurityBody: String = "Usa este PIN para salir del modo kiosco y volver a la app del agente."
        override val kioskPinLabel: String = "PIN del kiosco"
        override val mcpAccessTitle: String = "Acceso MCP"
        override val mcpAccessBody: String = "Conecta HAVN con Claude, OpenAI y otros clientes MCP en mcp.havnre.app. Disponible en todos los planes."
        override val mcpAuthorizationBearer: String = "Autorización: Bearer"
        override val mcpNoApiKeyCreated: String = "No se ha creado ninguna clave API"
        override val mcpNotUsedYet: String = "Aún no se ha usado"
        override val mcpLastUsedPrefix: String = "Último uso"
        override val mcpRevealApiKeyTitle: String = "Mostrar clave API"
        override val mcpRevealApiKeyBody: String = "La clave completa solo se muestra después de crearla o rotarla."
        override val mcpCreateKey: String = "Crear clave"
        override val mcpRotateKey: String = "Rotar clave"
        override val mcpRevokeKey: String = "Revocar clave"
        override val mcpEndpointHint: String = "Usa el endpoint https://mcp.havnre.app/mcp con esta clave como token Bearer."
        override val mcpUpgradeHint: String = "El acceso MCP está disponible en todos los planes HAVN."
        override val mcpUpgradePrompt: String = "El acceso MCP está disponible en todos los planes HAVN."
        override val mcpCopied: String = "Copiado"
        override val mcpCopy: String = "Copiar"
        override val mcpLoading: String = "Cargando"
        override val kioskFeaturedProperty: String = "Featured propiedad"
        override val kioskPrivateShowing: String = "Visita privada"
        override val kioskLuxuryListing: String = "Listado de lujo"
        override val kioskFastCheckIn: String = "Check-in rápido"
        override val kioskExitContentDescription: String = "Salir del kiosco"
        override val kioskWelcome: String = "Bienvenido"
        override val kioskGladHere: String = "Nos alegra que estés aquí."
        override val kioskScanToCheckIn: String = "Escanear para registrarse"
        override val kioskReceivePropertyDetails: String = "and receive propiedad details"
        override val kioskOr: String = "O"
        override val kioskStartCheckInManually: String = "Registro manual"
        override val kioskSecureInfo: String = "Tu información está segura y nunca se compartirá."
        override val kioskExitTitle: String = "Salir del kiosco"
        override val kioskExitBody: String = "Introduce el PIN del kiosco para volver a la app del agente."
        override val kioskIncorrectPin: String = "PIN incorrecto."
        override val kioskUnlock: String = "Desbloquear"
        override val kioskTellUsTitle: String = "Cuéntanos sobre ti"
        override val kioskTellUsBody: String = "Tu información va solo al agente anfitrión."
        override val kioskFullName: String = "Nombre completo"
        override val kioskContinue: String = "Continuar"
        override val kioskQuestionsTitle: String = "Unas preguntas rápidas"
        override val kioskQuestionsBody: String = "Esto ayuda al agente a hacer seguimiento con contexto."
        override val kioskWorkingWithAgentQuestion: String = "¿Trabajas con un agente?"
        override val kioskYes: String = "Sí"
        override val kioskNo: String = "No"
        override val kioskInterestQuestion: String = "¿Qué te interesa?"
        override val kioskInterestBuying: String = "Comprar"
        override val kioskInterestInvesting: String = "Invertir"
        override val kioskInterestBrowsing: String = "Solo mirando"
        override val kioskInterestRelocating: String = "Mudanza"
        override val kioskFinish: String = "Finalizar"
        override val kioskThankYou: String = "Gracias"
        override val kioskEnjoyVisitPrefix: String = "Disfruta tu visita en"
        override val kioskResetAutomatically: String = "Este kiosco se reiniciará automáticamente."
        override val environmentTitle: String = "Entorno"
        override val environmentBody: String = "La conexión está configurada para esta versión."
        override val secure: String = "Seguro"
        override val brokerageProfileTitle: String = "Brokerage proarchivo"
        override val brokerageProfileBody: String = "Team branding, agent invitars, and notification preferences will live here."
        override val logout: String = "Cerrar sesion"
        override val languageChanged: String = "Idioma cambiado"
        override val commonAdd: String = "Anadir"
        override val commonEdit: String = "Editar"
        override val commonDelete: String = "Eliminar"
        override val commonCancel: String = "Cancelar"
        override val commonSave: String = "Guardar"
        override val commonCreate: String = "Crear"
        override val commonDismiss: String = "Cerrar"
        override val commonAll: String = "Todo"
        override val commonDone: String = "Listo"
        override val commonSend: String = "Enviar"
        override val commonTime: String = "Hora"
        override val commonHour: String = "Hora"
        override val commonMinute: String = "Minuto"
        override val commonAgency: String = "Agencia"
        override val commonSettings: String = "Ajustes"
        override val commonOpening: String = "Apertura"
        override val commonPropertyName: String = "Propiedad"
        override val commonToday: String = "Hoy"
        override val agencyToolsAvailable: String = "Las herramientas de agencia están disponibles."
        override val agencySetupSubtitle: String = "Cada cuenta HAVN tiene una agencia predeterminada. Pro permite gestionar invitaciones, leads compartidos y marca."
        override val agencyRecentActivity: String = "Reciente activity"
        override val agencyActivityNewLead: String = "Nuevo lead añadido"
        override val agencyActivityInvitationAccepted: String = "Invitación de agente aceptada"
        override val agencyActivityAgentJoined: String = "Agent joined the agencia"
        override val agencyActivitySellerReport: String = "Seller informe creard"
        override val agencyWorkspaceTitle: String = "Agencia"
        override val agencyWorkspaceBody: String = "Elegir which agencia you are working with."
        override val agencySoloActiveTitle: String = "Solo agencia is activo"
        override val agencyProRequiredTitle: String = "Pro plan required"
        override val agencyCreateOrAcceptInviteBody: String = "Crear your agencia or accept an invitar to collaborate with another agencia."
        override val agencyProUnlockBody: String = "Agencia changes, invitars, shared leads, and shared branding unlock with Pro."
        override val realEstate: String = "Inmobiliaria"
        override val proAgency: String = "Pro agencia"
        override val agencyBrandingTitle: String = "Agencia branding"
        override val agencyBrandingBody: String = "Set the agencia name and logo shown in the app, kiosk, and team vers."
        override val uploadLogo: String = "Subir logo"
        override val saveAgency: String = "Guardar agencia"
        override val yourAgencyRole: String = "Your agencia role"
        override val agencyAgentsTitle: String = "Agencia agents"
        override val agencyAgentsBody: String = "People eligible to work with this agencia."
        override val inviteAgent: String = "Invitar agent"
        override val loadingAgents: String = "Cargando agents..."
        override val noAgencyAgentsYet: String = "Sin agencia agents todavía."
        override val changeRole: String = "Cambiar rol"
        override val updating: String = "Actualizando..."
        override val deleting: String = "Eliminando..."
        override val deleteInvite: String = "Cancelar invitación"
        override val chooseAgencyRoleFor: String = "Elegir the agencia role for"
        override val removeAccess: String = "Remove access"
        override val inviteAgentBody: String = "Enviar an agencia invitation por email. The agent accepts después de signing in with the same email."
        override val agentEmail: String = "Agent email"
        override val role: String = "Role"
        override val inviting: String = "Inviting..."
        override val invite: String = "Invitar"
        override val agents: String = "Agents"
        override val ok: String = "OK"
        override val personalActivePropertyLimit: String = "Personal activo propiedad limit"
        override val personalAccountAgencyToolsLocked: String = "Personal account is activo. Agencia tools unlock with Pro."
        override val selected: String = "Seleccionado"
        override val activeMembers: String = "activo miembros"
        override val agencySharedWorkspaceBody: String = "Shared propiedades, contactoos, visitas, leads, seguimientos, and informes use this agencia."
        override val actLikeAgent: String = "Actuar como agente"
        override val actAsAdmin: String = "Actuar como admin"
        override val actAsOwner: String = "Actuar como propietario"
        override val actLikeAgentBody: String = "Usar la agencia como un agente normal."
        override val actLikeAgentSelectedBody: String = "Solo se muestra el trabajo asignado o propio."
        override val agencyRoleOwner: String = "Propietario"
        override val agencyRoleAdmin: String = "Admin"
        override val agencyRoleAgent: String = "Agent"
        override val agencyRoleAssistant: String = "Asistente"
        override val agencyRoleViewer: String = "Lector"
        override val agencyRoleOwnerDescription: String = "Control completo de la agencia, incluidos miembros, marca, asignaciones, anuncios, leads e informes."
        override val agencyRoleAdminDescription: String = "Gestión completa de la agencia excepto eliminar la agencia."
        override val agencyRoleAgentDescription: String = "Trabaja con anuncios, visitas, leads, seguimientos, notas e informes de vendedor asignados."
        override val agencyRoleAssistantDescription: String = "Apoya anuncios asignados editando leads, preparando seguimientos y borradores de informes."
        override val agencyRoleViewerDescription: String = "Acceso de solo lectura a paneles e informes."
        override val agencyCapabilityInviteRemoveMembers: String = "Invitar y eliminar miembros"
        override val agencyCapabilityChangeRoles: String = "Cambiar roles de miembros"
        override val agencyCapabilityManageAllProperties: String = "Crear, editar y eliminar todas las propiedades"
        override val agencyCapabilityAssignAgents: String = "Asignar agentes"
        override val agencyCapabilitySeeAllLeads: String = "Ver todos los leads"
        override val agencyCapabilityExportReports: String = "Exportar informes"
        override val agencyCapabilityChangeBranding: String = "Cambiar marca y configuración de la agencia"
        override val agencyCapabilityDeleteAgency: String = "Eliminar agencia"
        override val agencyCapabilityViewAssignedProperties: String = "Ver propiedades asignadas"
        override val agencyCapabilityHostAssignedOpenings: String = "Organizar visitas asignadas"
        override val agencyCapabilitySeeAssignedLeads: String = "Ver leads de propiedades y visitas asignadas"
        override val agencyCapabilityAddNotes: String = "Añadir notas"
        override val agencyCapabilitySendFollowUps: String = "Enviar seguimientos"
        override val agencyCapabilityCreateSellerReports: String = "Crear informes de vendedor para anuncios asignados"
        override val agencyCapabilityEditAssignedLeads: String = "Editar leads asignados"
        override val agencyCapabilityPrepareFollowUps: String = "Preparar seguimientos"
        override val agencyCapabilityCreateDraftReports: String = "Crear borradores de informes"
        override val agencyCapabilityCannotDeleteProperties: String = "No puede eliminar propiedades"
        override val agencyCapabilityCannotInviteAgents: String = "No puede invitar agentes salvo autorización"
        override val agencyCapabilityViewDashboards: String = "Ver paneles"
        override val agencyCapabilityViewReports: String = "Ver informes"
        override val agencyCapabilityCannotEdit: String = "No puede editar nada"
        override val commonVisitors: String = "Leads"
        override val commonHot: String = "Caliente"
        override val commonWarm: String = "Templado"
        override val commonCold: String = "Frío"
        override val commonActive: String = "Activo"
        override val commonPlanned: String = "Planificado"
        override val commonArchived: String = "Archivado"
        override val commonPast: String = "Pasadas"
        override val commonFollowUps: String = "Pendientes"
        override val commonProperty: String = "Propiedad"
        override val commonAddress: String = "Dirección"
        override val commonOpenHouse: String = "Visita"
        override val commonInquiry: String = "Consulta"
        override val commonInquiries: String = "Consultas"
        override val generalInquiry: String = "Consulta general"
        override val generalInquiries: String = "Consultas generales"
        override val propertyInquiry: String = "Consulta sobre propiedad"
        override val propertyInquiries: String = "Consultas sobre propiedades"
        override val addGeneralInquiry: String = "Añadir consulta general"
        override val newGeneralInquiry: String = "Nueva consulta general"
        override val noGeneralInquiries: String = "Aún no hay consultas generales."
        override val noPropertyInquiries: String = "Aún no hay consultas sobre propiedades."
        override val buyerLookingFor: String = "¿Qué busca este comprador?"
        override val locationCity: String = "Ubicación / ciudad"
        override val radiusKm: String = "Radio (km)"
        override val propertyType: String = "Tipo de propiedad"
        override val budgetFrom: String = "Presupuesto desde"
        override val budgetTo: String = "Presupuesto hasta"
        override val purchaseTimeline: String = "Plazo de compra"
        override val createGeneralInquiry: String = "Crear consulta general"
        override val saveGeneralInquiry: String = "Guardar consulta general"
        override val inquiryType: String = "Tipo de consulta"
        override val leadSource: String = "Fuente del lead"
        override val notSpecified: String = "No especificado"
        override val inquiryStatus: String = "Estado de la consulta"
        override val inquiryFollowUp: String = "Seguimiento de consulta"
        override val addInquiry: String = "Añadir consulta"
        override val searchInquiries: String = "Buscar consultas"
        override val noInquiries: String = "Sin consultas"
        override val noInquiriesBody: String = "Usa el botón más para añadir el interés de un comprador desde un contacto existente."
        override val inquiryUnavailableTitle: String = "Consulta no disponible"
        override val inquiryUnavailableBody: String = "Esta consulta puede haberse eliminado o aún se está cargando."
        override val backToInquiries: String = "Volver a consultas"
        override val deleteInquiry: String = "Eliminar consulta"
        override val deleteInquiryQuestionPrefix: String = "Eliminar"
        override val deleteInquiryQuestionSuffix: String = "de esta propiedad?"
        override val deleteInquiryTargetFallback: String = "esta consulta"
        override val propertyInquiriesBody: String = "Haz seguimiento de compradores que preguntaron por esta propiedad. Las consultas también aparecen en Leads."
        override val propertyInquiriesEmpty: String = "Añade una consulta eligiendo uno de tus contactos."
        override val contactInquiriesBody: String = "Propiedades por las que este contacto ha preguntado."
        override val contactInquiriesEmpty: String = "Aún no hay consultas de propiedades."
        override val viewInquiries: String = "Ver consultas"
        override val createContactFirstForInquiry: String = "Primero crea un contacto y luego añade la consulta desde esta propiedad."
        override val commonCheckedIn: String = "Checked in"
        override val commonNotScheduled: String = "not scheduled"
        override val todayTitle: String = "Hoy"
        override val todaySubtitle: String = "Tu vista diaria de visitas, leads, seguimientos e impulso para vendedores."
        override val todayOpenHousesMetric: String = "visitas"
        override val capturedMetric: String = "captured"
        override val priorityMetric: String = "priority"
        override val noActivePropertiesTitle: String = "Sin activo propiedades"
        override val noActivePropertiesBody: String = "Add or activate a propiedad to make it appear on Hoy."
        override val checkIns: String = "Check-ins"
        override val allOpenHouses: String = "all visitas"
        override val pendingDrafts: String = "pending drafts"
        override val priorityLead: String = "Prioridad lead"
        override val nextOpenHouseAt: String = "Next visita at"
        override val noOpenHouseScheduled: String = "Sin visita scheduled"
        override val personalAccount: String = "Cuenta personal"
        override val accountReady: String = "Tu cuenta está lista"
        override val realEstateApp: String = "App inmobiliaria"
        override val needHelp: String = "¿Necesitas ayuda?"
        override val contactSupport: String = "Contactar soporte"
        override val upgradePlan: String = "Mejorar plan"
        override val planSuffix: String = "Plan"
        override val todayActionsTitle: String = "Prioridades de hoy"
        override val agencyInvitation: String = "Agencia invitation"
        override val joinAgency: String = "Join"
        override val youWereInvitedAs: String = "You were invitard as"
        override val invitedBy: String = "por"
        override val decline: String = "Decline"
        override val yourDefaultAgency: String = "Your default agencia"
        override val chooseAgencyBody: String = "Elegir which agencia you want to work with. Agencia tools include invitars, shared leads, and branding."
        override val agencyMembersSuffix: String = "miembros"
        override val quickActionTasksBody: String = "Queue"
        override val quickActionReportsBody: String = "Seller"
        override val quickActionAnalyticsBody: String = "Trends"
        override val quickActionAddPropertyTitle: String = "Añadir"
        override val quickActionAddPropertyBody: String = "Inmueble"
        override val quickActionAddContactTitle: String = "Contacto"
        override val quickActionAddContactBody: String = "Nuevo"
        override val quickActionFilesTitle: String = "Archivos"
        override val quickActionFilesBody: String = "Docs"
        override val firstRunStepsTitle: String = "Inicio with four simple steps"
        override val firstRunAddProperty: String = "Add propiedad"
        override val firstRunScheduleOpening: String = "Schedule visita"
        override val firstRunStartGuestCheckIn: String = "Inicio guest check-in"
        override val firstRunSendFollowUp: String = "Enviar seguimiento"
        override val greetingNamePrefix: String = "Hola"
        override val greetingAgent: String = "Hola agente"
        override val createListing: String = "Crear listing"
        override val newOwnerBuyer: String = "New propietario/buyer"
        override val documents: String = "Documentos"
        override val whatOpeningNext: String = "¿Cuál es la próxima apertura?"
        override val whoCheckedIn: String = "¿Quién se registró?"
        override val whoNeedsFollowUp: String = "¿Quién necesita seguimiento?"
        override val whatShouldIDoNow: String = "¿Qué debo hacer ahora?"
        override val noCheckInsYet: String = "Todavía no se registró ningún contacto."
        override val noPendingFollowUps: String = "Sin pending seguimientos right now."
        override val openKioskForNextOpening: String = "Abre el kiosco para la próxima apertura."
        override val reviewNewLeads: String = "Revisa nuevos leads y envía seguimientos."
        override val createOpeningToStart: String = "Crea una apertura desde una propiedad para empezar a captar leads."
        override val addFirstPropertyToStart: String = "Agrega tu primera propiedad para empezar."
        override val nextOpening: String = "Próxima apertura"
        override val quickSignIn: String = "Registro rápido"
        override val scanQrCode: String = "Escanear QR"
        override val newLead: String = "Nuevo lead"
        override val myProperties: String = "Mis propiedades"
        override val manageListings: String = "Gestionar anuncios"
        override val todaysOverview: String = "Resumen de hoy"
        override val seeAll: String = "Ver todo"
        override val propertiesEyebrow: String = "Portfólio"
        override val propertiesSubtitle: String = "Manage activo, planned, and archived listings with listing media, buyer activity, and performance insights."
        override val propertiesLiveMetric: String = "live"
        override val propertiesPipelineMetric: String = "pipeline"
        override val propertiesAllTimeMetric: String = "all time"
        override val addProperty: String = "Anadir propiedad"
        override val editProperty: String = "Editar propiedad"
        override val propertyFallback: String = "Propiedad"
        override val propertyUnavailableTitle: String = "Propiedad no disponible"
        override val propertyUnavailableBody: String = "Refresh the portfolio to reload this listing."
        override val backToProperties: String = "Volver a propiedades"
        override val deletePropertyTitle: String = "¿Eliminar propiedad?"
        override val deletePropertyBody: String = "This will permanently eliminar the propiedad and its related local records. Esta acción no se puede deshacer."
        override val loadingProperties: String = "Cargando propiedades"
        override val loadMore: String = "Cargar más"
        override val loadingPropertyDetails: String = "Cargando propiedad details"
        override val noPropertiesTitle: String = "Aún no hay propiedades"
        override val noPropertiesBody: String = "Add your first propiedad, then crear an visita to start collecting leads and seller-ready feedback."
        override val openHouseButton: String = "Crear visita"
        override val photosTitle: String = "Fotos"
        override val photosBody: String = "The first foto is used as the main propiedad image across Portfolio."
        override val uploadPhoto: String = "Subir foto"
        override val noPhotosYet: String = "Aún no se han subido fotos."
        override val propertyPhotoCountPlanLimit: String = "Se alcanzó el límite de fotos para esta propiedad en tu plan actual. Mejora el plan para subir más fotos."
        override val propertyPhotoStoragePlanLimit: String = "Se alcanzó el límite de almacenamiento de tu plan actual. Mejora el plan para subir más fotos o archivos."
        override val mainPhoto: String = "Principal"
        override val propertyTitleLabel: String = "Nombre de la propiedad"
        override val propertyAddressLine1Label: String = "Dirección"
        override val propertyAddressLine2Label: String = "Dirección línea 2"
        override val propertyCityLabel: String = "Ciudad"
        override val propertyRegionLabel: String = "Región"
        override val propertyPostalCodeLabel: String = "Código postal"
        override val propertyCountryLabel: String = "País"
        override val propertyAskingPriceLabel: String = "Precio solicitado"
        override val propertyBedsLabel: String = "Habitaciones"
        override val propertyBathsLabel: String = "Baños"
        override val propertyInteriorLabel: String = "Interior"
        override val propertyDescriptionLabel: String = "Descripción"
        override val createPropertyButton: String = "+ Inmueble"
        override val locateProperty: String = "Localizar propiedad"
        override val findLocation: String = "Buscar ubicación"
        override val find: String = "Buscar"
        override val navigate: String = "Navegar"
        override val propertyLocationMarkerTitle: String = "Ubicación de la propiedad"
        override val mapKitJsMissingToken: String = "El mapa no está configurado para esta versión."
        override val mapKitJsLoading: String = "Cargando MapKit JS..."
        override val generateSellerReport: String = "Generar informe para vendedor"
        override val deleteProperty: String = "Eliminar propiedad"
        override val conversionMetric: String = "Conversión"
        override val propertyPhotoContentDescription: String = "Foto de la propiedad"
        override val deletePhoto: String = "Eliminar foto"
        override val movePhotoLeft: String = "Mover foto a la izquierda"
        override val movePhotoRight: String = "Mover foto a la derecha"
        override val propertyTitleRequired: String = "El nombre de la propiedad es obligatorio."
        override val propertyStreetRequired: String = "La dirección es obligatoria."
        override val propertyCityRequired: String = "La ciudad es obligatoria."
        override val propertyRegionRequired: String = "La región es obligatoria."
        override val propertyPostalRequired: String = "El código postal es obligatorio."
        override val propertyAskingPriceInvalid: String = "Introduce un precio solicitado válido."
        override val propertyOwnerContactTitle: String = "Contacto del propietario"
        override val propertyOwnerSelectContact: String = "Selecciona un contacto existente como propietario de la propiedad."
        override val propertyOwnerSelected: String = "Propietario seleccionado"
        override val propertyOwnerNoContacts: String = "Todavía no hay contactos. Añade el propietario en Contactos y selecciónalo aquí."
        override val propertyOwnerChooseContact: String = "Elegir contacto"
        override val propertyOwnerChangeContact: String = "Cambiar contacto"
        override val propertyOwnerRemoveContact: String = "Quitar"
        override val propertyOwnerPickerTitle: String = "Elegir propietario de la propiedad"
        override val propertyOwnerSearchContact: String = "Buscar contactos"
        override val propertyOwnerSearchHint: String = "Empieza a escribir un nombre, email o teléfono."
        override val propertyOwnerNoMatches: String = "No hay contactos coincidentes."
        override val propertyOpeningsTitle: String = "Visitas"
        override val propertyNoOpenings: String = "No hay visitas programadas para esta propiedad."
        override val teamAccessTitle: String = "Acceso del equipo"
        override val onlyListingOwner: String = "Solo el propietario del anuncio"
        override val assignTeam: String = "Asignar equipo"
        override val assignPropertyTitle: String = "Asignar propiedad"
        override val assignPropertyBody: String = "Elige quién puede trabajar en esta propiedad. Selecciona todo el equipo o agentes específicos."
        override val wholeTeam: String = "Todo el equipo"
        override val leadsEyebrow: String = "Leads"
        override val leadFallback: String = "Lead"
        override val leadsSubtitle: String = "Busca, filtra y califica leads capturados en cada visita."
        override val leadDetailSubtitle: String = "Origen, calificación, notas e historial de seguimientos de este lead de la visita."
        override val totalMetric: String = "Total"
        override val loggedMetric: String = "registrados"
        override val searchLeads: String = "Buscar leads"
        override val searchLeadsPlaceholder: String = "Nombre, teléfono o e-mail"
        override val allProperties: String = "Todas las propiedades"
        override val loadingLeads: String = "Cargando leads de visitas"
        override val loadingLeadDetails: String = "Cargando detalles del lead"
        override val noLeadsFoundTitle: String = "Los leads aparecerán aquí cuando los contactos hagan check-in en una visita."
        override val noLeadsEmptyBody: String = "Usa el check-in del kiosco o añade contactos manualmente desde una visita."
        override val noLeadsFilteredBody: String = "Prueba con otra propiedad, estado o término de búsqueda."
        override val backToLeads: String = "Volver a leads"
        override val leadUnavailableTitle: String = "Lead no disponible"
        override val leadUnavailableBody: String = "Este lead ya no está disponible en la lista actual."
        override val leadTemperature: String = "Estado del lead"
        override val leadLabelSuffix: String = "Lead"
        override val greetingHi: String = "Hola"
        override val leadActionCall: String = "Llamar"
        override val leadActionSms: String = "SMS"
        override val leadActionEmail: String = "E-mail"
        override val leadFollowUp: String = "Seguimiento"
        override val leadNoFollowUpScheduled: String = "Sin seguimiento scheduled"
        override val leadIntentScore: String = "Puntuación de interés"
        override val leadInterestedIn: String = "Interés en"
        override val leadGenericGreetingName: String = "hola"
        override val followUpMessageTypeThankYou: String = "Gracias"
        override val followUpMessageTypePropertyInfo: String = "Info de propiedad"
        override val followUpMessageTypeFollowUp: String = "Seguimiento"
        override val followUpMessageTypeCheckIn: String = "Consultar interés"
        override val followUpMessageTypePriceUpdate: String = "Actualización de precio"
        override val followUpMessageTypePropertyBrochure: String = "Archivos"
        override val followUpPreview: String = "Vista previa"
        override val followUpSubject: String = "Asunto"
        override val followUpMessage: String = "Mensaje"
        override val followUpSendViaEmail: String = "Enviar por e-mail"
        override val followUpSendViaSms: String = "Enviar por SMS"
        override val followUpAiAssistantTitle: String = "Asistente AI"
        override val followUpAiAssistantBody: String = "Genera un mensaje personalizado en segundos."
        override val followUpGenerateWithAi: String = "Generar con AI"
        override val followUpUpgradeForAi: String = "Desbloquear AI"
        override val followUpDefaultSubject: String = "Seguimiento sobre"
        override val privateAgentNotes: String = "Private agent notes"
        override val notes: String = "Notes"
        override val notesPlaceholder: String = "Motivation, preferences, objections, next move"
        override val saveNotes: String = "Guardar notes"
        override val followUpHistory: String = "Seguimiento history"
        override val noFollowUpsLogged: String = "Sin seguimientos logged todavía."
        override val openHousesEyebrow: String = "Showings"
        override val scheduleOpenHouse: String = "Crear visita"
        override val openingDetails: String = "Detalles de apertura"
        override val editOpening: String = "Editar apertura"
        override val deleteOpening: String = "Eliminar apertura"
        override val deleteOpeningBody: String = "¿Seguro que quieres eliminar esta apertura? Esta acción no se puede deshacer."
        override val removeLeadTitle: String = "¿Quitar lead?"
        override val removeLeadBody: String = "¿Quitar %s de esta visita?"
        override val removeLeadFallback: String = "este lead"
        override val openingName: String = "Nombre de apertura"
        override val startsAt: String = "Empieza"
        override val endsAt: String = "Termina"
        override val chooseStartDateTime: String = "Elige fecha y hora de inicio"
        override val chooseEndDateTime: String = "Elige fecha y hora de fin"
        override val accessNotes: String = "Notas de acceso"
        override val privateNotes: String = "Notas privadas"
        override val addPrivateNote: String = "Agregar nota privada"
        override val liveDashboard: String = "Live dashboard"
        override val visitorKiosk: String = "Lead kiosk"
        override val openHousesSubtitle: String = "Crear visitas for propiedades, rever leads, and launch kiosk sessions."
        override val liveMetric: String = "Live"
        override val upcomingMetric: String = "Próximas"
        override val inProgressMetric: String = "in progress"
        override val scheduledMetric: String = "scheduled"
        override val loadingOpenHouses: String = "Cargando visitas"
        override val addPropertyFirstTitle: String = "Add a propiedad first"
        override val addPropertyFirstBody: String = "Crear an visita from a propiedad to start collecting leads."
        override val noOpenHousesTitle: String = "Sin visitas scheduled"
        override val noOpenHousesBody: String = "Crear an visita from a propiedad to start collecting leads."
        override val noSignInsTitle: String = "Sin sign-ins yet"
        override val noSignInsBody: String = "Leads checked in through kiosk mode will appear here in real time."
        override val dashboard: String = "Panel"
        override val start: String = "Inicio"
        override val end: String = "Fin"
        override val endOpenHouse: String = "Fin visita"
        override val reportsEyebrow: String = "Propietarios"
        override val sellerReportsTitle: String = "Informes vendedor"
        override val createReport: String = "Informe"
        override val reportPreview: String = "Informe vendedor"
        override val reportsSubtitle: String = "Crea resúmenes premium posteriores a visitas con calidad de leads, intención de compradores y narrativa lista para el vendedor."
        override val reportsMetricSaved: String = "guardard"
        override val reportedMetric: String = "informeed"
        override val leadsMetric: String = "leads"
        override val createSellerReport: String = "Informe"
        override val attendance: String = "Asistencia"
        override val savedReports: String = "guardard informes"
        override val buyerHeat: String = "Interés comprador"
        override val hotLeads: String = "calientes"
        override val loadingSellerReports: String = "Cargando informes vendedor"
        override val noSellerReportsTitle: String = "Sin informes vendedor yet"
        override val noSellerReportsBody: String = "Elegir an visita, add agent notes, prever an export-ready recap, then guardar it."
        override val chooseOpenHouse: String = "Elegir visita"
        override val noOpenHousesAvailable: String = "Sin visitas available todavía."
        override val agentNotes: String = "Agent notes"
        override val notesForSeller: String = "Notes for seller"
        override val sellerNotesPlaceholder: String = "Objeciones, señales de precio, comentarios de visita, próximo paso recomendado"
        override val generatePreview: String = "Generate prever"
        override val noPreviewReadyTitle: String = "Sin prever ready"
        override val noPreviewReadyBody: String = "Generate a informe vendedor prever antes de saving."
        override val saveReport: String = "Guardar"
        override val reportSaved: String = "Informe guardard"
        override val sellerOpenHouseReport: String = "Seller visita informe"
        override val mostCommonBuyerInterest: String = "Most common buyer interest"
        override val followUpsSent: String = "Seguimientos sent"
        override val summary: String = "Resumen"
        override val noPrivateNotesAdded: String = "Sin private notes added."
        override val openHouseReport: String = "Visita informe"
        override val commonDraft: String = "Borrador"
        override val commonAccepted: String = "Aceptado"
        override val searchSellerReports: String = "Buscar informes de vendedor"
        override val noMatchingReports: String = "No hay informes coincidentes"
        override val clearFilters: String = "Clear filters"
        override val tryDifferentSearchOrStatusFilter: String = "Prueba otra búsqueda o filtro de estado."
        override val connectedToProperty: String = "Conectado a la propiedad"
        override val viewProperty: String = "Ver propiedad"
        override val dataRollup: String = "Data rollup"
        override val connectedOpenings: String = "Visitas"
        override val visitors: String = "Visitantes"
        override val interestedBuyers: String = "Compradores interesados"
        override val completedFollowUps: String = "Follow Ups"
        override val reportHistory: String = "Informe history"
        override val noPreviousReportsYet: String = "Aún no hay informes anteriores."
        override val viewAllReports: String = "Ver todos los informes"
        override val actions: String = "Acciones"
        override val generatePdf: String = "Crear hoja de cálculo"
        override val previewPdf: String = "Vista de hoja"
        override val pdfSavedToPropertyFiles: String = "%s guardard to propiedad archivos."
        override val pdfSavingToPropertyFiles: String = "%s is being guardard to propiedad archivos."
        override val pdfSavedToFiles: String = "%s guardard to archivos."
        override val pdfSavingToFiles: String = "%s is being guardard to archivos."
        override val pdfIncludesSellerReport: String = "Spreadsheet includes Informe vendedor metrics, AI insights, agent details, propiedad data, and visita history."
        override val pdfIncludesAnalytics: String = "Spreadsheet includes analítica metrics, top propiedades, agent performance, seguimiento channels, and AI insights."
        override val pdfGenerateBeforeSending: String = "Crear the spreadsheet antes de enviaring."
        override val pdfUploadBeforeSharing: String = "The spreadsheet must finish upcargando antes de sharing."
        override val sellerReportPdfNeedsProperty: String = "La hoja de cálculo del informe de vendedor necesita una propiedad conectada antes de subirla."
        override val deleteReport: String = "Eliminar Informe"
        override val deleteReportBody: String = "¿Seguro que quieres eliminar this informe vendedor? Esta acción no se puede deshacer."
        override val shareReport: String = "Share informe"
        override val openingPropertyReportLoading: String = "Propiedad informe..."
        override val openingPropertyReportCreating: String = "Creating propiedad informe..."
        override val sellerReportGeneratedPrefix: String = "Informe vendedor generated"
        override val sellerReportGeneratedSuffix: String = "desde visitas, visitantes, leads, seguimientos y comentarios conectados a esta propiedad en el momento del informe."
        override val priceNotSet: String = "Precio not set"
        override val daysSuffix: String = "días"
        override val connectedOpeningSingular: String = "visita"
        override val connectedOpeningPlural: String = "visitas"
        override val connectedLeadSingular: String = "lead conectado"
        override val connectedLeadPlural: String = "leads conectados"
        override val sellerConfidence: String = "Seller confidence"
        override val sellerConfidenceExplanation: String = "Confidence explanation"
        override val aiDraftReviewBeforeSending: String = "AI draft only. Rever and editar antes de enviaring to the seller."
        override val executiveSummary: String = "Executive summary"
        override val buyerInterestOverview: String = "Resumen de interés comprador"
        override val whatBuyersLoved: String = "What buyers loved"
        override val buyerConcerns: String = "Preocupaciones del comprador"
        override val leadQualitySummary: String = "Resumen de calidad de leads"
        override val agentActivity: String = "Agent activity"
        override val aiRecommendations: String = "AI recommendations"
        override val recommendations: String = "Recomendaciones"
        override val marketPositionComparison: String = "Market position comparison"
        override val nextSteps: String = "Next steps"
        override val conversion: String = "Conversión"
        override val interested: String = "interested"
        override val tourSignalsLowercase: String = "tour signals"
        override val propertyTimeline: String = "Propiedad timeline"
        override val timelineBasisNote: String = "La cronología se basa solo en registros de visitas y seguimientos conectados."
        override val visitorsLowercase: String = "visitantes"
        override val hotLeadsLowercase: String = "leads calientes"
        override val hotLowercase: String = "caliente"
        override val sentiment: String = "Sentiment"
        override val toursLowercase: String = "tours"
        override val interestedLowercase: String = "interested"
        override val noRepeatedFeedbackMentions: String = "Sin repeated feedback mentions have been recorded todavía."
        override val scoresMentionRates: String = "Puntuacións are mention rates across guardard buyer feedback."
        override val aiExecutiveBriefing: String = "AI executive briefing"
        override val viewAllAiInsights: String = "Ver all AI insights ->"
        override val followUpsSentTitle: String = "Follow-Ups Sent"
        override val financingPacketsShared: String = "Financing Packets Shared"
        override val buyerCalls: String = "Llamadas a compradores"
        override val propertyDataEvidence: String = "Propiedad data evidence"
        override val attendanceCoverage: String = "Cobertura de asistencia"
        override val leadQuality: String = "Calidad de leads"
        override val followUpExecution: String = "Seguimiento execution"
        override val activityChannels: String = "Canales de actividad"
        override val callsLowercase: String = "llamadas"
        override val emailsLowercase: String = "emails"
        override val offerReadinessScore: String = "Offer readiness score"
        override val date: String = "Fecha"
        override val propertyLeadFunnel: String = "Propiedad lead funnel"
        override val openHouseBreakdown: String = "Open house breakdown"
        override val aiInsights: String = "Insights AI"
        override val generateAiInsights: String = "Generar insights AI"
        override val analyticsOverview: String = "Analítica overver"
        override val allAgents: String = "All agents"
        override val me: String = "Yo"
        override val allActivity: String = "All activity"
        override val latest30Days: String = "Latest 30 días"
        override val latest7Days: String = "Latest 7 días"
        override val analyticsDatePreset: String = "Periodo"
        override val analyticsCustomDate: String = "Custom date"
        override val analyticsLastDay: String = "Último día"
        override val analyticsLastWeek: String = "Última semana"
        override val analyticsLastMonth: String = "Último mes"
        override val analyticsLastYear: String = "Último año"
        override val analyticsAllTime: String = "Todo"
        override val analyticsDateFrom: String = "Fecha from"
        override val analyticsDateTo: String = "Fecha to"
        override val analyticsOpenHousesLowercase: String = "visitas"
        override val analyticsWarmLeadsLowercase: String = "leads templados"
        override val analyticsFromNotesFollowUps: String = ""
        override val analyticsFromText: String = "del texto"
        override val analyticsHotConversion: String = "Conversión de leads calientes"
        override val analyticsHotLeadsPerVisitors: String = "leads calientes / visitantes"
        override val analyticsAverageIntent: String = "Avg. intent"
        override val analyticsVisitorIntentScore: String = "visitor intent score"
        override val analyticsSelectDate: String = "Seleccionar date"
        override val propertyFunnel: String = "Propiedad funnel"
        override val propertyFunnelSubtitle: String = "From propiedad activity to qualified buyer momentum"
        override val properties: String = "Propiedades"
        override val tourSignals: String = "Señales de visita"
        override val offerSignals: String = "Señales de oferta"
        override val viewFullFunnelReport: String = "Ver full funnel informe"
        override val performanceOverTime: String = "Rendimiento en el tiempo"
        override val thirtyDays: String = "30 días"
        override val topPerformingProperties: String = "Propiedades destacadas"
        override val viewAll: String = "Ver all"
        override val noPropertyAnalyticsYet: String = "Sin propiedad analítica todavía."
        override val leadQualityBreakdown: String = "Desglose de calidad de leads"
        override val warmLeadsTitle: String = "Leads templados"
        override val coldLeadsTitle: String = "Leads fríos"
        override val followUpPerformance: String = "Seguimiento performance"
        override val agentPerformance: String = "Agent performance"
        override val viewTeamReport: String = "Ver informe del equipo"
        override val followUpChannels: String = "Seguimiento channels"
        override val viewReport: String = "Ver informe"
        override val searchProperties: String = "Buscar propiedades"
        override val searchOpenings: String = "Buscar visitas"
        override val noOpeningsFoundTitle: String = "Sin visitas found"
        override val noOpeningsFoundBody: String = "Prueba otra búsqueda o filtro de estado de visita."
        override val noMatchingPropertiesTitle: String = "No hay propiedades coincidentes"
        override val noMatchingPropertiesBody: String = "Prueba otra búsqueda o filtro de estado."
        override val clientsTitle: String = "Contactos"
        override val clientFallback: String = "Contatto"
        override val addClient: String = "Añadir contacto"
        override val editClient: String = "Editar contacto"
        override val newClient: String = "Nuevo contacto"
        override val saveClient: String = "Guardar contacto"
        override val createClient: String = "Crear contacto"
        override val deleteClientTitle: String = "Eliminar contacto?"
        override val deleteClientBody: String = "This will permanently eliminar the contacto. Esta acción no se puede deshacer."
        override val firstName: String = "Nombre"
        override val lastName: String = "Apellido"
        override val email: String = "E-mail"
        override val phone: String = "Teléfono"
        override val comments: String = "Comentarios"
        override val addPhoto: String = "Añadir foto"
        override val sendQr: String = "Enviar QR"
        override val sendQrShareTitle: String = "Tu QR de HAVN para la visita"
        override val sendQrShareBody: String = "Tu QR de HAVN para la visita está adjunto. Añade el Wallet pass (.pkpass) al teléfono cuando esté disponible, o muestra la imagen QR en la visita."
        override val sendQrReadyMessage: String = "Código QR listo para enviar"
        override val sendQrUnavailableError: String = "Sin email or SMS app is available for this contacto."
        override val clientQrDeliveryRequired: String = "Añade un email o teléfono para entregar el QR."
        override val photo: String = "Foto"
        override val clientDetailSubtitle: String = "Identidad QR, datos de contacto, comentarios y visitas conectadas mediante leads."
        override val clientFormEditSubtitle: String = "Actualiza los datos de contacto, la entrega y los comentarios."
        override val clientFormNewSubtitle: String = "Registra un comprador/contacto y genera una identidad QR reutilizable para visitas."
        override val searchClients: String = "Buscar contactos"
        override val noClientsYetTitle: String = "Aún no hay contactos"
        override val noClientsYetBody: String = "Registra primero los contactos y luego envíales el código QR por email o SMS antes de una visita."
        override val noClientsFoundTitle: String = "Sin contactoos found"
        override val noClientsFoundBody: String = "Prueba con otro nombre, teléfono o email."
        override val clientUnavailableTitle: String = "Contacto no disponible"
        override val clientUnavailableBody: String = "Actualiza la lista de contactos y abre este registro de nuevo."
        override val noCommentsAdded: String = "Sin comments added."
        override val openingsTitle: String = "Visitas"
        override val clientOpeningsEmpty: String = "Aún no hay visitas conectadas. Los leads conectan un contacto con una visita."
        override val clientPassLabel: String = "Wallet pass"
        override val clientNoEmail: String = "Sin email"
        override val visitorsBody: String = "Abre el kiosco, escanea el QR de un contacto o añade contactos existentes como leads para esta visita."
        override val openKiosk: String = "Abrir kiosco"
        override val addQrClient: String = "Contacto QR"
        override val addManually: String = "Manual"
        override val selectClients: String = "Seleccionar contactos"
        override val selectClientsBody: String = "Elige contactos de tu lista. Cada contacto seleccionado se convierte en un lead para esta visita."
        override val kioskCheckIn: String = "Check-in de kiosco"
        override val kioskCheckInBody: String = "Usa la cámara trasera para escanear el HAVN Wallet QR del contacto. Cuando se reconozca el código, HAVN creará automáticamente el lead para esta visita."
        override val scanWithCamera: String = "Escanear con cámara trasera"
        override val clientQrImage: String = "Imagen QR del contacto"
        override val clientQrImageBody: String = "Mantén el QR del contacto dentro del cuadrado dorado. HAVN recoge cada escaneo abajo."
        override val scanMultipleQrBody: String = "Escanea uno o más códigos QR de contactos HAVN y luego toca Añadir contacto QR."
        override val scannedQrReady: String = "QR de contacto listo para añadir"
        override val createLeadFromQr: String = "Crear lead desde QR"
        override val noClientsFoundShort: String = "Sin contactoos found."
        override val remove: String = "Quitar"
        override val tasksTitle: String = "Tareas"
        override val addTask: String = "Add tarea"
        override val searchTasks: String = "Buscar tareas"
        override val loadMoreTasks: String = "Load more tareas"
        override val createTask: String = "Crear Tarea"
        override val saveTask: String = "Guardar Tarea"
        override val editTask: String = "Editar Tarea"
        override val newTask: String = "New tarea"
        override val taskDetails: String = "Tarea Details"
        override val taskName: String = "Nombre"
        override val taskDescription: String = "Descripción"
        override val taskDueDateTime: String = "Tarea date & time"
        override val chooseTaskDateTime: String = "Elegir tarea date & time"
        override val clearTaskDateTime: String = "Clear date & time"
        override val assignToAgent: String = "Asignar a agente"
        override val noAgencyAgentsFound: String = "Sin agencia agents found. The tarea will stay assigned to the propietario."
        override val taskPriority: String = "Tarea Prioridad"
        override val taskStatus: String = "Estado"
        override val taskVisibility: String = "Visibilidad"
        override val taskOwner: String = "Propietario"
        override val taskOwnerFallback: String = "Tarea propietario"
        override val assignedTo: String = "Assigned to"
        override val selectedAgent: String = "Seleccionado agent"
        override val taskVisibilityBody: String = "This tarea is visible to the propietario and the assigned agent."
        override val taskQueue: String = "Tarea queue"
        override val taskDetail: String = "Tarea detail"
        override val taskDetailEmpty: String = "Seleccionar a tarea to see context and next actions."
        override val connectedContext: String = "Contexto vinculado"
        override val noTaskContext: String = "Sin propiedad, contacto, visita, or lead is linked todavía."
        override val activityTimeline: String = "Cronología de actividad"
        override val created: String = "Creard"
        override val recently: String = "Recientely"
        override val completed: String = "Completadas"
        override val nextAction: String = "Next action"
        override val agentReviewOrCompletion: String = "Agent rever or completion"
        override val noDueDate: String = "Sin due date"
        override val reopen: String = "Reabrir"
        override val accept: String = "Aceptar"
        override val linkedTasks: String = "Vinculado tareas"
        override val noLinkedTasks: String = "Sin linked tareas todavía."
        override val filesTitle: String = "Archivos"
        override val attachFile: String = "Attach archivo"
        override val noFilesAttached: String = "Sin archivos attached todavía."
        override val fileLimitHint: String = "Archivos can be PDF, DOC, CAD, or other formats up to 20 MB each."
        override val deleteFileTitle: String = "Eliminar archivo?"
        override val deleteFileBody: String = "This archivo will be removed from HAVN storage."
        override val attachmentOpenFailed: String = "No se pudo abrir este archivo."
        override val attachmentDeleteOwnerOnly: String = "Only the archivo propietario can eliminar this attachment."
        override val attachmentDocumentsNotIncluded: String = "Tu plan actual no incluye la carga de archivos. Mejora el plan para subir archivos."
        override val attachmentDocumentStorageNotIncluded: String = "Tu plan actual no incluye almacenamiento de documentos. Mejora el plan para subir archivos."
        override val attachmentFileSizePlanLimit: String = "Este archivo supera el tamaño permitido por tu plan actual. Mejora el plan para subir archivos más grandes."
        override val attachmentStoragePlanLimit: String = "Se alcanzó el límite de almacenamiento de tu plan actual. Mejora el plan para subir más archivos."
        override val attachmentDocumentCountPlanLimit: String = "Se alcanzó el límite de documentos para esta propiedad en tu plan actual. Mejora el plan para subir más archivos."
        override val attachmentHardFileLimit: String = "Los archivos adjuntos están limitados a 100 MB."
        override val openFiles: String = "Abrir archivos"
        override val sendViaEmail: String = "Enviar por e-mail"
        override val sendViaSms: String = "Enviar por SMS"
        override val sendEmailHeader: String = "Enviar e-mail"
        override val sendSmsHeader: String = "Enviar SMS"
        override val noContactsFound: String = "Sin contactoos found."
        override val searchContacts: String = "Buscar contactoos"
        override val linked: String = "Vinculado"
        override val recent: String = "Reciente"
        override val taskColumnToDo: String = "To Do"
        override val taskColumnInProgress: String = "In Progress"
        override val taskColumnDone: String = "Listo"
        override val taskColumnToDoSubtitle: String = "New tareas and next actions waiting to be started."
        override val taskColumnInProgressSubtitle: String = "Work currently owned por you or the team."
        override val taskColumnDoneSubtitle: String = "Completadas tareas kept visible for team confidence."
        override val taskEmptyToDo: String = "Sin tareas to do."
        override val taskEmptyInProgress: String = "Nothing in progress."
        override val taskEmptyDone: String = "Sin completed tareas todavía."
        override val taskKanbanEmptyToDo: String = "Nothing waiting. New seguimientos and informe work will appear here."
        override val taskKanbanEmptyInProgress: String = "Sin activo work in progress."
        override val taskKanbanEmptyDone: String = "Completadas tareas will land here."
        override val taskEmptyBodyPrefix: String = "Crear a tarea or move another tarea into"
        override val taskEmptyBodySuffix: String = "."
        override val taskActionStart: String = "Inicio"
        override val taskActionOverdue: String = "Vencidas"
        override val taskActionCancel: String = "Cancelar"
        override val taskPriorityLow: String = "Low"
        override val taskPriorityMedium: String = "Yodium"
        override val taskPriorityHigh: String = "High"
        override val taskPriorityUrgent: String = "Urgent"
        override val taskStatusOpen: String = "Open"
        override val taskStatusInProgress: String = "In progress"
        override val taskStatusDone: String = "Listo"
        override val taskStatusOverdue: String = "Vencidas"
        override val taskStatusCancelled: String = "Cancelarado"
        override val aiSuggestedTasks: String = "Tareas sugeridas por AI"
        override val noAiSuggestedTasks: String = "Sin AI suggestions todavía. HAVN will suggest tareas después de visitas and lead activity."
        override val taskFilterToday: String = "Hoy"
        override val taskFilterUpcoming: String = "Próximas"
        override val taskFilterOverdue: String = "Vencidas"
        override val taskFilterCompleted: String = "Completadas"
        override val taskFilterAssignedToMe: String = "Assigned to Yo"
        override val taskFilterAiSuggested: String = "Sugeridas por AI"
        override val taskFilterEmptyToday: String = "You're clear for hoy."
        override val taskFilterEmptyUpcoming: String = "Sin upcoming tareas."
        override val taskFilterEmptyOverdue: String = "Sin overdue tareas."
        override val taskFilterEmptyCompleted: String = "Sin completed tareas todavía."
        override val taskFilterEmptyAssignedToMe: String = "Sin tareas assigned to you."
        override val taskFilterEmptyAiSuggested: String = "Sin accepted AI suggested tareas todavía."
        override val taskSuggestionHotLeadTitlePrefix: String = "Hacer seguimiento a"
        override val taskSuggestionHotLeadTitleSuffix: String = "within 2 hours."
        override val taskSuggestionHotLeadDescriptionPrefix: String = "Hot lead from"
        override val taskSuggestionHotLeadDescriptionSuffix: String = "Keep momentum while intent is fresh."
        override val taskSuggestionHotLeadReason: String = "New hot lead captured."
        override val taskSuggestionSellerReportTitlePrefix: String = "Generate informe vendedor for"
        override val taskSuggestionSellerReportTitleSuffix: String = "."
        override val taskSuggestionSellerReportDescription: String = "Resume volumen de visitantes, leads calientes, actividad de seguimientos y sentimiento de compradores."
        override val taskSuggestionSellerReportReason: String = "Open house ended."
        override val taskSuggestionReviewFollowUpTitlePrefix: String = "Rever and enviar"
        override val taskSuggestionReviewFollowUpTitleSuffix: String = "seguimiento."
        override val taskSuggestionReviewFollowUpReason: String = "Seguimiento draft still needs agent rever."
        override val taskSuggestionKioskTitle: String = "Preparar modo kiosco y verificar fotos de la propiedad."
        override val taskSuggestionKioskDescription: String = "Confirm sign-in flow, gallery, and visita details antes de buyers arrive."
        override val taskSuggestionKioskReason: String = "Open house is scheduled."
    }

    private val italian: HavnStrings = object : HavnStrings {
        override val navToday: String = "Oggi"
        override val navProperties: String = "Immobili"
        override val navLeads: String = "Lead"
        override val navReports: String = "Report"
        override val navTasks: String = "Attività"
        override val navAnalytics: String = "Analisi"
        override val navAgency: String = "Agenzia"
        override val navSettings: String = "Impostazioni"
        override val navAuth: String = "Accesso agente"
        override val navOpenHouses: String = "Visite"
        override val navTours: String = "Visite"
        override val navFollowUps: String = "Contatti"
        override val navFollow: String = "Contatti"
        override val back: String = "Indietro"
        override val settingsEyebrow: String = "Area di lavoro"
        override val settingsTitle: String = "Impostazioni"
        override val settingsSubtitle: String = "Profilo, lingua, unita, ambiente e opzioni del team."
        override val agentProfileTitle: String = "Profilo agente"
        override val agentPhoto: String = "Foto agente"
        override val uploading: String = "Caricamento..."
        override val saving: String = "Salvataggio..."
        override val validAgentPhotoRequired: String = "Scegli una foto agente valida."
        override val signOut: String = "Esci"
        override val signOutQuestion: String = "Uscire?"
        override val signOutConfirmation: String = "Vuoi davvero uscire da HAVN?"
        override val deleteAccount: String = "Elimina account"
        override val deleteAccountQuestion: String = "Eliminare account?"
        override val deleteAccountOpenPageBody: String = "Si aprirà la pagina per richiedere l’eliminazione dell’account."
        override val deleteAccountReviewTitle: String = "Usa un account reale"
        override val deleteAccountReviewBody: String = "Questo account di app review è protetto per evitare che i reviewer perdano l’accesso durante i test. Usa un account di test reale per verificare l’eliminazione dell’account."
        override val upgrade: String = "Upgrade"
        override val premiumThemesTitle: String = "Temi premium"
        override val premiumThemesUpgradePrompt: String = "Passa a Pro per sbloccare i temi premium."
        override val appearanceTitle: String = "Aspetto"
        override val appearanceBody: String = "Scegli la modalità chiara o scura per l’app web."
        override val previewComponents: String = "Anteprima componenti"
        override val themeShowcaseTitle: String = "Anteprima tema"
        override val showcaseButtons: String = "Pulsanti"
        override val showcasePrimaryAction: String = "Azione principale"
        override val showcaseSecondaryAction: String = "Azione secondaria"
        override val showcaseGhostAction: String = "Azione discreta"
        override val showcaseTextField: String = "Campo testo"
        override val showcaseFocusedBorder: String = "Bordo evidenziato"
        override val showcaseSearchPreview: String = "Anteprima ricerca"
        override val showcaseOpeningCheckedIn: String = "Check-in a un’apertura oggi"
        override val showcaseSentAt: String = "Inviato alle 10:30"
        override val themeObsidianGoldName: String = "Obsidian Gold"
        override val themeObsidianGoldDescription: String = "Nero di lusso, grafite e oro caldo."
        override val themeMidnightSapphireName: String = "Midnight Sapphire"
        override val themeMidnightSapphireDescription: String = "Blu notte, zaffiro e accenti argento."
        override val themeEmeraldEstateName: String = "Emerald Estate"
        override val themeEmeraldEstateDescription: String = "Smeraldo scuro, carbone e oro champagne."
        override val themePlatinumStoneName: String = "Platinum Stone"
        override val themePlatinumStoneDescription: String = "Grigio pietra, platino e bianco morbido."
        override val themeBordeauxNoirName: String = "Bordeaux Noir"
        override val themeBordeauxNoirDescription: String = "Vino scuro, grafite e accenti rame."
        override val commonChange: String = "Cambia"
        override val agentPlanTitle: String = "Piano agente"
        override val agentPlanBody: String = "Migliora la tua esperienza e scegli il piano più adatto al tuo modo di lavorare."
        override val currentPlan: String = "Piano attuale"
        override val transferPlan: String = "Trasferisci piano"
        override val transferPlanTitle: String = "Trasferisci piano"
        override val transferPlanBody: String = "Sposta questo abbonamento su un altro account HAVN. Entrambi gli indirizzi email devono confermare con codici di verifica."
        override val transferTargetEmail: String = "Email del nuovo account"
        override val transferSendCodes: String = "Invia codici di verifica"
        override val transferCodesSentTitle: String = "Codici inviati"
        override val transferCodesSentBody: String = "Abbiamo inviato un codice alla tua email e uno all’email del nuovo account."
        override val transferYourCode: String = "Codice dalla tua email"
        override val transferTargetCode: String = "Codice del nuovo account"
        override val transferConfirm: String = "Trasferisci piano"
        override val transferSuccessTitle: String = "Piano trasferito"
        override val transferSuccessBody: String = "L’abbonamento è ora collegato al nuovo account HAVN."
        override val restorePurchase: String = "Ripristina acquisto"
        override val agencySettingsProBody: String = "Solo agency è attiva per impostazione predefinita. Pro permette di creare o selezionare un’agenzia condivisa."
        override val agencySettingsLockedBody: String = "Solo agency è attiva. Le modifiche all’agenzia si sbloccano con Pro."
        override val soloAgency: String = "Solo agenzia"
        override val defaultPrivateAgencyWorkspace: String = "Agenzia privata predefinita"
        override val noAgenciesAvailableYet: String = "Non ci sono ancora inviti o agenzie possedute disponibili."
        override val oneOwnedAgencyHint: String = "La tua agenzia è elencata sopra. Un agente può possedere una sola agenzia."
        override val createAgency: String = "Crea agenzia"
        override val createYourAgency: String = "Crea la tua agenzia"
        override val createAgencyBody: String = "Costruisci il tuo team, gestisci proprietà insieme e fai crescere il tuo business."
        override val agencyName: String = "Nome agenzia"
        override val agencyEmail: String = "Email agenzia"
        override val logoOptional: String = "Logo (opzionale)"
        override val upgradeExperienceTitle: String = "Migliora la tua esperienza"
        override val upgradeExperienceSubtitle: String = "Scegli il piano più adatto al tuo modo di lavorare."
        override val soloAgentPlan: String = "Solo agent"
        override val proAgentPlan: String = "Pro agent"
        override val teamAgentPlan: String = "Team"
        override val soloBenefitActiveProperties: String = "Fino a 1.000 proprietà"
        override val soloBenefitAiFollowUps: String = "1.000 richieste di testo AI / mese"
        override val soloBenefitSellerReports: String = "Nessun report venditore"
        override val soloBenefitPersonalOnly: String = "Solo account personale"
        override val proBenefitUnlimitedProperties: String = "Fino a 10.000 proprietà"
        override val proBenefitUnlimitedAi: String = "10.000 richieste di testo AI / mese"
        override val proBenefitAdvancedReports: String = "Report venditore avanzati"
        override val proBenefitAgencyCreation: String = "Creazione e gestione agenzia"
        override val proBenefitInviteAgents: String = "Invita agenti e collabora"
        override val proBenefitSharedLeads: String = "Lead condivisi e workflow team"
        override val proBenefitAgencyBranding: String = "Branding agenzia"
        override val proBenefitAdvancedAnalytics: String = "Analisi avanzate"
        override val teamBenefitLargeLimits: String = "Limiti per team"
        override val teamBenefitPrioritySupport: String = "Supporto e-mail prioritario"
        override val teamBenefitDailyBackups: String = "Backup giornalieri per 7 giorni"
        override val teamBenefitLargeStorage: String = "10 GB di archiviazione documenti"
        override val startFreeTrial7Day: String = "Abbonati ora"
        override val restorePurchases: String = "Ripristina acquisto"
        override val comparePlans: String = "Confronta piani"
        override val startFreeTrial: String = "Scegli piano"
        override val noCommitmentCancelAnytime: String = "Nessun impegno. Annulla quando vuoi."
        override val monthly: String = "Mensile"
        override val yearly: String = "Annuale"
        override val yearlySave20: String = "Annuale"
        override val yearlySavings20: String = "Fatturazione annuale."
        override val perYear: String = "/ anno"
        override val loadingPlans: String = "Caricamento piani..."
        override val selectedPlanUnavailable: String = "Questo piano non è ancora disponibile. Riprova più tardi o contatta il supporto."
        override val signInRequiredForPurchase: String = "Accedi prima di acquistare."
        override val subscriptionDisclosureIos: String = "Abbonamento con rinnovo automatico. Il pagamento verrà addebitato al tuo account Apple alla conferma dell'acquisto. L'abbonamento si rinnova automaticamente salvo annullamento almeno 24 ore prima della fine del periodo in corso. Il rinnovo verrà addebitato entro le 24 ore precedenti la fine del periodo in corso. Puoi gestire o annullare l'abbonamento nelle impostazioni dell'account App Store."
        override val subscriptionDisclosureAndroid: String = "Abbonamento con rinnovo automatico tramite Google Play. Ti verrà addebitato ogni periodo di fatturazione salvo annullamento. Puoi gestire o annullare l'abbonamento in qualsiasi momento negli abbonamenti Google Play. L'accesso continua fino alla fine del periodo pagato."
        override val subscriptionDisclosureWeb: String = "Abbonamento con rinnovo automatico. Ti verrà addebitato ogni periodo di fatturazione con il metodo di pagamento selezionato salvo annullamento. Puoi gestire o annullare in qualsiasi momento dalle impostazioni di fatturazione. L'accesso continua fino alla fine del periodo pagato. Potrebbero essere applicate imposte."
        override val subscriptionAgreementPrefix: String = "Abbonandoti, accetti i"
        override val subscriptionTermsOfUse: String = "Termini di utilizzo HAVN"
        override val subscriptionAgreementAnd: String = "e la"
        override val subscriptionPrivacyPolicy: String = "Informativa sulla privacy."
        override val purchaseSuccessTitle: String = "Grazie per l'acquisto"
        override val purchaseSuccessBody: String = "Il tuo abbonamento HAVN è attivo e il piano è pronto."
        override val restoreSuccessTitle: String = "Ripristina acquisto"
        override val restoreSuccessBody: String = "Il tuo abbonamento HAVN è stato ripristinato correttamente."
        override val purchaseCouldNotComplete: String = "Non è stato possibile completare l’acquisto. Riprova o controlla il tuo account App Store o Google Play."
        override val purchaseVerificationPending: String = "Your payment has not been confirmed yet. If you completed checkout, use Restore purchase to check again. You do not need to pay again."
        override val completeWebCheckout: String = "Complete payment in the checkout tab, then return here. Your access will update automatically once payment is confirmed."
        override val restoreCouldNotComplete: String = "Non è stato trovato alcun abbonamento HAVN attivo per questo account dello store."
        override val noActiveSubscriptionFound: String = "Non è stato trovato alcun abbonamento HAVN attivo per questo account dello store."
        override val compareActiveProperties: String = "Proprietà attive"
        override val compareAiFollowUps: String = "AI follow-up"
        override val compareSellerReports: String = "Report venditore"
        override val compareAdvancedAnalytics: String = "Analisi avanzate"
        override val compareAgencyCreation: String = "Creazione agenzia"
        override val compareJoinAgencies: String = "Unisciti ad agenzie"
        override val compareInviteAgents: String = "Invita agenti"
        override val compareSharedLeads: String = "Lead condivisi"
        override val compareAgencyBranding: String = "Branding agenzia"
        override val comparePrioritySupport: String = "Supporto prioritario"
        override val compareFeature: String = "Funzionalità"
        override val compareFreePlan: String = "Gratis"
        override val compareValueYes: String = "Sì"
        override val compareValueNo: String = "No"
        override val comparePricePerMonthUser: String = "Prezzo / mese / utente"
        override val comparePricePerYearUser: String = "Prezzo / anno / utente"
        override val compareMaxPropertiesOwner: String = "Max proprietà / proprietario"
        override val compareMaxContactsOwner: String = "Max contatti / proprietario"
        override val compareMaxOpenHousesOwner: String = "Max open house / proprietario"
        override val compareMaxLeadsOwner: String = "Max lead / proprietario"
        override val compareMaxPhotosProperty: String = "Max foto per proprietà"
        override val compareMaxDocumentsProperty: String = "Max documenti per proprietà"
        override val compareDocumentsStorage: String = "Archiviazione documenti"
        override val compareAgencyAgenda: String = "Agenda agenzia"
        override val compareAiTextRequestsMonth: String = "Richieste di testo AI / mese"
        override val compareAnalytics: String = "Analisi"
        override val compareTasks: String = "Attività"
        override val compareDocumentsStorageOwner: String = "Archiviazione documenti / proprietario"
        override val compareMaxFileSizeOwner: String = "Dimensione max file / proprietario"
        override val compareEmailSupport: String = "Supporto e-mail"
        override val compareDailyBackups7Days: String = "Backup giornalieri conservati per 7 giorni"
        override val compareKioskMode: String = "Modalità kiosk"
        override val unlimited: String = "Illimitato"
        override val basic: String = "Base"
        override val advanced: String = "Avanzato"
        override val perMonth: String = "/ mese"
        override val members: String = "membri"
        override val upgradeToProForAgencyTools: String = "Passa a Pro per usare gli strumenti agenzia"
        override val languageTitle: String = "Lingua"
        override val languageBody: String = "Scegli la lingua dell'app per questo dispositivo."
        override val english: String = "English"
        override val slovak: String = "Slovak"
        override val unitsTitle: String = "Unita e valuta"
        override val unitsBody: String = "Scegli come mostrare prezzi e superfici nell'app."
        override val measurementSystemTitle: String = "Misura"
        override val metric: String = "Metrico"
        override val imperial: String = "Imperiale"
        override val currencyTitle: String = "Valuta"
        override val notificationsTitle: String = "Notifiche"
        override val notificationsBody: String = "Control push alerts, quiet hours, and the types of updates HAVN can invia."
        override val notificationSettings: String = "Impostazioni notifiche"
        override val notificationsSubtitle: String = "Only important updates, filtered da your preferences."
        override val quietHoursTitle: String = "Ore silenziose"
        override val quietHoursBody: String = "HAVN skips non-critical pushes during quiet hours. Billing and account issues still stay concise."
        override val enableQuietHours: String = "Attiva ore silenziose"
        override val quietHoursStart: String = "Inizio"
        override val quietHoursEnd: String = "Fine"
        override val timezoneLabel: String = "Fuso orario"
        override val notificationTypesTitle: String = "Tipi di notifica"
        override val notificationNewLeadCapturedTitle: String = "Nuovo lead acquisito"
        override val notificationNewLeadCapturedBody: String = "When an open house or QR flow captures a lead."
        override val notificationHotLeadTitle: String = "Lead segnato caldo"
        override val notificationHotLeadBody: String = "Solo quando un lead mostra forte interesse."
        override val notificationOpeningStartsSoonTitle: String = "Open house starts soon"
        override val notificationOpeningStartsSoonBody: String = "A single reminder 30 minutes prima di start."
        override val notificationOpeningSummaryReadyTitle: String = "Open house summary ready"
        override val notificationOpeningSummaryReadyBody: String = "Quando il riepilogo post open house è pronto."
        override val notificationSellerReportGeneratedTitle: String = "Report venditore creato"
        override val notificationSellerReportGeneratedBody: String = "When a report venditore has been cread."
        override val notificationAiFollowUpReadyTitle: String = "AI follow-up ready"
        override val notificationAiFollowUpReadyBody: String = "When a follow-up draft is ready to revedi."
        override val notificationAgentInvitedTitle: String = "Agent invitad to agenzia"
        override val notificationAgentInvitedBody: String = "Agenzia invitations and membrihip changes."
        override val notificationLeadAssignedTitle: String = "Lead assegnato a te"
        override val notificationLeadAssignedBody: String = "Quando un collega ti assegna un lead."
        override val notificationLeadTransferredTitle: String = "Lead trasferito a te"
        override val notificationLeadTransferredBody: String = "When proprietarioship of a lead moves to you."
        override val notificationSubscriptionIssueTitle: String = "Problema abbonamento"
        override val notificationSubscriptionIssueBody: String = "Rinnovi non riusciti e problemi di pagamento."
        override val kioskSecurityTitle: String = "Sicurezza kiosk"
        override val kioskSecurityBody: String = "Usa questo PIN per uscire dal modo kiosk e tornare all’app agente."
        override val kioskPinLabel: String = "PIN kiosk"
        override val mcpAccessTitle: String = "Accesso MCP"
        override val mcpAccessBody: String = "Collega HAVN a Claude, OpenAI e altri client MCP su mcp.havnre.app. Disponibile in ogni piano."
        override val mcpAuthorizationBearer: String = "Autorizzazione: Bearer"
        override val mcpNoApiKeyCreated: String = "Nessuna chiave API creata"
        override val mcpNotUsedYet: String = "Non ancora usata"
        override val mcpLastUsedPrefix: String = "Ultimo utilizzo"
        override val mcpRevealApiKeyTitle: String = "Mostra chiave API"
        override val mcpRevealApiKeyBody: String = "La chiave completa viene mostrata solo dopo la creazione o la rotazione."
        override val mcpCreateKey: String = "Crea chiave"
        override val mcpRotateKey: String = "Ruota chiave"
        override val mcpRevokeKey: String = "Revoca chiave"
        override val mcpEndpointHint: String = "Usa l’endpoint https://mcp.havnre.app/mcp con questa chiave come token Bearer."
        override val mcpUpgradeHint: String = "L’accesso MCP è disponibile in ogni piano HAVN."
        override val mcpUpgradePrompt: String = "L’accesso MCP è disponibile in ogni piano HAVN."
        override val mcpCopied: String = "Copiato"
        override val mcpCopy: String = "Copia"
        override val mcpLoading: String = "Caricamento"
        override val kioskFeaturedProperty: String = "Featured immobile"
        override val kioskPrivateShowing: String = "Visita privata"
        override val kioskLuxuryListing: String = "Listing di lusso"
        override val kioskFastCheckIn: String = "Check-in rapido"
        override val kioskExitContentDescription: String = "Esci dal kiosk"
        override val kioskWelcome: String = "Benvenuto"
        override val kioskGladHere: String = "Siamo felici che tu sia qui."
        override val kioskScanToCheckIn: String = "Scansiona per registrarti"
        override val kioskReceivePropertyDetails: String = "and receive immobile details"
        override val kioskOr: String = "Oppure"
        override val kioskStartCheckInManually: String = "Check-in manuale"
        override val kioskSecureInfo: String = "Le tue informazioni sono sicure e non saranno condivise."
        override val kioskExitTitle: String = "Esci dal kiosk"
        override val kioskExitBody: String = "Inserisci il PIN kiosk per tornare all’app agente."
        override val kioskIncorrectPin: String = "PIN errato."
        override val kioskUnlock: String = "Sblocca"
        override val kioskTellUsTitle: String = "Raccontaci di te"
        override val kioskTellUsBody: String = "Le tue informazioni vanno solo all’agente host."
        override val kioskFullName: String = "Nome completo"
        override val kioskContinue: String = "Continua"
        override val kioskQuestionsTitle: String = "Qualche domanda rapida"
        override val kioskQuestionsBody: String = "Aiuta l’agente a fare follow-up con il giusto contesto."
        override val kioskWorkingWithAgentQuestion: String = "Stai lavorando con un agente?"
        override val kioskYes: String = "Sì"
        override val kioskNo: String = "No"
        override val kioskInterestQuestion: String = "Cosa ti interessa?"
        override val kioskInterestBuying: String = "Acquisto"
        override val kioskInterestInvesting: String = "Investimento"
        override val kioskInterestBrowsing: String = "Solo curiosità"
        override val kioskInterestRelocating: String = "Trasferimento"
        override val kioskFinish: String = "Fine"
        override val kioskThankYou: String = "Grazie"
        override val kioskEnjoyVisitPrefix: String = "Buona visita a"
        override val kioskResetAutomatically: String = "Questo kiosk si resetterà automaticamente."
        override val environmentTitle: String = "Ambiente"
        override val environmentBody: String = "La connessione è configurata per questa build."
        override val secure: String = "Sicuro"
        override val brokerageProfileTitle: String = "Profilo agenzia"
        override val brokerageProfileBody: String = "Team branding, agent invitas, and notification preferences will live here."
        override val logout: String = "Esci"
        override val languageChanged: String = "Lingua cambiata"
        override val commonAdd: String = "Aggiungi"
        override val commonEdit: String = "Modifica"
        override val commonDelete: String = "Elimina"
        override val commonCancel: String = "Annulla"
        override val commonSave: String = "Salva"
        override val commonCreate: String = "Crea"
        override val commonDismiss: String = "Chiudi"
        override val commonAll: String = "Tutto"
        override val commonDone: String = "Fatto"
        override val commonSend: String = "Invia"
        override val commonTime: String = "Ora"
        override val commonHour: String = "Ora"
        override val commonMinute: String = "Minuto"
        override val commonAgency: String = "Agenzia"
        override val commonSettings: String = "Impostazioni"
        override val commonOpening: String = "Apertura"
        override val commonPropertyName: String = "Immobile"
        override val commonToday: String = "Oggi"
        override val agencyToolsAvailable: String = "Gli strumenti agenzia sono disponibili."
        override val agencySetupSubtitle: String = "Ogni account HAVN ha un’agenzia predefinita. Pro consente di gestire inviti, lead condivisi e branding."
        override val agencyRecentActivity: String = "Recenti activity"
        override val agencyActivityNewLead: String = "Nuovo lead aggiunto"
        override val agencyActivityInvitationAccepted: String = "Invito agente accettato"
        override val agencyActivityAgentJoined: String = "Agent joined the agenzia"
        override val agencyActivitySellerReport: String = "Seller report cread"
        override val agencyWorkspaceTitle: String = "Agenzia"
        override val agencyWorkspaceBody: String = "Scegli which agenzia you are working with."
        override val agencySoloActiveTitle: String = "Solo agenzia is attivo"
        override val agencyProRequiredTitle: String = "Pro piano required"
        override val agencyCreateOrAcceptInviteBody: String = "Crea your agenzia or accept an invita to collaborate with another agenzia."
        override val agencyProUnlockBody: String = "Agenzia changes, invitas, shared lead, and shared branding unlock with Pro."
        override val realEstate: String = "Immobiliare"
        override val proAgency: String = "Pro agenzia"
        override val agencyBrandingTitle: String = "Agenzia branding"
        override val agencyBrandingBody: String = "Set the agenzia name and logo shown in the app, kiosk, and team vedis."
        override val uploadLogo: String = "Carica logo"
        override val saveAgency: String = "Salva agenzia"
        override val yourAgencyRole: String = "Your agenzia role"
        override val agencyAgentsTitle: String = "Agenzia agents"
        override val agencyAgentsBody: String = "People eligible to work with this agenzia."
        override val inviteAgent: String = "Invita agent"
        override val loadingAgents: String = "Caricamento agents..."
        override val noAgencyAgentsYet: String = "Nessun agenzia agents ancora."
        override val changeRole: String = "Cambia ruolo"
        override val updating: String = "Aggiornamento..."
        override val deleting: String = "Eliminazione..."
        override val deleteInvite: String = "Annulla invito"
        override val chooseAgencyRoleFor: String = "Scegli the agenzia role for"
        override val removeAccess: String = "Remove access"
        override val inviteAgentBody: String = "Invia an agenzia invitation da email. The agent accepts dopo signing in with the same email."
        override val agentEmail: String = "Agent email"
        override val role: String = "Role"
        override val inviting: String = "Inviting..."
        override val invite: String = "Invita"
        override val agents: String = "Agents"
        override val ok: String = "OK"
        override val personalActivePropertyLimit: String = "Personal attivo immobile limit"
        override val personalAccountAgencyToolsLocked: String = "Personal account is attivo. Agenzia tools unlock with Pro."
        override val selected: String = "Selezionato"
        override val activeMembers: String = "attivo membri"
        override val agencySharedWorkspaceBody: String = "Shared immobili, contatti, open house, lead, follow-up, and report use this agenzia."
        override val actLikeAgent: String = "Agisci come agente"
        override val actAsAdmin: String = "Agisci come admin"
        override val actAsOwner: String = "Agisci come proprietario"
        override val actLikeAgentBody: String = "Usa l'agenzia come un normale agente."
        override val actLikeAgentSelectedBody: String = "Viene mostrato solo il lavoro assegnato o di proprietà."
        override val agencyRoleOwner: String = "Proprietario"
        override val agencyRoleAdmin: String = "Admin"
        override val agencyRoleAgent: String = "Agent"
        override val agencyRoleAssistant: String = "Assistente"
        override val agencyRoleViewer: String = "Lettore"
        override val agencyRoleOwnerDescription: String = "Controllo completo dell’agenzia, inclusi membri, branding, assegnazioni, annunci, lead e report."
        override val agencyRoleAdminDescription: String = "Gestione completa dell’agenzia tranne l’eliminazione dell’agenzia."
        override val agencyRoleAgentDescription: String = "Lavora su annunci, open house, lead, follow-up, note e report venditore assegnati."
        override val agencyRoleAssistantDescription: String = "Supporta gli annunci assegnati modificando lead, preparando follow-up e bozze di report."
        override val agencyRoleViewerDescription: String = "Accesso in sola lettura a dashboard e report."
        override val agencyCapabilityInviteRemoveMembers: String = "Invitare e rimuovere membri"
        override val agencyCapabilityChangeRoles: String = "Cambiare ruoli dei membri"
        override val agencyCapabilityManageAllProperties: String = "Creare, modificare ed eliminare tutti gli immobili"
        override val agencyCapabilityAssignAgents: String = "Assegnare agenti"
        override val agencyCapabilitySeeAllLeads: String = "Vedere tutti i lead"
        override val agencyCapabilityExportReports: String = "Esportare report"
        override val agencyCapabilityChangeBranding: String = "Cambiare branding e impostazioni dell’agenzia"
        override val agencyCapabilityDeleteAgency: String = "Eliminare agenzia"
        override val agencyCapabilityViewAssignedProperties: String = "Vedere immobili assegnati"
        override val agencyCapabilityHostAssignedOpenings: String = "Gestire open house assegnate"
        override val agencyCapabilitySeeAssignedLeads: String = "Vedere lead da immobili e open house assegnati"
        override val agencyCapabilityAddNotes: String = "Aggiungere note"
        override val agencyCapabilitySendFollowUps: String = "Inviare follow-up"
        override val agencyCapabilityCreateSellerReports: String = "Creare report venditore per annunci assegnati"
        override val agencyCapabilityEditAssignedLeads: String = "Modificare lead assegnati"
        override val agencyCapabilityPrepareFollowUps: String = "Preparare follow-up"
        override val agencyCapabilityCreateDraftReports: String = "Creare bozze di report"
        override val agencyCapabilityCannotDeleteProperties: String = "Non può eliminare immobili"
        override val agencyCapabilityCannotInviteAgents: String = "Non può invitare agenti salvo autorizzazione"
        override val agencyCapabilityViewDashboards: String = "Vedere dashboard"
        override val agencyCapabilityViewReports: String = "Vedere report"
        override val agencyCapabilityCannotEdit: String = "Non può modificare nulla"
        override val commonVisitors: String = "Lead"
        override val commonHot: String = "Caldo"
        override val commonWarm: String = "Tiepido"
        override val commonCold: String = "Freddo"
        override val commonActive: String = "Attivo"
        override val commonPlanned: String = "Pianificato"
        override val commonArchived: String = "Archiviato"
        override val commonPast: String = "Passate"
        override val commonFollowUps: String = "Follow-up"
        override val commonProperty: String = "Immobile"
        override val commonAddress: String = "Indirizzo"
        override val commonOpenHouse: String = "Open house"
        override val commonInquiry: String = "Richiesta"
        override val commonInquiries: String = "Richieste"
        override val generalInquiry: String = "Richiesta generale"
        override val generalInquiries: String = "Richieste generali"
        override val propertyInquiry: String = "Richiesta su immobile"
        override val propertyInquiries: String = "Richieste su immobili"
        override val addGeneralInquiry: String = "Aggiungi richiesta generale"
        override val newGeneralInquiry: String = "Nuova richiesta generale"
        override val noGeneralInquiries: String = "Nessuna richiesta generale."
        override val noPropertyInquiries: String = "Nessuna richiesta su immobili."
        override val buyerLookingFor: String = "Cosa cerca questo acquirente?"
        override val locationCity: String = "Località / città"
        override val radiusKm: String = "Raggio (km)"
        override val propertyType: String = "Tipo di immobile"
        override val budgetFrom: String = "Budget da"
        override val budgetTo: String = "Budget fino a"
        override val purchaseTimeline: String = "Tempistica di acquisto"
        override val createGeneralInquiry: String = "Crea richiesta generale"
        override val saveGeneralInquiry: String = "Salva richiesta generale"
        override val inquiryType: String = "Tipo di richiesta"
        override val leadSource: String = "Fonte del lead"
        override val notSpecified: String = "Non specificato"
        override val inquiryStatus: String = "Stato richiesta"
        override val inquiryFollowUp: String = "Follow-up richiesta"
        override val addInquiry: String = "Aggiungi richiesta"
        override val searchInquiries: String = "Cerca richieste"
        override val noInquiries: String = "Nessuna richiesta"
        override val noInquiriesBody: String = "Usa il pulsante più per aggiungere l’interesse di un acquirente da un contatto esistente."
        override val inquiryUnavailableTitle: String = "Richiesta non disponibile"
        override val inquiryUnavailableBody: String = "Questa richiesta potrebbe essere stata rimossa o essere ancora in caricamento."
        override val backToInquiries: String = "Torna alle richieste"
        override val deleteInquiry: String = "Elimina richiesta"
        override val deleteInquiryQuestionPrefix: String = "Eliminare"
        override val deleteInquiryQuestionSuffix: String = "da questo immobile?"
        override val deleteInquiryTargetFallback: String = "questa richiesta"
        override val propertyInquiriesBody: String = "Tieni traccia degli acquirenti che hanno chiesto informazioni su questo immobile. Le richieste appaiono anche nei lead."
        override val propertyInquiriesEmpty: String = "Aggiungi una richiesta scegliendo uno dei tuoi contatti."
        override val contactInquiriesBody: String = "Immobili per cui questo contatto ha chiesto informazioni."
        override val contactInquiriesEmpty: String = "Ancora nessuna richiesta su immobili."
        override val viewInquiries: String = "Vedi richieste"
        override val createContactFirstForInquiry: String = "Crea prima un contatto, poi aggiungi la richiesta da questo immobile."
        override val commonCheckedIn: String = "Checked in"
        override val commonNotScheduled: String = "not scheduled"
        override val todayTitle: String = "Oggi"
        override val todaySubtitle: String = "La vista giornaliera per open house, lead, follow-up e slancio venditore."
        override val todayOpenHousesMetric: String = "open house"
        override val capturedMetric: String = "captured"
        override val priorityMetric: String = "priority"
        override val noActivePropertiesTitle: String = "Nessun attivo immobili"
        override val noActivePropertiesBody: String = "Add or activate a immobile to make it appear on Oggi."
        override val checkIns: String = "Check-ins"
        override val allOpenHouses: String = "all open house"
        override val pendingDrafts: String = "pending drafts"
        override val priorityLead: String = "Priorità lead"
        override val nextOpenHouseAt: String = "Next open house at"
        override val noOpenHouseScheduled: String = "Nessun open house scheduled"
        override val personalAccount: String = "Account personale"
        override val accountReady: String = "Il tuo account è pronto"
        override val realEstateApp: String = "App immobiliare"
        override val needHelp: String = "Hai bisogno di aiuto?"
        override val contactSupport: String = "Contatta il supporto"
        override val upgradePlan: String = "Aggiorna piano"
        override val planSuffix: String = "Piano"
        override val todayActionsTitle: String = "Priorità di oggi"
        override val agencyInvitation: String = "Agenzia invitation"
        override val joinAgency: String = "Join"
        override val youWereInvitedAs: String = "You were invitad as"
        override val invitedBy: String = "da"
        override val decline: String = "Decline"
        override val yourDefaultAgency: String = "Your default agenzia"
        override val chooseAgencyBody: String = "Scegli which agenzia you want to work with. Agenzia tools include invitas, shared lead, and branding."
        override val agencyMembersSuffix: String = "membri"
        override val quickActionTasksBody: String = "Queue"
        override val quickActionReportsBody: String = "Seller"
        override val quickActionAnalyticsBody: String = "Trends"
        override val quickActionAddPropertyTitle: String = "Aggiungi"
        override val quickActionAddPropertyBody: String = "Immobile"
        override val quickActionAddContactTitle: String = "Contatto"
        override val quickActionAddContactBody: String = "Nuovo"
        override val quickActionFilesTitle: String = "File"
        override val quickActionFilesBody: String = "Doc."
        override val firstRunStepsTitle: String = "Inizio with four simple steps"
        override val firstRunAddProperty: String = "Add immobile"
        override val firstRunScheduleOpening: String = "Schedule open house"
        override val firstRunStartGuestCheckIn: String = "Inizio guest check-in"
        override val firstRunSendFollowUp: String = "Invia follow-up"
        override val greetingNamePrefix: String = "Ciao"
        override val greetingAgent: String = "Ciao agente"
        override val createListing: String = "Crea listing"
        override val newOwnerBuyer: String = "New proprietario/buyer"
        override val documents: String = "Documenti"
        override val whatOpeningNext: String = "Qual è la prossima apertura?"
        override val whoCheckedIn: String = "Chi ha effettuato il check-in?"
        override val whoNeedsFollowUp: String = "Chi necessita di follow-up?"
        override val whatShouldIDoNow: String = "Cosa devo fare ora?"
        override val noCheckInsYet: String = "Nessun contatto ha ancora effettuato il check-in."
        override val noPendingFollowUps: String = "Nessun follow-up in sospeso al momento."
        override val openKioskForNextOpening: String = "Apri il kiosk per la prossima apertura."
        override val reviewNewLeads: String = "Controlla i nuovi lead e invia follow-up."
        override val createOpeningToStart: String = "Crea un’apertura da un immobile per iniziare a raccogliere lead."
        override val addFirstPropertyToStart: String = "Aggiungi il primo immobile per iniziare."
        override val nextOpening: String = "Prossima apertura"
        override val quickSignIn: String = "Check-in rapido"
        override val scanQrCode: String = "Scansiona QR"
        override val newLead: String = "Nuovo lead"
        override val myProperties: String = "I miei immobili"
        override val manageListings: String = "Gestisci annunci"
        override val todaysOverview: String = "Panoramica di oggi"
        override val seeAll: String = "Vedi tutto"
        override val propertiesEyebrow: String = "Portfólio"
        override val propertiesSubtitle: String = "Manage attivo, pianoned, and archived listings with listing media, buyer activity, and performance insights."
        override val propertiesLiveMetric: String = "live"
        override val propertiesPipelineMetric: String = "pipeline"
        override val propertiesAllTimeMetric: String = "all time"
        override val addProperty: String = "Aggiungi immobile"
        override val editProperty: String = "Modifica immobile"
        override val propertyFallback: String = "Immobile"
        override val propertyUnavailableTitle: String = "Immobile non disponibile"
        override val propertyUnavailableBody: String = "Refresh the portfolio to reload this listing."
        override val backToProperties: String = "Torna agli immobili"
        override val deletePropertyTitle: String = "Eliminare immobile?"
        override val deletePropertyBody: String = "This will permanently elimina the immobile and its related local records. Questa azione non può essere annullata."
        override val loadingProperties: String = "Caricamento immobili"
        override val loadMore: String = "Carica altri"
        override val loadingPropertyDetails: String = "Caricamento immobile details"
        override val noPropertiesTitle: String = "Nessun immobile per ora"
        override val noPropertiesBody: String = "Add your first immobile, then crea an open house to start collecting lead and seller-ready feedback."
        override val openHouseButton: String = "Crea open house"
        override val photosTitle: String = "Foto"
        override val photosBody: String = "The first foto is used as the main immobile image across Portfolio."
        override val uploadPhoto: String = "Carica foto"
        override val noPhotosYet: String = "Nessuna foto caricata."
        override val propertyPhotoCountPlanLimit: String = "Hai raggiunto il limite di foto per questo immobile nel piano attuale. Passa a un piano superiore per caricare altre foto."
        override val propertyPhotoStoragePlanLimit: String = "Hai raggiunto il limite di spazio del piano attuale. Passa a un piano superiore per caricare altre foto o file."
        override val mainPhoto: String = "Principale"
        override val propertyTitleLabel: String = "Nome dell’immobile"
        override val propertyAddressLine1Label: String = "Indirizzo"
        override val propertyAddressLine2Label: String = "Indirizzo riga 2"
        override val propertyCityLabel: String = "Città"
        override val propertyRegionLabel: String = "Regione"
        override val propertyPostalCodeLabel: String = "CAP"
        override val propertyCountryLabel: String = "Paese"
        override val propertyAskingPriceLabel: String = "Prezzo richiesto"
        override val propertyBedsLabel: String = "Camere"
        override val propertyBathsLabel: String = "Bagni"
        override val propertyInteriorLabel: String = "Interni"
        override val propertyDescriptionLabel: String = "Descrizione"
        override val createPropertyButton: String = "+ Immobile"
        override val locateProperty: String = "Localizza immobile"
        override val findLocation: String = "Trova posizione"
        override val find: String = "Trova"
        override val navigate: String = "Naviga"
        override val propertyLocationMarkerTitle: String = "Posizione dell’immobile"
        override val mapKitJsMissingToken: String = "La mappa non è configurata per questa build."
        override val mapKitJsLoading: String = "Caricamento di MapKit JS..."
        override val generateSellerReport: String = "Genera report venditore"
        override val deleteProperty: String = "Elimina immobile"
        override val conversionMetric: String = "Conversione"
        override val propertyPhotoContentDescription: String = "Foto dell’immobile"
        override val deletePhoto: String = "Elimina foto"
        override val movePhotoLeft: String = "Sposta foto a sinistra"
        override val movePhotoRight: String = "Sposta foto a destra"
        override val propertyTitleRequired: String = "Il nome dell’immobile è obbligatorio."
        override val propertyStreetRequired: String = "L’indirizzo è obbligatorio."
        override val propertyCityRequired: String = "La città è obbligatoria."
        override val propertyRegionRequired: String = "La regione è obbligatoria."
        override val propertyPostalRequired: String = "Il CAP è obbligatorio."
        override val propertyAskingPriceInvalid: String = "Inserisci un prezzo richiesto valido."
        override val propertyOwnerContactTitle: String = "Contatto del proprietario"
        override val propertyOwnerSelectContact: String = "Seleziona un contatto esistente come proprietario della proprietà."
        override val propertyOwnerSelected: String = "Proprietario selezionato"
        override val propertyOwnerNoContacts: String = "Non ci sono ancora contatti. Aggiungi il proprietario in Contatti, poi selezionalo qui."
        override val propertyOwnerChooseContact: String = "Scegli contatto"
        override val propertyOwnerChangeContact: String = "Cambia contatto"
        override val propertyOwnerRemoveContact: String = "Rimuovi"
        override val propertyOwnerPickerTitle: String = "Scegli proprietario dell'immobile"
        override val propertyOwnerSearchContact: String = "Cerca contatti"
        override val propertyOwnerSearchHint: String = "Inizia a digitare nome, e-mail o telefono."
        override val propertyOwnerNoMatches: String = "Nessun contatto corrispondente."
        override val propertyOpeningsTitle: String = "Open house"
        override val propertyNoOpenings: String = "Nessuna open house programmata per questo immobile."
        override val teamAccessTitle: String = "Accesso team"
        override val onlyListingOwner: String = "Solo il proprietario dell’annuncio"
        override val assignTeam: String = "Assegna team"
        override val assignPropertyTitle: String = "Assegna immobile"
        override val assignPropertyBody: String = "Scegli chi può lavorare su questo immobile. Seleziona tutto il team o agenti specifici."
        override val wholeTeam: String = "Tutto il team"
        override val leadsEyebrow: String = "Lead"
        override val leadFallback: String = "Lead"
        override val leadsSubtitle: String = "Cerca, filtra e qualifica i lead raccolti in ogni open house."
        override val leadDetailSubtitle: String = "Origine, qualifica, note e cronologia follow-up per questo lead dell’open house."
        override val totalMetric: String = "Totale"
        override val loggedMetric: String = "registrati"
        override val searchLeads: String = "Cerca lead"
        override val searchLeadsPlaceholder: String = "Nome, telefono o e-mail"
        override val allProperties: String = "Tutti gli immobili"
        override val loadingLeads: String = "Caricamento lead open house"
        override val loadingLeadDetails: String = "Caricamento dettaglio lead"
        override val noLeadsFoundTitle: String = "I lead appariranno qui quando i contatti faranno check-in a un’open house."
        override val noLeadsEmptyBody: String = "Usa il check-in kiosk o aggiungi contatti manualmente da un’open house."
        override val noLeadsFilteredBody: String = "Prova un altro immobile, stato o termine di ricerca."
        override val backToLeads: String = "Torna ai lead"
        override val leadUnavailableTitle: String = "Lead non disponibile"
        override val leadUnavailableBody: String = "Questo lead non è più disponibile nell’elenco corrente."
        override val leadTemperature: String = "Stato lead"
        override val leadLabelSuffix: String = "Lead"
        override val greetingHi: String = "Ciao"
        override val leadActionCall: String = "Chiama"
        override val leadActionSms: String = "SMS"
        override val leadActionEmail: String = "E-mail"
        override val leadFollowUp: String = "Follow-up"
        override val leadNoFollowUpScheduled: String = "Nessun follow-up programmato"
        override val leadIntentScore: String = "Punteggio interesse"
        override val leadInterestedIn: String = "Interessato a"
        override val leadGenericGreetingName: String = "ciao"
        override val followUpMessageTypeThankYou: String = "Grazie"
        override val followUpMessageTypePropertyInfo: String = "Info immobile"
        override val followUpMessageTypeFollowUp: String = "Follow up"
        override val followUpMessageTypeCheckIn: String = "Verifica interesse"
        override val followUpMessageTypePriceUpdate: String = "Aggiornamento prezzo"
        override val followUpMessageTypePropertyBrochure: String = "File"
        override val followUpPreview: String = "Anteprima"
        override val followUpSubject: String = "Oggetto"
        override val followUpMessage: String = "Messaggio"
        override val followUpSendViaEmail: String = "Invia via e-mail"
        override val followUpSendViaSms: String = "Invia via SMS"
        override val followUpAiAssistantTitle: String = "Assistente AI"
        override val followUpAiAssistantBody: String = "Genera un messaggio personalizzato in pochi secondi."
        override val followUpGenerateWithAi: String = "Genera con AI"
        override val followUpUpgradeForAi: String = "Sblocca AI"
        override val followUpDefaultSubject: String = "Following up on"
        override val privateAgentNotes: String = "Private agent notes"
        override val notes: String = "Notes"
        override val notesPlaceholder: String = "Motivation, preferences, objections, next move"
        override val saveNotes: String = "Salva notes"
        override val followUpHistory: String = "Follow-up history"
        override val noFollowUpsLogged: String = "Nessun follow-up logged ancora."
        override val openHousesEyebrow: String = "Showings"
        override val scheduleOpenHouse: String = "Crea visita"
        override val openingDetails: String = "Dettagli apertura"
        override val editOpening: String = "Modifica apertura"
        override val deleteOpening: String = "Elimina apertura"
        override val deleteOpeningBody: String = "Vuoi davvero eliminare questa apertura? L’azione non può essere annullata."
        override val removeLeadTitle: String = "Rimuovere lead?"
        override val removeLeadBody: String = "Rimuovere %s da questa visita?"
        override val removeLeadFallback: String = "questo lead"
        override val openingName: String = "Nome apertura"
        override val startsAt: String = "Inizia"
        override val endsAt: String = "Finisce"
        override val chooseStartDateTime: String = "Scegli data e ora di inizio"
        override val chooseEndDateTime: String = "Scegli data e ora di fine"
        override val accessNotes: String = "Note di accesso"
        override val privateNotes: String = "Note private"
        override val addPrivateNote: String = "Aggiungi nota privata"
        override val liveDashboard: String = "Live dashboard"
        override val visitorKiosk: String = "Lead kiosk"
        override val openHousesSubtitle: String = "Crea open house for immobili, revedi lead, and launch kiosk sessions."
        override val liveMetric: String = "Live"
        override val upcomingMetric: String = "In arrivo"
        override val inProgressMetric: String = "in progress"
        override val scheduledMetric: String = "scheduled"
        override val loadingOpenHouses: String = "Caricamento open house"
        override val addPropertyFirstTitle: String = "Add a immobile first"
        override val addPropertyFirstBody: String = "Crea an open house from a immobile to start collecting lead."
        override val noOpenHousesTitle: String = "Nessun open house scheduled"
        override val noOpenHousesBody: String = "Crea an open house from a immobile to start collecting lead."
        override val noSignInsTitle: String = "Nessun sign-ins yet"
        override val noSignInsBody: String = "Lead checked in through kiosk mode will appear here in real time."
        override val dashboard: String = "Dashboard"
        override val start: String = "Inizio"
        override val end: String = "Fine"
        override val endOpenHouse: String = "Fine open house"
        override val reportsEyebrow: String = "Proprietarios"
        override val sellerReportsTitle: String = "Report venditore"
        override val createReport: String = "Report"
        override val reportPreview: String = "Report venditore"
        override val reportsSubtitle: String = "Crea riepiloghi premium post-open house con qualità lead, intenzione acquirenti e narrativa pronta per il venditore."
        override val reportsMetricSaved: String = "salvad"
        override val reportedMetric: String = "reported"
        override val leadsMetric: String = "lead"
        override val createSellerReport: String = "Report"
        override val attendance: String = "Presenze"
        override val savedReports: String = "salvad report"
        override val buyerHeat: String = "Interesse acquirenti"
        override val hotLeads: String = "caldi"
        override val loadingSellerReports: String = "Caricamento report venditore"
        override val noSellerReportsTitle: String = "Nessun report venditore yet"
        override val noSellerReportsBody: String = "Scegli an open house, add agent notes, prevedi an export-ready recap, then salva it."
        override val chooseOpenHouse: String = "Scegli open house"
        override val noOpenHousesAvailable: String = "Nessun open house available ancora."
        override val agentNotes: String = "Agent notes"
        override val notesForSeller: String = "Notes for seller"
        override val sellerNotesPlaceholder: String = "Obiezioni, segnali prezzo, feedback visita, prossimo passo consigliato"
        override val generatePreview: String = "Generate prevedi"
        override val noPreviewReadyTitle: String = "Nessun prevedi ready"
        override val noPreviewReadyBody: String = "Generate a report venditore prevedi prima di saving."
        override val saveReport: String = "Salva"
        override val reportSaved: String = "Report salvad"
        override val sellerOpenHouseReport: String = "Seller open house report"
        override val mostCommonBuyerInterest: String = "Most common buyer interest"
        override val followUpsSent: String = "Follow-up sent"
        override val summary: String = "Riepilogo"
        override val noPrivateNotesAdded: String = "Nessun private notes added."
        override val openHouseReport: String = "Open house report"
        override val commonDraft: String = "Bozza"
        override val commonAccepted: String = "Accettato"
        override val searchSellerReports: String = "Cerca report venditore"
        override val noMatchingReports: String = "Nessun report corrispondente"
        override val clearFilters: String = "Clear filters"
        override val tryDifferentSearchOrStatusFilter: String = "Prova un’altra ricerca o un altro filtro di stato."
        override val connectedToProperty: String = "Collegato all’immobile"
        override val viewProperty: String = "Vedi immobile"
        override val dataRollup: String = "Data rollup"
        override val connectedOpenings: String = "Open house"
        override val visitors: String = "Visitatori"
        override val interestedBuyers: String = "Acquirenti interessati"
        override val completedFollowUps: String = "Follow Ups"
        override val reportHistory: String = "Report history"
        override val noPreviousReportsYet: String = "Nessun report precedente."
        override val viewAllReports: String = "Vedi tutti i report"
        override val actions: String = "Azioni"
        override val generatePdf: String = "Crea foglio di calcolo"
        override val previewPdf: String = "Anteprima foglio"
        override val pdfSavedToPropertyFiles: String = "%s salvad to immobile file."
        override val pdfSavingToPropertyFiles: String = "%s is being salvad to immobile file."
        override val pdfSavedToFiles: String = "%s salvad to file."
        override val pdfSavingToFiles: String = "%s is being salvad to file."
        override val pdfIncludesSellerReport: String = "Spreadsheet includes Report venditore metrics, AI insights, agent details, immobile data, and open house history."
        override val pdfIncludesAnalytics: String = "Spreadsheet includes analisi metrics, top immobili, agent performance, follow-up channels, and AI insights."
        override val pdfGenerateBeforeSending: String = "Crea the spreadsheet prima di inviaing."
        override val pdfUploadBeforeSharing: String = "The spreadsheet must finish upcaricamento prima di sharing."
        override val sellerReportPdfNeedsProperty: String = "Il foglio di calcolo del report venditore richiede un immobile collegato prima del caricamento."
        override val deleteReport: String = "Elimina Report"
        override val deleteReportBody: String = "Vuoi davvero elimina this report venditore? Questa azione non può essere annullata."
        override val shareReport: String = "Share report"
        override val openingPropertyReportLoading: String = "Immobile report..."
        override val openingPropertyReportCreating: String = "Creating immobile report..."
        override val sellerReportGeneratedPrefix: String = "Report venditore generated"
        override val sellerReportGeneratedSuffix: String = "da open house, visitatori, lead, follow-up e feedback collegati a questo immobile al momento del report."
        override val priceNotSet: String = "Prezzo not set"
        override val daysSuffix: String = "giorni"
        override val connectedOpeningSingular: String = "open house"
        override val connectedOpeningPlural: String = "open house"
        override val connectedLeadSingular: String = "lead collegato"
        override val connectedLeadPlural: String = "lead collegati"
        override val sellerConfidence: String = "Seller confidence"
        override val sellerConfidenceExplanation: String = "Confidence expianoation"
        override val aiDraftReviewBeforeSending: String = "AI draft only. Revedi and modifica prima di inviaing to the seller."
        override val executiveSummary: String = "Executive summary"
        override val buyerInterestOverview: String = "Panoramica interesse acquirenti"
        override val whatBuyersLoved: String = "What buyers loved"
        override val buyerConcerns: String = "Dubbi acquirenti"
        override val leadQualitySummary: String = "Riepilogo qualità lead"
        override val agentActivity: String = "Agent activity"
        override val aiRecommendations: String = "AI recommendations"
        override val recommendations: String = "Consigli"
        override val marketPositionComparison: String = "Market position comparison"
        override val nextSteps: String = "Next steps"
        override val conversion: String = "Conversione"
        override val interested: String = "interested"
        override val tourSignalsLowercase: String = "tour signals"
        override val propertyTimeline: String = "Immobile timeline"
        override val timelineBasisNote: String = "La timeline si basa solo su registrazioni open house e follow-up collegati."
        override val visitorsLowercase: String = "visitatori"
        override val hotLeadsLowercase: String = "lead caldi"
        override val hotLowercase: String = "caldo"
        override val sentiment: String = "Sentiment"
        override val toursLowercase: String = "tours"
        override val interestedLowercase: String = "interested"
        override val noRepeatedFeedbackMentions: String = "Nessun repeated feedback mentions have been recorded ancora."
        override val scoresMentionRates: String = "Punteggios are mention rates across salvad buyer feedback."
        override val aiExecutiveBriefing: String = "AI executive briefing"
        override val viewAllAiInsights: String = "Vedi all AI insights ->"
        override val followUpsSentTitle: String = "Follow-Ups Sent"
        override val financingPacketsShared: String = "Financing Packets Shared"
        override val buyerCalls: String = "Chiamate acquirenti"
        override val propertyDataEvidence: String = "Immobile data evidence"
        override val attendanceCoverage: String = "Copertura presenze"
        override val leadQuality: String = "Qualità lead"
        override val followUpExecution: String = "Follow-up execution"
        override val activityChannels: String = "Canali attività"
        override val callsLowercase: String = "chiamate"
        override val emailsLowercase: String = "email"
        override val offerReadinessScore: String = "Offer readiness score"
        override val date: String = "Data"
        override val propertyLeadFunnel: String = "Immobile lead funnel"
        override val openHouseBreakdown: String = "Open house breakdown"
        override val aiInsights: String = "Insight AI"
        override val generateAiInsights: String = "Genera insight AI"
        override val analyticsOverview: String = "Analisi overvedi"
        override val allAgents: String = "All agents"
        override val me: String = "Io"
        override val allActivity: String = "All activity"
        override val latest30Days: String = "Latest 30 giorni"
        override val latest7Days: String = "Latest 7 giorni"
        override val analyticsDatePreset: String = "Periodo"
        override val analyticsCustomDate: String = "Custom date"
        override val analyticsLastDay: String = "Ultimo giorno"
        override val analyticsLastWeek: String = "Ultima settimana"
        override val analyticsLastMonth: String = "Ultimo mese"
        override val analyticsLastYear: String = "Ultimo anno"
        override val analyticsAllTime: String = "Sempre"
        override val analyticsDateFrom: String = "Data from"
        override val analyticsDateTo: String = "Data to"
        override val analyticsOpenHousesLowercase: String = "open house"
        override val analyticsWarmLeadsLowercase: String = "lead tiepidi"
        override val analyticsFromNotesFollowUps: String = ""
        override val analyticsFromText: String = "da testo"
        override val analyticsHotConversion: String = "Conversione lead caldi"
        override val analyticsHotLeadsPerVisitors: String = "lead caldi / visitatori"
        override val analyticsAverageIntent: String = "Avg. intent"
        override val analyticsVisitorIntentScore: String = "visitor intent score"
        override val analyticsSelectDate: String = "Seleziona date"
        override val propertyFunnel: String = "Immobile funnel"
        override val propertyFunnelSubtitle: String = "From immobile activity to qualified buyer momentum"
        override val properties: String = "Immobili"
        override val tourSignals: String = "Segnali visita"
        override val offerSignals: String = "Segnali offerta"
        override val viewFullFunnelReport: String = "Vedi full funnel report"
        override val performanceOverTime: String = "Andamento nel tempo"
        override val thirtyDays: String = "30 giorni"
        override val topPerformingProperties: String = "Immobili migliori"
        override val viewAll: String = "Vedi all"
        override val noPropertyAnalyticsYet: String = "Nessun immobile analisi ancora."
        override val leadQualityBreakdown: String = "Dettaglio qualità lead"
        override val warmLeadsTitle: String = "Lead tiepidi"
        override val coldLeadsTitle: String = "Lead freddi"
        override val followUpPerformance: String = "Follow-up performance"
        override val agentPerformance: String = "Agent performance"
        override val viewTeamReport: String = "Vedi report team"
        override val followUpChannels: String = "Canali follow-up"
        override val viewReport: String = "Vedi report"
        override val searchProperties: String = "Cerca immobili"
        override val searchOpenings: String = "Cerca visite"
        override val noOpeningsFoundTitle: String = "Nessun open house found"
        override val noOpeningsFoundBody: String = "Prova un’altra ricerca o un altro filtro di stato open house."
        override val noMatchingPropertiesTitle: String = "Nessun immobile corrispondente"
        override val noMatchingPropertiesBody: String = "Prova un’altra ricerca o un altro filtro di stato."
        override val clientsTitle: String = "Contatti"
        override val clientFallback: String = "Contacto"
        override val addClient: String = "Aggiungi contatto"
        override val editClient: String = "Modifica contatto"
        override val newClient: String = "Nuovo contatto"
        override val saveClient: String = "Salva contatto"
        override val createClient: String = "Crea contatto"
        override val deleteClientTitle: String = "Elimina contatto?"
        override val deleteClientBody: String = "This will permanently elimina the contatto. Questa azione non può essere annullata."
        override val firstName: String = "Nome"
        override val lastName: String = "Cognome"
        override val email: String = "E-mail"
        override val phone: String = "Telefono"
        override val comments: String = "Commenti"
        override val addPhoto: String = "Aggiungi foto"
        override val sendQr: String = "Invia QR"
        override val sendQrShareTitle: String = "Il tuo QR HAVN per la visita"
        override val sendQrShareBody: String = "Il tuo QR HAVN per la visita è allegato. Aggiungi il Wallet pass (.pkpass) al telefono quando disponibile, oppure mostra l’immagine QR alla visita."
        override val sendQrReadyMessage: String = "Codice QR pronto per l’invio"
        override val sendQrUnavailableError: String = "Nessuna app e-mail o SMS è disponibile per questo contatto."
        override val clientQrDeliveryRequired: String = "Aggiungi un’e-mail o un numero di telefono per inviare il QR."
        override val photo: String = "Foto"
        override val clientDetailSubtitle: String = "Identità QR, dati di contatto, commenti e visite collegate tramite lead."
        override val clientFormEditSubtitle: String = "Aggiorna dati di contatto, consegna e commenti."
        override val clientFormNewSubtitle: String = "Registra un acquirente/contatto e genera un’identità QR riutilizzabile per le visite."
        override val searchClients: String = "Cerca contatti"
        override val noClientsYetTitle: String = "Ancora nessun contatto"
        override val noClientsYetBody: String = "Registra prima i contatti, poi invia loro il codice QR via e-mail o SMS prima di una visita."
        override val noClientsFoundTitle: String = "Nessun contatto trovato"
        override val noClientsFoundBody: String = "Prova con un altro nome, telefono o e-mail."
        override val clientUnavailableTitle: String = "Contatto non disponibile"
        override val clientUnavailableBody: String = "Aggiorna l’elenco contatti e apri di nuovo questo record."
        override val noCommentsAdded: String = "Nessun commento aggiunto."
        override val openingsTitle: String = "Visite"
        override val clientOpeningsEmpty: String = "Nessuna visita collegata. I lead collegano un contatto a una visita."
        override val clientPassLabel: String = "Wallet pass"
        override val clientNoEmail: String = "Senza e-mail"
        override val visitorsBody: String = "Apri il kiosk, scansiona il QR di un contatto o aggiungi contatti esistenti come lead per questa visita."
        override val openKiosk: String = "Apri kiosk"
        override val addQrClient: String = "Contatto QR"
        override val addManually: String = "Manuale"
        override val selectClients: String = "Seleziona contatti"
        override val selectClientsBody: String = "Scegli i contatti dall’elenco. Ogni contatto selezionato diventa un lead per questa visita."
        override val kioskCheckIn: String = "Check-in kiosk"
        override val kioskCheckInBody: String = "Usa la fotocamera posteriore per scansionare il QR HAVN Wallet del contatto. Quando il codice viene riconosciuto, HAVN crea automaticamente il lead per questa visita."
        override val scanWithCamera: String = "Scansiona con fotocamera posteriore"
        override val clientQrImage: String = "Immagine QR del contatto"
        override val clientQrImageBody: String = "Mantieni il QR del contatto dentro il quadrato dorato. HAVN raccoglie ogni scansione qui sotto."
        override val scanMultipleQrBody: String = "Scansiona uno o più codici QR di contatti HAVN, poi tocca Aggiungi contatto QR."
        override val scannedQrReady: String = "QR contatto pronto da aggiungere"
        override val createLeadFromQr: String = "Crea lead da QR"
        override val noClientsFoundShort: String = "Nessun contatto trovato."
        override val remove: String = "Rimuovi"
        override val tasksTitle: String = "Attività"
        override val addTask: String = "Add attività"
        override val searchTasks: String = "Cerca attività"
        override val loadMoreTasks: String = "Load more attività"
        override val createTask: String = "Crea Attività"
        override val saveTask: String = "Salva Attività"
        override val editTask: String = "Modifica Attività"
        override val newTask: String = "New attività"
        override val taskDetails: String = "Attività Details"
        override val taskName: String = "Nome"
        override val taskDescription: String = "Descrizione"
        override val taskDueDateTime: String = "Attività date & time"
        override val chooseTaskDateTime: String = "Scegli attività date & time"
        override val clearTaskDateTime: String = "Clear date & time"
        override val assignToAgent: String = "Assegna ad agente"
        override val noAgencyAgentsFound: String = "Nessun agenzia agents found. The attività will stay assigned to the proprietario."
        override val taskPriority: String = "Attività Priorità"
        override val taskStatus: String = "Stato"
        override val taskVisibility: String = "Visibilità"
        override val taskOwner: String = "Proprietario"
        override val taskOwnerFallback: String = "Attività proprietario"
        override val assignedTo: String = "Assigned to"
        override val selectedAgent: String = "Selezionato agent"
        override val taskVisibilityBody: String = "This attività is visible to the proprietario and the assigned agent."
        override val taskQueue: String = "Attività queue"
        override val taskDetail: String = "Attività detail"
        override val taskDetailEmpty: String = "Seleziona a attività to see context and next actions."
        override val connectedContext: String = "Contesto collegato"
        override val noTaskContext: String = "Nessun immobile, contatto, open house, or lead is linked ancora."
        override val activityTimeline: String = "Timeline attività"
        override val created: String = "Cread"
        override val recently: String = "Recentily"
        override val completed: String = "Completate"
        override val nextAction: String = "Next action"
        override val agentReviewOrCompletion: String = "Agent revedi or completion"
        override val noDueDate: String = "Nessun due date"
        override val reopen: String = "Riapri"
        override val accept: String = "Accetta"
        override val linkedTasks: String = "Collegato attività"
        override val noLinkedTasks: String = "Nessun linked attività ancora."
        override val filesTitle: String = "File"
        override val attachFile: String = "Attach file"
        override val noFilesAttached: String = "Nessun file attached ancora."
        override val fileLimitHint: String = "File can be PDF, DOC, CAD, or other formats up to 20 MB each."
        override val deleteFileTitle: String = "Elimina file?"
        override val deleteFileBody: String = "This file will be removed from HAVN storage."
        override val attachmentOpenFailed: String = "Impossibile aprire questo file."
        override val attachmentDeleteOwnerOnly: String = "Only the file proprietario can elimina this attachment."
        override val attachmentDocumentsNotIncluded: String = "Il piano attuale non include il caricamento di file. Passa a un piano superiore per caricare file."
        override val attachmentDocumentStorageNotIncluded: String = "Il piano attuale non include lo spazio per i documenti. Passa a un piano superiore per caricare file."
        override val attachmentFileSizePlanLimit: String = "Questo file è più grande di quanto consentito dal piano attuale. Passa a un piano superiore per caricare file più grandi."
        override val attachmentStoragePlanLimit: String = "Hai raggiunto il limite di spazio del piano attuale. Passa a un piano superiore per caricare altri file."
        override val attachmentDocumentCountPlanLimit: String = "Hai raggiunto il limite di documenti per questo immobile nel piano attuale. Passa a un piano superiore per caricare altri file."
        override val attachmentHardFileLimit: String = "Gli allegati sono limitati a 100 MB."
        override val openFiles: String = "Apri file"
        override val sendViaEmail: String = "Invia via e-mail"
        override val sendViaSms: String = "Invia via SMS"
        override val sendEmailHeader: String = "Invia e-mail"
        override val sendSmsHeader: String = "Invia SMS"
        override val noContactsFound: String = "Nessun contatti found."
        override val searchContacts: String = "Cerca contatti"
        override val linked: String = "Collegato"
        override val recent: String = "Recenti"
        override val taskColumnToDo: String = "To Do"
        override val taskColumnInProgress: String = "In Progress"
        override val taskColumnDone: String = "Fatto"
        override val taskColumnToDoSubtitle: String = "New attività and next actions waiting to be started."
        override val taskColumnInProgressSubtitle: String = "Work currently owned da you or the team."
        override val taskColumnDoneSubtitle: String = "Completate attività kept visible for team confidence."
        override val taskEmptyToDo: String = "Nessun attività to do."
        override val taskEmptyInProgress: String = "Nothing in progress."
        override val taskEmptyDone: String = "Nessun completed attività ancora."
        override val taskKanbanEmptyToDo: String = "Nothing waiting. New follow-up and report work will appear here."
        override val taskKanbanEmptyInProgress: String = "Nessun attivo work in progress."
        override val taskKanbanEmptyDone: String = "Completate attività will land here."
        override val taskEmptyBodyPrefix: String = "Crea a attività or move another attività into"
        override val taskEmptyBodySuffix: String = "."
        override val taskActionStart: String = "Inizio"
        override val taskActionOverdue: String = "Scadute"
        override val taskActionCancel: String = "Annulla"
        override val taskPriorityLow: String = "Low"
        override val taskPriorityMedium: String = "Iodium"
        override val taskPriorityHigh: String = "High"
        override val taskPriorityUrgent: String = "Urgent"
        override val taskStatusOpen: String = "Open"
        override val taskStatusInProgress: String = "In progress"
        override val taskStatusDone: String = "Fatto"
        override val taskStatusOverdue: String = "Scadute"
        override val taskStatusCancelled: String = "Annullato"
        override val aiSuggestedTasks: String = "Attività suggerite dall’AI"
        override val noAiSuggestedTasks: String = "Nessun AI suggestions ancora. HAVN will suggest attività dopo open house and lead activity."
        override val taskFilterToday: String = "Oggi"
        override val taskFilterUpcoming: String = "In arrivo"
        override val taskFilterOverdue: String = "Scadute"
        override val taskFilterCompleted: String = "Completate"
        override val taskFilterAssignedToMe: String = "Assigned to Io"
        override val taskFilterAiSuggested: String = "Suggerite AI"
        override val taskFilterEmptyToday: String = "You're clear for oggi."
        override val taskFilterEmptyUpcoming: String = "Nessun upcoming attività."
        override val taskFilterEmptyOverdue: String = "Nessun overdue attività."
        override val taskFilterEmptyCompleted: String = "Nessun completed attività ancora."
        override val taskFilterEmptyAssignedToMe: String = "Nessun attività assigned to you."
        override val taskFilterEmptyAiSuggested: String = "Nessun accepted AI suggested attività ancora."
        override val taskSuggestionHotLeadTitlePrefix: String = "Fai follow-up con"
        override val taskSuggestionHotLeadTitleSuffix: String = "within 2 hours."
        override val taskSuggestionHotLeadDescriptionPrefix: String = "Hot lead from"
        override val taskSuggestionHotLeadDescriptionSuffix: String = "Keep momentum while intent is fresh."
        override val taskSuggestionHotLeadReason: String = "New hot lead captured."
        override val taskSuggestionSellerReportTitlePrefix: String = "Generate report venditore for"
        override val taskSuggestionSellerReportTitleSuffix: String = "."
        override val taskSuggestionSellerReportDescription: String = "Riassumi volume visitatori, lead caldi, attività follow-up e sentiment acquirenti."
        override val taskSuggestionSellerReportReason: String = "Open house ended."
        override val taskSuggestionReviewFollowUpTitlePrefix: String = "Revedi and invia"
        override val taskSuggestionReviewFollowUpTitleSuffix: String = "follow-up."
        override val taskSuggestionReviewFollowUpReason: String = "Follow-up draft still needs agent revedi."
        override val taskSuggestionKioskTitle: String = "Prepara il modo kiosk e verifica le foto dell’immobile."
        override val taskSuggestionKioskDescription: String = "Confirm sign-in flow, gallery, and open house details prima di buyers arrive."
        override val taskSuggestionKioskReason: String = "Open house is scheduled."
    }

    private val croatian: HavnStrings = object : HavnStrings {
        override val navToday: String = "Danas"
        override val navProperties: String = "Svojstva"
        override val navLeads: String = "Leadovi"
        override val navReports: String = "Izvještaji"
        override val navTasks: String = "Zadaci"
        override val navAnalytics: String = "Analytics"
        override val navAgency: String = "Agencija"
        override val navSettings: String = "Postavke"
        override val navAuth: String = "Pristup agentu"
        override val navOpenHouses: String = "Dani otvorenih vrata"
        override val navTours: String = "Dani otvorenih vrata"
        override val navFollowUps: String = "Kontakti"
        override val navFollow: String = "Kontakti"
        override val back: String = "Nazad"
        override val settingsEyebrow: String = "Korisnički račun"
        override val settingsTitle: String = "Postavke"
        override val settingsSubtitle: String = "Brokerage profil, pozvati politiku, pohranu kante, i timske uloge."
        override val agentProfileTitle: String = "Profil"
        override val agentPhoto: String = "Slika agenta"
        override val uploading: String = "Šaljem..."
        override val saving: String = "Snimam..."
        override val validAgentPhotoRequired: String = "Odaberite ispravnu sliku agenta."
        override val signOut: String = "Odjava"
        override val signOutQuestion: String = "Odjaviti se?"
        override val signOutConfirmation: String = "Jeste li sigurni da se želite odjaviti iz HAVN-a?"
        override val deleteAccount: String = "Izbriši račun"
        override val deleteAccountQuestion: String = "Izbrisati račun?"
        override val deleteAccountOpenPageBody: String = "Ovo će otvoriti stranicu s zahtjevom za brisanje računa."
        override val deleteAccountReviewTitle: String = "Koristi stvarni korisnički račun"
        override val deleteAccountReviewBody: String = "Ovaj račun za pregled aplikacije je zaštićen tako da recenzenti ne gube pristup tijekom ispitivanja. Molimo koristite pravi testni račun za provjeru brisanja računa."
        override val upgrade: String = "Nadogradi"
        override val premiumThemesTitle: String = "Premium teme"
        override val premiumThemesUpgradePrompt: String = "Nadogradnja na Pro za otključavanje premium teme."
        override val appearanceTitle: String = "Izgled"
        override val appearanceBody: String = "Odaberite svijetli ili tamni način rada za web aplikaciju."
        override val previewComponents: String = "Komponente pregleda"
        override val themeShowcaseTitle: String = "Prikaz teme"
        override val showcaseButtons: String = "Gumbi"
        override val showcasePrimaryAction: String = "Osnovna akcija"
        override val showcaseSecondaryAction: String = "Sekundarna akcija"
        override val showcaseGhostAction: String = "Akcija duha"
        override val showcaseTextField: String = "Tekstualno polje"
        override val showcaseFocusedBorder: String = "Fokusirana granica naglaska"
        override val showcaseSearchPreview: String = "Pregled pretraživanja"
        override val showcaseOpeningCheckedIn: String = "Otvorena kuća prijava danas"
        override val showcaseSentAt: String = "Poslano u 10:30"
        override val themeObsidianGoldName: String = "Obsidijsko zlato"
        override val themeObsidianGoldDescription: String = "Luksuzno crno, grafitno i toplo zlato."
        override val themeMidnightSapphireName: String = "Ponoćni safir"
        override val themeMidnightSapphireDescription: String = "Duboka mornarica, safir plavo, i srebrni naglasak."
        override val themeEmeraldEstateName: String = "Smaragdno imanje"
        override val themeEmeraldEstateDescription: String = "Tamni smaragd, ugljen i šampanjac zlato."
        override val themePlatinumStoneName: String = "Platinasti kamen"
        override val themePlatinumStoneDescription: String = "Siva, platinasta i mekana bijela."
        override val themeBordeauxNoirName: String = "Bordeaux Noir"
        override val themeBordeauxNoirDescription: String = "Tamno vino, grafit i bakarni naglasak."
        override val commonChange: String = "Promijeni"
        override val agentPlanTitle: String = "Plan agenta"
        override val agentPlanBody: String = "Nadogradite svoje iskustvo, odaberite plan koji odgovara kako radite najbolje."
        override val currentPlan: String = "Trenutni plan"
        override val transferPlan: String = "Plan prijenosa"
        override val transferPlanTitle: String = "Plan prijenosa"
        override val transferPlanBody: String = "Premjesti ovu pretplatu na drugi HAVN korisnički račun. Obje email adrese moraju potvrditi s kodovima provjere."
        override val transferTargetEmail: String = "Nova e-pošta na računu"
        override val transferSendCodes: String = "Pošalji oznake provjere"
        override val transferCodesSentTitle: String = "Poslani kodovi provjere"
        override val transferCodesSentBody: String = "Poslali smo jedan kod na vaš e-mail i jedan kod na novi račun e-mail."
        override val transferYourCode: String = "Vaš e- poštanski kod"
        override val transferTargetCode: String = "Kodeks novog korisničkog računa"
        override val transferConfirm: String = "Plan prijenosa"
        override val transferSuccessTitle: String = "Prijenos plana"
        override val transferSuccessBody: String = "Pretplata je sada povezana s novim HAVN računom."
        override val restorePurchase: String = "Vrati kupnju"
        override val agencySettingsProBody: String = "Solo agencija je aktivna zadano. Pro omogućuje vam da kreirate ili odaberete zajedničku agenciju."
        override val agencySettingsLockedBody: String = "Agencija Solo agencija je aktivna. Promjene agencije otključati s Pro."
        override val soloAgency: String = "Solo agencija"
        override val defaultPrivateAgencyWorkspace: String = "Zadana privatna agencija"
        override val noAgenciesAvailableYet: String = "Još uvijek nisu dostupni pozivnici ili vlasničke agencije."
        override val oneOwnedAgencyHint: String = "Tvoja agencija je na popisu, jedan agent može posjedovati jednu agenciju."
        override val createAgency: String = "Stvori agenciju"
        override val createYourAgency: String = "Stvorite svoju agenciju"
        override val createAgencyBody: String = "Graditi svoj tim, upravljati nekretninama zajedno, i rasti svoj posao."
        override val agencyName: String = "Naziv agencije"
        override val agencyEmail: String = "E- pošta agencije"
        override val logoOptional: String = "Logo (opcija)"
        override val upgradeExperienceTitle: String = "Nadogradite svoje iskustvo"
        override val upgradeExperienceSubtitle: String = "Pokrenite svoj prvi Open House besplatno. Nadograditi kada vam je potrebno više lista, dani otvorenih vrata, i Pro radne protoke."
        override val soloAgentPlan: String = "Solo agent"
        override val proAgentPlan: String = "Pro agent"
        override val teamAgentPlan: String = "Tim"
        override val soloBenefitActiveProperties: String = "Do 100 aktivnih svojstava"
        override val soloBenefitAiFollowUps: String = "AI praćenja (osnovno)"
        override val soloBenefitSellerReports: String = "Nema izvještaja o prodaji"
        override val soloBenefitPersonalOnly: String = "Samo osobni"
        override val proBenefitUnlimitedProperties: String = "Do 10 000 osobina"
        override val proBenefitUnlimitedAi: String = "10.000 AI tekstualnih zahtjeva / mjesec"
        override val proBenefitAdvancedReports: String = "Napredni izvještaji o prodaji"
        override val proBenefitAgencyCreation: String = "Stvaranje i upravljanje agencijama"
        override val proBenefitInviteAgents: String = "Pozovite agente i suradnju"
        override val proBenefitSharedLeads: String = "Zajednički leadovi i timski radni tokovi"
        override val proBenefitAgencyBranding: String = "Označavanje agencija"
        override val proBenefitAdvancedAnalytics: String = "Napredna analiza"
        override val teamBenefitLargeLimits: String = "Ograničenja razmjera tima"
        override val teamBenefitPrioritySupport: String = "Podrška za prioritetnu e- poštu"
        override val teamBenefitDailyBackups: String = "Dnevne sigurnosne kopije za 7 dana"
        override val teamBenefitLargeStorage: String = "Pohrana 10GB dokumenata"
        override val startFreeTrial7Day: String = "Pretplati se odmah"
        override val restorePurchases: String = "Vrati kupnju"
        override val comparePlans: String = "Usporedi planove"
        override val startFreeTrial: String = "Odaberite plan"
        override val noCommitmentCancelAnytime: String = "Pokrenite svoj prvi Open House besplatno. Nadogradnja kada vam je potrebno više."
        override val monthly: String = "Mjesečno"
        override val yearly: String = "Godišnji"
        override val yearlySave20: String = "Godišnji"
        override val yearlySavings20: String = "Godišnje naplate."
        override val perYear: String = "/godina"
        override val loadingPlans: String = "Učitavam planove..."
        override val selectedPlanUnavailable: String = "Pretplate su privremeno nedostupne. Molimo pokušajte ponovo kasnije ili kontaktirajte podršku."
        override val signInRequiredForPurchase: String = "Upišite se prije nego što počnete kupnju."
        override val subscriptionDisclosureIos: String = "Automatski obnovljiv pretplata. Plaćanje će se naplatiti na vaš Apple račun po potvrdi kupnje. Vaša pretplata obnavlja automatski osim ako nije otkazana najmanje 24 sata prije kraja trenutnog razdoblja. Obnova će se naplatiti unutar 24 sata prije kraja trenutnog razdoblja. Možete upravljati ili otkazati pretplatu u postavki App Store račun."
        override val subscriptionDisclosureAndroid: String = "Automatsko obnavljanje pretplate preko Google Playa. Naplatit će vam se svako razdoblje računanja ukoliko ne otkažete. Možete upravljati ili otkazati pretplatu bilo kada u Google Play pretplatama. Pristup se nastavlja do kraja plaćenog razdoblja."
        override val subscriptionDisclosureWeb: String = "Automatsko obnavljanje pretplate. Naplatit će vam se svako razdoblje naplate pomoću odabrane metode plaćanja osim ako ne otkažete. Možete upravljati ili otkazati bilo kada iz postavki naplate. Pristup se nastavlja do kraja plaćenog razdoblja. Porezi se mogu primijeniti."
        override val subscriptionAgreementPrefix: String = "Pretplativši se, slažete se"
        override val subscriptionTermsOfUse: String = "HAVN Uvjeti korištenja"
        override val subscriptionAgreementAnd: String = "i"
        override val subscriptionPrivacyPolicy: String = "Pravila privatnosti."
        override val purchaseSuccessTitle: String = "Hvala na kupovini."
        override val purchaseSuccessBody: String = "Vaš HAVN pretplata je aktivna i vaš plan je spreman."
        override val restoreSuccessTitle: String = "Vrati kupnju"
        override val restoreSuccessBody: String = "Vaša pretplata na HAVN uspješno je obnovljena."
        override val purchaseCouldNotComplete: String = "Kupnja nije mogla biti završena. Molimo pokušajte ponovo, ili provjerite Vaš App Store ili Google Play račun."
        override val purchaseVerificationPending: String = "Your payment has not been confirmed yet. If you completed checkout, use Restore purchase to check again. You do not need to pay again."
        override val completeWebCheckout: String = "Complete payment in the checkout tab, then return here. Your access will update automatically once payment is confirmed."
        override val restoreCouldNotComplete: String = "Nije pronađena aktivna pretplata na HAVN za ovaj račun u pohrani."
        override val noActiveSubscriptionFound: String = "Nije pronađena aktivna pretplata na HAVN za ovaj račun u pohrani."
        override val compareActiveProperties: String = "Odrednice ispisa"
        override val compareAiFollowUps: String = "AI praćenja"
        override val compareSellerReports: String = "Izvješća prodavača"
        override val compareAdvancedAnalytics: String = "Napredna analiza"
        override val compareAgencyCreation: String = "Stvaranje agencija"
        override val compareJoinAgencies: String = "Pridružiti se agencijama"
        override val compareInviteAgents: String = "Pozivni agenti"
        override val compareSharedLeads: String = "Dijeljeni leadovi"
        override val compareAgencyBranding: String = "Označavanje agencija"
        override val comparePrioritySupport: String = "Prioritetna podrška"
        override val compareFeature: String = "Osobina"
        override val compareFreePlan: String = "Slobodan"
        override val compareValueYes: String = "Jesam."
        override val compareValueNo: String = "Ne"
        override val comparePricePerMonthUser: String = "Cijena / Mjesec / Korisnik"
        override val comparePricePerYearUser: String = "Cijena / Godina / Korisnik"
        override val compareMaxPropertiesOwner: String = "Najveća svojstva / vlasnik"
        override val compareMaxContactsOwner: String = "Maks. kontakti / vlasnik"
        override val compareMaxOpenHousesOwner: String = "Max dani otvorenih vrata / vlasnik"
        override val compareMaxLeadsOwner: String = "Najveća dopuštena / vlasnica"
        override val compareMaxPhotosProperty: String = "Maks fotografije po imovini"
        override val compareMaxDocumentsProperty: String = "Najveći broj dokumenata po imovini"
        override val compareDocumentsStorage: String = "Pohrana dokumenata"
        override val compareAgencyAgenda: String = "Agencijski program"
        override val compareAiTextRequestsMonth: String = "Zahtjevi za stvaranje teksta AI- a / mjesec"
        override val compareAnalytics: String = "Analytics"
        override val compareTasks: String = "Zadaci"
        override val compareDocumentsStorageOwner: String = "Pohrana dokumenata / vlasnik"
        override val compareMaxFileSizeOwner: String = "Najveća veličina datoteke / vlasnik"
        override val compareEmailSupport: String = "Podrška za e- poštu"
        override val compareDailyBackups7Days: String = "Dnevne sigurnosne kopije pohranjene 7 dana"
        override val compareKioskMode: String = "KIOSK način rada"
        override val unlimited: String = "Neograničeno"
        override val basic: String = "Osnovno"
        override val advanced: String = "Napredno"
        override val perMonth: String = "/mjesec"
        override val members: String = "članovi"
        override val upgradeToProForAgencyTools: String = "Nadogradnja u Pro za korištenje alata agencije"
        override val languageTitle: String = "Jezik"
        override val languageBody: String = "Odaberite jezik aplikacije za ovaj uređaj."
        override val english: String = "Engleski"
        override val slovak: String = "Slovački"
        override val unitsTitle: String = "Jedinice i valuta"
        override val unitsBody: String = "Odaberite kako su cijene i dimenzije nekretnina prikazane u cijeloj aplikaciji."
        override val measurementSystemTitle: String = "Mjerenje"
        override val metric: String = "Broj"
        override val imperial: String = "Imperial"
        override val currencyTitle: String = "Valuta"
        override val notificationsTitle: String = "Obavjesti"
        override val notificationsBody: String = "Kontrola potisnuti upozorenja, tiho vrijeme, i vrste ažuriranja HAVN može poslati."
        override val notificationSettings: String = "Postavke obavijesti"
        override val notificationsSubtitle: String = "Samo važne nadogradnje, filtrirane vašim postavkama."
        override val quietHoursTitle: String = "Mirno vrijeme"
        override val quietHoursBody: String = "HAVN preskače ne-kritične gura tijekom tihih sati. Naplata i račun problemi i dalje ostati koncizan."
        override val enableQuietHours: String = "Omogući tihe sate"
        override val quietHoursStart: String = "Započni"
        override val quietHoursEnd: String = "Kraj"
        override val timezoneLabel: String = "Vremenska zona"
        override val notificationTypesTitle: String = "Vrsta obavijesti"
        override val notificationNewLeadCapturedTitle: String = "Novi olovo uhvaćen"
        override val notificationNewLeadCapturedBody: String = "Kada otvorena kuća ili QR protok hvata olovo."
        override val notificationHotLeadTitle: String = "Olovo označeno kao vruće"
        override val notificationHotLeadBody: String = "Samo kad olovo postane visoka namjera."
        override val notificationOpeningStartsSoonTitle: String = "Otvorena kuća počinje uskoro."
        override val notificationOpeningStartsSoonBody: String = "Jedan podsjetnik 30 minuta prije početka."
        override val notificationOpeningSummaryReadyTitle: String = "Sažetak dani otvorenih vrata spreman"
        override val notificationOpeningSummaryReadyBody: String = "Kada je sažetak nakon događaja spreman."
        override val notificationSellerReportGeneratedTitle: String = "Izvještaj prodavača generiran"
        override val notificationSellerReportGeneratedBody: String = "Kada je izrađen izvještaj o prodaji."
        override val notificationAiFollowUpReadyTitle: String = "AI praćenje spremno"
        override val notificationAiFollowUpReadyBody: String = "Kada je nacrt nastavka spreman za reviziju."
        override val notificationAgentInvitedTitle: String = "Agent pozvan u agenciju"
        override val notificationAgentInvitedBody: String = "Pozivnici Agencije i promjene članstva."
        override val notificationLeadAssignedTitle: String = "Olovo dodijeljeno tebi"
        override val notificationLeadAssignedBody: String = "Kad ti suigrač dodeli lead."
        override val notificationLeadTransferredTitle: String = "Olovo prebačeno na vas"
        override val notificationLeadTransferredBody: String = "Kada je vlasništvo olovo kreće na vas."
        override val notificationSubscriptionIssueTitle: String = "Pretplata"
        override val notificationSubscriptionIssueBody: String = "Neuspjesi u obnavljanju i problemi s naplatom."
        override val kioskSecurityTitle: String = "KIOSK sigurnost"
        override val kioskSecurityBody: String = "Koristite ovaj PIN da napustite kiosk način rada i vratite se na aplikaciju agenta."
        override val kioskPinLabel: String = "KIOSK PIN"
        override val mcpAccessTitle: String = "MCP pristup"
        override val mcpAccessBody: String = "Most HAVN zove Claude, OpenAI, i drugi MCP klijenti na mcp.havnre.app. dostupan na svakom planu."
        override val mcpAuthorizationBearer: String = "Autorizacija: nositelj"
        override val mcpNoApiKeyCreated: String = "Nema API tipke"
        override val mcpNotUsedYet: String = "Još se ne koristi"
        override val mcpLastUsedPrefix: String = "Zadnje korišteno"
        override val mcpRevealApiKeyTitle: String = "Otkrij tipku API"
        override val mcpRevealApiKeyBody: String = "Puna tipka je prikazana tek nakon stvaranja ili rotiranja."
        override val mcpCreateKey: String = "Napravi ključ"
        override val mcpRotateKey: String = "Tipka rotiraj"
        override val mcpRevokeKey: String = "Otkaži tipku"
        override val mcpEndpointHint: String = "Koristi krajnju vrijednost https://mcp.havnre.app/mcp s ovim ključem kao simbolom nositelja."
        override val mcpUpgradeHint: String = "MCP pristup je dostupan na svakom HAVN planu."
        override val mcpUpgradePrompt: String = "MCP pristup je dostupan na svakom HAVN planu."
        override val mcpCopied: String = "Kopirano"
        override val mcpCopy: String = "Kopiraj"
        override val mcpLoading: String = "Učitavam"
        override val kioskFeaturedProperty: String = "Označena osobina"
        override val kioskPrivateShowing: String = "Privatni prikaz"
        override val kioskLuxuryListing: String = "Luksuzna lista"
        override val kioskFastCheckIn: String = "Brza prijava"
        override val kioskExitContentDescription: String = "Izlazni kiosk"
        override val kioskWelcome: String = "Dobrodošli"
        override val kioskGladHere: String = "Drago nam je da ste ovdje."
        override val kioskScanToCheckIn: String = "Skeniraj za provjeru"
        override val kioskReceivePropertyDetails: String = "i primati podatke o imovini"
        override val kioskOr: String = "Ili"
        override val kioskStartCheckInManually: String = "Pokreni ručnu provjeru"
        override val kioskSecureInfo: String = "Vaše informacije su sigurne i nikada neće biti dijele."
        override val kioskExitTitle: String = "Izlazni kiosk"
        override val kioskExitBody: String = "Unesite kiosk PIN za povratak u aplikaciju za agente."
        override val kioskIncorrectPin: String = "Neispravna PIN."
        override val kioskUnlock: String = "Otključaj"
        override val kioskTellUsTitle: String = "Pričaj nam o sebi."
        override val kioskTellUsBody: String = "Tvoja informacija ide samo domaćem agentu."
        override val kioskFullName: String = "Puno ime"
        override val kioskContinue: String = "Nastavi"
        override val kioskQuestionsTitle: String = "Nekoliko brzih pitanja."
        override val kioskQuestionsBody: String = "To pomaže agentu da prati pravi kontekst."
        override val kioskWorkingWithAgentQuestion: String = "Radiš li s agentom?"
        override val kioskYes: String = "Jesam."
        override val kioskNo: String = "Ne"
        override val kioskInterestQuestion: String = "Što te zanima?"
        override val kioskInterestBuying: String = "Kupnja"
        override val kioskInterestInvesting: String = "Ulaganje"
        override val kioskInterestBrowsing: String = "Samo pregledavam"
        override val kioskInterestRelocating: String = "Premještanje"
        override val kioskFinish: String = "Završi"
        override val kioskThankYou: String = "Hvala."
        override val kioskEnjoyVisitPrefix: String = "Uživajte u posjeti na"
        override val kioskResetAutomatically: String = "Ovaj kiosk će se automatski resetirati."
        override val environmentTitle: String = "Okoliš"
        override val environmentBody: String = "Detalji veze su podešeni za ovu izgradnju."
        override val secure: String = "Osigurano"
        override val brokerageProfileTitle: String = "Profil prekidača"
        override val brokerageProfileBody: String = "Označavanje tima, agent poziva, i obavijesti preferencije će živjeti ovdje."
        override val logout: String = "Odjava"
        override val languageChanged: String = "Jezik izmijenjen"
        override val commonAdd: String = "Dodaj"
        override val commonEdit: String = "Uredi"
        override val commonDelete: String = "Obriši"
        override val commonCancel: String = "Odustani"
        override val commonSave: String = "Spremi"
        override val commonCreate: String = "Napravi"
        override val commonDismiss: String = "Otpusti"
        override val commonAll: String = "Sve"
        override val commonDone: String = "Završeno"
        override val commonSend: String = "Pošalji"
        override val commonTime: String = "Vrijeme"
        override val commonHour: String = "Sat"
        override val commonMinute: String = "Minuta"
        override val commonAgency: String = "Agencija"
        override val commonSettings: String = "Postavke"
        override val commonOpening: String = "Otvorena kuća"
        override val commonPropertyName: String = "Svojstvo"
        override val commonToday: String = "Danas"
        override val agencyToolsAvailable: String = "Agencijski alati su dostupni."
        override val agencySetupSubtitle: String = "Svaki HAVN račun ima zadanu agenciju. Pro omogućuje vam da upravljate pozivnicama, zajedničkim leadovima i brendiranjem."
        override val agencyRecentActivity: String = "Nedavna aktivnost"
        override val agencyActivityNewLead: String = "Dodano novo olovo"
        override val agencyActivityInvitationAccepted: String = "Prihvaćena pozivnica"
        override val agencyActivityAgentJoined: String = "Agent se pridružio agenciji."
        override val agencyActivitySellerReport: String = "Izvještaj prodavača je napravljen"
        override val agencyWorkspaceTitle: String = "Agencija"
        override val agencyWorkspaceBody: String = "Izaberite u kojoj agenciji radite."
        override val agencySoloActiveTitle: String = "Agencija Solo je aktivna"
        override val agencyProRequiredTitle: String = "Zahtjev za pro plan"
        override val agencyCreateOrAcceptInviteBody: String = "Stvorite svoju agenciju ili prihvatite pozivnicu za suradnju s drugom agencijom."
        override val agencyProUnlockBody: String = "Agencija mijenja, poziva, dijeli leadove, i zajednički brending otključati s Pro."
        override val realEstate: String = "Nekretnine"
        override val proAgency: String = "Pro agencija"
        override val agencyBrandingTitle: String = "Označavanje agencija"
        override val agencyBrandingBody: String = "Postavite ime i logo agencije prikazano u aplikaciji, kiosku, i poglede na tim."
        override val uploadLogo: String = "Učitaj logotip"
        override val saveAgency: String = "Spremi agenciju"
        override val yourAgencyRole: String = "Vaša uloga agencije"
        override val agencyAgentsTitle: String = "Agencija"
        override val agencyAgentsBody: String = "Ljudi koji mogu raditi s ovom agencijom."
        override val inviteAgent: String = "Pozivni agent"
        override val loadingAgents: String = "Učitavam agente..."
        override val noAgencyAgentsYet: String = "Još nema agenata."
        override val changeRole: String = "Promijeni ulogu"
        override val updating: String = "Ažuriranje..."
        override val deleting: String = "Brisanje..."
        override val deleteInvite: String = "Poništi pozivnicu"
        override val chooseAgencyRoleFor: String = "Odaberite ulogu agencije za"
        override val removeAccess: String = "Ukloni pristup"
        override val inviteAgentBody: String = "Pošaljite pozivnicu agenciji putem e-pošte. Agent prihvaća nakon prijave s istom e-mailom."
        override val agentEmail: String = "E- pošta agenta"
        override val role: String = "Uloga"
        override val inviting: String = "Poziv..."
        override val invite: String = "Pozovi"
        override val agents: String = "Agenti"
        override val ok: String = "U redu."
        override val personalActivePropertyLimit: String = "Ograničenje aktivne imovine"
        override val personalAccountAgencyToolsLocked: String = "Osobni račun je aktivan. Alati agencije otključati s Pro."
        override val selected: String = "Odabrano"
        override val activeMembers: String = "aktivni članovi"
        override val agencySharedWorkspaceBody: String = "Zajednička svojstva, kontakti, dani otvorenih vrata, leadovi, praćenja, i izvješća koriste ovu agenciju."
        override val actLikeAgent: String = "Ponašaj se kao agent."
        override val actAsAdmin: String = "Ponašaj se kao administrator"
        override val actAsOwner: String = "Ponašaj se kao vlasnik"
        override val actLikeAgentBody: String = "Koristite agenciju kao normalan agent."
        override val actLikeAgentSelectedBody: String = "Prikazan je samo dodijeljeni ili vlasnički rad."
        override val agencyRoleOwner: String = "Vlasnik"
        override val agencyRoleAdmin: String = "Administrator"
        override val agencyRoleAgent: String = "Agent"
        override val agencyRoleAssistant: String = "Pomoćnik"
        override val agencyRoleViewer: String = "Preglednik"
        override val agencyRoleOwnerDescription: String = "Potpuna kontrola agencija, uključujući članove, brendiranje, zadaće, liste, leadove i izvještaje."
        override val agencyRoleAdminDescription: String = "PUNO UPRAVLJANJE AGENCIJAMA OSIM BRIŠANJA AGENCIJE."
        override val agencyRoleAgentDescription: String = "Radovi dodijeljene liste, dani otvorenih vrata, leadovi, praćenja, bilješke, i prodaje izvješća."
        override val agencyRoleAssistantDescription: String = "Podrška dodijeljenim listama putem uređivanja leadova, pripreme praćenja i izrade izvješća."
        override val agencyRoleViewerDescription: String = "Pristup samo za čitanje pločicama i izvještajima."
        override val agencyCapabilityInviteRemoveMembers: String = "Pozovi i ukloni članove"
        override val agencyCapabilityChangeRoles: String = "Promjeni uloge članova"
        override val agencyCapabilityManageAllProperties: String = "Kreirajte, uređujte i brišite sve osobine"
        override val agencyCapabilityAssignAgents: String = "Dodijeli agente"
        override val agencyCapabilitySeeAllLeads: String = "Pogledajte sve leadove"
        override val agencyCapabilityExportReports: String = "Izvoz izvješća"
        override val agencyCapabilityChangeBranding: String = "Promijenite markiranje i postavke agencije"
        override val agencyCapabilityDeleteAgency: String = "Obriši agenciju"
        override val agencyCapabilityViewAssignedProperties: String = "Pogledaj dodijeljena svojstva"
        override val agencyCapabilityHostAssignedOpenings: String = "Dodijeljene dani otvorenih vrata"
        override val agencyCapabilitySeeAssignedLeads: String = "Pogledajte leadove iz dodijeljenih nekretnina i otvorenih kuća"
        override val agencyCapabilityAddNotes: String = "Dodaj bilješke"
        override val agencyCapabilitySendFollowUps: String = "Pošalji praćenje"
        override val agencyCapabilityCreateSellerReports: String = "Kreirajte izvještaje prodavatelja za dodijeljene liste"
        override val agencyCapabilityEditAssignedLeads: String = "Uređivanje dodijeljenih leadova"
        override val agencyCapabilityPrepareFollowUps: String = "Pripremi praćenja"
        override val agencyCapabilityCreateDraftReports: String = "Osmisli nacrt izvještaja"
        override val agencyCapabilityCannotDeleteProperties: String = "Ne mogu obrisati osobine"
        override val agencyCapabilityCannotInviteAgents: String = "Ne mogu pozvati agente osim ako nije dopušteno"
        override val agencyCapabilityViewDashboards: String = "Pogledaj pločice"
        override val agencyCapabilityViewReports: String = "Pogledaj izvještaje"
        override val agencyCapabilityCannotEdit: String = "Ne mogu izmijeniti ništa"
        override val commonVisitors: String = "Leadovi"
        override val commonHot: String = "Vruć"
        override val commonWarm: String = "Topao"
        override val commonCold: String = "Hladan"
        override val commonActive: String = "Aktivno"
        override val commonPlanned: String = "Planirano"
        override val commonArchived: String = "Arhivirano"
        override val commonPast: String = "Prosljednja"
        override val commonFollowUps: String = "Praćenje"
        override val commonProperty: String = "Svojstvo"
        override val commonAddress: String = "Adresa"
        override val commonOpenHouse: String = "Otvorena kuća"
        override val commonInquiry: String = "Upit"
        override val commonInquiries: String = "Ispitivanja"
        override val generalInquiry: String = "Opći upit"
        override val generalInquiries: String = "Opći upiti"
        override val propertyInquiry: String = "Upit za nekretninu"
        override val propertyInquiries: String = "Upiti za nekretnine"
        override val addGeneralInquiry: String = "Dodaj opći upit"
        override val newGeneralInquiry: String = "Novi opći upit"
        override val noGeneralInquiries: String = "Još nema općih upita."
        override val noPropertyInquiries: String = "Još nema upita za nekretnine."
        override val buyerLookingFor: String = "Što ovaj kupac traži?"
        override val locationCity: String = "Lokacija / grad"
        override val radiusKm: String = "Radijus (km)"
        override val propertyType: String = "Vrsta nekretnine"
        override val budgetFrom: String = "Budžet od"
        override val budgetTo: String = "Budžet do"
        override val purchaseTimeline: String = "Rok kupnje"
        override val createGeneralInquiry: String = "Izradi opći upit"
        override val saveGeneralInquiry: String = "Spremi opći upit"
        override val inquiryType: String = "Vrsta upita"
        override val leadSource: String = "Izvor leada"
        override val notSpecified: String = "Nije navedeno"
        override val inquiryStatus: String = "Upitno stanje"
        override val inquiryFollowUp: String = "Ispitivanje praćenja"
        override val addInquiry: String = "Dodaj upit"
        override val searchInquiries: String = "Traži upit"
        override val noInquiries: String = "Nema upite"
        override val noInquiriesBody: String = "Koristite gumb plus za dodavanje kamata kupca iz postojećeg kontakta."
        override val inquiryUnavailableTitle: String = "Upit nedostupan"
        override val inquiryUnavailableBody: String = "Ovaj upit je možda uklonjen ili još uvijek učitava."
        override val backToInquiries: String = "Povratak na ispitivanje"
        override val deleteInquiry: String = "Obriši upit"
        override val deleteInquiryQuestionPrefix: String = "Obriši"
        override val deleteInquiryQuestionSuffix: String = "S ovog imanja?"
        override val deleteInquiryTargetFallback: String = "Ovo je upit"
        override val propertyInquiriesBody: String = "Track kupci koji su pitali za ovu imovinu. Isleade se također pojavljuju u Olovo."
        override val propertyInquiriesEmpty: String = "Dodajte upit odabirom jednog od vaših kontakata."
        override val contactInquiriesBody: String = "Svojstva za koje je zatražio ovaj kontakt."
        override val contactInquiriesEmpty: String = "Još nema isleade o imovini."
        override val viewInquiries: String = "Pogledaj upit"
        override val createContactFirstForInquiry: String = "Prvo napravite kontakt, a zatim dodajte upit sa ovog imanja."
        override val commonCheckedIn: String = "Prijavljeno"
        override val commonNotScheduled: String = "nije zakazano"
        override val todayTitle: String = "Danas"
        override val todaySubtitle: String = "Vaš dnevni dom za dani otvorenih vrata, vodi, praćenja, i prodavački zamah."
        override val todayOpenHousesMetric: String = "dani otvorenih vrata"
        override val capturedMetric: String = "Zarobljeno"
        override val priorityMetric: String = "prioritet"
        override val noActivePropertiesTitle: String = "Nema aktivnih osobina"
        override val noActivePropertiesBody: String = "Dodajte ili aktivirajte imovinu da se pojavi na Danas."
        override val checkIns: String = "Prijave"
        override val allOpenHouses: String = "sve dani otvorenih vrata"
        override val pendingDrafts: String = "Nedovršeni nacrti"
        override val priorityLead: String = "Prednji prioritet"
        override val nextOpenHouseAt: String = "Sljedeća otvorena kuća u"
        override val noOpenHouseScheduled: String = "Nema zakazanih otvorenih kuća"
        override val personalAccount: String = "Osobni korisnički račun"
        override val accountReady: String = "Vaš račun je spreman"
        override val realEstateApp: String = "Aplikacija za nekretnine"
        override val needHelp: String = "Trebate pomoć?"
        override val contactSupport: String = "Podrška za kontakt"
        override val upgradePlan: String = "Nadogradi plan"
        override val planSuffix: String = "Plan"
        override val todayActionsTitle: String = "Današnji prioriteti"
        override val agencyInvitation: String = "Pozivnica Agencije"
        override val joinAgency: String = "Pridruži se"
        override val youWereInvitedAs: String = "Ti si pozvan kao"
        override val invitedBy: String = "by"
        override val decline: String = "Odbij"
        override val yourDefaultAgency: String = "Vaša zadana agencija"
        override val chooseAgencyBody: String = "Odaberite s kojom agencijom želite raditi. Agencijski alati uključuju pozivnice, zajedničke leadove i brendiranje."
        override val agencyMembersSuffix: String = "članovi"
        override val quickActionTasksBody: String = "Uređaj"
        override val quickActionReportsBody: String = "Prodavač"
        override val quickActionAnalyticsBody: String = "Tendencije"
        override val quickActionAddPropertyTitle: String = "Dodaj"
        override val quickActionAddPropertyBody: String = "Lista"
        override val quickActionAddContactTitle: String = "Kontakt"
        override val quickActionAddContactBody: String = "Nova lista zadatakaNew"
        override val quickActionFilesTitle: String = "Datoteke"
        override val quickActionFilesBody: String = "Docs"
        override val firstRunStepsTitle: String = "Započni s četiri jednostavna koraka"
        override val firstRunAddProperty: String = "Svojstva"
        override val firstRunScheduleOpening: String = "Rasporedi dan otvorenih vrata"
        override val firstRunStartGuestCheckIn: String = "Pokreni prijavu za goste"
        override val firstRunSendFollowUp: String = "Pošalji praćenje"
        override val greetingNamePrefix: String = "Bok."
        override val greetingAgent: String = "Zdravo, agente."
        override val createListing: String = "Napravi popis"
        override val newOwnerBuyer: String = "Novi vlasnik/kupac"
        override val documents: String = "Dokumenti"
        override val whatOpeningNext: String = "Što je sljedeće otvorena kuća?"
        override val whoCheckedIn: String = "Tko se prijavio?"
        override val whoNeedsFollowUp: String = "Kome treba praćenje?"
        override val whatShouldIDoNow: String = "Što sad da radim?"
        override val noCheckInsYet: String = "Nijedan kontakt se još nije prijavio."
        override val noPendingFollowUps: String = "Nema na čekanju praćenja upravo sada."
        override val openKioskForNextOpening: String = "Otvorite kiosk za sljedeću dan otvorenih vrata."
        override val reviewNewLeads: String = "Pregledajte nove leadove i pošaljite praćenja."
        override val createOpeningToStart: String = "Kreirajte dan otvorenih vrata od nekretnine za početak prikupljanja leadova."
        override val addFirstPropertyToStart: String = "Dodajte svoju prvu imovinu za početak."
        override val nextOpening: String = "Sljedeća otvorena kuća"
        override val quickSignIn: String = "Brza prijava"
        override val scanQrCode: String = "Skeniraj QR kod"
        override val newLead: String = "Novi olovo"
        override val myProperties: String = "Moja svojstva"
        override val manageListings: String = "Upravljanje listama"
        override val todaysOverview: String = "Današnji pregled"
        override val seeAll: String = "Vidi sve"
        override val propertiesEyebrow: String = "Portfólio"
        override val propertiesSubtitle: String = "Upravljajte aktivnim, planiranim i arhiviranim listama s listama medija, aktivnosti kupca i performansi."
        override val propertiesLiveMetric: String = "živi"
        override val propertiesPipelineMetric: String = "cjevovod"
        override val propertiesAllTimeMetric: String = "cijelo vrijeme"
        override val addProperty: String = "Svojstva"
        override val editProperty: String = "Svojstva"
        override val propertyFallback: String = "Svojstvo"
        override val propertyUnavailableTitle: String = "Svojstva nedostupna"
        override val propertyUnavailableBody: String = "Osvježi portfolio za ponovno učitavanje ovog popisa."
        override val backToProperties: String = "Povratak na osobine"
        override val deletePropertyTitle: String = "Obriši osobinu?"
        override val deletePropertyBody: String = "Ovo će trajno obrisati osobinu i njene srodne lokalne zapise. To se ne može poništiti."
        override val loadingProperties: String = "Svojstva za učitavanje"
        override val loadMore: String = "Učitaj više"
        override val loadingPropertyDetails: String = "Učitavam podatke o osobini"
        override val noPropertiesTitle: String = "Još nema osobina"
        override val noPropertiesBody: String = "Dodajte svoju prvu nekretninu, a zatim stvorite dan otvorenih vrata za početak prikupljanja leadova i prodavač-spremne povratne informacije."
        override val openHouseButton: String = "Napravi dan otvorenih vrata"
        override val photosTitle: String = "Fotografije"
        override val photosBody: String = "Prva fotografija se koristi kao glavnu sliku nekretnine kroz Portfolio."
        override val uploadPhoto: String = "Slika za slanje"
        override val noPhotosYet: String = "Nema još uploadiranih fotografija."
        override val propertyPhotoCountPlanLimit: String = "Foto limit dostignut za ovu nekretnine na vašem trenutnom planu. Nadograditi za upload više fotografija."
        override val propertyPhotoStoragePlanLimit: String = "Ograničenje pohrane dostignuto za vaš trenutni plan. Nadograditi za upload više fotografija ili datoteka."
        override val mainPhoto: String = "Glavni"
        override val propertyTitleLabel: String = "Ime osobine"
        override val propertyAddressLine1Label: String = "Adresa ulice"
        override val propertyAddressLine2Label: String = "Adresa linija 2"
        override val propertyCityLabel: String = "Grad"
        override val propertyRegionLabel: String = "Područje"
        override val propertyPostalCodeLabel: String = "Poštanski broj"
        override val propertyCountryLabel: String = "Država"
        override val propertyAskingPriceLabel: String = "Upitna cijena"
        override val propertyBedsLabel: String = "Kreveti"
        override val propertyBathsLabel: String = "Kupke"
        override val propertyInteriorLabel: String = "Unutrašnjost"
        override val propertyDescriptionLabel: String = "Opis"
        override val createPropertyButton: String = "+ Svojstvo"
        override val locateProperty: String = "Lociraj svojstvo"
        override val findLocation: String = "_Lokacija:"
        override val find: String = "Nađi"
        override val navigate: String = "Navigate"
        override val propertyLocationMarkerTitle: String = "Lokacija imovine"
        override val mapKitJsMissingToken: String = "Dodaj HAVN_MAPKIT_JS_TOKEN na lokalnu."
        override val mapKitJsLoading: String = "Učitavam MapKit JS..."
        override val generateSellerReport: String = "Generiraj izvještaj prodavača"
        override val deleteProperty: String = "Obriši osobinu"
        override val conversionMetric: String = "Pretvaranje"
        override val propertyPhotoContentDescription: String = "Slika imovine"
        override val deletePhoto: String = "Obriši sliku"
        override val movePhotoLeft: String = "Pomakni sliku lijevo"
        override val movePhotoRight: String = "Pomakni sliku desno"
        override val propertyTitleRequired: String = "Potrebno je ime imovine."
        override val propertyStreetRequired: String = "Ulična adresa je potrebna."
        override val propertyCityRequired: String = "Grad je potreban."
        override val propertyRegionRequired: String = "Regija je potrebna."
        override val propertyPostalRequired: String = "Potrebna je poštanska šifra."
        override val propertyAskingPriceInvalid: String = "Unesite valjanu traženu cijenu."
        override val propertyOwnerContactTitle: String = "Kontakt vlasnika nekretnine"
        override val propertyOwnerSelectContact: String = "Odaberite postojeći kontakt kao vlasnik nekretnine."
        override val propertyOwnerSelected: String = "Odabrani vlasnik"
        override val propertyOwnerNoContacts: String = "Nema još kontakata. Dodajte vlasnika u kontakte, a zatim ih odaberite ovdje."
        override val propertyOwnerChooseContact: String = "Odaberite kontakt"
        override val propertyOwnerChangeContact: String = "Promijeni kontakt"
        override val propertyOwnerRemoveContact: String = "Ukloni"
        override val propertyOwnerPickerTitle: String = "Odaberite vlasnika osobine"
        override val propertyOwnerSearchContact: String = "Traži kontakte"
        override val propertyOwnerSearchHint: String = "Počni upisivati ime, e-mail ili broj telefona."
        override val propertyOwnerNoMatches: String = "Nema podudaranja kontakata."
        override val propertyOpeningsTitle: String = "Dani otvorenih vrata"
        override val propertyNoOpenings: String = "Nema otvorenih kuća za ovo imanje."
        override val teamAccessTitle: String = "Pristup timu"
        override val onlyListingOwner: String = "Samo vlasnik liste"
        override val assignTeam: String = "Dodijeli timu"
        override val assignPropertyTitle: String = "Dodijeli osobinu"
        override val assignPropertyBody: String = "Odaberite tko može raditi na ovoj osobini. Odaberite cijeli tim ili specifične agente."
        override val wholeTeam: String = "Cijeli tim"
        override val leadsEyebrow: String = "Leadovi"
        override val leadFallback: String = "Lead"
        override val leadsSubtitle: String = "Pretražujte, filtrirajte i kvalificirajte leadove prikupljene na svim danima otvorenih vrata."
        override val leadDetailSubtitle: String = "Izvor, kvalifikacija, bilješke i povijest praćenja ovog leada."
        override val totalMetric: String = "Ukupno"
        override val loggedMetric: String = "logiran"
        override val searchLeads: String = "Pretraži leadove"
        override val searchLeadsPlaceholder: String = "Ime, telefon ili e-pošta"
        override val allProperties: String = "Svojstva"
        override val loadingLeads: String = "Učitavanje leadova"
        override val loadingLeadDetails: String = "Učitavanje detalja leada"
        override val noLeadsFoundTitle: String = "Leadovi će se pojaviti ovdje kada se kontakti prijave na dan otvorenih vrata."
        override val noLeadsEmptyBody: String = "Koristite kiosk prijavu ili dodajte kontakte ručno iz dani otvorenih vrata."
        override val noLeadsFilteredBody: String = "Pokušajte drugo vlasništvo, status, ili termin za preleadu."
        override val backToLeads: String = "Natrag na leadove"
        override val leadUnavailableTitle: String = "Lead nije dostupan"
        override val leadUnavailableBody: String = "Ovaj lead više nije dostupan na trenutačnom popisu."
        override val leadTemperature: String = "Status leada"
        override val leadLabelSuffix: String = "Lead"
        override val greetingHi: String = "Bok."
        override val leadActionCall: String = "Poziv"
        override val leadActionSms: String = "SMS"
        override val leadActionEmail: String = "E- pošta"
        override val leadFollowUp: String = "Praćenje"
        override val leadNoFollowUpScheduled: String = "Nema zakazanog praćenja"
        override val leadIntentScore: String = "Namjeran rezultat"
        override val leadInterestedIn: String = "Zainteresiran za"
        override val leadGenericGreetingName: String = "Tamo."
        override val followUpMessageTypeThankYou: String = "Hvala."
        override val followUpMessageTypePropertyInfo: String = "Podaci o osobini"
        override val followUpMessageTypeFollowUp: String = "Prati"
        override val followUpMessageTypeCheckIn: String = "Provjeri"
        override val followUpMessageTypePriceUpdate: String = "Ažuriranje cijene"
        override val followUpMessageTypePropertyBrochure: String = "Datoteke"
        override val followUpPreview: String = "Pregled"
        override val followUpSubject: String = "Tema"
        override val followUpMessage: String = "Poruka"
        override val followUpSendViaEmail: String = "Pošalji e- poštom"
        override val followUpSendViaSms: String = "Pošalji putem SMS- a"
        override val followUpAiAssistantTitle: String = "Pomoćnik AI"
        override val followUpAiAssistantBody: String = "Generišite personaliziranu poruku u sekundi."
        override val followUpGenerateWithAi: String = "Generiraj s AI"
        override val followUpUpgradeForAi: String = "Nadogradnja za AI"
        override val followUpDefaultSubject: String = "Praćenje"
        override val privateAgentNotes: String = "Bilješke privatnog agenta"
        override val notes: String = "Bilješke"
        override val notesPlaceholder: String = "Motivacija, preferencije, prigovor, sljedeći potez"
        override val saveNotes: String = "Spremi bilješke"
        override val followUpHistory: String = "Povijest praćenja"
        override val noFollowUpsLogged: String = "Još nema prijave za praćenje."
        override val openHousesEyebrow: String = "Prikazi"
        override val scheduleOpenHouse: String = "Napravi dan otvorenih vrata"
        override val openingDetails: String = "Otvoreni detalji"
        override val editOpening: String = "Uređivanje dani otvorenih vrata"
        override val deleteOpening: String = "Obriši datoteku"
        override val deleteOpeningBody: String = "Jeste li sigurni da želite obrisati ovu dan otvorenih vrata? Ovo se ne može poništiti."
        override val removeLeadTitle: String = "Ukloniti olovo?"
        override val removeLeadBody: String = "Ukloniti %s iz ove dani otvorenih vrata?"
        override val removeLeadFallback: String = "ovaj lead"
        override val openingName: String = "Otvori datoteku"
        override val startsAt: String = "Počinje od"
        override val endsAt: String = "Završava na"
        override val chooseStartDateTime: String = "Odaberite datum i vrijeme početka"
        override val chooseEndDateTime: String = "Odaberite krajnji datum i vrijeme"
        override val accessNotes: String = "Pristupne bilješke"
        override val privateNotes: String = "Privatne bilješke"
        override val addPrivateNote: String = "Dodaj privatnu bilješku"
        override val liveDashboard: String = "Živa ploča"
        override val visitorKiosk: String = "Olovni kiosk"
        override val openHousesSubtitle: String = "Kreirajte dani otvorenih vrata za nekretnine, pregled vodi, i lansiranje kiosk sesije."
        override val liveMetric: String = "Uživo"
        override val upcomingMetric: String = "Nadolazeće"
        override val inProgressMetric: String = "u tijeku"
        override val scheduledMetric: String = "zakazano"
        override val loadingOpenHouses: String = "Učitavanje otvorenih kuća"
        override val addPropertyFirstTitle: String = "Dodaj prvo imovinu"
        override val addPropertyFirstBody: String = "Kreirajte dan otvorenih vrata od nekretnine za početak prikupljanja leadova."
        override val noOpenHousesTitle: String = "Nema zakazanih otvorenih kuća"
        override val noOpenHousesBody: String = "Kreirajte dan otvorenih vrata od nekretnine za početak prikupljanja leadova."
        override val noSignInsTitle: String = "Još nema prijava"
        override val noSignInsBody: String = "Olovo provjereno kroz kiosk način će se pojaviti ovdje u realnom vremenu."
        override val dashboard: String = "Tabla"
        override val start: String = "Započni"
        override val end: String = "Kraj"
        override val endOpenHouse: String = "Kraj dani otvorenih vrata"
        override val reportsEyebrow: String = "Vlasnici"
        override val sellerReportsTitle: String = "Izvješća prodavača"
        override val createReport: String = "Napravi izvještaj"
        override val reportPreview: String = "Izvještaj prodavača"
        override val reportsSubtitle: String = "Kreirajte premium post-otvorena kuća rekaps s olovnom kvalitetom, namjera kupca, i prodavač-spremne priče."
        override val reportsMetricSaved: String = "spremi"
        override val reportedMetric: String = "prijavljeno"
        override val leadsMetric: String = "leadovi"
        override val createSellerReport: String = "Napravi izvještaj"
        override val attendance: String = "Prisustvovanje"
        override val savedReports: String = "Spremi izvještaje"
        override val buyerHeat: String = "Vrućina kupca"
        override val hotLeads: String = "Vrući leadovi"
        override val loadingSellerReports: String = "Učitavanje izvještaja prodavatelja"
        override val noSellerReportsTitle: String = "Još nema izvještaja o prodaji"
        override val noSellerReportsBody: String = "Odaberite dan otvorenih vrata, dodajte napomene agenta, pregledajte izvozno-spremnu recap, a zatim je spremite."
        override val chooseOpenHouse: String = "Odaberite dan otvorenih vrata"
        override val noOpenHousesAvailable: String = "Još nema otvorenih kuća."
        override val agentNotes: String = "Bilješke"
        override val notesForSeller: String = "Napomene za prodavatelja"
        override val sellerNotesPlaceholder: String = "Prigovor kupca, Cenovni signali, pokazuje povratnu informaciju, preporučen sljedeći potez"
        override val generatePreview: String = "Generiraj pregled"
        override val noPreviewReadyTitle: String = "Nema spremnog pregleda"
        override val noPreviewReadyBody: String = "Generiraj pregled izvještaja prodavača prije snimanja."
        override val saveReport: String = "Spremi izvještaj"
        override val reportSaved: String = "Izvještaj snimljen"
        override val sellerOpenHouseReport: String = "Izvješće o otvorenoj kući prodavača"
        override val mostCommonBuyerInterest: String = "Najčešće zanimanje za kupce"
        override val followUpsSent: String = "Poslano praćenje"
        override val summary: String = "Sažetak"
        override val noPrivateNotesAdded: String = "Nema dodanih privatnih nota."
        override val openHouseReport: String = "Izvještaj dani otvorenih vrata"
        override val commonDraft: String = "Nacrt"
        override val commonAccepted: String = "Prihvaćeno"
        override val searchSellerReports: String = "Izvješća prodavača pretraživanja"
        override val noMatchingReports: String = "Nema odgovarajućih izvještaja"
        override val clearFilters: String = "Obriši filtere"
        override val tryDifferentSearchOrStatusFilter: String = "Pokušajte s drugim filterom za preleadu ili status."
        override val connectedToProperty: String = "Spojen na imovinu"
        override val viewProperty: String = "Svojstvo prikaza"
        override val dataRollup: String = "Rolanje podataka"
        override val connectedOpenings: String = "Dani otvorenih vrata"
        override val visitors: String = "Posjetitelji"
        override val interestedBuyers: String = "Zainteresirani kupci"
        override val completedFollowUps: String = "Prati uspone"
        override val reportHistory: String = "Povijest izvještaja"
        override val noPreviousReportsYet: String = "Još nema prijašnjih izvještaja."
        override val viewAllReports: String = "Pogledaj sve izvještaje"
        override val actions: String = "Radnje"
        override val generatePdf: String = "Napravi razgranat tabelu"
        override val previewPdf: String = "Pregled širine tablice"
        override val pdfSavedToPropertyFiles: String = "%s snimljeno u vlasničkim datotekama."
        override val pdfSavingToPropertyFiles: String = "%s se sprema u vlasničke datoteke."
        override val pdfSavedToFiles: String = "%s snimljeno u datoteke."
        override val pdfSavingToFiles: String = "%s se sprema u datoteke."
        override val pdfIncludesSellerReport: String = "Raspored uključuje metriku izvješćivanja o prodaji, uvide AI, detalje o agentima, podatke o imovini i povijest otvorenih kuća."
        override val pdfIncludesAnalytics: String = "Raspored uključuje analitičku metriku, top svojstva, performanse agenta, kanale praćenja, i AI uvide."
        override val pdfGenerateBeforeSending: String = "Napravi tabelu prije slanja."
        override val pdfUploadBeforeSharing: String = "Prije dijeljenja tablica mora završiti slanje."
        override val sellerReportPdfNeedsProperty: String = "Prodavatelj Izvještaj tablica treba povezane imovine prije upload."
        override val deleteReport: String = "Obriši izvještaj"
        override val deleteReportBody: String = "Jeste li sigurni da želite izbrisati ovaj izvještaj o prodaji? Ovo se ne može poništiti."
        override val shareReport: String = "Izvješće o dionicama"
        override val openingPropertyReportLoading: String = "Izvješće o imovini..."
        override val openingPropertyReportCreating: String = "Stvaram izvještaj o imovini..."
        override val sellerReportGeneratedPrefix: String = "Izvještaj o prodavaču generiran"
        override val sellerReportGeneratedSuffix: String = "od otvorenih kuća, posjetitelja, leadova, praćenja, i povratne informacije povezane s ovom imovinom u vrijeme prijave."
        override val priceNotSet: String = "Cijena nije postavljena"
        override val daysSuffix: String = "dana"
        override val connectedOpeningSingular: String = "otvorena kuća"
        override val connectedOpeningPlural: String = "dani otvorenih vrata"
        override val connectedLeadSingular: String = "spojeno olovo"
        override val connectedLeadPlural: String = "spojeni leadovi"
        override val sellerConfidence: String = "Samopouzdanje prodavača"
        override val sellerConfidenceExplanation: String = "Objašnjenje povjerenja"
        override val aiDraftReviewBeforeSending: String = "Pregled i uređivanje prije slanja prodavaču."
        override val executiveSummary: String = "Izvršni sažetak"
        override val buyerInterestOverview: String = "Pregled kamata kupca"
        override val whatBuyersLoved: String = "Što su kupci voljeli"
        override val buyerConcerns: String = "Zabrinjava se za kupce"
        override val leadQualitySummary: String = "Sažetak kvalitete olova"
        override val agentActivity: String = "Aktivnost agenta"
        override val aiRecommendations: String = "Preporuke AI"
        override val recommendations: String = "Preporuke"
        override val marketPositionComparison: String = "Usporedba tržišnog položaja"
        override val nextSteps: String = "Sljedeći koraci"
        override val conversion: String = "Pretvaranje"
        override val interested: String = "zainteresiran"
        override val tourSignalsLowercase: String = "Tour signali"
        override val propertyTimeline: String = "Vremenska razina svojstava"
        override val timelineBasisNote: String = "Vremenska linija temelji se samo na povezanim registracijama otvorenih kuća i praćenjima."
        override val visitorsLowercase: String = "posjetitelji"
        override val hotLeadsLowercase: String = "Vrući leadovi"
        override val hotLowercase: String = "vruće"
        override val sentiment: String = "Sentiment"
        override val toursLowercase: String = "obilazak"
        override val interestedLowercase: String = "zainteresiran"
        override val noRepeatedFeedbackMentions: String = "Još uvijek nisu zabilježena ponavljajuća se povratna informacija."
        override val scoresMentionRates: String = "Rezultati su spomenute stope u odnosu na ušteđene kupce povratne informacije."
        override val aiExecutiveBriefing: String = "Izvršni brifing AI"
        override val viewAllAiInsights: String = "Pogledaj sve AI uvide ->"
        override val followUpsSentTitle: String = "Poslano praćenje"
        override val financingPacketsShared: String = "Financiranje paketa dijeljeno"
        override val buyerCalls: String = "Pozivi kupca"
        override val propertyDataEvidence: String = "Podaci o imovini"
        override val attendanceCoverage: String = "Pokrivanje prisutnosti"
        override val leadQuality: String = "Kvaliteta olova"
        override val followUpExecution: String = "Postupak praćenja"
        override val activityChannels: String = "Kanali aktivnosti"
        override val callsLowercase: String = "pozivi"
        override val emailsLowercase: String = "E-pošta"
        override val offerReadinessScore: String = "Ponudi rezultat spremnosti"
        override val date: String = "Datum"
        override val propertyLeadFunnel: String = "Olovni lijevak za nekretnine"
        override val openHouseBreakdown: String = "Razlom otvorenih kuća"
        override val aiInsights: String = "Al Insights"
        override val generateAiInsights: String = "Generisanje uvida u AI"
        override val analyticsOverview: String = "Analitski pregled"
        override val allAgents: String = "Svi agenti"
        override val me: String = "Ja"
        override val allActivity: String = "Sve aktivnosti"
        override val latest30Days: String = "Posljednjih 30 dana"
        override val latest7Days: String = "Posljednjih 7 dana"
        override val analyticsDatePreset: String = "Raspon datuma"
        override val analyticsCustomDate: String = "Prilagođeni datum"
        override val analyticsLastDay: String = "Zadnji dan"
        override val analyticsLastWeek: String = "Prošli tjedan"
        override val analyticsLastMonth: String = "Prošlog mjeseca"
        override val analyticsLastYear: String = "Prošle godine"
        override val analyticsAllTime: String = "Cijelo vrijeme"
        override val analyticsDateFrom: String = "Datum od"
        override val analyticsDateTo: String = "Datum"
        override val analyticsOpenHousesLowercase: String = "dani otvorenih vrata"
        override val analyticsWarmLeadsLowercase: String = "topli leadovi"
        override val analyticsFromNotesFollowUps: String = ""
        override val analyticsFromText: String = "iz teksta"
        override val analyticsHotConversion: String = "Vruće pretvaranje"
        override val analyticsHotLeadsPerVisitors: String = "vrući lead / posjetitelji"
        override val analyticsAverageIntent: String = "Avg. namjera"
        override val analyticsVisitorIntentScore: String = "rezultat namjere posjetitelja"
        override val analyticsSelectDate: String = "Odaberi datum"
        override val propertyFunnel: String = "Livnik osobina"
        override val propertyFunnelSubtitle: String = "Od imovinske aktivnosti do kvalifikovanog zamaha kupca"
        override val properties: String = "Svojstva"
        override val tourSignals: String = "Tour signali"
        override val offerSignals: String = "Ponudi signale"
        override val viewFullFunnelReport: String = "Pogledaj cijeli lijevak izvještaj"
        override val performanceOverTime: String = "Uspjeh tijekom vremena"
        override val thirtyDays: String = "30 dana"
        override val topPerformingProperties: String = "Svojstva najvišeg izvođača"
        override val viewAll: String = "Pogledaj sve"
        override val noPropertyAnalyticsYet: String = "Još nema analitike."
        override val leadQualityBreakdown: String = "Razgradnja olovne kvalitete"
        override val warmLeadsTitle: String = "Topli leadovi"
        override val coldLeadsTitle: String = "Hladni leadovi"
        override val followUpPerformance: String = "Usluge praćenja"
        override val agentPerformance: String = "Uspjeh agenta"
        override val viewTeamReport: String = "Pogledaj izvještaj tima"
        override val followUpChannels: String = "Kanale za praćenje"
        override val viewReport: String = "Pogledaj izvještaj"
        override val searchProperties: String = "Odrednice ispisa"
        override val searchOpenings: String = "Traži dani otvorenih vrata"
        override val noOpeningsFoundTitle: String = "Nema otvorenih kuća"
        override val noOpeningsFoundBody: String = "Pokušajte drugi pretraživanje ili otvorena kuća status filter."
        override val noMatchingPropertiesTitle: String = "Odrednice ispisa"
        override val noMatchingPropertiesBody: String = "Pokušajte s drugim filterom za preleadu ili status."
        override val clientsTitle: String = "Kontakti"
        override val clientFallback: String = "Kontakt"
        override val addClient: String = "Dodaj kontakt"
        override val editClient: String = "Uređivanje kontakta"
        override val newClient: String = "Novi kontakt"
        override val saveClient: String = "Spremi kontakt"
        override val createClient: String = "Napravi kontakt"
        override val deleteClientTitle: String = "Obriši kontakt"
        override val deleteClientBody: String = "Ovo će trajno obrisati kontakt. Ovo se ne može poništiti."
        override val firstName: String = "Ime"
        override val lastName: String = "Prezime"
        override val email: String = "E- pošta"
        override val phone: String = "Telefon"
        override val comments: String = "Komentari"
        override val addPhoto: String = "Dodaj sliku"
        override val sendQr: String = "Pošalji QR"
        override val sendQrShareTitle: String = "Vaša HAVN otvorena kuća QR"
        override val sendQrShareBody: String = "Vaš HAVN otvorena kuća QR je prikačen. Dodajte novčanik propusnicu (.pkpass) na svoj telefon kada je dostupno, ili prikažite QR sliku na otvorenoj kući."
        override val sendQrReadyMessage: String = "QR kod spreman za slanje"
        override val sendQrUnavailableError: String = "Nijedna e-pošta ili SMS aplikacija nije dostupna za ovaj kontakt."
        override val clientQrDeliveryRequired: String = "Dodaj e-mail ili telefonski broj za isporuku QR-a."
        override val photo: String = "Slika"
        override val clientDetailSubtitle: String = "Identitet QR-a, kontaktni podaci, komentari i dani otvorenih vrata povezane kroz leadove."
        override val clientFormEditSubtitle: String = "Ažuriraj kontaktne podatke, informacije o isporuci i komentare."
        override val clientFormNewSubtitle: String = "Registrirajte kupca/kontakta i generirajte ponovno korišteni QR identitet za dani otvorenih vrata."
        override val searchClients: String = "Traži kontakte"
        override val noClientsYetTitle: String = "Još nema kontakata"
        override val noClientsYetBody: String = "Prijavite se prvo, a zatim pošaljite njihov QR kod e-mailom ili SMS prije dani otvorenih vrata."
        override val noClientsFoundTitle: String = "Nijedan kontakt nije pronađen"
        override val noClientsFoundBody: String = "Pokušajte drugo ime, telefon, ili e-mail."
        override val clientUnavailableTitle: String = "Kontakt nedostupan"
        override val clientUnavailableBody: String = "Osvježi popis kontakata i ponovo otvori ovaj zapis."
        override val noCommentsAdded: String = "Nema dodanih komentara."
        override val openingsTitle: String = "Dani otvorenih vrata"
        override val clientOpeningsEmpty: String = "Nema još otvorenih kuća, leadovi povezuju kontakt s otvorenom kućom."
        override val clientPassLabel: String = "Propusnica za novčanik"
        override val clientNoEmail: String = "Nema e-pošte"
        override val visitorsBody: String = "Otvorite kiosk način, skenirajte kontakt QR, ili dodajte postojeće kontakte kao leadove za ovu dan otvorenih vrata."
        override val openKiosk: String = "Otvori kiosk"
        override val addQrClient: String = "Dodaj QR kontakt"
        override val addManually: String = "Dodaj ručno"
        override val selectClients: String = "Odaberi kontakte"
        override val selectClientsBody: String = "Odaberite kontakte sa vaše liste. Svaki odabrani kontakt postaje lead za ovu dan otvorenih vrata."
        override val kioskCheckIn: String = "KIOSK prijava"
        override val kioskCheckInBody: String = "Koristite stražnju kameru za skeniranje HAVN novčanika kontakta QR. Kada je kod prepoznat, HAVN stvara vodstvo za ovu dan otvorenih vrata automatski."
        override val scanWithCamera: String = "Skeniraj stražnjim fotoaparatom"
        override val clientQrImage: String = "Kontaktiraj QR sliku"
        override val clientQrImageBody: String = "Držite kontakt QR unutar zlatnog trga. HAVN prikupi svaki skeniranje ispod."
        override val scanMultipleQrBody: String = "Skenirajte jedan ili više HAVN kontakt QR kodova, a zatim dodirnite Dodaj QR kontakt."
        override val scannedQrReady: String = "Kontakt QR spreman za dodavanje"
        override val createLeadFromQr: String = "Napravi olovo od QR"
        override val noClientsFoundShort: String = "Nisu pronađeni kontakti."
        override val remove: String = "Ukloni"
        override val tasksTitle: String = "Zadaci"
        override val addTask: String = "Dodaj zadaću"
        override val searchTasks: String = "Zadaci"
        override val loadMoreTasks: String = "Učitaj više zadataka"
        override val createTask: String = "Napravi zadatak"
        override val saveTask: String = "Spremi zadatak"
        override val editTask: String = "Uređivanje zadatka"
        override val newTask: String = "Novi zadatak"
        override val taskDetails: String = "Detalji zadatka"
        override val taskName: String = "Ime"
        override val taskDescription: String = "Opis"
        override val taskDueDateTime: String = "Vrijeme & datuma zadatka"
        override val chooseTaskDateTime: String = "Odaberi vrijeme & datuma zadatka"
        override val clearTaskDateTime: String = "Obriši vrijeme & datuma"
        override val assignToAgent: String = "Dodijeli agentu"
        override val noAgencyAgentsFound: String = "Zadatak će ostati dodijeljen vlasniku."
        override val taskPriority: String = "Prioritet zadatka"
        override val taskStatus: String = "Status"
        override val taskVisibility: String = "Vidljivost"
        override val taskOwner: String = "Vlasnik"
        override val taskOwnerFallback: String = "Vlasnik zadatka"
        override val assignedTo: String = "Dodijeljeno"
        override val selectedAgent: String = "Odabrani agent"
        override val taskVisibilityBody: String = "Ovaj zadatak je vidljiv vlasniku i dodijeljenom agentu."
        override val taskQueue: String = "Zadaci"
        override val taskDetail: String = "Detalj zadatka"
        override val taskDetailEmpty: String = "Odaberite zadatak da vidite kontekst i sljedeće radnje."
        override val connectedContext: String = "Spojen kontekst"
        override val noTaskContext: String = "Nema imovine, kontakta, dani otvorenih vrata, ili olovo je još povezan."
        override val activityTimeline: String = "Vremenska linija aktivnosti"
        override val created: String = "Napravljeno"
        override val recently: String = "Nedavno"
        override val completed: String = "Završeno"
        override val nextAction: String = "Sljedeća akcija"
        override val agentReviewOrCompletion: String = "Revizija ili dovršenje"
        override val noDueDate: String = "Datum krajnjeg roka"
        override val reopen: String = "Ponovo otvori"
        override val accept: String = "Prihvati"
        override val linkedTasks: String = "Vezani zadaci"
        override val noLinkedTasks: String = "Još nema vezanih zadataka."
        override val filesTitle: String = "Datoteke"
        override val attachFile: String = "Prikači datoteku"
        override val noFilesAttached: String = "Još nema prikačenih datoteka."
        override val fileLimitHint: String = "Datoteke mogu biti PDF, DOC, CAD, ili drugi formati do 20 MB svaki."
        override val deleteFileTitle: String = "Obriši datoteku"
        override val deleteFileBody: String = "Ova datoteka će biti uklonjena iz skladišta HAVN."
        override val attachmentOpenFailed: String = "Ne mogu otvoriti datoteku."
        override val attachmentDeleteOwnerOnly: String = "Samo vlasnik datoteke može izbrisati ovaj privitak."
        override val attachmentDocumentsNotIncluded: String = "Vaš trenutni plan ne uključuje slanje datoteka. Nadogradite za slanje datoteka."
        override val attachmentDocumentStorageNotIncluded: String = "Vaš trenutni plan ne uključuje pohranu dokumenata. Nadogradite za slanje datoteka."
        override val attachmentFileSizePlanLimit: String = "Ova datoteka je veća nego što vaš trenutni plan dopušta. Nadogradite za slanje većih datoteka."
        override val attachmentStoragePlanLimit: String = "Ograničenje pohrane dostignuto za vaš trenutni plan. Nadogradite za slanje više datoteka."
        override val attachmentDocumentCountPlanLimit: String = "Ograničenje dokumenta postignuto za ovu osobinu na vašem trenutnom planu. Nadogradite za upload više datoteka."
        override val attachmentHardFileLimit: String = "Privici datoteka su ograničeni na 100 MB."
        override val openFiles: String = "Otvori datoteku"
        override val sendViaEmail: String = "Pošalji e- poštom"
        override val sendViaSms: String = "Pošalji putem SMS- a"
        override val sendEmailHeader: String = "Pošalji e- poštu"
        override val sendSmsHeader: String = "Pošalji SMS"
        override val noContactsFound: String = "Nisu pronađeni kontakti."
        override val searchContacts: String = "Traži kontakte"
        override val linked: String = "Povezano"
        override val recent: String = "Nedavno"
        override val taskColumnToDo: String = "Za napraviti"
        override val taskColumnInProgress: String = "U napretku"
        override val taskColumnDone: String = "Završeno"
        override val taskColumnToDoSubtitle: String = "Novi zadaci i sljedeće akcije koje čekaju da se započnu."
        override val taskColumnInProgressSubtitle: String = "Rad koji trenutno posjedujete vi ili ekipa."
        override val taskColumnDoneSubtitle: String = "Završeni zadaci su bili vidljivi za pouzdanje tima."
        override val taskEmptyToDo: String = "Nema zadaća."
        override val taskEmptyInProgress: String = "Ništa u tijeku."
        override val taskEmptyDone: String = "Još nema dovršenih zadataka."
        override val taskKanbanEmptyToDo: String = "Ovdje će se pojaviti novi rad i prijava."
        override val taskKanbanEmptyInProgress: String = "Nema aktivnog posla u tijeku."
        override val taskKanbanEmptyDone: String = "Završeni zadaci će sletjeti ovdje."
        override val taskEmptyBodyPrefix: String = "Napravi zadatak ili premjesti drugi zadatak u"
        override val taskEmptyBodySuffix: String = "."
        override val taskActionStart: String = "Započni"
        override val taskActionOverdue: String = "Pretjerano"
        override val taskActionCancel: String = "Odustani"
        override val taskPriorityLow: String = "Nisko"
        override val taskPriorityMedium: String = "Srednje"
        override val taskPriorityHigh: String = "Visoko"
        override val taskPriorityUrgent: String = "Hitno"
        override val taskStatusOpen: String = "Otvori datoteku"
        override val taskStatusInProgress: String = "U tijeku"
        override val taskStatusDone: String = "Završeno"
        override val taskStatusOverdue: String = "Pretjerano"
        override val taskStatusCancelled: String = "Otkazano"
        override val aiSuggestedTasks: String = "AI predloženi zadaci"
        override val noAiSuggestedTasks: String = "HAVN će predložiti zadatke nakon otvorenih kuća i olovne aktivnosti."
        override val taskFilterToday: String = "Danas"
        override val taskFilterUpcoming: String = "Nadolazeće"
        override val taskFilterOverdue: String = "Pretjerano"
        override val taskFilterCompleted: String = "Završeno"
        override val taskFilterAssignedToMe: String = "Dodijeljen meni"
        override val taskFilterAiSuggested: String = "AI predložio"
        override val taskFilterEmptyToday: String = "Slobodna si za danas."
        override val taskFilterEmptyUpcoming: String = "Nema nadolazećih zadataka."
        override val taskFilterEmptyOverdue: String = "Nema zakašnjelih zadataka."
        override val taskFilterEmptyCompleted: String = "Još nema dovršenih zadataka."
        override val taskFilterEmptyAssignedToMe: String = "Nema zadataka koji su ti dodijeljeni."
        override val taskFilterEmptyAiSuggested: String = "Nije prihvaćen AI predložio zadatke još."
        override val taskSuggestionHotLeadTitlePrefix: String = "Pratite"
        override val taskSuggestionHotLeadTitleSuffix: String = "U roku od 2 sata."
        override val taskSuggestionHotLeadDescriptionPrefix: String = "Vruće olovo od"
        override val taskSuggestionHotLeadDescriptionSuffix: String = "Držite zamah dok je namjera svježa."
        override val taskSuggestionHotLeadReason: String = "Novo vruće olovo zarobljeno."
        override val taskSuggestionSellerReportTitlePrefix: String = "Generirajte izvještaj prodavača za"
        override val taskSuggestionSellerReportTitleSuffix: String = "."
        override val taskSuggestionSellerReportDescription: String = "Sažeti volumen posjetitelja, vruće leadove, aktivnosti praćenja, i kupca osjećaja."
        override val taskSuggestionSellerReportReason: String = "Otvorena kuća je završila."
        override val taskSuggestionReviewFollowUpTitlePrefix: String = "Pregled i slanje"
        override val taskSuggestionReviewFollowUpTitleSuffix: String = "Praćenje."
        override val taskSuggestionReviewFollowUpReason: String = "Nacrt još uvijek treba pregledati agenta."
        override val taskSuggestionKioskTitle: String = "Pripremite kiosk način i provjerite slike nekretnine."
        override val taskSuggestionKioskDescription: String = "Potvrdite protok prijave, galeriju i detalje dani otvorenih vrata prije nego što kupci stignu."
        override val taskSuggestionKioskReason: String = "Otvorena kuća je zakazana."
    }

    private val portuguese: HavnStrings = object : HavnStrings {
        override val navToday: String = "Hoje"
        override val navProperties: String = "Propriedades"
        override val navLeads: String = "Leads"
        override val navReports: String = "Relatórios"
        override val navTasks: String = "Tarefas"
        override val navAnalytics: String = "Análise"
        override val navAgency: String = "Agência"
        override val navSettings: String = "Definições"
        override val navAuth: String = "Acesso do agente"
        override val navOpenHouses: String = "Visitas abertas"
        override val navTours: String = "Visitas abertas"
        override val navFollowUps: String = "Contactos"
        override val navFollow: String = "Contactos"
        override val back: String = "Voltar"
        override val settingsEyebrow: String = "Conta"
        override val settingsTitle: String = "Configuração"
        override val settingsSubtitle: String = "Perfil de corretor, política de convites, baldes de armazenamento e papéis de equipe."
        override val agentProfileTitle: String = "Perfil do agente"
        override val agentPhoto: String = "Foto do agente"
        override val uploading: String = "Enviando..."
        override val saving: String = "A gravar..."
        override val validAgentPhotoRequired: String = "Escolha uma foto do agente válida."
        override val signOut: String = "Terminar sessão"
        override val signOutQuestion: String = "Terminar sessão?"
        override val signOutConfirmation: String = "Tem a certeza de que pretende terminar a sessão no HAVN?"
        override val deleteAccount: String = "Eliminar conta"
        override val deleteAccountQuestion: String = "Eliminar conta?"
        override val deleteAccountOpenPageBody: String = "Isto irá abrir a página de pedido de exclusão da conta."
        override val deleteAccountReviewTitle: String = "Usar uma conta real"
        override val deleteAccountReviewBody: String = "Esta conta de revisão de aplicativos está protegida para que os revisores não percam o acesso durante os testes. Use uma conta de teste real para verificar a exclusão da conta."
        override val upgrade: String = "Actualização"
        override val premiumThemesTitle: String = "Temas premium"
        override val premiumThemesUpgradePrompt: String = "Atualize para Pro para desbloquear temas premium."
        override val appearanceTitle: String = "Aparência"
        override val appearanceBody: String = "Escolha o modo claro ou escuro para a aplicação web."
        override val previewComponents: String = "Componentes de visualização"
        override val themeShowcaseTitle: String = "Apresentação do tema"
        override val showcaseButtons: String = "Botões"
        override val showcasePrimaryAction: String = "Acção primária"
        override val showcaseSecondaryAction: String = "Acção secundária"
        override val showcaseGhostAction: String = "Acção fantasma"
        override val showcaseTextField: String = "Campo de texto"
        override val showcaseFocusedBorder: String = "Contorno de acento focado"
        override val showcaseSearchPreview: String = "Visualização da pesquisa"
        override val showcaseOpeningCheckedIn: String = "Open House check-in hoje"
        override val showcaseSentAt: String = "Enviado às 10:30"
        override val themeObsidianGoldName: String = "Ouro Obsidiano"
        override val themeObsidianGoldDescription: String = "Preto de luxo, grafite e ouro quente."
        override val themeMidnightSapphireName: String = "Safira Meia-Noite"
        override val themeMidnightSapphireDescription: String = "Marinha profunda, azul safira e sotaques prateados."
        override val themeEmeraldEstateName: String = "Esmeralda"
        override val themeEmeraldEstateDescription: String = "Esmeralda escura, carvão e ouro champanhe."
        override val themePlatinumStoneName: String = "Pedra Platina"
        override val themePlatinumStoneDescription: String = "Cinza de pedra, platina e branco macio."
        override val themeBordeauxNoirName: String = "Bordeaux Noir"
        override val themeBordeauxNoirDescription: String = "Vinho escuro, grafite e sotaques de cobre."
        override val commonChange: String = "Alterar"
        override val agentPlanTitle: String = "Plano de agente"
        override val agentPlanBody: String = "Atualize sua experiência, escolha o plano que se encaixa em como você trabalha melhor."
        override val currentPlan: String = "Plano actual"
        override val transferPlan: String = "Plano de transferências"
        override val transferPlanTitle: String = "Plano de transferências"
        override val transferPlanBody: String = "Mova esta subscrição para outra conta HAVN. Ambos os endereços de e-mail devem confirmar com códigos de verificação."
        override val transferTargetEmail: String = "E- mail de nova conta"
        override val transferSendCodes: String = "Enviar códigos de verificação"
        override val transferCodesSentTitle: String = "Códigos de verificação enviados"
        override val transferCodesSentBody: String = "Enviamos um código para o seu e-mail e um código para o novo e-mail da conta."
        override val transferYourCode: String = "O seu código de email"
        override val transferTargetCode: String = "Novo código da conta"
        override val transferConfirm: String = "Plano de transferências"
        override val transferSuccessTitle: String = "Plano transferido"
        override val transferSuccessBody: String = "A subscrição está agora ligada à nova conta HAVN."
        override val restorePurchase: String = "Restaurar Compra"
        override val agencySettingsProBody: String = "A agência Solo está ativa por padrão. Pro permite criar ou selecionar uma agência compartilhada."
        override val agencySettingsLockedBody: String = "A agência Solo está activa. Mudanças de agência desbloquear com Pro."
        override val soloAgency: String = "Agência individual"
        override val defaultPrivateAgencyWorkspace: String = "Agência privada padrão"
        override val noAgenciesAvailableYet: String = "Nenhum convite de agência ou agências próprias ainda estão disponíveis."
        override val oneOwnedAgencyHint: String = "A sua agência está listada acima. Um agente pode ter uma agência."
        override val createAgency: String = "Criar agência"
        override val createYourAgency: String = "Crie sua agência"
        override val createAgencyBody: String = "Construa sua equipe, gerencie propriedades juntos e cresça seu negócio."
        override val agencyName: String = "Nome da agência"
        override val agencyEmail: String = "E- mail da Agência"
        override val logoOptional: String = "Logotipo (opcional)"
        override val upgradeExperienceTitle: String = "Atualize sua experiência"
        override val upgradeExperienceSubtitle: String = "Execute seu primeiro Open House livre. Atualize quando precisar de mais listas, visitas abertas e fluxos de trabalho Pro."
        override val soloAgentPlan: String = "Agente individual"
        override val proAgentPlan: String = "Agente Pro"
        override val teamAgentPlan: String = "Equipa"
        override val soloBenefitActiveProperties: String = "Até 100 propriedades activas"
        override val soloBenefitAiFollowUps: String = "Acompanhamentos de IA (base)"
        override val soloBenefitSellerReports: String = "Nenhum relatório de vendedor"
        override val soloBenefitPersonalOnly: String = "Apenas pessoal"
        override val proBenefitUnlimitedProperties: String = "Até 10.000 propriedades"
        override val proBenefitUnlimitedAi: String = "10.000 pedidos de texto de IA / mês"
        override val proBenefitAdvancedReports: String = "Relatórios avançados de vendedores"
        override val proBenefitAgencyCreation: String = "Criação e gestão da Agência"
        override val proBenefitInviteAgents: String = "Convidar agentes e colaborar"
        override val proBenefitSharedLeads: String = "Leads compartilhados e fluxos de trabalho de equipe"
        override val proBenefitAgencyBranding: String = "Marcação da agência"
        override val proBenefitAdvancedAnalytics: String = "Análise avançada"
        override val teamBenefitLargeLimits: String = "Limites em escala de equipa"
        override val teamBenefitPrioritySupport: String = "Suporte de e- mail prioritário"
        override val teamBenefitDailyBackups: String = "Backups diários para 7 dias"
        override val teamBenefitLargeStorage: String = "Armazenamento de documentos 10GB"
        override val startFreeTrial7Day: String = "Inscreva-se agora"
        override val restorePurchases: String = "Restaurar Compra"
        override val comparePlans: String = "Comparar os planos"
        override val startFreeTrial: String = "Escolher plano"
        override val noCommitmentCancelAnytime: String = "Execute seu primeiro Open House livre. Atualize quando precisar de mais."
        override val monthly: String = "Mensal"
        override val yearly: String = "Anual"
        override val yearlySave20: String = "Anual"
        override val yearlySavings20: String = "Faturado anualmente."
        override val perYear: String = "/ ano"
        override val loadingPlans: String = "A carregar os planos..."
        override val selectedPlanUnavailable: String = "As assinaturas estão temporariamente indisponível. Por favor, tente novamente mais tarde ou contacte o suporte."
        override val signInRequiredForPurchase: String = "Iniciar sessão antes de iniciar uma compra."
        override val subscriptionDisclosureIos: String = "Assinatura auto-renovável. O pagamento será cobrado na sua Conta Apple na confirmação da compra. Sua assinatura é renovada automaticamente, a menos que seja cancelada pelo menos 24 horas antes do final do período atual. A renovação será cobrada dentro de 24 horas antes do final do período atual. Você pode gerenciar ou cancelar sua assinatura nas configurações da conta da App Store."
        override val subscriptionDisclosureAndroid: String = "Assinatura renovável automática através do Google Play. Você será cobrado cada período de faturamento a menos que você cancele. Você pode gerenciar ou cancelar sua assinatura a qualquer momento nas assinaturas do Google Play. O acesso continua até ao final do período pago."
        override val subscriptionDisclosureWeb: String = "Assinatura auto-renovável. Você será cobrado cada período de faturamento usando seu método de pagamento selecionado, a menos que você cancele. Você pode gerenciar ou cancelar a qualquer momento das configurações de faturamento. O acesso continua até ao final do período pago. Podem aplicar-se impostos."
        override val subscriptionAgreementPrefix: String = "Ao subscrever, você concorda com"
        override val subscriptionTermsOfUse: String = "Termos de Uso da HAVN"
        override val subscriptionAgreementAnd: String = "e"
        override val subscriptionPrivacyPolicy: String = "Política de Privacidade."
        override val purchaseSuccessTitle: String = "Obrigado por sua compra"
        override val purchaseSuccessBody: String = "Sua assinatura HAVN está ativa e seu plano está pronto."
        override val restoreSuccessTitle: String = "Restaurar Compra"
        override val restoreSuccessBody: String = "Sua assinatura HAVN foi restaurada com sucesso."
        override val purchaseCouldNotComplete: String = "A compra não pôde ser concluída. Por favor, tente novamente ou verifique sua conta App Store ou Google Play."
        override val purchaseVerificationPending: String = "Your payment has not been confirmed yet. If you completed checkout, use Restore purchase to check again. You do not need to pay again."
        override val completeWebCheckout: String = "Complete payment in the checkout tab, then return here. Your access will update automatically once payment is confirmed."
        override val restoreCouldNotComplete: String = "Nenhuma assinatura HAVN ativa foi encontrada para esta conta de loja."
        override val noActiveSubscriptionFound: String = "Nenhuma assinatura HAVN ativa foi encontrada para esta conta de loja."
        override val compareActiveProperties: String = "Propriedades activas"
        override val compareAiFollowUps: String = "Acompanhamento dos IA"
        override val compareSellerReports: String = "Relatórios do vendedor"
        override val compareAdvancedAnalytics: String = "Análise avançada"
        override val compareAgencyCreation: String = "Criação da Agência"
        override val compareJoinAgencies: String = "Participar em agências"
        override val compareInviteAgents: String = "Convidar agentes"
        override val compareSharedLeads: String = "Leads compartilhados"
        override val compareAgencyBranding: String = "Marcação da agência"
        override val comparePrioritySupport: String = "Apoio prioritário"
        override val compareFeature: String = "Característica"
        override val compareFreePlan: String = "Livre"
        override val compareValueYes: String = "Sim."
        override val compareValueNo: String = "Não"
        override val comparePricePerMonthUser: String = "Preço / Mês / Usuário"
        override val comparePricePerYearUser: String = "Preço / Ano / Usuário"
        override val compareMaxPropertiesOwner: String = "Max propriedades / proprietário"
        override val compareMaxContactsOwner: String = "Max contatos / proprietário"
        override val compareMaxOpenHousesOwner: String = "Max visitas abertas / proprietário"
        override val compareMaxLeadsOwner: String = "Max leads / proprietário"
        override val compareMaxPhotosProperty: String = "Máximas fotos por propriedade"
        override val compareMaxDocumentsProperty: String = "Máximo de documentos por propriedade"
        override val compareDocumentsStorage: String = "Armazenagem de documentos"
        override val compareAgencyAgenda: String = "Ordem do dia da Agência"
        override val compareAiTextRequestsMonth: String = "Pedidos de geração de texto de IA / mês"
        override val compareAnalytics: String = "Análise"
        override val compareTasks: String = "Tarefas"
        override val compareDocumentsStorageOwner: String = "Armazenamento de documentos / proprietário"
        override val compareMaxFileSizeOwner: String = "Tamanho máximo do arquivo / proprietário"
        override val compareEmailSupport: String = "Suporte por e- mail"
        override val compareDailyBackups7Days: String = "Backups diários armazenados por 7 dias"
        override val compareKioskMode: String = "Modo quiosque"
        override val unlimited: String = "Ilimitado"
        override val basic: String = "Basic"
        override val advanced: String = "Avançado"
        override val perMonth: String = "/ mês"
        override val members: String = "membros"
        override val upgradeToProForAgencyTools: String = "Atualize para o Pro para usar ferramentas de agência"
        override val languageTitle: String = "Língua"
        override val languageBody: String = "Escolha o idioma da aplicação para este dispositivo."
        override val english: String = "Inglês"
        override val slovak: String = "Eslovaco"
        override val unitsTitle: String = "Unidades e moeda"
        override val unitsBody: String = "Escolha como os preços e as dimensões da propriedade são mostrados em todo o aplicativo."
        override val measurementSystemTitle: String = "Medição"
        override val metric: String = "Métrico"
        override val imperial: String = "Imperial"
        override val currencyTitle: String = "Moeda"
        override val notificationsTitle: String = "Notificação"
        override val notificationsBody: String = "Controle alertas de impulso, horas de silêncio, e os tipos de atualizações HAVN pode enviar."
        override val notificationSettings: String = "Configuração da notificação"
        override val notificationsSubtitle: String = "Apenas atualizações importantes, filtradas por suas preferências."
        override val quietHoursTitle: String = "Horas calmas"
        override val quietHoursBody: String = "HAVN pula impulsos não críticos durante horas tranquilas. Os problemas de faturamento e conta ainda permanecem concisos."
        override val enableQuietHours: String = "Habilitar horas silenciosas"
        override val quietHoursStart: String = "Iniciar"
        override val quietHoursEnd: String = "Fim"
        override val timezoneLabel: String = "Fuso horário"
        override val notificationTypesTitle: String = "Tipos de notificação"
        override val notificationNewLeadCapturedTitle: String = "Novo lead capturado"
        override val notificationNewLeadCapturedBody: String = "Quando uma visita aberta ou fluxo QR captura uma pista."
        override val notificationHotLeadTitle: String = "Lead marcado como quente"
        override val notificationHotLeadBody: String = "Só quando uma pista se torna uma grande intenção."
        override val notificationOpeningStartsSoonTitle: String = "Open House começa em breve"
        override val notificationOpeningStartsSoonBody: String = "Um único lembrete 30 minutos antes do início."
        override val notificationOpeningSummaryReadyTitle: String = "Resumo aberto pronto"
        override val notificationOpeningSummaryReadyBody: String = "Quando o resumo pós-evento estiver pronto."
        override val notificationSellerReportGeneratedTitle: String = "Relatório do vendedor gerado"
        override val notificationSellerReportGeneratedBody: String = "Quando um relatório de vendedor foi criado."
        override val notificationAiFollowUpReadyTitle: String = "AI acompanhamento pronto"
        override val notificationAiFollowUpReadyBody: String = "Quando um rascunho de acompanhamento estiver pronto para ser revisto."
        override val notificationAgentInvitedTitle: String = "Agente convidado para a agência"
        override val notificationAgentInvitedBody: String = "Convites da agência e mudanças de adesão."
        override val notificationLeadAssignedTitle: String = "Guia atribuído a você"
        override val notificationLeadAssignedBody: String = "Quando um colega de equipa lhe dá uma pista."
        override val notificationLeadTransferredTitle: String = "Lead transferido para você"
        override val notificationLeadTransferredBody: String = "Quando a propriedade de uma pista se move para você."
        override val notificationSubscriptionIssueTitle: String = "Número da assinatura"
        override val notificationSubscriptionIssueBody: String = "Falhas de renovação e problemas de cobrança."
        override val kioskSecurityTitle: String = "Segurança do quiosque"
        override val kioskSecurityBody: String = "Use este PIN para deixar o modo quiosque e voltar para o aplicativo agente."
        override val kioskPinLabel: String = "Kiosk PIN"
        override val mcpAccessTitle: String = "Acesso MCP"
        override val mcpAccessBody: String = "Ponte HAVN para Claude, OpenAI, e outros clientes MCP no mcp.havnre.app. Disponível em todos os planos."
        override val mcpAuthorizationBearer: String = "Autorização: Carregador"
        override val mcpNoApiKeyCreated: String = "Nenhuma chave de API criada"
        override val mcpNotUsedYet: String = "Ainda não utilizado"
        override val mcpLastUsedPrefix: String = "Última utilização"
        override val mcpRevealApiKeyTitle: String = "Revele a chave da API"
        override val mcpRevealApiKeyBody: String = "A chave completa só é mostrada após criar ou rodar."
        override val mcpCreateKey: String = "Criar chave"
        override val mcpRotateKey: String = "Rodar a tecla"
        override val mcpRevokeKey: String = "Revogar a tecla"
        override val mcpEndpointHint: String = "Utilizar o endpoint https://mcp.havnre.app/mcp com esta chave como token do portador."
        override val mcpUpgradeHint: String = "O acesso MCP está disponível em todos os planos HAVN."
        override val mcpUpgradePrompt: String = "O acesso MCP está disponível em todos os planos HAVN."
        override val mcpCopied: String = "Copiado"
        override val mcpCopy: String = "Copiar"
        override val mcpLoading: String = "Carregando"
        override val kioskFeaturedProperty: String = "Propriedade em destaque"
        override val kioskPrivateShowing: String = "Apresentação privada"
        override val kioskLuxuryListing: String = "Lista de luxo"
        override val kioskFastCheckIn: String = "Check-in rápido"
        override val kioskExitContentDescription: String = "Sair do quiosque"
        override val kioskWelcome: String = "Boas-vindas"
        override val kioskGladHere: String = "Estamos felizes que você está aqui."
        override val kioskScanToCheckIn: String = "Digitalizar para verificar"
        override val kioskReceivePropertyDetails: String = "e receber detalhes da propriedade"
        override val kioskOr: String = "Ou"
        override val kioskStartCheckInManually: String = "Iniciar o check-in manualmente"
        override val kioskSecureInfo: String = "Suas informações são seguras e nunca serão compartilhadas."
        override val kioskExitTitle: String = "Sair do quiosque"
        override val kioskExitBody: String = "Digite o PIN do quiosque para retornar ao aplicativo agente."
        override val kioskIncorrectPin: String = "PIN incorreto."
        override val kioskUnlock: String = "Desbloquear"
        override val kioskTellUsTitle: String = "Fale-nos de si."
        override val kioskTellUsBody: String = "A sua informação vai apenas para o agente de acolhimento."
        override val kioskFullName: String = "Nome completo"
        override val kioskContinue: String = "Continuar"
        override val kioskQuestionsTitle: String = "Algumas perguntas rápidas"
        override val kioskQuestionsBody: String = "Isso ajuda o agente a acompanhar o contexto certo."
        override val kioskWorkingWithAgentQuestion: String = "Está a trabalhar com um agente?"
        override val kioskYes: String = "Sim."
        override val kioskNo: String = "Não"
        override val kioskInterestQuestion: String = "No que estás interessado?"
        override val kioskInterestBuying: String = "Compra"
        override val kioskInterestInvesting: String = "Investir"
        override val kioskInterestBrowsing: String = "Apenas a navegar."
        override val kioskInterestRelocating: String = "Relocalização"
        override val kioskFinish: String = "Terminar"
        override val kioskThankYou: String = "Obrigado."
        override val kioskEnjoyVisitPrefix: String = "Aproveite a sua visita em"
        override val kioskResetAutomatically: String = "Este quiosque irá reiniciar automaticamente."
        override val environmentTitle: String = "Ambiente"
        override val environmentBody: String = "Os detalhes da conexão estão configurados para esta compilação."
        override val secure: String = "Seguro"
        override val brokerageProfileTitle: String = "Perfil do corretor"
        override val brokerageProfileBody: String = "Marcas de equipe, convites de agente e preferências de notificação viverão aqui."
        override val logout: String = "Sair"
        override val languageChanged: String = "Mudança de idioma"
        override val commonAdd: String = "Adicionar"
        override val commonEdit: String = "Editar"
        override val commonDelete: String = "Apagar"
        override val commonCancel: String = "Cancelar"
        override val commonSave: String = "Gravar"
        override val commonCreate: String = "Criar"
        override val commonDismiss: String = "Demitir"
        override val commonAll: String = "Tudo"
        override val commonDone: String = "Feito"
        override val commonSend: String = "Enviar"
        override val commonTime: String = "Tempo"
        override val commonHour: String = "Hora"
        override val commonMinute: String = "Minuto"
        override val commonAgency: String = "Agência"
        override val commonSettings: String = "Configuração"
        override val commonOpening: String = "Abrir a Casa"
        override val commonPropertyName: String = "Propriedade"
        override val commonToday: String = "Hoje"
        override val agencyToolsAvailable: String = "As ferramentas da agência estão disponíveis."
        override val agencySetupSubtitle: String = "Cada conta HAVN tem uma agência padrão. Pro permite gerenciar convites, leads compartilhados e branding."
        override val agencyRecentActivity: String = "Actividade recente"
        override val agencyActivityNewLead: String = "Novo lead adicionado"
        override val agencyActivityInvitationAccepted: String = "Convite do agente aceito"
        override val agencyActivityAgentJoined: String = "Agente entrou na agência."
        override val agencyActivitySellerReport: String = "Relatório do vendedor criado"
        override val agencyWorkspaceTitle: String = "Agência"
        override val agencyWorkspaceBody: String = "Escolha com qual agência você está trabalhando."
        override val agencySoloActiveTitle: String = "A agência Solo está activa"
        override val agencyProRequiredTitle: String = "Plano pro necessário"
        override val agencyCreateOrAcceptInviteBody: String = "Crie sua agência ou aceite um convite para colaborar com outra agência."
        override val agencyProUnlockBody: String = "Mudança de agência, convites, leads compartilhados e branding compartilhado desbloqueiam com o Pro."
        override val realEstate: String = "Imobiliária"
        override val proAgency: String = "Agência profissional"
        override val agencyBrandingTitle: String = "Marcação da agência"
        override val agencyBrandingBody: String = "Defina o nome e o logotipo da agência mostrados no aplicativo, quiosque e visualizações de equipe."
        override val uploadLogo: String = "Enviar o logótipo"
        override val saveAgency: String = "Salvar agência"
        override val yourAgencyRole: String = "Seu papel de agência"
        override val agencyAgentsTitle: String = "Agentes da Agência"
        override val agencyAgentsBody: String = "Pessoas elegíveis para trabalhar com esta agência."
        override val inviteAgent: String = "Convidar agente"
        override val loadingAgents: String = "Carregando agentes..."
        override val noAgencyAgentsYet: String = "Ainda não há agentes da agência."
        override val changeRole: String = "Mudar o papel"
        override val updating: String = "Actualizando..."
        override val deleting: String = "A apagar..."
        override val deleteInvite: String = "Cancelar o convite"
        override val chooseAgencyRoleFor: String = "Escolha o papel da agência para"
        override val removeAccess: String = "Remover acesso"
        override val inviteAgentBody: String = "Envie um convite da agência por e-mail. O agente aceita após iniciar sessão com o mesmo e-mail."
        override val agentEmail: String = "E- mail do agente"
        override val role: String = "Papel"
        override val inviting: String = "A convidar..."
        override val invite: String = "Convidar"
        override val agents: String = "Agentes"
        override val ok: String = "Está bem."
        override val personalActivePropertyLimit: String = "Limite de propriedade ativa pessoal"
        override val personalAccountAgencyToolsLocked: String = "A conta pessoal está activa. Ferramentas da agência desbloquear com Pro."
        override val selected: String = "Seleccionado"
        override val activeMembers: String = "membros activos"
        override val agencySharedWorkspaceBody: String = "Propriedades compartilhadas, contatos, visitas abertas, leads, acompanhamentos e relatórios usam esta agência."
        override val actLikeAgent: String = "Age como um agente."
        override val actAsAdmin: String = "Agir como Administrador"
        override val actAsOwner: String = "Agir como Dono"
        override val actLikeAgentBody: String = "Usa a agência como agente normal."
        override val actLikeAgentSelectedBody: String = "Apenas é mostrado o trabalho atribuído ou próprio."
        override val agencyRoleOwner: String = "Dono"
        override val agencyRoleAdmin: String = "Administrador"
        override val agencyRoleAgent: String = "Agente"
        override val agencyRoleAssistant: String = "Assistente"
        override val agencyRoleViewer: String = "Visualizador"
        override val agencyRoleOwnerDescription: String = "Controle completo da agência, incluindo membros, branding, atribuições, listas, leads e relatórios."
        override val agencyRoleAdminDescription: String = "Gestão completa da agência, excepto a exclusão da agência."
        override val agencyRoleAgentDescription: String = "Trabalhos designados listas, visitas abertas, leads, acompanhamentos, notas e relatórios de vendedores."
        override val agencyRoleAssistantDescription: String = "Suporta listas atribuídas através da edição de leads, preparação de acompanhamentos e elaboração de relatórios."
        override val agencyRoleViewerDescription: String = "Acesso somente para leitura a painéis e relatórios."
        override val agencyCapabilityInviteRemoveMembers: String = "Convidar e remover membros"
        override val agencyCapabilityChangeRoles: String = "Mudar funções dos membros"
        override val agencyCapabilityManageAllProperties: String = "Criar, editar e apagar todas as propriedades"
        override val agencyCapabilityAssignAgents: String = "Atribuir agentes"
        override val agencyCapabilitySeeAllLeads: String = "Ver todos os leads"
        override val agencyCapabilityExportReports: String = "Relatórios de exportação"
        override val agencyCapabilityChangeBranding: String = "Alterar branding e configurações da agência"
        override val agencyCapabilityDeleteAgency: String = "Apagar a agência"
        override val agencyCapabilityViewAssignedProperties: String = "Ver as propriedades atribuídas"
        override val agencyCapabilityHostAssignedOpenings: String = "Host atribuído visitas abertas"
        override val agencyCapabilitySeeAssignedLeads: String = "Veja leads de propriedades atribuídas e visitas abertas"
        override val agencyCapabilityAddNotes: String = "Adicionar notas"
        override val agencyCapabilitySendFollowUps: String = "Enviar seguimentos"
        override val agencyCapabilityCreateSellerReports: String = "Criar relatórios de vendedores para listas atribuídas"
        override val agencyCapabilityEditAssignedLeads: String = "Editar leads atribuídos"
        override val agencyCapabilityPrepareFollowUps: String = "Preparar os seguimentos"
        override val agencyCapabilityCreateDraftReports: String = "Criar um projecto de relatórios"
        override val agencyCapabilityCannotDeleteProperties: String = "Incapaz de apagar as propriedades"
        override val agencyCapabilityCannotInviteAgents: String = "Não é possível convidar agentes a menos que permitido"
        override val agencyCapabilityViewDashboards: String = "Ver painéis"
        override val agencyCapabilityViewReports: String = "Ver relatórios"
        override val agencyCapabilityCannotEdit: String = "Não é possível editar nada"
        override val commonVisitors: String = "Lead"
        override val commonHot: String = "Quente"
        override val commonWarm: String = "Morno"
        override val commonCold: String = "Frio"
        override val commonActive: String = "Activo"
        override val commonPlanned: String = "Planeado"
        override val commonArchived: String = "Arquivado"
        override val commonPast: String = "Passado"
        override val commonFollowUps: String = "Acompanhamentos"
        override val commonProperty: String = "Propriedade"
        override val commonAddress: String = "Endereço"
        override val commonOpenHouse: String = "Abrir a Casa"
        override val commonInquiry: String = "Inquérito"
        override val commonInquiries: String = "Consultas"
        override val generalInquiry: String = "Consulta geral"
        override val generalInquiries: String = "Consultas gerais"
        override val propertyInquiry: String = "Consulta sobre imóvel"
        override val propertyInquiries: String = "Consultas sobre imóveis"
        override val addGeneralInquiry: String = "Adicionar consulta geral"
        override val newGeneralInquiry: String = "Nova consulta geral"
        override val noGeneralInquiries: String = "Ainda não há consultas gerais."
        override val noPropertyInquiries: String = "Ainda não há consultas sobre imóveis."
        override val buyerLookingFor: String = "O que este comprador procura?"
        override val locationCity: String = "Localização / cidade"
        override val radiusKm: String = "Raio (km)"
        override val propertyType: String = "Tipo de imóvel"
        override val budgetFrom: String = "Orçamento desde"
        override val budgetTo: String = "Orçamento até"
        override val purchaseTimeline: String = "Prazo de compra"
        override val createGeneralInquiry: String = "Criar consulta geral"
        override val saveGeneralInquiry: String = "Guardar consulta geral"
        override val inquiryType: String = "Tipo de consulta"
        override val leadSource: String = "Origem do lead"
        override val notSpecified: String = "Não especificado"
        override val inquiryStatus: String = "Situação do inquérito"
        override val inquiryFollowUp: String = "Acompanhamento do inquérito"
        override val addInquiry: String = "Adicionar um inquérito"
        override val searchInquiries: String = "Pesquisa"
        override val noInquiries: String = "Sem inquéritos"
        override val noInquiriesBody: String = "Use o botão plus para adicionar o interesse do comprador de um contato existente."
        override val inquiryUnavailableTitle: String = "Inquérito indisponível"
        override val inquiryUnavailableBody: String = "Este inquérito pode ter sido removido ou ainda está a carregar."
        override val backToInquiries: String = "Voltar às perguntas"
        override val deleteInquiry: String = "Apagar o inquérito"
        override val deleteInquiryQuestionPrefix: String = "Apagar"
        override val deleteInquiryQuestionSuffix: String = "desta propriedade?"
        override val deleteInquiryTargetFallback: String = "este inquérito"
        override val propertyInquiriesBody: String = "Os compradores que perguntaram sobre esta propriedade. Os inquéritos também aparecem em Leads."
        override val propertyInquiriesEmpty: String = "Adicione um inquérito escolhendo um de seus contatos."
        override val contactInquiriesBody: String = "Propriedades sobre as quais este contacto perguntou."
        override val contactInquiriesEmpty: String = "Ainda não há perguntas de propriedade."
        override val viewInquiries: String = "Ver as perguntas"
        override val createContactFirstForInquiry: String = "Crie um contato primeiro, depois adicione o inquérito a partir desta propriedade."
        override val commonCheckedIn: String = "Registado"
        override val commonNotScheduled: String = "não agendado"
        override val todayTitle: String = "Hoje"
        override val todaySubtitle: String = "Sua casa diária para visitas abertas, pistas, acompanhamentos, e momento de venda-pronto."
        override val todayOpenHousesMetric: String = "visitas abertas"
        override val capturedMetric: String = "capturado"
        override val priorityMetric: String = "prioridade"
        override val noActivePropertiesTitle: String = "Sem propriedades activas"
        override val noActivePropertiesBody: String = "Adicione ou ative uma propriedade para fazê-la aparecer em Today."
        override val checkIns: String = "Check-ins"
        override val allOpenHouses: String = "todas as visitas abertas"
        override val pendingDrafts: String = "rascunhos pendentes"
        override val priorityLead: String = "Líder prioritário"
        override val nextOpenHouseAt: String = "Próximo open house em"
        override val noOpenHouseScheduled: String = "Nenhuma visita aberta programada"
        override val personalAccount: String = "Conta pessoal"
        override val accountReady: String = "Sua conta está pronta"
        override val realEstateApp: String = "Aplicação imobiliária"
        override val needHelp: String = "Precisas de ajuda?"
        override val contactSupport: String = "Suporte de contacto"
        override val upgradePlan: String = "Plano de actualização"
        override val planSuffix: String = "Plano"
        override val todayActionsTitle: String = "Prioridades de hoje"
        override val agencyInvitation: String = "Convite da Agência"
        override val joinAgency: String = "Entrar"
        override val youWereInvitedAs: String = "Foste convidado como"
        override val invitedBy: String = "por"
        override val decline: String = "Recusar"
        override val yourDefaultAgency: String = "Sua agência padrão"
        override val chooseAgencyBody: String = "Escolha com qual agência deseja trabalhar. As ferramentas da agência incluem convites, leads compartilhados e branding."
        override val agencyMembersSuffix: String = "membros"
        override val quickActionTasksBody: String = "Fila"
        override val quickActionReportsBody: String = "Vendedor"
        override val quickActionAnalyticsBody: String = "Tendências"
        override val quickActionAddPropertyTitle: String = "Adicionar"
        override val quickActionAddPropertyBody: String = "Listagem"
        override val quickActionAddContactTitle: String = "Contacto"
        override val quickActionAddContactBody: String = "Novo"
        override val quickActionFilesTitle: String = "Ficheiros"
        override val quickActionFilesBody: String = "Docs"
        override val firstRunStepsTitle: String = "Iniciar com quatro passos simples"
        override val firstRunAddProperty: String = "Adicionar propriedade"
        override val firstRunScheduleOpening: String = "Agendar a visita aberta"
        override val firstRunStartGuestCheckIn: String = "Iniciar o check-in dos convidados"
        override val firstRunSendFollowUp: String = "Enviar acompanhamento"
        override val greetingNamePrefix: String = "Olá."
        override val greetingAgent: String = "Olá, Agente."
        override val createListing: String = "Criar listagem"
        override val newOwnerBuyer: String = "Novo proprietário/comprador"
        override val documents: String = "Documentos"
        override val whatOpeningNext: String = "O que é a seguir?"
        override val whoCheckedIn: String = "Quem entrou?"
        override val whoNeedsFollowUp: String = "Quem precisa de acompanhamento?"
        override val whatShouldIDoNow: String = "O que devo fazer agora?"
        override val noCheckInsYet: String = "Ainda não há contactos."
        override val noPendingFollowUps: String = "Sem acompanhamentos pendentes neste momento."
        override val openKioskForNextOpening: String = "Abra o quiosque para a próxima visita aberta."
        override val reviewNewLeads: String = "Reveja novos leads e envie acompanhamentos."
        override val createOpeningToStart: String = "Crie uma visita aberta de uma propriedade para começar a coletar leads."
        override val addFirstPropertyToStart: String = "Adicione sua primeira propriedade para começar."
        override val nextOpening: String = "Próxima visita aberta"
        override val quickSignIn: String = "Entrada rápida"
        override val scanQrCode: String = "Analisar o código QR"
        override val newLead: String = "Novo lead"
        override val myProperties: String = "As minhas propriedades"
        override val manageListings: String = "Gerenciar listas"
        override val todaysOverview: String = "Visão geral de hoje"
        override val seeAll: String = "Ver todos"
        override val propertiesEyebrow: String = "Portfólio"
        override val propertiesSubtitle: String = "Gerencie listas ativas, planejadas e arquivadas com mídia de listagem, atividade de comprador e insights de desempenho."
        override val propertiesLiveMetric: String = "vivo"
        override val propertiesPipelineMetric: String = "pipeline"
        override val propertiesAllTimeMetric: String = "todo o tempo"
        override val addProperty: String = "Adicionar propriedade"
        override val editProperty: String = "Editar propriedade"
        override val propertyFallback: String = "Propriedade"
        override val propertyUnavailableTitle: String = "Propriedade não disponível"
        override val propertyUnavailableBody: String = "Atualizar o portfólio para recarregar esta lista."
        override val backToProperties: String = "Voltar às propriedades"
        override val deletePropertyTitle: String = "Apagar propriedade?"
        override val deletePropertyBody: String = "Isto apagará permanentemente a propriedade e seus registros locais relacionados. Isto não pode ser desfeito."
        override val loadingProperties: String = "Carregando propriedades"
        override val loadMore: String = "Carregar mais"
        override val loadingPropertyDetails: String = "Carregando detalhes da propriedade"
        override val noPropertiesTitle: String = "Sem propriedades ainda"
        override val noPropertiesBody: String = "Adicione sua primeira propriedade, depois crie uma visita aberta para começar a coletar leads e feedback pronto para o vendedor."
        override val openHouseButton: String = "Criar visita aberta"
        override val photosTitle: String = "Fotos"
        override val photosBody: String = "A primeira foto é usada como a imagem principal da propriedade em todo Portfólio."
        override val uploadPhoto: String = "Adicionar foto"
        override val noPhotosYet: String = "Nenhuma foto enviada ainda."
        override val propertyPhotoCountPlanLimit: String = "O limite de fotografia alcançado para esta propriedade no seu plano atual. Atualize para carregar mais fotos."
        override val propertyPhotoStoragePlanLimit: String = "Limite de armazenamento alcançado para o seu plano atual. Atualize para carregar mais fotos ou arquivos."
        override val mainPhoto: String = "Principal"
        override val propertyTitleLabel: String = "Nome da propriedade"
        override val propertyAddressLine1Label: String = "Endereço da rua"
        override val propertyAddressLine2Label: String = "Linha de endereço 2"
        override val propertyCityLabel: String = "Cidade"
        override val propertyRegionLabel: String = "Região"
        override val propertyPostalCodeLabel: String = "Código postal"
        override val propertyCountryLabel: String = "País"
        override val propertyAskingPriceLabel: String = "Preço de pedido"
        override val propertyBedsLabel: String = "Camas"
        override val propertyBathsLabel: String = "Banhos"
        override val propertyInteriorLabel: String = "Interior"
        override val propertyDescriptionLabel: String = "Designação das mercadorias"
        override val createPropertyButton: String = "+ Propriedade"
        override val locateProperty: String = "Localizar propriedade"
        override val findLocation: String = "Procurar localização"
        override val find: String = "Procurar"
        override val navigate: String = "Navegar"
        override val propertyLocationMarkerTitle: String = "Localização da propriedade"
        override val mapKitJsMissingToken: String = "Adicionar HAVN MAPKIT JS TOKEN para local.propriedades para o mapa web."
        override val mapKitJsLoading: String = "Carregando MapKit JS..."
        override val generateSellerReport: String = "Gerar o relatório do vendedor"
        override val deleteProperty: String = "Apagar propriedade"
        override val conversionMetric: String = "Conversão"
        override val propertyPhotoContentDescription: String = "Foto da propriedade"
        override val deletePhoto: String = "Apagar foto"
        override val movePhotoLeft: String = "Mover a foto para a esquerda"
        override val movePhotoRight: String = "Mover a foto para a direita"
        override val propertyTitleRequired: String = "O nome da propriedade é obrigatório."
        override val propertyStreetRequired: String = "O endereço da rua é obrigatório."
        override val propertyCityRequired: String = "A cidade é necessária."
        override val propertyRegionRequired: String = "A região é necessária."
        override val propertyPostalRequired: String = "É necessário o código postal."
        override val propertyAskingPriceInvalid: String = "Digite um preço válido."
        override val propertyOwnerContactTitle: String = "Contacto do proprietário da propriedade"
        override val propertyOwnerSelectContact: String = "Selecione um contato existente como proprietário da propriedade."
        override val propertyOwnerSelected: String = "O proprietário seleccionado"
        override val propertyOwnerNoContacts: String = "Ainda não há contactos. Adicione o proprietário em Contatos e selecione-os aqui."
        override val propertyOwnerChooseContact: String = "Escolher contato"
        override val propertyOwnerChangeContact: String = "Alterar contato"
        override val propertyOwnerRemoveContact: String = "Remover"
        override val propertyOwnerPickerTitle: String = "Escolha o proprietário da propriedade"
        override val propertyOwnerSearchContact: String = "Pesquisar contatos"
        override val propertyOwnerSearchHint: String = "Comece a digitar um nome, e-mail ou número de telefone."
        override val propertyOwnerNoMatches: String = "Não há contactos iguais."
        override val propertyOpeningsTitle: String = "Visitas abertas"
        override val propertyNoOpenings: String = "Não há visitas abertas programadas para esta propriedade."
        override val teamAccessTitle: String = "Acesso à equipa"
        override val onlyListingOwner: String = "Apenas o proprietário da lista"
        override val assignTeam: String = "Atribuir equipa"
        override val assignPropertyTitle: String = "Atribuir propriedade"
        override val assignPropertyBody: String = "Escolha quem pode trabalhar esta propriedade. Selecione toda a equipe ou agentes específicos."
        override val wholeTeam: String = "Toda a equipa"
        override val leadsEyebrow: String = "Leads"
        override val leadFallback: String = "Lead"
        override val leadsSubtitle: String = "Pesquise, filtre e qualifique os leads recolhidos em todas as visitas abertas."
        override val leadDetailSubtitle: String = "Origem, qualificação, notas e histórico de acompanhamento deste lead."
        override val totalMetric: String = "Total"
        override val loggedMetric: String = "registado"
        override val searchLeads: String = "Pesquisar leads"
        override val searchLeadsPlaceholder: String = "Nome, telefone ou e-mail"
        override val allProperties: String = "Todas as propriedades"
        override val loadingLeads: String = "A carregar leads"
        override val loadingLeadDetails: String = "A carregar detalhes do lead"
        override val noLeadsFoundTitle: String = "Os leads aparecerão aqui quando os contactos fizerem check-in numa visita aberta."
        override val noLeadsEmptyBody: String = "Use o check-in do quiosque ou adicione contatos manualmente de uma visita aberta."
        override val noLeadsFilteredBody: String = "Tente uma propriedade diferente, status ou termo de pesquisa."
        override val backToLeads: String = "Voltar aos leads"
        override val leadUnavailableTitle: String = "Lead indisponível"
        override val leadUnavailableBody: String = "Este lead já não está disponível na lista atual."
        override val leadTemperature: String = "Estado do lead"
        override val leadLabelSuffix: String = "Lead"
        override val greetingHi: String = "Olá."
        override val leadActionCall: String = "Chamada"
        override val leadActionSms: String = "SMS"
        override val leadActionEmail: String = "E- mail"
        override val leadFollowUp: String = "Seguimento"
        override val leadNoFollowUpScheduled: String = "Sem acompanhamento agendado"
        override val leadIntentScore: String = "Pontuação de intenção"
        override val leadInterestedIn: String = "Interessado em"
        override val leadGenericGreetingName: String = "ali."
        override val followUpMessageTypeThankYou: String = "Obrigado."
        override val followUpMessageTypePropertyInfo: String = "Informação da propriedade"
        override val followUpMessageTypeFollowUp: String = "Acompanhamento"
        override val followUpMessageTypeCheckIn: String = "Registar"
        override val followUpMessageTypePriceUpdate: String = "Actualização de preços"
        override val followUpMessageTypePropertyBrochure: String = "Ficheiros"
        override val followUpPreview: String = "Antevisão"
        override val followUpSubject: String = "Assunto"
        override val followUpMessage: String = "Mensagem"
        override val followUpSendViaEmail: String = "Enviar por e- mail"
        override val followUpSendViaSms: String = "Enviar via SMS"
        override val followUpAiAssistantTitle: String = "Assistente de IA"
        override val followUpAiAssistantBody: String = "Gere uma mensagem personalizada em segundos."
        override val followUpGenerateWithAi: String = "Gerar com IA"
        override val followUpUpgradeForAi: String = "Atualizar para IA"
        override val followUpDefaultSubject: String = "Acompanhamento"
        override val privateAgentNotes: String = "Notas de agente privado"
        override val notes: String = "Notas"
        override val notesPlaceholder: String = "Motivação, preferências, objeções, próxima jogada"
        override val saveNotes: String = "Gravar as notas"
        override val followUpHistory: String = "Histórico de acompanhamento"
        override val noFollowUpsLogged: String = "Ainda não foi registado nenhum seguimento."
        override val openHousesEyebrow: String = "Mostrações"
        override val scheduleOpenHouse: String = "Criar visita aberta"
        override val openingDetails: String = "Abrir detalhes da Casa"
        override val editOpening: String = "Editar a visita aberta"
        override val deleteOpening: String = "Apagar a visita aberta"
        override val deleteOpeningBody: String = "Tens a certeza que queres apagar esta visita aberta? Isto não pode ser desfeito."
        override val removeLeadTitle: String = "Remover lead?"
        override val removeLeadBody: String = "Remover %s desta visita aberta?"
        override val removeLeadFallback: String = "este lead"
        override val openingName: String = "Abrir o Nome da Casa"
        override val startsAt: String = "Inicia em"
        override val endsAt: String = "Termina em"
        override val chooseStartDateTime: String = "Escolha a data e hora de início"
        override val chooseEndDateTime: String = "Escolha a data e hora do fim"
        override val accessNotes: String = "Notas de acesso"
        override val privateNotes: String = "Notas privadas"
        override val addPrivateNote: String = "Adicionar nota privada"
        override val liveDashboard: String = "Painel ao vivo"
        override val visitorKiosk: String = "Quiosque de lead"
        override val openHousesSubtitle: String = "Crie visitas abertas para propriedades, reveja leads e inicie sessões de quiosque."
        override val liveMetric: String = "Vivo"
        override val upcomingMetric: String = "Próximo"
        override val inProgressMetric: String = "em curso"
        override val scheduledMetric: String = "agendado"
        override val loadingOpenHouses: String = "Carregando visitas abertas"
        override val addPropertyFirstTitle: String = "Adicionar uma propriedade primeiro"
        override val addPropertyFirstBody: String = "Crie uma visita aberta de uma propriedade para começar a coletar leads."
        override val noOpenHousesTitle: String = "Nenhuma visita aberta programada"
        override val noOpenHousesBody: String = "Crie uma visita aberta de uma propriedade para começar a coletar leads."
        override val noSignInsTitle: String = "Nenhum sinal ainda"
        override val noSignInsBody: String = "Os leads verificados através do modo quiosque aparecerão aqui em tempo real."
        override val dashboard: String = "Painel"
        override val start: String = "Iniciar"
        override val end: String = "Fim"
        override val endOpenHouse: String = "Fim da abertura da casa"
        override val reportsEyebrow: String = "Dono"
        override val sellerReportsTitle: String = "Relatórios do vendedor"
        override val createReport: String = "Criar relatório"
        override val reportPreview: String = "Relatório do Vendedor"
        override val reportsSubtitle: String = "Crie recaps post-open-house premium com qualidade de lead, intenção de comprador e narrativa pronta para vendedor."
        override val reportsMetricSaved: String = "salvo"
        override val reportedMetric: String = "notificado"
        override val leadsMetric: String = "pistas"
        override val createSellerReport: String = "Criar relatório"
        override val attendance: String = "Presença"
        override val savedReports: String = "relatórios salvos"
        override val buyerHeat: String = "Calor do comprador"
        override val hotLeads: String = "Pontas quentes"
        override val loadingSellerReports: String = "Carregando relatórios de vendedores"
        override val noSellerReportsTitle: String = "Nenhum relatório de vendedor ainda"
        override val noSellerReportsBody: String = "Escolha uma visita aberta, adicione notas de agente, visualize uma recap pronta para exportação e salve-a."
        override val chooseOpenHouse: String = "Escolha a visita aberta"
        override val noOpenHousesAvailable: String = "Ainda não há visitas abertas."
        override val agentNotes: String = "Notas do agente"
        override val notesForSeller: String = "Notas relativas ao vendedor"
        override val sellerNotesPlaceholder: String = "Objeções do comprador, sinais de preços, mostrando feedback, recomendado próximo movimento"
        override val generatePreview: String = "Gerar a antevisão"
        override val noPreviewReadyTitle: String = "Nenhuma antevisão pronta"
        override val noPreviewReadyBody: String = "Gerar uma antevisão do relatório do vendedor antes de gravar."
        override val saveReport: String = "Salvar relatório"
        override val reportSaved: String = "Relatório salvo"
        override val sellerOpenHouseReport: String = "Relatório de venda de visita aberta"
        override val mostCommonBuyerInterest: String = "Interesse do comprador mais comum"
        override val followUpsSent: String = "Acompanhamentos enviados"
        override val summary: String = "Resumo"
        override val noPrivateNotesAdded: String = "Nenhuma nota privada adicionada."
        override val openHouseReport: String = "Relatório do Open House"
        override val commonDraft: String = "Rascunho"
        override val commonAccepted: String = "Aceitado"
        override val searchSellerReports: String = "Relatórios do vendedor de pesquisa"
        override val noMatchingReports: String = "Sem relatórios correspondentes"
        override val clearFilters: String = "Limpar os filtros"
        override val tryDifferentSearchOrStatusFilter: String = "Tente um filtro de pesquisa ou estado diferente."
        override val connectedToProperty: String = "Ligado à propriedade"
        override val viewProperty: String = "Ver propriedade"
        override val dataRollup: String = "Enrolamento de dados"
        override val connectedOpenings: String = "Visitas abertas"
        override val visitors: String = "Visitantes"
        override val interestedBuyers: String = "Compradores interessados"
        override val completedFollowUps: String = "Acompanhamentos"
        override val reportHistory: String = "Relatar histórico"
        override val noPreviousReportsYet: String = "Ainda não há relatórios anteriores."
        override val viewAllReports: String = "Ver todos os relatórios"
        override val actions: String = "Acções"
        override val generatePdf: String = "Criar planilha"
        override val previewPdf: String = "Antevisão da planilha"
        override val pdfSavedToPropertyFiles: String = "%s salvos em arquivos de propriedade."
        override val pdfSavingToPropertyFiles: String = "%s está sendo salvo em arquivos de propriedade."
        override val pdfSavedToFiles: String = "%s gravado em arquivos."
        override val pdfSavingToFiles: String = "%s está sendo salvo em arquivos."
        override val pdfIncludesSellerReport: String = "A planilha inclui métricas do Seller Report, insights de IA, detalhes do agente, dados de propriedade e histórico de open house."
        override val pdfIncludesAnalytics: String = "A planilha inclui métricas de análise, propriedades de topo, desempenho do agente, canais de acompanhamento e insights de IA."
        override val pdfGenerateBeforeSending: String = "Crie a planilha antes de enviar."
        override val pdfUploadBeforeSharing: String = "A planilha deve terminar o upload antes de compartilhar."
        override val sellerReportPdfNeedsProperty: String = "A planilha Seller Report precisa de uma propriedade conectada antes do upload."
        override val deleteReport: String = "Apagar relatório"
        override val deleteReportBody: String = "Tem a certeza de que deseja apagar este relatório do vendedor? Isto não pode ser desfeito."
        override val shareReport: String = "Relatório de partilha"
        override val openingPropertyReportLoading: String = "Relatório de propriedade..."
        override val openingPropertyReportCreating: String = "Criando relatório de propriedade..."
        override val sellerReportGeneratedPrefix: String = "Relatório do vendedor gerado"
        override val sellerReportGeneratedSuffix: String = "de visitas abertas, visitantes, leads, follow-ups e feedback conectados a esta propriedade no momento do relatório."
        override val priceNotSet: String = "Preço não definido"
        override val daysSuffix: String = "dias"
        override val connectedOpeningSingular: String = "visita aberta"
        override val connectedOpeningPlural: String = "visitas abertas"
        override val connectedLeadSingular: String = "Lead ligado"
        override val connectedLeadPlural: String = "leads conectados"
        override val sellerConfidence: String = "Confiança do vendedor"
        override val sellerConfidenceExplanation: String = "Explicação da confiança"
        override val aiDraftReviewBeforeSending: String = "Apenas um rascunho de IA. Reveja e edite antes de enviar para o vendedor."
        override val executiveSummary: String = "Resumo"
        override val buyerInterestOverview: String = "Visão geral do interesse do comprador"
        override val whatBuyersLoved: String = "O que os compradores amavam"
        override val buyerConcerns: String = "Preocupações do comprador"
        override val leadQualitySummary: String = "Resumo da qualidade do lead"
        override val agentActivity: String = "Actividade do agente"
        override val aiRecommendations: String = "Recomendações de IA"
        override val recommendations: String = "Recomendações"
        override val marketPositionComparison: String = "Comparação da posição do mercado"
        override val nextSteps: String = "Próximas etapas"
        override val conversion: String = "Conversão"
        override val interested: String = "interessado"
        override val tourSignalsLowercase: String = "sinais turísticos"
        override val propertyTimeline: String = "Linha do tempo da propriedade"
        override val timelineBasisNote: String = "A linha do tempo é baseada apenas em registros e acompanhamentos conectados."
        override val visitorsLowercase: String = "visitantes"
        override val hotLeadsLowercase: String = "leads quentes"
        override val hotLowercase: String = "quente"
        override val sentiment: String = "Sentimento"
        override val toursLowercase: String = "passeios"
        override val interestedLowercase: String = "interessado"
        override val noRepeatedFeedbackMentions: String = "Ainda não foram registadas referências repetidas."
        override val scoresMentionRates: String = "Pontuações são taxas de menção em todo o feedback do comprador salvo."
        override val aiExecutiveBriefing: String = "Reunião executiva da IA"
        override val viewAllAiInsights: String = "Ver todos os insights de IA ->"
        override val followUpsSentTitle: String = "Acompanhamentos enviados"
        override val financingPacketsShared: String = "Financiamento dos Pacotes Partilhados"
        override val buyerCalls: String = "Chamadas de Compradores"
        override val propertyDataEvidence: String = "Dados de propriedade"
        override val attendanceCoverage: String = "Cobertura da presença"
        override val leadQuality: String = "Qualidade do lead"
        override val followUpExecution: String = "Execução posterior"
        override val activityChannels: String = "Canais de actividade"
        override val callsLowercase: String = "chamadas"
        override val emailsLowercase: String = "e- mail"
        override val offerReadinessScore: String = "Pontuação de prontidão da oferta"
        override val date: String = "Data"
        override val propertyLeadFunnel: String = "Funil de lead da propriedade"
        override val openHouseBreakdown: String = "Repartição da visita aberta"
        override val aiInsights: String = "AI Insights"
        override val generateAiInsights: String = "Gerar Insights de IA"
        override val analyticsOverview: String = "Visão geral da análise"
        override val allAgents: String = "Todos os agentes"
        override val me: String = "Eu."
        override val allActivity: String = "Todas as actividades"
        override val latest30Days: String = "Últimos 30 dias"
        override val latest7Days: String = "Últimos 7 dias"
        override val analyticsDatePreset: String = "Intervalo de datas"
        override val analyticsCustomDate: String = "Data personalizada"
        override val analyticsLastDay: String = "Último dia"
        override val analyticsLastWeek: String = "Semana passada"
        override val analyticsLastMonth: String = "No mês passado"
        override val analyticsLastYear: String = "Ano passado"
        override val analyticsAllTime: String = "Sempre."
        override val analyticsDateFrom: String = "Data de"
        override val analyticsDateTo: String = "Data a"
        override val analyticsOpenHousesLowercase: String = "visitas abertas"
        override val analyticsWarmLeadsLowercase: String = "cabos quentes"
        override val analyticsFromNotesFollowUps: String = ""
        override val analyticsFromText: String = "do texto"
        override val analyticsHotConversion: String = "Conversão a quente"
        override val analyticsHotLeadsPerVisitors: String = "leads / visitantes quentes"
        override val analyticsAverageIntent: String = "Avg. intention"
        override val analyticsVisitorIntentScore: String = "pontuação de intenção do visitante"
        override val analyticsSelectDate: String = "Selecionar data"
        override val propertyFunnel: String = "Funil de propriedade"
        override val propertyFunnelSubtitle: String = "Da atividade imobiliária ao momento de compra qualificado"
        override val properties: String = "Propriedades"
        override val tourSignals: String = "Sinais turísticos"
        override val offerSignals: String = "Oferecer sinais"
        override val viewFullFunnelReport: String = "Ver relatório completo do funil"
        override val performanceOverTime: String = "Desempenho ao longo do tempo"
        override val thirtyDays: String = "30 dias"
        override val topPerformingProperties: String = "Propriedades de desempenho de topo"
        override val viewAll: String = "Ver tudo"
        override val noPropertyAnalyticsYet: String = "Ainda não há análise de propriedades."
        override val leadQualityBreakdown: String = "Discriminação da qualidade do lead"
        override val warmLeadsTitle: String = "Lead quente"
        override val coldLeadsTitle: String = "Leads frios"
        override val followUpPerformance: String = "Desempenho de acompanhamento"
        override val agentPerformance: String = "Desempenho do agente"
        override val viewTeamReport: String = "Ver relatório da equipa"
        override val followUpChannels: String = "Canais de acompanhamento"
        override val viewReport: String = "Ver relatório"
        override val searchProperties: String = "Propriedades da pesquisa"
        override val searchOpenings: String = "Procurar visitas abertas"
        override val noOpeningsFoundTitle: String = "Nenhuma visita aberta encontrada"
        override val noOpeningsFoundBody: String = "Tente outro filtro de status de busca ou open house."
        override val noMatchingPropertiesTitle: String = "Sem propriedades correspondentes"
        override val noMatchingPropertiesBody: String = "Tente outro filtro de pesquisa ou status."
        override val clientsTitle: String = "Contactos"
        override val clientFallback: String = "Contacto"
        override val addClient: String = "Adicionar contato"
        override val editClient: String = "Editar contato"
        override val newClient: String = "Novo contacto"
        override val saveClient: String = "Gravar o contacto"
        override val createClient: String = "Criar contacto"
        override val deleteClientTitle: String = "Apagar o contacto?"
        override val deleteClientBody: String = "Isto apagará permanentemente o contacto. Isto não pode ser desfeito."
        override val firstName: String = "Nome próprio"
        override val lastName: String = "Sobrenome"
        override val email: String = "E- mail"
        override val phone: String = "Telefone"
        override val comments: String = "Observações"
        override val addPhoto: String = "Adicionar uma foto"
        override val sendQr: String = "Enviar QR"
        override val sendQrShareTitle: String = "A sua visita aberta HAVN QR"
        override val sendQrShareBody: String = "O seu HAVN está ligado. Adicione o passe da Carteira (.pkpass) ao telefone quando disponível ou mostre a imagem QR na visita aberta."
        override val sendQrReadyMessage: String = "Código QR pronto para enviar"
        override val sendQrUnavailableError: String = "Nenhum e-mail ou aplicativo SMS está disponível para este contato."
        override val clientQrDeliveryRequired: String = "Adicione um e-mail ou número de telefone para entrega QR."
        override val photo: String = "Foto"
        override val clientDetailSubtitle: String = "Identidade QR, detalhes de contato, comentários e visitas abertas conectadas através de leads."
        override val clientFormEditSubtitle: String = "Atualizar detalhes de contato, informações de entrega e comentários."
        override val clientFormNewSubtitle: String = "Registre um comprador/contato e gere uma identidade QR reutilizável para visitas abertas."
        override val searchClients: String = "Pesquisar contatos"
        override val noClientsYetTitle: String = "Sem contatos ainda"
        override val noClientsYetBody: String = "Registrar contatos primeiro, em seguida, enviar seu código QR por e-mail ou SMS antes de uma visita aberta."
        override val noClientsFoundTitle: String = "Nenhum contacto encontrado"
        override val noClientsFoundBody: String = "Tente outro nome, telefone ou e-mail."
        override val clientUnavailableTitle: String = "Contacto indisponível"
        override val clientUnavailableBody: String = "Atualizar a lista de contatos e abrir este registro novamente."
        override val noCommentsAdded: String = "Sem comentários adicionados."
        override val openingsTitle: String = "Visitas abertas"
        override val clientOpeningsEmpty: String = "Nenhuma visita aberta ainda. As pistas ligam um contacto a uma visita aberta."
        override val clientPassLabel: String = "Passagem da carteira"
        override val clientNoEmail: String = "Sem e- mail"
        override val visitorsBody: String = "Abra o modo quiosque, verifique um QR de contato ou adicione contatos existentes como leads para esta visita aberta."
        override val openKiosk: String = "Abrir o quiosque"
        override val addQrClient: String = "Adicionar contato QR"
        override val addManually: String = "Adicionar manualmente"
        override val selectClients: String = "Selecionar contatos"
        override val selectClientsBody: String = "Escolha contatos na sua lista. Cada contato selecionado torna-se uma liderança para esta visita aberta."
        override val kioskCheckIn: String = "Quiosque de check-in"
        override val kioskCheckInBody: String = "Use a câmera traseira para verificar a carteira de contato HAVN QR. Quando o código é reconhecido, HAVN cria o lead para esta visita aberta automaticamente."
        override val scanWithCamera: String = "Varrer com câmera traseira"
        override val clientQrImage: String = "Contacte a imagem QR"
        override val clientQrImageBody: String = "Mantenha o QR do contacto dentro do quadrado de ouro. HAVN coleta cada exame abaixo."
        override val scanMultipleQrBody: String = "Analise um ou mais códigos QR de contato HAVN e, em seguida, toque em Adicionar contato QR."
        override val scannedQrReady: String = "contato QR pronto para adicionar"
        override val createLeadFromQr: String = "Criar lead a partir do QR"
        override val noClientsFoundShort: String = "Nenhum contacto encontrado."
        override val remove: String = "Remover"
        override val tasksTitle: String = "Tarefas"
        override val addTask: String = "Adicionar tarefa"
        override val searchTasks: String = "Tarefas de pesquisa"
        override val loadMoreTasks: String = "Carregar mais tarefas"
        override val createTask: String = "Criar Tarefa"
        override val saveTask: String = "Salvar tarefa"
        override val editTask: String = "Editar tarefa"
        override val newTask: String = "Nova tarefa"
        override val taskDetails: String = "Detalhes da Tarefa"
        override val taskName: String = "Nome"
        override val taskDescription: String = "Designação das mercadorias"
        override val taskDueDateTime: String = "& Hora da tarefa"
        override val chooseTaskDateTime: String = "Escolha a data e hora da tarefa"
        override val clearTaskDateTime: String = "Limpar a & hora da data"
        override val assignToAgent: String = "Atribuir ao Agente"
        override val noAgencyAgentsFound: String = "Não foram encontrados agentes da agência. A tarefa permanecerá atribuída ao proprietário."
        override val taskPriority: String = "Prioridade da tarefa"
        override val taskStatus: String = "Estado"
        override val taskVisibility: String = "Visibilidade"
        override val taskOwner: String = "Dono"
        override val taskOwnerFallback: String = "Titular da tarefa"
        override val assignedTo: String = "Atribuído a"
        override val selectedAgent: String = "Agente selecionado"
        override val taskVisibilityBody: String = "Esta tarefa é visível para o proprietário e o agente atribuído."
        override val taskQueue: String = "Fila de tarefas"
        override val taskDetail: String = "Detalhes da tarefa"
        override val taskDetailEmpty: String = "Selecione uma tarefa para ver o contexto e as próximas ações."
        override val connectedContext: String = "Contexto Ligado"
        override val noTaskContext: String = "Nenhuma propriedade, contato, open house ou lead ainda está ligada."
        override val activityTimeline: String = "Prazo de Actividade"
        override val created: String = "Criado"
        override val recently: String = "Recentemente"
        override val completed: String = "Concluído"
        override val nextAction: String = "Próxima ação"
        override val agentReviewOrCompletion: String = "Revisão ou conclusão do agente"
        override val noDueDate: String = "Sem data de vencimento"
        override val reopen: String = "Abrir de novo"
        override val accept: String = "Aceitar"
        override val linkedTasks: String = "Tarefas ligadas"
        override val noLinkedTasks: String = "Nenhuma tarefa ligada ainda."
        override val filesTitle: String = "Ficheiros"
        override val attachFile: String = "Anexar arquivo"
        override val noFilesAttached: String = "Nenhum arquivo anexado ainda."
        override val fileLimitHint: String = "Os arquivos podem ser PDF, DOC, CAD ou outros formatos até 20 MB cada."
        override val deleteFileTitle: String = "Apagar o ficheiro?"
        override val deleteFileBody: String = "Este arquivo será removido do armazenamento HAVN."
        override val attachmentOpenFailed: String = "Não foi possível abrir este arquivo."
        override val attachmentDeleteOwnerOnly: String = "Somente o proprietário do arquivo pode excluir este anexo."
        override val attachmentDocumentsNotIncluded: String = "Seu plano atual não inclui uploads de arquivos. Atualize para carregar arquivos."
        override val attachmentDocumentStorageNotIncluded: String = "Seu plano atual não inclui armazenamento de documentos. Atualize para carregar arquivos."
        override val attachmentFileSizePlanLimit: String = "Este ficheiro é maior do que o seu plano actual permite. Atualize para enviar arquivos maiores."
        override val attachmentStoragePlanLimit: String = "Limite de armazenamento alcançado para o seu plano atual. Atualize para enviar mais arquivos."
        override val attachmentDocumentCountPlanLimit: String = "Limite de documento alcançado para esta propriedade em seu plano atual. Atualize para enviar mais arquivos."
        override val attachmentHardFileLimit: String = "Os anexos de arquivos são limitados a 100 MB."
        override val openFiles: String = "Abrir os Ficheiros"
        override val sendViaEmail: String = "Enviar por E- mail"
        override val sendViaSms: String = "Enviar via SMS"
        override val sendEmailHeader: String = "Enviar E- mail"
        override val sendSmsHeader: String = "Enviar SMS"
        override val noContactsFound: String = "Nenhum contacto encontrado."
        override val searchContacts: String = "Pesquisar contatos"
        override val linked: String = "Ligado"
        override val recent: String = "Recente"
        override val taskColumnToDo: String = "A Fazer"
        override val taskColumnInProgress: String = "Em Progresso"
        override val taskColumnDone: String = "Feito"
        override val taskColumnToDoSubtitle: String = "Novas tarefas e próximas ações esperando para ser iniciado."
        override val taskColumnInProgressSubtitle: String = "Trabalho atualmente propriedade de você ou da equipe."
        override val taskColumnDoneSubtitle: String = "Tarefas concluídas mantidas visíveis para a confiança da equipe."
        override val taskEmptyToDo: String = "Não há tarefas para fazer."
        override val taskEmptyInProgress: String = "Nada em progresso."
        override val taskEmptyDone: String = "Ainda não foram concluídas tarefas."
        override val taskKanbanEmptyToDo: String = "Nada à espera. Novos acompanhamentos e relatórios aparecerão aqui."
        override val taskKanbanEmptyInProgress: String = "Nenhum trabalho activo em curso."
        override val taskKanbanEmptyDone: String = "As tarefas concluídas irão parar aqui."
        override val taskEmptyBodyPrefix: String = "Criar uma tarefa ou mover outra tarefa para"
        override val taskEmptyBodySuffix: String = "."
        override val taskActionStart: String = "Iniciar"
        override val taskActionOverdue: String = "Excedente"
        override val taskActionCancel: String = "Cancelar"
        override val taskPriorityLow: String = "Baixo"
        override val taskPriorityMedium: String = "Médio"
        override val taskPriorityHigh: String = "Alta"
        override val taskPriorityUrgent: String = "Urgente"
        override val taskStatusOpen: String = "Abrir"
        override val taskStatusInProgress: String = "Em curso"
        override val taskStatusDone: String = "Feito"
        override val taskStatusOverdue: String = "Excedente"
        override val taskStatusCancelled: String = "Cancelado"
        override val aiSuggestedTasks: String = "Tarefas Sugeridas pela IA"
        override val noAiSuggestedTasks: String = "Ainda não há sugestões de IA. HAVN irá sugerir tarefas após visitas abertas e atividade de lead."
        override val taskFilterToday: String = "Hoje"
        override val taskFilterUpcoming: String = "Próximo"
        override val taskFilterOverdue: String = "Excedente"
        override val taskFilterCompleted: String = "Concluído"
        override val taskFilterAssignedToMe: String = "Atribuído a mim"
        override val taskFilterAiSuggested: String = "AI Sugerido"
        override val taskFilterEmptyToday: String = "Está livre por hoje."
        override val taskFilterEmptyUpcoming: String = "Não há próximas tarefas."
        override val taskFilterEmptyOverdue: String = "Nada de tarefas atrasadas."
        override val taskFilterEmptyCompleted: String = "Ainda não foram concluídas tarefas."
        override val taskFilterEmptyAssignedToMe: String = "Nenhuma tarefa atribuída a você."
        override val taskFilterEmptyAiSuggested: String = "Nenhuma IA aceita sugeriu tarefas ainda."
        override val taskSuggestionHotLeadTitlePrefix: String = "Acompanhamento com"
        override val taskSuggestionHotLeadTitleSuffix: String = "dentro de 2 horas."
        override val taskSuggestionHotLeadDescriptionPrefix: String = "Lead quente de"
        override val taskSuggestionHotLeadDescriptionSuffix: String = "Mantenha o impulso enquanto a intenção é fresca."
        override val taskSuggestionHotLeadReason: String = "Novo lead quente capturado."
        override val taskSuggestionSellerReportTitlePrefix: String = "Gerar o relatório do vendedor para"
        override val taskSuggestionSellerReportTitleSuffix: String = "."
        override val taskSuggestionSellerReportDescription: String = "Resumir o volume do visitante, pistas quentes, atividade de acompanhamento e sentimento do comprador."
        override val taskSuggestionSellerReportReason: String = "A visita aberta acabou."
        override val taskSuggestionReviewFollowUpTitlePrefix: String = "Rever e enviar"
        override val taskSuggestionReviewFollowUpTitleSuffix: String = "Seguimento."
        override val taskSuggestionReviewFollowUpReason: String = "O rascunho de acompanhamento ainda precisa de revisão do agente."
        override val taskSuggestionKioskTitle: String = "Prepare o modo quiosque e verifique as fotos da propriedade."
        override val taskSuggestionKioskDescription: String = "Confirme o fluxo de entrada, galeria e detalhes da visita aberta antes dos compradores chegarem."
        override val taskSuggestionKioskReason: String = "A visita aberta está marcada."
    }

    private val dutch: HavnStrings = object : HavnStrings {
        override val navToday: String = "Vandaag"
        override val navProperties: String = "Eigenschappen"
        override val navLeads: String = "Leads"
        override val navReports: String = "Verslagen"
        override val navTasks: String = "Taken"
        override val navAnalytics: String = "Analyse"
        override val navAgency: String = "Agentschap"
        override val navSettings: String = "Instellingen"
        override val navAuth: String = "Toegang tot agent"
        override val navOpenHouses: String = "Open huizen"
        override val navTours: String = "Open Huizen"
        override val navFollowUps: String = "Contacten"
        override val navFollow: String = "Contacten"
        override val back: String = "Terug"
        override val settingsEyebrow: String = "Account"
        override val settingsTitle: String = "Instellingen"
        override val settingsSubtitle: String = "Brokerage profiel, uitnodiging beleid, opslag emmers, en team rollen."
        override val agentProfileTitle: String = "Agentprofiel"
        override val agentPhoto: String = "Agent foto"
        override val uploading: String = "Uploaden..."
        override val saving: String = "Opslaan..."
        override val validAgentPhotoRequired: String = "Kies een geldige agentfoto."
        override val signOut: String = "Afmelden"
        override val signOutQuestion: String = "Afmelden?"
        override val signOutConfirmation: String = "Weet je zeker dat je je wilt afmelden bij HAVN?"
        override val deleteAccount: String = "Account verwijderen"
        override val deleteAccountQuestion: String = "Account verwijderen?"
        override val deleteAccountOpenPageBody: String = "Dit opent de pagina voor het verwijderen van het account verzoek."
        override val deleteAccountReviewTitle: String = "Een echt account gebruiken"
        override val deleteAccountReviewBody: String = "Deze app review account is beschermd zodat beoordelaars geen toegang verliezen tijdens het testen. Gebruik een echt testaccount om het verwijderen van een account te verifiëren."
        override val upgrade: String = "Upgrade"
        override val premiumThemesTitle: String = "Premiumthema's"
        override val premiumThemesUpgradePrompt: String = "Upgrade naar Pro om premium thema's te ontgrendelen."
        override val appearanceTitle: String = "Uiterlijk"
        override val appearanceBody: String = "Kies de licht- of donkere modus voor de webapp."
        override val previewComponents: String = "Voorbeeldcomponenten"
        override val themeShowcaseTitle: String = "Thema's"
        override val showcaseButtons: String = "Knoppen"
        override val showcasePrimaryAction: String = "Primaire actie"
        override val showcaseSecondaryAction: String = "Secundaire actie"
        override val showcaseGhostAction: String = "Spookactie"
        override val showcaseTextField: String = "Tekstveld"
        override val showcaseFocusedBorder: String = "Gerichte accentrand"
        override val showcaseSearchPreview: String = "Voorbeeld zoeken"
        override val showcaseOpeningCheckedIn: String = "Open Huis check-in vandaag"
        override val showcaseSentAt: String = "Verzonden om 10.30 uur."
        override val themeObsidianGoldName: String = "Obsidiaangoud"
        override val themeObsidianGoldDescription: String = "Luxe zwart, grafiet en warm goud."
        override val themeMidnightSapphireName: String = "Midnight Sapphire"
        override val themeMidnightSapphireDescription: String = "Diepe marine, saffier blauw en zilveren accenten."
        override val themeEmeraldEstateName: String = "Emerald Estate"
        override val themeEmeraldEstateDescription: String = "Donker smaragd, houtskool en champagne goud."
        override val themePlatinumStoneName: String = "Platinasteen"
        override val themePlatinumStoneDescription: String = "Steen grijs, platina en zacht wit."
        override val themeBordeauxNoirName: String = "Bordeaux Noir"
        override val themeBordeauxNoirDescription: String = "Donkere wijn, grafiet en koper accenten."
        override val commonChange: String = "Verschil"
        override val agentPlanTitle: String = "Agentplan"
        override val agentPlanBody: String = "Upgrade uw ervaring, kies het plan dat past bij hoe je het beste werkt."
        override val currentPlan: String = "Huidig plan"
        override val transferPlan: String = "Overdrachtsplan"
        override val transferPlanTitle: String = "Overdrachtsplan"
        override val transferPlanBody: String = "Verplaats dit abonnement naar een ander HAVN-account. Beide e-mailadressen moeten bevestigen met verificatiecodes."
        override val transferTargetEmail: String = "Nieuwe account e-mail"
        override val transferSendCodes: String = "Verzend verificatiecodes"
        override val transferCodesSentTitle: String = "Verzonden verificatiecodes"
        override val transferCodesSentBody: String = "We stuurden een code naar uw e-mail en een code naar de nieuwe account e-mail."
        override val transferYourCode: String = "rinsedevriescode"
        override val transferTargetCode: String = "Nieuwe rekeningcode"
        override val transferConfirm: String = "Overdrachtsplan"
        override val transferSuccessTitle: String = "Overgedragen plan"
        override val transferSuccessBody: String = "Het abonnement is nu verbonden met het nieuwe HAVN-account."
        override val restorePurchase: String = "Kopen herstellen"
        override val agencySettingsProBody: String = "Solo agentschap is standaard actief. Met Pro kunt u een gedeeld agentschap maken of selecteren."
        override val agencySettingsLockedBody: String = "Solo agentschap is actief. Agentschap wijzigingen ontgrendelen met Pro."
        override val soloAgency: String = "Solo-agentschap"
        override val defaultPrivateAgencyWorkspace: String = "Standaard particulier agentschap"
        override val noAgenciesAvailableYet: String = "Er zijn nog geen uitnodigingen of agentschappen van agentschappen beschikbaar."
        override val oneOwnedAgencyHint: String = "Uw bedrijf staat hierboven vermeld. Eén agent kan één agentschap bezitten."
        override val createAgency: String = "Agentschap aanmaken"
        override val createYourAgency: String = "Maak uw bureau"
        override val createAgencyBody: String = "Bouw je team, beheer samen onroerend goed en verbouw je bedrijf."
        override val agencyName: String = "Naam van het agentschap"
        override val agencyEmail: String = "Agentschap e-mail"
        override val logoOptional: String = "Logo (facultatief)"
        override val upgradeExperienceTitle: String = "Uw ervaring upgraden"
        override val upgradeExperienceSubtitle: String = "Start je eerste Open Huis gratis. Upgrade wanneer u meer aanbiedingen, open huizen en Pro workflows nodig."
        override val soloAgentPlan: String = "Soloagent"
        override val proAgentPlan: String = "Pro-agent"
        override val teamAgentPlan: String = "Team"
        override val soloBenefitActiveProperties: String = "Tot 100 actieve eigenschappen"
        override val soloBenefitAiFollowUps: String = "Follow-ups van AI (basis)"
        override val soloBenefitSellerReports: String = "Geen verkoper rapporten"
        override val soloBenefitPersonalOnly: String = "Alleen persoonlijk"
        override val proBenefitUnlimitedProperties: String = "Tot 10.000 eigenschappen"
        override val proBenefitUnlimitedAi: String = "10.000 AI-tekstverzoeken / maand"
        override val proBenefitAdvancedReports: String = "Geavanceerde verkooprapporten"
        override val proBenefitAgencyCreation: String = "Oprichting en beheer van het agentschap"
        override val proBenefitInviteAgents: String = "Agenten uitnodigen en samenwerken"
        override val proBenefitSharedLeads: String = "Gedeelde leads en teamworkflows"
        override val proBenefitAgencyBranding: String = "Agentschap branding"
        override val proBenefitAdvancedAnalytics: String = "Geavanceerde analyses"
        override val teamBenefitLargeLimits: String = "Teamschaallimieten"
        override val teamBenefitPrioritySupport: String = "E-mailondersteuning bij voorrang"
        override val teamBenefitDailyBackups: String = "Dagelijkse back-ups voor 7 dagen"
        override val teamBenefitLargeStorage: String = "10GB documentopslag"
        override val startFreeTrial7Day: String = "Nu inschrijven"
        override val restorePurchases: String = "Kopen herstellen"
        override val comparePlans: String = "Plannen vergelijken"
        override val startFreeTrial: String = "Plan kiezen"
        override val noCommitmentCancelAnytime: String = "Start je eerste Open Huis gratis. Upgrade wanneer je meer nodig hebt."
        override val monthly: String = "Maandelijks"
        override val yearly: String = "Jaarlijks"
        override val yearlySave20: String = "Jaarlijks"
        override val yearlySavings20: String = "Jaarlijks gefactureerd."
        override val perYear: String = "/ jaar"
        override val loadingPlans: String = "Plannen laden..."
        override val selectedPlanUnavailable: String = "Abonnementen zijn tijdelijk niet beschikbaar. Probeer het later opnieuw of neem contact op met ondersteuning."
        override val signInRequiredForPurchase: String = "Aanmelden voordat u een aankoop start."
        override val subscriptionDisclosureIos: String = "Auto-hernieuwbare abonnement. Betaling zal in rekening worden gebracht op uw Apple-account bij bevestiging van aankoop. Uw abonnement wordt automatisch verlengd tenzij ten minste 24 uur voor het einde van de huidige periode geannuleerd. Vernieuwing zal in rekening worden gebracht binnen 24 uur voor het einde van de huidige periode. U kunt uw abonnement beheren of annuleren in App Store-accountinstellingen."
        override val subscriptionDisclosureAndroid: String = "Auto-hernieuwbare abonnement via Google Play. U wordt elke factureringsperiode in rekening gebracht tenzij u annuleert. U kunt uw abonnement altijd beheren of annuleren in abonnementen op Google Play. De toegang blijft tot het einde van de betaalde periode."
        override val subscriptionDisclosureWeb: String = "Auto-hernieuwbare abonnement. U wordt elke factureringsperiode in rekening gebracht met behulp van uw gekozen betaalmethode, tenzij u deze annuleert. U kunt beheren of annuleren op elk moment van Billing instellingen. De toegang blijft tot het einde van de betaalde periode. Belastingen kunnen van toepassing zijn."
        override val subscriptionAgreementPrefix: String = "Door je in te schrijven, ga je akkoord met"
        override val subscriptionTermsOfUse: String = "Gebruiksvoorwaarden van HAVN"
        override val subscriptionAgreementAnd: String = "en"
        override val subscriptionPrivacyPolicy: String = "Privacybeleid."
        override val purchaseSuccessTitle: String = "Dank u voor uw aankoop"
        override val purchaseSuccessBody: String = "Uw HAVN-abonnement is actief en uw plan is klaar."
        override val restoreSuccessTitle: String = "Kopen herstellen"
        override val restoreSuccessBody: String = "Uw HAVN-abonnement is succesvol hersteld."
        override val purchaseCouldNotComplete: String = "De aankoop kon niet worden voltooid. Probeer het opnieuw of controleer uw App Store of Google Play-account."
        override val purchaseVerificationPending: String = "Your payment has not been confirmed yet. If you completed checkout, use Restore purchase to check again. You do not need to pay again."
        override val completeWebCheckout: String = "Complete payment in the checkout tab, then return here. Your access will update automatically once payment is confirmed."
        override val restoreCouldNotComplete: String = "Er is geen actief HAVN-abonnement gevonden voor deze winkelaccount."
        override val noActiveSubscriptionFound: String = "Er is geen actief HAVN-abonnement gevonden voor deze winkelaccount."
        override val compareActiveProperties: String = "Actieve eigenschappen"
        override val compareAiFollowUps: String = "Follow-ups van AI"
        override val compareSellerReports: String = "Verkopersverslagen"
        override val compareAdvancedAnalytics: String = "Geavanceerde analyses"
        override val compareAgencyCreation: String = "Oprichting van een agentschap"
        override val compareJoinAgencies: String = "Lid worden van agentschappen"
        override val compareInviteAgents: String = "Agenten uitnodigen"
        override val compareSharedLeads: String = "Gedeelde leads"
        override val compareAgencyBranding: String = "Agentschap branding"
        override val comparePrioritySupport: String = "Prioritaire steun"
        override val compareFeature: String = "Functie"
        override val compareFreePlan: String = "Vrij"
        override val compareValueYes: String = "Ja."
        override val compareValueNo: String = "Nee"
        override val comparePricePerMonthUser: String = "Prijs / Maand / Gebruiker"
        override val comparePricePerYearUser: String = "Prijs / Jaar / Gebruiker"
        override val compareMaxPropertiesOwner: String = "Max eigenschappen / eigenaar"
        override val compareMaxContactsOwner: String = "Max. contacten / eigenaar"
        override val compareMaxOpenHousesOwner: String = "Max open huizen / eigenaar"
        override val compareMaxLeadsOwner: String = "Max leads / eigenaar"
        override val compareMaxPhotosProperty: String = "Max. foto's per eigenschap"
        override val compareMaxDocumentsProperty: String = "Max. documenten per eigenschap"
        override val compareDocumentsStorage: String = "Documentenopslag"
        override val compareAgencyAgenda: String = "Agenda van het Agentschap"
        override val compareAiTextRequestsMonth: String = "AI tekst generatie verzoeken / maand"
        override val compareAnalytics: String = "Analyse"
        override val compareTasks: String = "Taken"
        override val compareDocumentsStorageOwner: String = "Documentenopslag / eigenaar"
        override val compareMaxFileSizeOwner: String = "Max bestandsgrootte / eigenaar"
        override val compareEmailSupport: String = "E-mailondersteuning"
        override val compareDailyBackups7Days: String = "Dagelijkse backups opgeslagen voor 7 dagen"
        override val compareKioskMode: String = "Kioskmodus"
        override val unlimited: String = "Onbeperkt"
        override val basic: String = "Basis"
        override val advanced: String = "Geavanceerd"
        override val perMonth: String = "/ maand"
        override val members: String = "leden"
        override val upgradeToProForAgencyTools: String = "Upgrade naar Pro om bureautools te gebruiken"
        override val languageTitle: String = "Taal"
        override val languageBody: String = "Kies de taal van de app voor dit apparaat."
        override val english: String = "Engels"
        override val slovak: String = "Slowaaks"
        override val unitsTitle: String = "Eenheden en valuta"
        override val unitsBody: String = "Kies hoe prijzen en eigenschappen in de app worden weergegeven."
        override val measurementSystemTitle: String = "Meting"
        override val metric: String = "Metrisch"
        override val imperial: String = "Keizerlijk"
        override val currencyTitle: String = "Valuta"
        override val notificationsTitle: String = "Kennisgevingen"
        override val notificationsBody: String = "Controle push waarschuwingen, rustige uren, en de soorten updates die HAVN kan verzenden."
        override val notificationSettings: String = "Notificatieinstellingen"
        override val notificationsSubtitle: String = "Alleen belangrijke updates, gefilterd door uw voorkeuren."
        override val quietHoursTitle: String = "Rustige uren"
        override val quietHoursBody: String = "HAVN slaat niet-kritische duwen over tijdens rustige uren. Facturering en rekeningkwesties blijven nog steeds beknopt."
        override val enableQuietHours: String = "Rustige uren inschakelen"
        override val quietHoursStart: String = "Begin"
        override val quietHoursEnd: String = "Einde"
        override val timezoneLabel: String = "Tijdzone"
        override val notificationTypesTitle: String = "Soorten kennisgevingen"
        override val notificationNewLeadCapturedTitle: String = "Nieuw gevangen lead"
        override val notificationNewLeadCapturedBody: String = "Wanneer een open huis of QR flow een lead vangt."
        override val notificationHotLeadTitle: String = "Lead gemarkeerd als heet"
        override val notificationHotLeadBody: String = "Alleen als een aanwijzing hoge intentie wordt."
        override val notificationOpeningStartsSoonTitle: String = "Open Huis begint binnenkort"
        override val notificationOpeningStartsSoonBody: String = "Een enkele herinnering 30 minuten voor de start."
        override val notificationOpeningSummaryReadyTitle: String = "Open Huis samenvatting klaar"
        override val notificationOpeningSummaryReadyBody: String = "Wanneer de samenvatting na het evenement klaar is."
        override val notificationSellerReportGeneratedTitle: String = "Verkopersrapport gegenereerd"
        override val notificationSellerReportGeneratedBody: String = "Wanneer een verkoper rapport is gemaakt."
        override val notificationAiFollowUpReadyTitle: String = "AI follow-up klaar"
        override val notificationAiFollowUpReadyBody: String = "Wanneer een follow-up ontwerp is klaar om te herzien."
        override val notificationAgentInvitedTitle: String = "Agent uitgenodigd voor agentschap"
        override val notificationAgentInvitedBody: String = "Uitnodigingen van het Agentschap en wijzigingen van het lidmaatschap."
        override val notificationLeadAssignedTitle: String = "Lead toegewezen aan u"
        override val notificationLeadAssignedBody: String = "Als een teamgenoot je een aanwijzing geeft."
        override val notificationLeadTransferredTitle: String = "Lead overgedragen aan u"
        override val notificationLeadTransferredBody: String = "Als de eigenaar van een aanwijzing naar jou toe gaat."
        override val notificationSubscriptionIssueTitle: String = "Abonnementsnummer"
        override val notificationSubscriptionIssueBody: String = "Vernieuwingsfouten en factureringsproblemen."
        override val kioskSecurityTitle: String = "Kioskbeveiliging"
        override val kioskSecurityBody: String = "Gebruik deze pincode om de kioskmodus te verlaten en terug te keren naar de agent-app."
        override val kioskPinLabel: String = "Kiosk PIN"
        override val mcpAccessTitle: String = "Toegang tot MCP"
        override val mcpAccessBody: String = "Bridge HAVN aan Claude, OpenAI, en andere MCP-klanten bij mcp.havnre.app. Beschikbaar op elk plan."
        override val mcpAuthorizationBearer: String = "Autorisatie: drager"
        override val mcpNoApiKeyCreated: String = "Geen API-sleutel aangemaakt"
        override val mcpNotUsedYet: String = "Nog niet gebruikt"
        override val mcpLastUsedPrefix: String = "Laatst gebruikt"
        override val mcpRevealApiKeyTitle: String = "API-sleutel onthullen"
        override val mcpRevealApiKeyBody: String = "De volledige sleutel wordt alleen weergegeven na het aanmaken of roteren."
        override val mcpCreateKey: String = "Sleutel aanmaken"
        override val mcpRotateKey: String = "Sleutel draaien"
        override val mcpRevokeKey: String = "Sleutel omkeren"
        override val mcpEndpointHint: String = "Gebruik eindpunt https://mcp.havnre.app/mcp met deze sleutel als de Bearer token."
        override val mcpUpgradeHint: String = "MCP toegang is beschikbaar op elk HAVN-plan."
        override val mcpUpgradePrompt: String = "MCP toegang is beschikbaar op elk HAVN-plan."
        override val mcpCopied: String = "gekopieerd"
        override val mcpCopy: String = "Kopiëren"
        override val mcpLoading: String = "Laden"
        override val kioskFeaturedProperty: String = "Aanbevolen eigenschap"
        override val kioskPrivateShowing: String = "Privé show"
        override val kioskLuxuryListing: String = "Luxe lijst"
        override val kioskFastCheckIn: String = "Snelle check-in"
        override val kioskExitContentDescription: String = "Kiosk afsluiten"
        override val kioskWelcome: String = "Verwelkoming"
        override val kioskGladHere: String = "We zijn blij dat je hier bent."
        override val kioskScanToCheckIn: String = "Scan om in te checken"
        override val kioskReceivePropertyDetails: String = "en ontvang details over de eigendommen"
        override val kioskOr: String = "Of"
        override val kioskStartCheckInManually: String = "Inchecken handmatig starten"
        override val kioskSecureInfo: String = "Uw informatie is veilig en zal nooit worden gedeeld."
        override val kioskExitTitle: String = "Kiosk afsluiten"
        override val kioskExitBody: String = "Voer de kiosk-pincode in om terug te keren naar de agent-app."
        override val kioskIncorrectPin: String = "Onjuiste PIN."
        override val kioskUnlock: String = "Ontgrendelen"
        override val kioskTellUsTitle: String = "Vertel ons over jezelf."
        override val kioskTellUsBody: String = "Je informatie gaat alleen naar de hosting agent."
        override val kioskFullName: String = "Volledige naam"
        override val kioskContinue: String = "Doorgaan"
        override val kioskQuestionsTitle: String = "Een paar korte vragen"
        override val kioskQuestionsBody: String = "Dit helpt de agent te volgen met de juiste context."
        override val kioskWorkingWithAgentQuestion: String = "Werk je met een agent?"
        override val kioskYes: String = "Ja."
        override val kioskNo: String = "Nee"
        override val kioskInterestQuestion: String = "Waar ben je in geïnteresseerd?"
        override val kioskInterestBuying: String = "Kopen"
        override val kioskInterestInvesting: String = "Investeren"
        override val kioskInterestBrowsing: String = "Gewoon aan het surfen"
        override val kioskInterestRelocating: String = "Verplaatsing"
        override val kioskFinish: String = "Afmaken"
        override val kioskThankYou: String = "Dank je."
        override val kioskEnjoyVisitPrefix: String = "Geniet van uw bezoek op"
        override val kioskResetAutomatically: String = "Deze kiosk wordt automatisch gereset."
        override val environmentTitle: String = "Milieu"
        override val environmentBody: String = "Verbindingsdetails zijn geconfigureerd voor deze build."
        override val secure: String = "Veilig"
        override val brokerageProfileTitle: String = "Brokerageprofiel"
        override val brokerageProfileBody: String = "Team branding, agent nodigt uit, en notificatie voorkeuren zullen hier wonen."
        override val logout: String = "Afmelden"
        override val languageChanged: String = "Taal gewijzigd"
        override val commonAdd: String = "Voeg toe"
        override val commonEdit: String = "Bewerken"
        override val commonDelete: String = "Verwijderen"
        override val commonCancel: String = "Annuleren"
        override val commonSave: String = "Opslaan"
        override val commonCreate: String = "Aanmaken"
        override val commonDismiss: String = "Ingetrokken"
        override val commonAll: String = "Alles"
        override val commonDone: String = "Klaar"
        override val commonSend: String = "Verzenden"
        override val commonTime: String = "Tijd"
        override val commonHour: String = "Uur"
        override val commonMinute: String = "Minuut"
        override val commonAgency: String = "Agentschap"
        override val commonSettings: String = "Instellingen"
        override val commonOpening: String = "Open Huis"
        override val commonPropertyName: String = "Eigenschap"
        override val commonToday: String = "Vandaag"
        override val agencyToolsAvailable: String = "Er zijn instrumenten van het Agentschap beschikbaar."
        override val agencySetupSubtitle: String = "Elk HAVN-account heeft een standaard bureau. Pro kunt u beheren uitnodigingen, gedeelde leads, en branding."
        override val agencyRecentActivity: String = "Recente activiteit"
        override val agencyActivityNewLead: String = "Nieuw lead toegevoegd"
        override val agencyActivityInvitationAccepted: String = "Agent uitnodiging geaccepteerd"
        override val agencyActivityAgentJoined: String = "Agent ging bij het agentschap."
        override val agencyActivitySellerReport: String = "Verkopersrapport aangemaakt"
        override val agencyWorkspaceTitle: String = "Agentschap"
        override val agencyWorkspaceBody: String = "Kies met welk agentschap je samenwerkt."
        override val agencySoloActiveTitle: String = "Solo agentschap is actief"
        override val agencyProRequiredTitle: String = "Pro plan vereist"
        override val agencyCreateOrAcceptInviteBody: String = "Maak uw agentschap aan of accepteer een uitnodiging om samen te werken met een ander agentschap."
        override val agencyProUnlockBody: String = "Agentschap verandert, nodigt uit, gedeelde leads, en gedeelde branding ontgrendelen met Pro."
        override val realEstate: String = "Onroerend goed"
        override val proAgency: String = "Agentschap"
        override val agencyBrandingTitle: String = "Agentschap branding"
        override val agencyBrandingBody: String = "Stel de naam en het logo in die getoond worden in de app, kiosk en teamweergaven."
        override val uploadLogo: String = "Logo uploaden"
        override val saveAgency: String = "Agentschap opslaan"
        override val yourAgencyRole: String = "Uw rol als agentschap"
        override val agencyAgentsTitle: String = "Agentschappen"
        override val agencyAgentsBody: String = "Mensen die voor dit agentschap in aanmerking komen."
        override val inviteAgent: String = "Agent uitnodigen"
        override val loadingAgents: String = "Laden van agenten..."
        override val noAgencyAgentsYet: String = "Nog geen agentes."
        override val changeRole: String = "Wijzigingsrol"
        override val updating: String = "Bijwerken..."
        override val deleting: String = "Verwijderen..."
        override val deleteInvite: String = "Uitnodiging annuleren"
        override val chooseAgencyRoleFor: String = "Kies de rol van het agentschap voor"
        override val removeAccess: String = "Toegang verwijderen"
        override val inviteAgentBody: String = "Stuur een uitnodiging per e-mail. De agent accepteert na het aanmelden met dezelfde e-mail."
        override val agentEmail: String = "Agent e-mail"
        override val role: String = "Rol"
        override val inviting: String = "Uitnodigen ..."
        override val invite: String = "Uitnodigen"
        override val agents: String = "Middelen"
        override val ok: String = "Goed."
        override val personalActivePropertyLimit: String = "Maximale persoonlijke actieve eigenschap"
        override val personalAccountAgencyToolsLocked: String = "Persoonlijke account is actief. Agentschap gereedschap ontgrendelen met Pro."
        override val selected: String = "Geselecteerd"
        override val activeMembers: String = "actieve leden"
        override val agencySharedWorkspaceBody: String = "Gedeelde eigendommen, contacten, open huizen, leads, follow-ups en rapporten gebruiken dit agentschap."
        override val actLikeAgent: String = "Gedraag je als agent."
        override val actAsAdmin: String = "Handelen als beheerder"
        override val actAsOwner: String = "Handelen als eigenaar"
        override val actLikeAgentBody: String = "Gebruik het agentschap als een normale agent."
        override val actLikeAgentSelectedBody: String = "Alleen toegewezen of eigen werk wordt getoond."
        override val agencyRoleOwner: String = "Eigenaar"
        override val agencyRoleAdmin: String = "Beheerder"
        override val agencyRoleAgent: String = "Agent"
        override val agencyRoleAssistant: String = "Assistent"
        override val agencyRoleViewer: String = "Viewer"
        override val agencyRoleOwnerDescription: String = "Volledige bureaucontrole, inclusief leden, branding, opdrachten, lijsten, leads en rapporten."
        override val agencyRoleAdminDescription: String = "Volledig beheer van het agentschap, behalve het verwijderen van het agentschap."
        override val agencyRoleAgentDescription: String = "Werkt toegewezen lijsten, open huizen, leads, follow-ups, notities, en verkoper rapporten."
        override val agencyRoleAssistantDescription: String = "Ondersteunt toegewezen lijsten door het bewerken van leads, het voorbereiden van follow-ups, en het opstellen van rapporten."
        override val agencyRoleViewerDescription: String = "Alleen-lezen toegang tot dashboards en rapporten."
        override val agencyCapabilityInviteRemoveMembers: String = "Leden uitnodigen en verwijderen"
        override val agencyCapabilityChangeRoles: String = "Rol van leden wijzigen"
        override val agencyCapabilityManageAllProperties: String = "Alle eigenschappen aanmaken, bewerken en verwijderen"
        override val agencyCapabilityAssignAgents: String = "Opdrachtgevers"
        override val agencyCapabilitySeeAllLeads: String = "Alle aanwijzingen bekijken"
        override val agencyCapabilityExportReports: String = "Uitvoerverslagen"
        override val agencyCapabilityChangeBranding: String = "Branding en instellingen wijzigen"
        override val agencyCapabilityDeleteAgency: String = "Agentschap verwijderen"
        override val agencyCapabilityViewAssignedProperties: String = "Bekijk toegewezen eigenschappen"
        override val agencyCapabilityHostAssignedOpenings: String = "Host toegewezen open huizen"
        override val agencyCapabilitySeeAssignedLeads: String = "Zie leads van toegewezen woningen en open huizen"
        override val agencyCapabilityAddNotes: String = "Opmerkingen toevoegen"
        override val agencyCapabilitySendFollowUps: String = "Follow-up sturen"
        override val agencyCapabilityCreateSellerReports: String = "Maak verkoper rapporten voor toegewezen lijsten"
        override val agencyCapabilityEditAssignedLeads: String = "Toegewezen aanwijzingen bewerken"
        override val agencyCapabilityPrepareFollowUps: String = "Opvolging voorbereiden"
        override val agencyCapabilityCreateDraftReports: String = "Ontwerpverslagen maken"
        override val agencyCapabilityCannotDeleteProperties: String = "Kan eigenschappen niet verwijderen"
        override val agencyCapabilityCannotInviteAgents: String = "Kan geen agenten uitnodigen tenzij toegestaan"
        override val agencyCapabilityViewDashboards: String = "Dashboards tonen"
        override val agencyCapabilityViewReports: String = "Verslagen bekijken"
        override val agencyCapabilityCannotEdit: String = "Kan niets bewerken"
        override val commonVisitors: String = "Lead"
        override val commonHot: String = "Heet"
        override val commonWarm: String = "Warm"
        override val commonCold: String = "Koud"
        override val commonActive: String = "Actief"
        override val commonPlanned: String = "Gepland"
        override val commonArchived: String = "Gearchiveerd"
        override val commonPast: String = "Verleden"
        override val commonFollowUps: String = "Follow-up"
        override val commonProperty: String = "Eigenschap"
        override val commonAddress: String = "Adres"
        override val commonOpenHouse: String = "Open Huis"
        override val commonInquiry: String = "Onderzoek"
        override val commonInquiries: String = "Onderzoeken"
        override val generalInquiry: String = "Algemene aanvraag"
        override val generalInquiries: String = "Algemene aanvragen"
        override val propertyInquiry: String = "Woningaanvraag"
        override val propertyInquiries: String = "Woningaanvragen"
        override val addGeneralInquiry: String = "Algemene aanvraag toevoegen"
        override val newGeneralInquiry: String = "Nieuwe algemene aanvraag"
        override val noGeneralInquiries: String = "Nog geen algemene aanvragen."
        override val noPropertyInquiries: String = "Nog geen woningaanvragen."
        override val buyerLookingFor: String = "Waar is deze koper naar op zoek?"
        override val locationCity: String = "Locatie / stad"
        override val radiusKm: String = "Straal (km)"
        override val propertyType: String = "Type woning"
        override val budgetFrom: String = "Budget vanaf"
        override val budgetTo: String = "Budget tot"
        override val purchaseTimeline: String = "Aankooptermijn"
        override val createGeneralInquiry: String = "Algemene aanvraag maken"
        override val saveGeneralInquiry: String = "Algemene aanvraag opslaan"
        override val inquiryType: String = "Type aanvraag"
        override val leadSource: String = "Leadbron"
        override val notSpecified: String = "Niet opgegeven"
        override val inquiryStatus: String = "Status van het onderzoek"
        override val inquiryFollowUp: String = "Follow-up van het onderzoek"
        override val addInquiry: String = "Onderzoek toevoegen"
        override val searchInquiries: String = "Onderzoek"
        override val noInquiries: String = "Geen onderzoek"
        override val noInquiriesBody: String = "Gebruik de plus-knop om koper rente toe te voegen van een bestaand contact."
        override val inquiryUnavailableTitle: String = "Onderzoek niet beschikbaar"
        override val inquiryUnavailableBody: String = "Dit onderzoek kan zijn verwijderd of wordt nog steeds geladen."
        override val backToInquiries: String = "Terug naar de onderzoeken"
        override val deleteInquiry: String = "Onderzoek verwijderen"
        override val deleteInquiryQuestionPrefix: String = "Verwijderen"
        override val deleteInquiryQuestionSuffix: String = "Van dit pand?"
        override val deleteInquiryTargetFallback: String = "Dit onderzoek"
        override val propertyInquiriesBody: String = "Volg kopers die naar dit pand vroegen. Ook in Leads komen onderzoeken voor."
        override val propertyInquiriesEmpty: String = "Voeg een onderzoek toe door een van uw contacten te kiezen."
        override val contactInquiriesBody: String = "Eigenschappen waarover dit contact heeft gevraagd."
        override val contactInquiriesEmpty: String = "Nog geen huiszoekingen."
        override val viewInquiries: String = "Bekijk onderzoeken"
        override val createContactFirstForInquiry: String = "Maak eerst een contact, voeg dan het onderzoek van deze eigenschap."
        override val commonCheckedIn: String = "Ingecheckt"
        override val commonNotScheduled: String = "niet gepland"
        override val todayTitle: String = "Vandaag"
        override val todaySubtitle: String = "Uw dagelijkse huis voor open huizen, leads, follow-ups, en verkoper-ready momentum."
        override val todayOpenHousesMetric: String = "open huizen"
        override val capturedMetric: String = "gevangen"
        override val priorityMetric: String = "prioriteit"
        override val noActivePropertiesTitle: String = "Geen actieve eigenschappen"
        override val noActivePropertiesBody: String = "Voeg een eigenschap toe of activeer het om het te laten verschijnen op Vandaag."
        override val checkIns: String = "Check-ins"
        override val allOpenHouses: String = "alle open huizen"
        override val pendingDrafts: String = "in behandeling zijnde ontwerpen"
        override val priorityLead: String = "Prioriteit"
        override val nextOpenHouseAt: String = "Volgende open huis op"
        override val noOpenHouseScheduled: String = "Geen open huis gepland"
        override val personalAccount: String = "Persoonlijke rekening"
        override val accountReady: String = "Uw account is klaar"
        override val realEstateApp: String = "Onroerend goed app"
        override val needHelp: String = "Hulp nodig?"
        override val contactSupport: String = "Contact ondersteuning"
        override val upgradePlan: String = "Upgradeplan"
        override val planSuffix: String = "Plan"
        override val todayActionsTitle: String = "De prioriteiten van vandaag"
        override val agencyInvitation: String = "Uitnodiging van het Agentschap"
        override val joinAgency: String = "Sluiten"
        override val youWereInvitedAs: String = "U bent uitgenodigd als"
        override val invitedBy: String = "door"
        override val decline: String = "Afwijzen"
        override val yourDefaultAgency: String = "Uw standaard bureau"
        override val chooseAgencyBody: String = "Kies met welk bureau je wilt werken. Agentschap tools omvatten uitnodigingen, gedeelde leads, en branding."
        override val agencyMembersSuffix: String = "leden"
        override val quickActionTasksBody: String = "Wachtrij"
        override val quickActionReportsBody: String = "Verkoper"
        override val quickActionAnalyticsBody: String = "Trends"
        override val quickActionAddPropertyTitle: String = "Voeg toe"
        override val quickActionAddPropertyBody: String = "Lijst"
        override val quickActionAddContactTitle: String = "Contactpersoon"
        override val quickActionAddContactBody: String = "Nieuw"
        override val quickActionFilesTitle: String = "Bestanden"
        override val quickActionFilesBody: String = "Documenten"
        override val firstRunStepsTitle: String = "Begin met vier eenvoudige stappen"
        override val firstRunAddProperty: String = "Eigenschap toevoegen"
        override val firstRunScheduleOpening: String = "Plan open huis"
        override val firstRunStartGuestCheckIn: String = "Start gasten check-in"
        override val firstRunSendFollowUp: String = "Stuur follow-up"
        override val greetingNamePrefix: String = "Hoi."
        override val greetingAgent: String = "Hallo, agent."
        override val createListing: String = "Lijst aanmaken"
        override val newOwnerBuyer: String = "Nieuwe eigenaar/koper"
        override val documents: String = "Documenten"
        override val whatOpeningNext: String = "Wat is het volgende open huis?"
        override val whoCheckedIn: String = "Wie heeft zich gemeld?"
        override val whoNeedsFollowUp: String = "Wie heeft follow-up nodig?"
        override val whatShouldIDoNow: String = "Wat moet ik nu doen?"
        override val noCheckInsYet: String = "Er zijn nog geen contacten ingecheckt."
        override val noPendingFollowUps: String = "Geen lopende follow-up nu."
        override val openKioskForNextOpening: String = "Open de kiosk voor de volgende open huis."
        override val reviewNewLeads: String = "Bekijk nieuwe leads en stuur vervolgacties."
        override val createOpeningToStart: String = "Maak een open huis van een woning om te beginnen met het verzamelen van leads."
        override val addFirstPropertyToStart: String = "Voeg uw eerste eigendom toe om te beginnen."
        override val nextOpening: String = "Volgende open huis"
        override val quickSignIn: String = "Snel aanmelden"
        override val scanQrCode: String = "Scan QR-code"
        override val newLead: String = "Nieuwe aanwijzing"
        override val myProperties: String = "Mijn eigendommen"
        override val manageListings: String = "Lijsten beheren"
        override val todaysOverview: String = "Overzicht van vandaag"
        override val seeAll: String = "Alles zien"
        override val propertiesEyebrow: String = "Portfólio"
        override val propertiesSubtitle: String = "Beheer actieve, geplande en gearchiveerde lijsten met vermelding van media, kopersactiviteiten en prestatie-inzichten."
        override val propertiesLiveMetric: String = "levend"
        override val propertiesPipelineMetric: String = "pijpleiding"
        override val propertiesAllTimeMetric: String = "alle tijden"
        override val addProperty: String = "Eigenschap toevoegen"
        override val editProperty: String = "Eigenschap bewerken"
        override val propertyFallback: String = "Eigenschap"
        override val propertyUnavailableTitle: String = "Eigenschap niet beschikbaar"
        override val propertyUnavailableBody: String = "Vernieuw de portfolio om deze lijst te herladen."
        override val backToProperties: String = "Terug naar eigenschappen"
        override val deletePropertyTitle: String = "Eigenschap verwijderen?"
        override val deletePropertyBody: String = "Dit zal de eigenschap en de bijbehorende lokale gegevens permanent verwijderen. Dit kan niet ongedaan worden gemaakt."
        override val loadingProperties: String = "Laden van eigenschappen"
        override val loadMore: String = "Meer laden"
        override val loadingPropertyDetails: String = "Eigenschappen laden"
        override val noPropertiesTitle: String = "Nog geen eigenschappen"
        override val noPropertiesBody: String = "Voeg uw eerste woning, maak dan een open huis te beginnen met het verzamelen van leads en verkoper-ready feedback."
        override val openHouseButton: String = "Open huis aanmaken"
        override val photosTitle: String = "Foto's"
        override val photosBody: String = "De eerste foto wordt gebruikt als de belangrijkste eigenschap afbeelding in Portfolio."
        override val uploadPhoto: String = "Foto uploaden"
        override val noPhotosYet: String = "Nog geen foto's geüpload."
        override val propertyPhotoCountPlanLimit: String = "Fotolimiet bereikt voor deze eigenschap op uw huidige plan. Upgrade om meer foto's te uploaden."
        override val propertyPhotoStoragePlanLimit: String = "Opslaglimiet bereikt voor uw huidige plan. Upgrade om meer foto's of bestanden te uploaden."
        override val mainPhoto: String = "Hoofd"
        override val propertyTitleLabel: String = "Eigenschap"
        override val propertyAddressLine1Label: String = "Adres"
        override val propertyAddressLine2Label: String = "Adresregel 2"
        override val propertyCityLabel: String = "Stad"
        override val propertyRegionLabel: String = "Gebieden"
        override val propertyPostalCodeLabel: String = "Postcode"
        override val propertyCountryLabel: String = "Land"
        override val propertyAskingPriceLabel: String = "Vraagprijs"
        override val propertyBedsLabel: String = "bedden"
        override val propertyBathsLabel: String = "Badkuipen"
        override val propertyInteriorLabel: String = "Binnenlands"
        override val propertyDescriptionLabel: String = "Omschrijving"
        override val createPropertyButton: String = "+ Eigenschap"
        override val locateProperty: String = "Eigenschap zoeken"
        override val findLocation: String = "Locatie zoeken"
        override val find: String = "Zoeken"
        override val navigate: String = "Navigeren"
        override val propertyLocationMarkerTitle: String = "Locatie van eigendom"
        override val mapKitJsMissingToken: String = "HAVN MAPKIT JS TOKEN toevoegen aan local.properties voor de webmap."
        override val mapKitJsLoading: String = "MapKit JS wordt geladen..."
        override val generateSellerReport: String = "Verkopersrapport genereren"
        override val deleteProperty: String = "Eigenschap verwijderen"
        override val conversionMetric: String = "Omrekening"
        override val propertyPhotoContentDescription: String = "Eigenschap foto"
        override val deletePhoto: String = "Foto verwijderen"
        override val movePhotoLeft: String = "Foto naar links verplaatsen"
        override val movePhotoRight: String = "Foto naar rechts verplaatsen"
        override val propertyTitleRequired: String = "Eigendomsnaam is vereist."
        override val propertyStreetRequired: String = "Straatadres is vereist."
        override val propertyCityRequired: String = "Stad is vereist."
        override val propertyRegionRequired: String = "Regio is vereist."
        override val propertyPostalRequired: String = "Postcode is vereist."
        override val propertyAskingPriceInvalid: String = "Voer een geldige vraagprijs in."
        override val propertyOwnerContactTitle: String = "Contactpersoon eigenaar"
        override val propertyOwnerSelectContact: String = "Selecteer een bestaand contact als eigenaar."
        override val propertyOwnerSelected: String = "Geselecteerde eigenaar"
        override val propertyOwnerNoContacts: String = "Nog geen contacten. Voeg de eigenaar toe in Contacten en selecteer ze hier."
        override val propertyOwnerChooseContact: String = "Contact kiezen"
        override val propertyOwnerChangeContact: String = "Contact wijzigen"
        override val propertyOwnerRemoveContact: String = "Verwijderen"
        override val propertyOwnerPickerTitle: String = "Kies eigenaar van de woning"
        override val propertyOwnerSearchContact: String = "Contacten zoeken"
        override val propertyOwnerSearchHint: String = "Begin met het typen van een naam, e-mail of telefoonnummer."
        override val propertyOwnerNoMatches: String = "Geen overeenkomende contacten."
        override val propertyOpeningsTitle: String = "Open Huizen"
        override val propertyNoOpenings: String = "Geen open huizen gepland voor dit pand."
        override val teamAccessTitle: String = "Toegang tot het team"
        override val onlyListingOwner: String = "Alleen de eigenaar van de lijst"
        override val assignTeam: String = "Team toewijzen"
        override val assignPropertyTitle: String = "Eigenschap toewijzen"
        override val assignPropertyBody: String = "Kies wie deze eigenschap kan gebruiken. Selecteer het hele team of specifieke agenten."
        override val wholeTeam: String = "Hele team"
        override val leadsEyebrow: String = "Leads"
        override val leadFallback: String = "Lead"
        override val leadsSubtitle: String = "Zoek, filter en kwalificeer leads die tijdens open huizen zijn verzameld."
        override val leadDetailSubtitle: String = "Bron, kwalificatie, notities en opvolggeschiedenis van deze lead."
        override val totalMetric: String = "Totaal"
        override val loggedMetric: String = "aangemeld"
        override val searchLeads: String = "Leads zoeken"
        override val searchLeadsPlaceholder: String = "Naam, telefoon of e-mail"
        override val allProperties: String = "Alle eigenschappen"
        override val loadingLeads: String = "Leads laden"
        override val loadingLeadDetails: String = "Leadgegevens laden"
        override val noLeadsFoundTitle: String = "Leads verschijnen hier wanneer contacten inchecken bij een open huis."
        override val noLeadsEmptyBody: String = "Gebruik kiosk check-in of voeg contacten handmatig toe vanuit een open huis."
        override val noLeadsFilteredBody: String = "Probeer een andere eigenschap, status of zoekterm."
        override val backToLeads: String = "Terug naar leads"
        override val leadUnavailableTitle: String = "Lead niet beschikbaar"
        override val leadUnavailableBody: String = "Deze lead staat niet meer in de huidige leadlijst."
        override val leadTemperature: String = "Leadstatus"
        override val leadLabelSuffix: String = "Lead"
        override val greetingHi: String = "Hoi."
        override val leadActionCall: String = "Oproep"
        override val leadActionSms: String = "SMS"
        override val leadActionEmail: String = "E-mail"
        override val leadFollowUp: String = "Follow-up"
        override val leadNoFollowUpScheduled: String = "Geen follow-up gepland"
        override val leadIntentScore: String = "Intent score"
        override val leadInterestedIn: String = "Interesse in"
        override val leadGenericGreetingName: String = "daar"
        override val followUpMessageTypeThankYou: String = "Dank je."
        override val followUpMessageTypePropertyInfo: String = "Eigenschap info"
        override val followUpMessageTypeFollowUp: String = "Follow-up"
        override val followUpMessageTypeCheckIn: String = "Check in"
        override val followUpMessageTypePriceUpdate: String = "Prijsupdate"
        override val followUpMessageTypePropertyBrochure: String = "Bestanden"
        override val followUpPreview: String = "Voorbeeld"
        override val followUpSubject: String = "Onderwerp"
        override val followUpMessage: String = "Bericht"
        override val followUpSendViaEmail: String = "Verzenden via e-mail"
        override val followUpSendViaSms: String = "Verzenden via SMS"
        override val followUpAiAssistantTitle: String = "AI assistent"
        override val followUpAiAssistantBody: String = "Genereer een gepersonaliseerd bericht in seconden."
        override val followUpGenerateWithAi: String = "Genereren met AI"
        override val followUpUpgradeForAi: String = "Upgrade voor AI"
        override val followUpDefaultSubject: String = "Follow-up"
        override val privateAgentNotes: String = "Opmerkingen van privéagent"
        override val notes: String = "Opmerkingen"
        override val notesPlaceholder: String = "Motivatie, voorkeuren, bezwaren, volgende zet"
        override val saveNotes: String = "Notities opslaan"
        override val followUpHistory: String = "Follow-upgeschiedenis"
        override val noFollowUpsLogged: String = "Nog geen follow-ups geregistreerd."
        override val openHousesEyebrow: String = "Toont"
        override val scheduleOpenHouse: String = "Open huis aanmaken"
        override val openingDetails: String = "Open House details"
        override val editOpening: String = "Open huis bewerken"
        override val deleteOpening: String = "Open huis verwijderen"
        override val deleteOpeningBody: String = "Weet u zeker dat u deze open huis wilt verwijderen? Dit kan niet ongedaan worden gemaakt."
        override val removeLeadTitle: String = "Lead verwijderen?"
        override val removeLeadBody: String = "%s uit dit open huis verwijderen?"
        override val removeLeadFallback: String = "dit lead"
        override val openingName: String = "Open Huisnaam"
        override val startsAt: String = "Begint bij"
        override val endsAt: String = "eindigt op"
        override val chooseStartDateTime: String = "Kies begindatum en -tijd"
        override val chooseEndDateTime: String = "Kies einddatum en tijd"
        override val accessNotes: String = "Toegangsnotities"
        override val privateNotes: String = "Particuliere nota's"
        override val addPrivateNote: String = "Privénotitie toevoegen"
        override val liveDashboard: String = "Live dashboard"
        override val visitorKiosk: String = "Leadkiosk"
        override val openHousesSubtitle: String = "Maak open huizen voor woningen, review leads, en start kiosk sessies."
        override val liveMetric: String = "Levend"
        override val upcomingMetric: String = "Binnenkort"
        override val inProgressMetric: String = "lopende"
        override val scheduledMetric: String = "gepland"
        override val loadingOpenHouses: String = "Laden van open huizen"
        override val addPropertyFirstTitle: String = "Eerst een eigenschap toevoegen"
        override val addPropertyFirstBody: String = "Maak een open huis van een woning om te beginnen met het verzamelen van leads."
        override val noOpenHousesTitle: String = "Geen open huizen gepland"
        override val noOpenHousesBody: String = "Maak een open huis van een woning om te beginnen met het verzamelen van leads."
        override val noSignInsTitle: String = "Nog geen aanmelding"
        override val noSignInsBody: String = "Leads ingecheckt via kiosk-modus zullen hier in real time verschijnen."
        override val dashboard: String = "Dashboard"
        override val start: String = "Begin"
        override val end: String = "Einde"
        override val endOpenHouse: String = "Einde open huis"
        override val reportsEyebrow: String = "Eigenaren"
        override val sellerReportsTitle: String = "Verkopersverslagen"
        override val createReport: String = "Rapport aanmaken"
        override val reportPreview: String = "Verkoopverslag"
        override val reportsSubtitle: String = "Creëer premium post-open-house samenvattingen met lead kwaliteit, koper intentie, en verkoper-ready verhaal."
        override val reportsMetricSaved: String = "opgeslagen"
        override val reportedMetric: String = "gerapporteerd"
        override val leadsMetric: String = "aanwijzingen"
        override val createSellerReport: String = "Rapport aanmaken"
        override val attendance: String = "Deelname"
        override val savedReports: String = "opgeslagen rapporten"
        override val buyerHeat: String = "Koperwarmte"
        override val hotLeads: String = "Hot leads"
        override val loadingSellerReports: String = "Rapporten van de verkoper laden"
        override val noSellerReportsTitle: String = "Nog geen verkoper rapporten"
        override val noSellerReportsBody: String = "Kies een open huis, voeg agent notes toe, bekijk een export-ready recap en sla het dan op."
        override val chooseOpenHouse: String = "Kies open huis"
        override val noOpenHousesAvailable: String = "Nog geen open huizen beschikbaar."
        override val agentNotes: String = "Agentnotities"
        override val notesForSeller: String = "Opmerkingen voor verkoper"
        override val sellerNotesPlaceholder: String = "Bezwaar van de koper, prijssignalen, feedback tonen, aanbevolen volgende stap"
        override val generatePreview: String = "Voorbeeld aanmaken"
        override val noPreviewReadyTitle: String = "Geen voorbeeld klaar"
        override val noPreviewReadyBody: String = "Genereer een verkoper rapport preview voordat u opslaat."
        override val saveReport: String = "Rapport opslaan"
        override val reportSaved: String = "Opgeslagen rapport"
        override val sellerOpenHouseReport: String = "Verkoper open huis rapport"
        override val mostCommonBuyerInterest: String = "Het meest voorkomende kopersbelang"
        override val followUpsSent: String = "Follow-ups verzonden"
        override val summary: String = "Samenvatting"
        override val noPrivateNotesAdded: String = "Geen privé notities toegevoegd."
        override val openHouseReport: String = "Verslag-Open Huis"
        override val commonDraft: String = "Ontwerp"
        override val commonAccepted: String = "Goedgekeurd"
        override val searchSellerReports: String = "Zoek verkoper rapporten"
        override val noMatchingReports: String = "Geen overeenkomende rapporten"
        override val clearFilters: String = "Filters wissen"
        override val tryDifferentSearchOrStatusFilter: String = "Probeer een ander zoek- of statusfilter."
        override val connectedToProperty: String = "Verbonden met eigendom"
        override val viewProperty: String = "Eigenschap tonen"
        override val dataRollup: String = "Oprollen van gegevens"
        override val connectedOpenings: String = "Open Huizen"
        override val visitors: String = "Bezoekers"
        override val interestedBuyers: String = "Geïnteresseerde kopers"
        override val completedFollowUps: String = "Follow-ups"
        override val reportHistory: String = "Rapportgeschiedenis"
        override val noPreviousReportsYet: String = "Nog geen eerdere verslagen."
        override val viewAllReports: String = "Bekijk alle rapporten"
        override val actions: String = "Acties"
        override val generatePdf: String = "spreadsheet aanmaken"
        override val previewPdf: String = "Voorbeeld van spreadsheet"
        override val pdfSavedToPropertyFiles: String = "%s opgeslagen in eigendomsbestanden."
        override val pdfSavingToPropertyFiles: String = "%s wordt opgeslagen in eigendomsbestanden."
        override val pdfSavedToFiles: String = "%s opgeslagen in bestanden."
        override val pdfSavingToFiles: String = "%s wordt opgeslagen in bestanden."
        override val pdfIncludesSellerReport: String = "Spreadsheet bevat Seller Report metrics, AI inzichten, agent details, eigendomsgegevens, en open house geschiedenis."
        override val pdfIncludesAnalytics: String = "Spreadsheet bevat analytics metrics, top eigenschappen, agent performance, follow-up kanalen, en AI inzichten."
        override val pdfGenerateBeforeSending: String = "Maak het spreadsheet aan voordat u het verstuurt."
        override val pdfUploadBeforeSharing: String = "De spreadsheet moet vóór het delen worden geüpload."
        override val sellerReportPdfNeedsProperty: String = "Seller Report spreadsheet heeft een verbonden eigenschap nodig voordat u uploadt."
        override val deleteReport: String = "Verslag verwijderen"
        override val deleteReportBody: String = "Weet u zeker dat u dit verkoperrapport wilt verwijderen? Dit kan niet ongedaan worden gemaakt."
        override val shareReport: String = "Deelverslag"
        override val openingPropertyReportLoading: String = "Eigendomsrapport..."
        override val openingPropertyReportCreating: String = "Aanmaken eigendomsrapport..."
        override val sellerReportGeneratedPrefix: String = "Verkopersrapport gegenereerd"
        override val sellerReportGeneratedSuffix: String = "van open huizen, bezoekers, leads, follow-ups, en feedback verbonden met deze woning op rapporttijd."
        override val priceNotSet: String = "Prijs niet vastgesteld"
        override val daysSuffix: String = "dagen"
        override val connectedOpeningSingular: String = "open huis"
        override val connectedOpeningPlural: String = "open huizen"
        override val connectedLeadSingular: String = "verbonden lead"
        override val connectedLeadPlural: String = "verbonden kabels"
        override val sellerConfidence: String = "Verkopersvertrouwen"
        override val sellerConfidenceExplanation: String = "Vertrouwensverklaring"
        override val aiDraftReviewBeforeSending: String = "Alleen al concept. Beoordelen en bewerken voordat het verzenden naar de verkoper."
        override val executiveSummary: String = "Samenvatting"
        override val buyerInterestOverview: String = "Renteoverzicht van de koper"
        override val whatBuyersLoved: String = "Waar kopers van hielden"
        override val buyerConcerns: String = "Bezorgdheid van de koper"
        override val leadQualitySummary: String = "Samenvatting van de leadkwaliteit"
        override val agentActivity: String = "Agentactiviteit"
        override val aiRecommendations: String = "AI-aanbevelingen"
        override val recommendations: String = "Aanbevelingen"
        override val marketPositionComparison: String = "Vergelijking van de marktpositie"
        override val nextSteps: String = "Volgende stappen"
        override val conversion: String = "Omrekening"
        override val interested: String = "Interesse"
        override val tourSignalsLowercase: String = "toursignalen"
        override val propertyTimeline: String = "Tijdlijn van eigendom"
        override val timelineBasisNote: String = "De tijdlijn is alleen gebaseerd op aangesloten open huis registraties en follow-ups."
        override val visitorsLowercase: String = "bezoekers"
        override val hotLeadsLowercase: String = "hot leads"
        override val hotLowercase: String = "heet"
        override val sentiment: String = "Sentiment"
        override val toursLowercase: String = "tours"
        override val interestedLowercase: String = "Interesse"
        override val noRepeatedFeedbackMentions: String = "Er is nog geen melding gemaakt van herhaalde feedback."
        override val scoresMentionRates: String = "Scores zijn meldingstarieven over opgeslagen koper feedback."
        override val aiExecutiveBriefing: String = "AI uitvoerende briefing"
        override val viewAllAiInsights: String = "Bekijk alle AI inzichten ->"
        override val followUpsSentTitle: String = "Follow-ups verzonden"
        override val financingPacketsShared: String = "Financieringspakketten Gedeeld"
        override val buyerCalls: String = "Kopergesprekken"
        override val propertyDataEvidence: String = "Bewijs van eigendomsgegevens"
        override val attendanceCoverage: String = "Deelnamedekking"
        override val leadQuality: String = "Leadkwaliteit"
        override val followUpExecution: String = "Follow-up uitvoering"
        override val activityChannels: String = "Activiteitenkanalen"
        override val callsLowercase: String = "oproepen"
        override val emailsLowercase: String = "e-mails"
        override val offerReadinessScore: String = "Aanbieding gereedheid score"
        override val date: String = "Datum"
        override val propertyLeadFunnel: String = "Leadtrechter"
        override val openHouseBreakdown: String = "Open huis instorting"
        override val aiInsights: String = "AI Inzichten"
        override val generateAiInsights: String = "AI-inzichten genereren"
        override val analyticsOverview: String = "Overzicht analytics"
        override val allAgents: String = "Alle agenten"
        override val me: String = "Ge"
        override val allActivity: String = "Alle activiteiten"
        override val latest30Days: String = "Laatste 30 dagen"
        override val latest7Days: String = "Laatste 7 dagen"
        override val analyticsDatePreset: String = "Datumbereik"
        override val analyticsCustomDate: String = "Gebruikelijke datum"
        override val analyticsLastDay: String = "Laatste dag"
        override val analyticsLastWeek: String = "Vorige week"
        override val analyticsLastMonth: String = "Vorige maand"
        override val analyticsLastYear: String = "Vorig jaar"
        override val analyticsAllTime: String = "Altijd"
        override val analyticsDateFrom: String = "Datum"
        override val analyticsDateTo: String = "Datum tot"
        override val analyticsOpenHousesLowercase: String = "open huizen"
        override val analyticsWarmLeadsLowercase: String = "warme aanwijzingen"
        override val analyticsFromNotesFollowUps: String = ""
        override val analyticsFromText: String = "uit tekst"
        override val analyticsHotConversion: String = "Warme conversie"
        override val analyticsHotLeadsPerVisitors: String = "hot leads / bezoekers"
        override val analyticsAverageIntent: String = "Intentieverklaring"
        override val analyticsVisitorIntentScore: String = "bezoekersintentiescore"
        override val analyticsSelectDate: String = "Datum selecteren"
        override val propertyFunnel: String = "Trechter"
        override val propertyFunnelSubtitle: String = "Van vastgoedactiviteiten tot gekwalificeerde kopersmoment"
        override val properties: String = "Eigenschappen"
        override val tourSignals: String = "Toursignalen"
        override val offerSignals: String = "Aanbodssignalen"
        override val viewFullFunnelReport: String = "Volledig trechterrapport bekijken"
        override val performanceOverTime: String = "Prestaties in de tijd"
        override val thirtyDays: String = "30 dagen"
        override val topPerformingProperties: String = "Topprestaties"
        override val viewAll: String = "Alles tonen"
        override val noPropertyAnalyticsYet: String = "Nog geen eigendomsanalyse."
        override val leadQualityBreakdown: String = "Verdeling van de leadkwaliteit"
        override val warmLeadsTitle: String = "Warme aanwijzingen"
        override val coldLeadsTitle: String = "Koude loden"
        override val followUpPerformance: String = "Follow-upprestaties"
        override val agentPerformance: String = "Agentprestaties"
        override val viewTeamReport: String = "Teamrapport bekijken"
        override val followUpChannels: String = "Follow-upkanalen"
        override val viewReport: String = "Verslag bekijken"
        override val searchProperties: String = "Zoekeigenschappen"
        override val searchOpenings: String = "Open huizen doorzoeken"
        override val noOpeningsFoundTitle: String = "Geen open huizen gevonden"
        override val noOpeningsFoundBody: String = "Probeer een ander zoek- of open huis status filter."
        override val noMatchingPropertiesTitle: String = "Geen overeenkomende eigenschappen"
        override val noMatchingPropertiesBody: String = "Probeer een ander zoek- of statusfilter."
        override val clientsTitle: String = "Contacten"
        override val clientFallback: String = "Contactpersoon"
        override val addClient: String = "Contact toevoegen"
        override val editClient: String = "Contact bewerken"
        override val newClient: String = "Nieuw contact"
        override val saveClient: String = "Contact opslaan"
        override val createClient: String = "Contact maken"
        override val deleteClientTitle: String = "Contact verwijderen?"
        override val deleteClientBody: String = "Dit zal het contact definitief verwijderen. Dit kan niet ongedaan worden gemaakt."
        override val firstName: String = "Voornaam"
        override val lastName: String = "Achternaam"
        override val email: String = "E-mail"
        override val phone: String = "Telefoon"
        override val comments: String = "Opmerkingen"
        override val addPhoto: String = "Foto toevoegen"
        override val sendQr: String = "QR versturen"
        override val sendQrShareTitle: String = "Uw HAVN open huis QR"
        override val sendQrShareBody: String = "Uw Havn open huis QR is bevestigd. Voeg de Wallet-pas (.pkpass) toe aan uw telefoon indien beschikbaar, of toon de QR-afbeelding in het open huis."
        override val sendQrReadyMessage: String = "QR-code klaar om te verzenden"
        override val sendQrUnavailableError: String = "Er is geen e-mail of SMS-app beschikbaar voor dit contact."
        override val clientQrDeliveryRequired: String = "Voeg een e-mail of telefoonnummer toe voor QR-levering."
        override val photo: String = "Foto"
        override val clientDetailSubtitle: String = "QR identiteit, contactgegevens, opmerkingen en open huizen verbonden door middel van leads."
        override val clientFormEditSubtitle: String = "Update contactgegevens, leveringsinformatie en opmerkingen."
        override val clientFormNewSubtitle: String = "Registreer een koper/contact en maak een herbruikbare QR-identiteit voor open huizen."
        override val searchClients: String = "Contacten zoeken"
        override val noClientsYetTitle: String = "Nog geen contacten"
        override val noClientsYetBody: String = "Registreer eerst contactpersonen en stuur vervolgens hun QR-code per e-mail of SMS voor een open huis."
        override val noClientsFoundTitle: String = "Geen contacten gevonden"
        override val noClientsFoundBody: String = "Probeer een andere naam, telefoon of e-mail."
        override val clientUnavailableTitle: String = "Contact niet beschikbaar"
        override val clientUnavailableBody: String = "Vernieuw de contactenlijst en open deze plaat opnieuw."
        override val noCommentsAdded: String = "Geen opmerkingen toegevoegd."
        override val openingsTitle: String = "Open Huizen"
        override val clientOpeningsEmpty: String = "Nog geen open huizen verbonden. Leads verbinden een contact met een open huis."
        override val clientPassLabel: String = "Portefeuillekaart"
        override val clientNoEmail: String = "Geen e-mail"
        override val visitorsBody: String = "Open de kioskmodus, scan een contact QR of voeg bestaande contacten toe als leads voor dit open huis."
        override val openKiosk: String = "Kiosk openen"
        override val addQrClient: String = "QR-contact toevoegen"
        override val addManually: String = "Handmatig toevoegen"
        override val selectClients: String = "Contacten selecteren"
        override val selectClientsBody: String = "Kies contacten uit uw lijst. Elk geselecteerd contact wordt een aanwijzing voor dit open huis."
        override val kioskCheckIn: String = "Kiosk check-in"
        override val kioskCheckInBody: String = "Gebruik de achtercamera om de HAVN-portemonnee QR van het contact te scannen. Wanneer de code wordt herkend, maakt HAVN automatisch de leiding voor dit open huis."
        override val scanWithCamera: String = "Scannen met achtercamera"
        override val clientQrImage: String = "QR-afbeelding contacteren"
        override val clientQrImageBody: String = "Hou het contact QR binnen het gouden vierkant. HAVN verzamelt elke scan hieronder."
        override val scanMultipleQrBody: String = "Scan één of meer HAVN-contact QR-codes en tik vervolgens op QR-contact toevoegen."
        override val scannedQrReady: String = "contacteer QR klaar om toe te voegen"
        override val createLeadFromQr: String = "Lead aanmaken van QR"
        override val noClientsFoundShort: String = "Geen contacten gevonden."
        override val remove: String = "Verwijderen"
        override val tasksTitle: String = "Taken"
        override val addTask: String = "Taak toevoegen"
        override val searchTasks: String = "Zoektaken"
        override val loadMoreTasks: String = "Meer taken laden"
        override val createTask: String = "Taak aanmaken"
        override val saveTask: String = "Taak opslaan"
        override val editTask: String = "Taak bewerken"
        override val newTask: String = "Nieuwe taak"
        override val taskDetails: String = "Taakdetails"
        override val taskName: String = "Naam"
        override val taskDescription: String = "Omschrijving"
        override val taskDueDateTime: String = "Taakdatum & tijd"
        override val chooseTaskDateTime: String = "Kies taakdatum & tijd"
        override val clearTaskDateTime: String = "Datum & tijd wissen"
        override val assignToAgent: String = "Aan agent toewijzen"
        override val noAgencyAgentsFound: String = "Geen agent gevonden. De taak blijft toegewezen aan de eigenaar."
        override val taskPriority: String = "Taakprioriteit"
        override val taskStatus: String = "Status"
        override val taskVisibility: String = "Zichtbaarheid"
        override val taskOwner: String = "Eigenaar"
        override val taskOwnerFallback: String = "Taakeigenaar"
        override val assignedTo: String = "Aan"
        override val selectedAgent: String = "Geselecteerde agent"
        override val taskVisibilityBody: String = "Deze taak is zichtbaar voor de eigenaar en de toegewezen agent."
        override val taskQueue: String = "Takenlijst"
        override val taskDetail: String = "Taak"
        override val taskDetailEmpty: String = "Selecteer een taak om context en volgende acties te zien."
        override val connectedContext: String = "Verbonden context"
        override val noTaskContext: String = "Geen eigendom, contact, open huis, of lead is nog niet verbonden."
        override val activityTimeline: String = "Activiteit Tijdslijn"
        override val created: String = "Aangemaakt"
        override val recently: String = "Recent"
        override val completed: String = "Voltooid"
        override val nextAction: String = "Volgende actie"
        override val agentReviewOrCompletion: String = "Evaluatie of voltooiing van de werkzaamheden"
        override val noDueDate: String = "Geen vervaldatum"
        override val reopen: String = "Heropenen"
        override val accept: String = "Accepteren"
        override val linkedTasks: String = "Gekoppelde taken"
        override val noLinkedTasks: String = "Nog geen verbonden taken."
        override val filesTitle: String = "Bestanden"
        override val attachFile: String = "Bestand bijvoegen"
        override val noFilesAttached: String = "Nog geen bestanden bijgevoegd."
        override val fileLimitHint: String = "Bestanden kunnen worden PDF, DOC, CAD, of andere formaten tot 20 MB elk."
        override val deleteFileTitle: String = "Bestand verwijderen?"
        override val deleteFileBody: String = "Dit bestand wordt verwijderd uit de opslag van HAVN."
        override val attachmentOpenFailed: String = "Kon dit bestand niet openen."
        override val attachmentDeleteOwnerOnly: String = "Alleen de eigenaar van het bestand kan deze bijlage verwijderen."
        override val attachmentDocumentsNotIncluded: String = "Uw huidige plan bevat geen bestandsuploads. Upgrade om bestanden te uploaden."
        override val attachmentDocumentStorageNotIncluded: String = "Uw huidige plan bevat geen documentopslag. Upgrade om bestanden te uploaden."
        override val attachmentFileSizePlanLimit: String = "Dit bestand is groter dan uw huidige plan toestaat. Upgrade om grotere bestanden te uploaden."
        override val attachmentStoragePlanLimit: String = "Opslaglimiet bereikt voor uw huidige plan. Upgrade om meer bestanden te uploaden."
        override val attachmentDocumentCountPlanLimit: String = "Documentlimiet bereikt voor deze eigenschap op uw huidige plan. Upgrade om meer bestanden te uploaden."
        override val attachmentHardFileLimit: String = "Bestandsbijlagen zijn beperkt tot 100 MB."
        override val openFiles: String = "Bestanden openen"
        override val sendViaEmail: String = "Verzenden via e-mail"
        override val sendViaSms: String = "Verzenden via SMS"
        override val sendEmailHeader: String = "E-mail versturen"
        override val sendSmsHeader: String = "SMS verzenden"
        override val noContactsFound: String = "Geen contacten gevonden."
        override val searchContacts: String = "Contacten zoeken"
        override val linked: String = "Gekoppeld"
        override val recent: String = "Recent"
        override val taskColumnToDo: String = "Te doen"
        override val taskColumnInProgress: String = "In behandeling"
        override val taskColumnDone: String = "Klaar"
        override val taskColumnToDoSubtitle: String = "Nieuwe taken en volgende acties wachten om te worden gestart."
        override val taskColumnInProgressSubtitle: String = "Werk momenteel eigendom van u of het team."
        override val taskColumnDoneSubtitle: String = "Voltooide taken bleven zichtbaar voor teamvertrouwen."
        override val taskEmptyToDo: String = "Geen taken te doen."
        override val taskEmptyInProgress: String = "Er is niets aan de hand."
        override val taskEmptyDone: String = "Nog geen voltooide taken."
        override val taskKanbanEmptyToDo: String = "Niets wachten. Hier zullen nieuwe follow-ups en rapporten verschijnen."
        override val taskKanbanEmptyInProgress: String = "Geen actief werk in uitvoering."
        override val taskKanbanEmptyDone: String = "Voltooide taken zullen hier landen."
        override val taskEmptyBodyPrefix: String = "Een taak aanmaken of een andere taak verplaatsen naar"
        override val taskEmptyBodySuffix: String = "."
        override val taskActionStart: String = "Begin"
        override val taskActionOverdue: String = "Te laat"
        override val taskActionCancel: String = "Annuleren"
        override val taskPriorityLow: String = "Laag"
        override val taskPriorityMedium: String = "Middel"
        override val taskPriorityHigh: String = "Hoog"
        override val taskPriorityUrgent: String = "Dringend"
        override val taskStatusOpen: String = "Open"
        override val taskStatusInProgress: String = "Aan de gang"
        override val taskStatusDone: String = "Klaar"
        override val taskStatusOverdue: String = "Te laat"
        override val taskStatusCancelled: String = "Geannuleerd"
        override val aiSuggestedTasks: String = "AI Suggereerde taken"
        override val noAiSuggestedTasks: String = "Nog geen AI suggesties. HAVN zal voorstellen taken na open huizen en lead activiteit."
        override val taskFilterToday: String = "Vandaag"
        override val taskFilterUpcoming: String = "Binnenkort"
        override val taskFilterOverdue: String = "Te laat"
        override val taskFilterCompleted: String = "Voltooid"
        override val taskFilterAssignedToMe: String = "Aan mij toegewezen"
        override val taskFilterAiSuggested: String = "AI voorgesteld"
        override val taskFilterEmptyToday: String = "Je bent vrij voor vandaag."
        override val taskFilterEmptyUpcoming: String = "Geen komende taken."
        override val taskFilterEmptyOverdue: String = "Geen taken te laat."
        override val taskFilterEmptyCompleted: String = "Nog geen voltooide taken."
        override val taskFilterEmptyAssignedToMe: String = "Geen taken toegewezen aan u."
        override val taskFilterEmptyAiSuggested: String = "Nog geen geaccepteerde AI voorgestelde taken."
        override val taskSuggestionHotLeadTitlePrefix: String = "Follow-up met"
        override val taskSuggestionHotLeadTitleSuffix: String = "binnen 2 uur."
        override val taskSuggestionHotLeadDescriptionPrefix: String = "Warm lead van"
        override val taskSuggestionHotLeadDescriptionSuffix: String = "Houd vaart terwijl de intentie vers is."
        override val taskSuggestionHotLeadReason: String = "Nieuw heet lead gevangen."
        override val taskSuggestionSellerReportTitlePrefix: String = "Genereer verkoper rapport voor"
        override val taskSuggestionSellerReportTitleSuffix: String = "."
        override val taskSuggestionSellerReportDescription: String = "Samengevat bezoekersvolume, hot leads, follow-up activiteit, en koper sentiment."
        override val taskSuggestionSellerReportReason: String = "Open huis eindigde."
        override val taskSuggestionReviewFollowUpTitlePrefix: String = "Evaluatie en verzending"
        override val taskSuggestionReviewFollowUpTitleSuffix: String = "follow-up."
        override val taskSuggestionReviewFollowUpReason: String = "Follow-up ontwerp moet nog steeds agent herziening."
        override val taskSuggestionKioskTitle: String = "Bereid de kioskmodus voor en verifieer de eigendomsfoto's."
        override val taskSuggestionKioskDescription: String = "Bevestig inlogstroom, galerie en open huis details voordat kopers arriveren."
        override val taskSuggestionKioskReason: String = "Open huis staat gepland."
    }

    private val polish: HavnStrings = object : HavnStrings {
        override val navToday: String = "Dzisiaj"
        override val navProperties: String = "Właściwości"
        override val navLeads: String = "Leady"
        override val navReports: String = "Sprawozdania"
        override val navTasks: String = "Zadania"
        override val navAnalytics: String = "Analiza"
        override val navAgency: String = "Agencja"
        override val navSettings: String = "Ustawienia"
        override val navAuth: String = "Dostęp agenta"
        override val navOpenHouses: String = "Dni otwarte"
        override val navTours: String = "Dni otwarte"
        override val navFollowUps: String = "Kontakty"
        override val navFollow: String = "Kontakty"
        override val back: String = "Tył"
        override val settingsEyebrow: String = "Konto"
        override val settingsTitle: String = "Ustawienia"
        override val settingsSubtitle: String = "Profil maklerski, zaproś politykę, wiadra magazynowe i role zespołowe."
        override val agentProfileTitle: String = "Profil agenta"
        override val agentPhoto: String = "Zdjęcie agenta"
        override val uploading: String = "Wysyłanie..."
        override val saving: String = "Zapisywanie..."
        override val validAgentPhotoRequired: String = "Wybierz poprawne zdjęcie agenta."
        override val signOut: String = "Wyloguj się"
        override val signOutQuestion: String = "Wylogować się?"
        override val signOutConfirmation: String = "Czy na pewno chcesz wylogować się z HAVN?"
        override val deleteAccount: String = "Usuń konto"
        override val deleteAccountQuestion: String = "Usunąć konto?"
        override val deleteAccountOpenPageBody: String = "To otworzy stronę żądania usunięcia konta."
        override val deleteAccountReviewTitle: String = "Użyj prawdziwego konta"
        override val deleteAccountReviewBody: String = "To konto recenzji aplikacji jest chronione, więc recenzenci nie tracą dostępu podczas testowania. Proszę użyć prawdziwego konta testowego do weryfikacji usunięcia konta."
        override val upgrade: String = "Aktualizacja"
        override val premiumThemesTitle: String = "Motywy Premium"
        override val premiumThemesUpgradePrompt: String = "Upgrade do Pro, aby odblokować motywy premium."
        override val appearanceTitle: String = "Wygląd"
        override val appearanceBody: String = "Wybierz tryb światła lub ciemności dla aplikacji internetowej."
        override val previewComponents: String = "Elementy podpowiedzi"
        override val themeShowcaseTitle: String = "Prezentacja motywu"
        override val showcaseButtons: String = "Przyciski"
        override val showcasePrimaryAction: String = "Działanie podstawowe"
        override val showcaseSecondaryAction: String = "Działania wtórne"
        override val showcaseGhostAction: String = "Działanie na rzecz ducha"
        override val showcaseTextField: String = "Pole tekstowe"
        override val showcaseFocusedBorder: String = "Granica akcentu"
        override val showcaseSearchPreview: String = "Podgląd wyszukiwania"
        override val showcaseOpeningCheckedIn: String = "Open House check- in dzisiaj"
        override val showcaseSentAt: String = "Wysłany o 10: 30"
        override val themeObsidianGoldName: String = "Obsidian Gold"
        override val themeObsidianGoldDescription: String = "Luksusowy czarny, grafit i ciepłe złoto."
        override val themeMidnightSapphireName: String = "Midnight Sapphire"
        override val themeMidnightSapphireDescription: String = "Deep Navy, Sapphire Blue i srebrny akcent."
        override val themeEmeraldEstateName: String = "Emerald Estate"
        override val themeEmeraldEstateDescription: String = "Ciemny szmaragd, węgiel drzewny i szampan."
        override val themePlatinumStoneName: String = "Kamień platynowy"
        override val themePlatinumStoneDescription: String = "Kamienny szary, platynowy i miękki biały."
        override val themeBordeauxNoirName: String = "Bordeaux Noir"
        override val themeBordeauxNoirDescription: String = "Ciemne wino, grafit i miedziany akcent."
        override val commonChange: String = "Zmiana"
        override val agentPlanTitle: String = "Plan agenta"
        override val agentPlanBody: String = "Uaktualnij swoje doświadczenie, wybierz plan, który pasuje do tego, jak najlepiej pracować."
        override val currentPlan: String = "Bieżący plan"
        override val transferPlan: String = "Plan transferu"
        override val transferPlanTitle: String = "Plan transferu"
        override val transferPlanBody: String = "Przenieś tę subskrypcję na inne konto HAVN. Oba adresy e-mail muszą być potwierdzone kodami weryfikacji."
        override val transferTargetEmail: String = "Nowy email konta"
        override val transferSendCodes: String = "Wyślij kody weryfikacji"
        override val transferCodesSentTitle: String = "Przesyłane kody weryfikacji"
        override val transferCodesSentBody: String = "Wysłaliśmy jeden kod na Twój e-mail i jeden kod na nowe konto e-mail."
        override val transferYourCode: String = "Kod email"
        override val transferTargetCode: String = "Nowy kod konta"
        override val transferConfirm: String = "Plan transferu"
        override val transferSuccessTitle: String = "Przekazany plan"
        override val transferSuccessBody: String = "Subskrypcja jest teraz podłączona do nowego konta HAVN."
        override val restorePurchase: String = "Przywróć zakup"
        override val agencySettingsProBody: String = "Agencja Solo działa domyślnie. Pro pozwala utworzyć lub wybrać wspólną agencję."
        override val agencySettingsLockedBody: String = "Agencja Solo jest aktywna. Zmiany w Agencji odblokować z Pro."
        override val soloAgency: String = "Agencja Solo"
        override val defaultPrivateAgencyWorkspace: String = "Domyślna agencja prywatna"
        override val noAgenciesAvailableYet: String = "Nie ma jeszcze zaproszeń ani agencji."
        override val oneOwnedAgencyHint: String = "Twoja agencja jest wymieniona powyżej. Jeden agent może posiadać jedną agencję."
        override val createAgency: String = "Tworzenie agencji"
        override val createYourAgency: String = "Stwórz swoją agencję"
        override val createAgencyBody: String = "Zbuduj swój zespół, zarządzaj nieruchomościami razem i rozwijaj swój biznes."
        override val agencyName: String = "Nazwa agencji"
        override val agencyEmail: String = "Adres e-mail Agencji"
        override val logoOptional: String = "Logo (opcjonalne)"
        override val upgradeExperienceTitle: String = "Ulepsz swoje doświadczenie"
        override val upgradeExperienceSubtitle: String = "Uruchom swój pierwszy Open House za darmo. Upgrade, gdy potrzebujesz więcej list, otwartych domów i Pro Workflow."
        override val soloAgentPlan: String = "Środek solowy"
        override val proAgentPlan: String = "Agent Pro"
        override val teamAgentPlan: String = "Zespół"
        override val soloBenefitActiveProperties: String = "Do 100 właściwości aktywnych"
        override val soloBenefitAiFollowUps: String = "AI follow- ups (basic)"
        override val soloBenefitSellerReports: String = "Brak raportów ze sprzedaży"
        override val soloBenefitPersonalOnly: String = "Tylko dla siebie"
        override val proBenefitUnlimitedProperties: String = "Do 10 000 właściwości"
        override val proBenefitUnlimitedAi: String = "10 000 wniosków / miesiąc w sprawie tekstu dotyczących ptasiej grypy"
        override val proBenefitAdvancedReports: String = "Zaawansowane raporty sprzedaży"
        override val proBenefitAgencyCreation: String = "Tworzenie agencji i zarządzanie nią"
        override val proBenefitInviteAgents: String = "Zaproszenie agentów i współpraca"
        override val proBenefitSharedLeads: String = "Wspólne prowadzenie i praca zespołowa"
        override val proBenefitAgencyBranding: String = "Znakowanie agencji"
        override val proBenefitAdvancedAnalytics: String = "Zaawansowana analityka"
        override val teamBenefitLargeLimits: String = "Limity skali zespołu"
        override val teamBenefitPrioritySupport: String = "Priorytetowe wsparcie e-mail"
        override val teamBenefitDailyBackups: String = "Codzienne kopie zapasowe przez 7 dni"
        override val teamBenefitLargeStorage: String = "Przechowywanie dokumentów 10GB"
        override val startFreeTrial7Day: String = "Subskrybuj teraz"
        override val restorePurchases: String = "Przywróć zakup"
        override val comparePlans: String = "Porównaj plany"
        override val startFreeTrial: String = "Wybierz plan"
        override val noCommitmentCancelAnytime: String = "Uruchom swój pierwszy Open House za darmo. Upgrade, kiedy potrzebujesz więcej."
        override val monthly: String = "Miesięcznie"
        override val yearly: String = "Rocznie"
        override val yearlySave20: String = "Rocznie"
        override val yearlySavings20: String = "Rocznie."
        override val perYear: String = "/ rok"
        override val loadingPlans: String = "Wczytywanie planów..."
        override val selectedPlanUnavailable: String = "Subskrypcje są tymczasowo niedostępne. Proszę spróbować ponownie później lub skontaktować się z obsługą."
        override val signInRequiredForPurchase: String = "Zaloguj się przed rozpoczęciem zakupu."
        override val subscriptionDisclosureIos: String = "Autoryzowana subskrypcja. Płatność zostanie pobrana na konto Apple przy potwierdzeniu zakupu. Prenumerata automatycznie aktualizuje się, chyba że anulowane co najmniej 24 godziny przed końcem bieżącego okresu. Odnowienie zostanie pobrane w ciągu 24 godzin przed końcem bieżącego okresu. Możesz zarządzać lub anulować subskrypcję w ustawieniach konta App Store."
        override val subscriptionDisclosureAndroid: String = "Autoryzowana subskrypcja poprzez Google Play. Będziesz pobierany za każdy okres rozliczeniowy, chyba że anulujesz. Możesz zarządzać lub anulować subskrypcję w każdej chwili w subskrypcji Google Play. Dostęp trwa do końca płatnego okresu."
        override val subscriptionDisclosureWeb: String = "Autoryzowana subskrypcja. Użytkownik będzie pobierał opłaty za każdy okres rozliczeniowy za pomocą wybranej metody płatności, chyba że anuluje. Możesz zarządzać lub anulować w każdej chwili z ustawień Billing. Dostęp trwa do końca płatnego okresu. Podatki mogą być stosowane."
        override val subscriptionAgreementPrefix: String = "Przez subskrybowanie, zgadzasz się na"
        override val subscriptionTermsOfUse: String = "Warunki użytkowania HAVN"
        override val subscriptionAgreementAnd: String = "oraz"
        override val subscriptionPrivacyPolicy: String = "Polityka prywatności."
        override val purchaseSuccessTitle: String = "Dziękuję za zakup"
        override val purchaseSuccessBody: String = "Subskrypcja HAVN jest aktywna, a plan gotowy."
        override val restoreSuccessTitle: String = "Przywróć zakup"
        override val restoreSuccessBody: String = "Subskrypcja HAVN została z powodzeniem przywrócona."
        override val purchaseCouldNotComplete: String = "Zakup nie mógł zostać zrealizowany. Proszę spróbować ponownie lub sprawdzić swój App Store lub konto Google Play."
        override val purchaseVerificationPending: String = "Your payment has not been confirmed yet. If you completed checkout, use Restore purchase to check again. You do not need to pay again."
        override val completeWebCheckout: String = "Complete payment in the checkout tab, then return here. Your access will update automatically once payment is confirmed."
        override val restoreCouldNotComplete: String = "Nie znaleziono żadnej aktywnej subskrypcji HAVN dla tego konta."
        override val noActiveSubscriptionFound: String = "Nie znaleziono żadnej aktywnej subskrypcji HAVN dla tego konta."
        override val compareActiveProperties: String = "Właściwości aktywne"
        override val compareAiFollowUps: String = "Działania następcze AI"
        override val compareSellerReports: String = "Sprawozdania sprzedającego"
        override val compareAdvancedAnalytics: String = "Zaawansowana analityka"
        override val compareAgencyCreation: String = "Tworzenie agencji"
        override val compareJoinAgencies: String = "Dołącz do agencji"
        override val compareInviteAgents: String = "Agenci zaproszeni"
        override val compareSharedLeads: String = "Wspólne prowadzenie"
        override val compareAgencyBranding: String = "Znakowanie agencji"
        override val comparePrioritySupport: String = "Priorytetowe wsparcie"
        override val compareFeature: String = "Cecha"
        override val compareFreePlan: String = "Wolne"
        override val compareValueYes: String = "Tak."
        override val compareValueNo: String = "Nie."
        override val comparePricePerMonthUser: String = "Cena / miesiąc / Użytkownik"
        override val comparePricePerYearUser: String = "Cena / rok / Użytkownik"
        override val compareMaxPropertiesOwner: String = "Maksymalne właściwości / właściciel"
        override val compareMaxContactsOwner: String = "Maksymalne kontakty / właściciel"
        override val compareMaxOpenHousesOwner: String = "Max dni otwarte / właściciel"
        override val compareMaxLeadsOwner: String = "Max prowadzi / właściciel"
        override val compareMaxPhotosProperty: String = "Max zdjęcia na nieruchomości"
        override val compareMaxDocumentsProperty: String = "Maksymalna liczba dokumentów na nieruchomość"
        override val compareDocumentsStorage: String = "Przechowywanie dokumentów"
        override val compareAgencyAgenda: String = "Agencje"
        override val compareAiTextRequestsMonth: String = "Wnioski o wydanie tekstu / miesiąc"
        override val compareAnalytics: String = "Analiza"
        override val compareTasks: String = "Zadania"
        override val compareDocumentsStorageOwner: String = "Przechowywanie dokumentów / właściciel"
        override val compareMaxFileSizeOwner: String = "Maksymalny rozmiar pliku / właściciel"
        override val compareEmailSupport: String = "Wsparcie e-mail"
        override val compareDailyBackups7Days: String = "Codzienne kopie zapasowe przechowywane przez 7 dni"
        override val compareKioskMode: String = "Tryb KioskName"
        override val unlimited: String = "Nieograniczony"
        override val basic: String = "Podstawowe"
        override val advanced: String = "Zaawansowane"
        override val perMonth: String = "/ miesiąc"
        override val members: String = "członkowie"
        override val upgradeToProForAgencyTools: String = "Upgrade to Pro to use agency tools"
        override val languageTitle: String = "Język"
        override val languageBody: String = "Wybierz język aplikacji dla tego urządzenia."
        override val english: String = "Angielski"
        override val slovak: String = "słowacki"
        override val unitsTitle: String = "Jednostki i waluta"
        override val unitsBody: String = "Wybierz sposób, w jaki ceny i wymiary właściwości są pokazywane w aplikacji."
        override val measurementSystemTitle: String = "Pomiar"
        override val metric: String = "Metric"
        override val imperial: String = "Imperial"
        override val currencyTitle: String = "Waluta"
        override val notificationsTitle: String = "Powiadomienia"
        override val notificationsBody: String = "Sterowanie wciskać alarmy, ciche godziny, i rodzaje aktualizacji HAVN może wysłać."
        override val notificationSettings: String = "Ustawienia powiadamiania"
        override val notificationsSubtitle: String = "Tylko ważne aktualizacje, filtrowane przez swoje preferencje."
        override val quietHoursTitle: String = "Godziny ciszy"
        override val quietHoursBody: String = "HAVN pomija niekrytyczne pchnięcia podczas spokojnych godzin. Rachunki i rachunki pozostają zwięzłe."
        override val enableQuietHours: String = "Włącz ciche godziny"
        override val quietHoursStart: String = "Start"
        override val quietHoursEnd: String = "Koniec"
        override val timezoneLabel: String = "Strefa czasowa"
        override val notificationTypesTitle: String = "Typy zgłoszeń"
        override val notificationNewLeadCapturedTitle: String = "Nowy ołów przechwycony"
        override val notificationNewLeadCapturedBody: String = "Kiedy otwarty dom lub przepływ QR przechwytuje ołów."
        override val notificationHotLeadTitle: String = "Ołów oznaczony jako gorący"
        override val notificationHotLeadBody: String = "Tylko wtedy, gdy ołów staje się wysokim zamiarem."
        override val notificationOpeningStartsSoonTitle: String = "Otwarty Dom zaczyna się wkrótce"
        override val notificationOpeningStartsSoonBody: String = "Pojedyncze przypomnienie 30 minut przed startem."
        override val notificationOpeningSummaryReadyTitle: String = "Podsumowanie otwarte gotowe"
        override val notificationOpeningSummaryReadyBody: String = "Kiedy podsumowanie post-event jest gotowe."
        override val notificationSellerReportGeneratedTitle: String = "Wygenerowany raport sprzedającego"
        override val notificationSellerReportGeneratedBody: String = "Po sporządzeniu raportu sprzedawcy."
        override val notificationAiFollowUpReadyTitle: String = "AI jest gotowa"
        override val notificationAiFollowUpReadyBody: String = "Kiedy ciąg dalszy jest gotowy do przeglądu."
        override val notificationAgentInvitedTitle: String = "Agent zaproszony do agencji"
        override val notificationAgentInvitedBody: String = "Zaproszenia agencji i zmiany w składzie."
        override val notificationLeadAssignedTitle: String = "Ołów przypisany tobie"
        override val notificationLeadAssignedBody: String = "Kiedy kolega z drużyny przydziela ci trop."
        override val notificationLeadTransferredTitle: String = "Ołów przeniesiony do ciebie"
        override val notificationLeadTransferredBody: String = "Kiedy własność prowadzi do ciebie."
        override val notificationSubscriptionIssueTitle: String = "Wydanie subskrypcji"
        override val notificationSubscriptionIssueBody: String = "Niepowodzenia odnowy i problemy z rozliczaniem."
        override val kioskSecurityTitle: String = "Bezpieczeństwo Kiosku"
        override val kioskSecurityBody: String = "Użyj tego PIN, aby opuścić tryb kiosku i powrócić do aplikacji agenta."
        override val kioskPinLabel: String = "PIN Kiosku"
        override val mcpAccessTitle: String = "Dostęp do MCP"
        override val mcpAccessBody: String = "Most HAVN do Claude 'a, OpenAI i innych klientów MCP w Mcp.havnre.app. Dostępny w każdym planie."
        override val mcpAuthorizationBearer: String = "Autoryzacja: Właściciel"
        override val mcpNoApiKeyCreated: String = "Brak utworzonego klucza API"
        override val mcpNotUsedYet: String = "Nieużywany jeszcze"
        override val mcpLastUsedPrefix: String = "Ostatnio używane"
        override val mcpRevealApiKeyTitle: String = "Ujawnienie klucza API"
        override val mcpRevealApiKeyBody: String = "Pełny klucz jest wyświetlany tylko po utworzeniu lub obróceniu."
        override val mcpCreateKey: String = "Utwórz klucz"
        override val mcpRotateKey: String = "Obróć klawisz"
        override val mcpRevokeKey: String = "Oświeć klucz"
        override val mcpEndpointHint: String = "Użyć punktu końcowego https: / / mcp.havnre.app / mcp z tym kluczem jako tokerem Lorera."
        override val mcpUpgradeHint: String = "Dostęp MCP jest dostępny w każdym planie HAVN."
        override val mcpUpgradePrompt: String = "Dostęp MCP jest dostępny w każdym planie HAVN."
        override val mcpCopied: String = "Kopiowane"
        override val mcpCopy: String = "Kopiuj"
        override val mcpLoading: String = "Ładowanie"
        override val kioskFeaturedProperty: String = "Promowane nieruchomości"
        override val kioskPrivateShowing: String = "Pokaz prywatny"
        override val kioskLuxuryListing: String = "Luksusowy wykaz"
        override val kioskFastCheckIn: String = "Szybkie sprawdzenie"
        override val kioskExitContentDescription: String = "Wyjście kiosku"
        override val kioskWelcome: String = "Powitanie"
        override val kioskGladHere: String = "Cieszymy się, że tu jesteś."
        override val kioskScanToCheckIn: String = "Skanuj, aby sprawdzić"
        override val kioskReceivePropertyDetails: String = "i otrzymać szczegóły nieruchomości"
        override val kioskOr: String = "Lub"
        override val kioskStartCheckInManually: String = "Uruchom check- in ręcznie"
        override val kioskSecureInfo: String = "Twoje informacje są bezpieczne i nigdy nie będą udostępniane."
        override val kioskExitTitle: String = "Wyjście kiosku"
        override val kioskExitBody: String = "Wprowadź PIN kiosku, aby powrócić do aplikacji agenta."
        override val kioskIncorrectPin: String = "Nieprawidłowy PIN."
        override val kioskUnlock: String = "Odblokuj"
        override val kioskTellUsTitle: String = "Opowiedz nam o sobie."
        override val kioskTellUsBody: String = "Twoje informacje trafiają tylko do agenta."
        override val kioskFullName: String = "Pełna nazwa"
        override val kioskContinue: String = "Kontynuuj"
        override val kioskQuestionsTitle: String = "Kilka szybkich pytań."
        override val kioskQuestionsBody: String = "Pomaga to agentowi w śledzeniu właściwego kontekstu."
        override val kioskWorkingWithAgentQuestion: String = "Pracujesz z agentem?"
        override val kioskYes: String = "Tak."
        override val kioskNo: String = "Nie."
        override val kioskInterestQuestion: String = "Czym się interesujesz?"
        override val kioskInterestBuying: String = "Kupno"
        override val kioskInterestInvesting: String = "Inwestowanie"
        override val kioskInterestBrowsing: String = "Tylko przeglądam."
        override val kioskInterestRelocating: String = "Przenoszenie"
        override val kioskFinish: String = "Zakończ"
        override val kioskThankYou: String = "Dziękuję."
        override val kioskEnjoyVisitPrefix: String = "Ciesz się swoją wizytą w"
        override val kioskResetAutomatically: String = "Ten kiosku zostanie automatycznie zresetowany."
        override val environmentTitle: String = "Środowisko"
        override val environmentBody: String = "Szczegóły połączeń są skonfigurowane dla tej budowy."
        override val secure: String = "Bezpieczne"
        override val brokerageProfileTitle: String = "Profil brokerski"
        override val brokerageProfileBody: String = "Marka zespołu, agent zaprasza i preferencje zgłoszeniowe będą tu żyć."
        override val logout: String = "Wyloguj się"
        override val languageChanged: String = "Zmieniony język"
        override val commonAdd: String = "Dodaj"
        override val commonEdit: String = "Edycja"
        override val commonDelete: String = "Usuń"
        override val commonCancel: String = "Anuluj"
        override val commonSave: String = "Zapisz"
        override val commonCreate: String = "Utwórz"
        override val commonDismiss: String = "Rozejść się"
        override val commonAll: String = "Wszystkie"
        override val commonDone: String = "Gotowe"
        override val commonSend: String = "Wyślij"
        override val commonTime: String = "Czas"
        override val commonHour: String = "Godzina"
        override val commonMinute: String = "Minuta"
        override val commonAgency: String = "Agencja"
        override val commonSettings: String = "Ustawienia"
        override val commonOpening: String = "Otwarty dom"
        override val commonPropertyName: String = "Własność"
        override val commonToday: String = "Dzisiaj"
        override val agencyToolsAvailable: String = "Narzędzia agencji są dostępne."
        override val agencySetupSubtitle: String = "Każde konto HAVN posiada agencję niesprawną. Pro pozwala zarządzać zaproszeniami, dzielonymi tropami i marką."
        override val agencyRecentActivity: String = "Ostatnie działania"
        override val agencyActivityNewLead: String = "Dodano nowy ołów"
        override val agencyActivityInvitationAccepted: String = "Zaproszenie agenta przyjęte"
        override val agencyActivityAgentJoined: String = "Agent dołączył do agencji"
        override val agencyActivitySellerReport: String = "Stworzony raport sprzedającego"
        override val agencyWorkspaceTitle: String = "Agencja"
        override val agencyWorkspaceBody: String = "Wybierz agencję, z którą pracujesz."
        override val agencySoloActiveTitle: String = "Agencja Solo działa"
        override val agencyProRequiredTitle: String = "Wymagany Pro plan"
        override val agencyCreateOrAcceptInviteBody: String = "Stwórz swoją agencję lub przyjmij zaproszenie do współpracy z inną agencją."
        override val agencyProUnlockBody: String = "Agencja zmienia, zaprasza, wspólne tropy i wspólne marki odblokować z Pro."
        override val realEstate: String = "Nieruchomości"
        override val proAgency: String = "Agencja Pro"
        override val agencyBrandingTitle: String = "Znakowanie agencji"
        override val agencyBrandingBody: String = "Ustaw nazwę agencji i logo pokazane w aplikacji, kiosku i widoku zespołu."
        override val uploadLogo: String = "Wyślij logo"
        override val saveAgency: String = "Ratowanie agencji"
        override val yourAgencyRole: String = "Rola agencji"
        override val agencyAgentsTitle: String = "Agenci"
        override val agencyAgentsBody: String = "Ludzie uprawnieni do pracy z tą agencją."
        override val inviteAgent: String = "Agent zaproszony"
        override val loadingAgents: String = "Agenci ładujący..."
        override val noAgencyAgentsYet: String = "Nie ma jeszcze agentów agencji."
        override val changeRole: String = "Zmiana roli"
        override val updating: String = "Aktualizacja..."
        override val deleting: String = "Usuwanie..."
        override val deleteInvite: String = "Anuluj zaproszenie"
        override val chooseAgencyRoleFor: String = "Wybierz rolę agencji dla"
        override val removeAccess: String = "Usuń dostęp"
        override val inviteAgentBody: String = "Wyślij zaproszenie do agencji pocztą elektroniczną. Agent akceptuje po zalogowaniu się z tym samym e-mailem."
        override val agentEmail: String = "E-mail agenta"
        override val role: String = "Rola"
        override val inviting: String = "Zaproszenie..."
        override val invite: String = "Zaproszenie"
        override val agents: String = "Agenci"
        override val ok: String = "Ok"
        override val personalActivePropertyLimit: String = "Limit własności osobistej czynnej"
        override val personalAccountAgencyToolsLocked: String = "Konto osobiste jest aktywne. Narzędzia Agencji odblokować z Pro."
        override val selected: String = "Wybrane"
        override val activeMembers: String = "aktywni członkowie"
        override val agencySharedWorkspaceBody: String = "Dzielone nieruchomości, kontakty, dni otwarte, tropy, obserwacje i raporty korzystają z tej agencji."
        override val actLikeAgent: String = "Zachowuj się jak agent."
        override val actAsAdmin: String = "Działaj jako administrator"
        override val actAsOwner: String = "Działaj jako właściciel"
        override val actLikeAgentBody: String = "Użyj agencji jako normalnego agenta."
        override val actLikeAgentSelectedBody: String = "Pokazuje się jedynie pracę przypisaną lub będącą własnością."
        override val agencyRoleOwner: String = "Właściciel"
        override val agencyRoleAdmin: String = "Admin"
        override val agencyRoleAgent: String = "Agent"
        override val agencyRoleAssistant: String = "Asystent"
        override val agencyRoleViewer: String = "Przeglądarka"
        override val agencyRoleOwnerDescription: String = "Pełna kontrola agencji, w tym członków, marki, zadania, listy, tropy i raporty."
        override val agencyRoleAdminDescription: String = "Pełne zarządzanie agencją, z wyjątkiem usunięcia agencji."
        override val agencyRoleAgentDescription: String = "Prace przypisane listy, dni otwarte, tropy, follow- up, notatki, i raporty sprzedawcy."
        override val agencyRoleAssistantDescription: String = "Obsługuje przypisane listy poprzez edytowanie tropów, przygotowywanie kolejnych raportów i sporządzanie raportów."
        override val agencyRoleViewerDescription: String = "Odczyt - tylko dostęp do desek rozdzielczych i raportów."
        override val agencyCapabilityInviteRemoveMembers: String = "Zaproś i usuń członków"
        override val agencyCapabilityChangeRoles: String = "Zmień role członków"
        override val agencyCapabilityManageAllProperties: String = "Tworzenie, edycja i usuwanie wszystkich właściwości"
        override val agencyCapabilityAssignAgents: String = "Przydzielanie agentów"
        override val agencyCapabilitySeeAllLeads: String = "Zobacz wszystkie tropy"
        override val agencyCapabilityExportReports: String = "Sprawozdania z wywozu"
        override val agencyCapabilityChangeBranding: String = "Zmień markę agencji i ustawienia"
        override val agencyCapabilityDeleteAgency: String = "Usuń agencję"
        override val agencyCapabilityViewAssignedProperties: String = "Wyświetl przypisane właściwości"
        override val agencyCapabilityHostAssignedOpenings: String = "Host przypisane dni otwarte"
        override val agencyCapabilitySeeAssignedLeads: String = "Zobacz wskazówki z przypisanych nieruchomości i otwartych domów"
        override val agencyCapabilityAddNotes: String = "Dodaj notatki"
        override val agencyCapabilitySendFollowUps: String = "Wyślij dalsze działania"
        override val agencyCapabilityCreateSellerReports: String = "Tworzenie raportów sprzedających dla przypisanych list"
        override val agencyCapabilityEditAssignedLeads: String = "Edytuj przypisane prowadnice"
        override val agencyCapabilityPrepareFollowUps: String = "Przygotowanie dalszych działań"
        override val agencyCapabilityCreateDraftReports: String = "Tworzenie projektów sprawozdań"
        override val agencyCapabilityCannotDeleteProperties: String = "Nie można usunąć właściwości"
        override val agencyCapabilityCannotInviteAgents: String = "Nie można zapraszać agentów, chyba że jest to dozwolone"
        override val agencyCapabilityViewDashboards: String = "Zobacz tablice rozdzielcze"
        override val agencyCapabilityViewReports: String = "Wyświetlanie raportów"
        override val agencyCapabilityCannotEdit: String = "Nie można niczego edytować"
        override val commonVisitors: String = "Leady"
        override val commonHot: String = "Gorący"
        override val commonWarm: String = "Ciepły"
        override val commonCold: String = "Zimny"
        override val commonActive: String = "Aktywne"
        override val commonPlanned: String = "Planowane"
        override val commonArchived: String = "Archiwizacja"
        override val commonPast: String = "Przeszłość"
        override val commonFollowUps: String = "Podsumowanie"
        override val commonProperty: String = "Własność"
        override val commonAddress: String = "Adres"
        override val commonOpenHouse: String = "Otwarty dom"
        override val commonInquiry: String = "Dochodzenie"
        override val commonInquiries: String = "Pytania"
        override val generalInquiry: String = "Zapytanie ogólne"
        override val generalInquiries: String = "Zapytania ogólne"
        override val propertyInquiry: String = "Zapytanie o nieruchomość"
        override val propertyInquiries: String = "Zapytania o nieruchomości"
        override val addGeneralInquiry: String = "Dodaj zapytanie ogólne"
        override val newGeneralInquiry: String = "Nowe zapytanie ogólne"
        override val noGeneralInquiries: String = "Brak zapytań ogólnych."
        override val noPropertyInquiries: String = "Brak zapytań o nieruchomości."
        override val buyerLookingFor: String = "Czego szuka ten kupujący?"
        override val locationCity: String = "Lokalizacja / miasto"
        override val radiusKm: String = "Promień (km)"
        override val propertyType: String = "Typ nieruchomości"
        override val budgetFrom: String = "Budżet od"
        override val budgetTo: String = "Budżet do"
        override val purchaseTimeline: String = "Termin zakupu"
        override val createGeneralInquiry: String = "Utwórz zapytanie ogólne"
        override val saveGeneralInquiry: String = "Zapisz zapytanie ogólne"
        override val inquiryType: String = "Typ zapytania"
        override val leadSource: String = "Źródło leada"
        override val notSpecified: String = "Nie określono"
        override val inquiryStatus: String = "Status dochodzenia"
        override val inquiryFollowUp: String = "Kontynuacja dochodzenia"
        override val addInquiry: String = "Dodaj zapytanie"
        override val searchInquiries: String = "Poszukiwania"
        override val noInquiries: String = "Brak pytań"
        override val noInquiriesBody: String = "Użyj przycisku plus, aby dodać odsetki nabywcy z istniejącego kontaktu."
        override val inquiryUnavailableTitle: String = "Dochodzenie niedostępne"
        override val inquiryUnavailableBody: String = "Dochodzenie to mogło zostać usunięte lub nadal jest załadowane."
        override val backToInquiries: String = "Powrót do zapytań"
        override val deleteInquiry: String = "Usuń zapytanie"
        override val deleteInquiryQuestionPrefix: String = "Usuń"
        override val deleteInquiryQuestionSuffix: String = "Z tej posiadłości?"
        override val deleteInquiryTargetFallback: String = "to dochodzenie"
        override val propertyInquiriesBody: String = "Kupcy torów, którzy pytali o tę nieruchomość. Pytania pojawiają się również w Leads."
        override val propertyInquiriesEmpty: String = "Dodaj zapytanie wybierając jeden z twoich kontaktów."
        override val contactInquiriesBody: String = "Właściwości, o które pytał ten kontakt."
        override val contactInquiriesEmpty: String = "Nie ma jeszcze śledztwa."
        override val viewInquiries: String = "Zobacz pytania"
        override val createContactFirstForInquiry: String = "Najpierw utwórz kontakt, a następnie dodaj zapytanie z tej właściwości."
        override val commonCheckedIn: String = "Zameldowany"
        override val commonNotScheduled: String = "nieplanowany"
        override val todayTitle: String = "Dzisiaj"
        override val todaySubtitle: String = "Twój codzienny dom dla otwartych domów, prowadzi, śledzi, i seller-gotowy pędu."
        override val todayOpenHousesMetric: String = "dni otwarte"
        override val capturedMetric: String = "schwytany"
        override val priorityMetric: String = "priorytet"
        override val noActivePropertiesTitle: String = "Brak właściwości aktywnych"
        override val noActivePropertiesBody: String = "Dodaj lub aktywuj właściwość, aby ukazała się w dniu dzisiejszym."
        override val checkIns: String = "Kontrole"
        override val allOpenHouses: String = "wszystkie dni otwarte"
        override val pendingDrafts: String = "oczekujące projekty"
        override val priorityLead: String = "Przewodnik priorytetowy"
        override val nextOpenHouseAt: String = "Następny otwarty dom w"
        override val noOpenHouseScheduled: String = "Nie planowano dnia otwartego."
        override val personalAccount: String = "Konto osobiste"
        override val accountReady: String = "Twoje konto jest gotowe."
        override val realEstateApp: String = "Aplikacja nieruchomości"
        override val needHelp: String = "Potrzebujesz pomocy?"
        override val contactSupport: String = "Wsparcie kontaktów"
        override val upgradePlan: String = "Plan modernizacji"
        override val planSuffix: String = "Plan"
        override val todayActionsTitle: String = "Dzisiejsze priorytety"
        override val agencyInvitation: String = "Zaproszenie Agencji"
        override val joinAgency: String = "Dołącz"
        override val youWereInvitedAs: String = "Zostałeś zaproszony jako"
        override val invitedBy: String = "przez"
        override val decline: String = "Zmniejsz"
        override val yourDefaultAgency: String = "Twoja agencja domyślna"
        override val chooseAgencyBody: String = "Wybierz agencję, z którą chcesz pracować. Narzędzia agencji obejmują zaproszenia, wspólne tropy i markę."
        override val agencyMembersSuffix: String = "członkowie"
        override val quickActionTasksBody: String = "Kolejka"
        override val quickActionReportsBody: String = "Sprzedawca"
        override val quickActionAnalyticsBody: String = "Tendencje"
        override val quickActionAddPropertyTitle: String = "Dodaj"
        override val quickActionAddPropertyBody: String = "Wykaz"
        override val quickActionAddContactTitle: String = "Kontakt"
        override val quickActionAddContactBody: String = "Nowy"
        override val quickActionFilesTitle: String = "Pliki"
        override val quickActionFilesBody: String = "Dokumenty"
        override val firstRunStepsTitle: String = "Zacznij od czterech prostych kroków"
        override val firstRunAddProperty: String = "Dodaj właściwość"
        override val firstRunScheduleOpening: String = "Harmonogram otwarty dom"
        override val firstRunStartGuestCheckIn: String = "Zameldowanie gości"
        override val firstRunSendFollowUp: String = "Wyślij kontynuację"
        override val greetingNamePrefix: String = "Cześć."
        override val greetingAgent: String = "Cześć, agencie."
        override val createListing: String = "Utwórz listę"
        override val newOwnerBuyer: String = "Nowy właściciel / nabywca"
        override val documents: String = "Dokumenty"
        override val whatOpeningNext: String = "Co dalej?"
        override val whoCheckedIn: String = "Kto się zgłosił?"
        override val whoNeedsFollowUp: String = "Kto potrzebuje obserwacji?"
        override val whatShouldIDoNow: String = "Co mam teraz zrobić?"
        override val noCheckInsYet: String = "Nie ma jeszcze żadnych kontaktów."
        override val noPendingFollowUps: String = "Żadnych oczekujących obserwacji."
        override val openKioskForNextOpening: String = "Otwórz kiosku na następny otwarty dom."
        override val reviewNewLeads: String = "Przejrzyj nowe tropy i wyślij dalsze informacje."
        override val createOpeningToStart: String = "Utwórz otwarty dom z nieruchomości, aby rozpocząć zbieranie tropów."
        override val addFirstPropertyToStart: String = "Dodaj swoją pierwszą nieruchomość, aby rozpocząć."
        override val nextOpening: String = "Następny otwarty dom"
        override val quickSignIn: String = "Szybkie podpisanie"
        override val scanQrCode: String = "Skanuj kod QR"
        override val newLead: String = "Nowy ołów"
        override val myProperties: String = "Moje właściwości"
        override val manageListings: String = "Zarządzanie listą"
        override val todaysOverview: String = "Dzisiejszy przegląd"
        override val seeAll: String = "Zobacz wszystkie"
        override val propertiesEyebrow: String = "Portfólio"
        override val propertiesSubtitle: String = "Zarządzanie aktywnymi, planowanymi i archiwizowanymi listami z mediami na liście, działalnością kupującego i przeglądami wyników."
        override val propertiesLiveMetric: String = "na żywo"
        override val propertiesPipelineMetric: String = "rurociąg"
        override val propertiesAllTimeMetric: String = "cały czas"
        override val addProperty: String = "Dodaj właściwość"
        override val editProperty: String = "Edytuj właściwość"
        override val propertyFallback: String = "Własność"
        override val propertyUnavailableTitle: String = "Niedostępna nieruchomość"
        override val propertyUnavailableBody: String = "Odśwież portfolio, aby ponownie załadować tę listę."
        override val backToProperties: String = "Powrót do właściwości"
        override val deletePropertyTitle: String = "Skasować własność?"
        override val deletePropertyBody: String = "To na stałe usunie nieruchomość i związane z nią lokalne rekordy. Tego nie da się cofnąć."
        override val loadingProperties: String = "Właściwości wczytywania"
        override val loadMore: String = "Wczytaj więcej"
        override val loadingPropertyDetails: String = "Wczytywanie danych dotyczących właściwości"
        override val noPropertiesTitle: String = "Brak właściwości jeszcze"
        override val noPropertiesBody: String = "Dodaj swoją pierwszą właściwość, a następnie utworzyć otwarty dom, aby rozpocząć zbieranie tropów i seller-gotowy sprzężenia zwrotnego."
        override val openHouseButton: String = "Utwórz otwarty dom"
        override val photosTitle: String = "Zdjęcia"
        override val photosBody: String = "Pierwsze zdjęcie jest używane jako główny obraz własności w całym Portfolio."
        override val uploadPhoto: String = "Wyślij zdjęcie"
        override val noPhotosYet: String = "Żadnych zdjęć."
        override val propertyPhotoCountPlanLimit: String = "Limit zdjęć dla tej nieruchomości na aktualnym planie. Upgrade, aby przesłać więcej zdjęć."
        override val propertyPhotoStoragePlanLimit: String = "Limit pamięci dla bieżącego planu. Upgrade, aby przesłać więcej zdjęć lub plików."
        override val mainPhoto: String = "Główne"
        override val propertyTitleLabel: String = "Nazwa właściwości"
        override val propertyAddressLine1Label: String = "Adres ulicy"
        override val propertyAddressLine2Label: String = "Linia adresowa 2"
        override val propertyCityLabel: String = "Miasto"
        override val propertyRegionLabel: String = "Region"
        override val propertyPostalCodeLabel: String = "Kod pocztowy"
        override val propertyCountryLabel: String = "Kraj"
        override val propertyAskingPriceLabel: String = "Cena"
        override val propertyBedsLabel: String = "Łóżka"
        override val propertyBathsLabel: String = "Kąpiele"
        override val propertyInteriorLabel: String = "Wnętrze"
        override val propertyDescriptionLabel: String = "Opis"
        override val createPropertyButton: String = "+ Własność"
        override val locateProperty: String = "Zlokalizuj właściwość"
        override val findLocation: String = "Znajdź lokalizację"
        override val find: String = "Znajdź"
        override val navigate: String = "Nawigacja"
        override val propertyLocationMarkerTitle: String = "Lokalizacja nieruchomości"
        override val mapKitJsMissingToken: String = "Dodaj HAVN _ MAPKIT _ JS _ TOKEN do local.properties dla mapy internetowej."
        override val mapKitJsLoading: String = "Wczytywanie MapKit..."
        override val generateSellerReport: String = "Generuj raport sprzedającego"
        override val deleteProperty: String = "Usuń właściwość"
        override val conversionMetric: String = "Konwersja"
        override val propertyPhotoContentDescription: String = "Zdjęcie własności"
        override val deletePhoto: String = "Usuń zdjęcie"
        override val movePhotoLeft: String = "Przesuń zdjęcie w lewo"
        override val movePhotoRight: String = "Przesuń zdjęcie w prawo"
        override val propertyTitleRequired: String = "Wymagana jest nazwa własności."
        override val propertyStreetRequired: String = "Wymagany jest adres ulicy."
        override val propertyCityRequired: String = "Miasto jest wymagane."
        override val propertyRegionRequired: String = "Region jest wymagany."
        override val propertyPostalRequired: String = "Kod pocztowy jest wymagany."
        override val propertyAskingPriceInvalid: String = "Podaj poprawną cenę zapytania."
        override val propertyOwnerContactTitle: String = "Kontakt z właścicielem nieruchomości"
        override val propertyOwnerSelectContact: String = "Wybierz istniejący kontakt jako właściciela nieruchomości."
        override val propertyOwnerSelected: String = "Wybrany właściciel"
        override val propertyOwnerNoContacts: String = "Żadnych kontaktów. Dodaj właściciela w kontaktach, a następnie wybierz je tutaj."
        override val propertyOwnerChooseContact: String = "Wybierz kontakt"
        override val propertyOwnerChangeContact: String = "Zmień kontakt"
        override val propertyOwnerRemoveContact: String = "Usuń"
        override val propertyOwnerPickerTitle: String = "Wybierz właściciela nieruchomości"
        override val propertyOwnerSearchContact: String = "Kontakty wyszukiwania"
        override val propertyOwnerSearchHint: String = "Zacznij pisać imię, e-mail lub numer telefonu."
        override val propertyOwnerNoMatches: String = "Żadnych kontaktów."
        override val propertyOpeningsTitle: String = "Dni otwarte"
        override val propertyNoOpenings: String = "Żadnych otwartych domów na tę posiadłość."
        override val teamAccessTitle: String = "Dostęp do zespołu"
        override val onlyListingOwner: String = "Tylko właściciel notowania"
        override val assignTeam: String = "Przypisz zespół"
        override val assignPropertyTitle: String = "Przypisz właściwość"
        override val assignPropertyBody: String = "Wybierz, kto może pracować w tej nieruchomości. Wybierz cały zespół lub konkretnych agentów."
        override val wholeTeam: String = "Cały zespół"
        override val leadsEyebrow: String = "Leady"
        override val leadFallback: String = "Lead"
        override val leadsSubtitle: String = "Wyszukuj, filtruj i kwalifikuj leady zebrane podczas dni otwartych."
        override val leadDetailSubtitle: String = "Źródło, kwalifikacja, notatki i historia działań dotyczących tego leada."
        override val totalMetric: String = "Razem"
        override val loggedMetric: String = "zalogowany"
        override val searchLeads: String = "Szukaj leadów"
        override val searchLeadsPlaceholder: String = "Nazwa, telefon lub e-mail"
        override val allProperties: String = "Wszystkie właściwości"
        override val loadingLeads: String = "Ładowanie leadów"
        override val loadingLeadDetails: String = "Ładowanie szczegółów leada"
        override val noLeadsFoundTitle: String = "Leady pojawią się tutaj, gdy kontakty zameldują się na dniu otwartym."
        override val noLeadsEmptyBody: String = "Użyj zameldowania kiosku lub ręcznie dodaj kontakty z dnia otwartego."
        override val noLeadsFilteredBody: String = "Spróbuj innej właściwości, statusu lub terminu wyszukiwania."
        override val backToLeads: String = "Wróć do leadów"
        override val leadUnavailableTitle: String = "Lead niedostępny"
        override val leadUnavailableBody: String = "Ten lead nie jest już dostępny na bieżącej liście."
        override val leadTemperature: String = "Status leada"
        override val leadLabelSuffix: String = "Lead"
        override val greetingHi: String = "Cześć."
        override val leadActionCall: String = "Call"
        override val leadActionSms: String = "SMS"
        override val leadActionEmail: String = "E-mail"
        override val leadFollowUp: String = "Follow- up"
        override val leadNoFollowUpScheduled: String = "Brak zaplanowanych działań następczych"
        override val leadIntentScore: String = "Liczba intentów"
        override val leadInterestedIn: String = "Zainteresowany"
        override val leadGenericGreetingName: String = "tam"
        override val followUpMessageTypeThankYou: String = "Dziękuję."
        override val followUpMessageTypePropertyInfo: String = "Informacje o własności"
        override val followUpMessageTypeFollowUp: String = "Dalsze działania"
        override val followUpMessageTypeCheckIn: String = "Zamelduj się"
        override val followUpMessageTypePriceUpdate: String = "Aktualizacja cen"
        override val followUpMessageTypePropertyBrochure: String = "Pliki"
        override val followUpPreview: String = "Podgląd"
        override val followUpSubject: String = "Przedmiot"
        override val followUpMessage: String = "Wiadomość"
        override val followUpSendViaEmail: String = "Wyślij e-mailem"
        override val followUpSendViaSms: String = "Wyślij przez SMS"
        override val followUpAiAssistantTitle: String = "Asystent AI"
        override val followUpAiAssistantBody: String = "Generuj spersonalizowaną wiadomość w kilka sekund."
        override val followUpGenerateWithAi: String = "Generuj z AI"
        override val followUpUpgradeForAi: String = "Ulepszenie dla AI"
        override val followUpDefaultSubject: String = "Działania następcze"
        override val privateAgentNotes: String = "Notatki agenta prywatnego"
        override val notes: String = "Uwagi"
        override val notesPlaceholder: String = "Motywacja, preferencje, zastrzeżenia, następny ruch"
        override val saveNotes: String = "Zapisz notatki"
        override val followUpHistory: String = "Historia dalszego rozwoju"
        override val noFollowUpsLogged: String = "Nie zalogowano się jeszcze."
        override val openHousesEyebrow: String = "Pokazy"
        override val scheduleOpenHouse: String = "Utwórz otwarty dom"
        override val openingDetails: String = "Szczegóły dotyczące dnia otwartego"
        override val editOpening: String = "Edytuj otwarty dom"
        override val deleteOpening: String = "Usuń otwarty dom"
        override val deleteOpeningBody: String = "Na pewno chcesz usunąć ten otwarty dom? Tego nie da się cofnąć."
        override val removeLeadTitle: String = "Usunąć ołów?"
        override val removeLeadBody: String = "Usuń%s z tego dnia otwartego?"
        override val removeLeadFallback: String = "ten ołów"
        override val openingName: String = "Nazwa dnia otwartego"
        override val startsAt: String = "Zaczyna się"
        override val endsAt: String = "Koniec"
        override val chooseStartDateTime: String = "Wybierz datę i godzinę rozpoczęcia"
        override val chooseEndDateTime: String = "Wybierz datę i godzinę zakończenia"
        override val accessNotes: String = "Notatki dostępu"
        override val privateNotes: String = "Notatki prywatne"
        override val addPrivateNote: String = "Dodaj notatkę prywatną"
        override val liveDashboard: String = "Płyta rozdzielcza na żywo"
        override val visitorKiosk: String = "Ołów"
        override val openHousesSubtitle: String = "Tworzenie otwartych domów dla nieruchomości, przeglądanie tropów i uruchomienie sesji kiosku."
        override val liveMetric: String = "Żywe"
        override val upcomingMetric: String = "Nadchodzące"
        override val inProgressMetric: String = "w toku"
        override val scheduledMetric: String = "zaplanowane"
        override val loadingOpenHouses: String = "Ładowanie otwartych domów"
        override val addPropertyFirstTitle: String = "Dodaj najpierw właściwość"
        override val addPropertyFirstBody: String = "Utwórz otwarty dom z nieruchomości, aby rozpocząć zbieranie tropów."
        override val noOpenHousesTitle: String = "Żadnych otwartych domów."
        override val noOpenHousesBody: String = "Utwórz otwarty dom z nieruchomości, aby rozpocząć zbieranie tropów."
        override val noSignInsTitle: String = "Brak znaków"
        override val noSignInsBody: String = "W czasie rzeczywistym pojawi się tutaj sprawdzony przez tryb kiosku trop."
        override val dashboard: String = "Deska rozdzielcza"
        override val start: String = "Start"
        override val end: String = "Koniec"
        override val endOpenHouse: String = "Koniec otwarty dom"
        override val reportsEyebrow: String = "Właściciele"
        override val sellerReportsTitle: String = "Sprawozdania sprzedającego"
        override val createReport: String = "Utwórz raport"
        override val reportPreview: String = "Sprawozdanie sprzedającego"
        override val reportsSubtitle: String = "Stwórz premium po-open- house z jakości ołowiu, intencji kupującego i narracji gotowy do sprzedaży."
        override val reportsMetricSaved: String = "zapisany"
        override val reportedMetric: String = "zgłoszone"
        override val leadsMetric: String = "ołów"
        override val createSellerReport: String = "Utwórz raport"
        override val attendance: String = "Uczestnictwo"
        override val savedReports: String = "zapisywane raporty"
        override val buyerHeat: String = "Ciepło kupującego"
        override val hotLeads: String = "Gorące przewody"
        override val loadingSellerReports: String = "Wczytywanie raportów sprzedającego"
        override val noSellerReportsTitle: String = "Brak raportów ze sprzedaży"
        override val noSellerReportsBody: String = "Wybierz otwarty dom, dodaj notatki agenta, podgląd export- ready podsumowania, a następnie zapisać."
        override val chooseOpenHouse: String = "Wybierz otwarty dom"
        override val noOpenHousesAvailable: String = "Nie ma jeszcze otwartych domów."
        override val agentNotes: String = "Uwagi agenta"
        override val notesForSeller: String = "Uwagi dotyczące sprzedawcy"
        override val sellerNotesPlaceholder: String = "Sprzeciwy kupujących, sygnały cenowe, wyświetlanie informacji zwrotnych, zalecane następny ruch"
        override val generatePreview: String = "Generuj podgląd"
        override val noPreviewReadyTitle: String = "Brak podglądu"
        override val noPreviewReadyBody: String = "Generuj podgląd raportu sprzedawcy przed zapisaniem."
        override val saveReport: String = "Zapisz raport"
        override val reportSaved: String = "Raport zapisany"
        override val sellerOpenHouseReport: String = "Raport z otwarcia domu sprzedającego"
        override val mostCommonBuyerInterest: String = "Najczęstsze odsetki od nabycia"
        override val followUpsSent: String = "Wysłane follow- up"
        override val summary: String = "Streszczenie"
        override val noPrivateNotesAdded: String = "Żadnych prywatnych notatek."
        override val openHouseReport: String = "Sprawozdanie Open House"
        override val commonDraft: String = "Projekt"
        override val commonAccepted: String = "Akceptowane"
        override val searchSellerReports: String = "Raporty sprzedawcy wyszukiwania"
        override val noMatchingReports: String = "Brak pasujących raportów"
        override val clearFilters: String = "Wyczyść filtry"
        override val tryDifferentSearchOrStatusFilter: String = "Spróbuj innego filtru wyszukiwania lub statusu."
        override val connectedToProperty: String = "Połączone z nieruchomością"
        override val viewProperty: String = "Widok właściwości"
        override val dataRollup: String = "Podsumowanie danych"
        override val connectedOpenings: String = "Dni otwarte"
        override val visitors: String = "Goście"
        override val interestedBuyers: String = "Zainteresowani nabywcy"
        override val completedFollowUps: String = "Śledź Ups"
        override val reportHistory: String = "Historia raportu"
        override val noPreviousReportsYet: String = "Brak wcześniejszych raportów."
        override val viewAllReports: String = "Wyświetl wszystkie raporty"
        override val actions: String = "Działania"
        override val generatePdf: String = "Utwórz arkusz kalkulacyjny"
        override val previewPdf: String = "Podgląd arkusza kalkulacyjnego"
        override val pdfSavedToPropertyFiles: String = "%s zapisane do plików właściwości."
        override val pdfSavingToPropertyFiles: String = "%s jest zapisywane do plików właściwości."
        override val pdfSavedToFiles: String = "%s zapisywane do plików."
        override val pdfSavingToFiles: String = "%s jest zapisywane do plików."
        override val pdfIncludesSellerReport: String = "Arkusz Spreadsheet zawiera wskaźniki Seller Report, spostrzeżenia AI, szczegóły agentów, dane nieruchomości, i open house historii."
        override val pdfIncludesAnalytics: String = "Arkusz kalkulacyjny zawiera wskaźniki analityczne, najwyższe właściwości, wydajność agenta, kanały follow- up i spostrzeżenia AI."
        override val pdfGenerateBeforeSending: String = "Utwórz arkusz kalkulacyjny przed wysłaniem."
        override val pdfUploadBeforeSharing: String = "Arkusz kalkulacyjny musi zakończyć załadunek przed udostępnieniem."
        override val sellerReportPdfNeedsProperty: String = "Arkusz kalkulacyjny Report Sprzedającego potrzebuje podłączonej własności przed załadowaniem."
        override val deleteReport: String = "Usuń raport"
        override val deleteReportBody: String = "Jesteś pewien, że chcesz usunąć ten raport sprzedawcy? Tego nie da się cofnąć."
        override val shareReport: String = "Raport o udziałach"
        override val openingPropertyReportLoading: String = "Raport własności..."
        override val openingPropertyReportCreating: String = "Tworzenie raportu z nieruchomości..."
        override val sellerReportGeneratedPrefix: String = "Wygenerowane sprawozdanie sprzedającego"
        override val sellerReportGeneratedSuffix: String = "z otwartych domów, odwiedzających, prowadzi, śledzi, i opinie związane z tą nieruchomością w czasie raportu."
        override val priceNotSet: String = "Cena nieustalona"
        override val daysSuffix: String = "dni"
        override val connectedOpeningSingular: String = "otwarty dom"
        override val connectedOpeningPlural: String = "dni otwarte"
        override val connectedLeadSingular: String = "Ołów połączony"
        override val connectedLeadPlural: String = "połączone przewody"
        override val sellerConfidence: String = "Poufność sprzedającego"
        override val sellerConfidenceExplanation: String = "Wyjaśnienie dotyczące zaufania"
        override val aiDraftReviewBeforeSending: String = "Tylko AI Draft. Przegląd i edycja przed wysłaniem do sprzedawcy."
        override val executiveSummary: String = "Streszczenie"
        override val buyerInterestOverview: String = "Przegląd zainteresowania kupującego"
        override val whatBuyersLoved: String = "Co kupujący kochali"
        override val buyerConcerns: String = "Zagadnienia kupującego"
        override val leadQualitySummary: String = "Podsumowanie jakości ołowiu"
        override val agentActivity: String = "Aktywność agenta"
        override val aiRecommendations: String = "Zalecenia dotyczące ptasiej grypy"
        override val recommendations: String = "Zalecenia"
        override val marketPositionComparison: String = "Porównanie pozycji rynkowej"
        override val nextSteps: String = "Kolejne kroki"
        override val conversion: String = "Konwersja"
        override val interested: String = "zainteresowane"
        override val tourSignalsLowercase: String = "sygnalizatory trasy"
        override val propertyTimeline: String = "Terminy nieruchomości"
        override val timelineBasisNote: String = "Linie czasowe opierają się tylko na połączonych rejestrach otwartych domów i kontynuacjach."
        override val visitorsLowercase: String = "odwiedzający"
        override val hotLeadsLowercase: String = "gorące ołów"
        override val hotLowercase: String = "gorące"
        override val sentiment: String = "Sentyment"
        override val toursLowercase: String = "wycieczki"
        override val interestedLowercase: String = "zainteresowane"
        override val noRepeatedFeedbackMentions: String = "Nie odnotowano jeszcze żadnych powtórzeń zwrotnych."
        override val scoresMentionRates: String = "Wyniki to stawki wymieniające zapisane informacje o kupującym."
        override val aiExecutiveBriefing: String = "Odprawa wykonawcza w sprawie ptasiej grypy"
        override val viewAllAiInsights: String = "Zobacz wszystkie spostrzeżenia AI - >"
        override val followUpsSentTitle: String = "Follow- Ups Wysłany"
        override val financingPacketsShared: String = "Finansowanie pakietów wspólnych"
        override val buyerCalls: String = "Rozmowy kupujących"
        override val propertyDataEvidence: String = "Dowody dotyczące danych majątkowych"
        override val attendanceCoverage: String = "Zakres uczestnictwa"
        override val leadQuality: String = "Jakość ołowiu"
        override val followUpExecution: String = "Wykonanie w górę"
        override val activityChannels: String = "Kanały aktywności"
        override val callsLowercase: String = "rozmowy"
        override val emailsLowercase: String = "e-maile"
        override val offerReadinessScore: String = "Ocena gotowości oferty"
        override val date: String = "Data"
        override val propertyLeadFunnel: String = "Lejek wiodący do nieruchomości"
        override val openHouseBreakdown: String = "Podział na domy otwarte"
        override val aiInsights: String = "AI Insights"
        override val generateAiInsights: String = "Generuj zapowiedzi AI"
        override val analyticsOverview: String = "Przegląd analityczny"
        override val allAgents: String = "Wszyscy agenci"
        override val me: String = "do"
        override val allActivity: String = "Wszystkie działania"
        override val latest30Days: String = "Ostatnie 30 dni"
        override val latest7Days: String = "Ostatnie 7 dni"
        override val analyticsDatePreset: String = "Zakres daty"
        override val analyticsCustomDate: String = "Data własna"
        override val analyticsLastDay: String = "Ostatni dzień"
        override val analyticsLastWeek: String = "W zeszłym tygodniu"
        override val analyticsLastMonth: String = "Ostatni miesiąc"
        override val analyticsLastYear: String = "W zeszłym roku"
        override val analyticsAllTime: String = "Cały czas"
        override val analyticsDateFrom: String = "Data"
        override val analyticsDateTo: String = "Data"
        override val analyticsOpenHousesLowercase: String = "dni otwarte"
        override val analyticsWarmLeadsLowercase: String = "ciepłe przewody"
        override val analyticsFromNotesFollowUps: String = ""
        override val analyticsFromText: String = "z tekstu"
        override val analyticsHotConversion: String = "Konwersja na gorąco"
        override val analyticsHotLeadsPerVisitors: String = "gorący trop / odwiedzający"
        override val analyticsAverageIntent: String = "Zamiar Avg."
        override val analyticsVisitorIntentScore: String = "liczba intencji odwiedzających"
        override val analyticsSelectDate: String = "Wybierz datę"
        override val propertyFunnel: String = "Lejek własności"
        override val propertyFunnelSubtitle: String = "Od działalności w zakresie nieruchomości do kwalifikowanego tempa nabywcy"
        override val properties: String = "Właściwości"
        override val tourSignals: String = "Sygnały trasy"
        override val offerSignals: String = "Sygnały ofertowe"
        override val viewFullFunnelReport: String = "Wyświetl pełny raport lejek"
        override val performanceOverTime: String = "Wydajność w czasie"
        override val thirtyDays: String = "30 dni"
        override val topPerformingProperties: String = "Najlepsze właściwości"
        override val viewAll: String = "Wyświetl wszystkie"
        override val noPropertyAnalyticsYet: String = "Nie ma jeszcze analizy własności."
        override val leadQualityBreakdown: String = "Podział jakości ołowiu"
        override val warmLeadsTitle: String = "Ciepłe przewody"
        override val coldLeadsTitle: String = "Ołów chłodny"
        override val followUpPerformance: String = "Poszerzenie wydajności"
        override val agentPerformance: String = "Wydajność agenta"
        override val viewTeamReport: String = "Zobacz raport zespołu"
        override val followUpChannels: String = "Kanały follow- up"
        override val viewReport: String = "Wyświetl raport"
        override val searchProperties: String = "Właściwości wyszukiwania"
        override val searchOpenings: String = "Szukaj otwartych domów"
        override val noOpeningsFoundTitle: String = "Nie znaleziono otwartych domów."
        override val noOpeningsFoundBody: String = "Spróbuj innego filtru statusu wyszukiwania lub dnia otwartego."
        override val noMatchingPropertiesTitle: String = "Brak właściwości dopasowujących"
        override val noMatchingPropertiesBody: String = "Spróbuj innego filtru wyszukiwania lub statusu."
        override val clientsTitle: String = "Kontakty"
        override val clientFallback: String = "Kontakt"
        override val addClient: String = "Dodaj kontakt"
        override val editClient: String = "Edytuj kontakt"
        override val newClient: String = "Nowy kontakt"
        override val saveClient: String = "Zapisz kontakt"
        override val createClient: String = "Utwórz kontakt"
        override val deleteClientTitle: String = "Skasować kontakt?"
        override val deleteClientBody: String = "To na stałe usunie kontakt. Tego nie da się cofnąć."
        override val firstName: String = "Imię"
        override val lastName: String = "Nazwisko"
        override val email: String = "E-mail"
        override val phone: String = "Telefon"
        override val comments: String = "Uwagi"
        override val addPhoto: String = "Dodaj zdjęcie"
        override val sendQr: String = "Wyślij QR"
        override val sendQrShareTitle: String = "Twój otwarty dom HAVN QR"
        override val sendQrShareBody: String = "Twój otwarty dom HAVN QR jest dołączony. Dodaj przepustkę Portfela (.pkpass) do telefonu, gdy jest dostępna, lub pokaż obraz QR w otwartym domu."
        override val sendQrReadyMessage: String = "Kod QR gotowy do wysłania"
        override val sendQrUnavailableError: String = "Żaden e-mail ani aplikacja SMS nie są dostępne dla tego kontaktu."
        override val clientQrDeliveryRequired: String = "Dodaj e-mail lub numer telefonu dla dostawy QR."
        override val photo: String = "Zdjęcie"
        override val clientDetailSubtitle: String = "Tożsamość QR, dane kontaktowe, komentarze i dni otwarte połączone za pośrednictwem tropów."
        override val clientFormEditSubtitle: String = "Aktualizuj dane kontaktowe, informacje o dostawie i komentarze."
        override val clientFormNewSubtitle: String = "Zarejestruj nabywcę / kontakt i wygeneruj powtarzalną tożsamość QR dla otwartych domów."
        override val searchClients: String = "Kontakty wyszukiwania"
        override val noClientsYetTitle: String = "Brak kontaktów"
        override val noClientsYetBody: String = "Najpierw zarejestruj kontakty, a następnie wyślij swój kod QR pocztą elektroniczną lub SMS przed otwarciem domu."
        override val noClientsFoundTitle: String = "Brak kontaktów"
        override val noClientsFoundBody: String = "Spróbuj innego nazwiska, telefonu lub e-maila."
        override val clientUnavailableTitle: String = "Kontakt niedostępny"
        override val clientUnavailableBody: String = "Odśwież listę kontaktów i otwórz ponownie ten rekord."
        override val noCommentsAdded: String = "Brak komentarzy."
        override val openingsTitle: String = "Dni otwarte"
        override val clientOpeningsEmpty: String = "Nie ma jeszcze otwartych domów. Prowadzą do kontaktu z otwartym domem."
        override val clientPassLabel: String = "Portfel"
        override val clientNoEmail: String = "Brak e-maila"
        override val visitorsBody: String = "Otwórz tryb kiosku, skanuj kontakt QR lub dodaj istniejące kontakty jako wskazówki dla tego dnia otwartego."
        override val openKiosk: String = "Otwórz kioskName"
        override val addQrClient: String = "Dodaj kontakt QR"
        override val addManually: String = "Dodaj ręcznie"
        override val selectClients: String = "Wybierz kontakty"
        override val selectClientsBody: String = "Wybierz kontakty z listy. Każdy wybrany kontakt staje się liderem dla tego dnia otwartego."
        override val kioskCheckIn: String = "Kontrola Kiosk"
        override val kioskCheckInBody: String = "Użyj tylnej kamery, aby zeskanować kontakt z HAVN Wallet QR. Kiedy kod jest rozpoznawany, HAVN tworzy prowadzenie dla tego dnia otwartego automatycznie."
        override val scanWithCamera: String = "Przeskanuj z tylną kamerą"
        override val clientQrImage: String = "Skontaktuj się z obrazem QR"
        override val clientQrImageBody: String = "Trzymaj QR kontaktu wewnątrz złotego kwadratu. HAVN zbiera każdy skan poniżej."
        override val scanMultipleQrBody: String = "Przeskanuj jeden lub więcej kodów HAVN kontaktowych QR, a następnie stuknij pozycję Dodaj kontakt QR."
        override val scannedQrReady: String = "kontakt QR gotowy do dodania"
        override val createLeadFromQr: String = "Utwórz ołów z QR"
        override val noClientsFoundShort: String = "Żadnych kontaktów."
        override val remove: String = "Usuń"
        override val tasksTitle: String = "Zadania"
        override val addTask: String = "Dodaj zadanie"
        override val searchTasks: String = "Zadania wyszukiwania"
        override val loadMoreTasks: String = "Wczytaj więcej zadań"
        override val createTask: String = "Utwórz zadanie"
        override val saveTask: String = "Zapisz zadanie"
        override val editTask: String = "Edytuj zadanie"
        override val newTask: String = "Nowe zadanie"
        override val taskDetails: String = "Szczegóły zadania"
        override val taskName: String = "Nazwa"
        override val taskDescription: String = "Opis"
        override val taskDueDateTime: String = "Data zadania i czas"
        override val chooseTaskDateTime: String = "Wybierz datę zadania i czas"
        override val clearTaskDateTime: String = "Wyczyść datę i czas"
        override val assignToAgent: String = "Przypisz agentowi"
        override val noAgencyAgentsFound: String = "Nie znaleziono agentów agencji. Zadanie zostanie przydzielone właścicielowi."
        override val taskPriority: String = "Priorytet zadania"
        override val taskStatus: String = "Status"
        override val taskVisibility: String = "Widoczność"
        override val taskOwner: String = "Właściciel"
        override val taskOwnerFallback: String = "Właściciel zadania"
        override val assignedTo: String = "Przyznane do"
        override val selectedAgent: String = "Wybrany agent"
        override val taskVisibilityBody: String = "To zadanie jest widoczne dla właściciela i wyznaczonego agenta."
        override val taskQueue: String = "Kolejka zadań"
        override val taskDetail: String = "Szczegóły zadania"
        override val taskDetailEmpty: String = "Wybierz zadanie, aby zobaczyć kontekst i kolejne działania."
        override val connectedContext: String = "Połączony kontekst"
        override val noTaskContext: String = "Brak nieruchomości, kontaktu, dnia otwartego, lub ołowiu jest jeszcze połączone."
        override val activityTimeline: String = "Czas działania"
        override val created: String = "Stworzony"
        override val recently: String = "Ostatnio"
        override val completed: String = "Zakończono"
        override val nextAction: String = "Następna akcja"
        override val agentReviewOrCompletion: String = "Przegląd lub ukończenie czynności"
        override val noDueDate: String = "Brak terminu"
        override val reopen: String = "Otwórz ponownie"
        override val accept: String = "Akceptuj"
        override val linkedTasks: String = "Powiązane zadania"
        override val noLinkedTasks: String = "Żadnych powiązanych zadań."
        override val filesTitle: String = "Pliki"
        override val attachFile: String = "Dołącz plik"
        override val noFilesAttached: String = "Nie ma jeszcze załączonych plików."
        override val fileLimitHint: String = "Pliki mogą być PDF, DOC, CAD lub inne formaty do 20 MB każdy."
        override val deleteFileTitle: String = "Usuń plik?"
        override val deleteFileBody: String = "Plik ten zostanie usunięty z pamięci HAVN."
        override val attachmentOpenFailed: String = "Nie można otworzyć tego pliku."
        override val attachmentDeleteOwnerOnly: String = "Tylko właściciel pliku może usunąć ten załącznik."
        override val attachmentDocumentsNotIncluded: String = "Twój obecny plan nie zawiera plików. Upgrade do przesyłania plików."
        override val attachmentDocumentStorageNotIncluded: String = "Twój obecny plan nie obejmuje przechowywania dokumentów. Upgrade do przesyłania plików."
        override val attachmentFileSizePlanLimit: String = "Ten plik jest większy, niż pozwala twój obecny plan. Upgrade do wysyłania większych plików."
        override val attachmentStoragePlanLimit: String = "Limit pamięci dla bieżącego planu. Upgrade, aby przesłać więcej plików."
        override val attachmentDocumentCountPlanLimit: String = "Ograniczenie dokumentu dla tej właściwości w bieżącym planie. Upgrade, aby przesłać więcej plików."
        override val attachmentHardFileLimit: String = "Załączniki plików są ograniczone do 100 MB."
        override val openFiles: String = "Otwórz plik (-y)"
        override val sendViaEmail: String = "Wyślij przez e-mail"
        override val sendViaSms: String = "Wyślij przez SMS"
        override val sendEmailHeader: String = "Wyślij e-mail"
        override val sendSmsHeader: String = "Wyślij SMS"
        override val noContactsFound: String = "Żadnych kontaktów."
        override val searchContacts: String = "Kontakty wyszukiwania"
        override val linked: String = "Powiązane"
        override val recent: String = "Ostatnie"
        override val taskColumnToDo: String = "Do zrobienia"
        override val taskColumnInProgress: String = "W toku"
        override val taskColumnDone: String = "Gotowe"
        override val taskColumnToDoSubtitle: String = "Nowe zadania i kolejne działania czekają na rozpoczęcie."
        override val taskColumnInProgressSubtitle: String = "Praca obecnie własnością ciebie lub zespołu."
        override val taskColumnDoneSubtitle: String = "Wykonane zadania były widoczne dla pewności siebie zespołu."
        override val taskEmptyToDo: String = "Nie ma zadań do wykonania."
        override val taskEmptyInProgress: String = "Nic w toku."
        override val taskEmptyDone: String = "Nie wykonano jeszcze żadnych zadań."
        override val taskKanbanEmptyToDo: String = "Nic nie czeka. Pojawią się tu nowe działania następcze i sprawozdania."
        override val taskKanbanEmptyInProgress: String = "Brak aktywnej pracy."
        override val taskKanbanEmptyDone: String = "Wykonane zadania wylądują tutaj."
        override val taskEmptyBodyPrefix: String = "Utwórz zadanie lub przenieś inne zadanie do"
        override val taskEmptyBodySuffix: String = "."
        override val taskActionStart: String = "Start"
        override val taskActionOverdue: String = "Nadwyżka"
        override val taskActionCancel: String = "Anuluj"
        override val taskPriorityLow: String = "Niski"
        override val taskPriorityMedium: String = "Średni"
        override val taskPriorityHigh: String = "Wysoki"
        override val taskPriorityUrgent: String = "Pilne"
        override val taskStatusOpen: String = "Otwórz"
        override val taskStatusInProgress: String = "W toku"
        override val taskStatusDone: String = "Gotowe"
        override val taskStatusOverdue: String = "Nadwyżka"
        override val taskStatusCancelled: String = "Anulowane"
        override val aiSuggestedTasks: String = "AI Sugerowane zadania"
        override val noAiSuggestedTasks: String = "Jeszcze żadnych sugestii. HAVN zaproponuje zadania po otwartych domach i działalności wiodącej."
        override val taskFilterToday: String = "Dzisiaj"
        override val taskFilterUpcoming: String = "Nadchodzące"
        override val taskFilterOverdue: String = "Nadwyżka"
        override val taskFilterCompleted: String = "Zakończono"
        override val taskFilterAssignedToMe: String = "Przydzielone do"
        override val taskFilterAiSuggested: String = "AI Sugerowane"
        override val taskFilterEmptyToday: String = "Jesteś wolna na dzisiaj."
        override val taskFilterEmptyUpcoming: String = "Żadnych przyszłych zadań."
        override val taskFilterEmptyOverdue: String = "Żadnych zaległych zadań."
        override val taskFilterEmptyCompleted: String = "Nie wykonano jeszcze żadnych zadań."
        override val taskFilterEmptyAssignedToMe: String = "Żadnych zadań."
        override val taskFilterEmptyAiSuggested: String = "Żadna akceptowana AI nie sugerowała jeszcze zadań."
        override val taskSuggestionHotLeadTitlePrefix: String = "Należy kontynuować leczenie"
        override val taskSuggestionHotLeadTitleSuffix: String = "w ciągu 2 godzin."
        override val taskSuggestionHotLeadDescriptionPrefix: String = "Hot lead from"
        override val taskSuggestionHotLeadDescriptionSuffix: String = "Utrzymuj tempo, póki intencje są świeże."
        override val taskSuggestionHotLeadReason: String = "Nowy gorący trop schwytany."
        override val taskSuggestionSellerReportTitlePrefix: String = "Generuj raport sprzedającego"
        override val taskSuggestionSellerReportTitleSuffix: String = "."
        override val taskSuggestionSellerReportDescription: String = "Podsumować głośność odwiedzających, gorące tropy, śledzenie aktywności i sentyment kupca."
        override val taskSuggestionSellerReportReason: String = "Otwarty dom się skończył."
        override val taskSuggestionReviewFollowUpTitlePrefix: String = "Przegląd i wysyłanie"
        override val taskSuggestionReviewFollowUpTitleSuffix: String = "Kontynuuj."
        override val taskSuggestionReviewFollowUpReason: String = "W dalszym ciągu potrzebny jest przegląd agenta."
        override val taskSuggestionKioskTitle: String = "Przygotować tryb kiosku i zweryfikować zdjęcia nieruchomości."
        override val taskSuggestionKioskDescription: String = "Potwierdź sign- w przepływie, galeria i otwarte szczegóły domu przed przybyciem kupujących."
        override val taskSuggestionKioskReason: String = "Otwarty dom jest zaplanowany."
    }

    private val hungarian: HavnStrings = object : HavnStrings {
        override val navToday: String = "Ma"
        override val navProperties: String = "Tulajdonságok"
        override val navLeads: String = "Érdeklődők"
        override val navReports: String = "Jelentések"
        override val navTasks: String = "Feladatok"
        override val navAnalytics: String = "Analitikai módszerek"
        override val navAgency: String = "Ügynökség"
        override val navSettings: String = "Beállítások"
        override val navAuth: String = "Ügynöki hozzáférés"
        override val navOpenHouses: String = "Nyílt napok"
        override val navTours: String = "Nyílt napok"
        override val navFollowUps: String = "Kapcsolatok"
        override val navFollow: String = "Kapcsolatok"
        override val back: String = "Vissza"
        override val settingsEyebrow: String = "Számla"
        override val settingsTitle: String = "Beállítások"
        override val settingsSubtitle: String = "Bróker profil, meghívó politika, tároló vödrök, és csapatszerepek."
        override val agentProfileTitle: String = "Ügynöki profil"
        override val agentPhoto: String = "Ügynök fotó"
        override val uploading: String = "Feltöltés..."
        override val saving: String = "Megmentem..."
        override val validAgentPhotoRequired: String = "Válasszon egy érvényes ügynök fotót."
        override val signOut: String = "Kijelentkezés"
        override val signOutQuestion: String = "Kijelentkezik?"
        override val signOutConfirmation: String = "Biztosan kijelentkezik a HAVN-ból?"
        override val deleteAccount: String = "Fiók törlése"
        override val deleteAccountQuestion: String = "Törli a fiókot?"
        override val deleteAccountOpenPageBody: String = "Ez megnyitja a számlatörlési kérések oldalát."
        override val deleteAccountReviewTitle: String = "Valódi fiók használata"
        override val deleteAccountReviewBody: String = "Ez az alkalmazás felülvizsgálati számla védett, így a bírálók nem veszítik el a hozzáférést a vizsgálat során. Kérjük, használjon egy valódi tesztszámlát a számlatörlés ellenőrzésére."
        override val upgrade: String = "Frissítés"
        override val premiumThemesTitle: String = "Prémium témák"
        override val premiumThemesUpgradePrompt: String = "Frissítés Pro, hogy kinyit prémium témák."
        override val appearanceTitle: String = "Megjelenés"
        override val appearanceBody: String = "Válassza ki a világos vagy sötét módot a web alkalmazás."
        override val previewComponents: String = "Előnézeti elemek"
        override val themeShowcaseTitle: String = "Témabemutató"
        override val showcaseButtons: String = "Gomb"
        override val showcasePrimaryAction: String = "Elsődleges fellépés"
        override val showcaseSecondaryAction: String = "Másodlagos cselekvés"
        override val showcaseGhostAction: String = "Szellemakció"
        override val showcaseTextField: String = "Szövegmező"
        override val showcaseFocusedBorder: String = "Fókuszált akcentushatár"
        override val showcaseSearchPreview: String = "Keresési előnézet"
        override val showcaseOpeningCheckedIn: String = "Open House check-in ma"
        override val showcaseSentAt: String = "Reggel 10: 30-kor küldték."
        override val themeObsidianGoldName: String = "Obszidián arany"
        override val themeObsidianGoldDescription: String = "Luxus fekete, grafit és meleg arany."
        override val themeMidnightSapphireName: String = "Éjféli zafír"
        override val themeMidnightSapphireDescription: String = "Mély haditengerészet, zafír kék, és ezüst akcentus."
        override val themeEmeraldEstateName: String = "Smaragd Estate"
        override val themeEmeraldEstateDescription: String = "Sötét smaragd, szén és pezsgő arany."
        override val themePlatinumStoneName: String = "Platinakő"
        override val themePlatinumStoneDescription: String = "Kőszürke, platina, puha fehér."
        override val themeBordeauxNoirName: String = "Bordeaux Noir"
        override val themeBordeauxNoirDescription: String = "Sötét bor, grafit és réz akcentus."
        override val commonChange: String = "Változás"
        override val agentPlanTitle: String = "Ügynöki terv"
        override val agentPlanBody: String = "Frissítse az élményt, válassza ki a tervet, hogy illik, hogyan működik a legjobban."
        override val currentPlan: String = "Jelenlegi terv"
        override val transferPlan: String = "Átutalási terv"
        override val transferPlanTitle: String = "Átutalási terv"
        override val transferPlanBody: String = "Az előfizetés áthelyezése egy másik HAVN számlára. Mindkét e-mail címnek igazolnia kell az ellenőrzési kódokat."
        override val transferTargetEmail: String = "Új fiók e-mail"
        override val transferSendCodes: String = "Hitelesítő kódok küldése"
        override val transferCodesSentTitle: String = "Elküldött ellenőrzési kódok"
        override val transferCodesSentBody: String = "Elküldtünk egy kódot az e-mailedre, és egy kódot az új fiókodra."
        override val transferYourCode: String = "Az e-mail kódja"
        override val transferTargetCode: String = "Új számlaszám"
        override val transferConfirm: String = "Átutalási terv"
        override val transferSuccessTitle: String = "Átültetett terv"
        override val transferSuccessBody: String = "Az előfizetés most csatlakozik az új HAVN számlához."
        override val restorePurchase: String = "Vásárlás újraindítása"
        override val agencySettingsProBody: String = "A Solo ügynökség alapértelmezés szerint aktív. A Pro segítségével létrehozhat vagy kiválaszthat egy közös ügynökséget."
        override val agencySettingsLockedBody: String = "A Solo ügynökség aktív. Az ügynökség változtatások feloldása Pro."
        override val soloAgency: String = "Solo ügynökség"
        override val defaultPrivateAgencyWorkspace: String = "Alapértelmezett magánügynökség"
        override val noAgenciesAvailableYet: String = "Még nem áll rendelkezésre ügynökség meghívó vagy saját ügynökség."
        override val oneOwnedAgencyHint: String = "Az ügynöksége fent van a listán. Egy ügynöknek lehet egy ügynöksége."
        override val createAgency: String = "Ügynökség létrehozása"
        override val createYourAgency: String = "Az ügynökség létrehozása"
        override val createAgencyBody: String = "Építsd meg a csapatod, menedzseld az ingatlanokat, és növeld az üzleted."
        override val agencyName: String = "Az Ügynökség neve"
        override val agencyEmail: String = "Az Ügynökség e-mail címe"
        override val logoOptional: String = "Logó (nem kötelező)"
        override val upgradeExperienceTitle: String = "Frissítse tapasztalatait"
        override val upgradeExperienceSubtitle: String = "Futtasd le az első Open House-t ingyen. Frissítés, ha több listára, nyílt napok, és Pro munkafolyamatok."
        override val soloAgentPlan: String = "Solo ügynök"
        override val proAgentPlan: String = "Pro ügynök"
        override val teamAgentPlan: String = "Csapat"
        override val soloBenefitActiveProperties: String = "100 aktív tulajdonság"
        override val soloBenefitAiFollowUps: String = "A MI nyomon követése (alap)"
        override val soloBenefitSellerReports: String = "Nincs eladójelentés"
        override val soloBenefitPersonalOnly: String = "Kizárólag személyes"
        override val proBenefitUnlimitedProperties: String = "Legfeljebb 10 000"
        override val proBenefitUnlimitedAi: String = "10 000 AI szöveges kérelem / hónap"
        override val proBenefitAdvancedReports: String = "Speciális eladói jelentések"
        override val proBenefitAgencyCreation: String = "Az Ügynökség létrehozása és irányítása"
        override val proBenefitInviteAgents: String = "Ügynökök meghívása és együttműködés"
        override val proBenefitSharedLeads: String = "Közös érdeklődők és csapatmunka"
        override val proBenefitAgencyBranding: String = "Az Ügynökség márkaneve"
        override val proBenefitAdvancedAnalytics: String = "Speciális analitika"
        override val teamBenefitLargeLimits: String = "Csapatszintű határértékek"
        override val teamBenefitPrioritySupport: String = "Prioritási e-mail támogatás"
        override val teamBenefitDailyBackups: String = "Napi mentések 7 napig"
        override val teamBenefitLargeStorage: String = "10GB dokumentumtárolás"
        override val startFreeTrial7Day: String = "Feliratkozás most"
        override val restorePurchases: String = "Vásárlás újraindítása"
        override val comparePlans: String = "Összehasonlító tervek"
        override val startFreeTrial: String = "Válassza ki a tervet"
        override val noCommitmentCancelAnytime: String = "Futtasd le az első Open House-t ingyen. Frissítsd, ha többre van szükséged."
        override val monthly: String = "Havi"
        override val yearly: String = "Éves"
        override val yearlySave20: String = "Éves"
        override val yearlySavings20: String = "Éves számlázás."
        override val perYear: String = "/ év"
        override val loadingPlans: String = "Tervek betöltése..."
        override val selectedPlanUnavailable: String = "Az előfizetés átmenetileg nem elérhető. Kérjük, próbálja meg később, vagy lépjen kapcsolatba támogatás."
        override val signInRequiredForPurchase: String = "Jelentkezzen be a vásárlás megkezdése előtt."
        override val subscriptionDisclosureIos: String = "Auto-megújuló előfizetés. A fizetés az Apple számlájára kerül felszámításra a vásárlás megerősítésekor. Az előfizetés automatikusan megújul, hacsak nem törli legalább 24 órával az aktuális időszak vége előtt. A megújítás a jelenlegi időszak vége előtt 24 órán belül esedékes. Az előfizetését az App Store fiók beállításaiban kezelheti vagy törölheti."
        override val subscriptionDisclosureAndroid: String = "Auto-megújuló előfizetés a Google Play-en keresztül. Minden számlázási időszakot felszámítunk, kivéve, ha lemondod. A Google Play előfizetései bármikor kezelhetők vagy törölhetők. A hozzáférés a fizetett időszak végéig tart."
        override val subscriptionDisclosureWeb: String = "Auto-megújuló előfizetés. Minden számlázási időszakot a kiválasztott fizetési mód használatával számol fel, hacsak nem törli. Bármikor kezelheti vagy törölheti a számlázási beállításokat. A hozzáférés a fizetett időszak végéig tart. Az adók alkalmazhatók."
        override val subscriptionAgreementPrefix: String = "A feliratkozással beleegyezik, hogy"
        override val subscriptionTermsOfUse: String = "HAVN Felhasználási feltételek"
        override val subscriptionAgreementAnd: String = "és"
        override val subscriptionPrivacyPolicy: String = "Adatvédelmi szabályzat."
        override val purchaseSuccessTitle: String = "Köszönöm a vásárlást."
        override val purchaseSuccessBody: String = "A HAVN előfizetés aktív és a terv készen áll."
        override val restoreSuccessTitle: String = "Vásárlás újraindítása"
        override val restoreSuccessBody: String = "A HAVN előfizetésed sikeresen helyreállt."
        override val purchaseCouldNotComplete: String = "A vásárlás nem fejeződött be. Kérjük, próbálja újra, vagy ellenőrizze az App Store vagy Google Play fiók."
        override val purchaseVerificationPending: String = "Your payment has not been confirmed yet. If you completed checkout, use Restore purchase to check again. You do not need to pay again."
        override val completeWebCheckout: String = "Complete payment in the checkout tab, then return here. Your access will update automatically once payment is confirmed."
        override val restoreCouldNotComplete: String = "Nem található aktív HAVN előfizetés erre a raktárszámlára."
        override val noActiveSubscriptionFound: String = "Nem található aktív HAVN előfizetés erre a raktárszámlára."
        override val compareActiveProperties: String = "Aktív tulajdonságok"
        override val compareAiFollowUps: String = "A vizsgálat eredményei"
        override val compareSellerReports: String = "Eladási jelentések"
        override val compareAdvancedAnalytics: String = "Speciális analitika"
        override val compareAgencyCreation: String = "Az Ügynökség létrehozása"
        override val compareJoinAgencies: String = "Csatlakozó ügynökségek"
        override val compareInviteAgents: String = "Meghívó ügynökök"
        override val compareSharedLeads: String = "Megosztott ólom"
        override val compareAgencyBranding: String = "Az Ügynökség márkaneve"
        override val comparePrioritySupport: String = "Prioritási támogatás"
        override val compareFeature: String = "Jellemzők"
        override val compareFreePlan: String = "Ingyenes"
        override val compareValueYes: String = "Igen."
        override val compareValueNo: String = "Nem."
        override val comparePricePerMonthUser: String = "Ár / hónap / Felhasználó"
        override val comparePricePerYearUser: String = "Ár / év / felhasználó"
        override val compareMaxPropertiesOwner: String = "Maximális tulajdonságok / tulajdonos"
        override val compareMaxContactsOwner: String = "Max. kapcsolatok / tulajdonos"
        override val compareMaxOpenHousesOwner: String = "Max. nyílt napok / tulajdonos"
        override val compareMaxLeadsOwner: String = "Max. érdeklődők / tulajdonos"
        override val compareMaxPhotosProperty: String = "Maximális képek ingatlanonként"
        override val compareMaxDocumentsProperty: String = "Maximális dokumentumok vagyononként"
        override val compareDocumentsStorage: String = "A dokumentumok tárolása"
        override val compareAgencyAgenda: String = "Az Ügynökség napirendje"
        override val compareAiTextRequestsMonth: String = "Szöveggeneráció-kérelmek / hónap"
        override val compareAnalytics: String = "Analitikai módszerek"
        override val compareTasks: String = "Feladatok"
        override val compareDocumentsStorageOwner: String = "Dokumentumok tárolása / tulajdonosa"
        override val compareMaxFileSizeOwner: String = "Maximális fájlméret / tulajdonos"
        override val compareEmailSupport: String = "E-mail támogatás"
        override val compareDailyBackups7Days: String = "7 napig tárolt napi mentések"
        override val compareKioskMode: String = "Kioszk üzemmód"
        override val unlimited: String = "Korlátlan"
        override val basic: String = "Alap"
        override val advanced: String = "Speciális"
        override val perMonth: String = "/ hónap"
        override val members: String = "tagok"
        override val upgradeToProForAgencyTools: String = "Frissítés Pro, hogy az ügynökség eszközök"
        override val languageTitle: String = "Nyelv"
        override val languageBody: String = "Válassza ki ennek az eszköznek az alkalmazás nyelvét."
        override val english: String = "Angol"
        override val slovak: String = "Szlovákia"
        override val unitsTitle: String = "Egységek és pénznem"
        override val unitsBody: String = "Válassza ki, hogyan jelennek meg az árak és az ingatlan méretei az alkalmazás egészében."
        override val measurementSystemTitle: String = "Mérés"
        override val metric: String = "Metric"
        override val imperial: String = "Császári"
        override val currencyTitle: String = "Pénznem"
        override val notificationsTitle: String = "Értesítések"
        override val notificationsBody: String = "Control push riasztások, csendes órák, és a típusok frissítések HAVN küldhet."
        override val notificationSettings: String = "Értesítési beállítások"
        override val notificationsSubtitle: String = "Csak fontos frissítések, szűrt a preferenciák."
        override val quietHoursTitle: String = "Csendes órák"
        override val quietHoursBody: String = "A HAVN nem kritikus lökéseket hagy ki csendes órákban. A számlázási és számlakérdések továbbra is tömörek."
        override val enableQuietHours: String = "Csendes órák engedélyezése"
        override val quietHoursStart: String = "Kezdés"
        override val quietHoursEnd: String = "Vége"
        override val timezoneLabel: String = "Időzóna"
        override val notificationTypesTitle: String = "Értesítéstípusok"
        override val notificationNewLeadCapturedTitle: String = "Új ólom rögzítve"
        override val notificationNewLeadCapturedBody: String = "Amikor egy nyílt nap vagy QR áramlás rögzíti egy ólom."
        override val notificationHotLeadTitle: String = "Melegként megjelölt ólom"
        override val notificationHotLeadBody: String = "Csak akkor, ha egy nyom nagy szándékú."
        override val notificationOpeningStartsSoonTitle: String = "A Nyílt Ház hamarosan kezdődik."
        override val notificationOpeningStartsSoonBody: String = "Egyetlen emlékeztető 30 perccel az indulás előtt."
        override val notificationOpeningSummaryReadyTitle: String = "Open House összefoglaló kész"
        override val notificationOpeningSummaryReadyBody: String = "Ha kész az esemény utáni összefoglaló."
        override val notificationSellerReportGeneratedTitle: String = "Eladási jelentés generálása"
        override val notificationSellerReportGeneratedBody: String = "Amikor az eladó jelentést készített."
        override val notificationAiFollowUpReadyTitle: String = "AI követő kész"
        override val notificationAiFollowUpReadyBody: String = "Ha a következő vázlat készen áll a felülvizsgálatra."
        override val notificationAgentInvitedTitle: String = "Ügynök meghívva az ügynökségre"
        override val notificationAgentInvitedBody: String = "Ügynökségi meghívók és tagsági változások."
        override val notificationLeadAssignedTitle: String = "Az Ön számára kijelölt ólom"
        override val notificationLeadAssignedBody: String = "Amikor egy csapattárs hozzád vezet."
        override val notificationLeadTransferredTitle: String = "Az ólom átkerült hozzád."
        override val notificationLeadTransferredBody: String = "Amikor egy ólom tulajdonosa hozzád költözik."
        override val notificationSubscriptionIssueTitle: String = "Előfizetés"
        override val notificationSubscriptionIssueBody: String = "Megújítási hibák és számlázási problémák."
        override val kioskSecurityTitle: String = "Kioszk biztonság"
        override val kioskSecurityBody: String = "Használja ezt a PIN-t, hogy elhagyja a kiosk módot, és visszatérjen az ügynök app."
        override val kioskPinLabel: String = "Kioszki PIN"
        override val mcpAccessTitle: String = "MCP hozzáférés"
        override val mcpAccessBody: String = "Híd HAVN Claude-nak, OpenAI-nak és más MCP ügyfeleknek a McP.Havnre.app.-nél. Minden terven elérhető."
        override val mcpAuthorizationBearer: String = "Engedélyezés: Bearer"
        override val mcpNoApiKeyCreated: String = "Nem létrehozott API kulcs"
        override val mcpNotUsedYet: String = "Még nem használt"
        override val mcpLastUsedPrefix: String = "Utoljára használt"
        override val mcpRevealApiKeyTitle: String = "Az API kulcsának felfedése"
        override val mcpRevealApiKeyBody: String = "A teljes kulcs csak a létrehozás vagy forgatás után jelenik meg."
        override val mcpCreateKey: String = "Kulcs létrehozása"
        override val mcpRotateKey: String = "A kulcs elforgatása"
        override val mcpRevokeKey: String = "A kulcs visszaállítása"
        override val mcpEndpointHint: String = "Használja a https: / / mcp.havnre.app / mcp végpontot ezzel a kulccsal, mint a Bearer token."
        override val mcpUpgradeHint: String = "MCP hozzáférés áll rendelkezésre minden HAVN terv."
        override val mcpUpgradePrompt: String = "MCP hozzáférés áll rendelkezésre minden HAVN terv."
        override val mcpCopied: String = "Másolt"
        override val mcpCopy: String = "Másolás"
        override val mcpLoading: String = "Berakodás"
        override val kioskFeaturedProperty: String = "Kiemelt tulajdon"
        override val kioskPrivateShowing: String = "Privát megjelenítés"
        override val kioskLuxuryListing: String = "Luxus lista"
        override val kioskFastCheckIn: String = "Gyors bejelentkezés"
        override val kioskExitContentDescription: String = "Kilépési kioszk"
        override val kioskWelcome: String = "Üdvözlöm."
        override val kioskGladHere: String = "Örülünk, hogy itt vagy."
        override val kioskScanToCheckIn: String = "Keresés"
        override val kioskReceivePropertyDetails: String = "és megkapja az ingatlan adatait"
        override val kioskOr: String = "vagy"
        override val kioskStartCheckInManually: String = "A bejelentkezés indítása manuálisan"
        override val kioskSecureInfo: String = "Az információi biztonságban vannak, és soha nem fogják megosztani."
        override val kioskExitTitle: String = "Kilépési kioszk"
        override val kioskExitBody: String = "Adja meg a kiosk PIN-t, hogy visszatérhessen az ügynök alkalmazáshoz."
        override val kioskIncorrectPin: String = "Helytelen PIN."
        override val kioskUnlock: String = "Nyisd ki!"
        override val kioskTellUsTitle: String = "Mesélj magadról."
        override val kioskTellUsBody: String = "Az információd csak a vendéglátó ügynöknek szól."
        override val kioskFullName: String = "Teljes név"
        override val kioskContinue: String = "Folytatás"
        override val kioskQuestionsTitle: String = "Néhány gyors kérdés."
        override val kioskQuestionsBody: String = "Ez segít az ügynöknek a megfelelő kontextusban."
        override val kioskWorkingWithAgentQuestion: String = "Egy ügynökkel dolgozol?"
        override val kioskYes: String = "Igen."
        override val kioskNo: String = "Nem."
        override val kioskInterestQuestion: String = "Mi érdekli?"
        override val kioskInterestBuying: String = "Vásárlás"
        override val kioskInterestInvesting: String = "Befektetés"
        override val kioskInterestBrowsing: String = "Csak nézelődöm."
        override val kioskInterestRelocating: String = "Áthelyezés"
        override val kioskFinish: String = "Befejezés"
        override val kioskThankYou: String = "Köszönöm."
        override val kioskEnjoyVisitPrefix: String = "Élvezze a látogatást a"
        override val kioskResetAutomatically: String = "Ez a kioszk automatikusan visszaáll."
        override val environmentTitle: String = "Környezet"
        override val environmentBody: String = "A kapcsolat részletei ehhez a felépítéshez vannak beállítva."
        override val secure: String = "Biztonságos"
        override val brokerageProfileTitle: String = "Bróker profil"
        override val brokerageProfileBody: String = "Csapat márkanév, ügynök meghívók, és értesítési preferenciák élnek itt."
        override val logout: String = "Kijelentkezés"
        override val languageChanged: String = "Megváltozott a nyelv"
        override val commonAdd: String = "Hozzáadás"
        override val commonEdit: String = "Szerkesztés"
        override val commonDelete: String = "Törlés"
        override val commonCancel: String = "Törlés"
        override val commonSave: String = "Mentés"
        override val commonCreate: String = "Létrehozás"
        override val commonDismiss: String = "Lelépés"
        override val commonAll: String = "Összes"
        override val commonDone: String = "Kész."
        override val commonSend: String = "Küldés"
        override val commonTime: String = "Idő"
        override val commonHour: String = "Óra"
        override val commonMinute: String = "Egy perc."
        override val commonAgency: String = "Ügynökség"
        override val commonSettings: String = "Beállítások"
        override val commonOpening: String = "Nyitott ház"
        override val commonPropertyName: String = "Tulajdonság"
        override val commonToday: String = "Ma"
        override val agencyToolsAvailable: String = "Az Ügynökség eszközei rendelkezésre állnak."
        override val agencySetupSubtitle: String = "Minden HAVN számlának van egy alapértelmezett ügynöksége. Pro lehetővé teszi, hogy kezelje a meghívókat, közös nyomokat, és a márkanév."
        override val agencyRecentActivity: String = "A legutóbbi tevékenység"
        override val agencyActivityNewLead: String = "Új ólom hozzáadása"
        override val agencyActivityInvitationAccepted: String = "Ügynök meghívása elfogadva"
        override val agencyActivityAgentJoined: String = "Az ügynök csatlakozott az ügynökséghez."
        override val agencyActivitySellerReport: String = "Eladó jelentés létrehozása"
        override val agencyWorkspaceTitle: String = "Ügynökség"
        override val agencyWorkspaceBody: String = "Válassza ki, melyik ügynökséggel dolgozik együtt."
        override val agencySoloActiveTitle: String = "A Solo ügynökség aktív"
        override val agencyProRequiredTitle: String = "Pro terv szükséges"
        override val agencyCreateOrAcceptInviteBody: String = "Hozzon létre egy ügynökséget, vagy fogadjon el egy meghívást, hogy együttműködjön egy másik ügynökséggel."
        override val agencyProUnlockBody: String = "Ügynökségi változások, meghívások, közös nyomok, és közös márkanév feloldása Pro."
        override val realEstate: String = "Ingatlan"
        override val proAgency: String = "Pro ügynökség"
        override val agencyBrandingTitle: String = "Az Ügynökség márkaneve"
        override val agencyBrandingBody: String = "Állítsa be az applikációban, a kioszkban és a csapatnézetekben látható ügynökségi nevet és logót."
        override val uploadLogo: String = "Feltöltési logó"
        override val saveAgency: String = "Az ügynökség mentése"
        override val yourAgencyRole: String = "Az ügynökség szerepe"
        override val agencyAgentsTitle: String = "Ügynökségi ügynökök"
        override val agencyAgentsBody: String = "Az ügynökségnél dolgozhatnak."
        override val inviteAgent: String = "Meghívó ügynök"
        override val loadingAgents: String = "Ügynökök betöltése..."
        override val noAgencyAgentsYet: String = "Még nincs ügynök."
        override val changeRole: String = "A változás szerepe"
        override val updating: String = "Frissítés..."
        override val deleting: String = "Törlés..."
        override val deleteInvite: String = "A meghívás törlése"
        override val chooseAgencyRoleFor: String = "Válassza ki az ügynökség szerepét"
        override val removeAccess: String = "Hozzáférés eltávolítása"
        override val inviteAgentBody: String = "Küldjön egy ügynökségi meghívót e-mailben. Az ügynök elfogadja, miután bejelentkezett ugyanazzal az e-mail."
        override val agentEmail: String = "Agent email"
        override val role: String = "Szerep"
        override val inviting: String = "Meghívás..."
        override val invite: String = "Meghívó"
        override val agents: String = "Ügynökök"
        override val ok: String = "Oké."
        override val personalActivePropertyLimit: String = "Személyi aktív vagyonkorlátozás"
        override val personalAccountAgencyToolsLocked: String = "A személyes számla aktív. Ügynökségi eszközök kinyit Pro."
        override val selected: String = "Kiválasztott"
        override val activeMembers: String = "aktív tagok"
        override val agencySharedWorkspaceBody: String = "Közös ingatlanok, kapcsolatok, nyílt napok, érdeklődők, nyomon követések, és jelentések használják ezt az ügynökséget."
        override val actLikeAgent: String = "Viselkedj ügynökként!"
        override val actAsAdmin: String = "Adminként jár el"
        override val actAsOwner: String = "Tulajdonosi tevékenység"
        override val actLikeAgentBody: String = "Használd az ügynökséget, mint egy normális ügynököt."
        override val actLikeAgentSelectedBody: String = "Csak a kijelölt vagy a tulajdonában lévő munka látható."
        override val agencyRoleOwner: String = "Tulajdonos"
        override val agencyRoleAdmin: String = "Admin"
        override val agencyRoleAgent: String = "Ügynök"
        override val agencyRoleAssistant: String = "Asszisztens"
        override val agencyRoleViewer: String = "Megjelenítő"
        override val agencyRoleOwnerDescription: String = "Teljes ügynökségi ellenőrzés, beleértve a tagokat, a márkanevet, a megbízásokat, a listákat, a érdeklődőket és a jelentéseket."
        override val agencyRoleAdminDescription: String = "Teljes ügynökségi irányítás, kivéve az ügynökség törlését."
        override val agencyRoleAgentDescription: String = "Munkák kijelölt listák, nyílt napok, ólmok, nyomon követés, jegyzetek, és az eladó jelentések."
        override val agencyRoleAssistantDescription: String = "Támogatja a listákat a vezérek szerkesztésével, a nyomon követések előkészítésével és a jelentések elkészítésével."
        override val agencyRoleViewerDescription: String = "Csak a műszerfalhoz és a jelentésekhez lehet hozzáférni."
        override val agencyCapabilityInviteRemoveMembers: String = "A tagok meghívása és eltávolítása"
        override val agencyCapabilityChangeRoles: String = "A tagok szerepének megváltoztatása"
        override val agencyCapabilityManageAllProperties: String = "Minden tulajdonság létrehozása, szerkesztése és törlése"
        override val agencyCapabilityAssignAgents: String = "Címzett ügynökök"
        override val agencyCapabilitySeeAllLeads: String = "Minden nyom megnézése"
        override val agencyCapabilityExportReports: String = "Exportjelentések"
        override val agencyCapabilityChangeBranding: String = "Az ügynökség márkajelzésének és beállításainak megváltoztatása"
        override val agencyCapabilityDeleteAgency: String = "Az ügynökség törlése"
        override val agencyCapabilityViewAssignedProperties: String = "A kijelölt tulajdonságok megtekintése"
        override val agencyCapabilityHostAssignedOpenings: String = "A fogadó által kijelölt nyílt napok"
        override val agencyCapabilitySeeAssignedLeads: String = "Lásd a kijelölt ingatlanokból és nyílt házakból származó ólomokat"
        override val agencyCapabilityAddNotes: String = "Megjegyzés hozzáadása"
        override val agencyCapabilitySendFollowUps: String = "Nyomkövetések küldése"
        override val agencyCapabilityCreateSellerReports: String = "Eladó jelentések készítése a kijelölt listákról"
        override val agencyCapabilityEditAssignedLeads: String = "A kijelölt csatornák szerkesztése"
        override val agencyCapabilityPrepareFollowUps: String = "A nyomon követés előkészítése"
        override val agencyCapabilityCreateDraftReports: String = "Jelentéstervezetek készítése"
        override val agencyCapabilityCannotDeleteProperties: String = "Nem sikerült törölni a tulajdonságokat"
        override val agencyCapabilityCannotInviteAgents: String = "Nem hívhat meg ügynököket, hacsak nem engedélyezett"
        override val agencyCapabilityViewDashboards: String = "A műszerfal megtekintése"
        override val agencyCapabilityViewReports: String = "Jelentések megtekintése"
        override val agencyCapabilityCannotEdit: String = "Nem sikerült szerkeszteni"
        override val commonVisitors: String = "Érdeklődők"
        override val commonHot: String = "Forró"
        override val commonWarm: String = "Meleg"
        override val commonCold: String = "Hideg"
        override val commonActive: String = "Aktív"
        override val commonPlanned: String = "Tervezett"
        override val commonArchived: String = "Archivált"
        override val commonPast: String = "Előző"
        override val commonFollowUps: String = "Follow-up"
        override val commonProperty: String = "Tulajdonság"
        override val commonAddress: String = "Cím"
        override val commonOpenHouse: String = "Nyitott ház"
        override val commonInquiry: String = "Vizsgálat"
        override val commonInquiries: String = "Vizsgálatok"
        override val generalInquiry: String = "Általános érdeklődés"
        override val generalInquiries: String = "Általános érdeklődések"
        override val propertyInquiry: String = "Ingatlan iránti érdeklődés"
        override val propertyInquiries: String = "Ingatlan iránti érdeklődések"
        override val addGeneralInquiry: String = "Általános érdeklődés hozzáadása"
        override val newGeneralInquiry: String = "Új általános érdeklődés"
        override val noGeneralInquiries: String = "Még nincs általános érdeklődés."
        override val noPropertyInquiries: String = "Még nincs ingatlan iránti érdeklődés."
        override val buyerLookingFor: String = "Mit keres ez a vevő?"
        override val locationCity: String = "Helyszín / város"
        override val radiusKm: String = "Körzet (km)"
        override val propertyType: String = "Ingatlantípus"
        override val budgetFrom: String = "Költségkeret ettől"
        override val budgetTo: String = "Költségkeret eddig"
        override val purchaseTimeline: String = "Vásárlás időzítése"
        override val createGeneralInquiry: String = "Általános érdeklődés létrehozása"
        override val saveGeneralInquiry: String = "Általános érdeklődés mentése"
        override val inquiryType: String = "Érdeklődés típusa"
        override val leadSource: String = "Lead forrása"
        override val notSpecified: String = "Nincs megadva"
        override val inquiryStatus: String = "Vizsgálati státus"
        override val inquiryFollowUp: String = "Vizsgálat nyomon követése"
        override val addInquiry: String = "A vizsgálat hozzáadása"
        override val searchInquiries: String = "Keresés"
        override val noInquiries: String = "Nincs vizsgálat"
        override val noInquiriesBody: String = "Használja a plusz gombot, hogy a vevő érdeklődését egy meglévő kapcsolat."
        override val inquiryUnavailableTitle: String = "Vizsgálat nem áll rendelkezésre"
        override val inquiryUnavailableBody: String = "A vizsgálatot lehet, hogy törölték, vagy még mindig berakodják."
        override val backToInquiries: String = "Vissza a vizsgálatokhoz"
        override val deleteInquiry: String = "A vizsgálat törlése"
        override val deleteInquiryQuestionPrefix: String = "Törlés"
        override val deleteInquiryQuestionSuffix: String = "Ebből a birtokból?"
        override val deleteInquiryTargetFallback: String = "Ez a vizsgálat"
        override val propertyInquiriesBody: String = "A vásárlók, akik kérdezősködtek erről az ingatlanról. A Leads-ben is megtalálhatók a kérdések."
        override val propertyInquiriesEmpty: String = "Adjon hozzá egy vizsgálatot az egyik kapcsolatának kiválasztásával."
        override val contactInquiriesBody: String = "Olyan tulajdonságokat, amikről ez a kapcsolat érdeklődött."
        override val contactInquiriesEmpty: String = "Még nincs ingatlanvizsgálat."
        override val viewInquiries: String = "Vizsgálatok megtekintése"
        override val createContactFirstForInquiry: String = "Először hozzon létre egy kapcsolatot, majd adja hozzá a vizsgálatot ebből a tulajdonból."
        override val commonCheckedIn: String = "Bejelentkezés"
        override val commonNotScheduled: String = "nem ütemezett"
        override val todayTitle: String = "Ma"
        override val todaySubtitle: String = "A napi otthon nyílt napok, érdeklődők, nyomon követések, és eladásra kész lendület."
        override val todayOpenHousesMetric: String = "nyílt napok"
        override val capturedMetric: String = "Fogva"
        override val priorityMetric: String = "prioritás"
        override val noActivePropertiesTitle: String = "Nincsenek aktív tulajdonságok"
        override val noActivePropertiesBody: String = "Adja hozzá vagy aktiválja a tulajdonságot, hogy megjelenjen a Today."
        override val checkIns: String = "Sakk-inek"
        override val allOpenHouses: String = "minden nyílt nap"
        override val pendingDrafts: String = "függőben lévő tervezetek"
        override val priorityLead: String = "Prioritási vezető"
        override val nextOpenHouseAt: String = "Következő nyílt nap a"
        override val noOpenHouseScheduled: String = "Nincs programozás"
        override val personalAccount: String = "Személyes számla"
        override val accountReady: String = "A számlája készen áll."
        override val realEstateApp: String = "Ingatlan alkalmazás"
        override val needHelp: String = "Segítsek?"
        override val contactSupport: String = "Kapcsolattartó támogatás"
        override val upgradePlan: String = "Frissítési terv"
        override val planSuffix: String = "Terv"
        override val todayActionsTitle: String = "A mai prioritások"
        override val agencyInvitation: String = "Az Ügynökség felkérése"
        override val joinAgency: String = "Csatlakozás"
        override val youWereInvitedAs: String = "Meghívtak, hogy"
        override val invitedBy: String = "a"
        override val decline: String = "Megszakítás"
        override val yourDefaultAgency: String = "Az Ön alapértelmezett ügynöksége"
        override val chooseAgencyBody: String = "Válassza ki, melyik ügynökséggel akar dolgozni. Az Ügynökség eszközei közé tartoznak a meghívók, a közös érdeklődők és a márkaépítés."
        override val agencyMembersSuffix: String = "tagok"
        override val quickActionTasksBody: String = "Sorozat"
        override val quickActionReportsBody: String = "Eladó"
        override val quickActionAnalyticsBody: String = "Trendek"
        override val quickActionAddPropertyTitle: String = "Hozzáadás"
        override val quickActionAddPropertyBody: String = "Lista"
        override val quickActionAddContactTitle: String = "Kapcsolat"
        override val quickActionAddContactBody: String = "Új"
        override val quickActionFilesTitle: String = "Fájlok"
        override val quickActionFilesBody: String = "Dokumentumok"
        override val firstRunStepsTitle: String = "Kezdje négy egyszerű lépéssel"
        override val firstRunAddProperty: String = "Ingatlan hozzáadása"
        override val firstRunScheduleOpening: String = "Menetrend nyitva tartás"
        override val firstRunStartGuestCheckIn: String = "Indítsa el a vendégellenőrzést"
        override val firstRunSendFollowUp: String = "Küldje a nyomon követést"
        override val greetingNamePrefix: String = "Szia."
        override val greetingAgent: String = "Üdv, ügynök."
        override val createListing: String = "Listázás létrehozása"
        override val newOwnerBuyer: String = "Új tulajdonos / vevő"
        override val documents: String = "Dokumentumok"
        override val whatOpeningNext: String = "Melyik ház lesz a következő?"
        override val whoCheckedIn: String = "Ki jelentkezett be?"
        override val whoNeedsFollowUp: String = "Kinek kell utána nézni?"
        override val whatShouldIDoNow: String = "Most mit csináljak?"
        override val noCheckInsYet: String = "Még nem jelentkezett be senki."
        override val noPendingFollowUps: String = "Nincs folyamatban lévő ellenőrzés."
        override val openKioskForNextOpening: String = "Nyisd ki a kioszkot a következő nyílt napra."
        override val reviewNewLeads: String = "Átnézzük az új nyomokat, és követjük őket."
        override val createOpeningToStart: String = "Hozzon létre egy nyílt napat egy ingatlanból, hogy elkezdjen gyűjteni nyomokat."
        override val addFirstPropertyToStart: String = "Adja hozzá az első ingatlan kezdeni."
        override val nextOpening: String = "Következő nyílt nap"
        override val quickSignIn: String = "Gyors jelzés"
        override val scanQrCode: String = "QR-kód keresése"
        override val newLead: String = "Új ólom"
        override val myProperties: String = "A tulajdonaim."
        override val manageListings: String = "A listák kezelése"
        override val todaysOverview: String = "A mai áttekintés"
        override val seeAll: String = "Lásd az összes"
        override val propertiesEyebrow: String = "Portfólio"
        override val propertiesSubtitle: String = "Aktív, tervezett és archivált listák kezelése listázó média, vevő tevékenység, és teljesítmény betekintést."
        override val propertiesLiveMetric: String = "élő"
        override val propertiesPipelineMetric: String = "csővezeték"
        override val propertiesAllTimeMetric: String = "mindig"
        override val addProperty: String = "Ingatlan hozzáadása"
        override val editProperty: String = "Ingatlanszerkesztés"
        override val propertyFallback: String = "Tulajdonság"
        override val propertyUnavailableTitle: String = "Ingatlan nem áll rendelkezésre"
        override val propertyUnavailableBody: String = "Frissítse fel a portfóliót, hogy újratöltse a listát."
        override val backToProperties: String = "Vissza a tárgyakhoz"
        override val deletePropertyTitle: String = "Törölni a tulajdonjogot?"
        override val deletePropertyBody: String = "Ez véglegesen törli az ingatlant és annak kapcsolódó helyi nyilvántartásait. Ezt nem lehet visszacsinálni."
        override val loadingProperties: String = "Betöltési tulajdonságok"
        override val loadMore: String = "Több betöltése"
        override val loadingPropertyDetails: String = "Ingatlanadatok betöltése"
        override val noPropertiesTitle: String = "Még nincsenek tulajdonságok."
        override val noPropertiesBody: String = "Add hozzá az első ingatlant, majd hozzon létre egy nyílt napat, hogy elkezdje gyűjteni a érdeklődőket és seller-kész visszajelzéseket."
        override val openHouseButton: String = "Nyitott ház létrehozása"
        override val photosTitle: String = "Fényképek"
        override val photosBody: String = "Az első fotó a fő ingatlan kép a Portfolio."
        override val uploadPhoto: String = "A kép feltöltése"
        override val noPhotosYet: String = "Még nincsenek feltöltött fotók."
        override val propertyPhotoCountPlanLimit: String = "Fotó limit elérte ezt az ingatlant a jelenlegi terv. Frissítés, hogy több képet töltsön fel."
        override val propertyPhotoStoragePlanLimit: String = "A tárolási határérték elérte a jelenlegi tervet. Frissítés további képek vagy fájlok feltöltéséhez."
        override val mainPhoto: String = "Fő"
        override val propertyTitleLabel: String = "Tulajdonnév"
        override val propertyAddressLine1Label: String = "Utca címe"
        override val propertyAddressLine2Label: String = "2. címsor"
        override val propertyCityLabel: String = "Város"
        override val propertyRegionLabel: String = "Régió"
        override val propertyPostalCodeLabel: String = "Irányítószám"
        override val propertyCountryLabel: String = "Ország"
        override val propertyAskingPriceLabel: String = "Kérelmi ár"
        override val propertyBedsLabel: String = "Ágynemű"
        override val propertyBathsLabel: String = "Fürdőkád"
        override val propertyInteriorLabel: String = "Belső"
        override val propertyDescriptionLabel: String = "Leírás"
        override val createPropertyButton: String = "+ Tulajdonság"
        override val locateProperty: String = "Ingatlanok keresése"
        override val findLocation: String = "A hely keresése"
        override val find: String = "Keresés"
        override val navigate: String = "Naiv"
        override val propertyLocationMarkerTitle: String = "Tulajdoni hely"
        override val mapKitJsMissingToken: String = "Adja hozzá a HAVN _ MAPKIT _ JS _ TOKEN objektumokat a webes térképhez."
        override val mapKitJsLoading: String = "MapKit JS betöltése..."
        override val generateSellerReport: String = "Eladó jelentés készítése"
        override val deleteProperty: String = "Tulajdonság törlése"
        override val conversionMetric: String = "Átalakítás"
        override val propertyPhotoContentDescription: String = "Tulajdoni fénykép"
        override val deletePhoto: String = "A kép törlése"
        override val movePhotoLeft: String = "Mozgassa a képet balra"
        override val movePhotoRight: String = "Mozgassa a képet jobbra"
        override val propertyTitleRequired: String = "Az ingatlan neve szükséges."
        override val propertyStreetRequired: String = "Az utca címe szükséges."
        override val propertyCityRequired: String = "Város szükséges."
        override val propertyRegionRequired: String = "A régió szükséges."
        override val propertyPostalRequired: String = "Irányítószám szükséges."
        override val propertyAskingPriceInvalid: String = "Adjon meg egy érvényes kérési árat."
        override val propertyOwnerContactTitle: String = "A tulajdonos kapcsolattartója"
        override val propertyOwnerSelectContact: String = "Válasszon ki egy meglévő kapcsolatot az ingatlan tulajdonosaként."
        override val propertyOwnerSelected: String = "Kiválasztott tulajdonos"
        override val propertyOwnerNoContacts: String = "Még nincs kapcsolat. Adja hozzá a tulajdonos a Kapcsolatok, majd válassza ki őket itt."
        override val propertyOwnerChooseContact: String = "Kapcsolat kiválasztása"
        override val propertyOwnerChangeContact: String = "Kapcsolat megváltoztatása"
        override val propertyOwnerRemoveContact: String = "Eltávolítás"
        override val propertyOwnerPickerTitle: String = "Az ingatlantulajdonos kiválasztása"
        override val propertyOwnerSearchContact: String = "Keresés"
        override val propertyOwnerSearchHint: String = "Írjon be egy nevet, e-mailt vagy telefonszámot."
        override val propertyOwnerNoMatches: String = "Nincs egyező kapcsolat."
        override val propertyOpeningsTitle: String = "Nyílt napok"
        override val propertyNoOpenings: String = "Erre az ingatlanra nem terveznek házakat."
        override val teamAccessTitle: String = "Csoportos hozzáférés"
        override val onlyListingOwner: String = "Csak a tőzsdei tulajdonos"
        override val assignTeam: String = "Csapat hozzárendelése"
        override val assignPropertyTitle: String = "Tulajdonjog átruházása"
        override val assignPropertyBody: String = "Válassza ki, ki dolgozhat ezen a területen. Válassza ki az egész csapatot vagy különleges ügynököket."
        override val wholeTeam: String = "Teljes csapat"
        override val leadsEyebrow: String = "Érdeklődők"
        override val leadFallback: String = "Érdeklődő"
        override val leadsSubtitle: String = "Keresheti, szűrheti és minősítheti a nyílt napokon rögzített érdeklődőket."
        override val leadDetailSubtitle: String = "Az érdeklődő forrása, minősítése, jegyzetei és utánkövetési előzményei."
        override val totalMetric: String = "Összesen"
        override val loggedMetric: String = "naplózva"
        override val searchLeads: String = "Érdeklődők keresése"
        override val searchLeadsPlaceholder: String = "Név, telefon vagy e-mail"
        override val allProperties: String = "Összes tulajdonság"
        override val loadingLeads: String = "Érdeklődők betöltése"
        override val loadingLeadDetails: String = "Érdeklődő adatainak betöltése"
        override val noLeadsFoundTitle: String = "Az érdeklődők akkor jelennek meg itt, amikor bejelentkeznek egy nyílt napra."
        override val noLeadsEmptyBody: String = "Használja a kiosk check-in vagy adjunk hozzá kapcsolatokat manuálisan egy nyílt napból."
        override val noLeadsFilteredBody: String = "Próbálkozzon egy másik ingatlannal, státusszal vagy keresési kifejezéssel."
        override val backToLeads: String = "Vissza az érdeklődőkhöz"
        override val leadUnavailableTitle: String = "Az érdeklődő nem érhető el"
        override val leadUnavailableBody: String = "Ez az érdeklődő már nem szerepel az aktuális listán."
        override val leadTemperature: String = "Érdeklődő állapota"
        override val leadLabelSuffix: String = "Érdeklődő"
        override val greetingHi: String = "Szia."
        override val leadActionCall: String = "Hívás"
        override val leadActionSms: String = "SMS"
        override val leadActionEmail: String = "E-mail"
        override val leadFollowUp: String = "Follow-up"
        override val leadNoFollowUpScheduled: String = "Nincs utókövetés"
        override val leadIntentScore: String = "Intenzív pontszám"
        override val leadInterestedIn: String = "Érdekel"
        override val leadGenericGreetingName: String = "Ott."
        override val followUpMessageTypeThankYou: String = "Köszönöm."
        override val followUpMessageTypePropertyInfo: String = "Ingatlanadatok"
        override val followUpMessageTypeFollowUp: String = "Nyomon követés"
        override val followUpMessageTypeCheckIn: String = "Bejelentkezés"
        override val followUpMessageTypePriceUpdate: String = "Árfrissítés"
        override val followUpMessageTypePropertyBrochure: String = "Fájlok"
        override val followUpPreview: String = "Előnézet"
        override val followUpSubject: String = "Tárgy"
        override val followUpMessage: String = "Üzenet"
        override val followUpSendViaEmail: String = "Küldés e-mailben"
        override val followUpSendViaSms: String = "Küldés SMS-ben"
        override val followUpAiAssistantTitle: String = "AI asszisztens"
        override val followUpAiAssistantBody: String = "Készíts egy személyre szabott üzenetet másodpercek alatt."
        override val followUpGenerateWithAi: String = "Az MI generálása"
        override val followUpUpgradeForAi: String = "Az MI korszerűsítése"
        override val followUpDefaultSubject: String = "Nyomon követés"
        override val privateAgentNotes: String = "Magán ügynök jegyzetei"
        override val notes: String = "Megjegyzések"
        override val notesPlaceholder: String = "Motiváció, preferenciák, ellenvetések, következő lépés"
        override val saveNotes: String = "Megjegyzés mentése"
        override val followUpHistory: String = "Összegzés története"
        override val noFollowUpsLogged: String = "Még nincsenek bejelentkezve."
        override val openHousesEyebrow: String = "Bemutatók"
        override val scheduleOpenHouse: String = "Nyitott ház létrehozása"
        override val openingDetails: String = "Open House részletek"
        override val editOpening: String = "Nyitott ház szerkesztése"
        override val deleteOpening: String = "A nyílt nap törlése"
        override val deleteOpeningBody: String = "Biztos, hogy törölni akarod ezt a házat? Ezt nem lehet visszacsinálni."
        override val removeLeadTitle: String = "Eltávolítani az ólmot?"
        override val removeLeadBody: String = "Távolítsa el a (z)%s értéket a nyílt házból?"
        override val removeLeadFallback: String = "ez az ólom"
        override val openingName: String = "Open House név"
        override val startsAt: String = "Kezdődik"
        override val endsAt: String = "Végpontok"
        override val chooseStartDateTime: String = "Válassza ki a kezdési dátumot és időt"
        override val chooseEndDateTime: String = "Válassza ki a végső dátumot és időt"
        override val accessNotes: String = "Hozzáférési megjegyzések"
        override val privateNotes: String = "Privát megjegyzések"
        override val addPrivateNote: String = "Privát megjegyzés hozzáadása"
        override val liveDashboard: String = "Élő műszerfal"
        override val visitorKiosk: String = "Ólom-kioszk"
        override val openHousesSubtitle: String = "Nyílt napok létrehozása ingatlanok, áttekintés vezet, és indítsa kiosk ülések."
        override val liveMetric: String = "Élő"
        override val upcomingMetric: String = "Közeledik."
        override val inProgressMetric: String = "folyamatban"
        override val scheduledMetric: String = "ütemezett"
        override val loadingOpenHouses: String = "Nyílt napok betöltése"
        override val addPropertyFirstTitle: String = "Az ingatlan hozzáadása"
        override val addPropertyFirstBody: String = "Hozzon létre egy nyílt napat egy ingatlanból, hogy elkezdjen gyűjteni nyomokat."
        override val noOpenHousesTitle: String = "Nincs tervezett nyílt nap"
        override val noOpenHousesBody: String = "Hozzon létre egy nyílt napat egy ingatlanból, hogy elkezdjen gyűjteni nyomokat."
        override val noSignInsTitle: String = "Még nincs jel."
        override val noSignInsBody: String = "A kioszk üzemmódban bejelentkező érdeklődők valós időben jelennek meg itt."
        override val dashboard: String = "Hajódeszka"
        override val start: String = "Kezdés"
        override val end: String = "Vége"
        override val endOpenHouse: String = "Nyitott ház vége"
        override val reportsEyebrow: String = "Tulajdonosok"
        override val sellerReportsTitle: String = "Eladási jelentések"
        override val createReport: String = "Jelentés készítése"
        override val reportPreview: String = "Eladó jelentés"
        override val reportsSubtitle: String = "Hozzon létre prémium post- open- house recaps ólom minőségű, vevői szándék, és seller-kész narratíva."
        override val reportsMetricSaved: String = "mentett"
        override val reportedMetric: String = "jelentett"
        override val leadsMetric: String = "ólom"
        override val createSellerReport: String = "Jelentés készítése"
        override val attendance: String = "Részvétel"
        override val savedReports: String = "mentett jelentések"
        override val buyerHeat: String = "Vásárlási hő"
        override val hotLeads: String = "Hőhullámok"
        override val loadingSellerReports: String = "Az eladóról szóló jelentések betöltése"
        override val noSellerReportsTitle: String = "Még nem jelentettek eladót."
        override val noSellerReportsBody: String = "Válasszon egy nyílt napat, adjon hozzá ügynök jegyzetek, előzetes megtekintés egy export-kész összefoglalás, majd mentse el."
        override val chooseOpenHouse: String = "Válasszon nyílt napat"
        override val noOpenHousesAvailable: String = "Még nincs szabad ház."
        override val agentNotes: String = "Ügynöki feljegyzések"
        override val notesForSeller: String = "Értékesítő megjegyzések"
        override val sellerNotesPlaceholder: String = "Vásárlási kifogások, árjelzések, visszajelzések, ajánlott következő lépés"
        override val generatePreview: String = "Előnézet létrehozása"
        override val noPreviewReadyTitle: String = "Nincs előnézet kész"
        override val noPreviewReadyBody: String = "Készíts el egy eladójelentést a megtakarítás előtt."
        override val saveReport: String = "A jelentés mentése"
        override val reportSaved: String = "A jelentés mentése"
        override val sellerOpenHouseReport: String = "Eladó nyílt napi jelentés"
        override val mostCommonBuyerInterest: String = "A leggyakoribb vevői érdek"
        override val followUpsSent: String = "Küldött follow-ups"
        override val summary: String = "Összefoglaló"
        override val noPrivateNotesAdded: String = "Nincs hozzá privát jegyzet."
        override val openHouseReport: String = "Nyílt Ház jelentés"
        override val commonDraft: String = "Táblázat"
        override val commonAccepted: String = "Elfogadva"
        override val searchSellerReports: String = "Keresés eladó jelentések"
        override val noMatchingReports: String = "Nincs egyező jelentés"
        override val clearFilters: String = "Szűrők törlése"
        override val tryDifferentSearchOrStatusFilter: String = "Próbáljon meg egy másik keresési vagy állapotszűrőt."
        override val connectedToProperty: String = "Ingatlannal való kapcsolat"
        override val viewProperty: String = "Ingatlan megtekintése"
        override val dataRollup: String = "Adatfeltöltés"
        override val connectedOpenings: String = "Nyílt napok"
        override val visitors: String = "Látogatók"
        override val interestedBuyers: String = "Érdekelt vásárlók"
        override val completedFollowUps: String = "Ups követése"
        override val reportHistory: String = "A jelentés előzményei"
        override val noPreviousReportsYet: String = "Még nincsenek jelentések."
        override val viewAllReports: String = "Minden jelentés megtekintése"
        override val actions: String = "Intézkedések"
        override val generatePdf: String = "Táblázat létrehozása"
        override val previewPdf: String = "Előnézeti táblázat"
        override val pdfSavedToPropertyFiles: String = "%s elmentve ingatlanfájlokba."
        override val pdfSavingToPropertyFiles: String = "A (z)%s elmentve van az ingatlanfájlokra."
        override val pdfSavedToFiles: String = "%s elmentve fájlokba."
        override val pdfSavingToFiles: String = "A (z)%s fájlok mentése folyamatban van."
        override val pdfIncludesSellerReport: String = "Spreadsheet tartalmazza Eladó jelentés mérőszámok, AI betekintések, ügynök adatok, ingatlan adatok, és nyílt nap története."
        override val pdfIncludesAnalytics: String = "Spreadsheet magában foglalja az analitikai mérőszámokat, a felső tulajdonságok, ügynök teljesítmény, követő csatornák, és AI betekintések."
        override val pdfGenerateBeforeSending: String = "Küldés előtt készítse el a táblázatot."
        override val pdfUploadBeforeSharing: String = "A táblázatnak a megosztást megelőzően be kell fejeznie a feltöltést."
        override val sellerReportPdfNeedsProperty: String = "Eladó jelentés táblázat szüksége van egy kapcsolódó ingatlan feltöltése előtt."
        override val deleteReport: String = "Jelentés törlése"
        override val deleteReportBody: String = "Biztos, hogy törölni akarod ezt a jelentést? Ezt nem lehet visszacsinálni."
        override val shareReport: String = "Részesedési jelentés"
        override val openingPropertyReportLoading: String = "Ingatlanjelentés..."
        override val openingPropertyReportCreating: String = "Ingatlanjelentés készítése..."
        override val sellerReportGeneratedPrefix: String = "Eladási jelentés"
        override val sellerReportGeneratedSuffix: String = "nyílt házakból, látogatókból, érdeklődőkből, nyomon követésekből, és visszajelzésekből, melyek az ingatlanhoz kapcsolódtak."
        override val priceNotSet: String = "Nem rögzített ár"
        override val daysSuffix: String = "nap"
        override val connectedOpeningSingular: String = "nyílt nap"
        override val connectedOpeningPlural: String = "nyílt napok"
        override val connectedLeadSingular: String = "összekapcsolt ólom"
        override val connectedLeadPlural: String = "összekapcsolt érdeklődők"
        override val sellerConfidence: String = "Eladó bizalom"
        override val sellerConfidenceExplanation: String = "Bizalmi magyarázat"
        override val aiDraftReviewBeforeSending: String = "Csak mesterséges intelligencia. Felülvizsgálja és szerkeszti, mielőtt elküldi az eladó."
        override val executiveSummary: String = "Összefoglaló"
        override val buyerInterestOverview: String = "Megvásárlási kamat áttekintése"
        override val whatBuyersLoved: String = "Amit a vevők imádtak"
        override val buyerConcerns: String = "A vevő aggályai"
        override val leadQualitySummary: String = "Ólomminőségi összefoglaló"
        override val agentActivity: String = "Ügynöki tevékenység"
        override val aiRecommendations: String = "A madárinfluenza ajánlásai"
        override val recommendations: String = "Ajánlások"
        override val marketPositionComparison: String = "A piaci helyzet összehasonlítása"
        override val nextSteps: String = "Következő lépések"
        override val conversion: String = "Átalakítás"
        override val interested: String = "érdekelt"
        override val tourSignalsLowercase: String = "turistajelek"
        override val propertyTimeline: String = "Tulajdoni idővonal"
        override val timelineBasisNote: String = "Az ütemezés kizárólag a kapcsolódó nyílt ház regisztrációkon és nyomon követéseken alapul."
        override val visitorsLowercase: String = "látogatók"
        override val hotLeadsLowercase: String = "forró csíkok"
        override val hotLowercase: String = "forró"
        override val sentiment: String = "Érzékenység"
        override val toursLowercase: String = "túrák"
        override val interestedLowercase: String = "érdekelt"
        override val noRepeatedFeedbackMentions: String = "Ismételt visszajelzéseket még nem rögzítettek."
        override val scoresMentionRates: String = "A pontszámok említik a megtakarított fogyasztói visszajelzéseket."
        override val aiExecutiveBriefing: String = "Az MI vezetői eligazítás"
        override val viewAllAiInsights: String = "Minden AI betekintés megtekintése - >"
        override val followUpsSentTitle: String = "Follow- Ups küldött"
        override val financingPacketsShared: String = "Megosztott finanszírozási csomagok"
        override val buyerCalls: String = "Vásárlási hívások"
        override val propertyDataEvidence: String = "Tulajdoni adatok igazolása"
        override val attendanceCoverage: String = "Részvételi lefedettség"
        override val leadQuality: String = "Ólomminőség"
        override val followUpExecution: String = "Összesített végrehajtás"
        override val activityChannels: String = "Tevékenységi csatornák"
        override val callsLowercase: String = "hívások"
        override val emailsLowercase: String = "e-mailek"
        override val offerReadinessScore: String = "Ajánlatkészségi pontszám"
        override val date: String = "Időpont"
        override val propertyLeadFunnel: String = "Tulajdoni ólomtölcsér"
        override val openHouseBreakdown: String = "Nyílt ház szerinti bontás"
        override val aiInsights: String = "MI-észlelések"
        override val generateAiInsights: String = "Az MI-észlelések generálása"
        override val analyticsOverview: String = "Analitikai áttekintés"
        override val allAgents: String = "Minden ügynök"
        override val me: String = "A"
        override val allActivity: String = "Minden tevékenység"
        override val latest30Days: String = "Legújabb 30 nap"
        override val latest7Days: String = "Legújabb 7 nap"
        override val analyticsDatePreset: String = "Időtartomány"
        override val analyticsCustomDate: String = "Egyedi dátum"
        override val analyticsLastDay: String = "Utolsó nap"
        override val analyticsLastWeek: String = "Múlt héten"
        override val analyticsLastMonth: String = "Múlt hónapban"
        override val analyticsLastYear: String = "Tavaly"
        override val analyticsAllTime: String = "Mindig"
        override val analyticsDateFrom: String = "Dátum"
        override val analyticsDateTo: String = "Időpont"
        override val analyticsOpenHousesLowercase: String = "nyílt napok"
        override val analyticsWarmLeadsLowercase: String = "meleg ólom"
        override val analyticsFromNotesFollowUps: String = ""
        override val analyticsFromText: String = "szövegből"
        override val analyticsHotConversion: String = "Melegátalakítás"
        override val analyticsHotLeadsPerVisitors: String = "forró érdeklődők / látogatók"
        override val analyticsAverageIntent: String = "Avg. szándék"
        override val analyticsVisitorIntentScore: String = "látogatói szándék pontszám"
        override val analyticsSelectDate: String = "Dátum kiválasztása"
        override val propertyFunnel: String = "Ingatlantölcsér"
        override val propertyFunnelSubtitle: String = "Az ingatlantevékenységtől a minősített vevői lendületig"
        override val properties: String = "Tulajdonságok"
        override val tourSignals: String = "Tour jelek"
        override val offerSignals: String = "Ajánlati jelek"
        override val viewFullFunnelReport: String = "Teljes tölcsér jelentés megtekintése"
        override val performanceOverTime: String = "Teljesítmény idővel"
        override val thirtyDays: String = "30 nap"
        override val topPerformingProperties: String = "A legjobb teljesítményt nyújtó tulajdonságok"
        override val viewAll: String = "Minden nézet"
        override val noPropertyAnalyticsYet: String = "Még nincs ingatlanelemző."
        override val leadQualityBreakdown: String = "Ólomminőség szerinti bontás"
        override val warmLeadsTitle: String = "Meleg érdeklődők"
        override val coldLeadsTitle: String = "Hideg ólom"
        override val followUpPerformance: String = "Follow-up teljesítmény"
        override val agentPerformance: String = "Az ügynök teljesítménye"
        override val viewTeamReport: String = "A csapat áttekintése"
        override val followUpChannels: String = "Follow-up csatornák"
        override val viewReport: String = "Jelentés megtekintése"
        override val searchProperties: String = "Keresési tulajdonságok"
        override val searchOpenings: String = "Nyílt napok keresése"
        override val noOpeningsFoundTitle: String = "Nincs nyílt ház"
        override val noOpeningsFoundBody: String = "Próbálja meg egy másik keresés vagy nyílt nap státusz szűrő."
        override val noMatchingPropertiesTitle: String = "Nincs egyező tulajdonság"
        override val noMatchingPropertiesBody: String = "Próbálkozzon egy másik kereséssel vagy állapotszűrővel."
        override val clientsTitle: String = "Kapcsolatok"
        override val clientFallback: String = "Kapcsolat"
        override val addClient: String = "Kapcsolat hozzáadása"
        override val editClient: String = "Kapcsolat szerkesztése"
        override val newClient: String = "Új kapcsolat"
        override val saveClient: String = "Kapcsolat mentése"
        override val createClient: String = "Kapcsolat létrehozása"
        override val deleteClientTitle: String = "A kapcsolat törlése?"
        override val deleteClientBody: String = "Ez véglegesen törli a kapcsolatot. Ezt nem lehet visszacsinálni."
        override val firstName: String = "Keresztnév"
        override val lastName: String = "Vezetéknév"
        override val email: String = "E-mail"
        override val phone: String = "Telefon"
        override val comments: String = "Megjegyzések"
        override val addPhoto: String = "A kép hozzáadása"
        override val sendQr: String = "QR küldése"
        override val sendQrShareTitle: String = "A HAVN nyílt nap QR"
        override val sendQrShareBody: String = "A HAVN nyílt napad QR van csatolva. Adja hozzá a pénztárcát (.pkpass) a telefonhoz, ha elérhető, vagy mutassa meg a QR képet a nyílt napon."
        override val sendQrReadyMessage: String = "QR kód küldésre kész"
        override val sendQrUnavailableError: String = "Ehhez a kapcsolathoz nem áll rendelkezésre e-mail vagy SMS alkalmazás."
        override val clientQrDeliveryRequired: String = "Adjon hozzá egy e-mailt vagy telefonszámot a QR kézbesítéshez."
        override val photo: String = "Fotó"
        override val clientDetailSubtitle: String = "QR identitás, elérhetőségek, megjegyzések, és nyílt napok csatlakoztatva vezet."
        override val clientFormEditSubtitle: String = "Frissítse elérhetőségeit, szállítási info, és észrevételeket."
        override val clientFormNewSubtitle: String = "Regisztráljon egy vevőt / kapcsolatot, és hozzon létre egy újra használható QR identitást nyílt házak számára."
        override val searchClients: String = "Keresés"
        override val noClientsYetTitle: String = "Még nincs kapcsolat"
        override val noClientsYetBody: String = "Regisztráljon kapcsolatokat először, majd küldje el a QR kódot e-mailben vagy SMS-ben előtt egy nyílt ház."
        override val noClientsFoundTitle: String = "Nincs kapcsolat"
        override val noClientsFoundBody: String = "Próbáljon ki egy másik nevet, telefont vagy emailt."
        override val clientUnavailableTitle: String = "Kapcsolat nem elérhető"
        override val clientUnavailableBody: String = "Frissítse fel a névjegyzéket, és nyissa meg újra ezt a lemezt."
        override val noCommentsAdded: String = "Nincs hozzászólás."
        override val openingsTitle: String = "Nyílt napok"
        override val clientOpeningsEmpty: String = "Még nincsenek nyílt napok. A vezetőség kapcsolatba lép egy nyílt napzal."
        override val clientPassLabel: String = "Pénztárca"
        override val clientNoEmail: String = "Nincs e-mail"
        override val visitorsBody: String = "Nyissuk meg a kioszk módot, keressünk kapcsolatot a QR-rel, vagy adjunk hozzá kapcsolatot, mint vezetőt ehhez a nyílt házhoz."
        override val openKiosk: String = "Kioszk megnyitása"
        override val addQrClient: String = "QR kapcsolat hozzáadása"
        override val addManually: String = "Kézzel hozzáadva"
        override val selectClients: String = "Névjegyek kiválasztása"
        override val selectClientsBody: String = "Válasszon kapcsolatokat a listájáról. Minden egyes kiválasztott kapcsolat a nyílt ház nyomára válik."
        override val kioskCheckIn: String = "Kioszk-check-in"
        override val kioskCheckInBody: String = "Használja a hátsó kamerát, hogy letapogassa a kontaktus HAVN Wallet QR-ét. Amikor a kódot felismerik, a HAVN automatikusan létrehozza ennek a háznak a vezetését."
        override val scanWithCamera: String = "Keresés hátsó kamerával"
        override val clientQrImage: String = "Kapcsolat QR képpel"
        override val clientQrImageBody: String = "Tartsa a kapcsolatot az arany téren belül. A HAVN összegyűjti a lenti felvételeket."
        override val scanMultipleQrBody: String = "Keressen egy vagy több HAVN kapcsolatot QR-kódokkal, majd koppintson a Hozzáadás QR kapcsolatra."
        override val scannedQrReady: String = "A QR kapcsolatfelvétel kész"
        override val createLeadFromQr: String = "Vezeték létrehozása QR-ből"
        override val noClientsFoundShort: String = "Nincs kapcsolat."
        override val remove: String = "Eltávolítás"
        override val tasksTitle: String = "Feladatok"
        override val addTask: String = "Feladat hozzáadása"
        override val searchTasks: String = "Keresés"
        override val loadMoreTasks: String = "Több feladat betöltése"
        override val createTask: String = "Feladat létrehozása"
        override val saveTask: String = "A feladat mentése"
        override val editTask: String = "Feladat szerkesztése"
        override val newTask: String = "Új feladat"
        override val taskDetails: String = "Feladatok"
        override val taskName: String = "Név"
        override val taskDescription: String = "Leírás"
        override val taskDueDateTime: String = "Munkaidő"
        override val chooseTaskDateTime: String = "Válassza ki a feladat dátumát és időpontját"
        override val clearTaskDateTime: String = "Dátum és idő törlése"
        override val assignToAgent: String = "Ügynök kijelölése"
        override val noAgencyAgentsFound: String = "Nem találtak ügynököket. A feladat a tulajdonosé marad."
        override val taskPriority: String = "Feladatprioritás"
        override val taskStatus: String = "Állapot"
        override val taskVisibility: String = "Láthatóság"
        override val taskOwner: String = "Tulajdonos"
        override val taskOwnerFallback: String = "Feladattulajdonos"
        override val assignedTo: String = "Címzett:"
        override val selectedAgent: String = "Kiválasztott ügynök"
        override val taskVisibilityBody: String = "Ez a feladat látható a tulajdonos és a kijelölt ügynök."
        override val taskQueue: String = "Feladatsor"
        override val taskDetail: String = "Feladatok"
        override val taskDetailEmpty: String = "Válasszon ki egy feladatot, hogy a kontextus és a következő intézkedések."
        override val connectedContext: String = "Csatlakozott beállítások"
        override val noTaskContext: String = "Ingatlan, kapcsolat, nyílt nap, vagy ólom még nincs összekötve."
        override val activityTimeline: String = "Tevékenységi ütemterv"
        override val created: String = "Létrehozva"
        override val recently: String = "Nemrég"
        override val completed: String = "Befejezve"
        override val nextAction: String = "Következő intézkedés"
        override val agentReviewOrCompletion: String = "Ügynök felülvizsgálata vagy befejezése"
        override val noDueDate: String = "Nincs esedékesség napja"
        override val reopen: String = "Újraindítás"
        override val accept: String = "Elfogadás"
        override val linkedTasks: String = "Kapcsolt feladatok"
        override val noLinkedTasks: String = "Még nincsenek kapcsolódó feladatok."
        override val filesTitle: String = "Fájlok"
        override val attachFile: String = "Fájl csatolása"
        override val noFilesAttached: String = "Még nem csatolták az aktákat."
        override val fileLimitHint: String = "A fájlok lehetnek PDF, DOC, CAD, vagy más formátumok akár 20 MB minden."
        override val deleteFileTitle: String = "Fájl törlése?"
        override val deleteFileBody: String = "Ezt a fájlt eltávolítjuk a HAVN raktárból."
        override val attachmentOpenFailed: String = "Nem sikerült megnyitni ezt a fájlt."
        override val attachmentDeleteOwnerOnly: String = "Csak a fájltulajdonos törölheti ezt a csatolást."
        override val attachmentDocumentsNotIncluded: String = "A jelenlegi terv nem tartalmazza a fájlfeltöltéseket. Frissítse a fájlokat."
        override val attachmentDocumentStorageNotIncluded: String = "Az Ön jelenlegi terve nem tartalmazza a dokumentumok tárolását. Frissítse a fájlokat."
        override val attachmentFileSizePlanLimit: String = "Ez a fájl nagyobb, mint amit a jelenlegi terv lehetővé tesz. Frissítés nagyobb fájlok feltöltéséhez."
        override val attachmentStoragePlanLimit: String = "A tárolási határérték elérte a jelenlegi tervet. Frissítés további fájlok feltöltéséhez."
        override val attachmentDocumentCountPlanLimit: String = "Dokumentum limit elérte ezt az ingatlant a jelenlegi terv. Frissítés további fájlok feltöltéséhez."
        override val attachmentHardFileLimit: String = "A csatolások 100 MB-re korlátozódnak."
        override val openFiles: String = "Fájlok megnyitása"
        override val sendViaEmail: String = "Küldés e-mailben"
        override val sendViaSms: String = "Küldés SMS-ben"
        override val sendEmailHeader: String = "E-mail küldése"
        override val sendSmsHeader: String = "SMS küldése"
        override val noContactsFound: String = "Nincs kapcsolat."
        override val searchContacts: String = "Keresés"
        override val linked: String = "Kapcsolt"
        override val recent: String = "Nemrég"
        override val taskColumnToDo: String = "To do"
        override val taskColumnInProgress: String = "Folyamatban"
        override val taskColumnDone: String = "Kész."
        override val taskColumnToDoSubtitle: String = "Új feladatok és a következő intézkedések indulásra várnak."
        override val taskColumnInProgressSubtitle: String = "A munka jelenleg az öné vagy a csapaté."
        override val taskColumnDoneSubtitle: String = "Befejezett feladatok láthatóak a csapatbizalom érdekében."
        override val taskEmptyToDo: String = "Nincs mit tenni."
        override val taskEmptyInProgress: String = "Semmi sincs folyamatban."
        override val taskEmptyDone: String = "Még nincs befejezett feladat."
        override val taskKanbanEmptyToDo: String = "Semmi várakozás. Új utóvizsgálatok és jelentések jelennek meg itt."
        override val taskKanbanEmptyInProgress: String = "Nincs folyamatban aktív munka."
        override val taskKanbanEmptyDone: String = "A befejezett feladatok itt fognak leszállni."
        override val taskEmptyBodyPrefix: String = "Egy feladat létrehozása vagy egy másik feladat áthelyezése"
        override val taskEmptyBodySuffix: String = "."
        override val taskActionStart: String = "Kezdés"
        override val taskActionOverdue: String = "Túllépés"
        override val taskActionCancel: String = "Törlés"
        override val taskPriorityLow: String = "Alacsony"
        override val taskPriorityMedium: String = "Közepes"
        override val taskPriorityHigh: String = "Magas"
        override val taskPriorityUrgent: String = "Sürgős"
        override val taskStatusOpen: String = "Megnyitás"
        override val taskStatusInProgress: String = "Folyamatban"
        override val taskStatusDone: String = "Kész."
        override val taskStatusOverdue: String = "Túllépés"
        override val taskStatusCancelled: String = "Törölve"
        override val aiSuggestedTasks: String = "AI Javasolt feladatok"
        override val noAiSuggestedTasks: String = "Még nincs AI javaslat. A HAVN a nyílt napok és a vezető tevékenységek után feladatokat javasol."
        override val taskFilterToday: String = "Ma"
        override val taskFilterUpcoming: String = "Közeledik."
        override val taskFilterOverdue: String = "Túllépés"
        override val taskFilterCompleted: String = "Befejezve"
        override val taskFilterAssignedToMe: String = "Hozzám rendelt"
        override val taskFilterAiSuggested: String = "AI Javasolt"
        override val taskFilterEmptyToday: String = "Mára szabad vagy."
        override val taskFilterEmptyUpcoming: String = "Nincs közelgő feladat."
        override val taskFilterEmptyOverdue: String = "Nincs esedékes feladat."
        override val taskFilterEmptyCompleted: String = "Még nincs befejezett feladat."
        override val taskFilterEmptyAssignedToMe: String = "Nem kap feladatot."
        override val taskFilterEmptyAiSuggested: String = "Az MI még nem javasolt feladatokat."
        override val taskSuggestionHotLeadTitlePrefix: String = "A"
        override val taskSuggestionHotLeadTitleSuffix: String = "2 órán belül."
        override val taskSuggestionHotLeadDescriptionPrefix: String = "Forró ólom"
        override val taskSuggestionHotLeadDescriptionSuffix: String = "Tartsa a lendületet, amíg a szándék friss."
        override val taskSuggestionHotLeadReason: String = "Új forró ólmot fogtunk."
        override val taskSuggestionSellerReportTitlePrefix: String = "Eladó-jelentés generálása"
        override val taskSuggestionSellerReportTitleSuffix: String = "."
        override val taskSuggestionSellerReportDescription: String = "Összegezze a látogatók számát, forró nyomokat, nyomon követési tevékenységet, és a vevő érzéseit."
        override val taskSuggestionSellerReportReason: String = "A nyílt nap véget ért."
        override val taskSuggestionReviewFollowUpTitlePrefix: String = "Felülvizsgálat és küldés"
        override val taskSuggestionReviewFollowUpTitleSuffix: String = "Nyomon követés."
        override val taskSuggestionReviewFollowUpReason: String = "A sorozatokat még át kell nézni."
        override val taskSuggestionKioskTitle: String = "Készítsd elő a kioszk módot, és ellenőrizd az ingatlanképeket."
        override val taskSuggestionKioskDescription: String = "Erősítse meg a jelzéseket az áramlás, galéria, és a nyílt nap részleteit, mielőtt a vevők megérkeznek."
        override val taskSuggestionKioskReason: String = "A nyitvatartási idő szerint."
    }

    private val romanian: HavnStrings = object : HavnStrings {
        override val navToday: String = "Astăzi"
        override val navProperties: String = "Proprietăți"
        override val navLeads: String = "Lead-uri"
        override val navReports: String = "Rapoarte"
        override val navTasks: String = "Sarcini"
        override val navAnalytics: String = "Analize"
        override val navAgency: String = "Agenţie"
        override val navSettings: String = "Setări"
        override val navAuth: String = "Accesul agentului"
        override val navOpenHouses: String = "Vizionări deschise"
        override val navTours: String = "Vizionări deschise"
        override val navFollowUps: String = "Contacte"
        override val navFollow: String = "Contacte"
        override val back: String = "Înapoi"
        override val settingsEyebrow: String = "Cont"
        override val settingsTitle: String = "Configurări"
        override val settingsSubtitle: String = "Profilul de Brokerage, invita politica, găleți de depozitare, și rolurile echipei."
        override val agentProfileTitle: String = "Profilul agentului"
        override val agentPhoto: String = "Agent foto"
        override val uploading: String = "Încarc..."
        override val saving: String = "Salvarea..."
        override val validAgentPhotoRequired: String = "Alegeți o fotografie de agent valid."
        override val signOut: String = "Deconectare"
        override val signOutQuestion: String = "Vă deconectați?"
        override val signOutConfirmation: String = "Sigur doriți să vă deconectați de la HAVN?"
        override val deleteAccount: String = "Șterge contul"
        override val deleteAccountQuestion: String = "Ștergeți contul?"
        override val deleteAccountOpenPageBody: String = "Acest lucru va deschide pagina de cerere de ștergere a contului."
        override val deleteAccountReviewTitle: String = "Utilizați un cont real"
        override val deleteAccountReviewBody: String = "Acest cont de revizuire a aplicației este protejat astfel încât revizorii să nu piardă accesul în timpul testării. Vă rugăm să utilizați un cont de testare real pentru a verifica ștergerea contului."
        override val upgrade: String = "Actualizează"
        override val premiumThemesTitle: String = "Teme premium"
        override val premiumThemesUpgradePrompt: String = "Upgrade la Pro pentru a debloca teme premium."
        override val appearanceTitle: String = "Aspect"
        override val appearanceBody: String = "Alegeți modul lumină sau întuneric pentru aplicația web."
        override val previewComponents: String = "Componente previzualizare"
        override val themeShowcaseTitle: String = "Spectacol tematic"
        override val showcaseButtons: String = "Nasturi"
        override val showcasePrimaryAction: String = "Acţiune primară"
        override val showcaseSecondaryAction: String = "Acţiune secundară"
        override val showcaseGhostAction: String = "Acţiune fantomă"
        override val showcaseTextField: String = "Câmp text"
        override val showcaseFocusedBorder: String = "Margine accent concentrat"
        override val showcaseSearchPreview: String = "Previzualizare căutare"
        override val showcaseOpeningCheckedIn: String = "Open House check-in astăzi"
        override val showcaseSentAt: String = "Trimis la 10:30 AM"
        override val themeObsidianGoldName: String = "Aur obsidian"
        override val themeObsidianGoldDescription: String = "Negru de lux, grafit şi aur cald."
        override val themeMidnightSapphireName: String = "Midnight Sapphire"
        override val themeMidnightSapphireDescription: String = "Marina profundă, safir albastru şi accente argintii."
        override val themeEmeraldEstateName: String = "Estate smarald"
        override val themeEmeraldEstateDescription: String = "Smarald negru, cărbune şi aur de şampanie."
        override val themePlatinumStoneName: String = "Piatră platină"
        override val themePlatinumStoneDescription: String = "Piatră gri, platină şi alb moale."
        override val themeBordeauxNoirName: String = "Bordeaux Noir"
        override val themeBordeauxNoirDescription: String = "Vin negru, grafit şi accente de cupru."
        override val commonChange: String = "Modificare"
        override val agentPlanTitle: String = "Plan agent"
        override val agentPlanBody: String = "Upgrade experiența ta, alege planul care se potrivește modul în care funcționează cel mai bine."
        override val currentPlan: String = "Planul curent"
        override val transferPlan: String = "Planul de transfer"
        override val transferPlanTitle: String = "Planul de transfer"
        override val transferPlanBody: String = "Mutați acest abonament la un alt cont HAVN. Ambele adrese de e-mail trebuie să confirme cu coduri de verificare."
        override val transferTargetEmail: String = "E-mail cont nou"
        override val transferSendCodes: String = "Trimite coduri de verificare"
        override val transferCodesSentTitle: String = "Coduri de verificare trimise"
        override val transferCodesSentBody: String = "Am trimis un cod pe e-mailul tău şi un cod pe noul e-mail al contului."
        override val transferYourCode: String = "Codul de e-mail"
        override val transferTargetCode: String = "Cod nou de cont"
        override val transferConfirm: String = "Planul de transfer"
        override val transferSuccessTitle: String = "Plan transferat"
        override val transferSuccessBody: String = "Abonamentul este acum conectat la noul cont HAVN."
        override val restorePurchase: String = "Restaurare cumpărare"
        override val agencySettingsProBody: String = "Agenţia Solo este activă în mod implicit. Pro vă permite să creați sau să selectați o agenție comună."
        override val agencySettingsLockedBody: String = "Agenţia Solo este activă. Agenţia schimbă sistemul cu Pro."
        override val soloAgency: String = "Agenţie Solo"
        override val defaultPrivateAgencyWorkspace: String = "Agenţie privată implicită"
        override val noAgenciesAvailableYet: String = "Nu sunt disponibile încă invitații de agenție sau agenții deținute."
        override val oneOwnedAgencyHint: String = "Agenţia ta e pe lista de mai sus. Un agent poate deţine o agenţie."
        override val createAgency: String = "Creează agenție"
        override val createYourAgency: String = "Creează-ţi agenţia"
        override val createAgencyBody: String = "Construiți-vă echipa, gestiona proprietăți împreună, și să crească afacerea ta."
        override val agencyName: String = "Numele agenției"
        override val agencyEmail: String = "E-mailul agenției"
        override val logoOptional: String = "Logo (opțional)"
        override val upgradeExperienceTitle: String = "Actualizează-ți experiența"
        override val upgradeExperienceSubtitle: String = "Rulați prima ta Open House gratuit. Upgrade atunci când aveți nevoie de mai multe liste, vizionări deschise, și fluxuri de lucru Pro."
        override val soloAgentPlan: String = "Agent Solo"
        override val proAgentPlan: String = "Agent pro"
        override val teamAgentPlan: String = "Echipa"
        override val soloBenefitActiveProperties: String = "Până la 100 proprietăți active"
        override val soloBenefitAiFollowUps: String = "Monitorizarea AI (de bază)"
        override val soloBenefitSellerReports: String = "Niciun raport de vânzare"
        override val soloBenefitPersonalOnly: String = "Numai personal"
        override val proBenefitUnlimitedProperties: String = "Până la 10.000 proprietăți"
        override val proBenefitUnlimitedAi: String = "10.000 cereri de text AI / lună"
        override val proBenefitAdvancedReports: String = "Rapoartele vânzătorilor avansaţi"
        override val proBenefitAgencyCreation: String = "Crearea și gestionarea agenției"
        override val proBenefitInviteAgents: String = "Invitaţi agenţi şi colaboraţi"
        override val proBenefitSharedLeads: String = "Conducte partajate și fluxuri de lucru în echipă"
        override val proBenefitAgencyBranding: String = "Marcarea agenției"
        override val proBenefitAdvancedAnalytics: String = "Analize avansate"
        override val teamBenefitLargeLimits: String = "Limite la scara de echipă"
        override val teamBenefitPrioritySupport: String = "Sprijin e-mail prioritar"
        override val teamBenefitDailyBackups: String = "Întăriri zilnice pentru 7 zile"
        override val teamBenefitLargeStorage: String = "Stocare document 10GB"
        override val startFreeTrial7Day: String = "Abonează acum"
        override val restorePurchases: String = "Restaurare cumpărare"
        override val comparePlans: String = "Compară planurile"
        override val startFreeTrial: String = "Alege planul"
        override val noCommitmentCancelAnytime: String = "Rulați prima ta Open House gratuit. Upgrade atunci când aveți nevoie de mai mult."
        override val monthly: String = "Lunar"
        override val yearly: String = "Anual"
        override val yearlySave20: String = "Anual"
        override val yearlySavings20: String = "Facturat anual."
        override val perYear: String = "/ an"
        override val loadingPlans: String = "Se încarcă planurile..."
        override val selectedPlanUnavailable: String = "Abonamentele sunt temporar indisponibile. Vă rugăm să încercați din nou mai târziu sau suport de contact."
        override val signInRequiredForPurchase: String = "Semnează înainte de a începe o achiziție."
        override val subscriptionDisclosureIos: String = "Abonare automata. Plata va fi încasată în contul dvs. Apple la confirmarea cumpărării. Abonamentul dvs. se reînnoiește automat, cu excepția cazului în care anulat cel puțin 24 de ore înainte de sfârșitul perioadei curente. Reînnoirea se va face cu 24 de ore înainte de încheierea perioadei curente. Puteți gestiona sau anula abonamentul în setările contului App Store."
        override val subscriptionDisclosureAndroid: String = "Abonare automata regenerabila prin Google Play. Vei fi taxat în fiecare perioadă de facturare dacă nu anulezi. Puteți gestiona sau anula abonamentul oricând în abonamentele Google Play. Accesul continuă până la sfârșitul perioadei plătite."
        override val subscriptionDisclosureWeb: String = "Abonare automata. Vi se va percepe fiecare perioadă de facturare folosind metoda de plată selectată dacă nu anulați. Puteți gestiona sau anula oricând din setările de facturare. Accesul continuă până la sfârșitul perioadei plătite. Se pot aplica taxe."
        override val subscriptionAgreementPrefix: String = "Prin abonare, sunteţi de acord cu"
        override val subscriptionTermsOfUse: String = "Termeni de utilizare HAVN"
        override val subscriptionAgreementAnd: String = "şi"
        override val subscriptionPrivacyPolicy: String = "Politica de confidențialitate."
        override val purchaseSuccessTitle: String = "Mulţumesc pentru achiziţie."
        override val purchaseSuccessBody: String = "Abonamentul dvs. HAVN este activ și planul dvs. este gata."
        override val restoreSuccessTitle: String = "Restaurare cumpărare"
        override val restoreSuccessBody: String = "Abonarea la HAVN a fost restaurată cu succes."
        override val purchaseCouldNotComplete: String = "Achiziția nu a putut fi finalizată. Vă rugăm să încercați din nou, sau verificați App Store sau Google Play cont."
        override val purchaseVerificationPending: String = "Your payment has not been confirmed yet. If you completed checkout, use Restore purchase to check again. You do not need to pay again."
        override val completeWebCheckout: String = "Complete payment in the checkout tab, then return here. Your access will update automatically once payment is confirmed."
        override val restoreCouldNotComplete: String = "Nu a fost găsit nici un abonament activ HAVN pentru acest cont magazin."
        override val noActiveSubscriptionFound: String = "Nu a fost găsit nici un abonament activ HAVN pentru acest cont magazin."
        override val compareActiveProperties: String = "Proprietăți active"
        override val compareAiFollowUps: String = "Monitorizarea AI"
        override val compareSellerReports: String = "Rapoarte de vânzare"
        override val compareAdvancedAnalytics: String = "Analize avansate"
        override val compareAgencyCreation: String = "Crearea Agenției"
        override val compareJoinAgencies: String = "Alăturaţi-vă agenţiilor"
        override val compareInviteAgents: String = "Invitaţi agenţi"
        override val compareSharedLeads: String = "Piste partajate"
        override val compareAgencyBranding: String = "Marcarea agenției"
        override val comparePrioritySupport: String = "Sprijin prioritar"
        override val compareFeature: String = "Caracteristici"
        override val compareFreePlan: String = "Liber"
        override val compareValueYes: String = "Da."
        override val compareValueNo: String = "Nu."
        override val comparePricePerMonthUser: String = "Preț / lună / Utilizator"
        override val comparePricePerYearUser: String = "Preț / an / Utilizator"
        override val compareMaxPropertiesOwner: String = "Proprietăți Max / proprietar"
        override val compareMaxContactsOwner: String = "Contacte maxime / proprietar"
        override val compareMaxOpenHousesOwner: String = "Max deschide case / proprietar"
        override val compareMaxLeadsOwner: String = "Max conduce / proprietar"
        override val compareMaxPhotosProperty: String = "Max fotografii pe proprietate"
        override val compareMaxDocumentsProperty: String = "Documente Max pe proprietate"
        override val compareDocumentsStorage: String = "Stocarea documentelor"
        override val compareAgencyAgenda: String = "Agenda agenției"
        override val compareAiTextRequestsMonth: String = "Solicitări de generare de text AI / lună"
        override val compareAnalytics: String = "Analize"
        override val compareTasks: String = "Sarcini"
        override val compareDocumentsStorageOwner: String = "Depozitare documente / proprietar"
        override val compareMaxFileSizeOwner: String = "Mărime maximă a fișierului / proprietar"
        override val compareEmailSupport: String = "Suport e-mail"
        override val compareDailyBackups7Days: String = "Backup-uri zilnice stocate timp de 7 zile"
        override val compareKioskMode: String = "Modul chioșc"
        override val unlimited: String = "Nelimitat"
        override val basic: String = "Basic"
        override val advanced: String = "Avansat"
        override val perMonth: String = "/ lună"
        override val members: String = "membri"
        override val upgradeToProForAgencyTools: String = "Upgrade la Pro pentru utilizarea instrumentelor agenției"
        override val languageTitle: String = "Limba"
        override val languageBody: String = "Alegeți limba aplicației pentru acest dispozitiv."
        override val english: String = "Engleză"
        override val slovak: String = "Slovacia"
        override val unitsTitle: String = "Unități și monedă"
        override val unitsBody: String = "Alegeți modul în care prețurile și dimensiunile proprietății sunt afișate în aplicație."
        override val measurementSystemTitle: String = "Măsurători"
        override val metric: String = "Metrică"
        override val imperial: String = "Imperial"
        override val currencyTitle: String = "Moneda"
        override val notificationsTitle: String = "Notificări"
        override val notificationsBody: String = "Controlul alerte împinge, ore liniștite, și tipurile de actualizări HAVN poate trimite."
        override val notificationSettings: String = "Configurările notificării"
        override val notificationsSubtitle: String = "Doar actualizări importante, filtrate de preferințele dumneavoastră."
        override val quietHoursTitle: String = "Orele de linişte"
        override val quietHoursBody: String = "HAVN sare peste împingeri non-critice în timpul orelor liniștite. Problemele de facturare şi de cont rămân încă concise."
        override val enableQuietHours: String = "Activează ore liniștite"
        override val quietHoursStart: String = "Start"
        override val quietHoursEnd: String = "Sfârşit"
        override val timezoneLabel: String = "Zona temporală"
        override val notificationTypesTitle: String = "Tipuri de notificare"
        override val notificationNewLeadCapturedTitle: String = "Noua pistă capturată"
        override val notificationNewLeadCapturedBody: String = "Când o vizionare deschisă sau fluxul QR captează o pistă."
        override val notificationHotLeadTitle: String = "Lead marcat ca fierbinte"
        override val notificationHotLeadBody: String = "Numai atunci când o pistă devine mare intenție."
        override val notificationOpeningStartsSoonTitle: String = "Open House începe curând"
        override val notificationOpeningStartsSoonBody: String = "Un singur memento cu 30 de minute înainte de a începe."
        override val notificationOpeningSummaryReadyTitle: String = "Open House sumar gata"
        override val notificationOpeningSummaryReadyBody: String = "Când rezumatul post-eveniment este gata."
        override val notificationSellerReportGeneratedTitle: String = "Raport de vânzare generat"
        override val notificationSellerReportGeneratedBody: String = "Atunci când un raport de vânzare a fost creat."
        override val notificationAiFollowUpReadyTitle: String = "Urmărire Al gata"
        override val notificationAiFollowUpReadyBody: String = "Atunci când un proiect de follow-up este gata să revizuiască."
        override val notificationAgentInvitedTitle: String = "Agent invitat la agenţie"
        override val notificationAgentInvitedBody: String = "Invitaţii la agenţie şi modificări de membru."
        override val notificationLeadAssignedTitle: String = "Conducere atribuită ţie."
        override val notificationLeadAssignedBody: String = "Când un coechipier îţi atribuie o pistă."
        override val notificationLeadTransferredTitle: String = "Lead transferat la tine"
        override val notificationLeadTransferredBody: String = "Când proprietatea unei conduceri se mută la tine."
        override val notificationSubscriptionIssueTitle: String = "Emitere subscripție"
        override val notificationSubscriptionIssueBody: String = "Eșecuri de reînnoire și probleme de facturare."
        override val kioskSecurityTitle: String = "Securitatea chioșcului"
        override val kioskSecurityBody: String = "Utilizați acest PIN pentru a lăsa modul chioșc și reveniți la aplicația agent."
        override val kioskPinLabel: String = "Kiosk PIN"
        override val mcpAccessTitle: String = "Acces MCP"
        override val mcpAccessBody: String = "Bridge HAVN către Claude, OpenAI și alți clienți ai MCP la Mcp.havnre.app. Disponibil pe fiecare plan."
        override val mcpAuthorizationBearer: String = "Autorizaţie: Purtător"
        override val mcpNoApiKeyCreated: String = "Nicio cheie API creată"
        override val mcpNotUsedYet: String = "Neutilizat încă"
        override val mcpLastUsedPrefix: String = "Ultima utilizare"
        override val mcpRevealApiKeyTitle: String = "Arată cheia API"
        override val mcpRevealApiKeyBody: String = "Cheia completă este afișată numai după crearea sau rotirea."
        override val mcpCreateKey: String = "Creează cheie"
        override val mcpRotateKey: String = "Rotește cheia"
        override val mcpRevokeKey: String = "Revocare cheie"
        override val mcpEndpointHint: String = "Utilizarea obiectivului final https://mcp.havnre.app/mcp cu această cheie ca jeton pentru purtător."
        override val mcpUpgradeHint: String = "Accesul MCP este disponibil pe fiecare plan HAVN."
        override val mcpUpgradePrompt: String = "Accesul MCP este disponibil pe fiecare plan HAVN."
        override val mcpCopied: String = "Copiat"
        override val mcpCopy: String = "Copiază"
        override val mcpLoading: String = "Încărcare"
        override val kioskFeaturedProperty: String = "Proprietate specifică"
        override val kioskPrivateShowing: String = "Spectacol privat"
        override val kioskLuxuryListing: String = "Listă de lux"
        override val kioskFastCheckIn: String = "Verificarea rapidă"
        override val kioskExitContentDescription: String = "Chioșc de ieșire"
        override val kioskWelcome: String = "Bine ai venit."
        override val kioskGladHere: String = "Ne bucurăm că eşti aici."
        override val kioskScanToCheckIn: String = "Scanare pentru a verifica în"
        override val kioskReceivePropertyDetails: String = "și să primească detalii privind proprietatea"
        override val kioskOr: String = "Sau"
        override val kioskStartCheckInManually: String = "Începe check-in manual"
        override val kioskSecureInfo: String = "Informaţiile tale sunt sigure şi nu vor fi niciodată împărtăşite."
        override val kioskExitTitle: String = "Chioșc de ieșire"
        override val kioskExitBody: String = "Introduceți PIN chioșc pentru a reveni la aplicația agent."
        override val kioskIncorrectPin: String = "PIN incorect."
        override val kioskUnlock: String = "Deblochează"
        override val kioskTellUsTitle: String = "Spune-ne despre tine."
        override val kioskTellUsBody: String = "Informaţiile tale merg doar către agentul gazdă."
        override val kioskFullName: String = "Nume complet"
        override val kioskContinue: String = "Continuă"
        override val kioskQuestionsTitle: String = "Câteva întrebări rapide."
        override val kioskQuestionsBody: String = "Acest lucru ajută agentul să urmărească contextul potrivit."
        override val kioskWorkingWithAgentQuestion: String = "Lucrezi cu un agent?"
        override val kioskYes: String = "Da."
        override val kioskNo: String = "Nu."
        override val kioskInterestQuestion: String = "Ce te interesează?"
        override val kioskInterestBuying: String = "Cumpărare"
        override val kioskInterestInvesting: String = "Investiţii"
        override val kioskInterestBrowsing: String = "Doar mă uit."
        override val kioskInterestRelocating: String = "Relocare"
        override val kioskFinish: String = "Termină"
        override val kioskThankYou: String = "Mulţumesc."
        override val kioskEnjoyVisitPrefix: String = "Bucuraţi-vă de vizita la"
        override val kioskResetAutomatically: String = "Acest chioşc se va reseta automat."
        override val environmentTitle: String = "Mediu"
        override val environmentBody: String = "Detaliile conexiunii sunt configurate pentru această clădire."
        override val secure: String = "Sigur"
        override val brokerageProfileTitle: String = "Profilul de brokeraj"
        override val brokerageProfileBody: String = "Echipa de branding, agentul invită, și preferințele de notificare vor trăi aici."
        override val logout: String = "Deconectează"
        override val languageChanged: String = "Limba modificată"
        override val commonAdd: String = "Adaugă"
        override val commonEdit: String = "Editare"
        override val commonDelete: String = "Șterge"
        override val commonCancel: String = "Renunță"
        override val commonSave: String = "Salvează"
        override val commonCreate: String = "Creează"
        override val commonDismiss: String = "Liber."
        override val commonAll: String = "Toate"
        override val commonDone: String = "Gata."
        override val commonSend: String = "Trimite"
        override val commonTime: String = "Timp"
        override val commonHour: String = "Ora"
        override val commonMinute: String = "Minute"
        override val commonAgency: String = "Agenţie"
        override val commonSettings: String = "Configurări"
        override val commonOpening: String = "Open House"
        override val commonPropertyName: String = "Proprietate"
        override val commonToday: String = "Astăzi"
        override val agencyToolsAvailable: String = "Sunt disponibile instrumente ale agenţiei."
        override val agencySetupSubtitle: String = "Fiecare cont HAVN are o agenţie implicită. Pro vă permite să gestionați invitații, piste partajate, și branding."
        override val agencyRecentActivity: String = "Activitatea recentă"
        override val agencyActivityNewLead: String = "Se adaugă un nou lead"
        override val agencyActivityInvitationAccepted: String = "Invitație de agent acceptată"
        override val agencyActivityAgentJoined: String = "Agentul s-a alăturat agenţiei."
        override val agencyActivitySellerReport: String = "Raportul de vânzare creat"
        override val agencyWorkspaceTitle: String = "Agenţie"
        override val agencyWorkspaceBody: String = "Alege cu ce agenţie lucrezi."
        override val agencySoloActiveTitle: String = "Agenţia Solo este activă"
        override val agencyProRequiredTitle: String = "Plan pro necesar"
        override val agencyCreateOrAcceptInviteBody: String = "Creați agenția sau acceptați o invitație de a colabora cu o altă agenție."
        override val agencyProUnlockBody: String = "Schimbarile agentiei, invitarile, pistele comune, si brandingul comun deblocat cu Pro."
        override val realEstate: String = "Bunuri imobiliare"
        override val proAgency: String = "Agenţia Pro"
        override val agencyBrandingTitle: String = "Marcarea agenției"
        override val agencyBrandingBody: String = "Setați numele agenției și logo-ul afișat în aplicație, chioșc și vizualizările echipei."
        override val uploadLogo: String = "Încarcă logo-ul"
        override val saveAgency: String = "Salvează agenția"
        override val yourAgencyRole: String = "Rolul tău de agentie"
        override val agencyAgentsTitle: String = "Agenţi agenţi"
        override val agencyAgentsBody: String = "Oameni eligibili să lucreze cu această agenţie."
        override val inviteAgent: String = "Invită agent"
        override val loadingAgents: String = "Încărcare agenți..."
        override val noAgencyAgentsYet: String = "Nici un agent încă."
        override val changeRole: String = "Modificarea rolului"
        override val updating: String = "Actualizare..."
        override val deleting: String = "Ştergerea..."
        override val deleteInvite: String = "Anulează invitația"
        override val chooseAgencyRoleFor: String = "Alegeți rolul agenției pentru"
        override val removeAccess: String = "Elimină accesul"
        override val inviteAgentBody: String = "Trimite o invitaţie prin e-mail. Agentul acceptă după semnarea cu același e-mail."
        override val agentEmail: String = "E-mail agent"
        override val role: String = "Rol"
        override val inviting: String = "Invit..."
        override val invite: String = "Invită"
        override val agents: String = "Agenţi"
        override val ok: String = "Bine."
        override val personalActivePropertyLimit: String = "Limita proprietății active personale"
        override val personalAccountAgencyToolsLocked: String = "Contul personal este activ. Instrumentele agenției sunt deblocate cu Pro."
        override val selected: String = "Selectat"
        override val activeMembers: String = "membri activi"
        override val agencySharedWorkspaceBody: String = "Proprietăţi comune, contacte, vizionări deschise, piste, follow-up-uri şi rapoarte folosesc această agenţie."
        override val actLikeAgent: String = "Poartă-te ca un agent."
        override val actAsAdmin: String = "Acționează ca administrator"
        override val actAsOwner: String = "Acționează ca proprietar"
        override val actLikeAgentBody: String = "Foloseşte agenţia ca agent normal."
        override val actLikeAgentSelectedBody: String = "Este afișată numai munca atribuită sau deținută."
        override val agencyRoleOwner: String = "Proprietar"
        override val agencyRoleAdmin: String = "Admin"
        override val agencyRoleAgent: String = "Agent"
        override val agencyRoleAssistant: String = "Asistent"
        override val agencyRoleViewer: String = "Vizualizator"
        override val agencyRoleOwnerDescription: String = "Controlul complet al agenţiei, inclusiv membri, branding, misiuni, liste, piste şi rapoarte."
        override val agencyRoleAdminDescription: String = "Managementul complet al agenţiei, cu excepţia ştergerii agenţiei."
        override val agencyRoleAgentDescription: String = "Lucrări atribuite listări, vizionări deschise, piste, follow-up-uri, note, și rapoarte vânzător."
        override val agencyRoleAssistantDescription: String = "Sprijină listele atribuite prin editarea de piste, pregătirea de follow-up-uri, și elaborarea de rapoarte."
        override val agencyRoleViewerDescription: String = "Accesul numai la borduri și rapoarte."
        override val agencyCapabilityInviteRemoveMembers: String = "Invită și elimină membrii"
        override val agencyCapabilityChangeRoles: String = "Schimbă rolurile membrilor"
        override val agencyCapabilityManageAllProperties: String = "Creați, editați și ștergeți toate proprietățile"
        override val agencyCapabilityAssignAgents: String = "Atribuiți agenți"
        override val agencyCapabilitySeeAllLeads: String = "Vezi toate pistele"
        override val agencyCapabilityExportReports: String = "Rapoarte privind exportul"
        override val agencyCapabilityChangeBranding: String = "Schimbă brandingul și setările agenției"
        override val agencyCapabilityDeleteAgency: String = "Șterge agenția"
        override val agencyCapabilityViewAssignedProperties: String = "Vizualizați proprietățile atribuite"
        override val agencyCapabilityHostAssignedOpenings: String = "Gazda a alocat vizionări deschise"
        override val agencyCapabilitySeeAssignedLeads: String = "A se vedea piste de la proprietăți atribuite și vizionări deschise"
        override val agencyCapabilityAddNotes: String = "Adaugă note"
        override val agencyCapabilitySendFollowUps: String = "Trimite urmăriri"
        override val agencyCapabilityCreateSellerReports: String = "Creează rapoarte ale vânzătorilor pentru listele atribuite"
        override val agencyCapabilityEditAssignedLeads: String = "Editează pistele atribuite"
        override val agencyCapabilityPrepareFollowUps: String = "Pregătirea acțiunilor ulterioare"
        override val agencyCapabilityCreateDraftReports: String = "Creează proiecte de rapoarte"
        override val agencyCapabilityCannotDeleteProperties: String = "Nu se pot șterge proprietățile"
        override val agencyCapabilityCannotInviteAgents: String = "Nu pot invita agenți dacă nu este permis"
        override val agencyCapabilityViewDashboards: String = "Vezi bordurile"
        override val agencyCapabilityViewReports: String = "Rapoarte de vizualizare"
        override val agencyCapabilityCannotEdit: String = "Nu se poate edita nimic"
        override val commonVisitors: String = "Lead-uri"
        override val commonHot: String = "Fierbinte"
        override val commonWarm: String = "Cald"
        override val commonCold: String = "Rece"
        override val commonActive: String = "Activ"
        override val commonPlanned: String = "Planificate"
        override val commonArchived: String = "Arhivat"
        override val commonPast: String = "Trecut"
        override val commonFollowUps: String = "Monitorizarea"
        override val commonProperty: String = "Proprietate"
        override val commonAddress: String = "Adresă"
        override val commonOpenHouse: String = "Open House"
        override val commonInquiry: String = "Ancheta"
        override val commonInquiries: String = "Anchete"
        override val generalInquiry: String = "Solicitare generală"
        override val generalInquiries: String = "Solicitări generale"
        override val propertyInquiry: String = "Solicitare pentru proprietate"
        override val propertyInquiries: String = "Solicitări pentru proprietăți"
        override val addGeneralInquiry: String = "Adaugă solicitare generală"
        override val newGeneralInquiry: String = "Solicitare generală nouă"
        override val noGeneralInquiries: String = "Nu există încă solicitări generale."
        override val noPropertyInquiries: String = "Nu există încă solicitări pentru proprietăți."
        override val buyerLookingFor: String = "Ce caută acest cumpărător?"
        override val locationCity: String = "Locație / oraș"
        override val radiusKm: String = "Rază (km)"
        override val propertyType: String = "Tip proprietate"
        override val budgetFrom: String = "Buget de la"
        override val budgetTo: String = "Buget până la"
        override val purchaseTimeline: String = "Termen de achiziție"
        override val createGeneralInquiry: String = "Creează solicitarea generală"
        override val saveGeneralInquiry: String = "Salvează solicitarea generală"
        override val inquiryType: String = "Tip solicitare"
        override val leadSource: String = "Sursa leadului"
        override val notSpecified: String = "Nespecificat"
        override val inquiryStatus: String = "Starea anchetei"
        override val inquiryFollowUp: String = "Urmărire anchetă"
        override val addInquiry: String = "Adaugă anchetă"
        override val searchInquiries: String = "Anchete de căutare"
        override val noInquiries: String = "Fără anchete"
        override val noInquiriesBody: String = "Utilizați butonul plus pentru a adăuga dobânda cumpărătorului de la un contact existent."
        override val inquiryUnavailableTitle: String = "Ancheta nu este disponibilă"
        override val inquiryUnavailableBody: String = "Această anchetă poate fi înlăturată sau încă se încarcă."
        override val backToInquiries: String = "Înapoi la anchete"
        override val deleteInquiry: String = "Șterge ancheta"
        override val deleteInquiryQuestionPrefix: String = "Șterge"
        override val deleteInquiryQuestionSuffix: String = "De pe proprietatea asta?"
        override val deleteInquiryTargetFallback: String = "Această anchetă"
        override val propertyInquiriesBody: String = "Cumpărătorii care au întrebat de proprietatea asta. Investigaţiile apar şi în Leads."
        override val propertyInquiriesEmpty: String = "Adaugă o anchetă prin alegerea unuia dintre contactele tale."
        override val contactInquiriesBody: String = "Proprietăți despre care a întrebat acest contact."
        override val contactInquiriesEmpty: String = "Nici o anchetă de proprietate încă."
        override val viewInquiries: String = "Vizualizare anchete"
        override val createContactFirstForInquiry: String = "Creați un contact mai întâi, apoi adăugați ancheta de pe această proprietate."
        override val commonCheckedIn: String = "Înregistrat"
        override val commonNotScheduled: String = "neprogramat"
        override val todayTitle: String = "Astăzi"
        override val todaySubtitle: String = "Casa ta de zi cu zi pentru vizionări deschise, piste, follow-up-uri, și de vânzare-gata impuls."
        override val todayOpenHousesMetric: String = "vizionări deschise"
        override val capturedMetric: String = "capturat"
        override val priorityMetric: String = "prioritate"
        override val noActivePropertiesTitle: String = "Nu există proprietăți active"
        override val noActivePropertiesBody: String = "Adăugați sau activați o proprietate pentru a face să apară pe Astăzi."
        override val checkIns: String = "Controale"
        override val allOpenHouses: String = "toate casele deschise"
        override val pendingDrafts: String = "proiecte în curs"
        override val priorityLead: String = "Lead prioritar"
        override val nextOpenHouseAt: String = "Următoarea vizionare deschisă la"
        override val noOpenHouseScheduled: String = "Nicio vizionare deschisă programată"
        override val personalAccount: String = "Cont personal"
        override val accountReady: String = "Contul tău e gata."
        override val realEstateApp: String = "Aplicație imobiliară"
        override val needHelp: String = "Ai nevoie de ajutor?"
        override val contactSupport: String = "Suport de contact"
        override val upgradePlan: String = "Actualizează planul"
        override val planSuffix: String = "Plan"
        override val todayActionsTitle: String = "Prioritățile de astăzi"
        override val agencyInvitation: String = "Invitație la agenție"
        override val joinAgency: String = "Alătură-te"
        override val youWereInvitedAs: String = "Ai fost invitat ca"
        override val invitedBy: String = "de"
        override val decline: String = "Refuză"
        override val yourDefaultAgency: String = "Agenția dumneavoastră implicită"
        override val chooseAgencyBody: String = "Alege cu care agenţie vrei să lucrezi. Instrumentele agenției includ invitații, piste comune și branding."
        override val agencyMembersSuffix: String = "membri"
        override val quickActionTasksBody: String = "Coadă"
        override val quickActionReportsBody: String = "Vânzarea"
        override val quickActionAnalyticsBody: String = "Tendinţe"
        override val quickActionAddPropertyTitle: String = "Adaugă"
        override val quickActionAddPropertyBody: String = "Listare"
        override val quickActionAddContactTitle: String = "Contact"
        override val quickActionAddContactBody: String = "Nou"
        override val quickActionFilesTitle: String = "Fișiere"
        override val quickActionFilesBody: String = "Docuri"
        override val firstRunStepsTitle: String = "Începe cu patru paşi simpli"
        override val firstRunAddProperty: String = "Adaugă proprietate"
        override val firstRunScheduleOpening: String = "Programează casa deschisă"
        override val firstRunStartGuestCheckIn: String = "Începe check-in oaspete"
        override val firstRunSendFollowUp: String = "Trimite follow-up"
        override val greetingNamePrefix: String = "Bună."
        override val greetingAgent: String = "Bună, agent."
        override val createListing: String = "Creează listă"
        override val newOwnerBuyer: String = "Proprietar/buyer nou"
        override val documents: String = "Documente"
        override val whatOpeningNext: String = "Ce va urma?"
        override val whoCheckedIn: String = "Cine a venit?"
        override val whoNeedsFollowUp: String = "Cine are nevoie de urmărire?"
        override val whatShouldIDoNow: String = "Ce ar trebui să fac acum?"
        override val noCheckInsYet: String = "Nici un contact nu s-a cazat încă."
        override val noPendingFollowUps: String = "Nici o urmărire în așteptare chiar acum."
        override val openKioskForNextOpening: String = "Deschide chioşcul pentru următoarea vizionare deschisă."
        override val reviewNewLeads: String = "Revizuiți noi piste și trimiteți urmăriri."
        override val createOpeningToStart: String = "Creați o vizionare deschisă de la o proprietate pentru a începe colectarea de piste."
        override val addFirstPropertyToStart: String = "Adăugați prima proprietate pentru a începe."
        override val nextOpening: String = "Următoarea vizionare deschisă"
        override val quickSignIn: String = "Semnare rapidă"
        override val scanQrCode: String = "Scanează codul QR"
        override val newLead: String = "Lead nou"
        override val myProperties: String = "Proprietăţile mele."
        override val manageListings: String = "Gestionează listele"
        override val todaysOverview: String = "Prezentare generală de astăzi"
        override val seeAll: String = "Vezi tot"
        override val propertiesEyebrow: String = "PortfólioCity in Germany"
        override val propertiesSubtitle: String = "Gestiona activ, planificate, și liste arhivate cu listare media, activitatea cumpărătorului, și perspective de performanță."
        override val propertiesLiveMetric: String = "live"
        override val propertiesPipelineMetric: String = "conducta"
        override val propertiesAllTimeMetric: String = "tot timpul"
        override val addProperty: String = "Adaugă proprietate"
        override val editProperty: String = "Editează proprietatea"
        override val propertyFallback: String = "Proprietate"
        override val propertyUnavailableTitle: String = "Proprietate indisponibilă"
        override val propertyUnavailableBody: String = "Reîmprospătează portofoliul pentru a reîncărca această listă."
        override val backToProperties: String = "Înapoi la proprietăți"
        override val deletePropertyTitle: String = "Să ştergi proprietatea?"
        override val deletePropertyBody: String = "Acest lucru va șterge permanent proprietatea și înregistrările sale locale aferente. Asta nu poate fi anulată."
        override val loadingProperties: String = "Proprietăți de încărcare"
        override val loadMore: String = "Încarcă mai mult"
        override val loadingPropertyDetails: String = "Se încarcă detaliile proprietății"
        override val noPropertiesTitle: String = "Nu există proprietăți încă"
        override val noPropertiesBody: String = "Adăugați prima proprietate, apoi creați o vizionare deschisă pentru a începe colectarea de piste și feedback-gata vânzător."
        override val openHouseButton: String = "Creează o vizionare deschisă"
        override val photosTitle: String = "Poze"
        override val photosBody: String = "Prima fotografie este folosită ca principala imagine de proprietate în cadrul Portfolio."
        override val uploadPhoto: String = "Încarcă fotografia"
        override val noPhotosYet: String = "Nu sunt fotografii încărcate încă."
        override val propertyPhotoCountPlanLimit: String = "Limita foto atins pentru această proprietate pe planul curent. Upgrade pentru a încărca mai multe fotografii."
        override val propertyPhotoStoragePlanLimit: String = "Limita de stocare atins pentru planul curent. Upgrade pentru a încărca mai multe fotografii sau fișiere."
        override val mainPhoto: String = "Principal"
        override val propertyTitleLabel: String = "Denumirea proprietății"
        override val propertyAddressLine1Label: String = "Adresa străzii"
        override val propertyAddressLine2Label: String = "Linia de adresă 2"
        override val propertyCityLabel: String = "Oraș"
        override val propertyRegionLabel: String = "Regiune"
        override val propertyPostalCodeLabel: String = "Codul poștal"
        override val propertyCountryLabel: String = "Țara"
        override val propertyAskingPriceLabel: String = "Preț cerut"
        override val propertyBedsLabel: String = "Paturi"
        override val propertyBathsLabel: String = "Bai"
        override val propertyInteriorLabel: String = "Interioare"
        override val propertyDescriptionLabel: String = "Descriere"
        override val createPropertyButton: String = "+ Proprietate"
        override val locateProperty: String = "Localizați proprietatea"
        override val findLocation: String = "Găsiți locația"
        override val find: String = "Caută"
        override val navigate: String = "Navighează"
        override val propertyLocationMarkerTitle: String = "Locația proprietății"
        override val mapKitJsMissingToken: String = "Adaugă HAVN MAPKIT JS TOKEN pe harta web."
        override val mapKitJsLoading: String = "Se încarcă MapKit JS..."
        override val generateSellerReport: String = "Generează raportul vânzătorului"
        override val deleteProperty: String = "Șterge proprietatea"
        override val conversionMetric: String = "Conversie"
        override val propertyPhotoContentDescription: String = "Fotografia proprietății"
        override val deletePhoto: String = "Șterge fotografia"
        override val movePhotoLeft: String = "Mută fotografia la stânga"
        override val movePhotoRight: String = "Mută fotografia la dreapta"
        override val propertyTitleRequired: String = "Numele proprietății este necesar."
        override val propertyStreetRequired: String = "Adresa este necesară."
        override val propertyCityRequired: String = "Oraşul e obligatoriu."
        override val propertyRegionRequired: String = "Regiunea este necesară."
        override val propertyPostalRequired: String = "Codul poștal este necesar."
        override val propertyAskingPriceInvalid: String = "Introduceți un preț de cerere valabil."
        override val propertyOwnerContactTitle: String = "Persoana de contact a proprietarului"
        override val propertyOwnerSelectContact: String = "Alegeți un contact existent ca proprietar al proprietății."
        override val propertyOwnerSelected: String = "Proprietar selectat"
        override val propertyOwnerNoContacts: String = "Nu există contacte încă. Adăugați proprietarul în Contacte, apoi selectați-le aici."
        override val propertyOwnerChooseContact: String = "Alege contactul"
        override val propertyOwnerChangeContact: String = "Schimbă contactul"
        override val propertyOwnerRemoveContact: String = "Elimină"
        override val propertyOwnerPickerTitle: String = "Alegeți proprietarul proprietății"
        override val propertyOwnerSearchContact: String = "Contacte de căutare"
        override val propertyOwnerSearchHint: String = "Începeţi să scrieţi un nume, un e-mail sau un număr de telefon."
        override val propertyOwnerNoMatches: String = "Nu există contacte de potrivire."
        override val propertyOpeningsTitle: String = "Vizionări deschise"
        override val propertyNoOpenings: String = "Nu există vizionări deschise programate pentru această proprietate."
        override val teamAccessTitle: String = "Accesul echipei"
        override val onlyListingOwner: String = "Numai proprietarul listei"
        override val assignTeam: String = "Atribuie echipa"
        override val assignPropertyTitle: String = "Atribuirea proprietății"
        override val assignPropertyBody: String = "Alege cine poate lucra această proprietate. Selectaţi întreaga echipă sau agenţi specifici."
        override val wholeTeam: String = "Întreaga echipă"
        override val leadsEyebrow: String = "Lead-uri"
        override val leadFallback: String = "Lead"
        override val leadsSubtitle: String = "Căutați, filtrați și calificați lead-urile colectate la toate vizionările deschise."
        override val leadDetailSubtitle: String = "Sursa, calificarea, notițele și istoricul de urmărire pentru acest lead."
        override val totalMetric: String = "Total"
        override val loggedMetric: String = "logat"
        override val searchLeads: String = "Caută lead-uri"
        override val searchLeadsPlaceholder: String = "Nume, telefon sau e-mail"
        override val allProperties: String = "Toate proprietățile"
        override val loadingLeads: String = "Se încarcă lead-urile"
        override val loadingLeadDetails: String = "Se încarcă detaliile leadului"
        override val noLeadsFoundTitle: String = "Lead-urile vor apărea aici când contactele se înregistrează la o vizionare deschisă."
        override val noLeadsEmptyBody: String = "Utilizați check-in chiosk sau adăugați contacte manual dintr-o vizionare deschisă."
        override val noLeadsFilteredBody: String = "Încercați o proprietate diferită, stare, sau termen de căutare."
        override val backToLeads: String = "Înapoi la lead-uri"
        override val leadUnavailableTitle: String = "Lead indisponibil"
        override val leadUnavailableBody: String = "Acest lead nu mai este disponibil în lista curentă."
        override val leadTemperature: String = "Starea leadului"
        override val leadLabelSuffix: String = "Lead"
        override val greetingHi: String = "Bună."
        override val leadActionCall: String = "Apel"
        override val leadActionSms: String = "SMS"
        override val leadActionEmail: String = "Email"
        override val leadFollowUp: String = "Monitorizarea"
        override val leadNoFollowUpScheduled: String = "Nicio urmărire programată"
        override val leadIntentScore: String = "Scor intenţionat"
        override val leadInterestedIn: String = "Interesat de"
        override val leadGenericGreetingName: String = "Acolo."
        override val followUpMessageTypeThankYou: String = "Mulţumesc."
        override val followUpMessageTypePropertyInfo: String = "Informații privind proprietatea"
        override val followUpMessageTypeFollowUp: String = "Monitorizarea"
        override val followUpMessageTypeCheckIn: String = "Verificare"
        override val followUpMessageTypePriceUpdate: String = "Actualizare preț"
        override val followUpMessageTypePropertyBrochure: String = "Fișiere"
        override val followUpPreview: String = "Previzualizare"
        override val followUpSubject: String = "Subiect"
        override val followUpMessage: String = "Mesaj"
        override val followUpSendViaEmail: String = "Trimite prin email"
        override val followUpSendViaSms: String = "Trimite prin SMS"
        override val followUpAiAssistantTitle: String = "Asistent AI"
        override val followUpAiAssistantBody: String = "Generează un mesaj personalizat în câteva secunde."
        override val followUpGenerateWithAi: String = "Generează cu AI"
        override val followUpUpgradeForAi: String = "Upgrade pentru AI"
        override val followUpDefaultSubject: String = "Urmărirea"
        override val privateAgentNotes: String = "Note de agent privat"
        override val notes: String = "Note"
        override val notesPlaceholder: String = "Motivație, preferințe, obiecții, următoarea mișcare"
        override val saveNotes: String = "Salvează notele"
        override val followUpHistory: String = "Istoricul monitorizării"
        override val noFollowUpsLogged: String = "Nu s-a înregistrat încă nimic."
        override val openHousesEyebrow: String = "Arată"
        override val scheduleOpenHouse: String = "Creează o vizionare deschisă"
        override val openingDetails: String = "Detaliile casei deschise"
        override val editOpening: String = "Editează casa deschisă"
        override val deleteOpening: String = "Șterge casa deschisă"
        override val deleteOpeningBody: String = "Sigur doriți să ștergeți această vizionare deschisă? Asta nu poate fi anulată."
        override val removeLeadTitle: String = "Scoateți lead?"
        override val removeLeadBody: String = "Eliminați %s din această vizionare deschisă?"
        override val removeLeadFallback: String = "Acest lead"
        override val openingName: String = "Numele casei deschise"
        override val startsAt: String = "Începe la"
        override val endsAt: String = "Se termină la"
        override val chooseStartDateTime: String = "Alegeți data și ora de începere"
        override val chooseEndDateTime: String = "Alegeți data și ora încheierii"
        override val accessNotes: String = "Note de acces"
        override val privateNotes: String = "Note private"
        override val addPrivateNote: String = "Adaugă notă privată"
        override val liveDashboard: String = "Tablou de bord viu"
        override val visitorKiosk: String = "Chioșc de lead"
        override val openHousesSubtitle: String = "Creați vizionări deschise pentru proprietăți, recenzii piste, și sesiuni de chioșc de lansare."
        override val liveMetric: String = "Live"
        override val upcomingMetric: String = "Se apropie"
        override val inProgressMetric: String = "în curs"
        override val scheduledMetric: String = "programat"
        override val loadingOpenHouses: String = "Încărcare vizionări deschise"
        override val addPropertyFirstTitle: String = "Adaugă mai întâi o proprietate"
        override val addPropertyFirstBody: String = "Creați o vizionare deschisă de la o proprietate pentru a începe colectarea de piste."
        override val noOpenHousesTitle: String = "Nu sunt programate vizionări deschise"
        override val noOpenHousesBody: String = "Creați o vizionare deschisă de la o proprietate pentru a începe colectarea de piste."
        override val noSignInsTitle: String = "Nici un semn încă"
        override val noSignInsBody: String = "Lead-urile verificate prin modul chioșc vor apărea aici în timp real."
        override val dashboard: String = "Dashboard"
        override val start: String = "Start"
        override val end: String = "Sfârşit"
        override val endOpenHouse: String = "End open house"
        override val reportsEyebrow: String = "Proprietari"
        override val sellerReportsTitle: String = "Rapoarte de vânzare"
        override val createReport: String = "Creează raport"
        override val reportPreview: String = "Raportul vânzătorului"
        override val reportsSubtitle: String = "Creați recapitulări premium post-deschis-casă cu calitate de lead, intenție de cumpărător, și poveste gata vânzător."
        override val reportsMetricSaved: String = "salvat"
        override val reportedMetric: String = "raportate"
        override val leadsMetric: String = "piste"
        override val createSellerReport: String = "Creează raport"
        override val attendance: String = "Participarea"
        override val savedReports: String = "rapoarte salvate"
        override val buyerHeat: String = "Caldura cumparatorului"
        override val hotLeads: String = "Conducte fierbinţi"
        override val loadingSellerReports: String = "Încărcare rapoarte vânzător"
        override val noSellerReportsTitle: String = "Niciun raport de vânzare încă"
        override val noSellerReportsBody: String = "Alegeți o vizionare deschisă, adăugați note agent, previzualizare un export-gata recapitulare, apoi salvați-l."
        override val chooseOpenHouse: String = "Alege casa deschisă"
        override val noOpenHousesAvailable: String = "Nu există vizionări deschise disponibile încă."
        override val agentNotes: String = "Note de agent"
        override val notesForSeller: String = "Note de vânzare"
        override val sellerNotesPlaceholder: String = "Obiecții cumpărători, semnale tarifare, afișarea feedback-ului, recomandat următoarea mișcare"
        override val generatePreview: String = "Generează previzualizare"
        override val noPreviewReadyTitle: String = "Nici o previzualizare gata"
        override val noPreviewReadyBody: String = "Generează un raport de vânzare previzualizare înainte de economisire."
        override val saveReport: String = "Salvează raportul"
        override val reportSaved: String = "Raport salvat"
        override val sellerOpenHouseReport: String = "Seller open house report"
        override val mostCommonBuyerInterest: String = "Cel mai frecvent interes al cumpărătorului"
        override val followUpsSent: String = "Urmăriri trimise"
        override val summary: String = "Rezumat"
        override val noPrivateNotesAdded: String = "Nicio notă privată adăugată."
        override val openHouseReport: String = "Raportul Open House"
        override val commonDraft: String = "Proiect"
        override val commonAccepted: String = "Acceptat"
        override val searchSellerReports: String = "Rapoartele vânzătorului de căutare"
        override val noMatchingReports: String = "Nu există rapoarte de corelare"
        override val clearFilters: String = "Curăță filtrele"
        override val tryDifferentSearchOrStatusFilter: String = "Încearcă alt filtru de căutare sau stare."
        override val connectedToProperty: String = "Conectat la proprietate"
        override val viewProperty: String = "Vizualizează proprietatea"
        override val dataRollup: String = "Rularea datelor"
        override val connectedOpenings: String = "Vizionări deschise"
        override val visitors: String = "Vizitatori"
        override val interestedBuyers: String = "Cumpărătorii interesați"
        override val completedFollowUps: String = "Urmăriri"
        override val reportHistory: String = "Istoricul raportului"
        override val noPreviousReportsYet: String = "Nu există rapoarte anterioare încă."
        override val viewAllReports: String = "Vizualizează toate rapoartele"
        override val actions: String = "Acțiuni"
        override val generatePdf: String = "Creează foaie de calcul"
        override val previewPdf: String = "Previzualizare foaie de calcul"
        override val pdfSavedToPropertyFiles: String = "%s salvate în fișierele de proprietate."
        override val pdfSavingToPropertyFiles: String = "%s este salvat în fișierele de proprietate."
        override val pdfSavedToFiles: String = "%s salvat în fișiere."
        override val pdfSavingToFiles: String = "%s este salvat în fișiere."
        override val pdfIncludesSellerReport: String = "Fișă de calcul include indicatori Seller Report, AI perspective, detalii de agent, date de proprietate, și istoria casei deschise."
        override val pdfIncludesAnalytics: String = "Fișă de calcul include indicatori de analiză, proprietăți de top, performanță agent, canale de urmărire, și perspective AI."
        override val pdfGenerateBeforeSending: String = "Creați foaia de calcul înainte de a o trimite."
        override val pdfUploadBeforeSharing: String = "Fişa de calcul trebuie să fie gata de încărcare înainte de partajare."
        override val sellerReportPdfNeedsProperty: String = "Raportul de vânzare are nevoie de o proprietate conectată înainte de încărcare."
        override val deleteReport: String = "Șterge raportul"
        override val deleteReportBody: String = "Sigur doriți să ștergeți acest raport al vânzătorului? Asta nu poate fi anulată."
        override val shareReport: String = "Raport de acțiune"
        override val openingPropertyReportLoading: String = "Raportul proprietăţii..."
        override val openingPropertyReportCreating: String = "Crearea raportului de proprietate..."
        override val sellerReportGeneratedPrefix: String = "Raport de vânzare generat"
        override val sellerReportGeneratedSuffix: String = "de la vizionări deschise, vizitatori, piste, follow-up-uri, și feedback-ul conectat la această proprietate la momentul raportului."
        override val priceNotSet: String = "Preț nesetat"
        override val daysSuffix: String = "zile"
        override val connectedOpeningSingular: String = "vizionare deschisă"
        override val connectedOpeningPlural: String = "vizionări deschise"
        override val connectedLeadSingular: String = "lead conectat"
        override val connectedLeadPlural: String = "piste conectate"
        override val sellerConfidence: String = "Încrederea vânzătorului"
        override val sellerConfidenceExplanation: String = "Explicație de încredere"
        override val aiDraftReviewBeforeSending: String = "Doar Al. Revizuiți și editați înainte de a trimite vânzătorului."
        override val executiveSummary: String = "Rezumat"
        override val buyerInterestOverview: String = "Prezentare generală a dobânzii cumpărătorului"
        override val whatBuyersLoved: String = "Ce-au iubit cumpărătorii"
        override val buyerConcerns: String = "Preocupările cumpărătorului"
        override val leadQualitySummary: String = "Rezumatul calității leadului"
        override val agentActivity: String = "Activitatea agentului"
        override val aiRecommendations: String = "Recomandări privind IA"
        override val recommendations: String = "Recomandări"
        override val marketPositionComparison: String = "Compararea poziției pieței"
        override val nextSteps: String = "Pașii următori"
        override val conversion: String = "Conversie"
        override val interested: String = "interesat"
        override val tourSignalsLowercase: String = "semnale turistice"
        override val propertyTimeline: String = "Calendarul proprietății"
        override val timelineBasisNote: String = "Cronologie se bazează doar pe înregistrări și follow-up-uri casa conectată."
        override val visitorsLowercase: String = "vizitatori"
        override val hotLeadsLowercase: String = "lead fierbinte"
        override val hotLowercase: String = "fierbinte"
        override val sentiment: String = "Sentiment"
        override val toursLowercase: String = "excursii"
        override val interestedLowercase: String = "interesat"
        override val noRepeatedFeedbackMentions: String = "Nu s-au înregistrat încă menţiuni de feedback repetate."
        override val scoresMentionRates: String = "Scorurile sunt ratele de menţionare în feedback-ul cumpărătorului salvat."
        override val aiExecutiveBriefing: String = "Informare executivă AI"
        override val viewAllAiInsights: String = "Vizualizați toate informațiile AI - >"
        override val followUpsSentTitle: String = "Urmăriri trimise"
        override val financingPacketsShared: String = "Pachete de finanțare partajate"
        override val buyerCalls: String = "Apeluri de cumpărare"
        override val propertyDataEvidence: String = "Dovezi privind datele de proprietate"
        override val attendanceCoverage: String = "Acoperirea participării"
        override val leadQuality: String = "Calitatea leadului"
        override val followUpExecution: String = "Execuție ulterioară"
        override val activityChannels: String = "Canalele de activitate"
        override val callsLowercase: String = "apeluri"
        override val emailsLowercase: String = "e-mailuri"
        override val offerReadinessScore: String = "Scor de pregătire ofertă"
        override val date: String = "Dată"
        override val propertyLeadFunnel: String = "Pâlnie cu lead de proprietate"
        override val openHouseBreakdown: String = "Deteriorare a casei deschise"
        override val aiInsights: String = "Al Insights"
        override val generateAiInsights: String = "Generează perspective AI"
        override val analyticsOverview: String = "Prezentare generală a analizei"
        override val allAgents: String = "Toți agenții"
        override val me: String = "Eu"
        override val allActivity: String = "Toată activitatea"
        override val latest30Days: String = "Ultimele 30 de zile"
        override val latest7Days: String = "Ultimele 7 zile"
        override val analyticsDatePreset: String = "Gama de date"
        override val analyticsCustomDate: String = "Data personalizată"
        override val analyticsLastDay: String = "Ultima zi"
        override val analyticsLastWeek: String = "Săptămâna trecută"
        override val analyticsLastMonth: String = "Luna trecută"
        override val analyticsLastYear: String = "Anul trecut"
        override val analyticsAllTime: String = "Tot timpul"
        override val analyticsDateFrom: String = "Data de la"
        override val analyticsDateTo: String = "Data până la"
        override val analyticsOpenHousesLowercase: String = "vizionări deschise"
        override val analyticsWarmLeadsLowercase: String = "piste calde"
        override val analyticsFromNotesFollowUps: String = ""
        override val analyticsFromText: String = "din text"
        override val analyticsHotConversion: String = "Conversie la cald"
        override val analyticsHotLeadsPerVisitors: String = "lead fierbinte / vizitatori"
        override val analyticsAverageIntent: String = "Avg. intenţie"
        override val analyticsVisitorIntentScore: String = "scorul de intenție al vizitatorilor"
        override val analyticsSelectDate: String = "Alegeți data"
        override val propertyFunnel: String = "Pâlnie de proprietate"
        override val propertyFunnelSubtitle: String = "De la activitatea imobiliară la impulsul cumpărătorului calificat"
        override val properties: String = "Proprietăți"
        override val tourSignals: String = "Semnale turistice"
        override val offerSignals: String = "Semnale de ofertă"
        override val viewFullFunnelReport: String = "Vizualizează raportul complet al pâlniei"
        override val performanceOverTime: String = "Performanță în timp"
        override val thirtyDays: String = "30 zile"
        override val topPerformingProperties: String = "Proprietăți performante de top"
        override val viewAll: String = "Vezi tot"
        override val noPropertyAnalyticsYet: String = "Nici o analiză de proprietate încă."
        override val leadQualityBreakdown: String = "Defalcarea calității leadului"
        override val warmLeadsTitle: String = "Piste calde"
        override val coldLeadsTitle: String = "Conducte reci"
        override val followUpPerformance: String = "Performanță de monitorizare"
        override val agentPerformance: String = "Performanță agent"
        override val viewTeamReport: String = "Vezi raportul echipei"
        override val followUpChannels: String = "Canalele de monitorizare"
        override val viewReport: String = "Raport de vizualizare"
        override val searchProperties: String = "Proprietăți căutare"
        override val searchOpenings: String = "Căutare vizionări deschise"
        override val noOpeningsFoundTitle: String = "Nu s-au găsit vizionări deschise"
        override val noOpeningsFoundBody: String = "Încercați un alt filtru de stare de căutare sau deschide casa."
        override val noMatchingPropertiesTitle: String = "Fără proprietăți de potrivire"
        override val noMatchingPropertiesBody: String = "Încearcă alt filtru de căutare sau stare."
        override val clientsTitle: String = "Contacte"
        override val clientFallback: String = "Contact"
        override val addClient: String = "Adaugă contact"
        override val editClient: String = "Editează contactul"
        override val newClient: String = "Contact nou"
        override val saveClient: String = "Salvează contactul"
        override val createClient: String = "Creează contact"
        override val deleteClientTitle: String = "Sterge contactul?"
        override val deleteClientBody: String = "Acest lucru va șterge permanent contactul. Asta nu poate fi anulată."
        override val firstName: String = "Prenume"
        override val lastName: String = "Numele de familie"
        override val email: String = "Email"
        override val phone: String = "Telefon"
        override val comments: String = "Observații"
        override val addPhoto: String = "Adaugă fotografie"
        override val sendQr: String = "Trimite QR"
        override val sendQrShareTitle: String = "Open house QR"
        override val sendQrShareBody: String = "Casa ta deschisă este ataşată. Adăugați cardul de portofel (.pkpass) la telefon atunci când sunt disponibile, sau arată imaginea QR la casa deschisă."
        override val sendQrReadyMessage: String = "Codul QR gata de trimis"
        override val sendQrUnavailableError: String = "Nu este disponibilă nicio aplicație de email sau SMS pentru acest contact."
        override val clientQrDeliveryRequired: String = "Adaugă un e-mail sau un număr de telefon pentru livrarea QR."
        override val photo: String = "Fotografie"
        override val clientDetailSubtitle: String = "Identitate QR, detalii de contact, comentarii, și vizionări deschise conectate prin piste."
        override val clientFormEditSubtitle: String = "Actualizați datele de contact, informațiile de livrare, și comentarii."
        override val clientFormNewSubtitle: String = "Înregistrați un cumpărător/contact și generați o identitate QR reutilizabilă pentru casele deschise."
        override val searchClients: String = "Contacte de căutare"
        override val noClientsYetTitle: String = "Nu există contacte încă"
        override val noClientsYetBody: String = "Înregistrați contactele mai întâi, apoi trimiteți codul QR prin e-mail sau SMS înainte de o vizionare deschisă."
        override val noClientsFoundTitle: String = "Nu am găsit niciun contact."
        override val noClientsFoundBody: String = "Încearcă alt nume, telefon sau e-mail."
        override val clientUnavailableTitle: String = "Contact indisponibil"
        override val clientUnavailableBody: String = "Reîmprospătați lista de contacte și deschideți acest record din nou."
        override val noCommentsAdded: String = "Nu s-au adăugat observații."
        override val openingsTitle: String = "Vizionări deschise"
        override val clientOpeningsEmpty: String = "Nu există vizionări deschise conectate încă. Conduce conecta un contact la o vizionare deschisă."
        override val clientPassLabel: String = "Pasă de portofel"
        override val clientNoEmail: String = "Niciun e-mail"
        override val visitorsBody: String = "Deschide modul chioșc, scanează un QR contact, sau adaugă contacte existente ca piste pentru această vizionare deschisă."
        override val openKiosk: String = "Chioșc deschis"
        override val addQrClient: String = "Adaugă contact QR"
        override val addManually: String = "Adaugă manual"
        override val selectClients: String = "Alegeți contacte"
        override val selectClientsBody: String = "Alegeţi contacte din listă. Fiecare contact selectat devine o pistă pentru această vizionare deschisă."
        override val kioskCheckIn: String = "Check-in Kiosk"
        override val kioskCheckInBody: String = "Foloseşte camera din spate pentru a scana portofelul de contact al lui HAVN QR. Când codul este recunoscut, HAVN creează automat leadul pentru această vizionare deschisă."
        override val scanWithCamera: String = "Scanează cu camera din spate"
        override val clientQrImage: String = "Contactează imaginea QR"
        override val clientQrImageBody: String = "Păstrați QR contactului în interiorul pătrat de aur. HAVN colectează fiecare scanare de mai jos."
        override val scanMultipleQrBody: String = "Scanează unul sau mai multe coduri HAVN contactează QR, apoi atingeți Adaugă contact QR."
        override val scannedQrReady: String = "contactează QR gata de adăugare"
        override val createLeadFromQr: String = "Creează lead din QR"
        override val noClientsFoundShort: String = "Nu am găsit niciun contact."
        override val remove: String = "Elimină"
        override val tasksTitle: String = "Sarcini"
        override val addTask: String = "Adaugă sarcină"
        override val searchTasks: String = "Sarcini de căutare"
        override val loadMoreTasks: String = "Încarcă mai multe sarcini"
        override val createTask: String = "Creează sarcină"
        override val saveTask: String = "Salvează sarcina"
        override val editTask: String = "Editează sarcina"
        override val newTask: String = "Sarcina nouă"
        override val taskDetails: String = "Detalii sarcini"
        override val taskName: String = "Nume"
        override val taskDescription: String = "Descriere"
        override val taskDueDateTime: String = "Data și ora sarcinii"
        override val chooseTaskDateTime: String = "Alegeți data și ora sarcinii"
        override val clearTaskDateTime: String = "Curăță data și ora"
        override val assignToAgent: String = "Atribuiți agentului"
        override val noAgencyAgentsFound: String = "Niciun agent nu a fost găsit. Sarcina va rămâne atribuită proprietarului."
        override val taskPriority: String = "Prioritatea sarcinii"
        override val taskStatus: String = "Stare"
        override val taskVisibility: String = "Vizibilitate"
        override val taskOwner: String = "Proprietar"
        override val taskOwnerFallback: String = "Proprietar de sarcini"
        override val assignedTo: String = "Atribuită"
        override val selectedAgent: String = "Agent selectat"
        override val taskVisibilityBody: String = "Această sarcină este vizibilă pentru proprietar și agentul desemnat."
        override val taskQueue: String = "Coadă de sarcini"
        override val taskDetail: String = "Detalii privind sarcina"
        override val taskDetailEmpty: String = "Selectați o sarcină pentru a vedea contextul și acțiunile următoare."
        override val connectedContext: String = "Context conectat"
        override val noTaskContext: String = "Nici o proprietate, contact, vizionare deschisă, sau lead este conectat încă."
        override val activityTimeline: String = "Cronologie activitate"
        override val created: String = "Creat"
        override val recently: String = "Recent"
        override val completed: String = "Completat"
        override val nextAction: String = "Acțiunea următoare"
        override val agentReviewOrCompletion: String = "Revizuire sau finalizare a agentului"
        override val noDueDate: String = "Fără scadență"
        override val reopen: String = "Redeschide"
        override val accept: String = "Acceptă"
        override val linkedTasks: String = "Sarcini legate"
        override val noLinkedTasks: String = "Nu există încă sarcini legate."
        override val filesTitle: String = "Fișiere"
        override val attachFile: String = "Atașează fișierul"
        override val noFilesAttached: String = "Nu există fișiere atașate încă."
        override val fileLimitHint: String = "Fișierele pot fi PDF, DOC, CAD sau alte formate până la 20 MB fiecare."
        override val deleteFileTitle: String = "Șterge fișierul?"
        override val deleteFileBody: String = "Acest fișier va fi eliminat din depozitul HAVN."
        override val attachmentOpenFailed: String = "Nu am putut deschide acest fișier."
        override val attachmentDeleteOwnerOnly: String = "Numai proprietarul fișierului poate șterge acest atașament."
        override val attachmentDocumentsNotIncluded: String = "Planul curent nu include upload-uri de fișiere. Upgrade pentru a încărca fișiere."
        override val attachmentDocumentStorageNotIncluded: String = "Planul actual nu include stocarea documentelor. Upgrade pentru a încărca fișiere."
        override val attachmentFileSizePlanLimit: String = "Acest fișier este mai mare decât vă permite planul curent. Upgrade pentru a încărca fișiere mai mari."
        override val attachmentStoragePlanLimit: String = "Limita de stocare atins pentru planul curent. Upgrade pentru a încărca mai multe fișiere."
        override val attachmentDocumentCountPlanLimit: String = "Limita documentului atins pentru această proprietate pe planul curent. Upgrade pentru a încărca mai multe fișiere."
        override val attachmentHardFileLimit: String = "Ataşamentul fişierului este limitat la 100 MB."
        override val openFiles: String = "Deschide fișierul (s)"
        override val sendViaEmail: String = "Trimite prin email"
        override val sendViaSms: String = "Trimite prin SMS"
        override val sendEmailHeader: String = "Trimite email"
        override val sendSmsHeader: String = "Trimite SMS"
        override val noContactsFound: String = "Nu am găsit niciun contact."
        override val searchContacts: String = "Contacte de căutare"
        override val linked: String = "Legat"
        override val recent: String = "Recent"
        override val taskColumnToDo: String = "Pentru a face"
        override val taskColumnInProgress: String = "În progres"
        override val taskColumnDone: String = "Gata."
        override val taskColumnToDoSubtitle: String = "Noi sarcini și acțiuni viitoare care așteaptă să fie demarate."
        override val taskColumnInProgressSubtitle: String = "Lucru deținut în prezent de tine sau echipa."
        override val taskColumnDoneSubtitle: String = "Sarcini finalizate păstrate vizibile pentru încrederea echipei."
        override val taskEmptyToDo: String = "Fără sarcini de făcut."
        override val taskEmptyInProgress: String = "Nimic în desfăşurare."
        override val taskEmptyDone: String = "Nu sunt încă sarcini finalizate."
        override val taskKanbanEmptyToDo: String = "Nu aşteaptă nimic. Vor apărea noi urmăriri şi rapoarte."
        override val taskKanbanEmptyInProgress: String = "Nicio activitate activă în desfăşurare."
        override val taskKanbanEmptyDone: String = "Sarcinile finalizate vor ateriza aici."
        override val taskEmptyBodyPrefix: String = "Creați o sarcină sau mutați o altă sarcină în"
        override val taskEmptyBodySuffix: String = "."
        override val taskActionStart: String = "Start"
        override val taskActionOverdue: String = "Excludere"
        override val taskActionCancel: String = "Renunță"
        override val taskPriorityLow: String = "Mică"
        override val taskPriorityMedium: String = "Mediu"
        override val taskPriorityHigh: String = "Ridicat"
        override val taskPriorityUrgent: String = "Urgent"
        override val taskStatusOpen: String = "Deschide"
        override val taskStatusInProgress: String = "În curs"
        override val taskStatusDone: String = "Gata."
        override val taskStatusOverdue: String = "Excludere"
        override val taskStatusCancelled: String = "Anulat"
        override val aiSuggestedTasks: String = "AI sugerează sarcini"
        override val noAiSuggestedTasks: String = "Nici o sugestie AI încă. HAVN va sugera sarcini după vizionări deschise și activitatea de lead."
        override val taskFilterToday: String = "Astăzi"
        override val taskFilterUpcoming: String = "Se apropie"
        override val taskFilterOverdue: String = "Excludere"
        override val taskFilterCompleted: String = "Completat"
        override val taskFilterAssignedToMe: String = "Atribuit mie"
        override val taskFilterAiSuggested: String = "Al a sugerat"
        override val taskFilterEmptyToday: String = "E liber pentru azi."
        override val taskFilterEmptyUpcoming: String = "Fără sarcini viitoare."
        override val taskFilterEmptyOverdue: String = "Fără sarcini restante."
        override val taskFilterEmptyCompleted: String = "Nu sunt încă sarcini finalizate."
        override val taskFilterEmptyAssignedToMe: String = "Nu ai sarcini."
        override val taskFilterEmptyAiSuggested: String = "Nici o AI acceptată a sugerat sarcini încă."
        override val taskSuggestionHotLeadTitlePrefix: String = "Urmăriți cu"
        override val taskSuggestionHotLeadTitleSuffix: String = "în două ore."
        override val taskSuggestionHotLeadDescriptionPrefix: String = "Lead fierbinte de la"
        override val taskSuggestionHotLeadDescriptionSuffix: String = "Păstrați impuls în timp ce intenția este proaspătă."
        override val taskSuggestionHotLeadReason: String = "Noul lead fierbinte capturat."
        override val taskSuggestionSellerReportTitlePrefix: String = "Generează raportul vânzătorului pentru"
        override val taskSuggestionSellerReportTitleSuffix: String = "."
        override val taskSuggestionSellerReportDescription: String = "Sumarizează volumul vizitatorilor, piste fierbinți, activități ulterioare, și sentiment de cumpărător."
        override val taskSuggestionSellerReportReason: String = "Casa deschisă s-a terminat."
        override val taskSuggestionReviewFollowUpTitlePrefix: String = "Revizuire și trimitere"
        override val taskSuggestionReviewFollowUpTitleSuffix: String = "Urmărire."
        override val taskSuggestionReviewFollowUpReason: String = "Proiectul de follow-up are încă nevoie de revizuire agent."
        override val taskSuggestionKioskTitle: String = "Pregătiţi kiosk mode şi verificaţi fotografiile proprietăţii."
        override val taskSuggestionKioskDescription: String = "Confirmați fluxul de sign-in, galerie, și detaliile casei deschise înainte de a sosi cumpărătorii."
        override val taskSuggestionKioskReason: String = "Casa deschisă este programată."
    }
}
